/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type AddCardsToCardGroupInput = {
  paidolId: string,
  cardGroupId: string,
  cardsIds: Array< string | null >,
};

export type BasicHTTPResponse = {
  __typename: "BasicHTTPResponse",
  statusCode?: number | null,
  body?: string | null,
};

export type CreateAgaveProjectInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveAddressInput | null,
  amount?: number | null,
  completion_date?: string | null,
  name?: string | null,
  number?: string | null,
  start_date?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type AgaveAddressInput = {
  street_1?: string | null,
  street_2?: string | null,
  city?: string | null,
  state?: string | null,
  postal_code?: string | null,
  country?: string | null,
};

export type AgaveSourceDataInput = {
  CreationDate?: string | null,
  data?: string | null,
  DeliveryAddressLine?: Array< string | null > | null,
  DeliveryCity?: Array< string | null > | null,
  DeliveryCountry?: Array< string | null > | null,
  DeliveryPostcode?: Array< string | null > | null,
  DeliveryState?: Array< string | null > | null,
  FaxNumber?: string | null,
  LogoPath?: string | null,
  ProjectOwnerOrganizationId?: string | null,
  ProjectOwnerOrganizationName?: string | null,
  PhoneNumber?: string | null,
  PostalAddressLine?: Array< string | null > | null,
  PostalCity?: Array< string | null > | null,
  PostalCountry?: Array< string | null > | null,
  PostalPostcode?: Array< string | null > | null,
  PostalState?: Array< string | null > | null,
  ProjectAddressLine?: string | null,
  ProjectCity?: string | null,
  ProjectCode?: string | null,
  ProjectCountry?: string | null,
  ProjectDescription?: string | null,
  ProjectId?: string | null,
  ProjectName?: string | null,
  ProjectPostcode?: string | null,
  ProjectShortName?: string | null,
  ProjectState?: string | null,
  ProjectType?: string | null,
  ProjectValue?: string | null,
  ProjectResponsibilities?: Array< string | null > | null,
  StartDate?: string | null,
  StopDate?: string | null,
};

export type ModelAgaveProjectConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  completion_date?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  start_date?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectConditionInput | null > | null,
  or?: Array< ModelAgaveProjectConditionInput | null > | null,
  not?: ModelAgaveProjectConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type AgaveProject = {
  __typename: "AgaveProject",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveAddress | null,
  amount?: number | null,
  completion_date?: string | null,
  name?: string | null,
  number?: string | null,
  start_date?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceData | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type AgaveAddress = {
  __typename: "AgaveAddress",
  street_1?: string | null,
  street_2?: string | null,
  city?: string | null,
  state?: string | null,
  postal_code?: string | null,
  country?: string | null,
};

export type AgaveSourceData = {
  __typename: "AgaveSourceData",
  CreationDate?: string | null,
  data?: string | null,
  DeliveryAddressLine?: Array< string | null > | null,
  DeliveryCity?: Array< string | null > | null,
  DeliveryCountry?: Array< string | null > | null,
  DeliveryPostcode?: Array< string | null > | null,
  DeliveryState?: Array< string | null > | null,
  FaxNumber?: string | null,
  LogoPath?: string | null,
  ProjectOwnerOrganizationId?: string | null,
  ProjectOwnerOrganizationName?: string | null,
  PhoneNumber?: string | null,
  PostalAddressLine?: Array< string | null > | null,
  PostalCity?: Array< string | null > | null,
  PostalCountry?: Array< string | null > | null,
  PostalPostcode?: Array< string | null > | null,
  PostalState?: Array< string | null > | null,
  ProjectAddressLine?: string | null,
  ProjectCity?: string | null,
  ProjectCode?: string | null,
  ProjectCountry?: string | null,
  ProjectDescription?: string | null,
  ProjectId?: string | null,
  ProjectName?: string | null,
  ProjectPostcode?: string | null,
  ProjectShortName?: string | null,
  ProjectState?: string | null,
  ProjectType?: string | null,
  ProjectValue?: string | null,
  ProjectResponsibilities?: Array< string | null > | null,
  StartDate?: string | null,
  StopDate?: string | null,
};

export type UpdateAgaveProjectInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveAddressInput | null,
  amount?: number | null,
  completion_date?: string | null,
  name?: string | null,
  number?: string | null,
  start_date?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type DeleteAgaveProjectInput = {
  id: string,
};

export type CreateAgaveGlCodeInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  classification?: string | null,
  currency_code?: string | null,
  current_balance?: number | null,
  description?: string | null,
  name?: string | null,
  number?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type ModelAgaveGlCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  classification?: ModelStringInput | null,
  currency_code?: ModelStringInput | null,
  current_balance?: ModelFloatInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveGlCodeConditionInput | null > | null,
  or?: Array< ModelAgaveGlCodeConditionInput | null > | null,
  not?: ModelAgaveGlCodeConditionInput | null,
};

export type AgaveGlCode = {
  __typename: "AgaveGlCode",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  classification?: string | null,
  currency_code?: string | null,
  current_balance?: number | null,
  description?: string | null,
  name?: string | null,
  number?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceData | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type UpdateAgaveGlCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  classification?: string | null,
  currency_code?: string | null,
  current_balance?: number | null,
  description?: string | null,
  name?: string | null,
  number?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type DeleteAgaveGlCodeInput = {
  id: string,
};

export type CreateAgaveCostCodeInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  asset_account_id?: string | null,
  source_id?: string | null,
  formatted_full_code?: string | null,
  code?: string | null,
  full_code?: string | null,
  cost_unit_of_measure?: string | null,
  description?: string | null,
  expense_account_id?: string | null,
  income_account_id?: string | null,
  name?: string | null,
  parent_id?: string | null,
  project_id?: string | null,
  price_unit_of_measure?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostCodesSourceDataInput | null,
  status?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_price?: string | null,
  vendor_id?: string | null,
  sub_job_id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
  projectIds?: Array< string | null > | null,
  cost_type_ids?: Array< string | null > | null,
  fullName?: string | null,
};

export type AgaveCostCodesSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveCostCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  asset_account_id?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  formatted_full_code?: ModelStringInput | null,
  code?: ModelStringInput | null,
  full_code?: ModelStringInput | null,
  cost_unit_of_measure?: ModelStringInput | null,
  description?: ModelStringInput | null,
  expense_account_id?: ModelStringInput | null,
  income_account_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  parent_id?: ModelStringInput | null,
  project_id?: ModelStringInput | null,
  price_unit_of_measure?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  unit_cost?: ModelStringInput | null,
  unit_price?: ModelStringInput | null,
  vendor_id?: ModelStringInput | null,
  sub_job_id?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  paidolProject?: ModelIDInput | null,
  projectIds?: ModelStringInput | null,
  cost_type_ids?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeConditionInput | null > | null,
  or?: Array< ModelAgaveCostCodeConditionInput | null > | null,
  not?: ModelAgaveCostCodeConditionInput | null,
};

export type AgaveCostCode = {
  __typename: "AgaveCostCode",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  asset_account_id?: string | null,
  source_id?: string | null,
  formatted_full_code?: string | null,
  code?: string | null,
  full_code?: string | null,
  cost_unit_of_measure?: string | null,
  description?: string | null,
  expense_account_id?: string | null,
  income_account_id?: string | null,
  name?: string | null,
  parent_id?: string | null,
  project_id?: string | null,
  price_unit_of_measure?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostCodesSourceData | null,
  status?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_price?: string | null,
  vendor_id?: string | null,
  sub_job_id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
  projectIds?: Array< string | null > | null,
  cost_type_ids?: Array< string | null > | null,
  fullName?: string | null,
};

export type AgaveCostCodesSourceData = {
  __typename: "AgaveCostCodesSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveCostCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  asset_account_id?: string | null,
  source_id?: string | null,
  formatted_full_code?: string | null,
  code?: string | null,
  full_code?: string | null,
  cost_unit_of_measure?: string | null,
  description?: string | null,
  expense_account_id?: string | null,
  income_account_id?: string | null,
  name?: string | null,
  parent_id?: string | null,
  project_id?: string | null,
  price_unit_of_measure?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostCodesSourceDataInput | null,
  status?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_price?: string | null,
  vendor_id?: string | null,
  sub_job_id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
  projectIds?: Array< string | null > | null,
  cost_type_ids?: Array< string | null > | null,
  fullName?: string | null,
};

export type DeleteAgaveCostCodeInput = {
  id: string,
};

export type CreateAgaveSubJobInput = {
  id?: string | null,
  agaveSubJobId?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  name?: string | null,
  number?: string | null,
  code?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSubJobSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  fullName?: string | null,
  cost_code_ids?: Array< string | null > | null,
};

export type AgaveSubJobSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveSubJobConditionInput = {
  agaveSubJobId?: ModelStringInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  code?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  fullName?: ModelStringInput | null,
  cost_code_ids?: ModelStringInput | null,
  and?: Array< ModelAgaveSubJobConditionInput | null > | null,
  or?: Array< ModelAgaveSubJobConditionInput | null > | null,
  not?: ModelAgaveSubJobConditionInput | null,
};

export type AgaveSubJob = {
  __typename: "AgaveSubJob",
  id: string,
  agaveSubJobId?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  name?: string | null,
  number?: string | null,
  code?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSubJobSourceData | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  fullName?: string | null,
  cost_code_ids?: Array< string | null > | null,
};

export type AgaveSubJobSourceData = {
  __typename: "AgaveSubJobSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveSubJobInput = {
  id: string,
  agaveSubJobId?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  name?: string | null,
  number?: string | null,
  code?: string | null,
  status?: string | null,
  type?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveSubJobSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  fullName?: string | null,
  cost_code_ids?: Array< string | null > | null,
};

export type DeleteAgaveSubJobInput = {
  id: string,
};

export type CreateAgaveProjectCostCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  costCodeId: string,
  projectIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveProjectCostCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  projectIdCostCodeId?: ModelIDInput | null,
  costCodeName?: ModelStringInput | null,
  costCodeCode?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectCostCodeConditionInput | null > | null,
  or?: Array< ModelAgaveProjectCostCodeConditionInput | null > | null,
  not?: ModelAgaveProjectCostCodeConditionInput | null,
};

export type AgaveProjectCostCode = {
  __typename: "AgaveProjectCostCode",
  id: string,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  costCodeId: string,
  projectIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveProjectCostCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectId?: string | null,
  costCodeId?: string | null,
  projectIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveProjectCostCodeInput = {
  id: string,
};

export type CreateAgaveProjectSubJobInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  subJobId: string,
  projectIdSubJobId?: string | null,
  subJobName?: string | null,
  subJobNumber?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveProjectSubJobConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  subJobId?: ModelIDInput | null,
  projectIdSubJobId?: ModelIDInput | null,
  subJobName?: ModelStringInput | null,
  subJobNumber?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectSubJobConditionInput | null > | null,
  or?: Array< ModelAgaveProjectSubJobConditionInput | null > | null,
  not?: ModelAgaveProjectSubJobConditionInput | null,
};

export type AgaveProjectSubJob = {
  __typename: "AgaveProjectSubJob",
  id: string,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  subJobId: string,
  projectIdSubJobId?: string | null,
  subJobName?: string | null,
  subJobNumber?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveProjectSubJobInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectId?: string | null,
  subJobId?: string | null,
  projectIdSubJobId?: string | null,
  subJobName?: string | null,
  subJobNumber?: string | null,
  projectName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveProjectSubJobInput = {
  id: string,
};

export type CreateAgaveSubJobCostCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  subJobId: string,
  costCodeId: string,
  projectId?: string | null,
  subJobIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  subJobName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveSubJobCostCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  subJobId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  subJobIdCostCodeId?: ModelIDInput | null,
  costCodeName?: ModelStringInput | null,
  costCodeCode?: ModelStringInput | null,
  subJobName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveSubJobCostCodeConditionInput | null > | null,
  or?: Array< ModelAgaveSubJobCostCodeConditionInput | null > | null,
  not?: ModelAgaveSubJobCostCodeConditionInput | null,
};

export type AgaveSubJobCostCode = {
  __typename: "AgaveSubJobCostCode",
  id: string,
  paidolId: string,
  authPaidolId: string,
  subJobId: string,
  costCodeId: string,
  projectId?: string | null,
  subJobIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  subJobName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveSubJobCostCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  subJobId?: string | null,
  costCodeId?: string | null,
  projectId?: string | null,
  subJobIdCostCodeId?: string | null,
  costCodeName?: string | null,
  costCodeCode?: string | null,
  subJobName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveSubJobCostCodeInput = {
  id: string,
};

export type CreateAgaveProjectLocationInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  locationId: string,
  projectName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveProjectLocationConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectLocationConditionInput | null > | null,
  or?: Array< ModelAgaveProjectLocationConditionInput | null > | null,
  not?: ModelAgaveProjectLocationConditionInput | null,
};

export type AgaveProjectLocation = {
  __typename: "AgaveProjectLocation",
  id: string,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  locationId: string,
  projectName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveProjectLocationInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectId?: string | null,
  locationId?: string | null,
  projectName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveProjectLocationInput = {
  id: string,
};

export type CreateAgaveProjectDepartmentInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  departmentId: string,
  projectName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveProjectDepartmentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  departmentId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  departmentName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectDepartmentConditionInput | null > | null,
  or?: Array< ModelAgaveProjectDepartmentConditionInput | null > | null,
  not?: ModelAgaveProjectDepartmentConditionInput | null,
};

export type AgaveProjectDepartment = {
  __typename: "AgaveProjectDepartment",
  id: string,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  departmentId: string,
  projectName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveProjectDepartmentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectId?: string | null,
  departmentId?: string | null,
  projectName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveProjectDepartmentInput = {
  id: string,
};

export type CreateAgaveEmployeeEntityInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  status?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type ModelAgaveEmployeeEntityConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeEntityConditionInput | null > | null,
  or?: Array< ModelAgaveEmployeeEntityConditionInput | null > | null,
  not?: ModelAgaveEmployeeEntityConditionInput | null,
};

export type AgaveEmployeeEntity = {
  __typename: "AgaveEmployeeEntity",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  status?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type UpdateAgaveEmployeeEntityInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  status?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type DeleteAgaveEmployeeEntityInput = {
  id: string,
};

export type CreateAgaveEmployeeLocationInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  employeeId: string,
  locationId: string,
  employeeName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveEmployeeLocationConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  employeeId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  employeeName?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeLocationConditionInput | null > | null,
  or?: Array< ModelAgaveEmployeeLocationConditionInput | null > | null,
  not?: ModelAgaveEmployeeLocationConditionInput | null,
};

export type AgaveEmployeeLocation = {
  __typename: "AgaveEmployeeLocation",
  id: string,
  paidolId: string,
  authPaidolId: string,
  employeeId: string,
  locationId: string,
  employeeName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveEmployeeLocationInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  employeeId?: string | null,
  locationId?: string | null,
  employeeName?: string | null,
  locationName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmployeeLocationInput = {
  id: string,
};

export type CreateAgaveEmployeeDepartmentInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  employeeId: string,
  departmentId: string,
  employeeName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveEmployeeDepartmentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  employeeId?: ModelIDInput | null,
  departmentId?: ModelIDInput | null,
  employeeName?: ModelStringInput | null,
  departmentName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeDepartmentConditionInput | null > | null,
  or?: Array< ModelAgaveEmployeeDepartmentConditionInput | null > | null,
  not?: ModelAgaveEmployeeDepartmentConditionInput | null,
};

export type AgaveEmployeeDepartment = {
  __typename: "AgaveEmployeeDepartment",
  id: string,
  paidolId: string,
  authPaidolId: string,
  employeeId: string,
  departmentId: string,
  employeeName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveEmployeeDepartmentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  employeeId?: string | null,
  departmentId?: string | null,
  employeeName?: string | null,
  departmentName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmployeeDepartmentInput = {
  id: string,
};

export type CreateAgaveCostTypeInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  project_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostTypeSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
};

export type AgaveCostTypeSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveCostTypeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  project_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  paidolProject?: ModelIDInput | null,
  and?: Array< ModelAgaveCostTypeConditionInput | null > | null,
  or?: Array< ModelAgaveCostTypeConditionInput | null > | null,
  not?: ModelAgaveCostTypeConditionInput | null,
};

export type AgaveCostType = {
  __typename: "AgaveCostType",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  project_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostTypeSourceData | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
};

export type AgaveCostTypeSourceData = {
  __typename: "AgaveCostTypeSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveCostTypeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  project_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveCostTypeSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  projectId?: string | null,
  paidolProject?: string | null,
};

export type DeleteAgaveCostTypeInput = {
  id: string,
};

export type CreateAgaveEquipmentInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCo?: string | null,
  category?: string | null,
  department?: string | null,
  status?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEquipmentSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEquipmentSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveEquipmentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  emCo?: ModelStringInput | null,
  category?: ModelStringInput | null,
  department?: ModelStringInput | null,
  status?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEquipmentConditionInput | null > | null,
  or?: Array< ModelAgaveEquipmentConditionInput | null > | null,
  not?: ModelAgaveEquipmentConditionInput | null,
};

export type AgaveEquipment = {
  __typename: "AgaveEquipment",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCo?: string | null,
  category?: string | null,
  department?: string | null,
  status?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEquipmentSourceData | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEquipmentSourceData = {
  __typename: "AgaveEquipmentSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveEquipmentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCo?: string | null,
  category?: string | null,
  department?: string | null,
  status?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEquipmentSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEquipmentInput = {
  id: string,
};

export type CreateAgaveEmCostCodeInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCostTypeCodes?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostCodeSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmCostCodeSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveEmCostCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  emCostTypeCodes?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostCodeConditionInput | null > | null,
  or?: Array< ModelAgaveEmCostCodeConditionInput | null > | null,
  not?: ModelAgaveEmCostCodeConditionInput | null,
};

export type AgaveEmCostCode = {
  __typename: "AgaveEmCostCode",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCostTypeCodes?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostCodeSourceData | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmCostCodeSourceData = {
  __typename: "AgaveEmCostCodeSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveEmCostCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  emCostTypeCodes?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostCodeSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmCostCodeInput = {
  id: string,
};

export type CreateAgaveEmDepartmentInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emCo?: string | null,
  costCodeKeys?: Array< string | null > | null,
  costTypeKeys?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmDepartmentSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmDepartmentSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveEmDepartmentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emCo?: ModelStringInput | null,
  costCodeKeys?: ModelStringInput | null,
  costTypeKeys?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmDepartmentConditionInput | null > | null,
  or?: Array< ModelAgaveEmDepartmentConditionInput | null > | null,
  not?: ModelAgaveEmDepartmentConditionInput | null,
};

export type AgaveEmDepartment = {
  __typename: "AgaveEmDepartment",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emCo?: string | null,
  costCodeKeys?: Array< string | null > | null,
  costTypeKeys?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmDepartmentSourceData | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmDepartmentSourceData = {
  __typename: "AgaveEmDepartmentSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveEmDepartmentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emCo?: string | null,
  costCodeKeys?: Array< string | null > | null,
  costTypeKeys?: Array< string | null > | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmDepartmentSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmDepartmentInput = {
  id: string,
};

export type CreateAgaveEmCostTypeInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  abbreviation?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostTypeSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmCostTypeSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ModelAgaveEmCostTypeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  abbreviation?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostTypeConditionInput | null > | null,
  or?: Array< ModelAgaveEmCostTypeConditionInput | null > | null,
  not?: ModelAgaveEmCostTypeConditionInput | null,
};

export type AgaveEmCostType = {
  __typename: "AgaveEmCostType",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  abbreviation?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostTypeSourceData | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AgaveEmCostTypeSourceData = {
  __typename: "AgaveEmCostTypeSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type UpdateAgaveEmCostTypeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  emGroup?: string | null,
  abbreviation?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveEmCostTypeSourceDataInput | null,
  lastSeenAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmCostTypeInput = {
  id: string,
};

export type CreateAgaveCostCodeCostTypeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  costCodeId: string,
  costTypeId: string,
  projectId?: string | null,
  costCodeCode?: string | null,
  costCodeName?: string | null,
  costTypeCode?: string | null,
  costTypeName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveCostCodeCostTypeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  costTypeId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeCode?: ModelStringInput | null,
  costCodeName?: ModelStringInput | null,
  costTypeCode?: ModelStringInput | null,
  costTypeName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeCostTypeConditionInput | null > | null,
  or?: Array< ModelAgaveCostCodeCostTypeConditionInput | null > | null,
  not?: ModelAgaveCostCodeCostTypeConditionInput | null,
};

export type AgaveCostCodeCostType = {
  __typename: "AgaveCostCodeCostType",
  id: string,
  paidolId: string,
  authPaidolId: string,
  costCodeId: string,
  costTypeId: string,
  projectId?: string | null,
  costCodeCode?: string | null,
  costCodeName?: string | null,
  costTypeCode?: string | null,
  costTypeName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveCostCodeCostTypeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  costCodeId?: string | null,
  costTypeId?: string | null,
  projectId?: string | null,
  costCodeCode?: string | null,
  costCodeName?: string | null,
  costTypeCode?: string | null,
  costTypeName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveCostCodeCostTypeInput = {
  id: string,
};

export type CreateAgaveEmCostCodeCostTypeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  emCostCodeId: string,
  emCostTypeId: string,
  emGroup?: string | null,
  emCostCodeCode?: string | null,
  emCostCodeName?: string | null,
  emCostTypeCode?: string | null,
  emCostTypeName?: string | null,
  unitOfMeasure?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveEmCostCodeCostTypeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  emCostCodeId?: ModelIDInput | null,
  emCostTypeId?: ModelIDInput | null,
  emGroup?: ModelStringInput | null,
  emCostCodeCode?: ModelStringInput | null,
  emCostCodeName?: ModelStringInput | null,
  emCostTypeCode?: ModelStringInput | null,
  emCostTypeName?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostCodeCostTypeConditionInput | null > | null,
  or?: Array< ModelAgaveEmCostCodeCostTypeConditionInput | null > | null,
  not?: ModelAgaveEmCostCodeCostTypeConditionInput | null,
};

export type AgaveEmCostCodeCostType = {
  __typename: "AgaveEmCostCodeCostType",
  id: string,
  paidolId: string,
  authPaidolId: string,
  emCostCodeId: string,
  emCostTypeId: string,
  emGroup?: string | null,
  emCostCodeCode?: string | null,
  emCostCodeName?: string | null,
  emCostTypeCode?: string | null,
  emCostTypeName?: string | null,
  unitOfMeasure?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveEmCostCodeCostTypeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  emCostCodeId?: string | null,
  emCostTypeId?: string | null,
  emGroup?: string | null,
  emCostCodeCode?: string | null,
  emCostCodeName?: string | null,
  emCostTypeCode?: string | null,
  emCostTypeName?: string | null,
  unitOfMeasure?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveEmCostCodeCostTypeInput = {
  id: string,
};

export type CreateAgaveCostCodeCostTypeGlInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  costCodeId: string,
  costTypeId: string,
  glCodeId: string,
  projectCostCodeCostTypeKey: string,
  glCodeSourceId?: string | null,
  glCodeNumber?: string | null,
  itemSourceId?: string | null,
  itemName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAgaveCostCodeCostTypeGlConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  costTypeId?: ModelIDInput | null,
  glCodeId?: ModelIDInput | null,
  projectCostCodeCostTypeKey?: ModelIDInput | null,
  glCodeSourceId?: ModelStringInput | null,
  glCodeNumber?: ModelStringInput | null,
  itemSourceId?: ModelStringInput | null,
  itemName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeCostTypeGlConditionInput | null > | null,
  or?: Array< ModelAgaveCostCodeCostTypeGlConditionInput | null > | null,
  not?: ModelAgaveCostCodeCostTypeGlConditionInput | null,
};

export type AgaveCostCodeCostTypeGl = {
  __typename: "AgaveCostCodeCostTypeGl",
  id: string,
  paidolId: string,
  authPaidolId: string,
  projectId: string,
  costCodeId: string,
  costTypeId: string,
  glCodeId: string,
  projectCostCodeCostTypeKey: string,
  glCodeSourceId?: string | null,
  glCodeNumber?: string | null,
  itemSourceId?: string | null,
  itemName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateAgaveCostCodeCostTypeGlInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectId?: string | null,
  costCodeId?: string | null,
  costTypeId?: string | null,
  glCodeId?: string | null,
  projectCostCodeCostTypeKey?: string | null,
  glCodeSourceId?: string | null,
  glCodeNumber?: string | null,
  itemSourceId?: string | null,
  itemName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAgaveCostCodeCostTypeGlInput = {
  id: string,
};

export type CreateAgaveLocationInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  parent_id?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type ModelAgaveLocationConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  parent_id?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveLocationConditionInput | null > | null,
  or?: Array< ModelAgaveLocationConditionInput | null > | null,
  not?: ModelAgaveLocationConditionInput | null,
};

export type AgaveLocation = {
  __typename: "AgaveLocation",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  parent_id?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type UpdateAgaveLocationInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  fullName?: string | null,
  parent_id?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type DeleteAgaveLocationInput = {
  id: string,
};

export type CreateAgaveDepartmentInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type ModelAgaveDepartmentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveDepartmentConditionInput | null > | null,
  or?: Array< ModelAgaveDepartmentConditionInput | null > | null,
  not?: ModelAgaveDepartmentConditionInput | null,
};

export type AgaveDepartment = {
  __typename: "AgaveDepartment",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type UpdateAgaveDepartmentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  fullName?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
  relatedIds?: Array< string | null > | null,
};

export type DeleteAgaveDepartmentInput = {
  id: string,
};

export type CreateAgaveSubaccountInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type ModelAgaveSubaccountConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  and?: Array< ModelAgaveSubaccountConditionInput | null > | null,
  or?: Array< ModelAgaveSubaccountConditionInput | null > | null,
  not?: ModelAgaveSubaccountConditionInput | null,
};

export type AgaveSubaccount = {
  __typename: "AgaveSubaccount",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type UpdateAgaveSubaccountInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  name?: string | null,
  status?: string | null,
  type?: string | null,
  source_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  source_data?: string | null,
};

export type DeleteAgaveSubaccountInput = {
  id: string,
};

export type CreateAgaveVendorInput = {
  id?: string | null,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveVendorAddressInput | null,
  code?: string | null,
  email?: string | null,
  fax?: string | null,
  name?: string | null,
  phone?: string | null,
  status?: AgaveVendorStatus | null,
  tax_number?: string | null,
  terms?: string | null,
  type?: AgaveVendorType | null,
  website?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveVendorSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
};

export type AgaveVendorAddressInput = {
  street_1?: string | null,
  street_2?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  postal_code?: string | null,
};

export enum AgaveVendorStatus {
  Active = "Active",
  Archived = "Archived",
  Unknown = "Unknown",
}


export enum AgaveVendorType {
  Supplier = "Supplier",
  Regular = "Regular",
}


export type AgaveVendorSourceDataInput = {
  V1099YN: AgaveVendorV1099YN,
  V1099Type?: string | null,
  V1099Box?: string | null,
  EFT: AgaveVendorEFT,
  data?: string | null,
};

export enum AgaveVendorV1099YN {
  N = "N",
  Y = "Y",
}


export enum AgaveVendorEFT {
  A = "A",
  N = "N",
  P = "P",
}


export type ModelAgaveVendorConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  email?: ModelStringInput | null,
  fax?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  status?: ModelAgaveVendorStatusInput | null,
  tax_number?: ModelStringInput | null,
  terms?: ModelStringInput | null,
  type?: ModelAgaveVendorTypeInput | null,
  website?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  and?: Array< ModelAgaveVendorConditionInput | null > | null,
  or?: Array< ModelAgaveVendorConditionInput | null > | null,
  not?: ModelAgaveVendorConditionInput | null,
};

export type ModelAgaveVendorStatusInput = {
  eq?: AgaveVendorStatus | null,
  ne?: AgaveVendorStatus | null,
};

export type ModelAgaveVendorTypeInput = {
  eq?: AgaveVendorType | null,
  ne?: AgaveVendorType | null,
};

export type AgaveVendor = {
  __typename: "AgaveVendor",
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveVendorAddress | null,
  code?: string | null,
  email?: string | null,
  fax?: string | null,
  name?: string | null,
  phone?: string | null,
  status?: AgaveVendorStatus | null,
  tax_number?: string | null,
  terms?: string | null,
  type?: AgaveVendorType | null,
  website?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveVendorSourceData | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
};

export type AgaveVendorAddress = {
  __typename: "AgaveVendorAddress",
  street_1?: string | null,
  street_2?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  postal_code?: string | null,
};

export type AgaveVendorSourceData = {
  __typename: "AgaveVendorSourceData",
  V1099YN: AgaveVendorV1099YN,
  V1099Type?: string | null,
  V1099Box?: string | null,
  EFT: AgaveVendorEFT,
  data?: string | null,
};

export type UpdateAgaveVendorInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  source_id?: string | null,
  address?: AgaveVendorAddressInput | null,
  code?: string | null,
  email?: string | null,
  fax?: string | null,
  name?: string | null,
  phone?: string | null,
  status?: AgaveVendorStatus | null,
  tax_number?: string | null,
  terms?: string | null,
  type?: AgaveVendorType | null,
  website?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveVendorSourceDataInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fullName?: string | null,
};

export type DeleteAgaveVendorInput = {
  id: string,
};

export type UpdateUserInput = {
  id: string,
  username?: string | null,
  email?: string | null,
  first_name?: string | null,
  middle_name?: string | null,
  last_name?: string | null,
  suffix?: string | null,
  picture?: string | null,
  is_speedster?: string | null,
  birthdate?: string | null,
  address?: string | null,
  phone_number?: string | null,
  phone_extension?: string | null,
  password_updated_at?: string | null,
  finicityCustomerId?: string | null,
  dwollaCustomerId?: string | null,
  firstRunBanner?: FirstRunBannerInput | null,
  is_support?: boolean | null,
  deletedAt?: string | null,
};

export type FirstRunBannerInput = {
  insights?: boolean | null,
  transactions?: boolean | null,
  reimbursements?: boolean | null,
  cardsManagement?: boolean | null,
  spendRules?: boolean | null,
  funding?: boolean | null,
  teamMembers?: boolean | null,
  groups?: boolean | null,
  wallet?: boolean | null,
  settings?: boolean | null,
  connections?: boolean | null,
};

export type ModelUserConditionInput = {
  username?: ModelStringInput | null,
  email?: ModelStringInput | null,
  first_name?: ModelStringInput | null,
  middle_name?: ModelStringInput | null,
  last_name?: ModelStringInput | null,
  suffix?: ModelStringInput | null,
  picture?: ModelStringInput | null,
  is_speedster?: ModelStringInput | null,
  birthdate?: ModelStringInput | null,
  address?: ModelStringInput | null,
  phone_number?: ModelStringInput | null,
  phone_extension?: ModelStringInput | null,
  password_updated_at?: ModelStringInput | null,
  finicityCustomerId?: ModelStringInput | null,
  dwollaCustomerId?: ModelStringInput | null,
  is_support?: ModelBooleanInput | null,
  deletedAt?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  id?: ModelStringInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  username: string,
  email: string,
  first_name: string,
  middle_name?: string | null,
  last_name: string,
  suffix?: string | null,
  paidol_users?: ModelPaidolUserConnection | null,
  picture?: string | null,
  is_speedster?: string | null,
  birthdate?: string | null,
  address?: string | null,
  phone_number?: string | null,
  phone_extension?: string | null,
  password_updated_at?: string | null,
  finicityCustomerId?: string | null,
  dwollaCustomerId?: string | null,
  firstRunBanner?: FirstRunBanner | null,
  is_support?: boolean | null,
  deletedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPaidolUserConnection = {
  __typename: "ModelPaidolUserConnection",
  items:  Array<PaidolUser | null >,
  nextToken?: string | null,
};

export type PaidolUser = {
  __typename: "PaidolUser",
  id: string,
  paidol_id?: string | null,
  paidol?: Paidol | null,
  user_id?: string | null,
  user?: User | null,
  email?: string | null,
  position?: string | null,
  phone?: string | null,
  address?: Address | null,
  roles?: Role | null,
  is_test_fixture?: boolean | null,
  paymentCards?: ModelPaidolUserToHighnotePaymentCardConnection | null,
  authorizedUserId?: string | null,
  authorizedUserApplicationId?: string | null,
  allowedJobCodes?: Array< string > | null,
  employee_id?: number | null,
  managedGroups?: ModelPaidolUserToCardGroupConnection | null,
  managedProjectsGroups?: ModelPaidolUserToProjectGroupConnection | null,
  glCodeVisibilitySettings?: CodingFilteringSettings | null,
  projectVisibilitySettings?: CodingFilteringSettings | null,
  departmentVisibilitySettings?: CodingFilteringSettings | null,
  columnPreferences?:  Array<UserColumnPreferences > | null,
  widgetPreferences?:  Array<UserWidgetPreference > | null,
  // Default Agave (Sage Intacct) employee for this cardholder in this company.
  // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
  defaultAgaveEmployeeId?: string | null,
  defaultAgaveEmployee?: AgaveEmployeeEntity | null,
  deletedAt?: string | null,
  landingPagePreference?: LandingPagePreference | null,
  createdAt: string,
  updatedAt: string,
};

export type Paidol = {
  __typename: "Paidol",
  id: string,
  id_base58?: string | null,
  id_base58_short?: string | null,
  // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
  // that are associated w/ their Suppliers... this will probably need
  // to be rethought once we start onboarding Suppliers into the system
  // as Paidol administrators
  owner_paidol_id?: string | null,
  slug?: string | null,
  legal_name?: string | null,
  account_balance?: string | null,
  name: string,
  dba?: string | null,
  ein?: string | null,
  mcc?: string | null,
  corp_type?: string | null,
  industry?: string | null,
  company_email?: string | null,
  customer_facing_email?: string | null,
  company_phone?: string | null,
  website?: string | null,
  company_address?: Address | null,
  customer_facing_address?: Address | null,
  legal_address?: Address | null,
  business_owner_ssn?: string | null,
  dwolla_business_industry_classification?: string | null,
  admin_user_id?: string | null,
  low_balance_alert_threshold?: number | null,
  low_balance_auto_funding_amount?: number | null,
  low_balance_auto_funding_threshold?: number | null,
  speedscore?: number | null,
  priority_status?: string | null,
  deleted_at?: string | null,
  company_id?: string | null,
  logo?: string | null,
  priority_response?: string | null,
  // Indicates whether agave data is currently being synced to the Paidol
  agave_data_sync_in_progress?: boolean | null,
  // These are not trustworthy; validation happens in CPX and we
  // currently do not update this data if there is a validation error
  bankAccounts?:  Array<BankAccounts | null > | null,
  submittedBankAccounts?: Array< string | null > | null,
  achEnabled?: boolean | null,
  virtualCardRequested?: boolean | null,
  virtualCardEnabled?: boolean | null,
  achRequested?: boolean | null,
  cron_status?: CronStatus | null,
  // The Cognito user ID of the user who signed-up for Speedchain
  owner_sub?: string | null,
  is_test_fixture?: boolean | null,
  is_migration?: boolean | null,
  // Enables Payment Cards when signed-in to Speedchain
  enablePCards?: boolean | null,
  accountingDateSettings?: ToggleableSetting | null,
  reimbursementSettings?: ReimbursementSettings | null,
  receiptsSettings?: ReceiptSettings | null,
  approveWithoutReceipts?: boolean | null,
  notesSettings?: ToggleableSetting | null,
  editLockingSettings?: EditLockingSettings | null,
  jobCodeSettings?: ToggleableSetting | null,
  flexCodingSettings?: ToggleableSetting | null,
  flexFieldSettings?: ToggleableSetting | null,
  fuelCaptureSettings?: FuelCaptureToggleableSetting | null,
  // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
  isConstructionType?: boolean | null,
  // Account token that is getting persisted after a user authenticates with the agave widget
  agaveAccountToken?: string | null,
  // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
  // Persisted when user authenticates with Agave to avoid async lookup
  agaveSourceSystemSlug?: string | null,
  // Is this paidol an Agave client or not
  isAgaveClient?: boolean | null,
  // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
  erpSpeedchain?: boolean | null,
  // References the ERPConnection record for this paidol's direct ERP integration
  erpConnectionId?: string | null,
  // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
  // captured at swap time (before the Agave token is cleared). The direct-ERP
  // cutover reconciliation compares it to the reconnected realmId to confirm a
  // same-company migration before remapping coding references.
  priorErpRealmId?: string | null,
  // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
  priorErpName?: string | null,
  // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
  // this paidol, so subsequent direct syncs skip the bridge/clear step.
  erpCutoverReconciledAt?: string | null,
  // Track which ERP system a user wants to integrate their SC transactions with
  selectedERP?: ERP | null,
  primaryAuthorizedPerson?: PrimaryPaidolAuthorizedPerson | null,
  firstRunChecklist?: FirstRunChecklist | null,
  logoUrl?: string | null,
  isProcoreClient?: boolean | null,
  cardLockSettings?: CardLockToggleableSetting | null,
  sessionTimeoutSettings?: SessionTimeoutSetting | null,
  approvalWorkflowSettings?: ApprovalWorkflowSettings | null,
  projectFilteringByUser?: ToggleableSetting | null,
  glCodeFilteringByUser?: ToggleableSetting | null,
  locationFilteringByUser?: ToggleableSetting | null,
  departmentFilteringByUser?: ToggleableSetting | null,
  projectVisibilitySettings?: CodingFilteringSettings | null,
  glCodeVisibilitySettings?: CodingFilteringSettings | null,
  locationVisibilitySettings?: CodingFilteringSettings | null,
  creditLimit?: number | null,
  qboPostingSettings?: ERPPostingToggleableSetting | null,
  // SEE-1763: QBO only. When on, any coded field (Item, Class, Vendor, ...) is
  // enough to attempt a post and QuickBooks validates; off keeps the GL-or-Project rule.
  qboAnyCodingPostingSettings?: ERPPostingToggleableSetting | null,
  erpCostCodesUseDescriptionSetting?: ToggleableSetting | null,
  // SEE-1325: when enabled, every ERP coding dropdown is ordered by code/number
  // (natural sort) and rendered "code - name". Off (the default) keeps ordering by
  // name/description and the "name - (code)" format. Written by the CDK
  // updatePaidolSettings mutation; read here so the frontend can pick the label
  // format and skip its own client-side sort when the server already ordered.
  erpDropdownSortByCodeSetting?: ToggleableSetting | null,
  erpProjectsEndpointSetting?: ERPEndpointSettings | null,
  // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
  // Their projects/codes live as GL dimensions, so coding is sourced from them
  // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
  // filtering is bypassed (show all, no relationships exist), and posting routes the
  // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
  intacctProjectsNotLicensed?: boolean | null,
  // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
  // at the Sage top level posts on the top-level session, so Sage owns the record at
  // the top level and Projects > Generate Invoices sees it from the top level too.
  intacctTopLevelProjectPosting?: boolean | null,
  erpDepartmentLocationSetting?: ERPDepartmentLocationSetting | null,
  sage300PostingSettings?: ERPPostingToggleableSetting | null,
  sageIntacctBillableSettings?: ERPPostingToggleableSetting | null,
  receiptAgentSettings?: ReceiptAgentSettings | null,
  codingColumnsConfig?: CodingColumnsConfig | null,
  codingRequirements?: CodingRequirementsSettings | null,
  widgetVisibilityConfig?:  Array<UserWidgetPreference > | null,
  requireProjectBeforeCostCode?: ToggleableSetting | null,
  scopeEquipmentCodesToEmDepartment?: ToggleableSetting | null,
  paymentTermDays?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type Address = {
  __typename: "Address",
  address1?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  postal_code?: string | null,
};

export type BankAccounts = {
  __typename: "BankAccounts",
  bankId?: string | null,
  accountType?: AccountTypeEnum | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  defaults?: Array< DefaultsEnum | null > | null,
  isActive?: boolean | null,
};

// Used by Payables
export enum AccountTypeEnum {
  checking = "checking",
  savings = "savings",
}


// Used by Payables
export enum DefaultsEnum {
  ACH = "ACH",
  VCN = "VCN",
}


// Used by various models that are processed by a lambda
export enum CronStatus {
  TO_BE_PROCESSED = "TO_BE_PROCESSED", // Awaiting processing
  IN_TRANSIT = "IN_TRANSIT", // Appears to no longer be in use; see amplify/backend/function/createBuyerToPriority/src/Constants.cs
  PRIORITY_ERROR = "PRIORITY_ERROR", // An error occurred in CPX
  SPEEDCHAIN_ERROR = "SPEEDCHAIN_ERROR", // An error occurred in SPX
  PROCESSED = "PROCESSED", // Submitted to Priority
  COMPLETED = "COMPLETED", // Finished processing completely
}


export type ToggleableSetting = {
  __typename: "ToggleableSetting",
  isEnabled: boolean,
};

export type ReimbursementSettings = {
  __typename: "ReimbursementSettings",
  isEnabled: boolean,
  isCheckrunEnabled: boolean,
  rhythm?: ReimbursementRhythm | null,
  day?: number | null,
  weekday?: Weekday | null,
  ordinal?: Ordinal | null,
  mileageRate?: number | null,
  mileageRateEffectiveFrom?: string | null,
};

export enum ReimbursementRhythm {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}


export enum Weekday {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}


export enum Ordinal {
  FIRST = "FIRST",
  SECOND = "SECOND",
  THIRD = "THIRD",
  FOURTH = "FOURTH",
  LAST = "LAST",
}


export type ReceiptSettings = {
  __typename: "ReceiptSettings",
  isEnabled: boolean,
  minimumAmount?: number | null,
  exemptCardIds?: Array< string | null > | null,
};

export type EditLockingSettings = {
  __typename: "EditLockingSettings",
  isEnabled: boolean,
};

export type FuelCaptureToggleableSetting = {
  __typename: "FuelCaptureToggleableSetting",
  isEnabled: boolean,
  isVehicleIdRequired?: boolean | null,
  isGallonsRequired?: boolean | null,
  isOdometerRequired?: boolean | null,
  isMCC5542Required?: boolean | null,
  isMCC5541Required?: boolean | null,
};

export enum ERP {
  PROCORE = "PROCORE",
  AGAVE = "AGAVE",
}


export type PrimaryPaidolAuthorizedPerson = {
  __typename: "PrimaryPaidolAuthorizedPerson",
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: HNPhone,
  hasExtension?: boolean | null,
  birthdate: string,
  homeAddress: HNAddress,
  socialSecurityNumber?: string | null,
  jobTitle: string,
  percentageOwnership?: number | null,
};

export type HNPhone = {
  __typename: "HNPhone",
  countryCode?: string | null,
  number?: string | null,
  label?: HNPhoneLabel | null,
};

export enum HNPhoneLabel {
  MOBILE = "MOBILE",
  HOME = "HOME",
  WORK = "WORK",
  SUPPORT = "SUPPORT",
}


export type HNAddress = {
  __typename: "HNAddress",
  streetAddress?: string | null,
  extendedAddress?: string | null,
  postalCode?: string | null,
  region?: string | null,
  locality?: string | null,
  countryCodeAlpha3?: string | null,
};

export type FirstRunChecklist = {
  __typename: "FirstRunChecklist",
  connectFinancialAccount?: boolean | null,
  addAdmin?: boolean | null,
  addTeamMember?: boolean | null,
  createSpendRule?: boolean | null,
  issueCard?: boolean | null,
  createGroup?: boolean | null,
  setReimbursement?: boolean | null,
  integrateERP?: boolean | null,
  dismissWelcomePage?: boolean | null,
  isStepperComplete?: boolean | null,
};

export type CardLockToggleableSetting = {
  __typename: "CardLockToggleableSetting",
  isEnabled: boolean,
  daysToLock?: number | null,
  isReceiptsRequired?: boolean | null,
  isNotesRequired?: boolean | null,
  isFuelCaptureRequired?: boolean | null,
  applyImmediately?: boolean | null,
  disableAutoUnlock?: boolean | null,
  includePendingCharges?: boolean | null,
};

export type SessionTimeoutSetting = {
  __typename: "SessionTimeoutSetting",
  isEnabled: boolean,
  timeoutMinutes?: number | null,
};

export type ApprovalWorkflowSettings = {
  __typename: "ApprovalWorkflowSettings",
  isEnabled?: boolean | null,
  approvalLevels?: number | null,
  groupApprovalsEnabled?: boolean | null,
};

export type CodingFilteringSettings = {
  __typename: "CodingFilteringSettings",
  isAllAvailable: boolean,
  ids?: Array< string | null > | null,
};

export type ERPPostingToggleableSetting = {
  __typename: "ERPPostingToggleableSetting",
  isEnabled?: boolean | null,
};

export type ERPEndpointSettings = {
  __typename: "ERPEndpointSettings",
  selectedEndpoint?: string | null,
  isEnabled?: boolean | null,
  shouldDisplay?: boolean | null,
};

export type ERPDepartmentLocationSetting = {
  __typename: "ERPDepartmentLocationSetting",
  isEnabled?: boolean | null,
  departmentEnabled?: boolean | null,
  locationEnabled?: boolean | null,
  filterProjectsByEmployeeLocationEnabled?: boolean | null,
};

export type ReceiptAgentSettings = {
  __typename: "ReceiptAgentSettings",
  isEnabled: boolean,
};

export type CodingColumnsConfig = {
  __typename: "CodingColumnsConfig",
  isEnabled?: boolean | null,
  glCode?: CodingColumnSettings | null,
  project?: CodingColumnSettings | null,
  costCode?: CodingColumnSettings | null,
  costType?: CodingColumnSettings | null,
  vendor?: CodingColumnSettings | null,
  subJob?: CodingColumnSettings | null,
  location?: CodingColumnSettings | null,
  department?: CodingColumnSettings | null,
  employee?: CodingColumnSettings | null,
  accountingDate?: CodingColumnSettings | null,
  subaccount?: CodingColumnSettings | null,
  jobCode?: CodingColumnSettings | null,
  billableItem?: CodingColumnSettings | null,
  transactionType?: CodingColumnSettings | null,
  equipment?: CodingColumnSettings | null,
  emCostCode?: CodingColumnSettings | null,
  emCostType?: CodingColumnSettings | null,
};

export type CodingColumnSettings = {
  __typename: "CodingColumnSettings",
  visibility?: ColumnVisibilityLevel | null,
  order?: number | null,
  customLabel?: string | null,
  defaultValue?: FilterOption | null,
  isRequired?: boolean | null,
};

export enum ColumnVisibilityLevel {
  DISABLED = "DISABLED",
  ADMINISTRATOR = "ADMINISTRATOR",
  GROUP_ADMINISTRATOR = "GROUP_ADMINISTRATOR",
  CARDHOLDER = "CARDHOLDER",
}


export type FilterOption = {
  __typename: "FilterOption",
  id: string,
  label: string,
  projectId?: string | null,
};

export type CodingRequirementsSettings = {
  __typename: "CodingRequirementsSettings",
  isEnabled?: boolean | null,
  groups?:  Array<CodingRequirementGroup | null > | null,
};

export type CodingRequirementGroup = {
  __typename: "CodingRequirementGroup",
  columns?: Array< string | null > | null,
};

export type UserWidgetPreference = {
  __typename: "UserWidgetPreference",
  widgetId: string,
  hidden: boolean,
};

// Permissions levels that a user may have
export enum Role {
  ADMINISTRATOR = "ADMINISTRATOR", // Paidol owner; can do everything. Displayed in the UI as "Administrator".
  // Operational admin: manages users, cards, spend rules, and settings. Cannot
  // access credit management, cannot view or approve transactions. SEE-946.
  SECONDARY_ADMINISTRATOR = "SECONDARY_ADMINISTRATOR",
  // Transaction-approval admin: views transactions, marks reviewed, and approves
  // the Flex final step. No platform/user/card management. SEE-946.
  APPROVAL_ADMINISTRATOR = "APPROVAL_ADMINISTRATOR",
  GROUP_ADMINISTRATOR = "GROUP_ADMINISTRATOR", // Manages a group of users; can do some admin tasks, but only for their group
  CARDHOLDER = "CARDHOLDER", // A holder of a payment card, with limited access
  MEMBER = "MEMBER", // Intended for future use
}


export type ModelPaidolUserToHighnotePaymentCardConnection = {
  __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
  items:  Array<PaidolUserToHighnotePaymentCard | null >,
  nextToken?: string | null,
};

export type PaidolUserToHighnotePaymentCard = {
  __typename: "PaidolUserToHighnotePaymentCard",
  id?: string | null,
  paidolUserID?: string | null,
  highnotePaymentCardID?: string | null,
  paidolUser?: PaidolUser | null,
  highnotePaymentCard?: HighnotePaymentCard | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HighnotePaymentCard = {
  __typename: "HighnotePaymentCard",
  paymentCardId: string,
  paidolId: string,
  authPaidolId: string,
  paidolUsers?: ModelPaidolUserToHighnotePaymentCardConnection | null,
  name?: string | null,
  cardGroupId?: string | null,
  group?: CardGroup | null,
  status?: HNPaymentCardStatus | null,
  bin?: string | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  formFactor?: HNCardFormFactor | null,
  expirationDate?: string | null,
  budget?: HNVelocityRuleConnection | null,
  hasPin?: boolean | null,
  procoreEmployee?: IssuePaymentCardProcoreEmployee | null,
  cardholderId?: string | null,
  cardholder?: PaidolUser | null,
  cardholderName?: string | null,
  isAdminLocked?: boolean | null,
  // Who last locked, unlocked or cancelled this card, captured at the moment of
  // the action (SEE-946, SEE-1495). Never resolved at read time.
  lastActionByRole?: string | null,
  lastActionByPaidolUserId?: string | null,
  lastActionByName?: string | null,
  lastActionByEmail?: string | null,
  lastActionAt?: string | null,
  merchantSpendRuleId?: string | null,
  isAuthorizedUserCard?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type CardGroup = {
  __typename: "CardGroup",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  groupProjects?: Array< string | null > | null,
  paymentCards?: ModelHighnotePaymentCardConnection | null,
  monthlyBudget?: Currency | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  spendGroup?: MerchantSpendRule | null,
  monthlyBudgetSpend?: ModelCardGroupBudgetSpendByMonthConnection | null,
  transactions?: ModelHighnoteTransactionEventConnection | null,
  groupAdmins?: ModelPaidolUserToCardGroupConnection | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettings | null,
  projectVisibilitySettings?: CodingFilteringSettings | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonth | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelHighnotePaymentCardConnection = {
  __typename: "ModelHighnotePaymentCardConnection",
  items:  Array<HighnotePaymentCard | null >,
  nextToken?: string | null,
};

export type Currency = {
  __typename: "Currency",
  // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
  // This guards against rounding errors in floating point math
  value: number,
  // The currency code; in real life always 'USD' for now.
  currency: string,
};

export type MerchantSpendRule = {
  __typename: "MerchantSpendRule",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  paymentCards?: Array< string | null > | null,
  merchantCountrySpendRuleId?: string | null,
  merchantCategorySpendRuleId?: string | null,
  amountLimitSpendRuleId?: string | null,
  monthlyLimitSpendRuleId?: string | null,
  monthlyLimitCumulativeRuleId?: string | null,
  maximumAmount?: HNAmount | null,
  monthlyLimitAmount?: HNAmount | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  monthlyLimitResetTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type HNAmount = {
  __typename: "HNAmount",
  value?: number | null,
  currencyCode?: string | null,
  decimalPlaces?: number | null,
};

export type ModelCardGroupBudgetSpendByMonthConnection = {
  __typename: "ModelCardGroupBudgetSpendByMonthConnection",
  items:  Array<CardGroupBudgetSpendByMonth | null >,
  nextToken?: string | null,
};

export type CardGroupBudgetSpendByMonth = {
  __typename: "CardGroupBudgetSpendByMonth",
  cardGroupId: string,
  paidolId: string,
  yearAndMonth: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelHighnoteTransactionEventConnection = {
  __typename: "ModelHighnoteTransactionEventConnection",
  items:  Array<HighnoteTransactionEvent | null >,
  nextToken?: string | null,
};

export type HighnoteTransactionEvent = {
  __typename: "HighnoteTransactionEvent",
  id: string,
  transactionId: string,
  transaction?: HighnoteTransaction | null,
  paymentCardId: string,
  paymentCard?: HighnotePaymentCard | null,
  paidolId: string,
  reconciliationId?: string | null,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  eventDate: string,
  processedAt?: string | null,
  origin: string,
  status: HighnoteTransactionStatus,
  partial?: boolean | null,
  settlementImpact?: boolean | null,
  approvedAmount: HNAmount,
  fees?:  Array<HNAmount | null > | null,
  approvedAmountValue?: number | null,
  approvedAmountCurrencyCode?: string | null,
  eventData?: string | null,
  transactionOldState?: string | null,
  transactionNewState?: string | null,
  enableListing?: boolean | null,
  email?: string | null,
  userId?: string | null,
  user?: User | null,
  last4?: string | null,
  card?: HighnotePaymentCard | null,
  groupApprovalLevels?: number | null,
  owningProjectGroupIds?: Array< string | null > | null,
  cardGroupId?: string | null,
  cardGroup?: CardGroup | null,
  merchantCategory?: string | null,
  merchantCategoryCode?: string | null,
  merchantName?: string | null,
  jobCodeId?: string | null,
  jobCode?: JobCode | null,
  flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
  workflowStatus?: WorkflowStatus | null,
  returnedStatus?: ReturnedStatus | null,
  flexCodeId?: string | null,
  flexCode?: FlexCode | null,
  flexCostCodeId?: string | null,
  flexCostCode?: FlexCostCode | null,
  flexCostTypeId?: string | null,
  flexCostType?: FlexCostType | null,
  flexGlCodeId?: string | null,
  flexGlCode?: FlexGlCode | null,
  flexVendorId?: string | null,
  flexVendor?: FlexVendor | null,
  agaveDepartment?: AgaveDepartment | null,
  agaveDepartmentId?: string | null,
  agaveLocation?: AgaveLocation | null,
  agaveLocationId?: string | null,
  agaveSubaccount?: AgaveSubaccount | null,
  agaveSubaccountId?: string | null,
  agaveEmployee?: AgaveEmployeeEntity | null,
  agaveEmployeeId?: string | null,
  agaveExpense?: CreateAgaveExpenseAPInvoice | null,
  agaveExpenseId?: string | null,
  agaveProject?: AgaveProject | null,
  agaveProjectId?: string | null,
  agaveCostCode?: AgaveCostCode | null,
  agaveCostCodeId?: string | null,
  agaveCostTypeId?: string | null,
  agaveCostType?: AgaveCostType | null,
  agaveGlCode?: AgaveGlCode | null,
  agaveGlCodeId?: string | null,
  agaveVendor?: AgaveVendor | null,
  agaveVendorId?: string | null,
  agaveSubJob?: AgaveSubJob | null,
  agaveSubJobId?: string | null,
  agaveEquipment?: AgaveEquipment | null,
  agaveEquipmentId?: string | null,
  agaveEmCostCode?: AgaveEmCostCode | null,
  agaveEmCostCodeId?: string | null,
  agaveEmCostType?: AgaveEmCostType | null,
  agaveEmCostTypeId?: string | null,
  codingType?: string | null,
  accountingDate?: string | null,
  procoreDirectCostId?: number | null,
  procoreDirectCostLineItemId?: number | null,
  procoreProject?: GetProcoreProjectsPayload | null,
  procoreProjectId?: number | null,
  procoreWBSCode?: GetProcoreWBSCodesPayload | null,
  procoreWBSCodeId?: number | null,
  erpApprovalStatus?: boolean | null,
  erpBypassStatus?: boolean | null,
  // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
  // line billable at post time (Sage Intacct's billable cascade also requires the coded
  // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
  // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
  // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
  // ERP-neutral so a future ERP can reuse the same fields.
  erpBillableItemId?: string | null,
  erpBillableItemName?: string | null,
  // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
  // (manual pick or cost-type derivation); explicitly false posts the line
  // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
  // behavior: item present = billable.
  erpBillable?: boolean | null,
  // Generic ERP posting status tracking (for all ERPs)
  erpPostingStatus?: ERPPostingStatus | null,
  erpPostingError?: string | null,
  // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
  // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
  erpPostingWarning?: string | null,
  // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
  sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
  sage300APInvoiceError?: string | null,
  note?: string | null,
  approveWithoutNotes?: boolean | null,
  receiptPath?: string | null,
  receiptId?: string | null,
  receipt?: ReceiptUpload | null,
  // Source-of-truth flag maintained by the v2-transaction Lambda from the
  // TransactionToReceiptUpload join table. Use this for "does this transaction
  // have a receipt"; receiptPath/receiptId are legacy display pointers.
  hasReceipt?: boolean | null,
  approveWithoutReceipts?: boolean | null,
  // Fuel capture fields for tracking fuel purchases
  fuelVehicleId?: string | null,
  fuelOdometerReading?: number | null,
  fuelGallons?: number | null,
  fuelCostPerGallon?: number | null,
  // Admin time savings tracking (SEE-407)
  codedAt?: string | null,
  codingMethod?: string | null,
  receiptUploadedAt?: string | null,
  receiptUploadMethod?: string | null,
  // SEE-1462: set once the transaction has been HANDLED by the daily flex
  // transaction export. Selection is "qualifying and erpExportedAt not set", plus
  // ONE permanent time bound: transactions dated before the company's enablement
  // window are baseline-stamped rather than delivered (see erpExportBatchId
  // below). There is deliberately no index on this field — the export queries
  // byPaidol and filters (an accepted read cost that grows with the company's
  // history).
  // 
  // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
  // stamps BEFORE building/uploading the file (a conditional update on
  // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
  // the file — this is what makes concurrent runs safe), and on a failed delivery
  // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
  // the rows return to the pool. Residual risk is a process kill between stamp and
  // rollback; the unwind is operational: for a FlexTransactionExport row that is
  // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
  // from the console/CLI, oldest first; deliberately no AppSync queryField), find
  // this paidol's transactions where
  // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
  // field is on the @searchable projection, no scan needed) and REMOVE
  // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
  // rollback fails, naming the stuck transaction ids.
  // 
  // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
  // a FlexTransactionExport.id for rows actually delivered in that run, or
  // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
  // handled-before-switch-on — on ANY run, not just the first: the cutoff is
  // permanent (anchored on the company's earliest export attempt; the audit row
  // for a run is created BEFORE the anchor is read, so a true first run anchors
  // on its own row), and a pre-enablement transaction is stamped whenever it
  // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
  // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
  // rollback nor the manual unwind above touches them (both match the bare batch
  // id, which "baseline-" rows never equal — that exclusion is intentional, not an
  // oversight; an operator should not hunt for baseline rows that "didn't get
  // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
  // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
  // newly enabled company's entire history would display as Exported for files
  // that never existed.
  // 
  // Field-level auth: read-only through AppSync for group members; admin roles
  // (custom-roles.json) bypass rules as everywhere. A client that can set
  // erpExportedAt can silently suppress a transaction from every future file
  // (selection skips stamped rows), or clear it and force a duplicate. The
  // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
  // `allow: private, provider: iam` read here either. A field-level rule is
  // unioned into the model's read resolvers, so it would reopen get/list/search
  // to every signed-in user's identity pool role.
  erpExportedAt?: string | null,
  erpExportBatchId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type HighnoteTransaction = {
  __typename: "HighnoteTransaction",
  transactionId: string,
  paymentCardId: string,
  paymentCard?: HighnotePaymentCard | null,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  cardGroupId?: string | null,
  cardGroup?: CardGroup | null,
  status: HighnoteTransactionStatus,
  transactionDate: string,
  approvedAmount: HNAmount,
  merchantName?: string | null,
  merchantCategoryCode?: string | null,
  // Our custom category mapping, based on original MCCCode
  merchantCategory?: string | null,
  // An array of source TransactionEvents payloads from the Highnote API.
  // May be useful in future if we need to backfill this data with additional
  // fields. This data is in its original JSON-serialized format.
  transactionEvents?: Array< string | null > | null,
  note?: string | null,
  jobCodeId?: string | null,
  jobCode?: JobCode | null,
  procoreCompanyId?: number | null,
  procoreCompany?: GetProcoreCompaniesPayload | null,
  procoreProjectId?: number | null,
  procoreProject?: GetProcoreProjectsPayload | null,
  procoreWBSCodeId?: number | null,
  procoreWBSCode?: GetProcoreWBSCodesPayload | null,
  procoreDirectCostId?: number | null,
  procoreDirectCostLineItemId?: number | null,
  agaveProjectId?: string | null,
  agaveProject?: AgaveProject | null,
  agaveCostCodeId?: string | null,
  agaveCostCode?: AgaveCostCode | null,
  agaveCostTypeId?: string | null,
  agaveCostType?: AgaveCostType | null,
  agaveExpenseId?: string | null,
  agaveExpense?: CreateAgaveExpenseAPInvoice | null,
  agaveVendor?: AgaveVendor | null,
  agaveVendorId?: string | null,
  agaveGlCodeId?: string | null,
  agaveGlCode?: AgaveGlCode | null,
  agaveDepartmentId?: string | null,
  agaveLocationId?: string | null,
  agaveSubaccountId?: string | null,
  agaveSubaccount?: AgaveSubaccount | null,
  // AWS S3 receipt upload path
  receiptPath?: string | null,
  receiptId?: string | null,
  receipt?: ReceiptUpload | null,
  // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
  erpApprovalStatus?: boolean | null,
  // Track when a transaction is marked to bypass ERP posting (acts like posted)
  erpBypassStatus?: boolean | null,
  last4?: string | null,
  userId?: string | null,
  user?: User | null,
  // The email from paidolUser assigned to the Highnote Payment Card
  email?: string | null,
  approvedAmountValue?: number | null,
  approvedAmountCurrencyCode?: string | null,
  flexCodeId?: string | null,
  flexCode?: FlexCode | null,
  flexCostCodeId?: string | null,
  flexCostCode?: FlexCostCode | null,
  flexCostTypeId?: string | null,
  flexCostType?: FlexCostType | null,
  flexGlCodeId?: string | null,
  flexGlCode?: FlexGlCode | null,
  flexVendorId?: string | null,
  flexVendor?: FlexVendor | null,
  selectedCodingOption?: CodingOptions | null,
  card?: HighnotePaymentCard | null,
  agaveGlCostTypeId?: string | null,
  agaveGlCostType?: AgaveGlCostType | null,
  flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
  approveWithoutNotes?: boolean | null,
  approveWithoutReceipts?: boolean | null,
  // Fuel capture fields for tracking fuel purchases
  fuelVehicleId?: string | null,
  fuelOdometerReading?: number | null,
  fuelGallons?: number | null,
  fuelCostPerGallon?: number | null,
  createdAt: string,
  updatedAt: string,
};

// Our own custom status codes for transactions that correspond
// to how we want to present transaction in Speedchain. These
// are based on Highnote's transaction event types.
export enum HighnoteTransactionStatus {
  APPROVED = "APPROVED", // Charge is approved, but not yet final
  // Approval has been canceled.
  // This generally doesn't need to be shown to the user, since
  // it means that a transaction was aborted entirely.
  REVERSED = "REVERSED",
  CLEARED = "CLEARED", // Charge has been cleared & deducted
  REFUNDED = "REFUNDED", // Money has been put back into account
}


export type JobCode = {
  __typename: "JobCode",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  description: string,
  code: string,
  isActive: boolean,
  budget?: number | null,
  jobCodeImportId: string,
  jobCodeImport?: JobCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export type JobCodeImport = {
  __typename: "JobCodeImport",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  createdAt: string,
  storageFileKey: string,
  fileName: string,
  status: JobCodeImportStatus,
  errors?: string | null,
  jobCodes?: ModelJobCodeConnection | null,
  updatedAt: string,
};

export enum JobCodeImportStatus {
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}


export type ModelJobCodeConnection = {
  __typename: "ModelJobCodeConnection",
  items?:  Array<GetJobCodesJobCodePayload | null > | null,
  nextToken?: string | null,
};

export type GetJobCodesJobCodePayload = {
  __typename: "GetJobCodesJobCodePayload",
  id: string,
  paidolId: string,
  authPaidolId: string,
  description: string,
  code: string,
  isActive: boolean,
  budget?: number | null,
  jobCodeImportId: string,
  createdAt: string,
  updatedAt: string,
  spent?: GetJobCodesSpentPayload | null,
};

export type GetJobCodesSpentPayload = {
  __typename: "GetJobCodesSpentPayload",
  amount: number,
  currency: string,
};

export type GetProcoreCompaniesPayload = {
  __typename: "GetProcoreCompaniesPayload",
  id: number,
  name: string,
  is_active: boolean,
  logo_url?: string | null,
};

export type GetProcoreProjectsPayload = {
  __typename: "GetProcoreProjectsPayload",
  id: number,
  active: boolean,
  display_name: string,
  name: string,
  created_at: string,
  start_date?: string | null,
  completion_date?: string | null,
  project_number?: string | null,
  project_stage?: ProcoreProjectStage | null,
  project_template?: ProcoreProjectTemplate | null,
  total_value?: string | null,
};

export type ProcoreProjectStage = {
  __typename: "ProcoreProjectStage",
  id: number,
  name: string,
};

export type ProcoreProjectTemplate = {
  __typename: "ProcoreProjectTemplate",
  id: number,
  name: string,
};

export type GetProcoreWBSCodesPayload = {
  __typename: "GetProcoreWBSCodesPayload",
  id: number,
  flat_code?: string | null,
  flat_name?: string | null,
  description?: string | null,
  status?: string | null,
  segment_items?:  Array<ProcoreSegmentItem > | null,
};

export type ProcoreSegmentItem = {
  __typename: "ProcoreSegmentItem",
  id: number,
  code?: string | null,
  name?: string | null,
  status?: string | null,
  segment?: ProcoreSegment | null,
};

export type ProcoreSegment = {
  __typename: "ProcoreSegment",
  id: number,
  name?: string | null,
  type?: string | null,
};

export type CreateAgaveExpenseAPInvoice = {
  __typename: "CreateAgaveExpenseAPInvoice",
  id: string,
  source_id?: string | null,
  amount?: string | null,
  amount_due?: string | null,
  ap_payment_ids?: Array< string | null > | null,
  attachments?:  Array<CreateAgaveExpenseAttachment | null > | null,
  batch?: string | null,
  batch_id?: string | null,
  contract?: CreateAgaveExpenseContract | null,
  creator_id?: string | null,
  currency_code?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  discount_date?: string | null,
  due_date?: string | null,
  issue_date?: string | null,
  line_items?:  Array<CreateAgaveExpenseAPInvoiceLineItem | null > | null,
  misc_amount?: string | null,
  net_amount?: string | null,
  number?: string | null,
  project_id?: string | null,
  retention_amount?: string | null,
  retention_percent?: string | null,
  status?: string | null,
  subtotal_amount?: string | null,
  tax_amount?: string | null,
  total_amount?: string | null,
  type?: string | null,
  vendor_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: CreateAgaveExpenseAPInvoiceSourceData | null,
};

export type CreateAgaveExpenseAttachment = {
  __typename: "CreateAgaveExpenseAttachment",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
  url?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type CreateAgaveExpenseContract = {
  __typename: "CreateAgaveExpenseContract",
  id?: string | null,
  type?: string | null,
};

export type CreateAgaveExpenseAPInvoiceLineItem = {
  __typename: "CreateAgaveExpenseAPInvoiceLineItem",
  id?: string | null,
  source_id?: string | null,
  amount?: string | null,
  change_order?: CreateAgaveExpenseChangeOrder | null,
  contract?: CreateAgaveExpenseContract | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  customer_id?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  item_id?: string | null,
  ledger_account_id?: string | null,
  project_id?: string | null,
  quantity?: string | null,
  retention_amount?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  tax_amount?: string | null,
  tax_code_id?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_of_measure?: string | null,
  vendor_id?: string | null,
  wbs_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type CreateAgaveExpenseChangeOrder = {
  __typename: "CreateAgaveExpenseChangeOrder",
  id?: string | null,
  line_item_id?: string | null,
};

export type CreateAgaveExpenseAPInvoiceSourceData = {
  __typename: "CreateAgaveExpenseAPInvoiceSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type ReceiptUpload = {
  __typename: "ReceiptUpload",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  document: string,
  status: ReceiptUploadStatus,
  summaryFields?: ModelReceiptSummaryFieldConnection | null,
  lineItems?: ModelReceiptLineItemConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum ReceiptUploadStatus {
  PENDING = "PENDING",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
}


export type ModelReceiptSummaryFieldConnection = {
  __typename: "ModelReceiptSummaryFieldConnection",
  items:  Array<ReceiptSummaryField | null >,
  nextToken?: string | null,
};

export type ReceiptSummaryField = {
  __typename: "ReceiptSummaryField",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  receiptUploadId: string,
  type: NormalizedSummaryField,
  typeConfidenceScore?: number | null,
  label?: string | null,
  labelConfidenceScore?: number | null,
  value?: string | null,
  valueConfidenceScore?: number | null,
  createdAt: string,
  updatedAt: string,
};

export enum NormalizedSummaryField {
  INVOICE_RECEIPT_DATE = "INVOICE_RECEIPT_DATE",
  INVOICE_RECEIPT_ID = "INVOICE_RECEIPT_ID",
  TAX_PAYER_ID = "TAX_PAYER_ID",
  CUSTOMER_NUMBER = "CUSTOMER_NUMBER",
  ACCOUNT_NUMBER = "ACCOUNT_NUMBER",
  VENDOR_NAME = "VENDOR_NAME",
  RECEIVER_NAME = "RECEIVER_NAME",
  VENDOR_ADDRESS = "VENDOR_ADDRESS",
  RECEIVER_ADDRESS = "RECEIVER_ADDRESS",
  ORDER_DATE = "ORDER_DATE",
  DUE_DATE = "DUE_DATE",
  DELIVERY_DATE = "DELIVERY_DATE",
  PO_NUMBER = "PO_NUMBER",
  PAYMENT_TERMS = "PAYMENT_TERMS",
  TOTAL = "TOTAL",
  AMOUNT_DUE = "AMOUNT_DUE",
  AMOUNT_PAID = "AMOUNT_PAID",
  SUBTOTAL = "SUBTOTAL",
  TAX = "TAX",
  SERVICE_CHARGE = "SERVICE_CHARGE",
  GRATUITY = "GRATUITY",
  PRIOR_BALANCE = "PRIOR_BALANCE",
  DISCOUNT = "DISCOUNT",
  SHIPPING_HANDLING_CHARGE = "SHIPPING_HANDLING_CHARGE",
  VENDOR_ABN_NUMBER = "VENDOR_ABN_NUMBER",
  VENDOR_GST_NUMBER = "VENDOR_GST_NUMBER",
  VENDOR_PAN_NUMBER = "VENDOR_PAN_NUMBER",
  VENDOR_VAT_NUMBER = "VENDOR_VAT_NUMBER",
  RECEIVER_ABN_NUMBER = "RECEIVER_ABN_NUMBER",
  RECEIVER_GST_NUMBER = "RECEIVER_GST_NUMBER",
  RECEIVER_PAN_NUMBER = "RECEIVER_PAN_NUMBER",
  RECEIVER_VAT_NUMBER = "RECEIVER_VAT_NUMBER",
  VENDOR_PHONE = "VENDOR_PHONE",
  RECEIVER_PHONE = "RECEIVER_PHONE",
  VENDOR_URL = "VENDOR_URL",
  ITEM = "ITEM",
  QUANTITY = "QUANTITY",
  PRICE = "PRICE",
  UNIT_PRICE = "UNIT_PRICE",
  PRODUCT_CODE = "PRODUCT_CODE",
  ADDRESS = "ADDRESS",
  NAME = "NAME",
  ADDRESS_BLOCK = "ADDRESS_BLOCK",
  STREET = "STREET",
  CITY = "CITY",
  STATE = "STATE",
  COUNTRY = "COUNTRY",
  ZIP_CODE = "ZIP_CODE",
  OTHER = "OTHER",
}


export type ModelReceiptLineItemConnection = {
  __typename: "ModelReceiptLineItemConnection",
  items:  Array<ReceiptLineItem | null >,
  nextToken?: string | null,
};

export type ReceiptLineItem = {
  __typename: "ReceiptLineItem",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  receiptUploadId: string,
  lineItemFields?: ModelReceiptLineItemFieldConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelReceiptLineItemFieldConnection = {
  __typename: "ModelReceiptLineItemFieldConnection",
  items:  Array<ReceiptLineItemField | null >,
  nextToken?: string | null,
};

export type ReceiptLineItemField = {
  __typename: "ReceiptLineItemField",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  receiptLineItemId: string,
  type: NormalizedSummaryField,
  typeConfidenceScore: number,
  label: string,
  labelConfidenceScore: number,
  value: string,
  valueConfidenceScore: number,
  createdAt: string,
  updatedAt: string,
};

export type FlexCode = {
  __typename: "FlexCode",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  projectName: string,
  projectCode?: string | null,
  isActive: boolean,
  flexCodeImportId: string,
  flexCodeImport?: FlexCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export type FlexCodeImport = {
  __typename: "FlexCodeImport",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  createdAt: string,
  updatedAt: string,
  storageFileKey: string,
  fileName: string,
  status: FlexCodeImportStatus,
  errors?: string | null,
  searchSynced?: boolean | null,
  flexCodes?: ModelFlexCodeConnection | null,
  type: FlexCodeImportType,
};

export enum FlexCodeImportStatus {
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}


export type ModelFlexCodeConnection = {
  __typename: "ModelFlexCodeConnection",
  items:  Array<FlexCode | null >,
  nextToken?: string | null,
};

export enum FlexCodeImportType {
  BASIC = "BASIC",
  OPTIMIZED = "OPTIMIZED",
}


export type FlexCostCode = {
  __typename: "FlexCostCode",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  code: string,
  flexCodeImportId: string,
  flexCodeImport?: FlexCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export type FlexCostType = {
  __typename: "FlexCostType",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
  flexCodeImport?: FlexCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export type FlexGlCode = {
  __typename: "FlexGlCode",
  id: string,
  paidolId: string,
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
  flexCodeImport?: FlexCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export type FlexVendor = {
  __typename: "FlexVendor",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
  flexCodeImport?: FlexCodeImport | null,
  createdAt: string,
  updatedAt: string,
};

export enum CodingOptions {
  ProjectCodes = "ProjectCodes",
  GLCode = "GLCode",
}


export type AgaveGlCostType = {
  __typename: "AgaveGlCostType",
  id?: string | null,
  source_id?: string | null,
  code?: string | null,
  name?: string | null,
  project_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveGlCostTypeSourceData | null,
};

export type AgaveGlCostTypeSourceData = {
  __typename: "AgaveGlCostTypeSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export enum FlexCodeTransactionStatus {
  APPROVED = "APPROVED",
  REVIEWED = "REVIEWED",
  NEEDS_REVIEW = "NEEDS_REVIEW",
}


export enum WorkflowStatus {
  NEW = "NEW",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  RETURNED = "RETURNED",
  GROUP_APPROVAL_1 = "GROUP_APPROVAL_1",
  GROUP_FINAL_APPROVAL = "GROUP_FINAL_APPROVAL",
  PENDING_APPROVAL_1 = "PENDING_APPROVAL_1",
  PENDING_FINAL_APPROVAL = "PENDING_FINAL_APPROVAL",
  APPROVED = "APPROVED",
  EXPORTED = "EXPORTED",
}


export enum ReturnedStatus {
  RETURNED = "RETURNED",
  RESUBMITTED = "RESUBMITTED",
}


export enum ERPPostingStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum Sage300APInvoiceStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export type ModelPaidolUserToCardGroupConnection = {
  __typename: "ModelPaidolUserToCardGroupConnection",
  items:  Array<PaidolUserToCardGroup | null >,
  nextToken?: string | null,
};

export type PaidolUserToCardGroup = {
  __typename: "PaidolUserToCardGroup",
  id: string,
  paidolId: string,
  paidolUserId: string,
  cardGroupId: string,
  paidolUser?: PaidolUser | null,
  cardGroup: CardGroup,
  approvalLevels?: Array< number | null > | null,
  isReviewer?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type AmountSpentThisMonth = {
  __typename: "AmountSpentThisMonth",
  amount?: number | null,
  yearAndMonth?: string | null,
};

export enum HNPaymentCardStatus {
  ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CLOSED = "CLOSED",
}


export enum HNPaymentCardNetwork {
  MASTERCARD = "MASTERCARD",
  VISA = "VISA",
}


export enum HNCardFormFactor {
  VIRTUAL = "VIRTUAL",
  PHYSICAL = "PHYSICAL",
}


export type HNVelocityRuleConnection = {
  __typename: "HNVelocityRuleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNVelocityRuleEdge > | null,
};

export type HNPageInfo = {
  __typename: "HNPageInfo",
  hasNextPage: boolean,
  hasPreviousPage: boolean,
  startCursor: string,
  endCursor: string,
};

export type HNVelocityRuleEdge = {
  __typename: "HNVelocityRuleEdge",
  cursor: string,
  node?: HNVelocityRule | null,
};

export type HNVelocityRule = {
  __typename: "HNVelocityRule",
  id: string,
  name?: string | null,
  velocityRuleWindow?: HNVelocityRuleWindow | null,
  cumulativeRule?: HNSpendRule | null,
  spendRules?:  Array<HNSpendRule | null > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNVelocityRuleConnection | null,
  velocityConstraintLevelOverride?: HNVelocityConstraintLevel | null,
};

export type HNNode = {
  __typename: "HNNode",
  id: string,
};

export type HNUSPersonAccountHolder = {
  __typename: "HNUSPersonAccountHolder",
  id: string,
  name?: HNName | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  billingAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  externalId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  personCreditRiskAttributes?: HNPersonCreditRiskAttributes | null,
  cardProductApplications?: HNAccountHolderCardProductApplicationConnection | null,
  paymentCards?: HNPaymentCardConnection | null,
  externalFinancialAccounts?: HNExternalFinancialAccountConnection | null,
  financialAccounts?: HNFinancialAccountConnection | null,
  globalNotes?: HNGlobalNoteConnectionPayload | null,
};

export type HNPersonAccountHolder = {
  __typename: "HNPersonAccountHolder",
  name?: HNName | null,
  billingAddress?: HNAddress | null,
};

export type HNUSPersonAccountHolderSnapshot = {
  __typename: "HNUSPersonAccountHolderSnapshot",
  accountHolderCurrent?: HNUSPersonAccountHolder | null,
  name?: HNName | null,
  billingAddress?: HNAddress | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  currentVerification?: HNAccountHolderVerification | null,
  currentCreditUnderwritingVerification?: HNCreditUnderwritingVerification | null,
  personCreditRiskAttributes?: HNPersonCreditRiskAttributes | null,
};

export type HNName = {
  __typename: "HNName",
  givenName?: string | null,
  middleName?: string | null,
  familyName?: string | null,
  suffix?: string | null,
  title?: string | null,
};

export type HNUSIdentificationDocument = {
  __typename: "HNUSIdentificationDocument",
  socialSecurityNumber?: HNTaxIdentificationDocument | null,
};

export type HNTaxIdentificationDocument = {
  __typename: "HNTaxIdentificationDocument",
  numberHash?: string | null,
  countryCodeAlpha3?: string | null,
};

export type HNAccountHolderVerification = {
  __typename: "HNAccountHolderVerification",
  status?: HNAccountHolderVerificationStatusCode | null,
  riskStatus?: HNAccountHolderRiskVerificationStatusCode | null,
  reason?: HNAccountHolderVerificationStatusReasonCode | null,
  results?:  Array<HNAccountHolderVerificationResult > | null,
  requiredDocuments?:  Array<HNAccountHolderApplicationRequiredDocument | null > | null,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  requestedUpdates?:  Array<HNRequestedIdentityUpdate > | null,
};

export enum HNAccountHolderVerificationStatusCode {
  DENIED = "DENIED",
  PASSED = "PASSED",
  PENDING = "PENDING",
}


export enum HNAccountHolderRiskVerificationStatusCode {
  DENIED = "DENIED",
  PASSED = "PASSED",
  PENDING = "PENDING",
  IN_REVIEW = "IN_REVIEW",
}


export enum HNAccountHolderVerificationStatusReasonCode {
  DENIED = "DENIED",
  PASSED = "PASSED",
  PENDING = "PENDING",
  REVIEW_REQUIRED = "REVIEW_REQUIRED",
  IN_REVIEW = "IN_REVIEW",
  KBA_REQUIRED = "KBA_REQUIRED",
  DOCUMENT_UPLOAD_REQUIRED = "DOCUMENT_UPLOAD_REQUIRED",
  IDENTITY_UPDATE_REQUESTED = "IDENTITY_UPDATE_REQUESTED",
}


export type HNAccountHolderVerificationResult = {
  __typename: "HNAccountHolderVerificationResult",
  code?: HNAccountHolderVerificationResultCode | null,
  description?: string | null,
};

export enum HNAccountHolderVerificationResultCode {
  DEVICE_WARNING = "DEVICE_WARNING",
  FRAUD_REVIEW = "FRAUD_REVIEW",
  SSN_WARNING = "SSN_WARNING",
  SSN_MISKEY = "SSN_MISKEY",
  DOB_MISKEY = "DOB_MISKEY",
  EMAIL_WARNING = "EMAIL_WARNING",
  ADDRESS_WARNING = "ADDRESS_WARNING",
  FRAUD_RISK = "FRAUD_RISK",
  FRAUD_WARNING = "FRAUD_WARNING",
  DENIED_FRAUD = "DENIED_FRAUD",
  DENIED_KYC = "DENIED_KYC",
  FOREIGN_DEVICE = "FOREIGN_DEVICE",
  WATCHLIST_WARNING = "WATCHLIST_WARNING",
  BUSINESS_NAME_MISMATCH = "BUSINESS_NAME_MISMATCH",
  BUSINESS_NAME_MATCH = "BUSINESS_NAME_MATCH",
  FEIN_DOCUMENT_REQUIRED = "FEIN_DOCUMENT_REQUIRED",
  ADDRESS_MATCH = "ADDRESS_MATCH",
  ADDRESS_MISMATCH = "ADDRESS_MISMATCH",
  DOB_MATCH = "DOB_MATCH",
  DOB_MISMATCH = "DOB_MISMATCH",
  NAME_MATCH = "NAME_MATCH",
  NAME_MISMATCH = "NAME_MISMATCH",
  SSN_MATCH = "SSN_MATCH",
  SSN_MISMATCH = "SSN_MISMATCH",
  PHONE_MATCH = "PHONE_MATCH",
  PHONE_MISMATCH = "PHONE_MISMATCH",
  FEIN_MATCH = "FEIN_MATCH",
  FEIN_MISMATCH = "FEIN_MISMATCH",
  WATCHLIST_HIT = "WATCHLIST_HIT",
  HIGH_ABUSE_SCORE = "HIGH_ABUSE_SCORE",
  HIGH_THEFT_SCORE = "HIGH_THEFT_SCORE",
  MEDIUM_ABUSE_SCORE = "MEDIUM_ABUSE_SCORE",
  MEDIUM_THEFT_SCORE = "MEDIUM_THEFT_SCORE",
  LOW_ABUSE_SCORE = "LOW_ABUSE_SCORE",
  LOW_THEFT_SCORE = "LOW_THEFT_SCORE",
  KYC_FRAUD_PASS = "KYC_FRAUD_PASS",
  KYC_WARNING = "KYC_WARNING",
  REPRESENTATIVE_MATCH = "REPRESENTATIVE_MATCH",
  REPRESENTATIVE_MISMATCH = "REPRESENTATIVE_MISMATCH",
  OFAC_MATCH = "OFAC_MATCH",
  BUSINESS_VERIFICATION_SCORE_FAILED = "BUSINESS_VERIFICATION_SCORE_FAILED",
  BUSINESS_VERIFICATION_SCORE_PASSED = "BUSINESS_VERIFICATION_SCORE_PASSED",
  SOS_MATCH = "SOS_MATCH",
  SOS_MISMATCH = "SOS_MISMATCH",
  SOS_INACTIVE = "SOS_INACTIVE",
  SOS_ACTIVE = "SOS_ACTIVE",
  SOS_UNKNOWN = "SOS_UNKNOWN",
  SSN_MULTI_IDENTITY = "SSN_MULTI_IDENTITY",
}


export type HNAccountHolderApplicationRequiredDocument = {
  __typename: "HNAccountHolderApplicationRequiredDocument",
  referenceIdentifier?: string | null,
  documentUploadSession?: HNAccountHolderApplicationDocumentUploadSession | null,
  status?: HNApplicationDocumentUploadSessionStatus | null,
  uploadedDocuments?:  Array<HNApplicationDocument | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAccountHolderApplicationDocumentUploadSession = HNUSAccountHolderApplicationDocumentUploadSession


export type HNUSAccountHolderApplicationDocumentUploadSession = {
  __typename: "HNUSAccountHolderApplicationDocumentUploadSession",
  id: string,
  status?: HNDocumentUploadSessionStatusCode | null,
  primaryDocumentTypes?: Array< HNDocumentType > | null,
  secondaryDocumentTypes?: Array< HNDocumentType > | null,
  supportingDocumentTypes?: Array< HNDocumentType > | null,
  uploadRequirements?:  Array<HNUploadRequirement > | null,
  uploadLinks?:  Array<HNUploadLink | null > | null,
  documentContext?: HNDocumentUploadSessionContext | null,
  recommendedDocumentTypes?: Array< HNDocumentType > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNDocumentUploadSession = {
  __typename: "HNDocumentUploadSession",
  id: string,
  status?: HNDocumentUploadSessionStatusCode | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNIdentityVerificationDocumentUploadSession = {
  __typename: "HNIdentityVerificationDocumentUploadSession",
  id: string,
  status?: HNDocumentUploadSessionStatusCode | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  expiresAt?: string | null,
  requestedDocuments?: Array< HNDocumentType > | null,
  uploadLinks?:  Array<HNUploadLink | null > | null,
};

export enum HNDocumentUploadSessionStatusCode {
  CREATED = "CREATED",
  INITIATED = "INITIATED",
  IN_PROGRESS = "IN_PROGRESS",
  SUBMITTED = "SUBMITTED",
  EXPIRED = "EXPIRED",
}


export enum HNDocumentType {
  SOCIAL_SECURITY_CARD = "SOCIAL_SECURITY_CARD",
  BIRTH_CERTIFICATE = "BIRTH_CERTIFICATE",
  US_MILITARY_RECORD_OF_SERVICE = "US_MILITARY_RECORD_OF_SERVICE",
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  DIVORCE_DECREE = "DIVORCE_DECREE",
  STATE_ISSUED_PERMIT = "STATE_ISSUED_PERMIT",
  STATE_ISSUED_BENEFIT_CARD = "STATE_ISSUED_BENEFIT_CARD",
  US_TAX_FORM = "US_TAX_FORM",
  W2 = "W2",
  FORM_1099 = "FORM_1099",
  FORM_5498 = "FORM_5498",
  FORM_1098 = "FORM_1098",
  CERTIFICATE_OF_CITIZENSHIP = "CERTIFICATE_OF_CITIZENSHIP",
  MEDICARE_CARD = "MEDICARE_CARD",
  COURT_ORDER_FOR_LEGAL_NAME_CHANGE = "COURT_ORDER_FOR_LEGAL_NAME_CHANGE",
  MUNICIPAL_ID = "MUNICIPAL_ID",
  DRIVERS_LICENSE = "DRIVERS_LICENSE",
  PASSPORT = "PASSPORT",
  STATE_ISSUED_ID = "STATE_ISSUED_ID",
  STATE_US_MILITARY_ARMED_FORCES_ID = "STATE_US_MILITARY_ARMED_FORCES_ID",
  STATE_US_PERMANENT_RESIDENT_CARD = "STATE_US_PERMANENT_RESIDENT_CARD",
  STATE_CONSULAR_IDENTIFICATION_CARD = "STATE_CONSULAR_IDENTIFICATION_CARD",
  STATE_US_BORDER_CROSSING_CARD = "STATE_US_BORDER_CROSSING_CARD",
  STATE_US_EMPLOYMENT_AUTHORIZATION_CARD = "STATE_US_EMPLOYMENT_AUTHORIZATION_CARD",
  STATE_TRIBAL_ID = "STATE_TRIBAL_ID",
  UTILITY_BILL = "UTILITY_BILL",
  PHONE_BILL = "PHONE_BILL",
  CABLE_BILL = "CABLE_BILL",
  INTERNET_BILL = "INTERNET_BILL",
  BANK_STATEMENT = "BANK_STATEMENT",
  STATEMENT_401K = "STATEMENT_401K",
  BROKERAGE_STATEMENT = "BROKERAGE_STATEMENT",
  LIFE_INSURANCE = "LIFE_INSURANCE",
  HEALTH_INSURANCE = "HEALTH_INSURANCE",
  AUTO_INSURANCE = "AUTO_INSURANCE",
  PAY_STUB = "PAY_STUB",
  LEASE_AGREEMENT = "LEASE_AGREEMENT",
  ARTICLES_OF_INCORPORATION = "ARTICLES_OF_INCORPORATION",
  NON_PROFIT_501_C3 = "NON_PROFIT_501_C3",
  FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER = "FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER",
  SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD = "SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD",
  OPERATING_AGREEMENT = "OPERATING_AGREEMENT",
  PARTNERSHIP_AGREEMENT = "PARTNERSHIP_AGREEMENT",
  CERTIFICATE_OF_GOOD_STANDING = "CERTIFICATE_OF_GOOD_STANDING",
  IRS_ISSUED_TAX_RETURN = "IRS_ISSUED_TAX_RETURN",
  TRUST_AGREEMENT = "TRUST_AGREEMENT",
  BUSINESS_LICENSE = "BUSINESS_LICENSE",
  BUSINESS_REGISTRATION = "BUSINESS_REGISTRATION",
  FORM_CP_575 = "FORM_CP_575",
  TAX_ID_APPLICATION = "TAX_ID_APPLICATION",
  PRISON_ID = "PRISON_ID",
  PRISON_RELEASE_PAPERWORK = "PRISON_RELEASE_PAPERWORK",
  CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY = "CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY",
  VETERAN_AFFAIRS_BENEFITS_LETTER = "VETERAN_AFFAIRS_BENEFITS_LETTER",
  IRS_ISSUED_FEDERAL_TAX_RETURN = "IRS_ISSUED_FEDERAL_TAX_RETURN",
  IRS_ISSUED_STATE_TAX_RETURN = "IRS_ISSUED_STATE_TAX_RETURN",
  DIGITAL_BACKGROUND = "DIGITAL_BACKGROUND",
  DIGITAL_FRONT_OF_CARD = "DIGITAL_FRONT_OF_CARD",
  DIGITAL_ICON = "DIGITAL_ICON",
  DIGITAL_LOGO = "DIGITAL_LOGO",
  PHYSICAL_BACK_OF_CARD = "PHYSICAL_BACK_OF_CARD",
  PHYSICAL_FRONT_OF_CARD = "PHYSICAL_FRONT_OF_CARD",
  VIRTUAL_FRONT_OF_CARD = "VIRTUAL_FRONT_OF_CARD",
  VIRTUAL_THREE_DS_VERIFICATION_LOGO = "VIRTUAL_THREE_DS_VERIFICATION_LOGO",
}


export type HNUploadLink = {
  __typename: "HNUploadLink",
  id: string,
  status?: HNDocumentUploadLinkStatusCode | null,
  uploadUrl?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNDocumentUploadLink = {
  __typename: "HNDocumentUploadLink",
  id: string,
  documentUploadSession?: HNDocumentUploadSession | null,
  documentType?: HNDocumentType | null,
  status?: HNDocumentUploadLinkStatusCode | null,
  documentCategoryType?: HNDocumentCategoryType | null,
  uploadUrl?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNDocumentUploadLinkStatusCode {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  DENIED = "DENIED",
}


export enum HNDocumentCategoryType {
  PRIMARY_DOCUMENT_TYPE = "PRIMARY_DOCUMENT_TYPE",
  SECONDARY_DOCUMENT_TYPE = "SECONDARY_DOCUMENT_TYPE",
  SUPPORTING_DOCUMENT_TYPE = "SUPPORTING_DOCUMENT_TYPE",
}


export type HNCardArtDocument = {
  __typename: "HNCardArtDocument",
  createdAt?: string | null,
  documentType?: HNDocumentType | null,
  documentUploadSession?: HNCardProfileDocumentUploadSession | null,
  id: string,
  status?: HNDocumentUploadLinkStatusCode | null,
  updatedAt?: string | null,
  uploadUrl?: string | null,
  downloadUrl?: string | null,
};

export type HNCardProfileDocumentUploadSession = {
  __typename: "HNCardProfileDocumentUploadSession",
  cardArtDocuments?:  Array<HNCardArtDocument > | null,
  id: string,
  status?: HNDocumentUploadSessionStatusCode | null,
  updatedAt?: string | null,
  createdAt?: string | null,
  expiration?: string | null,
  cardProduct: HNCardProduct,
  allowedDocumentTypes?: Array< HNCardArtDocumentType > | null,
};

export type HNCardProduct = {
  __typename: "HNCardProduct",
  paymentCardTransactionChargebacks?: HNPaymentCardTransactionChargebackConnection | null,
  id: string,
  name?: string | null,
  usage?: HNCardUsage | null,
  vertical?: HNCardProductVertical | null,
  commercial?: boolean | null,
  paymentCards?: HNPaymentCardConnection | null,
  transactionEvents?: HNTransactionEventConnection | null,
  attachedSpendRules?: HNSpendRuleConnection | null,
  attachedRewardRules?: HNRewardRuleAttachmentConnection | null,
  attachedRewardRedemptionConfigurations?: HNRewardRedemptionConfigurationAttachmentConnection | null,
  cardProductApplications?: HNAccountHolderCardProductApplicationConnection | null,
  searchCardProductApplications?: HNSearchCardProductApplicationConnection | null,
  financialAccounts?:  Array<HNFinancialAccount > | null,
  accounts?: HNFinancialAccountConnection | null,
  features?:  Array<HNCardProductFeature > | null,
  groupOrders?: HNPhysicalCardGroupOrderConnection | null,
  attachedVelocityRules?: HNVelocityRuleConnection | null,
  attachedPlatformSpendRules?: HNSpendRuleConnection | null,
  attachedPlatformVelocityRules?: HNVelocityRuleConnection | null,
  paymentCardTransactionDisputes?: HNPaymentCardTransactionDisputeConnectionPayload | null,
  integratorACHTransfers?: HNIntegratorInitiatedACHTransferConnection | null,
  externalACHTransfers?: HNExternallyInitiatedACHTransferConnection | null,
  originatedAchTransfers?: HNOriginatedAchTransferPayload | null,
  nonOriginatedAchTransfers?: HNNonOriginatedAchTransferPayload | null,
  feeSchedules?: HNFeeScheduleConnection | null,
  attachedInterFinancialAccountTransferRules?: HNInterFinancialAccountTransferRuleConnectionPayload | null,
  attachedVelocityInterFinancialAccountTransferRules?: HNVelocityInterFinancialAccountTransferRuleConnectionPayload | null,
  interFinancialAccountTransfers?: HNInterFinancialAccountTransferConnection | null,
  creditPlanTemplates?: HNCreditPlanTemplateConnection | null,
  creditPlans?: HNCreditPlanConnection | null,
  cardProfileSets?: HNCardProfileSetConnectionPayload | null,
  creditConfiguration?: HNCreditCardProductConfiguration | null,
  sourceTemplateId?: string | null,
};

export type HNPaymentCardTransactionChargebackConnection = {
  __typename: "HNPaymentCardTransactionChargebackConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPaymentCardTransactionChargebackEdge > | null,
};

export type HNPaymentCardTransactionChargebackEdge = {
  __typename: "HNPaymentCardTransactionChargebackEdge",
  cursor: string,
  node?: HNPaymentCardTransactionChargeback | null,
};

export type HNPaymentCardTransactionChargeback = {
  __typename: "HNPaymentCardTransactionChargeback",
  id: string,
  requestedAmount?: HNAmount | null,
  receivedAmount?: HNAmount | null,
  status?: HNPaymentCardChargebackStatus | null,
  creditStatus?: HNPaymentCardChargebackCreditStatus | null,
  dispute?: HNPaymentCardTransactionDispute | null,
  chargebackExternalNetwork?: HNChargebackExternalNetwork | null,
  networkReasonCode?: HNPaymentCardChargebackNetworkReasonCode | null,
  fromDate?: string | null,
  throughDate?: string | null,
  creditIssueFromDate?: string | null,
  creditIssueThroughDate?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNPaymentCardChargebackStatus {
  SUBMITTED = "SUBMITTED",
  RECEIVED = "RECEIVED",
  RESOLVED = "RESOLVED",
  CANCELLED = "CANCELLED",
  REJECTED = "REJECTED",
  WON = "WON",
  PARTIALLY_WON = "PARTIALLY_WON",
  LOST = "LOST",
}


export enum HNPaymentCardChargebackCreditStatus {
  CREDIT_NOT_ISSUED = "CREDIT_NOT_ISSUED",
  CREDIT_PENDING_WIN = "CREDIT_PENDING_WIN",
  CREDIT_WON = "CREDIT_WON",
  CREDIT_PENDING_PARTIAL_WIN = "CREDIT_PENDING_PARTIAL_WIN",
  CREDIT_PARTIALLY_WON = "CREDIT_PARTIALLY_WON",
  PROVISIONAL_CREDIT_PENDING_ISSUE = "PROVISIONAL_CREDIT_PENDING_ISSUE",
  PROVISIONAL_CREDIT_ISSUED = "PROVISIONAL_CREDIT_ISSUED",
  PROVISIONAL_CREDIT_PENDING_REVOCATION = "PROVISIONAL_CREDIT_PENDING_REVOCATION",
  PROVISIONAL_CREDIT_REVOKED = "PROVISIONAL_CREDIT_REVOKED",
  PROVISIONAL_CREDIT_PENDING_WIN = "PROVISIONAL_CREDIT_PENDING_WIN",
  PROVISIONAL_CREDIT_WON = "PROVISIONAL_CREDIT_WON",
  PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN = "PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN",
  PROVISIONAL_CREDIT_PARTIALLY_WON = "PROVISIONAL_CREDIT_PARTIALLY_WON",
}


export type HNPaymentCardTransactionDispute = {
  __typename: "HNPaymentCardTransactionDispute",
  id: string,
  amount?: HNAmount | null,
  status?: HNPaymentCardDisputeStatus | null,
  category?: HNPaymentCardDisputeCategoryType | null,
  chargebacks?:  Array<HNPaymentCardTransactionChargeback > | null,
  transactionEvent?: HNTransactionEvent | null,
  customerInitiatedOn?: string | null,
  customerClaimType?: HNPaymentCardDisputeCustomerClaimType | null,
  customerContact?: HNPaymentCardDisputeCustomerContact | null,
  subscriberNote?: string | null,
  fromDate?: string | null,
  throughDate?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNPaymentCardDisputeStatus {
  INITIATED = "INITIATED",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  WON = "WON",
  LOST = "LOST",
  PENDING_RESOLUTION = "PENDING_RESOLUTION",
  RESOLVED = "RESOLVED",
}


export enum HNPaymentCardDisputeCategoryType {
  FRAUD = "FRAUD",
  AUTHORIZATION = "AUTHORIZATION",
  PROCESSING_ERROR = "PROCESSING_ERROR",
  MERCHANT_DISPUTE = "MERCHANT_DISPUTE",
}


export type HNTransactionEvent = {
  __typename: "HNTransactionEvent",
  id: string,
  transaction?: HNTransaction | null,
  approvedAmount?: HNAmount | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  createdAt?: string | null,
  responseCode?: HNTransactionEventResponseCode | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
};

export type HNReversalEvent = {
  __typename: "HNReversalEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  transaction?: HNTransaction | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  issuerExpiredAuthorization?: boolean | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  additionalTransactionData?:  Array<HNAdditionalTransactionData > | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
  settlementImpact?: boolean | null,
};

export enum HNTransactionEventResponseCode {
  APPROVED = "APPROVED",
  DO_NOT_HONOR = "DO_NOT_HONOR",
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  EXPIRED_CARD = "EXPIRED_CARD",
  NO_CARD_RECORD = "NO_CARD_RECORD",
  INCORRECT_PIN = "INCORRECT_PIN",
  APPROVED_FOR_PARTIAL_AMOUNT = "APPROVED_FOR_PARTIAL_AMOUNT",
  APPROVED_FOR_PURCHASE_AMOUNT_ONLY = "APPROVED_FOR_PURCHASE_AMOUNT_ONLY",
  BAD_CVV = "BAD_CVV",
  BAD_CVV2 = "BAD_CVV2",
  BAD_CVC3 = "BAD_CVC3",
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  SUSPENDED_CARD = "SUSPENDED_CARD",
  TERMINATED_CARD = "TERMINATED_CARD",
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  BLOCKED_CARD = "BLOCKED_CARD",
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  CASH_BACK_LIMIT_EXCEEDED = "CASH_BACK_LIMIT_EXCEEDED",
  CLOSED_ACCOUNT = "CLOSED_ACCOUNT",
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  INVALID_MERCHANT = "INVALID_MERCHANT",
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  PIN_DECRYPTION_ERROR = "PIN_DECRYPTION_ERROR",
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED",
  CHIP_CARD_ARQC_VALIDATION_FAILURE = "CHIP_CARD_ARQC_VALIDATION_FAILURE",
  PRE_AUTHORIZATION_EXPIRED = "PRE_AUTHORIZATION_EXPIRED",
  INVALID_TRACK_DATA = "INVALID_TRACK_DATA",
  INVALID_3DS_VERIFICATION = "INVALID_3DS_VERIFICATION",
  CA_DECLINED = "CA_DECLINED",
  ALL_APPROVED_CODES = "ALL_APPROVED_CODES",
  ALL_ISSUER_DECLINED_CODES = "ALL_ISSUER_DECLINED_CODES",
}


export type HNTransaction = HNCreditTransaction | HNDebitTransaction


export type HNCreditTransaction = {
  __typename: "HNCreditTransaction",
  id: string,
  transactionEvents?:  Array<HNTransactionEvent > | null,
};

export type HNDebitTransaction = {
  __typename: "HNDebitTransaction",
  id: string,
  transactionEvents?:  Array<HNTransactionEvent > | null,
};

export type HNPaymentCard = {
  __typename: "HNPaymentCard",
  id: string,
  externalId?: string | null,
  bin?: string | null,
  last4?: string | null,
  expirationDate?: string | null,
  expirationMonth?: string | null,
  expirationYear?: string | null,
  network?: HNPaymentCardNetwork | null,
  cardProduct?: HNCardProduct | null,
  cardProductApplication?: HNCardProductApplication | null,
  application?: HNAccountHolderCardProductApplication | null,
  status?: HNPaymentCardStatus | null,
  formFactor?: HNCardFormFactor | null,
  originalPaymentCard?: HNPaymentCard | null,
  restrictedDetails?: HNPaymentCardRestrictedDetailsResult | null,
  atmLocations?: HNAtmLocationsResult | null,
  transactionEvents?: HNTransactionEventConnection | null,
  financialAccounts?:  Array<HNFinancialAccount > | null,
  physicalPaymentCardOrders?:  Array<HNPhysicalPaymentCardOrder | null > | null,
  attachedSpendRules?: HNSpendRuleConnection | null,
  cardDigitalWalletTokens?: HNCardDigitalWalletTokenConnection | null,
  velocityRuleBalances?:  Array<HNVelocityRuleBalance | null > | null,
  velocitySpendRuleBalances?:  Array<HNVelocitySpendRuleBalance | null > | null,
  attachedVelocityRules?: HNVelocityRuleConnection | null,
  paymentCardHolderDetails?: HNPaymentCardHolderDetails | null,
  customFields?:  Array<HNCustomField > | null,
  revisionSnapshots?: HNPaymentCardSnapshotConnection | null,
  cardProfileSet?: HNCardProfileSet | null,
  pinDetails?: HNPaymentCardPinDetails | null,
  suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
};

export type HNCardProductApplication = HNAccountHolderCardProductApplication | HNAuthorizedUserCardProductApplication


export type HNAccountHolderCardProductApplication = {
  __typename: "HNAccountHolderCardProductApplication",
  id: string,
  applicationState?: HNAccountHolderApplicationState | null,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  applicationDenialReason?: HNApplicationDenialReason | null,
  accountHolderSnapshot?: HNAccountHolderSnapshot | null,
  cardProduct?: HNCardProduct | null,
  applicationHistory?: HNAccountHolderCardProductApplicationSnapshotConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccounts?: HNFinancialAccountConnection | null,
  offers?: HNAccountHolderCardProductApplicationOfferConnection | null,
  creditReportFraudAlertVerificationResult?: HNCreditReportFraudAlertVerificationResult | null,
};

export type HNAccountHolderApplicationState = {
  __typename: "HNAccountHolderApplicationState",
  status: HNAccountHolderApplicationStatusCode,
};

export enum HNAccountHolderApplicationStatusCode {
  DENIED = "DENIED",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  IN_REVIEW = "IN_REVIEW",
  CLOSED = "CLOSED",
}


export type HNAdverseActionReason = {
  __typename: "HNAdverseActionReason",
  code?: HNAdverseActionCode | null,
  description?: string | null,
};

export enum HNAdverseActionCode {
  INSUFFICIENT_INCOME = "INSUFFICIENT_INCOME",
  DELINQUENT_CREDIT_OBLIGATIONS = "DELINQUENT_CREDIT_OBLIGATIONS",
  UNABLE_TO_VERIFY_IDENTITY = "UNABLE_TO_VERIFY_IDENTITY",
  UNABLE_TO_VERIFY_INCOME = "UNABLE_TO_VERIFY_INCOME",
  COLLECTIONS = "COLLECTIONS",
  BANKRUPTCY = "BANKRUPTCY",
  LIEN_POSITION = "LIEN_POSITION",
  UNACCEPTED_BUSINESS_INDUSTRY = "UNACCEPTED_BUSINESS_INDUSTRY",
  MIN_CREDIT_SCORE = "MIN_CREDIT_SCORE",
  HIGH_UTILIZATION = "HIGH_UTILIZATION",
  RECENT_CREDIT_APPLICATIONS = "RECENT_CREDIT_APPLICATIONS",
  MIN_YEARS_INCORPORATION = "MIN_YEARS_INCORPORATION",
  INCOMPLETE_IDENTITY_INFORMATION = "INCOMPLETE_IDENTITY_INFORMATION",
  LIMITED_CREDIT_EXPERIENCE = "LIMITED_CREDIT_EXPERIENCE",
  EXCESSIVE_DEBT_OBLIGATIONS = "EXCESSIVE_DEBT_OBLIGATIONS",
  UNABLE_TO_VERIFY_EMPLOYMENT = "UNABLE_TO_VERIFY_EMPLOYMENT",
  LENGTH_OF_EMPLOYMENT = "LENGTH_OF_EMPLOYMENT",
  LENGTH_OF_RESIDENCE = "LENGTH_OF_RESIDENCE",
  RECENT_CREDIT_ACCOUNTS = "RECENT_CREDIT_ACCOUNTS",
  UNABLE_TO_VERIFY_CREDIT_REFERENCES = "UNABLE_TO_VERIFY_CREDIT_REFERENCES",
  WITHDRAWN = "WITHDRAWN",
}


export enum HNApplicationDenialReason {
  DENIED_DUE_TO_APPLICATION_INACTIVITY = "DENIED_DUE_TO_APPLICATION_INACTIVITY",
  DENIED_DUE_TO_OTHER = "DENIED_DUE_TO_OTHER",
}


export type HNAccountHolderSnapshot = HNUSPersonAccountHolderSnapshot | HNUSBusinessAccountHolderSnapshot


export type HNUSBusinessAccountHolderSnapshot = {
  __typename: "HNUSBusinessAccountHolderSnapshot",
  accountHolderCurrent?: HNUSBusinessAccountHolder | null,
  businessProfile?: HNUSBusinessProfileSnapshot | null,
  primaryAuthorizedPerson?: HNUSBusinessAuthorizedPersonSnapshot | null,
  currentVerification?: HNAccountHolderVerification | null,
};

export type HNBusinessAccountHolder = {
  __typename: "HNBusinessAccountHolder",
  primaryAuthorizedPerson?: HNAuthorizedPerson | null,
  businessProfile?: HNBusinessProfile | null,
};

export type HNUSBusinessAccountHolder = {
  __typename: "HNUSBusinessAccountHolder",
  id: string,
  primaryAuthorizedPerson?: HNUSBusinessAuthorizedPerson | null,
  businessProfile?: HNUSBusinessProfile | null,
  externalId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  cardProductApplications?: HNAccountHolderCardProductApplicationConnection | null,
  paymentCards?: HNPaymentCardConnection | null,
  externalFinancialAccounts?: HNExternalFinancialAccountConnection | null,
  financialAccounts?: HNFinancialAccountConnection | null,
  globalNotes?: HNGlobalNoteConnectionPayload | null,
};

export type HNUSBusinessAuthorizedPerson = {
  __typename: "HNUSBusinessAuthorizedPerson",
  id: string,
  name?: HNName | null,
  percentageOwnership?: number | null,
  authorizingPersonTitle?: HNBusinessTitle | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAuthorizedPerson = {
  __typename: "HNAuthorizedPerson",
  name?: HNName | null,
  homeAddress?: HNAddress | null,
};

export type HNUSBusinessAuthorizedPersonSnapshot = {
  __typename: "HNUSBusinessAuthorizedPersonSnapshot",
  name?: HNName | null,
  percentageOwnership?: number | null,
  authorizingPersonTitle?: HNBusinessTitle | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  verificationState?: HNAccountHolderVerificationStatusCode | null,
  currentVerification?: HNAccountHolderVerification | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNBusinessTitle {
  PRESIDENT = "PRESIDENT",
  VICE_PRESIDENT = "VICE_PRESIDENT",
  TREASURER = "TREASURER",
  OWNER = "OWNER",
  CEO = "CEO",
  CFO = "CFO",
  COO = "COO",
}


export type HNUSBusinessProfile = {
  __typename: "HNUSBusinessProfile",
  id: string,
  name?: HNBusinessName | null,
  businessType?: HNBusinessStructure | null,
  creditRiskAttributes?: HNCreditRiskAttributes | null,
  businessCreditRiskAttributes?: HNBusinessCreditRiskAttributes | null,
  website?: string | null,
  billingAddress?: HNAddress | null,
  phoneNumbers?:  Array<HNPhone > | null,
  identificationDocument?: HNUSBusinessIdentificationDocument | null,
  ultimateBeneficialOwners?:  Array<HNUSBusinessUltimateBeneficialOwner | null > | null,
  authorizedUsers?: HNAuthorizedUserConnection | null,
  operatingDetails?: HNBusinessPlanOperatingDetails | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNBusinessProfile = {
  __typename: "HNBusinessProfile",
  name?: HNBusinessName | null,
  billingAddress?: HNAddress | null,
  operatingDetails?: HNBusinessPlanOperatingDetails | null,
};

export type HNUSBusinessProfileSnapshot = {
  __typename: "HNUSBusinessProfileSnapshot",
  name?: HNBusinessName | null,
  businessType?: HNBusinessStructure | null,
  creditRiskAttributes?: HNCreditRiskAttributes | null,
  operatingDetails?: HNBusinessPlanOperatingDetails | null,
  businessCreditRiskAttributes?: HNBusinessCreditRiskAttributes | null,
  currentCreditUnderwritingVerification?: HNCreditUnderwritingVerification | null,
  website?: string | null,
  billingAddress?: HNAddress | null,
  phoneNumbers?:  Array<HNPhone > | null,
  identificationDocument?: HNUSBusinessIdentificationDocument | null,
  verificationState?: HNAccountHolderVerificationStatusCode | null,
  currentVerification?: HNAccountHolderVerification | null,
  ultimateBeneficialOwners?:  Array<HNUSBusinessUltimateBeneficialOwnerSnapshot | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNBusinessName = {
  __typename: "HNBusinessName",
  legalBusinessName: string,
  doingBusinessAsName?: string | null,
};

export enum HNBusinessStructure {
  CORPORATION = "CORPORATION",
  PARTNERSHIP = "PARTNERSHIP",
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  NON_PROFIT = "NON_PROFIT",
  LLC = "LLC",
  PRIVATE_CORPORATION = "PRIVATE_CORPORATION",
  PUBLIC_CORPORATION = "PUBLIC_CORPORATION",
}


export type HNCreditRiskAttributes = {
  __typename: "HNCreditRiskAttributes",
  annualRevenue?:  Array<HNAmount | null > | null,
};

export type HNBusinessPlanOperatingDetails = {
  __typename: "HNBusinessPlanOperatingDetails",
  annualVolumes?:  Array<HNBusinessPlanReportedAmount > | null,
  largestTickets?:  Array<HNBusinessPlanReportedAmount > | null,
  averageTickets?:  Array<HNBusinessPlanReportedAmount > | null,
  largestMonthlyVolumes?:  Array<HNBusinessPlanReportedAmount > | null,
  interactionMethods?: Array< HNBusinessCustomerInteractionMethod > | null,
  employeeCounts?:  Array<HNBusinessPlanReportedValue > | null,
  operatingModels?:  Array<HNBusinessPlanOperatingModel > | null,
  customerSupportContactInformation?: HNBusinessPlanCustomerSupportContactInformation | null,
};

export type HNBusinessPlanReportedAmount = {
  __typename: "HNBusinessPlanReportedAmount",
  reportedAmounts?:  Array<HNAmount > | null,
  reportedOn?: string | null,
};

export enum HNBusinessCustomerInteractionMethod {
  ONLINE = "ONLINE",
  IN_PERSON = "IN_PERSON",
  MOBILE = "MOBILE",
  MAIL_ORDER_TELEPHONE_ORDER = "MAIL_ORDER_TELEPHONE_ORDER",
}


export type HNBusinessPlanReportedValue = {
  __typename: "HNBusinessPlanReportedValue",
  value?: number | null,
  reportedOn?: string | null,
};

export type HNBusinessPlanOperatingModel = {
  __typename: "HNBusinessPlanOperatingModel",
  type?: HNBusinessPlanOperatingModelType | null,
  reportedAsOperatingModel?: boolean | null,
  operatingModelDetails?:  Array<HNBusinessPlanOperatingModelDetail > | null,
};

export enum HNBusinessPlanOperatingModelType {
  PHYSICAL_GOODS_SOLD = "PHYSICAL_GOODS_SOLD",
  SEASONAL_BUSINESS = "SEASONAL_BUSINESS",
  FORWARD_COMMITMENT = "FORWARD_COMMITMENT",
}


export type HNBusinessPlanOperatingModelDetail = HNBusinessPlanOperatingModelSeasonal | HNBusinessPlanOperatingModelForwardCommitment | HNBusinessPlanOperatingModelGoodsAndService


export type HNBusinessPlanOperatingModelSeasonal = {
  __typename: "HNBusinessPlanOperatingModelSeasonal",
  seasonalRanges?:  Array<HNBusinessPlanOperatingModelSeasonalMonthlyRange > | null,
  peakMonths?: Array< HNMonth > | null,
  reportedOn?: string | null,
};

export type HNBusinessPlanOperatingModelSeasonalMonthlyRange = {
  __typename: "HNBusinessPlanOperatingModelSeasonalMonthlyRange",
  startMonth?: HNMonth | null,
  endMonth?: HNMonth | null,
};

export enum HNMonth {
  JANUARY = "JANUARY",
  FEBRUARY = "FEBRUARY",
  MARCH = "MARCH",
  APRIL = "APRIL",
  MAY = "MAY",
  JUNE = "JUNE",
  JULY = "JULY",
  AUGUST = "AUGUST",
  SEPTEMBER = "SEPTEMBER",
  OCTOBER = "OCTOBER",
  NOVEMBER = "NOVEMBER",
  DECEMBER = "DECEMBER",
}


export type HNBusinessPlanOperatingModelForwardCommitment = {
  __typename: "HNBusinessPlanOperatingModelForwardCommitment",
  minimumDays?: number | null,
  maximumDays?: number | null,
  reportedOn?: string | null,
};

export type HNBusinessPlanOperatingModelGoodsAndService = {
  __typename: "HNBusinessPlanOperatingModelGoodsAndService",
  goodsAndServicesProvided?: Array< HNBusinessPlanOperatingGoodsAndServiceCategory > | null,
  reportedOn?: string | null,
};

export enum HNBusinessPlanOperatingGoodsAndServiceCategory {
  AGRICULTURAL_SERVICES = "AGRICULTURAL_SERVICES",
  CONTRACTED_SERVICES = "CONTRACTED_SERVICES",
  TRAVEL = "TRAVEL",
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  UTILITY_SERVICES = "UTILITY_SERVICES",
  RETAIL_OUTLET_SERVICES = "RETAIL_OUTLET_SERVICES",
  CLOTHING_STORES = "CLOTHING_STORES",
  MISCELLANEOUS_STORES = "MISCELLANEOUS_STORES",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS = "PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS",
  GOVERNMENT_SERVICES = "GOVERNMENT_SERVICES",
}


export type HNBusinessPlanCustomerSupportContactInformation = {
  __typename: "HNBusinessPlanCustomerSupportContactInformation",
  url?: string | null,
  email?: string | null,
  phone?: HNPhone | null,
  address?: HNAddress | null,
};

export type HNBusinessCreditRiskAttributes = {
  __typename: "HNBusinessCreditRiskAttributes",
  annualRevenue?:  Array<HNAmount | null > | null,
};

export type HNCreditUnderwritingVerification = {
  __typename: "HNCreditUnderwritingVerification",
  status?: HNUnderwriterVerificationStatusCode | null,
  reviewReasonDetails?: HNCreditUnderwritingVerificationReviewReasonDetails | null,
  decision?: HNUnderwriterDecision | null,
  decisionDate?: string | null,
  decisionResults?: Array< HNCreditDecisionResult > | null,
  creditScoreDetails?: HNCreditUnderwritingVerificationCreditScoreDetails | null,
};

export enum HNUnderwriterVerificationStatusCode {
  DENIED = "DENIED",
  PASSED = "PASSED",
  PENDING = "PENDING",
  IN_REVIEW = "IN_REVIEW",
}


export type HNCreditUnderwritingVerificationReviewReasonDetails = {
  __typename: "HNCreditUnderwritingVerificationReviewReasonDetails",
  reviewReason?: HNCreditUnderwritingVerificationReviewStatusReasonCode | null,
  memo?: string | null,
};

export enum HNCreditUnderwritingVerificationReviewStatusReasonCode {
  AWAITING_FRAUD_ALERT_REVIEW = "AWAITING_FRAUD_ALERT_REVIEW",
  AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN = "AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN",
}


export type HNUnderwriterDecision = HNUnderwriterPositiveDecision | HNUnderwriterAdverseDecision


export type HNUnderwriterPositiveDecision = {
  __typename: "HNUnderwriterPositiveDecision",
  creditLine: HNAmount,
  creditPlanTerms?:  Array<HNCreditPlanTerms > | null,
};

export type HNCreditPlanTerms = {
  __typename: "HNCreditPlanTerms",
  creditPlan?: HNCreditPlan | null,
  interest?: HNInterestDetails | null,
};

export type HNCreditPlan = {
  __typename: "HNCreditPlan",
  id: string,
  name?: string | null,
  status?: HNCreditPlanStatus | null,
  planType?: HNCreditPlanType | null,
  balanceType?: HNCreditBalanceType | null,
  riskBasedPricingPolicy?: HNRiskBasedPricingPolicy | null,
  percentageOfCreditLimit?: number | null,
  interestPolicy?: HNCreditPlanInterestPolicy | null,
  effectiveFromDate?: string | null,
  effectiveThroughDate?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNCreditPlanStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEPRECATED = "DEPRECATED",
}


export enum HNCreditPlanType {
  STANDARD = "STANDARD",
  PROMO = "PROMO",
}


export enum HNCreditBalanceType {
  PURCHASE = "PURCHASE",
  CASH_ADVANCE = "CASH_ADVANCE",
  INSTALLMENT = "INSTALLMENT",
  BALANCE_TRANSFER = "BALANCE_TRANSFER",
}


export type HNRiskBasedPricingPolicy = {
  __typename: "HNRiskBasedPricingPolicy",
  isRiskBased?: boolean | null,
};

export type HNCreditPlanInterestPolicy = {
  __typename: "HNCreditPlanInterestPolicy",
  rateType?: HNInterestRateType | null,
  index?: HNInterestRateIndexConfiguration | null,
  accrualType?: HNInterestAccrualType | null,
  accrualMethod?: HNInterestAccrualMethod | null,
  assessmentSchedule?: HNInterestAssessmentSchedule | null,
  defaultApr?: number | null,
  scraApr?: number | null,
};

export enum HNInterestRateType {
  FIXED = "FIXED",
  VARIABLE = "VARIABLE",
}


export type HNInterestRateIndexConfiguration = {
  __typename: "HNInterestRateIndexConfiguration",
  type?: HNInterestRateIndex | null,
  value?: number | null,
  effectiveDate?: string | null,
};

export enum HNInterestRateIndex {
  PRIME = "PRIME",
  LIBOR = "LIBOR",
}


export enum HNInterestAccrualType {
  SIMPLE = "SIMPLE",
  COMPOUND = "COMPOUND",
}


export enum HNInterestAccrualMethod {
  TRANSACTION_POST_DATE = "TRANSACTION_POST_DATE",
  FIRST_DAY_OF_BILLING_PERIOD = "FIRST_DAY_OF_BILLING_PERIOD",
  PAYMENT_DUE_DATE = "PAYMENT_DUE_DATE",
}


export enum HNInterestAssessmentSchedule {
  STATEMENT = "STATEMENT",
  DAILY = "DAILY",
}


export type HNInterestDetails = {
  __typename: "HNInterestDetails",
  apr?: number | null,
};

export type HNUnderwriterAdverseDecision = {
  __typename: "HNUnderwriterAdverseDecision",
  adverseActionReasons?:  Array<HNAdverseActionReason | null > | null,
};

export enum HNCreditDecisionResult {
  RECENT_INQUIRIES = "RECENT_INQUIRIES",
  RECENT_BANKRUPTCY = "RECENT_BANKRUPTCY",
  ACTIVE_BANKRUPTCY = "ACTIVE_BANKRUPTCY",
  RECENT_CHARGE_OFF = "RECENT_CHARGE_OFF",
  RECENT_DELINQUENCY = "RECENT_DELINQUENCY",
  CURRENT_DEBT_OBLIGATIONS = "CURRENT_DEBT_OBLIGATIONS",
  MLA_ELIGIBLE = "MLA_ELIGIBLE",
  CREDIT_REPORT_FRAUD_ALERT = "CREDIT_REPORT_FRAUD_ALERT",
  CREDIT_REPORT_FREEZE = "CREDIT_REPORT_FREEZE",
  EXCESSIVE_DEBT_OBLIGATIONS = "EXCESSIVE_DEBT_OBLIGATIONS",
  DELINQUENT_CREDIT_OBLIGATIONS = "DELINQUENT_CREDIT_OBLIGATIONS",
  RECENT_CREDIT_APPLICATIONS = "RECENT_CREDIT_APPLICATIONS",
  RECENT_CREDIT_ACCOUNTS = "RECENT_CREDIT_ACCOUNTS",
  BANKRUPTCY = "BANKRUPTCY",
  MIN_CREDIT_SCORE = "MIN_CREDIT_SCORE",
  INSUFFICIENT_INCOME = "INSUFFICIENT_INCOME",
}


export type HNCreditUnderwritingVerificationCreditScoreDetails = {
  __typename: "HNCreditUnderwritingVerificationCreditScoreDetails",
  creditBureau?: HNCreditBureau | null,
  creditScoreModels?:  Array<HNCreditScoreModel > | null,
};

export enum HNCreditBureau {
  EXPERIAN = "EXPERIAN",
}


export type HNCreditScoreModel = {
  __typename: "HNCreditScoreModel",
  creditScoreType?: string | null,
  creditScore?: string | null,
  creditScoreReasons?: Array< string > | null,
};

export type HNUSBusinessIdentificationDocument = {
  __typename: "HNUSBusinessIdentificationDocument",
  employerIdentificationNumber?: HNTaxIdentificationDocument | null,
};

export type HNUSBusinessUltimateBeneficialOwnerSnapshot = {
  __typename: "HNUSBusinessUltimateBeneficialOwnerSnapshot",
  ultimateBeneficialOwnerId: string,
  name?: HNName | null,
  percentageOwnership?: number | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  verificationState?: HNAccountHolderVerificationStatusCode | null,
  currentVerification?: HNAccountHolderVerification | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNUSBusinessUltimateBeneficialOwner = {
  __typename: "HNUSBusinessUltimateBeneficialOwner",
  id: string,
  name?: HNName | null,
  percentageOwnership?: number | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAuthorizedUserConnection = {
  __typename: "HNAuthorizedUserConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAuthorizedUserEdge > | null,
};

export type HNAuthorizedUserEdge = {
  __typename: "HNAuthorizedUserEdge",
  cursor: string,
  node?: HNUSPersonAuthorizedUser | null,
};

export type HNUSPersonAuthorizedUser = {
  __typename: "HNUSPersonAuthorizedUser",
  id: string,
  name?: HNName | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  billingAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
  externalId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  cardProductApplications?: HNAuthorizedUserCardProductApplicationConnection | null,
  paymentCards?: HNPaymentCardConnection | null,
  associatedAccountHolders?: HNAccountHolderConnection | null,
};

export type HNPersonAuthorizedUser = {
  __typename: "HNPersonAuthorizedUser",
  name?: HNName | null,
  billingAddress?: HNAddress | null,
};

export type HNUSPersonAuthorizedUserSnapshot = {
  __typename: "HNUSPersonAuthorizedUserSnapshot",
  authorizedUserCurrent?: HNUSPersonAuthorizedUser | null,
  name?: HNName | null,
  billingAddress?: HNAddress | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNUSIdentificationDocument | null,
};

export type HNAuthorizedUserCardProductApplicationConnection = {
  __typename: "HNAuthorizedUserCardProductApplicationConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAuthorizedUserCardProductApplicationEdge > | null,
};

export type HNAuthorizedUserCardProductApplicationEdge = {
  __typename: "HNAuthorizedUserCardProductApplicationEdge",
  cursor: string,
  node?: HNAuthorizedUserCardProductApplication | null,
};

export type HNAuthorizedUserCardProductApplication = {
  __typename: "HNAuthorizedUserCardProductApplication",
  id: string,
  applicationState?: HNAuthorizedUserApplicationState | null,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  applicationDenialReason?: HNApplicationDenialReason | null,
  authorizedUserSnapshot?: HNAuthorizedUserSnapshot | null,
  accountHolderCardProductApplication?: HNAccountHolderCardProductApplication | null,
  financialAccount?: HNFinancialAccount | null,
  applicationHistory?: HNAuthorizedUserCardProductApplicationSnapshotConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAuthorizedUserApplicationState = {
  __typename: "HNAuthorizedUserApplicationState",
  status: HNAuthorizedUserApplicationStatusCode,
};

export enum HNAuthorizedUserApplicationStatusCode {
  DENIED = "DENIED",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  IN_REVIEW = "IN_REVIEW",
  CLOSED = "CLOSED",
}


export type HNAuthorizedUserSnapshot = HNUSPersonAuthorizedUserSnapshot


export type HNFinancialAccount = {
  __typename: "HNFinancialAccount",
  paymentCardTransactionChargebacks?: HNPaymentCardTransactionChargebackConnection | null,
  globalNotes?: HNGlobalNoteConnectionPayload | null,
  accountReviewHistory?: HNAccountReviewConnectionPayload | null,
  id: string,
  externalId?: string | null,
  ledgers?:  Array<HNLedger > | null,
  owner?: HNFinancialAccountOwner | null,
  name?: string | null,
  cardProduct?: HNCardProduct | null,
  application?: HNAccountHolderCardProductApplication | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  features?:  Array<HNFinancialAccountFeature > | null,
  directDepositDetails?: HNDirectDepositDetail | null,
  activeBillingCycleConfiguration?: HNBillingCycleConfiguration | null,
  statementSnapshot?: HNFinancialAccountStatementSnapshot | null,
  statements?: HNFinancialAccountStatementConnection | null,
  financialAccountActivities?: HNFinancialAccountActivityConnection | null,
  integratorInitiatedAchTransfers?: HNACHTransactionConnection | null,
  integratorInitiatedACHTransfer?: HNIntegratorInitiatedACHTransferConnection | null,
  integratorACHTransfers?: HNIntegratorInitiatedACHTransferConnection | null,
  externallyInitiatedAchTransfers?: HNACHTransactionConnection | null,
  externallyInitiatedACHTransfer?: HNExternallyInitiatedACHTransferConnection | null,
  externalACHTransfers?: HNExternallyInitiatedACHTransferConnection | null,
  originatedAchTransfers?: HNOriginatedAchTransferPayload | null,
  nonOriginatedAchTransfers?: HNNonOriginatedAchTransferPayload | null,
  incomingScheduledTransfers?: HNScheduledTransferConnection | null,
  transactionEvents?: HNTransactionEventConnection | null,
  interFinancialAccountTransfers?: HNInterFinancialAccountTransferConnection | null,
  accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
  accountStatus?: string | null,
  accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
  financialAccountAttributesWithReason?:  Array<HNFinancialAccountAttributeWithReason > | null,
  paymentCards?: HNPaymentCardConnection | null,
  velocityRuleBalances?:  Array<HNVelocityRuleBalance | null > | null,
  velocitySpendRuleBalances?:  Array<HNVelocitySpendRuleBalance | null > | null,
  partnerBankName?: HNPartnerBankName | null,
  delinquency?: HNFinancialAccountDelinquency | null,
  delinquencyState?: HNCurrentFinancialAccountDelinquencyState | null,
  billingCycleHistory?: HNBillingCycleConnection | null,
  creditConfiguration?: HNCreditFinancialAccountConfiguration | null,
  feeTransferEvents?: HNFeeTransferEventConnection | null,
  paymentCardTransactionDisputes?: HNPaymentCardTransactionDisputeConnectionPayload | null,
  customFields?:  Array<HNCustomField > | null,
  revisionSnapshots?: HNFinancialAccountSnapshotConnection | null,
  rewardPointsTransfers?: HNRewardPointsTransferConnectionPayload | null,
  attachedSpendRules?: HNSpendRuleConnection | null,
  attachedVelocityRules?: HNVelocityRuleConnection | null,
  velocityInterFinancialAccountTransferRuleBalances?: HNVelocityInterFinancialAccountTransferRuleBalanceConnectionPayload | null,
};

export type HNGlobalNoteConnectionPayload = HNGlobalNoteConnection | HNUserError | HNAccessDeniedError


export type HNGlobalNoteConnection = {
  __typename: "HNGlobalNoteConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNGlobalNoteEdge > | null,
};

export type HNGlobalNoteEdge = {
  __typename: "HNGlobalNoteEdge",
  cursor: string,
  node?: HNGlobalNote | null,
};

export type HNGlobalNote = {
  __typename: "HNGlobalNote",
  id: string,
  createdBy?: HNUser | null,
  message: string,
  createdAt?: string | null,
  primaryEntity?: HNGlobalNotePrimaryEntity | null,
  aggregateEntity?: HNGlobalNoteAggregateEntity | null,
};

export type HNUser = {
  __typename: "HNUser",
  id: string,
  email?: string | null,
  clientCredentials?:  Array<HNUserClientCredential > | null,
  roles?: Array< HNUserRole > | null,
};

export type HNUserClientCredential = {
  __typename: "HNUserClientCredential",
  token?: string | null,
  organization?: HNOrganization | null,
  roles: Array< HNUserRole >,
};

export type HNOrganization = {
  __typename: "HNOrganization",
  paymentCardTransactionDisputes?: HNPaymentCardTransactionDisputeConnection | null,
  paymentCardTransactionChargebacks?: HNPaymentCardTransactionChargebackConnection | null,
  id: string,
  profile: HNOrganizationProfile,
  apiKeys?: HNAPIKeyConnection | null,
  financialAccounts?:  Array<HNFinancialAccount > | null,
  users?: HNUserConnection | null,
  accounts?: HNFinancialAccountConnection | null,
  businessDetail?: HNBusinessDetail | null,
  cardProducts?: HNCardProductConnection | null,
  spendRules?: HNSpendRuleConnection | null,
  velocityRules?: HNVelocityRuleConnection | null,
  rewardEarnRules?: HNRewardEarnRuleConnection | null,
  rewardRedemptionConfigurations?: HNRewardRedemptionConfigurationConnection | null,
  interFinancialAccountTransferRules?: HNInterFinancialAccountTransferRuleConnectionPayload | null,
  velocityInterFinancialAccountTransferRules?: HNVelocityInterFinancialAccountTransferRuleConnectionPayload | null,
  physicalPaymentCardOrders?: HNPhysicalPaymentCardOrderConnection | null,
  physicalCardGroupOrders?: HNPhysicalCardGroupOrderConnection | null,
  physicalPaymentCardGroupOrders?: HNPhysicalCardGroupOrderConnection | null,
  webhookNotificationTargets?: HNWebhookNotificationTargetConnection | null,
  collaborativeAuthorizationEndpoints?: HNCollaborativeAuthorizationEndpointConnection | null,
};

export type HNPaymentCardTransactionDisputeConnection = {
  __typename: "HNPaymentCardTransactionDisputeConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPaymentCardTransactionDisputeEdge > | null,
};

export type HNPaymentCardTransactionDisputeEdge = {
  __typename: "HNPaymentCardTransactionDisputeEdge",
  cursor: string,
  node?: HNPaymentCardTransactionDispute | null,
};

export type HNOrganizationProfile = {
  __typename: "HNOrganizationProfile",
  displayName?: string | null,
  environment?: HNIntegrationEnvironment | null,
  region?: HNComputeRegion | null,
  tenantId?: string | null,
  featurePermissions?: HNFeaturePermissionConnection | null,
};

export enum HNIntegrationEnvironment {
  TEST = "TEST",
  LIVE = "LIVE",
}


export enum HNComputeRegion {
  USA = "USA",
  EUROPE = "EUROPE",
  ASIA = "ASIA",
}


export type HNFeaturePermissionConnection = {
  __typename: "HNFeaturePermissionConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFeaturePermissionEdge > | null,
};

export type HNFeaturePermissionEdge = {
  __typename: "HNFeaturePermissionEdge",
  cursor: string,
  node?: HNFeaturePermission | null,
};

export type HNFeaturePermission = {
  __typename: "HNFeaturePermission",
  id: string,
  createdBy?: string | null,
  updatedBy?: string | null,
  createDate?: string | null,
  updateDate?: string | null,
  enabled?: boolean | null,
  revisions?: HNFeaturePermissionRevisionConnection | null,
};

export type HNRiskApplicationSDK = {
  __typename: "HNRiskApplicationSDK",
  id: string,
  createdBy?: string | null,
  updatedBy?: string | null,
  createDate?: string | null,
  updateDate?: string | null,
  enabled?: boolean | null,
  revisions?: HNFeaturePermissionRevisionConnection | null,
};

export type HNFeaturePermissionRevisionConnection = {
  __typename: "HNFeaturePermissionRevisionConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFeaturePermissionRevisionEdge > | null,
};

export type HNFeaturePermissionRevisionEdge = {
  __typename: "HNFeaturePermissionRevisionEdge",
  cursor: string,
  node?: HNFeaturePermissionRevision | null,
};

export type HNFeaturePermissionRevision = {
  __typename: "HNFeaturePermissionRevision",
  id: string,
  featurePermissionId: string,
  createdBy?: string | null,
  updatedBy?: string | null,
  createDate?: string | null,
  updateDate?: string | null,
  enabled?: boolean | null,
};

export type HNRiskApplicationSDKRevision = {
  __typename: "HNRiskApplicationSDKRevision",
  id: string,
  featurePermissionId: string,
  createdBy?: string | null,
  updatedBy?: string | null,
  createDate?: string | null,
  updateDate?: string | null,
  enabled?: boolean | null,
};

export type HNAPIKeyConnection = {
  __typename: "HNAPIKeyConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAPIKeyEdge > | null,
};

export type HNAPIKeyEdge = {
  __typename: "HNAPIKeyEdge",
  cursor: string,
  node?: HNAPIKey | null,
};

export type HNAPIKey = {
  __typename: "HNAPIKey",
  id: string,
  name?: string | null,
  key?: string | null,
  redactedKey?: string | null,
  revokedAt?: string | null,
  createdAt?: string | null,
};

export type HNUserConnection = {
  __typename: "HNUserConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNUserEdge > | null,
};

export type HNUserEdge = {
  __typename: "HNUserEdge",
  cursor: string,
  node?: HNUser | null,
};

export type HNFinancialAccountConnection = {
  __typename: "HNFinancialAccountConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFinancialAccountEdge > | null,
};

export type HNFinancialAccountEdge = {
  __typename: "HNFinancialAccountEdge",
  cursor: string,
  node?: HNFinancialAccount | null,
};

export type HNBusinessDetail = {
  __typename: "HNBusinessDetail",
  primaryAuthorizedPerson?: HNAuthorizedPerson | null,
  businessProfile?: HNBusinessProfile | null,
};

export type HNCardProductConnection = {
  __typename: "HNCardProductConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCardProductEdge > | null,
};

export type HNCardProductEdge = {
  __typename: "HNCardProductEdge",
  cursor: string,
  node?: HNCardProduct | null,
};

export type HNSpendRuleConnection = {
  __typename: "HNSpendRuleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNSpendRuleEdge > | null,
};

export type HNSpendRuleEdge = {
  __typename: "HNSpendRuleEdge",
  cursor: string,
  node?: HNSpendRule | null,
};

export type HNSpendRule = {
  __typename: "HNSpendRule",
  id: string,
  name?: string | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNMerchantCategorySpendRule = {
  __typename: "HNMerchantCategorySpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  allowedMcc?: Array< string > | null,
  blockedMcc?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNCVVSpendRule = {
  __typename: "HNCVVSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNStreetAddressSpendRule = {
  __typename: "HNStreetAddressSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNMerchantIdentifierSpendRule = {
  __typename: "HNMerchantIdentifierSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNMerchantCountrySpendRule = {
  __typename: "HNMerchantCountrySpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNAmountLimitSpendRule = {
  __typename: "HNAmountLimitSpendRule",
  id: string,
  name?: string | null,
  maximumAmount?: HNAmount | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNCountLimitSpendRule = {
  __typename: "HNCountLimitSpendRule",
  id: string,
  name?: string | null,
  maximumCount?: number | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNPointOfServiceCategorySpendRule = {
  __typename: "HNPointOfServiceCategorySpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNPostalCodeVerificationSpendRule = {
  __typename: "HNPostalCodeVerificationSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNDepositAmountLimitSpendRule = {
  __typename: "HNDepositAmountLimitSpendRule",
  id: string,
  name?: string | null,
  maximumAmount?: HNAmount | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNDepositProcessingNetworkSpendRule = {
  __typename: "HNDepositProcessingNetworkSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNDepositCountLimitSpendRule = {
  __typename: "HNDepositCountLimitSpendRule",
  id: string,
  name?: string | null,
  maximumCount?: number | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNConditionalRuleSetSpendRule = {
  __typename: "HNConditionalRuleSetSpendRule",
  id: string,
  name?: string | null,
  allow?: boolean | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNCardTransactionProcessingTypeConditionSpendRule = {
  __typename: "HNCardTransactionProcessingTypeConditionSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNRestrictedAccountHolderSpendRule = {
  __typename: "HNRestrictedAccountHolderSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNPanEntryModeSpendRule = {
  __typename: "HNPanEntryModeSpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNCardDataInputCapabilitySpendRule = {
  __typename: "HNCardDataInputCapabilitySpendRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  revisions?: HNSpendRuleConnection | null,
};

export type HNRewardEarnRuleConnection = {
  __typename: "HNRewardEarnRuleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNRewardEarnRuleEdge > | null,
};

export type HNRewardEarnRuleEdge = {
  __typename: "HNRewardEarnRuleEdge",
  cursor?: string | null,
  node?: HNRewardEarnRule | null,
};

export type HNRewardEarnRule = {
  __typename: "HNRewardEarnRule",
  id: string,
  name?: string | null,
  attachments?: HNRewardRuleAttachmentConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNRewardDefaultEarnRule = {
  __typename: "HNRewardDefaultEarnRule",
  id: string,
  type?: HNEarnRuleType | null,
  name?: string | null,
  rewardPointEarning?: HNRewardEarnRate | null,
  attachments?: HNRewardRuleAttachmentConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNEarnRuleType {
  PER_TRANSACTION_SPEND_AMOUNT = "PER_TRANSACTION_SPEND_AMOUNT",
}


export type HNRewardEarnRate = {
  __typename: "HNRewardEarnRate",
  rate?: string | null,
};

export type HNRewardRuleAttachmentConnection = {
  __typename: "HNRewardRuleAttachmentConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNRewardRuleAttachmentEdge > | null,
};

export type HNRewardRuleAttachmentEdge = {
  __typename: "HNRewardRuleAttachmentEdge",
  cursor?: string | null,
  node?: HNRewardRuleAttachment | null,
};

export type HNRewardRuleAttachment = {
  __typename: "HNRewardRuleAttachment",
  id: string,
  rewardEarnRule?: HNRewardEarnRule | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNRewardRuleProductAttachment = {
  __typename: "HNRewardRuleProductAttachment",
  id: string,
  rewardEarnRule?: HNRewardEarnRule | null,
  cardProduct?: HNCardProduct | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNRewardMerchantCategoryEarnRule = {
  __typename: "HNRewardMerchantCategoryEarnRule",
  id: string,
  type?: HNEarnRuleType | null,
  name?: string | null,
  rewardPointEarning?: HNRewardEarnRate | null,
  attachments?: HNRewardRuleAttachmentConnection | null,
  allowedList?: Array< HNMerchantCategory > | null,
  allowedListCodes?: Array< string > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNMerchantCategory {
  VETERINARY_SERVICES = "VETERINARY_SERVICES",
  WINE_PRODUCERS = "WINE_PRODUCERS",
  CHAMPAGNE_PRODUCERS = "CHAMPAGNE_PRODUCERS",
  AGRICULTURAL_COOPERATIVE = "AGRICULTURAL_COOPERATIVE",
  LANDSCAPING_SERVICES = "LANDSCAPING_SERVICES",
  WHOLESALE = "WHOLESALE",
  CONCESSION = "CONCESSION",
  GENERAL_SERVICES = "GENERAL_SERVICES",
  HEATING_PLUMBING_A_C = "HEATING_PLUMBING_A_C",
  ELECTRICAL_SERVICES = "ELECTRICAL_SERVICES",
  MASONRY_STONEWORK_AND_PLASTER = "MASONRY_STONEWORK_AND_PLASTER",
  CARPENTRY_SERVICES = "CARPENTRY_SERVICES",
  ROOFING_SIDING_SHEET_METAL = "ROOFING_SIDING_SHEET_METAL",
  CONCRETE_WORK_SERVICES = "CONCRETE_WORK_SERVICES",
  SPECIAL_TRADE_SERVICES = "SPECIAL_TRADE_SERVICES",
  FAST_FOOD = "FAST_FOOD",
  MISCELLANEOUS_PUBLISHING_AND_PRINTING = "MISCELLANEOUS_PUBLISHING_AND_PRINTING",
  TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES = "TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES",
  SPECIALTY_CLEANING = "SPECIALTY_CLEANING",
  KYORITSUHOTELS = "KYORITSUHOTELS",
  RAILROADS = "RAILROADS",
  COMMUTER_TRANSPORT_AND_FERRIES = "COMMUTER_TRANSPORT_AND_FERRIES",
  PASSENGER_RAILWAYS = "PASSENGER_RAILWAYS",
  AMBULANCE_SERVICES = "AMBULANCE_SERVICES",
  TAXICABS_LIMOUSINES = "TAXICABS_LIMOUSINES",
  BUS_LINES = "BUS_LINES",
  MOTOR_FREIGHT_CARRIERS_AND_TRUCKING = "MOTOR_FREIGHT_CARRIERS_AND_TRUCKING",
  COURIER_SERVICES = "COURIER_SERVICES",
  PUBLIC_WAREHOUSING_AND_STORAGE = "PUBLIC_WAREHOUSING_AND_STORAGE",
  CRUISE_LINES = "CRUISE_LINES",
  BOAT_RENTALS_AND_LEASES = "BOAT_RENTALS_AND_LEASES",
  MARINAS_SERVICE_AND_SUPPLIES = "MARINAS_SERVICE_AND_SUPPLIES",
  AIRLINES_AIR_CARRIERS = "AIRLINES_AIR_CARRIERS",
  AIRPORTS_FLYING_FIELDS = "AIRPORTS_FLYING_FIELDS",
  TRAVEL_AGENCIES_TOUR_OPERATORS = "TRAVEL_AGENCIES_TOUR_OPERATORS",
  T_UI_TRAVEL_GERMANY = "T_UI_TRAVEL_GERMANY",
  TOLLS_BRIDGE_FEES = "TOLLS_BRIDGE_FEES",
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES = "TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES",
  TELECOMMUNICATION_SERVICES = "TELECOMMUNICATION_SERVICES",
  COMPUTER_NETWORK_SERVICES = "COMPUTER_NETWORK_SERVICES",
  TELEGRAPH_SERVICES = "TELEGRAPH_SERVICES",
  WIRES_MONEY_ORDERS = "WIRES_MONEY_ORDERS",
  CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO = "CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO",
  UTILITIES = "UTILITIES",
  MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS = "MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS",
  OFFICE_AND_COMMERCIAL_FURNITURE = "OFFICE_AND_COMMERCIAL_FURNITURE",
  CONSTRUCTION_MATERIALS = "CONSTRUCTION_MATERIALS",
  PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES = "PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES",
  COMPUTERS_PERIPHERALS_AND_SOFTWARE = "COMPUTERS_PERIPHERALS_AND_SOFTWARE",
  COMMERCIAL_EQUIPMENT = "COMMERCIAL_EQUIPMENT",
  MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES = "MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES",
  METAL_SERVICE_CENTERS = "METAL_SERVICE_CENTERS",
  ELECTRICAL_PARTS_AND_EQUIPMENT = "ELECTRICAL_PARTS_AND_EQUIPMENT",
  HARDWARE_EQUIPMENT_AND_SUPPLIES = "HARDWARE_EQUIPMENT_AND_SUPPLIES",
  PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES = "PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES",
  INDUSTRIAL_SUPPLIES = "INDUSTRIAL_SUPPLIES",
  PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY = "PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY",
  DURABLE_GOODS = "DURABLE_GOODS",
  STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER = "STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER",
  DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES = "DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES",
  PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS = "PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS",
  UNIFORMS_COMMERCIAL_CLOTHING = "UNIFORMS_COMMERCIAL_CLOTHING",
  COMMERCIAL_FOOTWEAR = "COMMERCIAL_FOOTWEAR",
  CHEMICALS_AND_ALLIED_PRODUCTS = "CHEMICALS_AND_ALLIED_PRODUCTS",
  PETROLEUM_AND_PETROLEUM_PRODUCTS = "PETROLEUM_AND_PETROLEUM_PRODUCTS",
  BOOKS_PERIODICALS_AND_NEWSPAPERS = "BOOKS_PERIODICALS_AND_NEWSPAPERS",
  FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS = "FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS",
  PAINTS_VARNISHES_AND_SUPPLIES = "PAINTS_VARNISHES_AND_SUPPLIES",
  NONDURABLE_GOODS = "NONDURABLE_GOODS",
  HOME_SUPPLY_WAREHOUSE_STORES = "HOME_SUPPLY_WAREHOUSE_STORES",
  LUMBER_BUILDING_MATERIALS_STORES = "LUMBER_BUILDING_MATERIALS_STORES",
  GLASS_PAINT_AND_WALLPAPER_STORES = "GLASS_PAINT_AND_WALLPAPER_STORES",
  HARDWARE_STORES = "HARDWARE_STORES",
  NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES = "NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES",
  ONLINE_MARKETPLACES = "ONLINE_MARKETPLACES",
  MOBILE_HOME_DEALERS = "MOBILE_HOME_DEALERS",
  WHOLESALE_CLUBS = "WHOLESALE_CLUBS",
  DUTY_FREE_STORES = "DUTY_FREE_STORES",
  DISCOUNT_STORES = "DISCOUNT_STORES",
  DEPARTMENT_STORES = "DEPARTMENT_STORES",
  VARIETY_STORES = "VARIETY_STORES",
  MISCELLANEOUS_GENERAL_MERCHANDISE = "MISCELLANEOUS_GENERAL_MERCHANDISE",
  GROCERY_STORES_SUPERMARKETS = "GROCERY_STORES_SUPERMARKETS",
  FREEZER_AND_LOCKER_MEAT_PROVISIONERS = "FREEZER_AND_LOCKER_MEAT_PROVISIONERS",
  CANDY_NUT_AND_CONFECTIONERY_STORES = "CANDY_NUT_AND_CONFECTIONERY_STORES",
  DAIRY_PRODUCTS_STORES = "DAIRY_PRODUCTS_STORES",
  BAKERIES = "BAKERIES",
  MISCELLANEOUS_FOOD_STORES = "MISCELLANEOUS_FOOD_STORES",
  CAR_AND_TRUCK_DEALERS_NEW_USED = "CAR_AND_TRUCK_DEALERS_NEW_USED",
  CAR_AND_TRUCK_DEALERS_USED_ONLY = "CAR_AND_TRUCK_DEALERS_USED_ONLY",
  AUTO_AND_HOME_SUPPLY_STORES = "AUTO_AND_HOME_SUPPLY_STORES",
  AUTOMOTIVE_TIRE_STORES = "AUTOMOTIVE_TIRE_STORES",
  AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES = "AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES",
  SERVICE_STATIONS = "SERVICE_STATIONS",
  AUTOMATED_FUEL_DISPENSERS = "AUTOMATED_FUEL_DISPENSERS",
  BOAT_DEALERS = "BOAT_DEALERS",
  ELECTRIC_VEHICLE_CHARGING = "ELECTRIC_VEHICLE_CHARGING",
  MOTORCYCLE_SHOPS_DEALERS = "MOTORCYCLE_SHOPS_DEALERS",
  MOTORCYCLE_SHOPS_AND_DEALERS = "MOTORCYCLE_SHOPS_AND_DEALERS",
  MOTOR_HOMES_DEALERS = "MOTOR_HOMES_DEALERS",
  SNOWMOBILE_DEALERS = "SNOWMOBILE_DEALERS",
  MISCELLANEOUS_AUTO_DEALERS = "MISCELLANEOUS_AUTO_DEALERS",
  MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES = "MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES",
  WOMENS_READY_TO_WEAR_STORES = "WOMENS_READY_TO_WEAR_STORES",
  WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS = "WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS",
  CHILDRENS_AND_INFANTS_WEAR_STORES = "CHILDRENS_AND_INFANTS_WEAR_STORES",
  FAMILY_CLOTHING_STORES = "FAMILY_CLOTHING_STORES",
  SPORTS_AND_RIDING_APPAREL_STORES = "SPORTS_AND_RIDING_APPAREL_STORES",
  SHOE_STORES = "SHOE_STORES",
  FURRIERS_AND_FUR_SHOPS = "FURRIERS_AND_FUR_SHOPS",
  MENS_WOMENS_CLOTHING_STORES = "MENS_WOMENS_CLOTHING_STORES",
  TAILORS_ALTERATIONS = "TAILORS_ALTERATIONS",
  WIG_AND_TOUPEE_STORES = "WIG_AND_TOUPEE_STORES",
  MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS = "MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS",
  FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES = "FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES",
  FLOOR_COVERING_STORES = "FLOOR_COVERING_STORES",
  DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES = "DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES",
  FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES = "FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES",
  MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES = "MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES",
  HOUSEHOLD_APPLIANCE_STORES = "HOUSEHOLD_APPLIANCE_STORES",
  GUNS_AMMO = "GUNS_AMMO",
  ELECTRONICS_STORES = "ELECTRONICS_STORES",
  MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC = "MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC",
  COMPUTER_SOFTWARE_STORES = "COMPUTER_SOFTWARE_STORES",
  RECORD_STORES = "RECORD_STORES",
  CATERERS = "CATERERS",
  EATING_PLACES_RESTAURANTS = "EATING_PLACES_RESTAURANTS",
  DRINKING_PLACES = "DRINKING_PLACES",
  FAST_FOOD_RESTAURANTS = "FAST_FOOD_RESTAURANTS",
  DIGITAL_GOODS_MEDIA = "DIGITAL_GOODS_MEDIA",
  DIGITAL_GOODS_GAMES = "DIGITAL_GOODS_GAMES",
  DIGITAL_GOODS_APPLICATIONS = "DIGITAL_GOODS_APPLICATIONS",
  DIGITAL_GOODS_LARGE_VOLUME = "DIGITAL_GOODS_LARGE_VOLUME",
  DRUG_STORES_AND_PHARMACIES = "DRUG_STORES_AND_PHARMACIES",
  PACKAGE_STORES_BEER_WINE_AND_LIQUOR = "PACKAGE_STORES_BEER_WINE_AND_LIQUOR",
  USED_MERCHANDISE_AND_SECONDHAND_STORES = "USED_MERCHANDISE_AND_SECONDHAND_STORES",
  ANTIQUE_SHOPS = "ANTIQUE_SHOPS",
  PAWN_SHOPS = "PAWN_SHOPS",
  WRECKING_AND_SALVAGE_YARDS = "WRECKING_AND_SALVAGE_YARDS",
  ANTIQUE_REPRODUCTIONS = "ANTIQUE_REPRODUCTIONS",
  BICYCLE_SHOPS = "BICYCLE_SHOPS",
  SPORTING_GOODS_STORES = "SPORTING_GOODS_STORES",
  BOOK_STORES = "BOOK_STORES",
  STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES = "STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES",
  JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES = "JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES",
  HOBBY_TOY_AND_GAME_SHOPS = "HOBBY_TOY_AND_GAME_SHOPS",
  CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES = "CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES",
  GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS = "GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS",
  LUGGAGE_AND_LEATHER_GOODS_STORES = "LUGGAGE_AND_LEATHER_GOODS_STORES",
  SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES = "SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES",
  GLASSWARE_CRYSTAL_STORES = "GLASSWARE_CRYSTAL_STORES",
  DIRECT_MARKETING_INSURANCE_SERVICES = "DIRECT_MARKETING_INSURANCE_SERVICES",
  DIRECT_MARKETING_TRAVEL = "DIRECT_MARKETING_TRAVEL",
  DOOR_TO_DOOR_SALES = "DOOR_TO_DOOR_SALES",
  DIRECT_MARKETING_CATALOG_MERCHANT = "DIRECT_MARKETING_CATALOG_MERCHANT",
  DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT = "DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT",
  DIRECT_MARKETING_OUTBOUND_TELEMARKETING = "DIRECT_MARKETING_OUTBOUND_TELEMARKETING",
  DIRECT_MARKETING_INBOUND_TELEMARKETING = "DIRECT_MARKETING_INBOUND_TELEMARKETING",
  DIRECT_MARKETING_SUBSCRIPTION = "DIRECT_MARKETING_SUBSCRIPTION",
  DIRECT_MARKETING_OTHER = "DIRECT_MARKETING_OTHER",
  ARTISTS_SUPPLY_AND_CRAFT_SHOPS = "ARTISTS_SUPPLY_AND_CRAFT_SHOPS",
  ART_DEALERS_AND_GALLERIES = "ART_DEALERS_AND_GALLERIES",
  STAMP_AND_COIN_STORES = "STAMP_AND_COIN_STORES",
  RELIGIOUS_GOODS_STORES = "RELIGIOUS_GOODS_STORES",
  HEARING_AIDS_SALES_AND_SUPPLIES = "HEARING_AIDS_SALES_AND_SUPPLIES",
  ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES = "ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES",
  COSMETIC_STORES = "COSMETIC_STORES",
  TYPEWRITER_STORES = "TYPEWRITER_STORES",
  FUEL_DEALERS_NON_AUTOMOTIVE = "FUEL_DEALERS_NON_AUTOMOTIVE",
  FLORISTS = "FLORISTS",
  CIGAR_STORES_AND_STANDS = "CIGAR_STORES_AND_STANDS",
  NEWS_DEALERS_AND_NEWSSTANDS = "NEWS_DEALERS_AND_NEWSSTANDS",
  PET_SHOPS_PET_FOOD_AND_SUPPLIES = "PET_SHOPS_PET_FOOD_AND_SUPPLIES",
  SWIMMING_POOLS_SALES = "SWIMMING_POOLS_SALES",
  ELECTRIC_RAZOR_STORES = "ELECTRIC_RAZOR_STORES",
  TENT_AND_AWNING_SHOPS = "TENT_AND_AWNING_SHOPS",
  MISCELLANEOUS_SPECIALTY_RETAIL = "MISCELLANEOUS_SPECIALTY_RETAIL",
  MANUAL_CASH_DISBURSE = "MANUAL_CASH_DISBURSE",
  AUTOMATED_CASH_DISBURSE = "AUTOMATED_CASH_DISBURSE",
  FINANCIAL_INSTITUTIONS = "FINANCIAL_INSTITUTIONS",
  QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS = "QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS",
  NON_FI_MONEY_ORDERS = "NON_FI_MONEY_ORDERS",
  PERSONAL_CREDIT_INSTITUTIONS = "PERSONAL_CREDIT_INSTITUTIONS",
  MORTGAGE_BANKERS_LOAN_CORRESPONDENTS = "MORTGAGE_BANKERS_LOAN_CORRESPONDENTS",
  SECURITY_BROKERS_DEALERS = "SECURITY_BROKERS_DEALERS",
  INSURANCE_UNDERWRITING_PREMIUMS = "INSURANCE_UNDERWRITING_PREMIUMS",
  PINLESS_DEBIT_BILLPAY_TIER_2 = "PINLESS_DEBIT_BILLPAY_TIER_2",
  INSURANCE_PREMIUMS = "INSURANCE_PREMIUMS",
  INSURANCE_DEFAULT = "INSURANCE_DEFAULT",
  INSURANCE_AGENTS_BROKERS_SERVICE = "INSURANCE_AGENTS_BROKERS_SERVICE",
  REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS = "REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS",
  MONEYSEND_INTRACOUNTRY = "MONEYSEND_INTRACOUNTRY",
  MONEYSEND_INTERCOUNTRY = "MONEYSEND_INTERCOUNTRY",
  MONEYSEND_FUNDING = "MONEYSEND_FUNDING",
  FUNDING_TRANSACTION = "FUNDING_TRANSACTION",
  NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD = "NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD",
  HOTELS_MOTELS_AND_RESORTS = "HOTELS_MOTELS_AND_RESORTS",
  TIMESHARES = "TIMESHARES",
  SPORTING_RECREATION_CAMPS = "SPORTING_RECREATION_CAMPS",
  TRAILER_PARKS_CAMPGROUNDS = "TRAILER_PARKS_CAMPGROUNDS",
  LAUNDRY_CLEANING_SERVICES = "LAUNDRY_CLEANING_SERVICES",
  LAUNDRIES = "LAUNDRIES",
  DRY_CLEANERS = "DRY_CLEANERS",
  CARPET_UPHOLSTERY_CLEANING = "CARPET_UPHOLSTERY_CLEANING",
  PHOTOGRAPHIC_STUDIOS = "PHOTOGRAPHIC_STUDIOS",
  BARBER_AND_BEAUTY_SHOPS = "BARBER_AND_BEAUTY_SHOPS",
  SHOE_REPAIR_HAT_CLEANING = "SHOE_REPAIR_HAT_CLEANING",
  FUNERAL_SERVICES_CREMATORIES = "FUNERAL_SERVICES_CREMATORIES",
  DATING_ESCORT_SERVICES = "DATING_ESCORT_SERVICES",
  TAX_PREPARATION_SERVICES = "TAX_PREPARATION_SERVICES",
  COUNSELING_SERVICES = "COUNSELING_SERVICES",
  BUYING_SHOPPING_SERVICES = "BUYING_SHOPPING_SERVICES",
  CLOTHING_RENTAL = "CLOTHING_RENTAL",
  MASSAGE_PARLORS = "MASSAGE_PARLORS",
  HEALTH_AND_BEAUTY_SPAS = "HEALTH_AND_BEAUTY_SPAS",
  MISCELLANEOUS_GENERAL_SERVICES = "MISCELLANEOUS_GENERAL_SERVICES",
  ADVERTISING_SERVICES = "ADVERTISING_SERVICES",
  CREDIT_REPORTING_AGENCIES = "CREDIT_REPORTING_AGENCIES",
  COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS = "COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS",
  QUICK_COPY_REPRO_AND_BLUEPRINT = "QUICK_COPY_REPRO_AND_BLUEPRINT",
  SECRETARIAL_SUPPORT_SERVICES = "SECRETARIAL_SUPPORT_SERVICES",
  EXTERMINATING_SERVICES = "EXTERMINATING_SERVICES",
  CLEANING_AND_MAINTENANCE = "CLEANING_AND_MAINTENANCE",
  EMPLOYMENT_TEMP_AGENCIES = "EMPLOYMENT_TEMP_AGENCIES",
  COMPUTER_PROGRAMMING = "COMPUTER_PROGRAMMING",
  INFORMATION_RETRIEVAL_SERVICES = "INFORMATION_RETRIEVAL_SERVICES",
  COMPUTER_REPAIR = "COMPUTER_REPAIR",
  CONSULTING_PUBLIC_RELATIONS = "CONSULTING_PUBLIC_RELATIONS",
  DETECTIVE_AGENCIES = "DETECTIVE_AGENCIES",
  EQUIPMENT_RENTAL = "EQUIPMENT_RENTAL",
  PHOTO_DEVELOPING = "PHOTO_DEVELOPING",
  MISCELLANEOUS_BUSINESS_SERVICES = "MISCELLANEOUS_BUSINESS_SERVICES",
  TRUCK_STOP_ITERATION = "TRUCK_STOP_ITERATION",
  CAR_RENTAL_AGENCIES = "CAR_RENTAL_AGENCIES",
  CAR_RENTAL = "CAR_RENTAL",
  TRUCK_UTILITY_TRAILER_RENTALS = "TRUCK_UTILITY_TRAILER_RENTALS",
  RECREATIONAL_VEHICLE_RENTALS = "RECREATIONAL_VEHICLE_RENTALS",
  PARKING_LOTS_GARAGES = "PARKING_LOTS_GARAGES",
  AUTO_BODY_REPAIR_SHOPS = "AUTO_BODY_REPAIR_SHOPS",
  TIRE_RETREADING_AND_REPAIR = "TIRE_RETREADING_AND_REPAIR",
  AUTO_PAINT_SHOPS = "AUTO_PAINT_SHOPS",
  AUTO_SERVICE_SHOPS = "AUTO_SERVICE_SHOPS",
  CAR_WASHES = "CAR_WASHES",
  TOWING_SERVICES = "TOWING_SERVICES",
  ELECTRONICS_REPAIR_SHOPS = "ELECTRONICS_REPAIR_SHOPS",
  AC_REFRIGERATION_REPAIR = "AC_REFRIGERATION_REPAIR",
  SMALL_APPLIANCE_REPAIR = "SMALL_APPLIANCE_REPAIR",
  WATCH_JEWELRY_REPAIR = "WATCH_JEWELRY_REPAIR",
  FURNITURE_REPAIR_REFINISHING = "FURNITURE_REPAIR_REFINISHING",
  WELDING_REPAIR = "WELDING_REPAIR",
  MISCELLANEOUS_REPAIR_SHOPS = "MISCELLANEOUS_REPAIR_SHOPS",
  PICTURE_VIDEO_PRODUCTION = "PICTURE_VIDEO_PRODUCTION",
  MOTION_PICTURE_THEATERS = "MOTION_PICTURE_THEATERS",
  VIDEO_TAPE_RENTAL_STORES = "VIDEO_TAPE_RENTAL_STORES",
  DANCE_HALL_STUDIOS_SCHOOLS = "DANCE_HALL_STUDIOS_SCHOOLS",
  THEATRICAL_TICKET_AGENCIES = "THEATRICAL_TICKET_AGENCIES",
  BANDS_ORCHESTRAS = "BANDS_ORCHESTRAS",
  BILLIARD_POOL_ESTABLISHMENTS = "BILLIARD_POOL_ESTABLISHMENTS",
  BOWLING_ALLEYS = "BOWLING_ALLEYS",
  SPORTS_CLUBS_FIELDS = "SPORTS_CLUBS_FIELDS",
  TOURIST_ATTRACTIONS_AND_EXHIBITS = "TOURIST_ATTRACTIONS_AND_EXHIBITS",
  GOLF_COURSES_PUBLIC = "GOLF_COURSES_PUBLIC",
  VIDEO_AMUSEMENT_GAME_SUPPLIES = "VIDEO_AMUSEMENT_GAME_SUPPLIES",
  VIDEO_GAME_ARCADES = "VIDEO_GAME_ARCADES",
  BETTING_CASINO_GAMBLING = "BETTING_CASINO_GAMBLING",
  AMUSEMENT_PARKS_CARNIVALS = "AMUSEMENT_PARKS_CARNIVALS",
  COUNTRY_CLUBS = "COUNTRY_CLUBS",
  AQUARIUMS = "AQUARIUMS",
  MISCELLANEOUS_RECREATION_SERVICES = "MISCELLANEOUS_RECREATION_SERVICES",
  DOCTORS = "DOCTORS",
  DENTISTS_ORTHODONTISTS = "DENTISTS_ORTHODONTISTS",
  OSTEOPATHS = "OSTEOPATHS",
  CHIROPRACTORS = "CHIROPRACTORS",
  OPTOMETRISTS_OPHTHALMOLOGIST = "OPTOMETRISTS_OPHTHALMOLOGIST",
  OPTICIANS_EYEGLASSES = "OPTICIANS_EYEGLASSES",
  CHIROPODISTS_PODIATRISTS = "CHIROPODISTS_PODIATRISTS",
  NURSING_PERSONAL_CARE = "NURSING_PERSONAL_CARE",
  HOSPITALS = "HOSPITALS",
  MEDICAL_AND_DENTAL_LABS = "MEDICAL_AND_DENTAL_LABS",
  MEDICAL_SERVICES = "MEDICAL_SERVICES",
  LEGAL_SERVICES_ATTORNEYS = "LEGAL_SERVICES_ATTORNEYS",
  ELEMENTARY_SECONDARY_SCHOOLS = "ELEMENTARY_SECONDARY_SCHOOLS",
  COLLEGES_UNIVERSITIES = "COLLEGES_UNIVERSITIES",
  CORRESPONDENCE_SCHOOLS = "CORRESPONDENCE_SCHOOLS",
  BUSINESS_SECRETARIAL_SCHOOLS = "BUSINESS_SECRETARIAL_SCHOOLS",
  VOCATIONAL_TRADE_SCHOOLS = "VOCATIONAL_TRADE_SCHOOLS",
  EDUCATIONAL_SERVICES = "EDUCATIONAL_SERVICES",
  CHILD_CARE_SERVICES = "CHILD_CARE_SERVICES",
  CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING = "CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING",
  CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS = "CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS",
  POLITICAL_ORGANIZATIONS = "POLITICAL_ORGANIZATIONS",
  RELIGIOUS_ORGANIZATIONS = "RELIGIOUS_ORGANIZATIONS",
  AUTOMOBILE_ASSOCIATIONS = "AUTOMOBILE_ASSOCIATIONS",
  MEMBERSHIP_ORGANIZATIONS = "MEMBERSHIP_ORGANIZATIONS",
  TESTING_LABORATORIES = "TESTING_LABORATORIES",
  ARCHITECTURAL_SURVEYING_SERVICES = "ARCHITECTURAL_SURVEYING_SERVICES",
  ACCOUNTING_BOOKKEEPING_SERVICES = "ACCOUNTING_BOOKKEEPING_SERVICES",
  PROFESSIONAL_SERVICES = "PROFESSIONAL_SERVICES",
  COURT_COSTS = "COURT_COSTS",
  FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES = "FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES",
  BAIL_AND_BOND_PAYMENTS = "BAIL_AND_BOND_PAYMENTS",
  TAX_PAYMENTS_GOVERNMENT_AGENCIES = "TAX_PAYMENTS_GOVERNMENT_AGENCIES",
  GOVERNMENT_SERVICES = "GOVERNMENT_SERVICES",
  POSTAL_SERVICES_GOVERNMENT_ONLY = "POSTAL_SERVICES_GOVERNMENT_ONLY",
  US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS = "US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS",
  GOVERNMENT_OWNED_LOTTERY_GLOBAL = "GOVERNMENT_OWNED_LOTTERY_GLOBAL",
  INTRA_COMPANY_PURCHASES = "INTRA_COMPANY_PURCHASES",
  BLUEPRINTING_AND_PHOTOCOPYING_SERVICES = "BLUEPRINTING_AND_PHOTOCOPYING_SERVICES",
  GOVERNMENT_OWNED_LOTTERY = "GOVERNMENT_OWNED_LOTTERY",
  GOVERNMENT_LICENSED_ON_LINE_CASINO = "GOVERNMENT_LICENSED_ON_LINE_CASINO",
  GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING = "GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING",
  HOME_2_SUITES = "HOME_2_SUITES",
  MASTERS_ECONOMY_INNS = "MASTERS_ECONOMY_INNS",
  UNITED_AIRLINES = "UNITED_AIRLINES",
  AMERICAN_AIRLINES = "AMERICAN_AIRLINES",
  PAN_AMERICAN = "PAN_AMERICAN",
  TRANS_WORLD_AIRLINES = "TRANS_WORLD_AIRLINES",
  BRITISH_AIRWAYS = "BRITISH_AIRWAYS",
  JAPAN_AIRLINES = "JAPAN_AIRLINES",
  AIR_FRANCE = "AIR_FRANCE",
  LUFTHANSA = "LUFTHANSA",
  AIR_CANADA = "AIR_CANADA",
  KLM_ROYAL_DUTCH_AIRLINES = "KLM_ROYAL_DUTCH_AIRLINES",
  AEORFLOT = "AEORFLOT",
  QUANTAS = "QUANTAS",
  ALITALIA = "ALITALIA",
  SAUDIA_ARABIAN_AIRLINES = "SAUDIA_ARABIAN_AIRLINES",
  SWISS_AIR = "SWISS_AIR",
  SCANDINAVIAN_AIRLINE_SYSTEM = "SCANDINAVIAN_AIRLINE_SYSTEM",
  SOUTH_AFRICAN_AIRWAYS = "SOUTH_AFRICAN_AIRWAYS",
  VARIG = "VARIG",
  AIR_INDIA = "AIR_INDIA",
  AIR_ALGERIE = "AIR_ALGERIE",
  PHILIPPINE_AIRLINES = "PHILIPPINE_AIRLINES",
  MEXICANA_AIRLINES = "MEXICANA_AIRLINES",
  PAKISTAN_INTERNATIONAL = "PAKISTAN_INTERNATIONAL",
  AIR_NEW_ZEALAND = "AIR_NEW_ZEALAND",
  EMIRATES = "EMIRATES",
  UTA_INTERAIR = "UTA_INTERAIR",
  AIR_MALTA = "AIR_MALTA",
  SABENA = "SABENA",
  AEROLINEAS_ARGENTINAS = "AEROLINEAS_ARGENTINAS",
  OLYMPIC_AIRWAYS = "OLYMPIC_AIRWAYS",
  EL_AL_AIRLINES = "EL_AL_AIRLINES",
  ANSETT_AIRLINES = "ANSETT_AIRLINES",
  ETIHAD_AIR = "ETIHAD_AIR",
  TAP_AIR_PORTUGAL = "TAP_AIR_PORTUGAL",
  VASP_AIR = "VASP_AIR",
  EGYPT_AIR = "EGYPT_AIR",
  KUWAIT_AIR = "KUWAIT_AIR",
  AVIANCA = "AVIANCA",
  GULF_AIR = "GULF_AIR",
  BALKAN_AIR = "BALKAN_AIR",
  FINNAIR = "FINNAIR",
  AER_LINGUS = "AER_LINGUS",
  AIR_LANKA = "AIR_LANKA",
  NIGERIA_AIR = "NIGERIA_AIR",
  CRUZIERO_AIR = "CRUZIERO_AIR",
  THY_AIRLINE = "THY_AIRLINE",
  AIR_MAROC = "AIR_MAROC",
  TUNIS_AIR = "TUNIS_AIR",
  ICELAND_AIR = "ICELAND_AIR",
  AUSTRIAN_AIR = "AUSTRIAN_AIR",
  LAN_AIR = "LAN_AIR",
  AVIACO_AIR = "AVIACO_AIR",
  LADECO_AIR = "LADECO_AIR",
  LAB_AIR = "LAB_AIR",
  JET_AIRWAYS = "JET_AIRWAYS",
  VIRGIN_AMERICA = "VIRGIN_AMERICA",
  DELTA_AIRLINES = "DELTA_AIRLINES",
  DBA_AIR = "DBA_AIR",
  NWA_AIR = "NWA_AIR",
  CONTINENTAL_AIRLINES = "CONTINENTAL_AIRLINES",
  HLX_AIR = "HLX_AIR",
  US_AIRWAYS = "US_AIRWAYS",
  ADRIA_AIR = "ADRIA_AIR",
  AIRINTER = "AIRINTER",
  SOUTHWEST_AIRLINES = "SOUTHWEST_AIRLINES",
  VANGUARD_AIR = "VANGUARD_AIR",
  AIR_ASTANA = "AIR_ASTANA",
  SUN_COUNTRY_AIRLINES = "SUN_COUNTRY_AIRLINES",
  AIR_BRITISH_COLUMBIA = "AIR_BRITISH_COLUMBIA",
  CEBU_PACIFIC_AIRLINES = "CEBU_PACIFIC_AIRLINES",
  SINGAPORE_AIRLINES = "SINGAPORE_AIRLINES",
  AEROMEXICO = "AEROMEXICO",
  THAI_AIRWAYS = "THAI_AIRWAYS",
  CHINA_AIRLINES = "CHINA_AIRLINES",
  JETSTAR_AIRWAYS = "JETSTAR_AIRWAYS",
  NORD_AIR = "NORD_AIR",
  KOREAN_AIRLINES = "KOREAN_AIRLINES",
  AIR_AFRIQUE = "AIR_AFRIQUE",
  EVA_AIRWAYS = "EVA_AIRWAYS",
  MIDWEST_EXPRESS_AIRLINES = "MIDWEST_EXPRESS_AIRLINES",
  CARNIVAL_AIRLINES = "CARNIVAL_AIRLINES",
  METRO_AIRLINES = "METRO_AIRLINES",
  CROATIA_AIR = "CROATIA_AIR",
  TRANSAERO = "TRANSAERO",
  UNI_AIRWAYS_CORPORATION = "UNI_AIRWAYS_CORPORATION",
  ZAMBIA_AIRWAYS = "ZAMBIA_AIRWAYS",
  AIR_ZIMBABWE_CORP = "AIR_ZIMBABWE_CORP",
  SPANAIR = "SPANAIR",
  ASIANA_AIRLINES = "ASIANA_AIRLINES",
  CATHAY_PACIFIC = "CATHAY_PACIFIC",
  MALAYSIAN_AIRLINE_SYSTEM = "MALAYSIAN_AIRLINE_SYSTEM",
  IBERIA = "IBERIA",
  GARUDA = "GARUDA",
  BRAATHENS = "BRAATHENS",
  WINGS_AIRWAYS = "WINGS_AIRWAYS",
  BRITISH_MIDLAND_AIR = "BRITISH_MIDLAND_AIR",
  WINDWARD_ISLAND_AIR = "WINDWARD_ISLAND_AIR",
  TOWER_AIR = "TOWER_AIR",
  VIASA_AIR = "VIASA_AIR",
  VALLEY_AIRLINES = "VALLEY_AIRLINES",
  TAN_AIR = "TAN_AIR",
  TAL_AIR = "TAL_AIR",
  TACA_INTERNATIONAL_AIR = "TACA_INTERNATIONAL_AIR",
  SURINAM_AIRWAYS = "SURINAM_AIRWAYS",
  SUNWORLD_AIR = "SUNWORLD_AIR",
  VLM_AIRLINES = "VLM_AIRLINES",
  FRONTIER_AIRLINES = "FRONTIER_AIRLINES",
  SUNBELT_AIRLINES = "SUNBELT_AIRLINES",
  SUDAN_AIRWAYS = "SUDAN_AIRWAYS",
  QATAR_AIRWAYS = "QATAR_AIRWAYS",
  SINGLETON_AIR = "SINGLETON_AIR",
  SIMMONS_AIRLINES = "SIMMONS_AIRLINES",
  SCENIC_AIRLINES = "SCENIC_AIRLINES",
  VIRGIN_ATLANTIC = "VIRGIN_ATLANTIC",
  SAN_JUAN_AIR = "SAN_JUAN_AIR",
  LUXAIR = "LUXAIR",
  AIR_LITTORAL = "AIR_LITTORAL",
  AIR_ZAIRE = "AIR_ZAIRE",
  PRINCEVILLE_AIR = "PRINCEVILLE_AIR",
  GOFLY = "GOFLY",
  PBA_AIRLINE = "PBA_AIRLINE",
  ANA_AIR = "ANA_AIR",
  NORONTAIR = "NORONTAIR",
  NY_HELI = "NY_HELI",
  AERO_CONTINENTE = "AERO_CONTINENTE",
  HAINAN_AIRLINES = "HAINAN_AIRLINES",
  MOUNT_COOK = "MOUNT_COOK",
  CANADIAN_AIR = "CANADIAN_AIR",
  NATIONAIR = "NATIONAIR",
  JETBLUE_AIRWAYS = "JETBLUE_AIRWAYS",
  MIDDLE_EAST_AIR = "MIDDLE_EAST_AIR",
  METROFLIGHT_AIRLINES = "METROFLIGHT_AIRLINES",
  AIRTRAN_AIRWAYS = "AIRTRAN_AIRWAYS",
  MESA_AIR = "MESA_AIR",
  WESTJET_AIRLINES = "WESTJET_AIRLINES",
  MALEV = "MALEV",
  LOT_AIR = "LOT_AIR",
  OMAN_AIR = "OMAN_AIR",
  LIAT_AIRLINE = "LIAT_AIRLINE",
  LAV_AIR = "LAV_AIR",
  LAP_AIR = "LAP_AIR",
  LACSA_AIR = "LACSA_AIR",
  VIRGIN_EXPRESS_AIR = "VIRGIN_EXPRESS_AIR",
  JUGOSLAV_AIR = "JUGOSLAV_AIR",
  ISLAND_AIRLINES = "ISLAND_AIRLINES",
  INDIAN_AIRLINES = "INDIAN_AIRLINES",
  HAWAIIAN_AIR = "HAWAIIAN_AIR",
  HAVASU_AIRLINES = "HAVASU_AIRLINES",
  GUYANA_AIRWAYS = "GUYANA_AIRWAYS",
  GOLDEN_PACIFIC_AIR = "GOLDEN_PACIFIC_AIR",
  FREEDOM_AIRLINES = "FREEDOM_AIRLINES",
  CHINA_EASTERN_AIRLINES = "CHINA_EASTERN_AIRLINES",
  NORWEGIAN_AIR_SHUTTLE = "NORWEGIAN_AIR_SHUTTLE",
  DOMINICA_AIR = "DOMINICA_AIR",
  MALMO_AIR = "MALMO_AIR",
  DAN_AIR_SERVICES = "DAN_AIR_SERVICES",
  CUMBERLAND_AIRLINES = "CUMBERLAND_AIRLINES",
  CSA_AIRLINE = "CSA_AIRLINE",
  CROWN_AIR = "CROWN_AIR",
  COPA_AIR = "COPA_AIR",
  COMP_FAU_AIR = "COMP_FAU_AIR",
  TAME_AIR = "TAME_AIR",
  COMMAND_AIR = "COMMAND_AIR",
  COMAIR = "COMAIR",
  SKYWAYS_AIR = "SKYWAYS_AIR",
  CAYMAN_AIRWAYS = "CAYMAN_AIRWAYS",
  SAETA_AIR = "SAETA_AIR",
  SAHSA_AIR = "SAHSA_AIR",
  CAPITOL_AIR = "CAPITOL_AIR",
  CARIBBEAN_AIRLINES = "CARIBBEAN_AIRLINES",
  BROCKWAY_AIR = "BROCKWAY_AIR",
  AIR_ARABIA = "AIR_ARABIA",
  BEMIDJI_AIR = "BEMIDJI_AIR",
  BAR_HARBOR_AIRLINES = "BAR_HARBOR_AIRLINES",
  BAHAMAS_AIR = "BAHAMAS_AIR",
  AVIATECA_AIR = "AVIATECA_AIR",
  AVENSA_AIR = "AVENSA_AIR",
  AUSTRIAN_AIR_SERVICE = "AUSTRIAN_AIR_SERVICE",
  EASYJET_AIR = "EASYJET_AIR",
  RYANAIR = "RYANAIR",
  GOL_AIRLINES = "GOL_AIRLINES",
  TAM_AIRLINES = "TAM_AIRLINES",
  ALOHA_AIRLINES = "ALOHA_AIRLINES",
  ALM_AIRLINE = "ALM_AIRLINE",
  AMERICA_WEST = "AMERICA_WEST",
  US_AIR_SHUTTLE = "US_AIR_SHUTTLE",
  ALASKA_AIR = "ALASKA_AIR",
  ATA_AIR = "ATA_AIR",
  SPIRIT_AIRLINES = "SPIRIT_AIRLINES",
  AIR_CHINA = "AIR_CHINA",
  RENO_AIR = "RENO_AIR",
  ASC_AIRLINE = "ASC_AIRLINE",
  AIR_SEYCHELLES = "AIR_SEYCHELLES",
  AIR_PANAMA = "AIR_PANAMA",
  AIR_JAMAICA = "AIR_JAMAICA",
  AIR_DJIBOUTI = "AIR_DJIBOUTI",
  AERO_VIRGIN_ISLANDS = "AERO_VIRGIN_ISLANDS",
  AERO_PERU = "AERO_PERU",
  AERO_NICARAGUENSIS = "AERO_NICARAGUENSIS",
  AERO_COACH_AVIATION = "AERO_COACH_AVIATION",
  CYPRUS_AIRWAYS = "CYPRUS_AIRWAYS",
  ECUATORIANA = "ECUATORIANA",
  ETHIOPIAN_AIRLINES = "ETHIOPIAN_AIRLINES",
  KENYA_AIRWAYS = "KENYA_AIRWAYS",
  AIR_BERLIN = "AIR_BERLIN",
  TAROM_AIR = "TAROM_AIR",
  AIR_MAURITIUS = "AIR_MAURITIUS",
  WIDEROES = "WIDEROES",
  AZUL_BRAZILIAN_AIRLINES = "AZUL_BRAZILIAN_AIRLINES",
  WIZZ_AIR = "WIZZ_AIR",
  FLYBE = "FLYBE",
  TIGERAIR = "TIGERAIR",
  CHINA_SOUTHERN_AIRLINES = "CHINA_SOUTHERN_AIRLINES",
  AIR_TRANSAT = "AIR_TRANSAT",
  AFFILIATED_AUTO_RENTAL = "AFFILIATED_AUTO_RENTAL",
  AMERICAN_INTERNATIONAL = "AMERICAN_INTERNATIONAL",
  BROOKS_RENT_A_CAR = "BROOKS_RENT_A_CAR",
  ACTION_AUTO_RENTAL = "ACTION_AUTO_RENTAL",
  SIXT_CAR_RENTAL = "SIXT_CAR_RENTAL",
  HERTZ = "HERTZ",
  PAYLESS_CAR_RENTAL = "PAYLESS_CAR_RENTAL",
  SNAPPY_CAR_RENTAL = "SNAPPY_CAR_RENTAL",
  AIRWAYS = "AIRWAYS",
  ALTRA_AUTO_RENTAL = "ALTRA_AUTO_RENTAL",
  AGENCY_RENT_A_CAR = "AGENCY_RENT_A_CAR",
  BUDGET_RENT_A_CAR = "BUDGET_RENT_A_CAR",
  HOLIDAY_RENT_A_CAR = "HOLIDAY_RENT_A_CAR",
  RENT_A_WRECK = "RENT_A_WRECK",
  ACCENT_RENT_A_CAR = "ACCENT_RENT_A_CAR",
  AJAX_RENT_A_CAR = "AJAX_RENT_A_CAR",
  TRIANGLE_RENT_A_CAR = "TRIANGLE_RENT_A_CAR",
  EUROPCAR = "EUROPCAR",
  TROPICAL_RENT_A_CAR = "TROPICAL_RENT_A_CAR",
  SHOWCASE_RENTAL_CARS = "SHOWCASE_RENTAL_CARS",
  ALAMO_RENT_A_CAR = "ALAMO_RENT_A_CAR",
  MERCHANTS_RENT_A_CAR = "MERCHANTS_RENT_A_CAR",
  AVIS_RENT_A_CAR = "AVIS_RENT_A_CAR",
  DOLLAR_RENT_A_CAR = "DOLLAR_RENT_A_CAR",
  EUROPE_BY_CAR = "EUROPE_BY_CAR",
  NATIONAL_CAR_RENTAL = "NATIONAL_CAR_RENTAL",
  KEMWELL_GROUP = "KEMWELL_GROUP",
  THRIFTY_CAR_RENTAL = "THRIFTY_CAR_RENTAL",
  TILDEN_RENT_A_CAR = "TILDEN_RENT_A_CAR",
  ECONO_CAR_RENT_A_CAR = "ECONO_CAR_RENT_A_CAR",
  AUTO_HOST_RENTAL_CARS = "AUTO_HOST_RENTAL_CARS",
  ENTERPRISE_RENT_A_CAR = "ENTERPRISE_RENT_A_CAR",
  GENERAL_RENT_A_CAR = "GENERAL_RENT_A_CAR",
  A1_RENT_A_CAR = "A1_RENT_A_CAR",
  GODFREY_NATIONAL = "GODFREY_NATIONAL",
  ANSA_INTERNATIONAL = "ANSA_INTERNATIONAL",
  ALLSTATE = "ALLSTATE",
  AVCAR = "AVCAR",
  AUTOMATE = "AUTOMATE",
  AVON_RENT_A_CAR = "AVON_RENT_A_CAR",
  CAREY = "CAREY",
  INSURANCE_RENT_A_CAR = "INSURANCE_RENT_A_CAR",
  MAJOR_RENT_A_CAR = "MAJOR_RENT_A_CAR",
  REPLACEMENT_RENT_A_CAR = "REPLACEMENT_RENT_A_CAR",
  RESERVE_RENT_A_CAR = "RESERVE_RENT_A_CAR",
  UGLY_DUCKLING_RENT_A_CAR = "UGLY_DUCKLING_RENT_A_CAR",
  USA_RENTAL = "USA_RENTAL",
  VALUE_RENT_A_CAR = "VALUE_RENT_A_CAR",
  AUTOHANSA = "AUTOHANSA",
  CITE = "CITE",
  INTERENT = "INTERENT",
  MILLEVILLE = "MILLEVILLE",
  ADVANTAGE_RENT_A_CAR = "ADVANTAGE_RENT_A_CAR",
  HOLIDAY_INNS = "HOLIDAY_INNS",
  BEST_WESTERN = "BEST_WESTERN",
  SHERATON = "SHERATON",
  HILTON = "HILTON",
  TRUSTHOUSE_FORTE = "TRUSTHOUSE_FORTE",
  GOLDEN_TULIP = "GOLDEN_TULIP",
  FRIENDSHIP_INNS_INTERNATIONAL = "FRIENDSHIP_INNS_INTERNATIONAL",
  QUALITY_INTERNATIONAL = "QUALITY_INTERNATIONAL",
  MARRIOTT = "MARRIOTT",
  DAYS_INNS_OF_AMERICA = "DAYS_INNS_OF_AMERICA",
  ARABELLA_HOTELS = "ARABELLA_HOTELS",
  INTERCONTINENTAL = "INTERCONTINENTAL",
  WESTIN_HOTELS = "WESTIN_HOTELS",
  AMERISUITES = "AMERISUITES",
  RODEWAY_INNS_INTERNATIONAL = "RODEWAY_INNS_INTERNATIONAL",
  LA_QUINTA_MOTOR_INNS = "LA_QUINTA_MOTOR_INNS",
  AMERICANA_HOTELS_CORPORATION = "AMERICANA_HOTELS_CORPORATION",
  SOL_HOTELS = "SOL_HOTELS",
  PLM_ETAP_INTERNATIONAL = "PLM_ETAP_INTERNATIONAL",
  MERIDIEN = "MERIDIEN",
  CREST_HOTELS = "CREST_HOTELS",
  TOKYO_GROUP = "TOKYO_GROUP",
  PENINSULA_HOTELS = "PENINSULA_HOTELS",
  WELCOMGROUP = "WELCOMGROUP",
  DUNFEY_HOTELS = "DUNFEY_HOTELS",
  PRINCE_HOTELS = "PRINCE_HOTELS",
  DOWNTOWNER_PASSPORT = "DOWNTOWNER_PASSPORT",
  THUNDERBIRD_RED_LION = "THUNDERBIRD_RED_LION",
  CANADIAN_PACIFIC = "CANADIAN_PACIFIC",
  RENAISSANCE_HOTELS = "RENAISSANCE_HOTELS",
  KAUAI_COCONUT_BEACH_RESORT = "KAUAI_COCONUT_BEACH_RESORT",
  ROYAL_KONA_RESORT = "ROYAL_KONA_RESORT",
  PARK_INN_BY_RADISSON = "PARK_INN_BY_RADISSON",
  SOUTHERN_PACIFIC_HOTEL = "SOUTHERN_PACIFIC_HOTEL",
  HILTON_INTERNATIONAL = "HILTON_INTERNATIONAL",
  AMFAC_HOTELS = "AMFAC_HOTELS",
  ANA_HOTELS = "ANA_HOTELS",
  CONCORDE_HOTELS = "CONCORDE_HOTELS",
  SUMMERFIELD_SUITES_HOTEL = "SUMMERFIELD_SUITES_HOTEL",
  IBEROTEL = "IBEROTEL",
  HOTEL_OKURA = "HOTEL_OKURA",
  ROYAL_HOTELS = "ROYAL_HOTELS",
  FOUR_SEASONS = "FOUR_SEASONS",
  CIGAHOTELS = "CIGAHOTELS",
  SHANGRI_LA_INTERNATIONAL = "SHANGRI_LA_INTERNATIONAL",
  HOTEL_SIERRA = "HOTEL_SIERRA",
  BREAKERS_RESORT = "BREAKERS_RESORT",
  HOTELS_MELIA = "HOTELS_MELIA",
  AUBERGE_DES_GOVERNEURS = "AUBERGE_DES_GOVERNEURS",
  REGAL_8_INNS = "REGAL_8_INNS",
  MIRAGE_HOTEL_AND_CASINO = "MIRAGE_HOTEL_AND_CASINO",
  COAST_HOTELS = "COAST_HOTELS",
  PARKS_INNS_INTERNATIONAL = "PARKS_INNS_INTERNATIONAL",
  PINEHURST_RESORT = "PINEHURST_RESORT",
  TREASURE_ISLAND_HOTEL_AND_CASINO = "TREASURE_ISLAND_HOTEL_AND_CASINO",
  BARTON_CREEK_RESORT = "BARTON_CREEK_RESORT",
  MANHATTAN_EAST_SUITE_HOTELS = "MANHATTAN_EAST_SUITE_HOTELS",
  JOLLY_HOTELS = "JOLLY_HOTELS",
  CANDLEWOOD_SUITES = "CANDLEWOOD_SUITES",
  ALADDIN_RESORT_AND_CASINO = "ALADDIN_RESORT_AND_CASINO",
  GOLDEN_NUGGET = "GOLDEN_NUGGET",
  COMFORT_HOTEL_INTERNATIONAL = "COMFORT_HOTEL_INTERNATIONAL",
  JOURNEYS_END_MOTELS = "JOURNEYS_END_MOTELS",
  SAMS_TOWN_HOTEL_AND_CASINO = "SAMS_TOWN_HOTEL_AND_CASINO",
  RELAX_INNS = "RELAX_INNS",
  GARDEN_PLACE_HOTEL = "GARDEN_PLACE_HOTEL",
  SOHO_GRAND_HOTEL = "SOHO_GRAND_HOTEL",
  LADBROKE_HOTELS = "LADBROKE_HOTELS",
  TRIBECA_GRAND_HOTEL = "TRIBECA_GRAND_HOTEL",
  GRAND_MET_FORUM_HOTELS = "GRAND_MET_FORUM_HOTELS",
  GRAND_WAILEA_RESORT = "GRAND_WAILEA_RESORT",
  MIYAKO_HOTEL_KINTETSU = "MIYAKO_HOTEL_KINTETSU",
  SANDMAN_HOTELS = "SANDMAN_HOTELS",
  VENTURE_INN = "VENTURE_INN",
  VAGABOND_HOTELS = "VAGABOND_HOTELS",
  LA_QUINTA_RESORT = "LA_QUINTA_RESORT",
  MANDARIN_INTERNATIONAL = "MANDARIN_INTERNATIONAL",
  FRANKENMUTH_BAVARIAN = "FRANKENMUTH_BAVARIAN",
  HOTEL_MERCURE = "HOTEL_MERCURE",
  HOTEL_DEL_CORONADO = "HOTEL_DEL_CORONADO",
  DELTA_HOTELS = "DELTA_HOTELS",
  CALIFORNIA_HOTEL_AND_CASINO = "CALIFORNIA_HOTEL_AND_CASINO",
  RADISSON_BLU = "RADISSON_BLU",
  PRINCESS_HOTELS_INTERNATIONAL = "PRINCESS_HOTELS_INTERNATIONAL",
  HUNGAR_HOTELS = "HUNGAR_HOTELS",
  SOKOS_HOTEL = "SOKOS_HOTEL",
  DORAL_HOTELS = "DORAL_HOTELS",
  HELMSLEY_HOTELS = "HELMSLEY_HOTELS",
  DORAL_GOLF_RESORT = "DORAL_GOLF_RESORT",
  FAIRMONT_HOTELS_CORPORATION = "FAIRMONT_HOTELS_CORPORATION",
  SONESTA_INTERNATIONAL_HOTELS = "SONESTA_INTERNATIONAL_HOTELS",
  OMNI_INTERNATIONAL = "OMNI_INTERNATIONAL",
  CUNARD_HOTELS = "CUNARD_HOTELS",
  ARIZONA_BILTMORE = "ARIZONA_BILTMORE",
  HOSPITALITY_INNS = "HOSPITALITY_INNS",
  WYNN_LAS_VEGAS = "WYNN_LAS_VEGAS",
  RIVERSIDE_RESORT_AND_CASINO = "RIVERSIDE_RESORT_AND_CASINO",
  REGENT_HOTELS = "REGENT_HOTELS",
  PANNONIA_HOTELS = "PANNONIA_HOTELS",
  SADDLEBROOK_RESORT_TAMPA = "SADDLEBROOK_RESORT_TAMPA",
  TRADEWINDS_RESORT = "TRADEWINDS_RESORT",
  HUDSON_HOTEL = "HUDSON_HOTEL",
  NOAHS_HOTEL_MELBOURNE = "NOAHS_HOTEL_MELBOURNE",
  HILTON_GARDEN_INN = "HILTON_GARDEN_INN",
  JURYS_DOYLE_HOTEL_GROUP = "JURYS_DOYLE_HOTEL_GROUP",
  JEFFERSON_HOTEL = "JEFFERSON_HOTEL",
  FONTAINEBLEAU_RESORT = "FONTAINEBLEAU_RESORT",
  GAYLORD_OPRYLAND = "GAYLORD_OPRYLAND",
  GAYLORD_PALMS = "GAYLORD_PALMS",
  GAYLORD_TEXAN = "GAYLORD_TEXAN",
  C_MON_INN = "C_MON_INN",
  MOEVENPICK = "MOEVENPICK",
  MICROTEL_INN_AND_SUITES = "MICROTEL_INN_AND_SUITES",
  AMERICINN = "AMERICINN",
  TRAVELODGE_MOTELS = "TRAVELODGE_MOTELS",
  HERMITAGE_HOTELS = "HERMITAGE_HOTELS",
  AMERICAS_BEST_VALUE_INN = "AMERICAS_BEST_VALUE_INN",
  GREAT_WOLF = "GREAT_WOLF",
  ALOFT = "ALOFT",
  BINIONS_HORSESHOE_CLUB = "BINIONS_HORSESHOE_CLUB",
  EXTENDED_STAY = "EXTENDED_STAY",
  MERLIN_HOTEL_PERTH = "MERLIN_HOTEL_PERTH",
  DORINT_HOTELS = "DORINT_HOTELS",
  LADY_LUCK_HOTEL_AND_CASINO = "LADY_LUCK_HOTEL_AND_CASINO",
  HOTEL_UNIVERSAL = "HOTEL_UNIVERSAL",
  STUDIO_PLUS = "STUDIO_PLUS",
  EXTENDED_STAY_AMERICA = "EXTENDED_STAY_AMERICA",
  EXCALIBUR_HOTEL_AND_CASINO = "EXCALIBUR_HOTEL_AND_CASINO",
  DAN_HOTELS = "DAN_HOTELS",
  EXTENDED_STAY_DELUXE = "EXTENDED_STAY_DELUXE",
  SLEEP_INN = "SLEEP_INN",
  THE_PHOENICIAN = "THE_PHOENICIAN",
  RANK_HOTELS = "RANK_HOTELS",
  SWISSOTEL = "SWISSOTEL",
  RESO_HOTELS = "RESO_HOTELS",
  SAROVA_HOTELS = "SAROVA_HOTELS",
  RAMADA_INNS = "RAMADA_INNS",
  HOWARD_JOHNSON = "HOWARD_JOHNSON",
  MOUNT_CHARLOTTE_HOTELS = "MOUNT_CHARLOTTE_HOTELS",
  HYATT_HOTELS_INTERNATIONAL = "HYATT_HOTELS_INTERNATIONAL",
  SOFITEL_HOTELS = "SOFITEL_HOTELS",
  NOVOTEL_SIEH_ACCOR = "NOVOTEL_SIEH_ACCOR",
  STEIGENBERGER = "STEIGENBERGER",
  ECONO_TRAVEL_MOTOR_HOTEL = "ECONO_TRAVEL_MOTOR_HOTEL",
  QUEENS_MOAT_HOUSES = "QUEENS_MOAT_HOUSES",
  SWALLOW_HOTELS = "SWALLOW_HOTELS",
  GRUPO_HOTELS_HUSA_SA = "GRUPO_HOTELS_HUSA_SA",
  DE_VERE_HOTELS = "DE_VERE_HOTELS",
  RADISSON = "RADISSON",
  RED_ROOF_INNS = "RED_ROOF_INNS",
  IMPERIAL_LONDON_HOTELS = "IMPERIAL_LONDON_HOTELS",
  EMBASSY_HOTELS = "EMBASSY_HOTELS",
  PENTA_HOTELS = "PENTA_HOTELS",
  LOEWS_HOTELS = "LOEWS_HOTELS",
  SCANDIC_HOTELS = "SCANDIC_HOTELS",
  SARA_HOTELS = "SARA_HOTELS",
  OBEROI_HOTELS = "OBEROI_HOTELS",
  NEW_OTANI_HOTELS = "NEW_OTANI_HOTELS",
  TAJ_HOTELS_INTL = "TAJ_HOTELS_INTL",
  KNIGHTS_INN = "KNIGHTS_INN",
  METROPOLE_HOTELS = "METROPOLE_HOTELS",
  CIRCUS_CIRCUS_HOTEL_AND_CASINO = "CIRCUS_CIRCUS_HOTEL_AND_CASINO",
  HOTELES_EL_PRESIDENTE = "HOTELES_EL_PRESIDENTE",
  FLAG_INNS = "FLAG_INNS",
  HAMPTON_INNS = "HAMPTON_INNS",
  STAKIS_HOTELS = "STAKIS_HOTELS",
  LUXOR_HOTEL_AND_CASINO = "LUXOR_HOTEL_AND_CASINO",
  MARITIM = "MARITIM",
  ELDORADO_HOTEL_AND_CASINO = "ELDORADO_HOTEL_AND_CASINO",
  ARCADE = "ARCADE",
  ARCTIA = "ARCTIA",
  CAMPANILE = "CAMPANILE",
  IBUSZ_HOTELS = "IBUSZ_HOTELS",
  RANTASIPI_HOTELS = "RANTASIPI_HOTELS",
  INTERHOTEL_CEDOK = "INTERHOTEL_CEDOK",
  MONTE_CARLO_HOTEL_AND_CASINO = "MONTE_CARLO_HOTEL_AND_CASINO",
  CLIMAT_DE_FRANCE = "CLIMAT_DE_FRANCE",
  CUMULUS_HOTELS = "CUMULUS_HOTELS",
  SILVER_LEGACY_HOTEL_AND_CASINO = "SILVER_LEGACY_HOTEL_AND_CASINO",
  HOTEIS_OTHAN = "HOTEIS_OTHAN",
  ADAMS_MARK = "ADAMS_MARK",
  SAHARA_HOTEL_AND_CASINO = "SAHARA_HOTEL_AND_CASINO",
  BRADBURY_SUITES = "BRADBURY_SUITES",
  BUDGET_HOST_INNS = "BUDGET_HOST_INNS",
  BUDGETEL = "BUDGETEL",
  SUISSE_CHALET = "SUISSE_CHALET",
  CLARION_HOTEL = "CLARION_HOTEL",
  COMPRI_HOTEL = "COMPRI_HOTEL",
  CONSORT = "CONSORT",
  COURTYARD_BY_MARRIOTT = "COURTYARD_BY_MARRIOTT",
  DILLON_INN = "DILLON_INN",
  DOUBLETREE = "DOUBLETREE",
  DRURY_INN = "DRURY_INN",
  ECONOMY_INNS_OF_AMERICA = "ECONOMY_INNS_OF_AMERICA",
  EMBASSY_SUITES = "EMBASSY_SUITES",
  EXCEL_INN = "EXCEL_INN",
  FAIRFIELD_HOTEL = "FAIRFIELD_HOTEL",
  HARLEY_HOTEL = "HARLEY_HOTEL",
  MIDWAY_MOTOR_LODGE = "MIDWAY_MOTOR_LODGE",
  MOTEL_6 = "MOTEL_6",
  LA_MANSION_DEL_RIO = "LA_MANSION_DEL_RIO",
  REGISTRY_HOTELS = "REGISTRY_HOTELS",
  RESIDENCE_INN = "RESIDENCE_INN",
  ROYCE_HOTEL = "ROYCE_HOTEL",
  SANDMAN_INN = "SANDMAN_INN",
  SHILO_INN = "SHILO_INN",
  SHONEYS_INN = "SHONEYS_INN",
  VIRGIN_RIVER_HOTEL_AND_CASINO = "VIRGIN_RIVER_HOTEL_AND_CASINO",
  SUPER_8_MOTEL = "SUPER_8_MOTEL",
  RITZ_CARLTON = "RITZ_CARLTON",
  FLAG_INNS_AUSTRALIA = "FLAG_INNS_AUSTRALIA",
  BUFFALO_BILLS_HOTEL_AND_CASINO = "BUFFALO_BILLS_HOTEL_AND_CASINO",
  QUALITY_PACIFIC_HOTEL = "QUALITY_PACIFIC_HOTEL",
  FOUR_SEASONS_AUSTRALIA = "FOUR_SEASONS_AUSTRALIA",
  FAIRFIELD_INN = "FAIRFIELD_INN",
  CARLTON_HOTELS = "CARLTON_HOTELS",
  CITY_LODGE_HOTELS = "CITY_LODGE_HOTELS",
  KAROS_HOTELS = "KAROS_HOTELS",
  PROTEA_HOTELS = "PROTEA_HOTELS",
  SOUTHERN_SUN_HOTELS = "SOUTHERN_SUN_HOTELS",
  CONRAD_HOTELS = "CONRAD_HOTELS",
  WYNDHAM = "WYNDHAM",
  RICA_HOTELS = "RICA_HOTELS",
  INTER_NOR_HOTELS = "INTER_NOR_HOTELS",
  SEA_PINES_RESORT = "SEA_PINES_RESORT",
  RIO_SUITES = "RIO_SUITES",
  BROADMOOR_HOTEL = "BROADMOOR_HOTEL",
  BALLYS_HOTEL_AND_CASINO = "BALLYS_HOTEL_AND_CASINO",
  JOHN_ASCUAGAS_NUGGET = "JOHN_ASCUAGAS_NUGGET",
  MGM_GRAND_HOTEL = "MGM_GRAND_HOTEL",
  HARRAHS_HOTELS_AND_CASINOS = "HARRAHS_HOTELS_AND_CASINOS",
  OPRYLAND_HOTEL = "OPRYLAND_HOTEL",
  BOCA_RATON_RESORT = "BOCA_RATON_RESORT",
  HARVEY_BRISTOL_HOTELS = "HARVEY_BRISTOL_HOTELS",
  COLORADO_BELLE_EDGEWATER_RESORT = "COLORADO_BELLE_EDGEWATER_RESORT",
  RIVIERA_HOTEL_AND_CASINO = "RIVIERA_HOTEL_AND_CASINO",
  TROPICANA_RESORT_AND_CASINO = "TROPICANA_RESORT_AND_CASINO",
  WOODSIDE_HOTELS_AND_RESORTS = "WOODSIDE_HOTELS_AND_RESORTS",
  TOWNEPLACE_SUITES = "TOWNEPLACE_SUITES",
  MILLENNIUM_BROADWAY_HOTEL = "MILLENNIUM_BROADWAY_HOTEL",
  CLUB_MED = "CLUB_MED",
  BILTMORE_HOTEL_AND_SUITES = "BILTMORE_HOTEL_AND_SUITES",
  CAREFREE_RESORTS = "CAREFREE_RESORTS",
  ST_REGIS_HOTEL = "ST_REGIS_HOTEL",
  THE_ELIOT_HOTEL = "THE_ELIOT_HOTEL",
  CLUB_CORPORATION_CLUB_RESORTS = "CLUB_CORPORATION_CLUB_RESORTS",
  WELLESLEY_INNS = "WELLESLEY_INNS",
  BEVERLY_HILLS_HOTEL = "BEVERLY_HILLS_HOTEL",
  CROWNE_PLAZA_HOTELS = "CROWNE_PLAZA_HOTELS",
  HOMEWOOD_SUITES = "HOMEWOOD_SUITES",
  PEABODY_HOTELS = "PEABODY_HOTELS",
  GREENBRIAR_RESORTS = "GREENBRIAR_RESORTS",
  AMELIA_ISLAND_PLANTATION = "AMELIA_ISLAND_PLANTATION",
  HOMESTEAD = "HOMESTEAD",
  CANYON_RANCH = "CANYON_RANCH",
  KAHALA_MANDARIN_ORIENTAL_HOTEL = "KAHALA_MANDARIN_ORIENTAL_HOTEL",
  ORCHID_AT_MAUNA_LAI = "ORCHID_AT_MAUNA_LAI",
  HALEKULANI_HOTEL_WAIKIKI_PARC = "HALEKULANI_HOTEL_WAIKIKI_PARC",
  PRIMADONNA_HOTEL_AND_CASINO = "PRIMADONNA_HOTEL_AND_CASINO",
  WHISKEY_PETES_HOTEL_AND_CASINO = "WHISKEY_PETES_HOTEL_AND_CASINO",
  CHATEAU_ELAN_WINERY_AND_RESORT = "CHATEAU_ELAN_WINERY_AND_RESORT",
  BEAU_RIVAGE_HOTEL_AND_CASINO = "BEAU_RIVAGE_HOTEL_AND_CASINO",
  BELLAGIO = "BELLAGIO",
  FREMONT_HOTEL_AND_CASINO = "FREMONT_HOTEL_AND_CASINO",
  MAIN_STREET_STATION_HOTEL_AND_CASINO = "MAIN_STREET_STATION_HOTEL_AND_CASINO",
  SILVER_STAR_HOTEL_AND_CASINO = "SILVER_STAR_HOTEL_AND_CASINO",
  STRATOSPHERE_HOTEL_AND_CASINO = "STRATOSPHERE_HOTEL_AND_CASINO",
  SPRINGHILL_SUITES = "SPRINGHILL_SUITES",
  CAESARS_HOTEL_AND_CASINO = "CAESARS_HOTEL_AND_CASINO",
  NEMACOLIN_WOODLANDS = "NEMACOLIN_WOODLANDS",
  VENETIAN_RESORT_HOTEL_AND_CASINO = "VENETIAN_RESORT_HOTEL_AND_CASINO",
  NEW_YORK_NEW_YORK_HOTEL_AND_CASINO = "NEW_YORK_NEW_YORK_HOTEL_AND_CASINO",
  SANDS_RESORT = "SANDS_RESORT",
  NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB = "NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB",
  MANDALAY_BAY_RESORT = "MANDALAY_BAY_RESORT",
  FOUR_POINTS_HOTELS = "FOUR_POINTS_HOTELS",
  W_HOTELS = "W_HOTELS",
  DISNEYLAND_RESORTS = "DISNEYLAND_RESORTS",
  PATRICIA_GRAND_RESORT_HOTELS = "PATRICIA_GRAND_RESORT_HOTELS",
  ROSEN_HOTEL_AND_RESORTS = "ROSEN_HOTEL_AND_RESORTS",
  TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER = "TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER",
  FIRST_HOSPITALITY_HOTELS = "FIRST_HOSPITALITY_HOTELS",
  OUTRIGGER_HOTELS_AND_RESORTS = "OUTRIGGER_HOTELS_AND_RESORTS",
  OHANA_HOTELS_OF_HAWAII = "OHANA_HOTELS_OF_HAWAII",
  CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS = "CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS",
  ALA_MOANA_HOTEL = "ALA_MOANA_HOTEL",
  SMUGGLERS_NOTCH_RESORT = "SMUGGLERS_NOTCH_RESORT",
  RAFFLES_HOTELS = "RAFFLES_HOTELS",
  STAYBRIDGE_SUITES = "STAYBRIDGE_SUITES",
  CLARIDGE_CASINO_HOTEL = "CLARIDGE_CASINO_HOTEL",
  THE_FLAMINGO_HOTELS = "THE_FLAMINGO_HOTELS",
  GRAND_CASINO_HOTELS = "GRAND_CASINO_HOTELS",
  PARIS_LAS_VEGAS_HOTEL = "PARIS_LAS_VEGAS_HOTEL",
  PEPPERMILL_HOTEL_CASINO = "PEPPERMILL_HOTEL_CASINO",
  ATLANTIC_CITY_HILTON = "ATLANTIC_CITY_HILTON",
  EMBASSY_VACATION_RESORT = "EMBASSY_VACATION_RESORT",
  HALE_KOA_HOTEL = "HALE_KOA_HOTEL",
  HOMESTEAD_SUITES = "HOMESTEAD_SUITES",
  WILDERNESS_HOTEL_AND_RESORT = "WILDERNESS_HOTEL_AND_RESORT",
  THE_PALACE_HOTEL = "THE_PALACE_HOTEL",
  THE_WIGWAM_GOLF_RESORT_AND_SPA = "THE_WIGWAM_GOLF_RESORT_AND_SPA",
  THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA = "THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA",
  THE_ATLANTIC = "THE_ATLANTIC",
  PRINCEVILLE_RESORT = "PRINCEVILLE_RESORT",
  ELEMENT = "ELEMENT",
  LUXURY_RESORTS = "LUXURY_RESORTS",
  SETTLE_INN = "SETTLE_INN",
  LA_COSTA_RESORT = "LA_COSTA_RESORT",
  PREMIER_TRAVEL_INNS = "PREMIER_TRAVEL_INNS",
  HYATT_PLACE = "HYATT_PLACE",
  HOTEL_INDIGO = "HOTEL_INDIGO",
  THE_ROOSEVELT_HOTEL_NY = "THE_ROOSEVELT_HOTEL_NY",
  NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN = "NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN",
  HOME2SUITES = "HOME2SUITES",
  AFFINIA = "AFFINIA",
  MAINSTAY_SUITES = "MAINSTAY_SUITES",
  OXFORD_SUITES = "OXFORD_SUITES",
  JUMEIRAH_ESSEX_HOUSE = "JUMEIRAH_ESSEX_HOUSE",
  CARIBE_ROYAL = "CARIBE_ROYAL",
  CROSSLAND = "CROSSLAND",
  GRAND_SIERRA_RESORT = "GRAND_SIERRA_RESORT",
  ARIA = "ARIA",
  VDARA = "VDARA",
  AUTOGRAPH = "AUTOGRAPH",
  GALT_HOUSE = "GALT_HOUSE",
  COSMOPOLITAN_OF_LAS_VEGAS = "COSMOPOLITAN_OF_LAS_VEGAS",
  COUNTRY_INN_BY_CARLSON = "COUNTRY_INN_BY_CARLSON",
  PARK_PLAZA_HOTEL = "PARK_PLAZA_HOTEL",
  WALDORF = "WALDORF",
  RIO_HOTELS = "RIO_HOTELS",
  JHAT = "JHAT",
  CEST_LA_VIE_RESORT_IZUMIGO = "CEST_LA_VIE_RESORT_IZUMIGO",
  BANYAN_TREE_HOTELS_AND_RESORTS = "BANYAN_TREE_HOTELS_AND_RESORTS",
  HOTEL_SUNROUTE = "HOTEL_SUNROUTE",
  SOTETSU_FRESA_INN = "SOTETSU_FRESA_INN",
  LA_VISTA = "LA_VISTA",
  JR_EAST_HOTEL_METS = "JR_EAST_HOTEL_METS",
  AB_HOTEL = "AB_HOTEL",
  CHISUN_HOTELS = "CHISUN_HOTELS",
  SUPER_HOTEL = "SUPER_HOTEL",
  ITOEN_HOTEL = "ITOEN_HOTEL",
  QUINTESSA_HOTEL = "QUINTESSA_HOTEL",
  SMILE_HOTEL = "SMILE_HOTEL",
  HOTEL_ALPHA_1 = "HOTEL_ALPHA_1",
  RELO_VACATIONS = "RELO_VACATIONS",
  YUTORELO = "YUTORELO",
  KEIO_PRESSO_INN = "KEIO_PRESSO_INN",
  VILLA_FONTAINE = "VILLA_FONTAINE",
  MEITETSU_INN = "MEITETSU_INN",
  TOKYU_HARVESTCLUB = "TOKYU_HARVESTCLUB",
  HOTEL_LIVEMAX = "HOTEL_LIVEMAX",
  FUFU_JAPAN = "FUFU_JAPAN",
  HMI_HOTEL_GROUP = "HMI_HOTEL_GROUP",
  ORIX_HOTELS_AND_RESORTS = "ORIX_HOTELS_AND_RESORTS",
  WASHINGTON_HOTEL = "WASHINGTON_HOTEL",
  SANCO_INN = "SANCO_INN",
  HOTEL_UNIZO = "HOTEL_UNIZO",
  HOTEL_METROPOLITAN = "HOTEL_METROPOLITAN",
  CENTURION_HOTELS = "CENTURION_HOTELS",
  NEST_HOTEL = "NEST_HOTEL",
}


export type HNRewardRedemptionConfigurationConnection = {
  __typename: "HNRewardRedemptionConfigurationConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNRewardRedemptionConfigurationEdge > | null,
};

export type HNRewardRedemptionConfigurationEdge = {
  __typename: "HNRewardRedemptionConfigurationEdge",
  cursor?: string | null,
  node?: HNRewardRedemptionConfiguration | null,
};

export type HNRewardRedemptionConfiguration = {
  __typename: "HNRewardRedemptionConfiguration",
  id: string,
  type?: HNRedemptionConfigurationType | null,
  name?: string | null,
  rewardPointRedemption?: HNRewardRedemptionRate | null,
  attachments?: HNRewardRedemptionConfigurationAttachmentConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNRedemptionConfigurationType {
  STATEMENT_CREDIT = "STATEMENT_CREDIT",
}


export type HNRewardRedemptionRate = {
  __typename: "HNRewardRedemptionRate",
  rate?: string | null,
};

export type HNRewardRedemptionConfigurationAttachmentConnection = {
  __typename: "HNRewardRedemptionConfigurationAttachmentConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNRewardRedemptionConfigurationAttachmentEdge > | null,
};

export type HNRewardRedemptionConfigurationAttachmentEdge = {
  __typename: "HNRewardRedemptionConfigurationAttachmentEdge",
  cursor?: string | null,
  node?: HNRewardRedemptionConfigurationAttachment | null,
};

export type HNRewardRedemptionConfigurationAttachment = {
  __typename: "HNRewardRedemptionConfigurationAttachment",
  id: string,
  redemptionConfiguration?: HNRewardRedemptionConfiguration | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNRewardRedemptionConfigurationProductAttachment = {
  __typename: "HNRewardRedemptionConfigurationProductAttachment",
  id: string,
  redemptionConfiguration?: HNRewardRedemptionConfiguration | null,
  cardProduct?: HNCardProduct | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNInterFinancialAccountTransferRuleConnectionPayload = HNInterFinancialAccountTransferRuleConnection | HNAccessDeniedError


export type HNInterFinancialAccountTransferRuleConnection = {
  __typename: "HNInterFinancialAccountTransferRuleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNInterFinancialAccountTransferRuleEdge > | null,
};

export type HNInterFinancialAccountTransferRuleEdge = {
  __typename: "HNInterFinancialAccountTransferRuleEdge",
  cursor: string,
  node?: HNInterFinancialAccountTransferRule | null,
};

export type HNInterFinancialAccountTransferRule = {
  __typename: "HNInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  version?: string | null,
  revisions?: HNInterFinancialAccountTransferRuleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAmountLimitInterFinancialAccountTransferRule = {
  __typename: "HNAmountLimitInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  maximumAmount?: HNAmount | null,
  version?: string | null,
  interFinancialAccountTransferAccountType?: HNInterFinancialAccountTransferAccountType | null,
  revisions?: HNInterFinancialAccountTransferRuleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNInterFinancialAccountTransferAccountType {
  SOURCE = "SOURCE",
}


export type HNCountLimitInterFinancialAccountTransferRule = {
  __typename: "HNCountLimitInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  maximumCount?: number | null,
  interFinancialAccountTransferAccountType?: HNInterFinancialAccountTransferAccountType | null,
  version?: string | null,
  revisions?: HNInterFinancialAccountTransferRuleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNTransferPurposeInterFinancialAccountTransferRule = {
  __typename: "HNTransferPurposeInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  version?: string | null,
  revisions?: HNInterFinancialAccountTransferRuleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNWatchlistInterFinancialAccountTransferRule = {
  __typename: "HNWatchlistInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  version?: string | null,
  revisions?: HNInterFinancialAccountTransferRuleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAccessDeniedError = {
  __typename: "HNAccessDeniedError",
  message: string,
};

export type HNVelocityInterFinancialAccountTransferRuleConnectionPayload = HNVelocityInterFinancialAccountTransferRuleConnection | HNAccessDeniedError


export type HNVelocityInterFinancialAccountTransferRuleConnection = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNVelocityInterFinancialAccountTransferRuleEdge > | null,
};

export type HNVelocityInterFinancialAccountTransferRuleEdge = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleEdge",
  cursor: string,
  node?: HNVelocityInterFinancialAccountTransferRule | null,
};

export type HNVelocityInterFinancialAccountTransferRule = {
  __typename: "HNVelocityInterFinancialAccountTransferRule",
  id: string,
  name?: string | null,
  velocityRuleWindow?: HNVelocityRuleWindow | null,
  cumulativeInterFinancialAccountTransferRule?: HNCumulativeInterFinancialAccountTransferRule | null,
  conditionalInterFinancialAccountTransferRules?:  Array<HNConditionalInterFinancialAccountTransferRule | null > | null,
  version?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNVelocityRuleWindow {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  NINETY_DAYS = "NINETY_DAYS",
  YEARLY = "YEARLY",
  PER_TRANSACTION = "PER_TRANSACTION",
}


export type HNCumulativeInterFinancialAccountTransferRule = HNAmountLimitInterFinancialAccountTransferRule | HNCountLimitInterFinancialAccountTransferRule


export type HNConditionalInterFinancialAccountTransferRule = HNTransferPurposeInterFinancialAccountTransferRule


export type HNPhysicalPaymentCardOrderConnection = {
  __typename: "HNPhysicalPaymentCardOrderConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPhysicalPaymentCardOrderEdge > | null,
};

export type HNPhysicalPaymentCardOrderEdge = {
  __typename: "HNPhysicalPaymentCardOrderEdge",
  cursor: string,
  node?: HNPhysicalPaymentCardOrder | null,
};

export type HNPhysicalPaymentCardOrder = {
  __typename: "HNPhysicalPaymentCardOrder",
  id: string,
  paymentCardShipment?: HNPaymentCardShipment | null,
  orderState?: HNPaymentCardOrderStateDetail | null,
  cardPersonalization?: HNPaymentCardPersonalization | null,
  stateHistory?:  Array<HNPaymentCardOrderStateDetailHistory | null > | null,
  paymentCard?: HNPaymentCard | null,
  groupOrder?: HNPhysicalCardGroupOrder | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPaymentCardShipment = {
  __typename: "HNPaymentCardShipment",
  courier?: HNPaymentCardShipmentCourier | null,
  requestedShipDate?: string | null,
  deliveryDetails?: HNPaymentCardDeliveryDetails | null,
  senderDetails?: HNPaymentCardDeliveryDetails | null,
};

export type HNPaymentCardShipmentCourier = {
  __typename: "HNPaymentCardShipmentCourier",
  method?: HNPaymentCardShippingMethod | null,
  signatureRequiredOnDelivery?: boolean | null,
  tracking?: HNPaymentCardShipmentTracking | null,
};

export enum HNPaymentCardShippingMethod {
  USPS_GROUND = "USPS_GROUND",
  USPS_PRIORITY = "USPS_PRIORITY",
  USPS_EXPRESS = "USPS_EXPRESS",
  UPS_GROUND = "UPS_GROUND",
  UPS_SECOND_DAY = "UPS_SECOND_DAY",
  UPS_NEXT_DAY = "UPS_NEXT_DAY",
  FEDEX_GROUND = "FEDEX_GROUND",
  FEDEX_2_DAY = "FEDEX_2_DAY",
  FEDEX_PRIORITY_OVERNIGHT = "FEDEX_PRIORITY_OVERNIGHT",
  FEDEX_OVERNIGHT = "FEDEX_OVERNIGHT",
  SAME_DAY_USPS_GROUND = "SAME_DAY_USPS_GROUND",
  SAME_DAY_USPS_PRIORITY = "SAME_DAY_USPS_PRIORITY",
  SAME_DAY_UPS_GROUND = "SAME_DAY_UPS_GROUND",
  SAME_DAY_UPS_SECOND_DAY = "SAME_DAY_UPS_SECOND_DAY",
  SAME_DAY_UPS_NEXT_DAY = "SAME_DAY_UPS_NEXT_DAY",
}


export type HNPaymentCardShipmentTracking = {
  __typename: "HNPaymentCardShipmentTracking",
  trackingNumber?: string | null,
  actualShipDateLocal?: string | null,
};

export type HNPaymentCardDeliveryDetails = {
  __typename: "HNPaymentCardDeliveryDetails",
  name?: HNName | null,
  companyName?: string | null,
  address?: HNAddress | null,
  validatedAddress?: HNValidatedAddress | null,
};

export type HNValidatedAddress = {
  __typename: "HNValidatedAddress",
  id: string,
  provided?: HNAddress | null,
  standardized?: HNAddress | null,
  labels?: Array< HNValidatedAddressLabel > | null,
  createdAt?: string | null,
};

export type HNValidAddress = {
  __typename: "HNValidAddress",
  id: string,
  provided?: HNAddress | null,
  standardized?: HNAddress | null,
  labels?: Array< HNValidatedAddressLabel > | null,
  createdAt?: string | null,
};

export type HNValidatedAddressToken = {
  __typename: "HNValidatedAddressToken",
  id: string,
  provided?: HNAddress | null,
  standardized?: HNAddress | null,
  labels?: Array< HNValidatedAddressLabel > | null,
  createdAt?: string | null,
};

export enum HNValidatedAddressLabel {
  PO_BOX = "PO_BOX",
  BUSINESS = "BUSINESS",
  RESIDENTIAL = "RESIDENTIAL",
  CMRA = "CMRA",
  VACANT = "VACANT",
  INACTIVE = "INACTIVE",
  UNSECURED_LOCATION = "UNSECURED_LOCATION",
  UNCONFIRMED_EXTENDED_ADDRESS = "UNCONFIRMED_EXTENDED_ADDRESS",
}


export type HNPaymentCardOrderStateDetail = {
  __typename: "HNPaymentCardOrderStateDetail",
  status?: HNPaymentCardOrderStatus | null,
};

export enum HNPaymentCardOrderStatus {
  NEW = "NEW",
  SENT_TO_PRINTER = "SENT_TO_PRINTER",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  SHIPPED = "SHIPPED",
  SHIP_FAILED = "SHIP_FAILED",
}


export type HNPaymentCardPersonalization = {
  __typename: "HNPaymentCardPersonalization",
  textLines: HNPaymentCardPersonalizationTextLines,
};

export type HNPaymentCardPersonalizationTextLines = {
  __typename: "HNPaymentCardPersonalizationTextLines",
  line1: string,
  line2?: string | null,
};

export type HNPaymentCardOrderStateDetailHistory = {
  __typename: "HNPaymentCardOrderStateDetailHistory",
  previousStatus?: HNPaymentCardOrderStatus | null,
  newStatus?: HNPaymentCardOrderStatus | null,
  createdAt?: string | null,
};

export type HNPhysicalCardGroupOrder = {
  __typename: "HNPhysicalCardGroupOrder",
  id: string,
  cardProductId?: string | null,
  cardCount?: number | null,
  paymentCardShipment?: HNPaymentCardShipment | null,
  orderState?: HNPaymentCardGroupOrderStateDetail | null,
  stateHistory?:  Array<HNPaymentCardGroupOrderStateDetailHistory | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  physicalPaymentCardOrders?: HNPhysicalPaymentCardOrderConnection | null,
};

export type HNPaymentCardGroupOrderStateDetail = {
  __typename: "HNPaymentCardGroupOrderStateDetail",
  status?: HNPaymentCardGroupOrderStatus | null,
};

export enum HNPaymentCardGroupOrderStatus {
  NEW = "NEW",
  PENDING = "PENDING",
  SENT_TO_PRINTER = "SENT_TO_PRINTER",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  SHIPPED = "SHIPPED",
  SHIP_FAILED = "SHIP_FAILED",
}


export type HNPaymentCardGroupOrderStateDetailHistory = {
  __typename: "HNPaymentCardGroupOrderStateDetailHistory",
  previousStatus?: HNPaymentCardGroupOrderStatus | null,
  newStatus?: HNPaymentCardGroupOrderStatus | null,
  createdAt?: string | null,
};

export type HNPhysicalCardGroupOrderConnection = {
  __typename: "HNPhysicalCardGroupOrderConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPhysicalCardGroupOrderEdge > | null,
};

export type HNPhysicalCardGroupOrderEdge = {
  __typename: "HNPhysicalCardGroupOrderEdge",
  cursor: string,
  node?: HNPhysicalCardGroupOrder | null,
};

export type HNWebhookNotificationTargetConnection = {
  __typename: "HNWebhookNotificationTargetConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNWebhookNotificationTargetEdge > | null,
};

export type HNWebhookNotificationTargetEdge = {
  __typename: "HNWebhookNotificationTargetEdge",
  cursor: string,
  node?: HNWebhookNotificationTarget | null,
};

export type HNWebhookNotificationTarget = {
  __typename: "HNWebhookNotificationTarget",
  id: string,
  name?: string | null,
  uri?: string | null,
  email?: string | null,
  subscriptions?: Array< HNNotificationEventName > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  deactivatedAt?: string | null,
  signingKeys?:  Array<HNSigningKey > | null,
  status: HNNotificationTargetStatus,
  deliveryAttempts?: HNDeliveryAttemptConnection | null,
  statusHistory?: HNNotificationTargetStatusHistoryConnection | null,
  webhookNotificationTargetEvents?: HNWebhookNotificationTargetEventConnection | null,
};

export enum HNNotificationEventName {
  AUTHORIZATION_CREATED = "AUTHORIZATION_CREATED",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED",
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED",
  CARD_PRODUCT_APPLICATION_APPROVED = "CARD_PRODUCT_APPLICATION_APPROVED",
  CARD_PRODUCT_APPLICATION_CLOSED = "CARD_PRODUCT_APPLICATION_CLOSED",
  CARD_PRODUCT_APPLICATION_DENIED = "CARD_PRODUCT_APPLICATION_DENIED",
  CARD_PRODUCT_APPLICATION_MANUAL_REVIEW = "CARD_PRODUCT_APPLICATION_MANUAL_REVIEW",
  CARD_PRODUCT_APPLICATION_IN_REVIEW = "CARD_PRODUCT_APPLICATION_IN_REVIEW",
  CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED = "CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED",
  CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT",
  CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE",
  CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED = "CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED",
  CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED = "CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED",
  NOTIFICATION_ACTIVATION = "NOTIFICATION_ACTIVATION",
  ACH_SECURE_DEPOSIT_INITIATED = "ACH_SECURE_DEPOSIT_INITIATED",
  ACH_SECURE_DEPOSIT_PROCESSING = "ACH_SECURE_DEPOSIT_PROCESSING",
  ACH_SECURE_DEPOSIT_PROCESSED = "ACH_SECURE_DEPOSIT_PROCESSED",
  ACH_SECURE_DEPOSIT_FAILED = "ACH_SECURE_DEPOSIT_FAILED",
  ACH_SECURE_DEPOSIT_RETURNED = "ACH_SECURE_DEPOSIT_RETURNED",
  ACH_SECURE_DEPOSIT_CANCELED = "ACH_SECURE_DEPOSIT_CANCELED",
  ACH_FUNDS_WITHDRAWAL_INITIATED = "ACH_FUNDS_WITHDRAWAL_INITIATED",
  ACH_FUNDS_WITHDRAWAL_PROCESSING = "ACH_FUNDS_WITHDRAWAL_PROCESSING",
  ACH_FUNDS_WITHDRAWAL_PROCESSED = "ACH_FUNDS_WITHDRAWAL_PROCESSED",
  ACH_FUNDS_WITHDRAWAL_FAILED = "ACH_FUNDS_WITHDRAWAL_FAILED",
  ACH_FUNDS_WITHDRAWAL_RETURNED = "ACH_FUNDS_WITHDRAWAL_RETURNED",
  ACH_FUNDS_WITHDRAWAL_CANCELED = "ACH_FUNDS_WITHDRAWAL_CANCELED",
  ACH_FUNDS_DEPOSIT_INITIATED = "ACH_FUNDS_DEPOSIT_INITIATED",
  ACH_FUNDS_DEPOSIT_PROCESSING = "ACH_FUNDS_DEPOSIT_PROCESSING",
  ACH_FUNDS_DEPOSIT_PROCESSED = "ACH_FUNDS_DEPOSIT_PROCESSED",
  ACH_FUNDS_DEPOSIT_FAILED = "ACH_FUNDS_DEPOSIT_FAILED",
  ACH_FUNDS_DEPOSIT_RETURNED = "ACH_FUNDS_DEPOSIT_RETURNED",
  ACH_FUNDS_DEPOSIT_CANCELED = "ACH_FUNDS_DEPOSIT_CANCELED",
  ACH_REPAYMENT_PROCESSING = "ACH_REPAYMENT_PROCESSING",
  ACH_REPAYMENT_PROCESSED = "ACH_REPAYMENT_PROCESSED",
  ACH_REPAYMENT_FAILED = "ACH_REPAYMENT_FAILED",
  ACH_REPAYMENT_RETURNED = "ACH_REPAYMENT_RETURNED",
  ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED",
  ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED",
  ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED",
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED",
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED",
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED",
  PAYMENT_CARD_AUTHORIZATION_CREATED = "PAYMENT_CARD_AUTHORIZATION_CREATED",
  PAYMENT_CARD_AUTHORIZATION_APPROVED = "PAYMENT_CARD_AUTHORIZATION_APPROVED",
  PAYMENT_CARD_AUTHORIZATION_DECLINED = "PAYMENT_CARD_AUTHORIZATION_DECLINED",
  PAYMENT_CARD_AUTHORIZATION_REVERSED = "PAYMENT_CARD_AUTHORIZATION_REVERSED",
  PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED",
  PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED",
  PAYMENT_CARD_CLEARED = "PAYMENT_CARD_CLEARED",
  PAYMENT_CARD_ADJUSTMENT = "PAYMENT_CARD_ADJUSTMENT",
  PAYMENT_CARD_ENHANCED_DATA_RECEIVED = "PAYMENT_CARD_ENHANCED_DATA_RECEIVED",
  PAYMENT_CARD_VERIFICATION_APPROVED = "PAYMENT_CARD_VERIFICATION_APPROVED",
  PAYMENT_CARD_VERIFICATION_DECLINED = "PAYMENT_CARD_VERIFICATION_DECLINED",
  PAYMENT_CARD_ACTIVATED = "PAYMENT_CARD_ACTIVATED",
  PAYMENT_CARD_SUSPENDED = "PAYMENT_CARD_SUSPENDED",
  PAYMENT_CARD_UNSUSPENDED = "PAYMENT_CARD_UNSUSPENDED",
  PAYMENT_CARD_CLOSED = "PAYMENT_CARD_CLOSED",
  PHYSICAL_PAYMENT_CARD_SHIPPED = "PHYSICAL_PAYMENT_CARD_SHIPPED",
  PHYSICAL_PAYMENT_CARD_SHIP_FAILED = "PHYSICAL_PAYMENT_CARD_SHIP_FAILED",
  FINANCIAL_ACCOUNT_STATEMENT_READY = "FINANCIAL_ACCOUNT_STATEMENT_READY",
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING",
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED",
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED",
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING",
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED",
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED",
  PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED",
  PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED",
  PAYROLL_ADVANCE_REPAYMENT_COMPLETED = "PAYROLL_ADVANCE_REPAYMENT_COMPLETED",
  PAYROLL_ADVANCE_WRITE_OFF_COMPLETED = "PAYROLL_ADVANCE_WRITE_OFF_COMPLETED",
  ACCOUNT_STATUS_ACTIVE = "ACCOUNT_STATUS_ACTIVE",
  ACCOUNT_STATUS_SUSPENDED = "ACCOUNT_STATUS_SUSPENDED",
  ACCOUNT_STATUS_UNDER_REVIEW = "ACCOUNT_STATUS_UNDER_REVIEW",
  ACCOUNT_STATUS_PENDING_CLOSURE = "ACCOUNT_STATUS_PENDING_CLOSURE",
  ACCOUNT_STATUS_CLOSED = "ACCOUNT_STATUS_CLOSED",
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT",
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT",
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED",
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED",
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION",
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION",
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF",
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF",
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE",
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE",
  EXTERNAL_BANK_ACCOUNT_ADDED = "EXTERNAL_BANK_ACCOUNT_ADDED",
  EXTERNAL_BANK_ACCOUNT_REMOVED = "EXTERNAL_BANK_ACCOUNT_REMOVED",
  CARD_DIGITAL_WALLET_TOKEN_ACTIVATED = "CARD_DIGITAL_WALLET_TOKEN_ACTIVATED",
  CARD_DIGITAL_WALLET_TOKEN_SUSPENDED = "CARD_DIGITAL_WALLET_TOKEN_SUSPENDED",
  CARD_DIGITAL_WALLET_TOKEN_TERMINATED = "CARD_DIGITAL_WALLET_TOKEN_TERMINATED",
  ACH_HOLD_ADDED = "ACH_HOLD_ADDED",
  ACH_HOLD_REMOVED = "ACH_HOLD_REMOVED",
  REPORT_COMPLETED = "REPORT_COMPLETED",
  REPORT_FAILED = "REPORT_FAILED",
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED",
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING",
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED",
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED",
  PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED",
  PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED",
  PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED = "PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED",
  BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED",
  BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED",
  BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED",
  PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED = "PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED",
  BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED",
  BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED",
  BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED",
  ORIGINATED_ACH_TRANSFER_INITIATED = "ORIGINATED_ACH_TRANSFER_INITIATED",
  ORIGINATED_ACH_TRANSFER_PENDING = "ORIGINATED_ACH_TRANSFER_PENDING",
  ORIGINATED_ACH_TRANSFER_PROCESSING = "ORIGINATED_ACH_TRANSFER_PROCESSING",
  ORIGINATED_ACH_TRANSFER_PROCESSED = "ORIGINATED_ACH_TRANSFER_PROCESSED",
  ORIGINATED_ACH_TRANSFER_FAILED = "ORIGINATED_ACH_TRANSFER_FAILED",
  ORIGINATED_ACH_TRANSFER_RETURNED = "ORIGINATED_ACH_TRANSFER_RETURNED",
  ORIGINATED_ACH_TRANSFER_CANCELED = "ORIGINATED_ACH_TRANSFER_CANCELED",
  NON_ORIGINATED_ACH_TRANSFER_RECEIVED = "NON_ORIGINATED_ACH_TRANSFER_RECEIVED",
  NON_ORIGINATED_ACH_TRANSFER_PROCESSED = "NON_ORIGINATED_ACH_TRANSFER_PROCESSED",
  NON_ORIGINATED_ACH_TRANSFER_FAILED = "NON_ORIGINATED_ACH_TRANSFER_FAILED",
  NON_ORIGINATED_ACH_TRANSFER_RETURNED = "NON_ORIGINATED_ACH_TRANSFER_RETURNED",
  CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED = "CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED",
  ACH_TRANSFER_HOLD_ADDED = "ACH_TRANSFER_HOLD_ADDED",
  ACH_TRANSFER_HOLD_REMOVED = "ACH_TRANSFER_HOLD_REMOVED",
  CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED = "CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED",
}


export type HNSigningKey = {
  __typename: "HNSigningKey",
  id: string,
  secret?: string | null,
  createdAt?: string | null,
  expiresAt?: string | null,
};

export enum HNNotificationTargetStatus {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  ACTIVATION_FAILED = "ACTIVATION_FAILED",
}


export type HNDeliveryAttemptConnection = {
  __typename: "HNDeliveryAttemptConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNDeliveryAttemptEdge > | null,
};

export type HNDeliveryAttemptEdge = {
  __typename: "HNDeliveryAttemptEdge",
  cursor: string,
  node?: HNDeliveryAttempt | null,
};

export type HNDeliveryAttempt = {
  __typename: "HNDeliveryAttempt",
  id: string,
  uri?: string | null,
  target?: HNWebhookNotificationTarget | null,
  status?: number | null,
  success?: boolean | null,
  response?: HNDeliveryAttemptResponse | null,
  deliveryAttemptStatus?: HNDeliveryAttemptStatus | null,
  createdAt?: string | null,
  event?: HNNotificationEvent | null,
};

export type HNDeliveryAttemptResponse = {
  __typename: "HNDeliveryAttemptResponse",
  httpStatusCode?: number | null,
};

export enum HNDeliveryAttemptStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  SKIPPED = "SKIPPED",
}


export type HNNotificationEvent = {
  __typename: "HNNotificationEvent",
  id: string,
  createdAt?: string | null,
  expiresAt?: string | null,
  name?: HNNotificationEventName | null,
  node?: HNNotificationEventNode | null,
  deliveryAttempts?: HNDeliveryAttemptConnection | null,
};

export type HNNotificationEventNode = HNAuthorizationEvent | HNAccountHolderCardProductApplication | HNAuthorizedUserCardProductApplication | HNNotificationTargetActivationEvent | HNNotificationPingTestEvent | HNSecureDepositInitiatedEvent | HNSecureDepositProcessingEvent | HNSecureDepositProcessedEvent | HNSecureDepositFailedEvent | HNSecureDepositReturnedEvent | HNSecureDepositCanceledEvent | HNFundsWithdrawalInitiatedEvent | HNFundsWithdrawalProcessingEvent | HNFundsWithdrawalProcessedEvent | HNFundsWithdrawalFailedEvent | HNFundsWithdrawalReturnedEvent | HNFundsWithdrawalCanceledEvent | HNFundsDepositInitiatedEvent | HNFundsDepositProcessingEvent | HNFundsDepositProcessedEvent | HNFundsDepositFailedEvent | HNFundsDepositReturnedEvent | HNFundsDepositCanceledEvent | HNRepaymentProcessedEvent | HNRepaymentProcessingEvent | HNRepaymentFailedEvent | HNRepaymentReturnedEvent | HNAchExternallyInitatedDepositReceivedEvent | HNAchExternallyInitatedDepositProcessedEvent | HNAchExternallyInitatedDepositFailedEvent | HNAchExternallyInitiatedWithdrawalReceivedEvent | HNAchExternallyInitiatedWithdrawalProcessedEvent | HNAchExternallyInitiatedWithdrawalFailedEvent | HNPaymentCardAuthorizationApprovedEvent | HNPaymentCardAuthorizationCreatedEvent | HNPaymentCardAuthorizationDeclinedEvent | HNPaymentCardAuthorizationReversedEvent | HNPaymentCardAuthorizationAndClearApprovedEvent | HNPaymentCardAuthorizationAndClearDeclinedEvent | HNPaymentCardClearedEvent | HNPaymentCardAdjustmentEvent | HNPaymentCardEnhancedDataEvent | HNPaymentCardVerificationApprovedEvent | HNPaymentCardVerificationDeclinedEvent | HNPaymentCardActivatedEvent | HNPaymentCardSuspendedEvent | HNPaymentCardUnsuspendedEvent | HNPaymentCardClosedEvent | HNPhysicalPaymentCardShippedEvent | HNPhysicalPaymentCardShipFailedEvent | HNFinancialAccountStatementReadyEvent | HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent | HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent | HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent | HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent | HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent | HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent | HNPhysicalPaymentCardGroupOrderShippedEvent | HNPhysicalPaymentCardGroupOrderShipFailedEvent | HNPayrollAdvanceRepaymentCompletedEvent | HNPayrollAdvanceWriteOffCompletedEvent | HNAccountStatusActiveEvent | HNAccountStatusSuspendedEvent | HNAccountStatusUnderReviewEvent | HNAccountStatusPendingClosureEvent | HNAccountStatusClosedEvent | HNFinancialAccount | HNExternalBankAccountAddedEvent | HNExternalBankAccountRemovedEvent | HNCardDigitalWalletTokenActivatedEvent | HNCardDigitalWalletTokenSuspendedEvent | HNCardDigitalWalletTokenTerminatedEvent | HNAchHoldAddedEvent | HNAchHoldRemovedEvent | HNReport | HNInterFinancialAccountTransfer | HNPaymentCardTransactionDispute | HNPaymentCardTransactionChargeback | HNPersonAccountHolderIdentityUpdatedEvent | HNBusinessAccountHolderIdentityUpdatedEvent | HNBusinessAuthorizedPersonIdentityUpdatedEvent | HNBusinessUltimateBeneficialOwnerIdentityUpdatedEvent | HNPersonAccountHolderIdentityDocumentsRequestedEvent | HNBusinessAccountHolderIdentityDocumentsRequestedEvent | HNBusinessAuthorizedPersonIdentityDocumentsRequestedEvent | HNBusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent | HNOriginatedAchTransferInitiatedEvent | HNOriginatedAchTransferPendingEvent | HNOriginatedAchTransferProcessingEvent | HNOriginatedAchTransferProcessedEvent | HNOriginatedAchTransferCanceledEvent | HNOriginatedAchTransferFailedEvent | HNOriginatedAchTransferReturnedEvent | HNNonOriginatedAchTransferReceivedEvent | HNNonOriginatedAchTransferProcessedEvent | HNNonOriginatedAchTransferFailedEvent | HNNonOriginatedAchTransferReturnedEvent | HNCreditLimitChangeRequestStatusChangedEvent | HNAchTransferHoldAddedEvent | HNAchTransferHoldRemovedEvent


export type HNAuthorizationEvent = {
  __typename: "HNAuthorizationEvent",
  id: string,
  transactionId?: string | null,
  transaction?: HNTransaction | null,
  responseCode?: HNTransactionEventResponseCode | null,
  avsResponseCode?: HNAVSResponseCode | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  collaborativeAuthorizationDetails?: HNCollaborativeAuthorizationDetails | null,
  authorizationExpiration?: string | null,
  spendRuleResults?: HNSpendRuleResultConnection | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  additionalTransactionData?:  Array<HNAdditionalTransactionData > | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export enum HNAVSResponseCode {
  NOT_PERFORMED = "NOT_PERFORMED",
  NOT_PROVIDED = "NOT_PROVIDED",
  NO_MATCH = "NO_MATCH",
  MATCH = "MATCH",
}


export enum HNPostalCodeResponseCode {
  NOT_PERFORMED = "NOT_PERFORMED",
  NOT_PROVIDED = "NOT_PROVIDED",
  NO_MATCH = "NO_MATCH",
  MATCH = "MATCH",
  ZIP5_MATCH = "ZIP5_MATCH",
  ZIP9_MATCH = "ZIP9_MATCH",
}


export enum HNCVVResponseCode {
  NOT_PERFORMED = "NOT_PERFORMED",
  NO_MATCH = "NO_MATCH",
  MATCH = "MATCH",
  NOT_ON_CARD = "NOT_ON_CARD",
  NOT_PROVIDED = "NOT_PROVIDED",
}


export type HNMerchantDetails = {
  __typename: "HNMerchantDetails",
  merchantId?: string | null,
  category?: HNMerchantCategory | null,
  categoryCode?: string | null,
  countryCodeAlpha3?: HNISO3166Alpha3Country | null,
  description?: string | null,
  name?: string | null,
  address?: HNAddress | null,
};

export enum HNISO3166Alpha3Country {
  AFG = "AFG",
  ALA = "ALA",
  ALB = "ALB",
  DZA = "DZA",
  ASM = "ASM",
  AND = "AND",
  AGO = "AGO",
  AIA = "AIA",
  ATA = "ATA",
  ATG = "ATG",
  ARG = "ARG",
  ARM = "ARM",
  ABW = "ABW",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BHS = "BHS",
  BHR = "BHR",
  BGD = "BGD",
  BRB = "BRB",
  BLR = "BLR",
  BEL = "BEL",
  BLZ = "BLZ",
  BEN = "BEN",
  BMU = "BMU",
  BTN = "BTN",
  BOL = "BOL",
  BES = "BES",
  BIH = "BIH",
  BWA = "BWA",
  BVT = "BVT",
  BRA = "BRA",
  IOT = "IOT",
  BRN = "BRN",
  BGR = "BGR",
  BFA = "BFA",
  BDI = "BDI",
  CPV = "CPV",
  KHM = "KHM",
  CMR = "CMR",
  CAN = "CAN",
  CYM = "CYM",
  CAF = "CAF",
  TCD = "TCD",
  CHL = "CHL",
  CHN = "CHN",
  CXR = "CXR",
  CCK = "CCK",
  COL = "COL",
  COM = "COM",
  COG = "COG",
  COD = "COD",
  COK = "COK",
  CRI = "CRI",
  CIV = "CIV",
  HRV = "HRV",
  CUB = "CUB",
  CUW = "CUW",
  CYP = "CYP",
  CZE = "CZE",
  DNK = "DNK",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  ECU = "ECU",
  EGY = "EGY",
  SLV = "SLV",
  GNQ = "GNQ",
  ERI = "ERI",
  EST = "EST",
  SWZ = "SWZ",
  ETH = "ETH",
  FLK = "FLK",
  FRO = "FRO",
  FJI = "FJI",
  FIN = "FIN",
  FRA = "FRA",
  GUF = "GUF",
  PYF = "PYF",
  ATF = "ATF",
  GAB = "GAB",
  GMB = "GMB",
  GEO = "GEO",
  DEU = "DEU",
  GHA = "GHA",
  GIB = "GIB",
  GRC = "GRC",
  GRL = "GRL",
  GRD = "GRD",
  GLP = "GLP",
  GUM = "GUM",
  GTM = "GTM",
  GGY = "GGY",
  GIN = "GIN",
  GNB = "GNB",
  GUY = "GUY",
  HTI = "HTI",
  HMD = "HMD",
  VAT = "VAT",
  HND = "HND",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  IDN = "IDN",
  IRN = "IRN",
  IRQ = "IRQ",
  IRL = "IRL",
  IMN = "IMN",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JEY = "JEY",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  PRK = "PRK",
  KOR = "KOR",
  QZZ = "QZZ",
  KWT = "KWT",
  KGZ = "KGZ",
  LAO = "LAO",
  LVA = "LVA",
  LBN = "LBN",
  LSO = "LSO",
  LBR = "LBR",
  LBY = "LBY",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAC = "MAC",
  MDG = "MDG",
  MWI = "MWI",
  MYS = "MYS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTQ = "MTQ",
  MRT = "MRT",
  MUS = "MUS",
  MYT = "MYT",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MCO = "MCO",
  MNG = "MNG",
  MNE = "MNE",
  MSR = "MSR",
  MAR = "MAR",
  MOZ = "MOZ",
  MMR = "MMR",
  NAM = "NAM",
  NRU = "NRU",
  NPL = "NPL",
  NLD = "NLD",
  NCL = "NCL",
  NZL = "NZL",
  NIC = "NIC",
  NER = "NER",
  NGA = "NGA",
  NIU = "NIU",
  NFK = "NFK",
  MKD = "MKD",
  MNP = "MNP",
  NOR = "NOR",
  OMN = "OMN",
  PAK = "PAK",
  PLW = "PLW",
  PSE = "PSE",
  PAN = "PAN",
  PNG = "PNG",
  PRY = "PRY",
  PER = "PER",
  PHL = "PHL",
  PCN = "PCN",
  POL = "POL",
  PRT = "PRT",
  PRI = "PRI",
  QAT = "QAT",
  REU = "REU",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  BLM = "BLM",
  SHN = "SHN",
  KNA = "KNA",
  LCA = "LCA",
  MAF = "MAF",
  SPM = "SPM",
  VCT = "VCT",
  WSM = "WSM",
  SMR = "SMR",
  STP = "STP",
  SAU = "SAU",
  SEN = "SEN",
  SRB = "SRB",
  SYC = "SYC",
  SLE = "SLE",
  SGP = "SGP",
  SXM = "SXM",
  SVK = "SVK",
  SVN = "SVN",
  SLB = "SLB",
  SOM = "SOM",
  ZAF = "ZAF",
  SGS = "SGS",
  SSD = "SSD",
  ESP = "ESP",
  LKA = "LKA",
  SDN = "SDN",
  SUR = "SUR",
  SJM = "SJM",
  SWE = "SWE",
  CHE = "CHE",
  SYR = "SYR",
  TWN = "TWN",
  TJK = "TJK",
  TZA = "TZA",
  THA = "THA",
  TLS = "TLS",
  TGO = "TGO",
  TKL = "TKL",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TCA = "TCA",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  ARE = "ARE",
  GBR = "GBR",
  USA = "USA",
  UMI = "UMI",
  URY = "URY",
  UZB = "UZB",
  VUT = "VUT",
  VEN = "VEN",
  VNM = "VNM",
  VGB = "VGB",
  VIR = "VIR",
  WLF = "WLF",
  ESH = "ESH",
  YEM = "YEM",
  ZMB = "ZMB",
  ZWE = "ZWE",
}


export type HNCollaborativeAuthorizationDetails = {
  __typename: "HNCollaborativeAuthorizationDetails",
  responseCode?: HNCollaborativeAuthorizationResponseCode | null,
  authorizedAmount?: HNAmount | null,
  currentProductStandIn?: HNCollaborativeAuthorizationStandIn | null,
};

export enum HNCollaborativeAuthorizationResponseCode {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  PARTIAL_AMOUNT_APPROVED = "PARTIAL_AMOUNT_APPROVED",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  EXCEEDS_LIMIT = "EXCEEDS_LIMIT",
  EXCEEDS_FREQUENCY = "EXCEEDS_FREQUENCY",
  INVALID_MERCHANT = "INVALID_MERCHANT",
  RESTRICTED_CARD = "RESTRICTED_CARD",
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  CASHBACK_LIMIT_EXCEEDED = "CASHBACK_LIMIT_EXCEEDED",
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  CARD_NOT_PRESENT_AT_POS = "CARD_NOT_PRESENT_AT_POS",
  MANUAL_KEY_ENTERED_AT_POS = "MANUAL_KEY_ENTERED_AT_POS",
  BLOCKED_CARD = "BLOCKED_CARD",
  INVALID_DRIVER = "INVALID_DRIVER",
  INVALID_VEHICLE = "INVALID_VEHICLE",
  INVALID_ID = "INVALID_ID",
  INVALID_LOCATION = "INVALID_LOCATION",
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  INVALID_PURCHASE_TIME = "INVALID_PURCHASE_TIME",
  INVALID_MERCHANT_CATEGORY_CODE = "INVALID_MERCHANT_CATEGORY_CODE",
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
  PROHIBITED_SELFPAY = "PROHIBITED_SELFPAY",
  RESTRICTED_MERCHANT = "RESTRICTED_MERCHANT",
  RESTRICTED_MERCHANT_CATEGORY_CODE = "RESTRICTED_MERCHANT_CATEGORY_CODE",
  TIMEOUT = "TIMEOUT",
  ERROR = "ERROR",
}


export enum HNCollaborativeAuthorizationStandIn {
  APPROVE = "APPROVE",
  DECLINE = "DECLINE",
}


export type HNSpendRuleResultConnection = {
  __typename: "HNSpendRuleResultConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNSpendRuleResultEdge > | null,
};

export type HNSpendRuleResultEdge = {
  __typename: "HNSpendRuleResultEdge",
  cursor: string,
  node?: HNSpendRuleResult | null,
};

export type HNSpendRuleResult = {
  __typename: "HNSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNMerchantCategorySpendRuleResult = {
  __typename: "HNMerchantCategorySpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNMerchantCategory > | null,
  spendRule?: HNMerchantCategorySpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNSpendRuleRecommendation {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
  NONE = "NONE",
}


export enum HNAttachedLevel {
  UNSPECIFIED = "UNSPECIFIED",
  PLATFORM = "PLATFORM",
  PRODUCT = "PRODUCT",
  CARD = "CARD",
  ACCOUNT = "ACCOUNT",
}


export type HNMerchantCountrySpendRuleResult = {
  __typename: "HNMerchantCountrySpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNISO3166Alpha3Country > | null,
  spendRule?: HNMerchantCountrySpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNMerchantIdentifierSpendRuleResult = {
  __typename: "HNMerchantIdentifierSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< string > | null,
  spendRule?: HNMerchantIdentifierSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNCVVSpendRuleResult = {
  __typename: "HNCVVSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNCVVResponseCode > | null,
  spendRule?: HNCVVSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNStreetAddressSpendRuleResult = {
  __typename: "HNStreetAddressSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNAVSResponseCode > | null,
  spendRule?: HNStreetAddressSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNAmountLimitSpendRuleResult = {
  __typename: "HNAmountLimitSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?:  Array<HNAmount > | null,
  spendRule?: HNAmountLimitSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNPointOfServiceCategorySpendRuleResult = {
  __typename: "HNPointOfServiceCategorySpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNPointOfServiceCategory > | null,
  spendRule?: HNPointOfServiceCategorySpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNPointOfServiceCategory {
  ADMINISTRATIVE_TERMINAL = "ADMINISTRATIVE_TERMINAL",
  POS_TERMINAL = "POS_TERMINAL",
  HOME_TERMINAL = "HOME_TERMINAL",
  ELECTRONIC_CASH_REGISTER = "ELECTRONIC_CASH_REGISTER",
  DIAL_TERMINAL = "DIAL_TERMINAL",
  TRAVELERS_CHECK_MACHINE = "TRAVELERS_CHECK_MACHINE",
  SCRIP_MACHINE = "SCRIP_MACHINE",
  COUPON_MACHINE = "COUPON_MACHINE",
  TICKET_MACHINE = "TICKET_MACHINE",
  PERSONAL_BANKING = "PERSONAL_BANKING",
  PUBLIC_UTILITY = "PUBLIC_UTILITY",
  SELF_SERVICE = "SELF_SERVICE",
  AUTHORIZATION = "AUTHORIZATION",
  PAYMENT = "PAYMENT",
  VRU = "VRU",
  SMART_PHONE = "SMART_PHONE",
  INTERACTIVE_TELEVISION = "INTERACTIVE_TELEVISION",
  PERSONAL_DIGITAL_ASSISTANCE = "PERSONAL_DIGITAL_ASSISTANCE",
  SCREEN_PHONE = "SCREEN_PHONE",
  UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION = "UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION",
  UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED = "UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED",
  UNATTENDED_CUSTOMER_TERMINAL = "UNATTENDED_CUSTOMER_TERMINAL",
  TELEPHONE_DEVICE = "TELEPHONE_DEVICE",
  MPOS = "MPOS",
  AUTOMATED_TELLER_MACHINE = "AUTOMATED_TELLER_MACHINE",
  AUTOMATED_FUEL_DISPENSER = "AUTOMATED_FUEL_DISPENSER",
  POINT_OF_BANKING_TERMINAL = "POINT_OF_BANKING_TERMINAL",
  TELLER = "TELLER",
  FRANCHISE_TELLER = "FRANCHISE_TELLER",
  VENDING = "VENDING",
  ECOMMERCE = "ECOMMERCE",
  MICR_TERMINAL = "MICR_TERMINAL",
  UNATTENDED_CHIP_PIN_TERMINAL = "UNATTENDED_CHIP_PIN_TERMINAL",
}


export type HNDepositAmountLimitSpendRuleResult = {
  __typename: "HNDepositAmountLimitSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?:  Array<HNAmount > | null,
  spendRule?: HNDepositAmountLimitSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNDepositProcessingNetworkSpendRuleResult = {
  __typename: "HNDepositProcessingNetworkSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNDepositProcessingNetwork > | null,
  spendRule?: HNDepositProcessingNetworkSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNDepositProcessingNetwork {
  UNKNOWN = "UNKNOWN",
  ACCEL = "ACCEL",
  ACCEL_CARD_FREE_CASH = "ACCEL_CARD_FREE_CASH",
  ACCEL_NEBRASKA = "ACCEL_NEBRASKA",
  ACCEL_NO_PIN = "ACCEL_NO_PIN",
  ACCEL_SURCHARGE_FREE = "ACCEL_SURCHARGE_FREE",
  AMERICAN_EXPRESS_ATM = "AMERICAN_EXPRESS_ATM",
  AFFN = "AFFN",
  AFFN_HIGH_TICKET_POS = "AFFN_HIGH_TICKET_POS",
  AFFN_LOW_TICKET_POS = "AFFN_LOW_TICKET_POS",
  AFFN_RECIPROCAL = "AFFN_RECIPROCAL",
  ALLPOINT_NETWORK = "ALLPOINT_NETWORK",
  CIRRUS_ATM = "CIRRUS_ATM",
  CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE = "CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE",
  CREDIT_UNION_COOPERATIVE_ATM = "CREDIT_UNION_COOPERATIVE_ATM",
  CULIANCE = "CULIANCE",
  CULIANCE_CUHERE_PROGRAM = "CULIANCE_CUHERE_PROGRAM",
  CULIANCE_CUHERE_MONEYPASS_RECIPROCAL = "CULIANCE_CUHERE_MONEYPASS_RECIPROCAL",
  CULIANCE_CUHERE_PRESTO_PUBLIX = "CULIANCE_CUHERE_PRESTO_PUBLIX",
  CULIANCE_NYCE_RECIPROCAL = "CULIANCE_NYCE_RECIPROCAL",
  CULIANCE_PINLESS_LOW_VALUE_POS = "CULIANCE_PINLESS_LOW_VALUE_POS",
  EBT_PROGRAMS = "EBT_PROGRAMS",
  INTERLINK = "INTERLINK",
  MAESTRO = "MAESTRO",
  MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE = "MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE",
  MASTERCARD_ATM = "MASTERCARD_ATM",
  MASTERCARD_SINGLE_MESSAGE_SYSTEM = "MASTERCARD_SINGLE_MESSAGE_SYSTEM",
  MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM = "MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM",
  MONEY_PASS = "MONEY_PASS",
  MONEY_PASS_ATM_NEBRASKA = "MONEY_PASS_ATM_NEBRASKA",
  MONEY_PASS_ATM_STAR = "MONEY_PASS_ATM_STAR",
  NYCE = "NYCE",
  NYCE_AFFN_RECIPROCAL = "NYCE_AFFN_RECIPROCAL",
  NYCE_CROSS_BORDER = "NYCE_CROSS_BORDER",
  NYCE_CULIANCE_RECIPROCAL = "NYCE_CULIANCE_RECIPROCAL",
  NYCE_ECOMMERCE = "NYCE_ECOMMERCE",
  NYCE_INTERNATIONAL_RECIPROCAL_GROUP1 = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP1",
  NYCE_INTERNATIONAL_RECIPROCAL_GROUP2 = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP2",
  NYCE_PINLESS_POS = "NYCE_PINLESS_POS",
  NYCE_DIRECT_SETTLEMENT_LINK = "NYCE_DIRECT_SETTLEMENT_LINK",
  PLUS_ATM = "PLUS_ATM",
  PULSE = "PULSE",
  PULSE_ACCEL_RECIPROCAL = "PULSE_ACCEL_RECIPROCAL",
  PULSE_AFFN_RECIPROCAL = "PULSE_AFFN_RECIPROCAL",
  PULSE_CANADA = "PULSE_CANADA",
  PULSE_MEXICO = "PULSE_MEXICO",
  PULSE_PAY_EXPRESS = "PULSE_PAY_EXPRESS",
  PULSE_SELECT = "PULSE_SELECT",
  PULSE_DIRECT_SETTLEMENT_LINK = "PULSE_DIRECT_SETTLEMENT_LINK",
  SHAZAM = "SHAZAM",
  STAR = "STAR",
  STAR_ACCESS = "STAR_ACCESS",
  STAR_BC_CARD_KOREA_RECIPROCAL = "STAR_BC_CARD_KOREA_RECIPROCAL",
  STAR_PUBLIX_PRESTO = "STAR_PUBLIX_PRESTO",
  STAR_RAPIDFLASH = "STAR_RAPIDFLASH",
  STAR_SF = "STAR_SF",
  STAR_DIRECT_SETTLEMENT_LINK = "STAR_DIRECT_SETTLEMENT_LINK",
  VISA_DIRECT_SETTLEMENT_LINK = "VISA_DIRECT_SETTLEMENT_LINK",
  VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK = "VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK",
  VISA = "VISA",
  VISA_DIRECT = "VISA_DIRECT",
  PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE = "PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE",
  NETS = "NETS",
  CU24 = "CU24",
  EBT_POS = "EBT_POS",
  EBT_ATM = "EBT_ATM",
  ALASKA_OPTION = "ALASKA_OPTION",
  DISCOVER_ATM = "DISCOVER_ATM",
}


export type HNPostalCodeVerificationSpendRuleResult = {
  __typename: "HNPostalCodeVerificationSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNPostalCodeResponseCode > | null,
  spendRule?: HNPostalCodeVerificationSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNCardTransactionProcessingTypeConditionSpendRuleResult = {
  __typename: "HNCardTransactionProcessingTypeConditionSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNCardTransactionProcessingType > | null,
  spendRule?: HNCardTransactionProcessingTypeConditionSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNCardTransactionProcessingType {
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  CASH = "CASH",
  ADJUSTMENT_DEBIT = "ADJUSTMENT_DEBIT",
  GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT = "GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT",
  NON_CASH_FINANCIAL_FOR_FUNDING = "NON_CASH_FINANCIAL_FOR_FUNDING",
  QUASI_CASH_AND_SCRIP = "QUASI_CASH_AND_SCRIP",
  FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE = "FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE",
  PAYMENT_TO_ANOTHER_PARTY = "PAYMENT_TO_ANOTHER_PARTY",
  PAYMENT_DEBIT = "PAYMENT_DEBIT",
  RETURNS = "RETURNS",
  DEPOSITS = "DEPOSITS",
  ADJUSTMENT_CREDIT = "ADJUSTMENT_CREDIT",
  PAYMENT_FROM_THIRD_PARTY = "PAYMENT_FROM_THIRD_PARTY",
  PAYMENT_CREDIT = "PAYMENT_CREDIT",
  PAYMENT_ENCLOSED = "PAYMENT_ENCLOSED",
  AVAILABLE_FUNDS_INQUIRY = "AVAILABLE_FUNDS_INQUIRY",
  BALANCE_INQUIRY = "BALANCE_INQUIRY",
  ACCOUNT_VERIFICATION = "ACCOUNT_VERIFICATION",
  CARDHOLDER_ACCOUNTS_TRANSFER = "CARDHOLDER_ACCOUNTS_TRANSFER",
  PIN_UNBLOCK = "PIN_UNBLOCK",
  PIN_CHANGE = "PIN_CHANGE",
  NOTIFICATION_TO_BANK = "NOTIFICATION_TO_BANK",
  LOAD_OF_PREPAID_OR_STORED_VALUE_CARD = "LOAD_OF_PREPAID_OR_STORED_VALUE_CARD",
  FEE_COLLECTION_DEBIT = "FEE_COLLECTION_DEBIT",
  ORIGINAL_CREDIT = "ORIGINAL_CREDIT",
  FUNDS_DISBURSEMENT_CREDIT = "FUNDS_DISBURSEMENT_CREDIT",
  ATM_MINI_STATEMENT = "ATM_MINI_STATEMENT",
  ELIGIBILITY_INQUIRY = "ELIGIBILITY_INQUIRY",
}


export type HNRestrictedAccountHolderSpendRuleResult = {
  __typename: "HNRestrictedAccountHolderSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< string > | null,
  spendRule?: HNRestrictedAccountHolderSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNPanEntryModeSpendRuleResult = {
  __typename: "HNPanEntryModeSpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNPanEntryMode > | null,
  spendRule?: HNPanEntryModeSpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNPanEntryMode {
  MANUAL = "MANUAL",
  MAGNETIC_STRIPE = "MAGNETIC_STRIPE",
  BAR_CODE_OR_QR_CODE = "BAR_CODE_OR_QR_CODE",
  OPTICAL_CHARACTER_READER = "OPTICAL_CHARACTER_READER",
  INTEGRATED_CIRCUIT_CARD = "INTEGRATED_CIRCUIT_CARD",
  MANUAL_KEY_ENTERED = "MANUAL_KEY_ENTERED",
  CONTACTLESS_VIA_CHIP_RULES = "CONTACTLESS_VIA_CHIP_RULES",
  VIA_ELECTRONIC_COMMERCE = "VIA_ELECTRONIC_COMMERCE",
  CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY = "CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY",
  CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE = "CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE",
  CREDENTIALS_ON_FILE = "CREDENTIALS_ON_FILE",
  PAN_AUTO_ENTRY_VIA_SERVER = "PAN_AUTO_ENTRY_VIA_SERVER",
  SECURE_CARD_LESS_ENTRY = "SECURE_CARD_LESS_ENTRY",
  FULL_MAGNETIC_STRIPE_READ = "FULL_MAGNETIC_STRIPE_READ",
  CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES = "CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES",
  ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE = "ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE",
  RESERVED = "RESERVED",
}


export type HNCardDataInputCapabilitySpendRuleResult = {
  __typename: "HNCardDataInputCapabilitySpendRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  valuesTested?: Array< HNCardDataInputCapability > | null,
  spendRule?: HNCardDataInputCapabilitySpendRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNCardDataInputCapability {
  CAPABILITY_UNKNOWN = "CAPABILITY_UNKNOWN",
  MANUAL_NO_TERMINAL = "MANUAL_NO_TERMINAL",
  MAGNETIC_STRIPE = "MAGNETIC_STRIPE",
  BARCODE_OR_QR_CODE = "BARCODE_OR_QR_CODE",
  OCR = "OCR",
  INTEGRATED_CIRCUIT_CARD = "INTEGRATED_CIRCUIT_CARD",
  KEY_ENTERED = "KEY_ENTERED",
  CONTACTLESS_ONLY_SUPPORTED = "CONTACTLESS_ONLY_SUPPORTED",
  FILE = "FILE",
  CONTACTLESS_READ_VIA_MAG_STRIPE_RULES = "CONTACTLESS_READ_VIA_MAG_STRIPE_RULES",
  CONTACTLESS_READ_VIA_CHIP_RULES = "CONTACTLESS_READ_VIA_CHIP_RULES",
  MAG_STRIPE_READER_AND_KEY_ENTRY = "MAG_STRIPE_READER_AND_KEY_ENTRY",
  MAG_STRIPE_READER_AND_EMV_ICC = "MAG_STRIPE_READER_AND_EMV_ICC",
  MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC = "MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC",
  SECURE_CARDLESS_ENTRY = "SECURE_CARDLESS_ENTRY",
}


export type HNVelocityRuleResult = {
  __typename: "HNVelocityRuleResult",
  recommendation?: HNSpendRuleRecommendation | null,
  message?: string | null,
  velocityRule?: HNVelocityRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNPointOfServiceDetails = {
  __typename: "HNPointOfServiceDetails",
  category?: HNPointOfServiceCategory | null,
  panEntryMode?: HNPanEntryMode | null,
  pinEntryMode?: HNPinEntryMode | null,
  terminalAttendance?: HNTerminalAttendance | null,
  isCardHolderPresent?: boolean | null,
  isCardPresent?: boolean | null,
  isRecurring?: boolean | null,
  terminalSupportsPartialApproval?: boolean | null,
  cardDataInputCapability?: HNCardDataInputCapability | null,
};

export enum HNPinEntryMode {
  PIN_ENTRY_CAPABILITY = "PIN_ENTRY_CAPABILITY",
  NO_PIN_ENTRY_CAPABILITY = "NO_PIN_ENTRY_CAPABILITY",
  PIN_PAD_INOPERATIVE = "PIN_PAD_INOPERATIVE",
  PIN_VERIFIED_BY_TERMINAL_DEVICE = "PIN_VERIFIED_BY_TERMINAL_DEVICE",
  RESERVED = "RESERVED",
}


export enum HNTerminalAttendance {
  ATTENDED = "ATTENDED",
  UNATTENDED = "UNATTENDED",
}


export type HNAdditionalNetworkData = HNVisaData | HNMastercardData


export type HNVisaData = {
  __typename: "HNVisaData",
  transactionIdentifier?: string | null,
  authorizationCode?: string | null,
  acquiringInstitutionIdentificationCode?: string | null,
  systemTraceAuditNumber?: string | null,
  retrievalReferenceNumber?: string | null,
  networkTransmissionDateAndTime?: string | null,
};

export type HNMastercardData = {
  __typename: "HNMastercardData",
  banknetReferenceNumber?: string | null,
  authorizationCode?: string | null,
  acquiringInstitutionIdentificationCode?: string | null,
  systemTraceAuditNumber?: string | null,
  retrievalReferenceNumber?: string | null,
  networkTransmissionDateAndTime?: string | null,
};

export type HNPaymentCardSnapshot = {
  __typename: "HNPaymentCardSnapshot",
  id: string,
  sourceCard?: HNPaymentCard | null,
  expirationDate?: string | null,
  expirationMonth?: string | null,
  expirationYear?: string | null,
  status?: HNPaymentCardStatus | null,
  statusChangeReason?: HNPaymentCardStatusChangeReason | null,
  statusChangeMemo?: string | null,
  usage?: HNCardUsage | null,
  formFactor?: HNCardFormFactor | null,
  updatedAt?: string | null,
  createdAt?: string | null,
  paymentCardCurrent?: HNPaymentCard | null,
};

export enum HNPaymentCardStatusChangeReason {
  CREATED = "CREATED",
  EXPIRED = "EXPIRED",
  LOST = "LOST",
  STOLEN = "STOLEN",
  OTHER = "OTHER",
  UNSPECIFIED = "UNSPECIFIED",
}


export enum HNCardUsage {
  MULTI_USE = "MULTI_USE",
  SINGLE_USE = "SINGLE_USE",
}


export type HNAdditionalTransactionData = {
  __typename: "HNAdditionalTransactionData",
  id: string,
};

export type HNVisaFleetL2TransactionData = {
  __typename: "HNVisaFleetL2TransactionData",
  id: string,
  visaFuelPurchaseType?: HNVisaFuelPurchaseType | null,
  visaFuelServiceType?: HNVisaFuelServiceType | null,
  visaFuelType?: HNVisaFuelType | null,
  visaFuelQuantity?: number | null,
  visaFuelUnitOfMeasure?: HNVisaFuelUnitOfMeasure | null,
  visaFuelUnitCost?: number | null,
  visaFuelNetAmount?: number | null,
  visaFuelGrossAmount?: number | null,
  visaNonFuelNetAmount?: number | null,
  visaNonFuelGrossAmount?: number | null,
  visaTaxRate?: number | null,
  visaExpandedFuelType?: HNVisaFuelType | null,
  visaAdditionalDataIndicator?: boolean | null,
  visaFleetIdentifier?: string | null,
  visaOdometerReading?: number | null,
  visaPurchaseIdentifierFormat?: HNVisaFleetPurchaseIdentifierFormat | null,
  visaPurchaseIdentifier?: string | null,
  visaFleetEmployeeNumber?: string | null,
  visaFleetTrailerNumber?: string | null,
  visaFleetCustomPrompt1?: string | null,
  visaFleetCustomPrompt2?: string | null,
  visaNonFuelProductCodes?: Array< HNVisaNonFuelProductCode > | null,
  visaChargingPowerCapacity?: number | null,
  visaChargingReasonCode?: number | null,
  visaEvChargingReasonCode?: HNVisaEvChargingReasonCode | null,
  visaEstimatedKmMilesAdded?: number | null,
  visaCarbonFootprintAvoided?: number | null,
  visaEstimatedKmMilesAvailable?: number | null,
  visaMaxPowerDispensed?: number | null,
  visaConnectorType?: string | null,
  visaEvConnectorType?: HNVisaEvConnectorType | null,
  visaFleetFuelLineItems?:  Array<HNVisaFleetL2FuelLineItem > | null,
  visaNationalTaxRate?: number | null,
  visaOtherTaxRate?: number | null,
  visaDiscountMethod?: HNVisaFleetDiscountMethod | null,
  visaDiscountAgent?: HNVisaFleetDiscountAgent | null,
  visaDiscountPlanIdentifier?: string | null,
  visaClientIdentifier?: string | null,
};

export enum HNVisaFuelPurchaseType {
  FUEL_PURCHASE = "FUEL_PURCHASE",
  NON_FUEL_PURCHASE = "NON_FUEL_PURCHASE",
  MIXED = "MIXED",
}


export enum HNVisaFuelServiceType {
  FULL_SERVICE = "FULL_SERVICE",
  SELF_SERVICE = "SELF_SERVICE",
  HIGH_SPEED_DISPENSE = "HIGH_SPEED_DISPENSE",
}


export enum HNVisaFuelType {
  REGULAR = "REGULAR",
  MID_PLUS = "MID_PLUS",
  PREMIUM_SUPER = "PREMIUM_SUPER",
  MID_PLUS_2 = "MID_PLUS_2",
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  UNLEADED_METHANOL_57 = "UNLEADED_METHANOL_57",
  UNLEADED_PLUS_METHANOL_57 = "UNLEADED_PLUS_METHANOL_57",
  UNLEADED_SUPER_METHANOL_57 = "UNLEADED_SUPER_METHANOL_57",
  UNLEADED_METHANOL_77 = "UNLEADED_METHANOL_77",
  UNLEADED_PLUS_METHANOL_77 = "UNLEADED_PLUS_METHANOL_77",
  ETHANOL_57 = "ETHANOL_57",
  MID_PLUS_ETHANOL_57 = "MID_PLUS_ETHANOL_57",
  PREMIUM_SUPER_ETHANOL_57 = "PREMIUM_SUPER_ETHANOL_57",
  ETHANOL_77 = "ETHANOL_77",
  MID_PLUS_ETHANOL_77 = "MID_PLUS_ETHANOL_77",
  GREEN_GAS_REGULAR = "GREEN_GAS_REGULAR",
  GREEN_GAS_PLUS = "GREEN_GAS_PLUS",
  GREEN_GAS_SUPER = "GREEN_GAS_SUPER",
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  COMPRESSED_NAT_GAS = "COMPRESSED_NAT_GAS",
  LPG = "LPG",
  LNG = "LNG",
  M85 = "M85",
  E85 = "E85",
  REFORMULATED_1 = "REFORMULATED_1",
  REFORMULATED_2 = "REFORMULATED_2",
  REFORMULATED_3 = "REFORMULATED_3",
  REFORMULATED_4 = "REFORMULATED_4",
  REFORMULATED_5 = "REFORMULATED_5",
  DIESEL_OFF_ROAD_TAXABLE = "DIESEL_OFF_ROAD_TAXABLE",
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  BIODIESEL_OFF_ROAD_NON_TAXABLE = "BIODIESEL_OFF_ROAD_NON_TAXABLE",
  BIODIESEL_OFF_ROAD_NON_TAXABLE_35 = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35",
  RACING_FUEL = "RACING_FUEL",
  MID_PLUS_2_10 = "MID_PLUS_2_10",
  PREMIUM_SUPER_2_10 = "PREMIUM_SUPER_2_10",
  PLUS_ETHANOL_2_15 = "PLUS_ETHANOL_2_15",
  SUPER_ETHANOL_2_15 = "SUPER_ETHANOL_2_15",
  REGULAR_ETHANOL_10 = "REGULAR_ETHANOL_10",
  PLUS_ETHANOL_10 = "PLUS_ETHANOL_10",
  SUPER_ETHANOL_10 = "SUPER_ETHANOL_10",
  B2_DIESEL = "B2_DIESEL",
  B5_DIESEL = "B5_DIESEL",
  B10_DIESEL = "B10_DIESEL",
  B11_DIESEL = "B11_DIESEL",
  B15_DIESEL = "B15_DIESEL",
  B20_DIESEL = "B20_DIESEL",
  B100_DIESEL = "B100_DIESEL",
  ULTRA_LOW_SULFUR_1 = "ULTRA_LOW_SULFUR_1",
  ULTRA_LOW_SULFUR_2 = "ULTRA_LOW_SULFUR_2",
  ULTRA_LOW_SULFUR_PREMIUM_1 = "ULTRA_LOW_SULFUR_PREMIUM_1",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100",
  DEF = "DEF",
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  REGULAR_ETHANOL_15 = "REGULAR_ETHANOL_15",
  PLUS_ETHANOL_15 = "PLUS_ETHANOL_15",
  SUPER_ETHANOL_15 = "SUPER_ETHANOL_15",
  PREMIUM_BIODIESEL_BLEND_UNDER_20 = "PREMIUM_BIODIESEL_BLEND_UNDER_20",
  PREMIUM_BIODIESEL_BLEND_OVER_20 = "PREMIUM_BIODIESEL_BLEND_OVER_20",
  B75_DIESEL = "B75_DIESEL",
  B99_DIESEL = "B99_DIESEL",
  MISC_FUEL = "MISC_FUEL",
  MISC_FUEL_1 = "MISC_FUEL_1",
  MISC_FUEL_2 = "MISC_FUEL_2",
  MISC_FUEL_3 = "MISC_FUEL_3",
  MISC_FUEL_4 = "MISC_FUEL_4",
  MISC_FUEL_5 = "MISC_FUEL_5",
  UNDEFINED_FUEL_1 = "UNDEFINED_FUEL_1",
  UNDEFINED_FUEL_2 = "UNDEFINED_FUEL_2",
  UNDEFINED_FUEL_3 = "UNDEFINED_FUEL_3",
  UNDEFINED_FUEL_4 = "UNDEFINED_FUEL_4",
  UNDEFINED_FUEL_5 = "UNDEFINED_FUEL_5",
  UNDEFINED_FUEL_6 = "UNDEFINED_FUEL_6",
  UNDEFINED_FUEL_7 = "UNDEFINED_FUEL_7",
  UNDEFINED_FUEL_8 = "UNDEFINED_FUEL_8",
  UNDEFINED_FUEL_9 = "UNDEFINED_FUEL_9",
  UNDEFINED_FUEL_10 = "UNDEFINED_FUEL_10",
  UNDEFINED_FUEL_11 = "UNDEFINED_FUEL_11",
  UNDEFINED_FUEL_12 = "UNDEFINED_FUEL_12",
  UNDEFINED_FUEL_13 = "UNDEFINED_FUEL_13",
  UNDEFINED_FUEL_14 = "UNDEFINED_FUEL_14",
  UNDEFINED_FUEL_15 = "UNDEFINED_FUEL_15",
  UNDEFINED_FUEL_16 = "UNDEFINED_FUEL_16",
  UNDEFINED_FUEL_17 = "UNDEFINED_FUEL_17",
  UNDEFINED_FUEL_18 = "UNDEFINED_FUEL_18",
  UNDEFINED_FUEL_19 = "UNDEFINED_FUEL_19",
  UNDEFINED_FUEL_20 = "UNDEFINED_FUEL_20",
  UNDEFINED_FUEL_21 = "UNDEFINED_FUEL_21",
  UNDEFINED_FUEL_22 = "UNDEFINED_FUEL_22",
  UNDEFINED_FUEL_23 = "UNDEFINED_FUEL_23",
  JET_FUEL = "JET_FUEL",
  AV_FUEL_REGULAR = "AV_FUEL_REGULAR",
  AV_FUEL_PREMIUM = "AV_FUEL_PREMIUM",
  AV_FUEL_JP8 = "AV_FUEL_JP8",
  AV_FUEL_4 = "AV_FUEL_4",
  AV_FUEL_5 = "AV_FUEL_5",
  BIOJET = "BIOJET",
  AV_BIOFUEL = "AV_BIOFUEL",
  AV_FUEL_UNDEFINED_1 = "AV_FUEL_UNDEFINED_1",
  AV_FUEL_UNDEFINED_2 = "AV_FUEL_UNDEFINED_2",
  AV_FUEL_UNDEFINED_3 = "AV_FUEL_UNDEFINED_3",
  AV_FUEL_UNDEFINED_4 = "AV_FUEL_UNDEFINED_4",
  AV_FUEL_UNDEFINED_5 = "AV_FUEL_UNDEFINED_5",
  AV_FUEL_UNDEFINED_6 = "AV_FUEL_UNDEFINED_6",
  AV_FUEL_UNDEFINED_7 = "AV_FUEL_UNDEFINED_7",
  AV_FUEL_UNDEFINED_8 = "AV_FUEL_UNDEFINED_8",
  AV_FUEL_UNDEFINED_9 = "AV_FUEL_UNDEFINED_9",
  AV_FUEL_UNDEFINED_10 = "AV_FUEL_UNDEFINED_10",
  AV_FUEL_UNDEFINED_11 = "AV_FUEL_UNDEFINED_11",
  MISC_AV_FUEL = "MISC_AV_FUEL",
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  MARINE_FUEL_OTHER = "MARINE_FUEL_OTHER",
  MARINE_DIESEL = "MARINE_DIESEL",
  MISC_MARINE_FUEL = "MISC_MARINE_FUEL",
  KEROSENE = "KEROSENE",
  WHITE_GAS = "WHITE_GAS",
  HEATING_OIL = "HEATING_OIL",
  BOTTLED_PROPANE = "BOTTLED_PROPANE",
  OTHER_FUEL_NT = "OTHER_FUEL_NT",
  KEROSENE_ULS = "KEROSENE_ULS",
  KEROSENE_LS_NT = "KEROSENE_LS_NT",
  KEROSENE_ULS_NT = "KEROSENE_ULS_NT",
  EVC_1 = "EVC_1",
  EVC_2 = "EVC_2",
  EVC_3 = "EVC_3",
  BIODIESEL_BLEND_2_OR_NT = "BIODIESEL_BLEND_2_OR_NT",
  BIODIESEL_BLEND_5_OR_NT = "BIODIESEL_BLEND_5_OR_NT",
  BIODIESEL_BLEND_10_OR_NT = "BIODIESEL_BLEND_10_OR_NT",
  BIODIESEL_BLEND_11_OR_NT = "BIODIESEL_BLEND_11_OR_NT",
  BIODIESEL_BLEND_15_OR_NT = "BIODIESEL_BLEND_15_OR_NT",
  BIODIESEL_BLEND_20_OR_NT = "BIODIESEL_BLEND_20_OR_NT",
  DIESEL_1_OR_NT = "DIESEL_1_OR_NT",
  DIESEL_2_OR_NT = "DIESEL_2_OR_NT",
  DIESEL_1_PREMIUM_OR_NT = "DIESEL_1_PREMIUM_OR_NT",
  DIESEL_2_PREMIUM_OR_NT = "DIESEL_2_PREMIUM_OR_NT",
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  E16_E84 = "E16_E84",
  LO_UNL = "LO_UNL",
  BLENDED_DIESEL_1_2 = "BLENDED_DIESEL_1_2",
  REGULAR_OR_NT = "REGULAR_OR_NT",
  PLUS_OR_NT = "PLUS_OR_NT",
  SUPER_OR_NT = "SUPER_OR_NT",
  PLUS_2_OR_NT = "PLUS_2_OR_NT",
  SUPER_2_OR_NT = "SUPER_2_OR_NT",
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  H35 = "H35",
  H70 = "H70",
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  PACKAGED_DEF = "PACKAGED_DEF",
  PACKAGED_B99 = "PACKAGED_B99",
  PACKAGED_B100 = "PACKAGED_B100",
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  MISC_PACKAGED_FUEL = "MISC_PACKAGED_FUEL",
  UNDEFINED_OTHER_FUEL_1 = "UNDEFINED_OTHER_FUEL_1",
  UNDEFINED_OTHER_FUEL_2 = "UNDEFINED_OTHER_FUEL_2",
  UNDEFINED_OTHER_FUEL_3 = "UNDEFINED_OTHER_FUEL_3",
  UNDEFINED_OTHER_FUEL_4 = "UNDEFINED_OTHER_FUEL_4",
  UNDEFINED_OTHER_FUEL_5 = "UNDEFINED_OTHER_FUEL_5",
  UNDEFINED_OTHER_FUEL_6 = "UNDEFINED_OTHER_FUEL_6",
  UNDEFINED_OTHER_FUEL_7 = "UNDEFINED_OTHER_FUEL_7",
  UNDEFINED_OTHER_FUEL_8 = "UNDEFINED_OTHER_FUEL_8",
  UNDEFINED_OTHER_FUEL_9 = "UNDEFINED_OTHER_FUEL_9",
  UNDEFINED_OTHER_FUEL_10 = "UNDEFINED_OTHER_FUEL_10",
  UNDEFINED_OTHER_FUEL_11 = "UNDEFINED_OTHER_FUEL_11",
  UNDEFINED_OTHER_FUEL_12 = "UNDEFINED_OTHER_FUEL_12",
  UNDEFINED_OTHER_FUEL_13 = "UNDEFINED_OTHER_FUEL_13",
  UNDEFINED_OTHER_FUEL_14 = "UNDEFINED_OTHER_FUEL_14",
  UNDEFINED_OTHER_FUEL_15 = "UNDEFINED_OTHER_FUEL_15",
  UNDEFINED_OTHER_FUEL_16 = "UNDEFINED_OTHER_FUEL_16",
  UNDEFINED_OTHER_FUEL_17 = "UNDEFINED_OTHER_FUEL_17",
  UNDEFINED_OTHER_FUEL_18 = "UNDEFINED_OTHER_FUEL_18",
  UNDEFINED_PACKAGED_FUEL_1 = "UNDEFINED_PACKAGED_FUEL_1",
  UNDEFINED_PACKAGED_FUEL_2 = "UNDEFINED_PACKAGED_FUEL_2",
  UNDEFINED_PACKAGED_FUEL_3 = "UNDEFINED_PACKAGED_FUEL_3",
  UNDEFINED_PACKAGED_FUEL_4 = "UNDEFINED_PACKAGED_FUEL_4",
  UNDEFINED_PACKAGED_FUEL_5 = "UNDEFINED_PACKAGED_FUEL_5",
  UNDEFINED_PACKAGED_FUEL_6 = "UNDEFINED_PACKAGED_FUEL_6",
  UNDEFINED_PACKAGED_FUEL_7 = "UNDEFINED_PACKAGED_FUEL_7",
  UNDEFINED_PACKAGED_FUEL_8 = "UNDEFINED_PACKAGED_FUEL_8",
  UNDEFINED_PACKAGED_FUEL_9 = "UNDEFINED_PACKAGED_FUEL_9",
  UNDEFINED_PACKAGED_FUEL_10 = "UNDEFINED_PACKAGED_FUEL_10",
  UNDEFINED_PACKAGED_FUEL_11 = "UNDEFINED_PACKAGED_FUEL_11",
  UNDEFINED_PACKAGED_FUEL_12 = "UNDEFINED_PACKAGED_FUEL_12",
  UNDEFINED_PACKAGED_FUEL_13 = "UNDEFINED_PACKAGED_FUEL_13",
  UNDEFINED_PACKAGED_FUEL_14 = "UNDEFINED_PACKAGED_FUEL_14",
  UNDEFINED_PACKAGED_FUEL_15 = "UNDEFINED_PACKAGED_FUEL_15",
  UNDEFINED_PACKAGED_FUEL_16 = "UNDEFINED_PACKAGED_FUEL_16",
  UNDEFINED_PACKAGED_FUEL_17 = "UNDEFINED_PACKAGED_FUEL_17",
  UNDEFINED_PACKAGED_FUEL_18 = "UNDEFINED_PACKAGED_FUEL_18",
  RESERVED_1 = "RESERVED_1",
  RESERVED_2 = "RESERVED_2",
  RESERVED_3 = "RESERVED_3",
  RESERVED_4 = "RESERVED_4",
  RESERVED_5 = "RESERVED_5",
  RESERVED_6 = "RESERVED_6",
  RESERVED_7 = "RESERVED_7",
  RESERVED_8 = "RESERVED_8",
  RESERVED_9 = "RESERVED_9",
  RESERVED_10 = "RESERVED_10",
  RESERVED_11 = "RESERVED_11",
  RESERVED_12 = "RESERVED_12",
  RESERVED_13 = "RESERVED_13",
  RESERVED_14 = "RESERVED_14",
  RESERVED_15 = "RESERVED_15",
  RESERVED_16 = "RESERVED_16",
  RESERVED_17 = "RESERVED_17",
  RESERVED_18 = "RESERVED_18",
  RESERVED_19 = "RESERVED_19",
  RESERVED_20 = "RESERVED_20",
  RESERVED_21 = "RESERVED_21",
  RESERVED_22 = "RESERVED_22",
  RESERVED_23 = "RESERVED_23",
  RESERVED_24 = "RESERVED_24",
  RESERVED_25 = "RESERVED_25",
  UNKNOWN = "UNKNOWN",
}


export enum HNVisaFuelUnitOfMeasure {
  GALLON = "GALLON",
  LITER = "LITER",
  IMPERIAL = "IMPERIAL",
  KILO = "KILO",
  POUND = "POUND",
  KILOWATT_HOUR = "KILOWATT_HOUR",
  CHARGING_MINUTES = "CHARGING_MINUTES",
}


export enum HNVisaFleetPurchaseIdentifierFormat {
  ORDER = "ORDER",
  INVOICE = "INVOICE",
}


export enum HNVisaNonFuelProductCode {
  GEN_AUTO_MERCH = "GEN_AUTO_MERCH",
  MOTOR_OIL = "MOTOR_OIL",
  CAR_WASH = "CAR_WASH",
  OIL_CHANGE = "OIL_CHANGE",
  OIL_FILTER = "OIL_FILTER",
  WORK_ORDER = "WORK_ORDER",
  ANTI_FREEZE = "ANTI_FREEZE",
  WASHER_FLUID = "WASHER_FLUID",
  BRAKE_FLUID = "BRAKE_FLUID",
  TIRES = "TIRES",
  TIRES_FET = "TIRES_FET",
  TIRE_ROTATION = "TIRE_ROTATION",
  BATTERIES = "BATTERIES",
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  LUBE = "LUBE",
  INSPECTION = "INSPECTION",
  LABOR = "LABOR",
  TOWING = "TOWING",
  ROAD_SERVICE = "ROAD_SERVICE",
  VEHICLE_ACC = "VEHICLE_ACC",
  VEHICLE_PARTS = "VEHICLE_PARTS",
  PREV_MAINTENANCE = "PREV_MAINTENANCE",
  AC_SERVICE = "AC_SERVICE",
  ENGINE_SERVICE = "ENGINE_SERVICE",
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  BRAKE_SERVICE = "BRAKE_SERVICE",
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  BODY_WORK = "BODY_WORK",
  VEHICLE_GLASS = "VEHICLE_GLASS",
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  LAMPS = "LAMPS",
  WIPERS = "WIPERS",
  HOSES = "HOSES",
  TIRE_RELATED = "TIRE_RELATED",
  REPAIRS = "REPAIRS",
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  VEHICLE_PARKING = "VEHICLE_PARKING",
  TRUNK_TANK_CLEANING = "TRUNK_TANK_CLEANING",
  OTHER_LUBE = "OTHER_LUBE",
  VEHICLE_FUEL_ADDITIVES = "VEHICLE_FUEL_ADDITIVES",
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  AIR_FILTER = "AIR_FILTER",
  VEHICLE_PREP = "VEHICLE_PREP",
  FUEL_SYSTEM = "FUEL_SYSTEM",
  MISC_VEHICLE_PS = "MISC_VEHICLE_PS",
  SCALES = "SCALES",
  SHOWER = "SHOWER",
  TIRE_REPAIR = "TIRE_REPAIR",
  LODGING = "LODGING",
  WASH_OUT = "WASH_OUT",
  TRAILER_WASH = "TRAILER_WASH",
  RV_DUMP_FEE = "RV_DUMP_FEE",
  EV_CHARGE = "EV_CHARGE",
  EV_BATTERY_ECH = "EV_BATTERY_ECH",
  TOLL = "TOLL",
  STORAGE = "STORAGE",
  AIRCRAFT_GROUND_HAULING = "AIRCRAFT_GROUND_HAULING",
  AIRCRAFT_GROUND_PU = "AIRCRAFT_GROUND_PU",
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  AIRCRAFT_WO = "AIRCRAFT_WO",
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  TRANSPORTATION = "TRANSPORTATION",
  DE_ICING = "DE_ICING",
  RAMP_FEES = "RAMP_FEES",
  CATERING = "CATERING",
  HANGAR_FEE = "HANGAR_FEE",
  APU = "APU",
  LANDING_FEE = "LANDING_FEE",
  CALL_OUT_FEE = "CALL_OUT_FEE",
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  FLIGHT_PLANS = "FLIGHT_PLANS",
  FLIGHT_PLANNING_FEES = "FLIGHT_PLANNING_FEES",
  WEATHER_FEES = "WEATHER_FEES",
  CHARTER_FEE = "CHARTER_FEE",
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  CARGO_HANDLING = "CARGO_HANDLING",
  AIRCRAFT_ACC = "AIRCRAFT_ACC",
  AVIONICS = "AVIONICS",
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  AIRCRAFT_PARKING_FEE = "AIRCRAFT_PARKING_FEE",
  AIRCRAFT_TIE_DOWN_FEE = "AIRCRAFT_TIE_DOWN_FEE",
  AIRCRAFT_SANITATION = "AIRCRAFT_SANITATION",
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  AC_PARTS = "AC_PARTS",
  OXYGEN = "OXYGEN",
  DE_FUEL = "DE_FUEL",
  RE_SERVICE = "RE_SERVICE",
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  AIRPORT_FEE = "AIRPORT_FEE",
  OVERTIME_FEE = "OVERTIME_FEE",
  IT_BLADDER = "IT_BLADDER",
  GES_FEE = "GES_FEE",
  SECURE_FEE = "SECURE_FEE",
  FLOW_FEE = "FLOW_FEE",
  MISC_AV_PS = "MISC_AV_PS",
  MARINE_SERVICE = "MARINE_SERVICE",
  MARINE_LABOR = "MARINE_LABOR",
  MARINE_WO = "MARINE_WO",
  LAUNCH_FEE = "LAUNCH_FEE",
  SLIP_RENTAL = "SLIP_RENTAL",
  MISC_MARINE_PS = "MISC_MARINE_PS",
  GEN_MERCH = "GEN_MERCH",
  GEN_ICE = "GEN_ICE",
  GEN_UNDEFINED = "GEN_UNDEFINED",
  GEN_UNDEFINED_2 = "GEN_UNDEFINED_2",
  GEN_UNDEFINED_3 = "GEN_UNDEFINED_3",
  GEN_UNDEFINED_4 = "GEN_UNDEFINED_4",
  GEN_UNDEFINED_5 = "GEN_UNDEFINED_5",
  GEN_UNDEFINED_6 = "GEN_UNDEFINED_6",
  GEN_UNDEFINED_7 = "GEN_UNDEFINED_7",
  GEN_UNDEFINED_8 = "GEN_UNDEFINED_8",
  GEN_TOBACCO = "GEN_TOBACCO",
  CIGARETTES = "CIGARETTES",
  TOBACCO_OTHER = "TOBACCO_OTHER",
  GEN_PACKAGED_BEV = "GEN_PACKAGED_BEV",
  PACKAGED_BEV_NA = "PACKAGED_BEV_NA",
  PACKAGED_JUICE = "PACKAGED_JUICE",
  OTHER_PACKAGED_BEV = "OTHER_PACKAGED_BEV",
  GEN_DISPENSED_BEV = "GEN_DISPENSED_BEV",
  SODA = "SODA",
  HOT_DISPENSED_BEV = "HOT_DISPENSED_BEV",
  COLD_DISPENSED_BEV = "COLD_DISPENSED_BEV",
  FROZEN_DISPENSED_BEV = "FROZEN_DISPENSED_BEV",
  OTHER_DISPENSED_BEV = "OTHER_DISPENSED_BEV",
  UNASSIGNED_BEV = "UNASSIGNED_BEV",
  UNASSIGNED_BEV_2 = "UNASSIGNED_BEV_2",
  UNASSIGNED_BEV_3 = "UNASSIGNED_BEV_3",
  UNASSIGNED_BEV_4 = "UNASSIGNED_BEV_4",
  UNASSIGNED_BEV_5 = "UNASSIGNED_BEV_5",
  UNASSIGNED_BEV_6 = "UNASSIGNED_BEV_6",
  UNASSIGNED_BEV_7 = "UNASSIGNED_BEV_7",
  GEN_SNACKS = "GEN_SNACKS",
  SALTY_SNACKS = "SALTY_SNACKS",
  ALT_SNACKS = "ALT_SNACKS",
  SWEET_SNACKS = "SWEET_SNACKS",
  GEN_CANDY = "GEN_CANDY",
  GEN_DAIRY = "GEN_DAIRY",
  FLUID_MILK = "FLUID_MILK",
  PACKAGED_ICE_CREAM = "PACKAGED_ICE_CREAM",
  OTHER_DAIRY = "OTHER_DAIRY",
  GEN_GROCERY = "GEN_GROCERY",
  GROCERY_EDIBLE = "GROCERY_EDIBLE",
  GROCERY_NON_EDIBLE = "GROCERY_NON_EDIBLE",
  GROCERY_PER_EDIBLE = "GROCERY_PER_EDIBLE",
  UNASSIGNED_GROCERY = "UNASSIGNED_GROCERY",
  UNASSIGNED_GROCERY_2 = "UNASSIGNED_GROCERY_2",
  UNASSIGNED_GROCERY_3 = "UNASSIGNED_GROCERY_3",
  UNASSIGNED_GROCERY_4 = "UNASSIGNED_GROCERY_4",
  UNASSIGNED_GROCERY_5 = "UNASSIGNED_GROCERY_5",
  UNASSIGNED_GROCERY_6 = "UNASSIGNED_GROCERY_6",
  PACKAGED_BREAD = "PACKAGED_BREAD",
  FROZEN_FOOD = "FROZEN_FOOD",
  GEN_ALCOHOL = "GEN_ALCOHOL",
  BEER = "BEER",
  BEER_NA = "BEER_NA",
  WINE = "WINE",
  LIQUOR = "LIQUOR",
  GEN_DELI = "GEN_DELI",
  PACKAGED_DELI = "PACKAGED_DELI",
  PREPARED_FOOD = "PREPARED_FOOD",
  DELI_ITEMS = "DELI_ITEMS",
  GEN_FOODSERVICE = "GEN_FOODSERVICE",
  GEN_LOTTERY = "GEN_LOTTERY",
  LOTTERY_IN = "LOTTERY_IN",
  LOTTERY_ON = "LOTTERY_ON",
  LOTTERT_OT = "LOTTERT_OT",
  GEN_MONEY_ORDER = "GEN_MONEY_ORDER",
  MONEY_ORDER_VP = "MONEY_ORDER_VP",
  MONEY_ORDER_PC = "MONEY_ORDER_PC",
  MONEY_ORDER_GC = "MONEY_ORDER_GC",
  MONEY_ORDER_REFC = "MONEY_ORDER_REFC",
  MONEY_ORDER_OC = "MONEY_ORDER_OC",
  MONEY_ORDER_REBC = "MONEY_ORDER_REBC",
  MONEY_ORDER_DC = "MONEY_ORDER_DC",
  MONEY_ORDER_UC = "MONEY_ORDER_UC",
  GEN_STORE_SERVICE = "GEN_STORE_SERVICE",
  HOME_DELIVERY = "HOME_DELIVERY",
  MISC = "MISC",
  SALES_TAX_NON_FUEL = "SALES_TAX_NON_FUEL",
  PREPAID_PURCHASE = "PREPAID_PURCHASE",
  PREPAID_ACT = "PREPAID_ACT",
  MEMBERSHIP = "MEMBERSHIP",
  GEN_HEALTH = "GEN_HEALTH",
  GEN_PUBLICATIONS = "GEN_PUBLICATIONS",
  PIN_PREPAID_ACT = "PIN_PREPAID_ACT",
  PIN_PREPAID_RET = "PIN_PREPAID_RET",
  ENABLE_HANDSET = "ENABLE_HANDSET",
  DISABLE_HANDSET = "DISABLE_HANDSET",
  THREE_P_PREPAID_ACT = "THREE_P_PREPAID_ACT",
  THREE_P_PREPAID_REL = "THREE_P_PREPAID_REL",
  FIN_PREPAID_ACT = "FIN_PREPAID_ACT",
  FIN_PREPAID_REL = "FIN_PREPAID_REL",
  PROP_PREPAID_ACT = "PROP_PREPAID_ACT",
  PROP_PREPAID_REL = "PROP_PREPAID_REL",
  GEN_PURPOSE_ACT = "GEN_PURPOSE_ACT",
  GEN_PURPOSE_REL = "GEN_PURPOSE_REL",
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  WL_REAL_TIME_RECHARGE = "WL_REAL_TIME_RECHARGE",
  SINGLE_BILL_PAY = "SINGLE_BILL_PAY",
  MULTI_BILL_PAY = "MULTI_BILL_PAY",
  CBD = "CBD",
  DISCOUNT_1 = "DISCOUNT_1",
  DISCOUNT_2 = "DISCOUNT_2",
  DISCOUNT_3 = "DISCOUNT_3",
  DISCOUNT_4 = "DISCOUNT_4",
  DISCOUNT_5 = "DISCOUNT_5",
  COUPON_1 = "COUPON_1",
  COUPON_2 = "COUPON_2",
  COUPON_3 = "COUPON_3",
  COUPON_4 = "COUPON_4",
  COUPON_5 = "COUPON_5",
  LOTTERY_PO_IN = "LOTTERY_PO_IN",
  LOTTERY_PO_ON = "LOTTERY_PO_ON",
  LOTTERY_PO_OT = "LOTTERY_PO_OT",
  SPLIT_TENDER = "SPLIT_TENDER",
  TAX_DISCOUNT_F = "TAX_DISCOUNT_F",
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  POS_RES_DISCOUNT_1 = "POS_RES_DISCOUNT_1",
  POS_RES_DISCOUNT_2 = "POS_RES_DISCOUNT_2",
  POS_RES_DISCOUNT_3 = "POS_RES_DISCOUNT_3",
  POS_RES_DISCOUNT_4 = "POS_RES_DISCOUNT_4",
  POS_RES_DISCOUNT_5 = "POS_RES_DISCOUNT_5",
  MISC_NEG_ADMIN = "MISC_NEG_ADMIN",
  TAX_1 = "TAX_1",
  TAX_2 = "TAX_2",
  TAX_3 = "TAX_3",
  TAX_4 = "TAX_4",
  TAX_5 = "TAX_5",
  CASH_BACK = "CASH_BACK",
  CASH_BACK_FEE = "CASH_BACK_FEE",
  FEE_1 = "FEE_1",
  FEE_2 = "FEE_2",
  FEE_3 = "FEE_3",
  FEE_4 = "FEE_4",
  FEE_5 = "FEE_5",
  MISC_AV_TAX = "MISC_AV_TAX",
  GST_HST_VAT_1 = "GST_HST_VAT_1",
  PST_HST_VAT_2 = "PST_HST_VAT_2",
  SWT_RATE = "SWT_RATE",
  TAX_6 = "TAX_6",
  TAX_7 = "TAX_7",
  TAX_8 = "TAX_8",
  JET_FD_E_TAX = "JET_FD_E_TAX",
  AV_GAS_FED_E_TAX = "AV_GAS_FED_E_TAX",
  CHARITY = "CHARITY",
  GRATUITY = "GRATUITY",
  MISC_ADMIN = "MISC_ADMIN",
  RESERVED_1 = "RESERVED_1",
  RESERVED_2 = "RESERVED_2",
  RESERVED_3 = "RESERVED_3",
  RESERVED_4 = "RESERVED_4",
  RESERVED_5 = "RESERVED_5",
  RESERVED_6 = "RESERVED_6",
  RESERVED_7 = "RESERVED_7",
  RESERVED_8 = "RESERVED_8",
  UNKNOWN = "UNKNOWN",
}


export enum HNVisaEvChargingReasonCode {
  OTHER_ERROR = "OTHER_ERROR",
  CONNECTOR_LOCK_FAILURE = "CONNECTOR_LOCK_FAILURE",
  EV_COMMUNICATION_ERROR = "EV_COMMUNICATION_ERROR",
  GROUND_FAILURE = "GROUND_FAILURE",
  HIGH_TEMPERATURE = "HIGH_TEMPERATURE",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  OVER_CURRENT_FAILURE = "OVER_CURRENT_FAILURE",
  OVER_VOLTAGE = "OVER_VOLTAGE",
  POWER_METER_FAILURE = "POWER_METER_FAILURE",
  POWER_SWITCH_FAILURE = "POWER_SWITCH_FAILURE",
  READER_FAILURE = "READER_FAILURE",
  RESET_FAILURE = "RESET_FAILURE",
  UNDER_VOLTAGE = "UNDER_VOLTAGE",
  WEAK_SIGNAL = "WEAK_SIGNAL",
  NO_ERROR = "NO_ERROR",
  PAYMENT_RELATED_ERROR = "PAYMENT_RELATED_ERROR",
}


export enum HNVisaEvConnectorType {
  AC_J1772 = "AC_J1772",
  AC_MENNEKES = "AC_MENNEKES",
  AC_GBT = "AC_GBT",
  DC_CCS1 = "DC_CCS1",
  DC_CHADEMO = "DC_CHADEMO",
  DC_CCS2 = "DC_CCS2",
  DC_GBT = "DC_GBT",
  NACS = "NACS",
}


export type HNVisaFleetL2FuelLineItem = {
  __typename: "HNVisaFleetL2FuelLineItem",
  productCode?: HNVisaFuelType | null,
  unitPrice?: number | null,
  unitPriceMinorUnit?: number | null,
  unitOfMeasure?: HNVisaFuelUnitOfMeasure | null,
  quantity?: number | null,
  quantityMinorUnit?: number | null,
  totalTimePluggedIn?: string | null,
  totalTimeCharging?: string | null,
  chargingStartTime?: string | null,
  chargingFinishTime?: string | null,
  totalAmount?: HNAmount | null,
  fuelIndicator?: boolean | null,
  serviceType?: HNVisaFuelServiceType | null,
  productCategoryOrDescription?: string | null,
  discountRatePercentage?: number | null,
  discountPerUnit?: HNAmount | null,
  discountPerTransaction?: HNAmount | null,
  totalDiscountAmount?: HNAmount | null,
  netAmount?: HNAmount | null,
  notTaxableIndicator?: boolean | null,
  localTaxIncludedIndicator?: boolean | null,
  localTaxAmount?: HNAmount | null,
  localTaxRate?: number | null,
  nationalTaxIncludedIndicator?: boolean | null,
  nationalTaxAmount?: HNAmount | null,
  nationalTaxRate?: number | null,
  otherTaxIncludedIndicator?: boolean | null,
  otherTaxAmount?: HNAmount | null,
  otherTaxRate?: number | null,
};

export enum HNVisaFleetDiscountMethod {
  RETAIL_MINUS = "RETAIL_MINUS",
  COST_PLUS = "COST_PLUS",
  BEST_OF_RETAIL_MINUS_OR_COST_PLUS = "BEST_OF_RETAIL_MINUS_OR_COST_PLUS",
}


export enum HNVisaFleetDiscountAgent {
  MERCHANT = "MERCHANT",
  VISA = "VISA",
}


export type HNVisaFleetL3EnhancedData = {
  __typename: "HNVisaFleetL3EnhancedData",
  id: string,
  discount?: HNVisaFleetL3EnhancedDataDiscount | null,
  duty?: HNVisaFleetL3EnhancedDataDuty | null,
  invoice?: HNVisaFleetL3EnhancedDataInvoice | null,
  shipping?: HNVisaFleetL3EnhancedDataShipping | null,
  tax?: HNVisaFleetL3EnhancedDataTax | null,
};

export type HNVisaFleetL3EnhancedDataDiscount = {
  __typename: "HNVisaFleetL3EnhancedDataDiscount",
  amount?: HNAmount | null,
  signage?: HNVisaAmountSignage | null,
  treatment?: HNVisaDiscountTreatment | null,
};

export enum HNVisaAmountSignage {
  NULL = "NULL",
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}


export enum HNVisaDiscountTreatment {
  NO_DISCOUNT = "NO_DISCOUNT",
  POST_DISCOUNT = "POST_DISCOUNT",
  PRE_DISCOUNT = "PRE_DISCOUNT",
}


export type HNVisaFleetL3EnhancedDataDuty = {
  __typename: "HNVisaFleetL3EnhancedDataDuty",
  amount?: HNAmount | null,
  signage?: HNVisaAmountSignage | null,
};

export type HNVisaFleetL3EnhancedDataInvoice = {
  __typename: "HNVisaFleetL3EnhancedDataInvoice",
  referenceNumber?: string | null,
  destinationPostalCode?: string | null,
  shipFromPostalCode?: string | null,
  destinationCountryCode?: string | null,
  authorizationCode?: string | null,
  orderDate?: string | null,
  lineItems?:  Array<HNVisaFleetL3EnhancedDataLineItem > | null,
};

export type HNVisaFleetL3EnhancedDataLineItem = {
  __typename: "HNVisaFleetL3EnhancedDataLineItem",
  commodityCode?: HNVisaItemCommodityCode | null,
  descriptor?: string | null,
  productCode?: string | null,
  quantity?: number | null,
  unitOfMeasure?: string | null,
  unitCost?: HNAmount | null,
  taxAmount?: HNAmount | null,
  taxRate?: number | null,
  discountPerItem?: HNAmount | null,
  lineItemDiscountTreatment?: HNVisaDiscountTreatment | null,
  lineItemTotal?: HNAmount | null,
  lineItemDetailIndicator?: HNVisaLineItemDetailIndicator | null,
};

export enum HNVisaItemCommodityCode {
  REGULAR = "REGULAR",
  MID_PLUS = "MID_PLUS",
  PREMIUM_SUPER = "PREMIUM_SUPER",
  MID_PLUS_2 = "MID_PLUS_2",
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  UNLEADED_METHANOL_57 = "UNLEADED_METHANOL_57",
  UNLEADED_PLUS_METHANOL_57 = "UNLEADED_PLUS_METHANOL_57",
  UNLEADED_SUPER_METHANOL_57 = "UNLEADED_SUPER_METHANOL_57",
  UNLEADED_METHANOL_77 = "UNLEADED_METHANOL_77",
  UNLEADED_PLUS_METHANOL_77 = "UNLEADED_PLUS_METHANOL_77",
  ETHANOL_57 = "ETHANOL_57",
  MID_PLUS_ETHANOL_57 = "MID_PLUS_ETHANOL_57",
  PREMIUM_SUPER_ETHANOL_57 = "PREMIUM_SUPER_ETHANOL_57",
  ETHANOL_77 = "ETHANOL_77",
  MID_PLUS_ETHANOL_77 = "MID_PLUS_ETHANOL_77",
  GREEN_GAS_REGULAR = "GREEN_GAS_REGULAR",
  GREEN_GAS_PLUS = "GREEN_GAS_PLUS",
  GREEN_GAS_SUPER = "GREEN_GAS_SUPER",
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  COMPRESSED_NAT_GAS = "COMPRESSED_NAT_GAS",
  LPG = "LPG",
  LNG = "LNG",
  M85 = "M85",
  E85 = "E85",
  REFORMULATED_1 = "REFORMULATED_1",
  REFORMULATED_2 = "REFORMULATED_2",
  REFORMULATED_3 = "REFORMULATED_3",
  REFORMULATED_4 = "REFORMULATED_4",
  REFORMULATED_5 = "REFORMULATED_5",
  DIESEL_OFF_ROAD_TAXABLE = "DIESEL_OFF_ROAD_TAXABLE",
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  BIODIESEL_OFF_ROAD_NON_TAXABLE = "BIODIESEL_OFF_ROAD_NON_TAXABLE",
  BIODIESEL_OFF_ROAD_NON_TAXABLE_35 = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35",
  RACING_FUEL = "RACING_FUEL",
  MID_PLUS_2_10 = "MID_PLUS_2_10",
  PREMIUM_SUPER_2_10 = "PREMIUM_SUPER_2_10",
  PLUS_ETHANOL_2_15 = "PLUS_ETHANOL_2_15",
  SUPER_ETHANOL_2_15 = "SUPER_ETHANOL_2_15",
  REGULAR_ETHANOL_10 = "REGULAR_ETHANOL_10",
  PLUS_ETHANOL_10 = "PLUS_ETHANOL_10",
  SUPER_ETHANOL_10 = "SUPER_ETHANOL_10",
  B2_DIESEL = "B2_DIESEL",
  B5_DIESEL = "B5_DIESEL",
  B10_DIESEL = "B10_DIESEL",
  B11_DIESEL = "B11_DIESEL",
  B15_DIESEL = "B15_DIESEL",
  B20_DIESEL = "B20_DIESEL",
  B100_DIESEL = "B100_DIESEL",
  ULTRA_LOW_SULFUR_1 = "ULTRA_LOW_SULFUR_1",
  ULTRA_LOW_SULFUR_2 = "ULTRA_LOW_SULFUR_2",
  ULTRA_LOW_SULFUR_PREMIUM_1 = "ULTRA_LOW_SULFUR_PREMIUM_1",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20",
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100",
  DEF = "DEF",
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  REGULAR_ETHANOL_15 = "REGULAR_ETHANOL_15",
  PLUS_ETHANOL_15 = "PLUS_ETHANOL_15",
  SUPER_ETHANOL_15 = "SUPER_ETHANOL_15",
  PREMIUM_BIODIESEL_BLEND_UNDER_20 = "PREMIUM_BIODIESEL_BLEND_UNDER_20",
  PREMIUM_BIODIESEL_BLEND_OVER_20 = "PREMIUM_BIODIESEL_BLEND_OVER_20",
  B75_DIESEL = "B75_DIESEL",
  B99_DIESEL = "B99_DIESEL",
  MISC_FUEL = "MISC_FUEL",
  JET_FUEL = "JET_FUEL",
  AV_FUEL_REGULAR = "AV_FUEL_REGULAR",
  AV_FUEL_PREMIUM = "AV_FUEL_PREMIUM",
  AV_FUEL_JP8 = "AV_FUEL_JP8",
  AV_FUEL_4 = "AV_FUEL_4",
  AV_FUEL_5 = "AV_FUEL_5",
  BIOJET = "BIOJET",
  AV_BIOFUEL = "AV_BIOFUEL",
  MISC_AV_FUEL = "MISC_AV_FUEL",
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  MARINE_FUEL_OTHER = "MARINE_FUEL_OTHER",
  MARINE_DIESEL = "MARINE_DIESEL",
  MISC_MARINE_FUEL = "MISC_MARINE_FUEL",
  KEROSENE = "KEROSENE",
  WHITE_GAS = "WHITE_GAS",
  HEATING_OIL = "HEATING_OIL",
  BOTTLED_PROPANE = "BOTTLED_PROPANE",
  OTHER_FUEL_NT = "OTHER_FUEL_NT",
  KEROSENE_ULS = "KEROSENE_ULS",
  KEROSENE_LS_NT = "KEROSENE_LS_NT",
  KEROSENE_ULS_NT = "KEROSENE_ULS_NT",
  EVC_1 = "EVC_1",
  EVC_2 = "EVC_2",
  EVC_3 = "EVC_3",
  BIODIESEL_BLEND_2_OR_NT = "BIODIESEL_BLEND_2_OR_NT",
  BIODIESEL_BLEND_5_OR_NT = "BIODIESEL_BLEND_5_OR_NT",
  BIODIESEL_BLEND_10_OR_NT = "BIODIESEL_BLEND_10_OR_NT",
  BIODIESEL_BLEND_11_OR_NT = "BIODIESEL_BLEND_11_OR_NT",
  BIODIESEL_BLEND_15_OR_NT = "BIODIESEL_BLEND_15_OR_NT",
  BIODIESEL_BLEND_20_OR_NT = "BIODIESEL_BLEND_20_OR_NT",
  DIESEL_1_OR_NT = "DIESEL_1_OR_NT",
  DIESEL_2_OR_NT = "DIESEL_2_OR_NT",
  DIESEL_1_PREMIUM_OR_NT = "DIESEL_1_PREMIUM_OR_NT",
  DIESEL_2_PREMIUM_OR_NT = "DIESEL_2_PREMIUM_OR_NT",
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  E16_E84 = "E16_E84",
  LO_UNL = "LO_UNL",
  BLENDED_DIESEL_1_2 = "BLENDED_DIESEL_1_2",
  REGULAR_OR_NT = "REGULAR_OR_NT",
  PLUS_OR_NT = "PLUS_OR_NT",
  SUPER_OR_NT = "SUPER_OR_NT",
  PLUS_2_OR_NT = "PLUS_2_OR_NT",
  SUPER_2_OR_NT = "SUPER_2_OR_NT",
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  H35 = "H35",
  H70 = "H70",
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  PACKAGED_DEF = "PACKAGED_DEF",
  PACKAGED_B99 = "PACKAGED_B99",
  PACKAGED_B100 = "PACKAGED_B100",
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  MISC_PACKAGED_FUEL = "MISC_PACKAGED_FUEL",
  GEN_AUTO_MERCH = "GEN_AUTO_MERCH",
  MOTOR_OIL = "MOTOR_OIL",
  CAR_WASH = "CAR_WASH",
  OIL_CHANGE = "OIL_CHANGE",
  OIL_FILTER = "OIL_FILTER",
  WORK_ORDER = "WORK_ORDER",
  ANTI_FREEZE = "ANTI_FREEZE",
  WASHER_FLUID = "WASHER_FLUID",
  BRAKE_FLUID = "BRAKE_FLUID",
  TIRES = "TIRES",
  TIRES_FET = "TIRES_FET",
  TIRE_ROTATION = "TIRE_ROTATION",
  BATTERIES = "BATTERIES",
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  LUBE = "LUBE",
  INSPECTION = "INSPECTION",
  LABOR = "LABOR",
  TOWING = "TOWING",
  ROAD_SERVICE = "ROAD_SERVICE",
  VEHICLE_ACC = "VEHICLE_ACC",
  VEHICLE_PARTS = "VEHICLE_PARTS",
  PREV_MAINTENANCE = "PREV_MAINTENANCE",
  AC_SERVICE = "AC_SERVICE",
  ENGINE_SERVICE = "ENGINE_SERVICE",
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  BRAKE_SERVICE = "BRAKE_SERVICE",
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  BODY_WORK = "BODY_WORK",
  VEHICLE_GLASS = "VEHICLE_GLASS",
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  LAMPS = "LAMPS",
  WIPERS = "WIPERS",
  HOSES = "HOSES",
  TIRE_RELATED = "TIRE_RELATED",
  REPAIRS = "REPAIRS",
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  VEHICLE_PARKING = "VEHICLE_PARKING",
  TRUNK_TANK_CLEANING = "TRUNK_TANK_CLEANING",
  OTHER_LUBE = "OTHER_LUBE",
  VEHICLE_FUEL_ADDITIVES = "VEHICLE_FUEL_ADDITIVES",
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  AIR_FILTER = "AIR_FILTER",
  VEHICLE_PREP = "VEHICLE_PREP",
  FUEL_SYSTEM = "FUEL_SYSTEM",
  UNDEFINED_VEHICLE_PS_1 = "UNDEFINED_VEHICLE_PS_1",
  UNDEFINED_VEHICLE_PS_2 = "UNDEFINED_VEHICLE_PS_2",
  UNDEFINED_VEHICLE_PS_3 = "UNDEFINED_VEHICLE_PS_3",
  UNDEFINED_VEHICLE_PS_4 = "UNDEFINED_VEHICLE_PS_4",
  UNDEFINED_VEHICLE_PS_5 = "UNDEFINED_VEHICLE_PS_5",
  UNDEFINED_VEHICLE_PS_6 = "UNDEFINED_VEHICLE_PS_6",
  UNDEFINED_VEHICLE_PS_7 = "UNDEFINED_VEHICLE_PS_7",
  UNDEFINED_VEHICLE_PS_8 = "UNDEFINED_VEHICLE_PS_8",
  UNDEFINED_VEHICLE_PS_9 = "UNDEFINED_VEHICLE_PS_9",
  UNDEFINED_VEHICLE_PS_10 = "UNDEFINED_VEHICLE_PS_10",
  UNDEFINED_VEHICLE_PS_11 = "UNDEFINED_VEHICLE_PS_11",
  UNDEFINED_VEHICLE_PS_12 = "UNDEFINED_VEHICLE_PS_12",
  UNDEFINED_VEHICLE_PS_13 = "UNDEFINED_VEHICLE_PS_13",
  UNDEFINED_VEHICLE_PS_14 = "UNDEFINED_VEHICLE_PS_14",
  UNDEFINED_VEHICLE_PS_15 = "UNDEFINED_VEHICLE_PS_15",
  UNDEFINED_VEHICLE_PS_16 = "UNDEFINED_VEHICLE_PS_16",
  UNDEFINED_VEHICLE_PS_17 = "UNDEFINED_VEHICLE_PS_17",
  UNDEFINED_VEHICLE_PS_18 = "UNDEFINED_VEHICLE_PS_18",
  UNDEFINED_VEHICLE_PS_19 = "UNDEFINED_VEHICLE_PS_19",
  UNDEFINED_VEHICLE_PS_20 = "UNDEFINED_VEHICLE_PS_20",
  UNDEFINED_VEHICLE_PS_21 = "UNDEFINED_VEHICLE_PS_21",
  UNDEFINED_VEHICLE_PS_22 = "UNDEFINED_VEHICLE_PS_22",
  UNDEFINED_VEHICLE_PS_23 = "UNDEFINED_VEHICLE_PS_23",
  UNDEFINED_VEHICLE_PS_24 = "UNDEFINED_VEHICLE_PS_24",
  UNDEFINED_VEHICLE_PS_25 = "UNDEFINED_VEHICLE_PS_25",
  UNDEFINED_VEHICLE_PS_26 = "UNDEFINED_VEHICLE_PS_26",
  UNDEFINED_VEHICLE_PS_27 = "UNDEFINED_VEHICLE_PS_27",
  UNDEFINED_VEHICLE_PS_28 = "UNDEFINED_VEHICLE_PS_28",
  UNDEFINED_VEHICLE_PS_29 = "UNDEFINED_VEHICLE_PS_29",
  UNDEFINED_VEHICLE_PS_30 = "UNDEFINED_VEHICLE_PS_30",
  UNDEFINED_VEHICLE_PS_31 = "UNDEFINED_VEHICLE_PS_31",
  UNDEFINED_VEHICLE_PS_32 = "UNDEFINED_VEHICLE_PS_32",
  UNDEFINED_VEHICLE_PS_33 = "UNDEFINED_VEHICLE_PS_33",
  UNDEFINED_VEHICLE_PS_34 = "UNDEFINED_VEHICLE_PS_34",
  UNDEFINED_VEHICLE_PS_35 = "UNDEFINED_VEHICLE_PS_35",
  UNDEFINED_VEHICLE_PS_36 = "UNDEFINED_VEHICLE_PS_36",
  UNDEFINED_VEHICLE_PS_37 = "UNDEFINED_VEHICLE_PS_37",
  UNDEFINED_VEHICLE_PS_38 = "UNDEFINED_VEHICLE_PS_38",
  UNDEFINED_VEHICLE_PS_39 = "UNDEFINED_VEHICLE_PS_39",
  UNDEFINED_VEHICLE_PS_40 = "UNDEFINED_VEHICLE_PS_40",
  UNDEFINED_VEHICLE_PS_41 = "UNDEFINED_VEHICLE_PS_41",
  UNDEFINED_VEHICLE_PS_42 = "UNDEFINED_VEHICLE_PS_42",
  UNDEFINED_VEHICLE_PS_43 = "UNDEFINED_VEHICLE_PS_43",
  UNDEFINED_VEHICLE_PS_44 = "UNDEFINED_VEHICLE_PS_44",
  UNDEFINED_VEHICLE_PS_45 = "UNDEFINED_VEHICLE_PS_45",
  UNDEFINED_VEHICLE_PS_46 = "UNDEFINED_VEHICLE_PS_46",
  MISC_VEHICLE_PS = "MISC_VEHICLE_PS",
  UNASSIGNED_1 = "UNASSIGNED_1",
  UNASSIGNED_2 = "UNASSIGNED_2",
  UNASSIGNED_3 = "UNASSIGNED_3",
  UNASSIGNED_4 = "UNASSIGNED_4",
  UNASSIGNED_5 = "UNASSIGNED_5",
  UNASSIGNED_6 = "UNASSIGNED_6",
  UNASSIGNED_7 = "UNASSIGNED_7",
  UNASSIGNED_8 = "UNASSIGNED_8",
  UNASSIGNED_9 = "UNASSIGNED_9",
  UNASSIGNED_10 = "UNASSIGNED_10",
  UNASSIGNED_11 = "UNASSIGNED_11",
  UNASSIGNED_12 = "UNASSIGNED_12",
  UNASSIGNED_13 = "UNASSIGNED_13",
  UNASSIGNED_14 = "UNASSIGNED_14",
  UNASSIGNED_15 = "UNASSIGNED_15",
  UNASSIGNED_16 = "UNASSIGNED_16",
  UNASSIGNED_17 = "UNASSIGNED_17",
  UNASSIGNED_18 = "UNASSIGNED_18",
  UNASSIGNED_19 = "UNASSIGNED_19",
  UNASSIGNED_20 = "UNASSIGNED_20",
  UNASSIGNED_21 = "UNASSIGNED_21",
  UNASSIGNED_22 = "UNASSIGNED_22",
  UNASSIGNED_23 = "UNASSIGNED_23",
  UNASSIGNED_24 = "UNASSIGNED_24",
  UNASSIGNED_25 = "UNASSIGNED_25",
  UNASSIGNED_26 = "UNASSIGNED_26",
  UNASSIGNED_27 = "UNASSIGNED_27",
  UNASSIGNED_28 = "UNASSIGNED_28",
  UNASSIGNED_29 = "UNASSIGNED_29",
  UNASSIGNED_REPAIR_1 = "UNASSIGNED_REPAIR_1",
  UNASSIGNED_REPAIR_2 = "UNASSIGNED_REPAIR_2",
  UNASSIGNED_REPAIR_3 = "UNASSIGNED_REPAIR_3",
  UNASSIGNED_REPAIR_4 = "UNASSIGNED_REPAIR_4",
  UNASSIGNED_AUTO_PS_1 = "UNASSIGNED_AUTO_PS_1",
  UNASSIGNED_AUTO_PS_2 = "UNASSIGNED_AUTO_PS_2",
  UNASSIGNED_AUTO_PS_3 = "UNASSIGNED_AUTO_PS_3",
  UNASSIGNED_AUTO_PS_4 = "UNASSIGNED_AUTO_PS_4",
  SCALES = "SCALES",
  SHOWER = "SHOWER",
  TIRE_REPAIR = "TIRE_REPAIR",
  LODGING = "LODGING",
  WASH_OUT = "WASH_OUT",
  TRAILER_WASH = "TRAILER_WASH",
  RV_DUMP_FEE = "RV_DUMP_FEE",
  EV_CHARGE = "EV_CHARGE",
  EV_BATTERY_ECH = "EV_BATTERY_ECH",
  TOLL = "TOLL",
  STORAGE = "STORAGE",
  AIRCRAFT_GROUND_HAULING = "AIRCRAFT_GROUND_HAULING",
  AIRCRAFT_GROUND_PU = "AIRCRAFT_GROUND_PU",
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  AIRCRAFT_WO = "AIRCRAFT_WO",
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  TRANSPORTATION = "TRANSPORTATION",
  DE_ICING = "DE_ICING",
  RAMP_FEES = "RAMP_FEES",
  CATERING = "CATERING",
  HANGAR_FEE = "HANGAR_FEE",
  APU = "APU",
  LANDING_FEE = "LANDING_FEE",
  CALL_OUT_FEE = "CALL_OUT_FEE",
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  FLIGHT_PLANS = "FLIGHT_PLANS",
  FLIGHT_PLANNING_FEES = "FLIGHT_PLANNING_FEES",
  WEATHER_FEES = "WEATHER_FEES",
  CHARTER_FEE = "CHARTER_FEE",
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  CARGO_HANDLING = "CARGO_HANDLING",
  AIRCRAFT_ACC = "AIRCRAFT_ACC",
  AVIONICS = "AVIONICS",
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  AIRCRAFT_PARKING_FEE = "AIRCRAFT_PARKING_FEE",
  AIRCRAFT_TIE_DOWN_FEE = "AIRCRAFT_TIE_DOWN_FEE",
  AIRCRAFT_SANITATION = "AIRCRAFT_SANITATION",
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  AC_PARTS = "AC_PARTS",
  OXYGEN = "OXYGEN",
  DE_FUEL = "DE_FUEL",
  RE_SERVICE = "RE_SERVICE",
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  AIRPORT_FEE = "AIRPORT_FEE",
  OVERTIME_FEE = "OVERTIME_FEE",
  IT_BLADDER = "IT_BLADDER",
  GES_FEE = "GES_FEE",
  SECURE_FEE = "SECURE_FEE",
  FLOW_FEE = "FLOW_FEE",
  UNDEFINED_AVIATION_1 = "UNDEFINED_AVIATION_1",
  UNDEFINED_AVIATION_2 = "UNDEFINED_AVIATION_2",
  UNDEFINED_AVIATION_3 = "UNDEFINED_AVIATION_3",
  UNDEFINED_AVIATION_4 = "UNDEFINED_AVIATION_4",
  UNDEFINED_AVIATION_5 = "UNDEFINED_AVIATION_5",
  UNDEFINED_AVIATION_6 = "UNDEFINED_AVIATION_6",
  UNDEFINED_AVIATION_7 = "UNDEFINED_AVIATION_7",
  UNDEFINED_AVIATION_8 = "UNDEFINED_AVIATION_8",
  UNDEFINED_AVIATION_9 = "UNDEFINED_AVIATION_9",
  UNDEFINED_AVIATION_10 = "UNDEFINED_AVIATION_10",
  MISC_AV_PS = "MISC_AV_PS",
  MARINE_SERVICE = "MARINE_SERVICE",
  MARINE_LABOR = "MARINE_LABOR",
  MARINE_WO = "MARINE_WO",
  LAUNCH_FEE = "LAUNCH_FEE",
  SLIP_RENTAL = "SLIP_RENTAL",
  UNDEFINED_MARINE_SERVICES_1 = "UNDEFINED_MARINE_SERVICES_1",
  UNDEFINED_MARINE_SERVICES_2 = "UNDEFINED_MARINE_SERVICES_2",
  UNDEFINED_MARINE_SERVICES_3 = "UNDEFINED_MARINE_SERVICES_3",
  UNDEFINED_MARINE_SERVICES_4 = "UNDEFINED_MARINE_SERVICES_4",
  UNDEFINED_MARINE_SERVICES_5 = "UNDEFINED_MARINE_SERVICES_5",
  UNDEFINED_MARINE_SERVICES_6 = "UNDEFINED_MARINE_SERVICES_6",
  UNDEFINED_MARINE_SERVICES_7 = "UNDEFINED_MARINE_SERVICES_7",
  UNDEFINED_MARINE_SERVICES_8 = "UNDEFINED_MARINE_SERVICES_8",
  UNDEFINED_MARINE_SERVICES_9 = "UNDEFINED_MARINE_SERVICES_9",
  UNDEFINED_MARINE_SERVICES_10 = "UNDEFINED_MARINE_SERVICES_10",
  UNDEFINED_MARINE_SERVICES_11 = "UNDEFINED_MARINE_SERVICES_11",
  UNDEFINED_MARINE_SERVICES_12 = "UNDEFINED_MARINE_SERVICES_12",
  UNDEFINED_MARINE_SERVICES_13 = "UNDEFINED_MARINE_SERVICES_13",
  UNDEFINED_MARINE_SERVICES_14 = "UNDEFINED_MARINE_SERVICES_14",
  UNDEFINED_MARINE_SERVICES_15 = "UNDEFINED_MARINE_SERVICES_15",
  UNDEFINED_MARINE_SERVICES_16 = "UNDEFINED_MARINE_SERVICES_16",
  UNDEFINED_MARINE_SERVICES_17 = "UNDEFINED_MARINE_SERVICES_17",
  UNDEFINED_MARINE_SERVICES_18 = "UNDEFINED_MARINE_SERVICES_18",
  UNDEFINED_MARINE_SERVICES_19 = "UNDEFINED_MARINE_SERVICES_19",
  UNDEFINED_MARINE_SERVICES_20 = "UNDEFINED_MARINE_SERVICES_20",
  UNDEFINED_MARINE_SERVICES_21 = "UNDEFINED_MARINE_SERVICES_21",
  UNDEFINED_MARINE_SERVICES_22 = "UNDEFINED_MARINE_SERVICES_22",
  UNDEFINED_MARINE_SERVICES_23 = "UNDEFINED_MARINE_SERVICES_23",
  UNDEFINED_MARINE_SERVICES_24 = "UNDEFINED_MARINE_SERVICES_24",
  UNDEFINED_MARINE_SERVICES_25 = "UNDEFINED_MARINE_SERVICES_25",
  UNDEFINED_MARINE_SERVICES_26 = "UNDEFINED_MARINE_SERVICES_26",
  UNDEFINED_MARINE_SERVICES_27 = "UNDEFINED_MARINE_SERVICES_27",
  UNDEFINED_MARINE_SERVICES_28 = "UNDEFINED_MARINE_SERVICES_28",
  UNDEFINED_MARINE_SERVICES_29 = "UNDEFINED_MARINE_SERVICES_29",
  UNDEFINED_MARINE_SERVICES_30 = "UNDEFINED_MARINE_SERVICES_30",
  UNDEFINED_MARINE_SERVICES_31 = "UNDEFINED_MARINE_SERVICES_31",
  UNDEFINED_MARINE_SERVICES_32 = "UNDEFINED_MARINE_SERVICES_32",
  UNDEFINED_MARINE_SERVICES_33 = "UNDEFINED_MARINE_SERVICES_33",
  UNDEFINED_MARINE_SERVICES_34 = "UNDEFINED_MARINE_SERVICES_34",
  UNDEFINED_MARINE_SERVICES_35 = "UNDEFINED_MARINE_SERVICES_35",
  UNDEFINED_MARINE_SERVICES_36 = "UNDEFINED_MARINE_SERVICES_36",
  UNDEFINED_MARINE_SERVICES_37 = "UNDEFINED_MARINE_SERVICES_37",
  UNDEFINED_MARINE_SERVICES_38 = "UNDEFINED_MARINE_SERVICES_38",
  UNDEFINED_MARINE_SERVICES_39 = "UNDEFINED_MARINE_SERVICES_39",
  UNDEFINED_MARINE_SERVICES_40 = "UNDEFINED_MARINE_SERVICES_40",
  UNDEFINED_MARINE_SERVICES_41 = "UNDEFINED_MARINE_SERVICES_41",
  UNDEFINED_MARINE_SERVICES_42 = "UNDEFINED_MARINE_SERVICES_42",
  UNDEFINED_MARINE_SERVICES_43 = "UNDEFINED_MARINE_SERVICES_43",
  UNDEFINED_MARINE_SERVICES_44 = "UNDEFINED_MARINE_SERVICES_44",
  MISC_MARINE_PS = "MISC_MARINE_PS",
  GEN_MERCH = "GEN_MERCH",
  GEN_ICE = "GEN_ICE",
  GEN_UNDEFINED_1 = "GEN_UNDEFINED_1",
  GEN_UNDEFINED_2 = "GEN_UNDEFINED_2",
  GEN_UNDEFINED_3 = "GEN_UNDEFINED_3",
  GEN_UNDEFINED_4 = "GEN_UNDEFINED_4",
  GEN_UNDEFINED_5 = "GEN_UNDEFINED_5",
  GEN_UNDEFINED_6 = "GEN_UNDEFINED_6",
  GEN_UNDEFINED_7 = "GEN_UNDEFINED_7",
  GEN_UNDEFINED_8 = "GEN_UNDEFINED_8",
  GEN_TOBACCO = "GEN_TOBACCO",
  CIGARETTES = "CIGARETTES",
  TOBACCO_OTHER = "TOBACCO_OTHER",
  UNDEFINED_TOBACCO_1 = "UNDEFINED_TOBACCO_1",
  UNDEFINED_TOBACCO_2 = "UNDEFINED_TOBACCO_2",
  UNDEFINED_TOBACCO_3 = "UNDEFINED_TOBACCO_3",
  UNDEFINED_TOBACCO_4 = "UNDEFINED_TOBACCO_4",
  UNDEFINED_TOBACCO_5 = "UNDEFINED_TOBACCO_5",
  UNDEFINED_TOBACCO_6 = "UNDEFINED_TOBACCO_6",
  UNDEFINED_TOBACCO_7 = "UNDEFINED_TOBACCO_7",
  GEN_PACKAGED_BEV = "GEN_PACKAGED_BEV",
  PACKAGED_BEV_NA = "PACKAGED_BEV_NA",
  PACKAGED_JUICE = "PACKAGED_JUICE",
  OTHER_PACKAGED_BEV = "OTHER_PACKAGED_BEV",
  UNDEFINED_PACKAGED_BEV_1 = "UNDEFINED_PACKAGED_BEV_1",
  UNDEFINED_PACKAGED_BEV_2 = "UNDEFINED_PACKAGED_BEV_2",
  UNDEFINED_PACKAGED_BEV_3 = "UNDEFINED_PACKAGED_BEV_3",
  UNDEFINED_PACKAGED_BEV_4 = "UNDEFINED_PACKAGED_BEV_4",
  UNDEFINED_PACKAGED_BEV_5 = "UNDEFINED_PACKAGED_BEV_5",
  UNDEFINED_PACKAGED_BEV_6 = "UNDEFINED_PACKAGED_BEV_6",
  GEN_DISPENSED_BEV = "GEN_DISPENSED_BEV",
  SODA = "SODA",
  HOT_DISPENSED_BEV = "HOT_DISPENSED_BEV",
  COLD_DISPENSED_BEV = "COLD_DISPENSED_BEV",
  FROZEN_DISPENSED_BEV = "FROZEN_DISPENSED_BEV",
  OTHER_DISPENSED_BEV = "OTHER_DISPENSED_BEV",
  UNDEFINED_DISPENSED_BEV_1 = "UNDEFINED_DISPENSED_BEV_1",
  UNDEFINED_DISPENSED_BEV_2 = "UNDEFINED_DISPENSED_BEV_2",
  UNDEFINED_DISPENSED_BEV_3 = "UNDEFINED_DISPENSED_BEV_3",
  UNDEFINED_DISPENSED_BEV_4 = "UNDEFINED_DISPENSED_BEV_4",
  UNDEFINED_DISPENSED_BEV_5 = "UNDEFINED_DISPENSED_BEV_5",
  UNASSIGNED_BEV_1 = "UNASSIGNED_BEV_1",
  UNASSIGNED_BEV_2 = "UNASSIGNED_BEV_2",
  UNASSIGNED_BEV_3 = "UNASSIGNED_BEV_3",
  UNASSIGNED_BEV_4 = "UNASSIGNED_BEV_4",
  UNASSIGNED_BEV_5 = "UNASSIGNED_BEV_5",
  UNASSIGNED_BEV_6 = "UNASSIGNED_BEV_6",
  UNASSIGNED_BEV_7 = "UNASSIGNED_BEV_7",
  GEN_SNACKS = "GEN_SNACKS",
  SALTY_SNACKS = "SALTY_SNACKS",
  ALT_SNACKS = "ALT_SNACKS",
  SWEET_SNACKS = "SWEET_SNACKS",
  UNDEFINED_SNACKS_1 = "UNDEFINED_SNACKS_1",
  UNDEFINED_SNACKS_2 = "UNDEFINED_SNACKS_2",
  UNDEFINED_SNACKS_3 = "UNDEFINED_SNACKS_3",
  UNDEFINED_SNACKS_4 = "UNDEFINED_SNACKS_4",
  UNDEFINED_SNACKS_5 = "UNDEFINED_SNACKS_5",
  UNDEFINED_SNACKS_6 = "UNDEFINED_SNACKS_6",
  GEN_CANDY = "GEN_CANDY",
  UNDEFINED_CANDY_1 = "UNDEFINED_CANDY_1",
  UNDEFINED_CANDY_2 = "UNDEFINED_CANDY_2",
  UNDEFINED_CANDY_3 = "UNDEFINED_CANDY_3",
  UNDEFINED_CANDY_4 = "UNDEFINED_CANDY_4",
  UNDEFINED_CANDY_5 = "UNDEFINED_CANDY_5",
  UNDEFINED_CANDY_6 = "UNDEFINED_CANDY_6",
  UNDEFINED_CANDY_7 = "UNDEFINED_CANDY_7",
  UNDEFINED_CANDY_8 = "UNDEFINED_CANDY_8",
  UNDEFINED_CANDY_9 = "UNDEFINED_CANDY_9",
  GEN_DAIRY = "GEN_DAIRY",
  FLUID_MILK = "FLUID_MILK",
  PACKAGED_ICE_CREAM = "PACKAGED_ICE_CREAM",
  OTHER_DAIRY = "OTHER_DAIRY",
  UNDEFINED_DAIRY_1 = "UNDEFINED_DAIRY_1",
  UNDEFINED_DAIRY_2 = "UNDEFINED_DAIRY_2",
  UNDEFINED_DAIRY_3 = "UNDEFINED_DAIRY_3",
  UNDEFINED_DAIRY_4 = "UNDEFINED_DAIRY_4",
  UNDEFINED_DAIRY_5 = "UNDEFINED_DAIRY_5",
  UNDEFINED_DAIRY_6 = "UNDEFINED_DAIRY_6",
  GEN_GROCERY = "GEN_GROCERY",
  GROCERY_EDIBLE = "GROCERY_EDIBLE",
  GROCERY_NON_EDIBLE = "GROCERY_NON_EDIBLE",
  GROCERY_PERISHABLE = "GROCERY_PERISHABLE",
  UNASSIGNED_GROCERY_1 = "UNASSIGNED_GROCERY_1",
  UNASSIGNED_GROCERY_2 = "UNASSIGNED_GROCERY_2",
  UNASSIGNED_GROCERY_3 = "UNASSIGNED_GROCERY_3",
  UNASSIGNED_GROCERY_4 = "UNASSIGNED_GROCERY_4",
  UNASSIGNED_GROCERY_5 = "UNASSIGNED_GROCERY_5",
  UNASSIGNED_GROCERY_6 = "UNASSIGNED_GROCERY_6",
  PACKAGED_BREAD = "PACKAGED_BREAD",
  FROZEN_FOOD = "FROZEN_FOOD",
  UNDEFINED_GROCERY_1 = "UNDEFINED_GROCERY_1",
  UNDEFINED_GROCERY_2 = "UNDEFINED_GROCERY_2",
  UNDEFINED_GROCERY_3 = "UNDEFINED_GROCERY_3",
  UNDEFINED_GROCERY_4 = "UNDEFINED_GROCERY_4",
  GEN_ALCOHOL = "GEN_ALCOHOL",
  BEER = "BEER",
  BEER_NA = "BEER_NA",
  WINE = "WINE",
  LIQUOR = "LIQUOR",
  UNDEFINED_ALCOHOL_1 = "UNDEFINED_ALCOHOL_1",
  UNDEFINED_ALCOHOL_2 = "UNDEFINED_ALCOHOL_2",
  UNDEFINED_ALCOHOL_3 = "UNDEFINED_ALCOHOL_3",
  UNDEFINED_ALCOHOL_4 = "UNDEFINED_ALCOHOL_4",
  UNDEFINED_ALCOHOL_5 = "UNDEFINED_ALCOHOL_5",
  GEN_DELI = "GEN_DELI",
  PACKAGED_DELI = "PACKAGED_DELI",
  PREPARED_FOOD = "PREPARED_FOOD",
  DELI_ITEMS = "DELI_ITEMS",
  UNDEFINED_DELI_1 = "UNDEFINED_DELI_1",
  UNDEFINED_DELI_2 = "UNDEFINED_DELI_2",
  UNDEFINED_DELI_3 = "UNDEFINED_DELI_3",
  UNDEFINED_DELI_4 = "UNDEFINED_DELI_4",
  UNDEFINED_DELI_5 = "UNDEFINED_DELI_5",
  UNDEFINED_DELI_6 = "UNDEFINED_DELI_6",
  GEN_FOODSERVICE = "GEN_FOODSERVICE",
  UNDEFINED_FOODSERVICE_1 = "UNDEFINED_FOODSERVICE_1",
  UNDEFINED_FOODSERVICE_2 = "UNDEFINED_FOODSERVICE_2",
  UNDEFINED_FOODSERVICE_3 = "UNDEFINED_FOODSERVICE_3",
  UNDEFINED_FOODSERVICE_4 = "UNDEFINED_FOODSERVICE_4",
  UNDEFINED_FOODSERVICE_5 = "UNDEFINED_FOODSERVICE_5",
  UNDEFINED_FOODSERVICE_6 = "UNDEFINED_FOODSERVICE_6",
  UNDEFINED_FOODSERVICE_7 = "UNDEFINED_FOODSERVICE_7",
  UNDEFINED_FOODSERVICE_8 = "UNDEFINED_FOODSERVICE_8",
  UNDEFINED_FOODSERVICE_9 = "UNDEFINED_FOODSERVICE_9",
  GEN_LOTTERY = "GEN_LOTTERY",
  LOTTERY_IN = "LOTTERY_IN",
  LOTTERY_ON = "LOTTERY_ON",
  LOTTERY_OTHER = "LOTTERY_OTHER",
  UNDEFINED_LOTTERY_1 = "UNDEFINED_LOTTERY_1",
  UNDEFINED_LOTTERY_2 = "UNDEFINED_LOTTERY_2",
  UNDEFINED_LOTTERY_3 = "UNDEFINED_LOTTERY_3",
  UNDEFINED_LOTTERY_4 = "UNDEFINED_LOTTERY_4",
  UNDEFINED_LOTTERY_5 = "UNDEFINED_LOTTERY_5",
  UNDEFINED_LOTTERY_6 = "UNDEFINED_LOTTERY_6",
  GEN_MONEY_ORDER = "GEN_MONEY_ORDER",
  MONEY_ORDER_VP = "MONEY_ORDER_VP",
  MONEY_ORDER_PC = "MONEY_ORDER_PC",
  MONEY_ORDER_GC = "MONEY_ORDER_GC",
  MONEY_ORDER_REFC = "MONEY_ORDER_REFC",
  MONEY_ORDER_OC = "MONEY_ORDER_OC",
  MONEY_ORDER_REBC = "MONEY_ORDER_REBC",
  MONEY_ORDER_DC = "MONEY_ORDER_DC",
  MONEY_ORDER_UC = "MONEY_ORDER_UC",
  UNDEFINED_MONEY_ORDER = "UNDEFINED_MONEY_ORDER",
  GEN_STORE_SERVICE = "GEN_STORE_SERVICE",
  HOME_DELIVERY = "HOME_DELIVERY",
  MISC = "MISC",
  SALES_TAX_NON_FUEL = "SALES_TAX_NON_FUEL",
  UNASSIGNED_30 = "UNASSIGNED_30",
  UNASSIGNED_31 = "UNASSIGNED_31",
  UNASSIGNED_32 = "UNASSIGNED_32",
  UNASSIGNED_33 = "UNASSIGNED_33",
  UNASSIGNED_34 = "UNASSIGNED_34",
  UNASSIGNED_35 = "UNASSIGNED_35",
  UNASSIGNED_36 = "UNASSIGNED_36",
  UNASSIGNED_37 = "UNASSIGNED_37",
  PREPAID_PURCHASE = "PREPAID_PURCHASE",
  PREPAID_ACT = "PREPAID_ACT",
  MEMBERSHIP = "MEMBERSHIP",
  UNDEFINED_STORE_SERVICES_1 = "UNDEFINED_STORE_SERVICES_1",
  UNDEFINED_STORE_SERVICES_2 = "UNDEFINED_STORE_SERVICES_2",
  UNDEFINED_STORE_SERVICES_3 = "UNDEFINED_STORE_SERVICES_3",
  UNDEFINED_STORE_SERVICES_4 = "UNDEFINED_STORE_SERVICES_4",
  UNDEFINED_STORE_SERVICES_5 = "UNDEFINED_STORE_SERVICES_5",
  GEN_HEALTH = "GEN_HEALTH",
  UNDEFINED_HEALTH_1 = "UNDEFINED_HEALTH_1",
  UNDEFINED_HEALTH_2 = "UNDEFINED_HEALTH_2",
  UNDEFINED_HEALTH_3 = "UNDEFINED_HEALTH_3",
  UNDEFINED_HEALTH_4 = "UNDEFINED_HEALTH_4",
  UNDEFINED_HEALTH_5 = "UNDEFINED_HEALTH_5",
  UNDEFINED_HEALTH_6 = "UNDEFINED_HEALTH_6",
  UNDEFINED_HEALTH_7 = "UNDEFINED_HEALTH_7",
  UNDEFINED_HEALTH_8 = "UNDEFINED_HEALTH_8",
  UNDEFINED_HEALTH_9 = "UNDEFINED_HEALTH_9",
  GEN_PUBLICATIONS = "GEN_PUBLICATIONS",
  UNDEFINED_PUBLICATIONS_1 = "UNDEFINED_PUBLICATIONS_1",
  UNDEFINED_PUBLICATIONS_2 = "UNDEFINED_PUBLICATIONS_2",
  UNDEFINED_PUBLICATIONS_3 = "UNDEFINED_PUBLICATIONS_3",
  UNDEFINED_PUBLICATIONS_4 = "UNDEFINED_PUBLICATIONS_4",
  UNDEFINED_PUBLICATIONS_5 = "UNDEFINED_PUBLICATIONS_5",
  UNDEFINED_PUBLICATIONS_6 = "UNDEFINED_PUBLICATIONS_6",
  UNDEFINED_PUBLICATIONS_7 = "UNDEFINED_PUBLICATIONS_7",
  UNDEFINED_PUBLICATIONS_8 = "UNDEFINED_PUBLICATIONS_8",
  UNDEFINED_PUBLICATIONS_9 = "UNDEFINED_PUBLICATIONS_9",
  PIN_PREPAID_ACT = "PIN_PREPAID_ACT",
  PIN_PREPAID_RET = "PIN_PREPAID_RET",
  ENABLE_HANDSET = "ENABLE_HANDSET",
  DISABLE_HANDSET = "DISABLE_HANDSET",
  THIRD_PARTY_PREPAID_ACT = "THIRD_PARTY_PREPAID_ACT",
  THIRD_PARTY_PREPAID_REL = "THIRD_PARTY_PREPAID_REL",
  FIN_PREPAID_ACT = "FIN_PREPAID_ACT",
  FIN_PREPAID_REL = "FIN_PREPAID_REL",
  PROP_PREPAID_ACT = "PROP_PREPAID_ACT",
  PROP_PREPAID_REL = "PROP_PREPAID_REL",
  GEN_PURPOSE_ACT = "GEN_PURPOSE_ACT",
  GEN_PURPOSE_REL = "GEN_PURPOSE_REL",
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  WL_REAL_TIME_RECHARGE = "WL_REAL_TIME_RECHARGE",
  SINGLE_BILL_PAY = "SINGLE_BILL_PAY",
  MULTI_BILL_PAY = "MULTI_BILL_PAY",
  UNDEFINED_BILL_PAY_1 = "UNDEFINED_BILL_PAY_1",
  UNDEFINED_BILL_PAY_2 = "UNDEFINED_BILL_PAY_2",
  UNDEFINED_BILL_PAY_3 = "UNDEFINED_BILL_PAY_3",
  UNDEFINED_BILL_PAY_4 = "UNDEFINED_BILL_PAY_4",
  UNDEFINED_BILL_PAY_5 = "UNDEFINED_BILL_PAY_5",
  UNDEFINED_BILL_PAY_6 = "UNDEFINED_BILL_PAY_6",
  UNDEFINED_BILL_PAY_7 = "UNDEFINED_BILL_PAY_7",
  UNDEFINED_BILL_PAY_8 = "UNDEFINED_BILL_PAY_8",
  UNDEFINED_BILL_PAY_9 = "UNDEFINED_BILL_PAY_9",
  UNDEFINED_BILL_PAY_10 = "UNDEFINED_BILL_PAY_10",
  UNDEFINED_BILL_PAY_11 = "UNDEFINED_BILL_PAY_11",
  UNDEFINED_BILL_PAY_12 = "UNDEFINED_BILL_PAY_12",
  UNDEFINED_BILL_PAY_13 = "UNDEFINED_BILL_PAY_13",
  UNDEFINED_BILL_PAY_14 = "UNDEFINED_BILL_PAY_14",
  UNDEFINED_BILL_PAY_15 = "UNDEFINED_BILL_PAY_15",
  UNDEFINED_MERCHANDISE_1 = "UNDEFINED_MERCHANDISE_1",
  UNDEFINED_MERCHANDISE_2 = "UNDEFINED_MERCHANDISE_2",
  UNDEFINED_MERCHANDISE_3 = "UNDEFINED_MERCHANDISE_3",
  UNDEFINED_MERCHANDISE_4 = "UNDEFINED_MERCHANDISE_4",
  UNDEFINED_MERCHANDISE_5 = "UNDEFINED_MERCHANDISE_5",
  UNDEFINED_MERCHANDISE_6 = "UNDEFINED_MERCHANDISE_6",
  UNDEFINED_MERCHANDISE_7 = "UNDEFINED_MERCHANDISE_7",
  UNDEFINED_MERCHANDISE_8 = "UNDEFINED_MERCHANDISE_8",
  UNDEFINED_MERCHANDISE_9 = "UNDEFINED_MERCHANDISE_9",
  CBD = "CBD",
  UNDEFINED_CBD_1 = "UNDEFINED_CBD_1",
  UNDEFINED_CBD_2 = "UNDEFINED_CBD_2",
  UNDEFINED_CBD_3 = "UNDEFINED_CBD_3",
  UNDEFINED_CBD_4 = "UNDEFINED_CBD_4",
  UNDEFINED_CBD_5 = "UNDEFINED_CBD_5",
  UNDEFINED_CBD_6 = "UNDEFINED_CBD_6",
  UNDEFINED_CBD_7 = "UNDEFINED_CBD_7",
  UNDEFINED_CBD_8 = "UNDEFINED_CBD_8",
  UNDEFINED_CBD_9 = "UNDEFINED_CBD_9",
  UNDEFINED_CBD_10 = "UNDEFINED_CBD_10",
  UNDEFINED_CBD_11 = "UNDEFINED_CBD_11",
  UNDEFINED_CBD_12 = "UNDEFINED_CBD_12",
  UNDEFINED_CBD_13 = "UNDEFINED_CBD_13",
  UNDEFINED_CBD_14 = "UNDEFINED_CBD_14",
  UNDEFINED_CBD_15 = "UNDEFINED_CBD_15",
  UNDEFINED_CBD_16 = "UNDEFINED_CBD_16",
  UNDEFINED_CBD_17 = "UNDEFINED_CBD_17",
  UNDEFINED_CBD_18 = "UNDEFINED_CBD_18",
  UNDEFINED_CBD_19 = "UNDEFINED_CBD_19",
  DISCOUNT_1 = "DISCOUNT_1",
  DISCOUNT_2 = "DISCOUNT_2",
  DISCOUNT_3 = "DISCOUNT_3",
  DISCOUNT_4 = "DISCOUNT_4",
  DISCOUNT_5 = "DISCOUNT_5",
  COUPON_1 = "COUPON_1",
  COUPON_2 = "COUPON_2",
  COUPON_3 = "COUPON_3",
  COUPON_4 = "COUPON_4",
  COUPON_5 = "COUPON_5",
  LOTTERY_PO_IN = "LOTTERY_PO_IN",
  LOTTERY_PO_ON = "LOTTERY_PO_ON",
  LOTTERY_PO_OT = "LOTTERY_PO_OT",
  SPLIT_TENDER = "SPLIT_TENDER",
  TAX_DISCOUNT_F = "TAX_DISCOUNT_F",
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  POS_RES_DISCOUNT_1 = "POS_RES_DISCOUNT_1",
  POS_RES_DISCOUNT_2 = "POS_RES_DISCOUNT_2",
  POS_RES_DISCOUNT_3 = "POS_RES_DISCOUNT_3",
  POS_RES_DISCOUNT_4 = "POS_RES_DISCOUNT_4",
  POS_RES_DISCOUNT_5 = "POS_RES_DISCOUNT_5",
  MISC_NEG_ADMIN = "MISC_NEG_ADMIN",
  UNDEFINED_NEG_1 = "UNDEFINED_NEG_1",
  UNDEFINED_NEG_2 = "UNDEFINED_NEG_2",
  UNDEFINED_NEG_3 = "UNDEFINED_NEG_3",
  UNDEFINED_NEG_4 = "UNDEFINED_NEG_4",
  UNDEFINED_NEG_5 = "UNDEFINED_NEG_5",
  UNDEFINED_NEG_6 = "UNDEFINED_NEG_6",
  UNDEFINED_NEG_7 = "UNDEFINED_NEG_7",
  UNDEFINED_NEG_8 = "UNDEFINED_NEG_8",
  UNDEFINED_NEG_9 = "UNDEFINED_NEG_9",
  UNDEFINED_NEG_10 = "UNDEFINED_NEG_10",
  UNDEFINED_NEG_11 = "UNDEFINED_NEG_11",
  UNDEFINED_NEG_12 = "UNDEFINED_NEG_12",
  UNDEFINED_NEG_13 = "UNDEFINED_NEG_13",
  UNDEFINED_NEG_14 = "UNDEFINED_NEG_14",
  UNDEFINED_NEG_15 = "UNDEFINED_NEG_15",
  UNDEFINED_NEG_16 = "UNDEFINED_NEG_16",
  UNDEFINED_NEG_17 = "UNDEFINED_NEG_17",
  UNDEFINED_NEG_18 = "UNDEFINED_NEG_18",
  UNDEFINED_NEG_19 = "UNDEFINED_NEG_19",
  UNDEFINED_NEG_20 = "UNDEFINED_NEG_20",
  UNDEFINED_NEG_21 = "UNDEFINED_NEG_21",
  UNDEFINED_NEG_22 = "UNDEFINED_NEG_22",
  UNDEFINED_NEG_23 = "UNDEFINED_NEG_23",
  UNDEFINED_NEG_24 = "UNDEFINED_NEG_24",
  TAX_1 = "TAX_1",
  TAX_2 = "TAX_2",
  TAX_3 = "TAX_3",
  TAX_4 = "TAX_4",
  TAX_5 = "TAX_5",
  CASH_BACK = "CASH_BACK",
  CASH_BACK_FEE = "CASH_BACK_FEE",
  FEE_1 = "FEE_1",
  FEE_2 = "FEE_2",
  FEE_3 = "FEE_3",
  FEE_4 = "FEE_4",
  FEE_5 = "FEE_5",
  MISC_AV_TAX = "MISC_AV_TAX",
  GST_HST_VAT_1 = "GST_HST_VAT_1",
  PST_HST_VAT_2 = "PST_HST_VAT_2",
  SWT_RATE = "SWT_RATE",
  TAX_6 = "TAX_6",
  TAX_7 = "TAX_7",
  TAX_8 = "TAX_8",
  JET_FD_E_TAX = "JET_FD_E_TAX",
  AV_GAS_FED_E_TAX = "AV_GAS_FED_E_TAX",
  CHARITY = "CHARITY",
  GRATUITY = "GRATUITY",
  MISC_ADMIN = "MISC_ADMIN",
  UNDEFINED_AMIN_1 = "UNDEFINED_AMIN_1",
  UNDEFINED_AMIN_2 = "UNDEFINED_AMIN_2",
  UNDEFINED_AMIN_3 = "UNDEFINED_AMIN_3",
  UNDEFINED_AMIN_4 = "UNDEFINED_AMIN_4",
  UNDEFINED_AMIN_5 = "UNDEFINED_AMIN_5",
  UNDEFINED_AMIN_6 = "UNDEFINED_AMIN_6",
  UNDEFINED_AMIN_7 = "UNDEFINED_AMIN_7",
  UNDEFINED_AMIN_8 = "UNDEFINED_AMIN_8",
  UNDEFINED_AMIN_9 = "UNDEFINED_AMIN_9",
  UNDEFINED_AMIN_10 = "UNDEFINED_AMIN_10",
  UNDEFINED_AMIN_11 = "UNDEFINED_AMIN_11",
  UNDEFINED_AMIN_12 = "UNDEFINED_AMIN_12",
  UNDEFINED_AMIN_13 = "UNDEFINED_AMIN_13",
  UNDEFINED_AMIN_14 = "UNDEFINED_AMIN_14",
  UNDEFINED_AMIN_15 = "UNDEFINED_AMIN_15",
  UNDEFINED_AMIN_16 = "UNDEFINED_AMIN_16",
  UNDEFINED_AMIN_17 = "UNDEFINED_AMIN_17",
  UNDEFINED_AMIN_18 = "UNDEFINED_AMIN_18",
  UNDEFINED_AMIN_19 = "UNDEFINED_AMIN_19",
  UNDEFINED_AMIN_20 = "UNDEFINED_AMIN_20",
  UNDEFINED_AMIN_21 = "UNDEFINED_AMIN_21",
  UNDEFINED_AMIN_22 = "UNDEFINED_AMIN_22",
  UNDEFINED_AMIN_23 = "UNDEFINED_AMIN_23",
  UNDEFINED_AMIN_24 = "UNDEFINED_AMIN_24",
  UNDEFINED_AMIN_25 = "UNDEFINED_AMIN_25",
  UNDEFINED_AMIN_26 = "UNDEFINED_AMIN_26",
  UNKNOWN = "UNKNOWN",
}


export enum HNVisaLineItemDetailIndicator {
  NORMAL = "NORMAL",
  CREDIT = "CREDIT",
  PAYMENT = "PAYMENT",
}


export type HNVisaFleetL3EnhancedDataShipping = {
  __typename: "HNVisaFleetL3EnhancedDataShipping",
  amount?: HNAmount | null,
  signage?: HNVisaAmountSignage | null,
  taxAmount?: HNAmount | null,
  taxAmountSignage?: HNVisaAmountSignage | null,
  taxRate?: number | null,
};

export type HNVisaFleetL3EnhancedDataTax = {
  __typename: "HNVisaFleetL3EnhancedDataTax",
  treatment?: HNVisaTaxTreatment | null,
};

export enum HNVisaTaxTreatment {
  NLL = "NLL",
  NIL = "NIL",
  GLL = "GLL",
  GIL = "GIL",
  NON = "NON",
}


export type HNMastercardFleetEnhancedData = {
  __typename: "HNMastercardFleetEnhancedData",
  id: string,
  fuelBrand?: HNMastercardFleetFuelBrand | null,
  purchaseTime?: string | null,
  fuelServiceType?: HNMastercardFleetFuelServiceType | null,
  fuelType?: HNMastercardFleetProductCode | null,
  fuelUnitPrice?: HNAmount | null,
  fuelUnitPriceValue?: number | null,
  fuelUnitPriceValuePrecision?: number | null,
  fuelUnitOfMeasure?: HNMastercardFleetUnitOfMeasure | null,
  fuelQuantity?: number | null,
  fuelSaleAmount?: HNAmount | null,
  odometerReading?: string | null,
  vehicleNumber?: string | null,
  driverIdentification?: string | null,
  productType?: HNMastercardFleetProductType | null,
  fuelDiscountAmount?: HNAmount | null,
  taxAmount1?: HNAmount | null,
  taxAmount2?: HNAmount | null,
  fuelLocationDetails?: HNMastercardAdditionalFuelLocationDetails | null,
  lineItems?:  Array<HNMastercardFleetEnhancedDataLineItem > | null,
};

export enum HNMastercardFleetFuelBrand {
  HESS = "HESS",
  AMOCO = "AMOCO",
  ARCO = "ARCO",
  ASHLAND = "ASHLAND",
  BP = "BP",
  CENEX = "CENEX",
  CHEVRON = "CHEVRON",
  CIRCLE_K = "CIRCLE_K",
  CITGO = "CITGO",
  CLARK = "CLARK",
  CONOCO = "CONOCO",
  CROWN_CENTRAL = "CROWN_CENTRAL",
  GULF = "GULF",
  DIAMOND_SHAMROCK = "DIAMOND_SHAMROCK",
  EXXON = "EXXON",
  FINA = "FINA",
  FLYING_J = "FLYING_J",
  GETTY = "GETTY",
  KWIK_TRIP = "KWIK_TRIP",
  MAPCO = "MAPCO",
  MARATHON = "MARATHON",
  EXXON_MOBIL = "EXXON_MOBIL",
  MURPHY = "MURPHY",
  PENNZOIL = "PENNZOIL",
  PHILLIPS = "PHILLIPS",
  QUIK_TRIP = "QUIK_TRIP",
  RACETRAC = "RACETRAC",
  SHELL = "SHELL",
  SINCLAIR = "SINCLAIR",
  SOUTHLAND = "SOUTHLAND",
  SUN = "SUN",
  TEXACO = "TEXACO",
  TOSCO = "TOSCO",
  KWIK_FILL = "KWIK_FILL",
  GAS_AMERICA = "GAS_AMERICA",
  HANDY_WAY = "HANDY_WAY",
  HOLIDAY = "HOLIDAY",
  LOVES = "LOVES",
  PURE = "PURE",
  QUAKER_STATE = "QUAKER_STATE",
  THORNTON = "THORNTON",
  UNITED_DAIRY = "UNITED_DAIRY",
  US_OIL = "US_OIL",
  USA_PETROLEUM = "USA_PETROLEUM",
  VALVOLINE = "VALVOLINE",
  WESTERN_ENERGETIX = "WESTERN_ENERGETIX",
  CASEYS = "CASEYS",
  PETRO = "PETRO",
  PILOT = "PILOT",
  SHEETZ = "SHEETZ",
  SPEEDWAY = "SPEEDWAY",
  TESORO_AK = "TESORO_AK",
  TA = "TA",
  UNION_76 = "UNION_76",
  WARREN_EQUITIES = "WARREN_EQUITIES",
  WILCO = "WILCO",
  PDQ = "PDQ",
  WAWA = "WAWA",
  FKG = "FKG",
  GROWMARK = "GROWMARK",
  AAFES = "AAFES",
  GATE = "GATE",
  MFA = "MFA",
  NEXCOM = "NEXCOM",
  THE_PANTRY = "THE_PANTRY",
  ZIONS = "ZIONS",
  NORDSTROM = "NORDSTROM",
  QUARLES = "QUARLES",
  KROGER = "KROGER",
  ERICKSON = "ERICKSON",
  IRVING = "IRVING",
  HUCKS = "HUCKS",
  LASSUS = "LASSUS",
  FAMILY = "FAMILY",
  HOME_DEPOT = "HOME_DEPOT",
  DISCOUNT_TIRE = "DISCOUNT_TIRE",
  RACEWAY = "RACEWAY",
  MEINEKE = "MEINEKE",
  GIANT_EAGLE = "GIANT_EAGLE",
  RUDY = "RUDY",
  HYVEES = "HYVEES",
  SEVEN_ELEVEN = "SEVEN_ELEVEN",
  AMOCO_CA = "AMOCO_CA",
  CANADIAN_TIRE = "CANADIAN_TIRE",
  CANADIAN_TURBO = "CANADIAN_TURBO",
  CHEVRON_CA = "CHEVRON_CA",
  CONOCO_CA = "CONOCO_CA",
  DOMO = "DOMO",
  FAS = "FAS",
  SONIC = "SONIC",
  GULF_CA = "GULF_CA",
  HUSKY = "HUSKY",
  ESSO_CA = "ESSO_CA",
  IRVING_CA = "IRVING_CA",
  MOHAWK = "MOHAWK",
  MR_GAS = "MR_GAS",
  MURPHY_CA = "MURPHY_CA",
  OLCO = "OLCO",
  PETROCANADA = "PETROCANADA",
  PETRO_T = "PETRO_T",
  PIONEER = "PIONEER",
  SHELL_CA = "SHELL_CA",
  SEVEN_ELEVEN_CA = "SEVEN_ELEVEN_CA",
  SUNOCO_CA = "SUNOCO_CA",
  TEMPO = "TEMPO",
  ULTRAMAR = "ULTRAMAR",
  ASDA = "ASDA",
  BFL = "BFL",
  BP_MOBIL = "BP_MOBIL",
  BURNAH = "BURNAH",
  BUTLER = "BUTLER",
  ELF = "ELF",
  ESSO_EU = "ESSO_EU",
  FINA_EU = "FINA_EU",
  FLARE = "FLARE",
  GULF_CHEVRON = "GULF_CHEVRON",
  HERON = "HERON",
  JSAINSBURY = "JSAINSBURY",
  JET = "JET",
  KUWAIT = "KUWAIT",
  MAXOL = "MAXOL",
  MURCO = "MURCO",
  PIONEER_EU = "PIONEER_EU",
  REPSOL = "REPSOL",
  SAFEWAY = "SAFEWAY",
  SHELL_EU = "SHELL_EU",
  SPAR = "SPAR",
  TESCO_EU = "TESCO_EU",
  TEXACO_EU = "TEXACO_EU",
  TOTAL = "TOTAL",
  UK = "UK",
  VG = "VG",
  MORRISON = "MORRISON",
  UNBRANDED = "UNBRANDED",
}


export enum HNMastercardFleetFuelServiceType {
  UNDEFINED = "UNDEFINED",
  SELF_SERVICE = "SELF_SERVICE",
  FULL_SERVICE = "FULL_SERVICE",
  ONLY_NON_FUEL_PRODUCTS = "ONLY_NON_FUEL_PRODUCTS",
}


export enum HNMastercardFleetProductCode {
  REGULAR = "REGULAR",
  MID = "MID",
  PREMIUM = "PREMIUM",
  SUPER = "SUPER",
  REGULAR_METHANOL = "REGULAR_METHANOL",
  MID_METHANOL = "MID_METHANOL",
  PREMIUM_METHANOL = "PREMIUM_METHANOL",
  SUPER_METHANOL = "SUPER_METHANOL",
  LEADED_METHANOL = "LEADED_METHANOL",
  REGULAR_LEADED = "REGULAR_LEADED",
  DIESEL = "DIESEL",
  DIESEL_PREMIUM = "DIESEL_PREMIUM",
  KEROSENE = "KEROSENE",
  LPG = "LPG",
  CNG = "CNG",
  M85 = "M85",
  E85 = "E85",
  REGULAR_ETHANOL = "REGULAR_ETHANOL",
  MID_ETHANOL = "MID_ETHANOL",
  PREMIUM_ETHANOL = "PREMIUM_ETHANOL",
  SUPER_ETHANOL = "SUPER_ETHANOL",
  LEADED_ETHANOL = "LEADED_ETHANOL",
  UNLEADED_REFORMULATED = "UNLEADED_REFORMULATED",
  UNLEADED_MID_REFORMULATED = "UNLEADED_MID_REFORMULATED",
  DYED_DIESEL = "DYED_DIESEL",
  GASOHOL = "GASOHOL",
  BIODIESEL = "BIODIESEL",
  ULSD = "ULSD",
  MOTOR_OIL = "MOTOR_OIL",
  OIL_CHANGE = "OIL_CHANGE",
  ENGINE_SERVICE = "ENGINE_SERVICE",
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  BRAKE_SERVICE = "BRAKE_SERVICE",
  SOLVENT = "SOLVENT",
  BRAKE_FLUID = "BRAKE_FLUID",
  MISC_PARTS = "MISC_PARTS",
  MISC_LABOR = "MISC_LABOR",
  MISC_REPAIRS = "MISC_REPAIRS",
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  TIRES = "TIRES",
  BATTERIES = "BATTERIES",
  AUTO_ACC = "AUTO_ACC",
  AUTO_GLASS = "AUTO_GLASS",
  CAR_WASH = "CAR_WASH",
  TOWING = "TOWING",
  DEF = "DEF",
  CIGARETTES = "CIGARETTES",
  HEALTH_BEAUTY = "HEALTH_BEAUTY",
  MISC_FOOD = "MISC_FOOD",
  SODA = "SODA",
  BEER_WINE = "BEER_WINE",
  MILK_JUICE = "MILK_JUICE",
  RESTAURANT = "RESTAURANT",
  MISC_BEV = "MISC_BEV",
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  AV_FUEL_100 = "AV_FUEL_100",
  JET_FUEL = "JET_FUEL",
  AV_FUEL = "AV_FUEL",
  MARINE_FUEL = "MARINE_FUEL",
  MISC_FUEL = "MISC_FUEL",
  LNG = "LNG",
  WHITE_GAS = "WHITE_GAS",
  RACING_FUEL = "RACING_FUEL",
  EV_LEVEL_1_CHARGE = "EV_LEVEL_1_CHARGE",
  EV_LEVEL_2_CHARGE = "EV_LEVEL_2_CHARGE",
  EV_LEVEL_3_CHARGE = "EV_LEVEL_3_CHARGE",
  BIODIESEL_NON_TAXABLE = "BIODIESEL_NON_TAXABLE",
  DIESEL_NON_TAXABLE = "DIESEL_NON_TAXABLE",
  DIESEL_EXHAUST_FLUID_DISPENSED = "DIESEL_EXHAUST_FLUID_DISPENSED",
  AV_MAINTENANCE = "AV_MAINTENANCE",
  DE_ICING = "DE_ICING",
  APU = "APU",
  AV_CATERING = "AV_CATERING",
  TIEDOWN_HANGAR = "TIEDOWN_HANGAR",
  LANDING_FEE = "LANDING_FEE",
  RAMP_FEE = "RAMP_FEE",
  CALL_OUT_FEE = "CALL_OUT_FEE",
  PLANE_RENTAL = "PLANE_RENTAL",
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  MISC_AV = "MISC_AV",
  FLIGHT_PLAN_FEE = "FLIGHT_PLAN_FEE",
  CHARTER_FEE = "CHARTER_FEE",
  GROUND_HANDLING = "GROUND_HANDLING",
  COMM_FEE = "COMM_FEE",
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  CARGO_HANDLING = "CARGO_HANDLING",
  AC_ACC = "AC_ACC",
  BOAT_SERVICE = "BOAT_SERVICE",
}


export enum HNMastercardFleetUnitOfMeasure {
  GALLONS = "GALLONS",
  LITERS = "LITERS",
  POUNDS = "POUNDS",
  KILOS = "KILOS",
  IMPERIAL_GALLONS = "IMPERIAL_GALLONS",
  KILOWATT_HOURS = "KILOWATT_HOURS",
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}


export enum HNMastercardFleetProductType {
  PROMPT_FOR_ID_AND_ODOMETER = "PROMPT_FOR_ID_AND_ODOMETER",
  PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER = "PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER",
  PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER = "PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER",
  PROMPT_FOR_ODOMETER_ONLY = "PROMPT_FOR_ODOMETER_ONLY",
  NO_PROMPTS_ISSUED = "NO_PROMPTS_ISSUED",
}


export type HNMastercardAdditionalFuelLocationDetails = {
  __typename: "HNMastercardAdditionalFuelLocationDetails",
  openTwentyFourHours?: boolean | null,
  eighteenWheelerAccess?: boolean | null,
  dieselSites?: boolean | null,
  interstateAccess?: boolean | null,
  convenienceStore?: boolean | null,
  restaurant?: boolean | null,
  hotel?: boolean | null,
  showers?: boolean | null,
  repairBays?: boolean | null,
  vehicleWash?: boolean | null,
  aviationLocation?: boolean | null,
  marinaLocation?: boolean | null,
  alternativeFuel?: boolean | null,
  payAtPump?: boolean | null,
};

export type HNMastercardFleetEnhancedDataLineItem = {
  __typename: "HNMastercardFleetEnhancedDataLineItem",
  productCode?: HNMastercardFleetProductCode | null,
  description?: string | null,
  quantity?: number | null,
  unitOfMeasure?: string | null,
  unitPrice?: HNAmount | null,
  unitPriceValue?: number | null,
  unitPriceValuePrecision?: number | null,
  itemAmount?: HNAmount | null,
  itemAmountValue?: number | null,
  itemAmountValuePrecision?: number | null,
  creditOrDebit?: HNMastercardFleetCreditOrDebitIndicator | null,
};

export enum HNMastercardFleetCreditOrDebitIndicator {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}


export type HNMastercardFleetAuthorizationData = {
  __typename: "HNMastercardFleetAuthorizationData",
  id: string,
  driverIdentifier?: string | null,
  vehicleIdentifier?: string | null,
  spendControlOverrideFlag?: boolean | null,
  prompts?:  Array<HNMastercardFleetPrompt > | null,
  fuelProducts?:  Array<HNMastercardFleetAuthorizationDataFuelProduct > | null,
  nonFuelProducts?:  Array<HNMastercardFleetAuthorizationDataNonFuelProduct > | null,
};

export type HNMastercardFleetPrompt = {
  __typename: "HNMastercardFleetPrompt",
  code?: HNMastercardFleetPromptType | null,
  value?: string | null,
};

export enum HNMastercardFleetPromptType {
  USER_ID = "USER_ID",
  VEHICLE_NUMBER = "VEHICLE_NUMBER",
  VEHICLE_TAG = "VEHICLE_TAG",
  DRIVER_ID = "DRIVER_ID",
  ODOMETER = "ODOMETER",
  WORK_ORDER_OR_PO_NUMBER = "WORK_ORDER_OR_PO_NUMBER",
  INVOICE_NUMBER = "INVOICE_NUMBER",
  TRIP_NUMBER = "TRIP_NUMBER",
  UNIT_NUMBER = "UNIT_NUMBER",
  REEFER_HOURS = "REEFER_HOURS",
  ZIP_OR_POSTAL_CODE = "ZIP_OR_POSTAL_CODE",
  REPLACEMENT_CAR = "REPLACEMENT_CAR",
  ENTERED_DATA_ALPHA = "ENTERED_DATA_ALPHA",
  WEB_PORTAL_DATA = "WEB_PORTAL_DATA",
  ENTERED_DATA_NUM = "ENTERED_DATA_NUM",
  JOB_NUMBER = "JOB_NUMBER",
  MAINTENANCE_ID = "MAINTENANCE_ID",
  DEPARTMENT_NUMBER = "DEPARTMENT_NUMBER",
  TRAILER_NUMBER = "TRAILER_NUMBER",
  DELIVERY_TICKET_NUMBER = "DELIVERY_TICKET_NUMBER",
  HUBOMETER = "HUBOMETER",
  SUB_FLEET_NUMBER = "SUB_FLEET_NUMBER",
  TRANSACTION_NUMBER = "TRANSACTION_NUMBER",
  CONTROL_NUMBER = "CONTROL_NUMBER",
  REEFER_TEMPERATURE = "REEFER_TEMPERATURE",
  DRIVER_OR_VEHICLE_CARD = "DRIVER_OR_VEHICLE_CARD",
  CUSTOMER_NUMBER = "CUSTOMER_NUMBER",
  ADDITIONAL_CARD_DATA = "ADDITIONAL_CARD_DATA",
  ADDITIONAL_VEHICLE_DATA = "ADDITIONAL_VEHICLE_DATA",
  ENGINE_HOURS = "ENGINE_HOURS",
  TANK_LEVEL_START = "TANK_LEVEL_START",
  FUEL_GAUGE_LEVEL = "FUEL_GAUGE_LEVEL",
  BATTERY_VOLTAGE = "BATTERY_VOLTAGE",
  COOLANT_TEMPERATURE = "COOLANT_TEMPERATURE",
  CHECK_ENGINE_STATUS = "CHECK_ENGINE_STATUS",
  FUEL_ECONOMY = "FUEL_ECONOMY",
  ENGINE_RPM = "ENGINE_RPM",
  ENGINE_LOAD = "ENGINE_LOAD",
  ENGINE_OIL_TEMPERATURE = "ENGINE_OIL_TEMPERATURE",
  ENGINE_TIME_TOTAL = "ENGINE_TIME_TOTAL",
  HARD_BREAKING = "HARD_BREAKING",
  HARD_ACCELERATION = "HARD_ACCELERATION",
  IDLE_TIME = "IDLE_TIME",
  TOTAL_IDLE_TIME = "TOTAL_IDLE_TIME",
  ENGINE_OIL_PRESSURE = "ENGINE_OIL_PRESSURE",
  ENGINE_OIL_LIFE = "ENGINE_OIL_LIFE",
  BILLING_ID = "BILLING_ID",
}


export type HNMastercardFleetAuthorizationDataFuelProduct = {
  __typename: "HNMastercardFleetAuthorizationDataFuelProduct",
  code?: HNMastercardFleetFuelProductCode | null,
  unitPrice?: number | null,
  unitPricePrecision?: number | null,
  unitOfMeasure?: HNMastercardFleetUnitOfMeasure | null,
  quantity?: number | null,
  quantityPrecision?: number | null,
  saleAmount?: HNAmount | null,
};

export enum HNMastercardFleetFuelProductCode {
  REGULAR = "REGULAR",
  MID_PLUS = "MID_PLUS",
  PREMIUM_SUPER = "PREMIUM_SUPER",
  MID_PLUS_2 = "MID_PLUS_2",
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  ETHANOL_5_7_BLEND = "ETHANOL_5_7_BLEND",
  MID_PLUS_ETHANOL_5_7_BLEND = "MID_PLUS_ETHANOL_5_7_BLEND",
  PREMIUM_SUPER_ETHANOL_5_7_BLEND = "PREMIUM_SUPER_ETHANOL_5_7_BLEND",
  ETHANOL_7_7_BLEND = "ETHANOL_7_7_BLEND",
  MID_PLUS_ETHANOL_7_7_BLEND = "MID_PLUS_ETHANOL_7_7_BLEND",
  GREEN_GASOLINE_REGULAR = "GREEN_GASOLINE_REGULAR",
  GREEN_GASOLINE_MID_PLUS = "GREEN_GASOLINE_MID_PLUS",
  GREEN_GASOLINE_PREMIUM_SUPER = "GREEN_GASOLINE_PREMIUM_SUPER",
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  COMPRESSED_NATURAL_GAS = "COMPRESSED_NATURAL_GAS",
  LIQUID_PROPANE_GAS = "LIQUID_PROPANE_GAS",
  LIQUID_NATURAL_GAS = "LIQUID_NATURAL_GAS",
  E_85 = "E_85",
  REFORMULATED_1 = "REFORMULATED_1",
  REFORMULATED_2 = "REFORMULATED_2",
  REFORMULATED_3 = "REFORMULATED_3",
  REFORMULATED_4 = "REFORMULATED_4",
  REFORMULATED_5 = "REFORMULATED_5",
  DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE = "DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE",
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  BIODIESEL_BLEND_OFF_ROAD = "BIODIESEL_BLEND_OFF_ROAD",
  UNDEFINED_FUEL = "UNDEFINED_FUEL",
  RACING_FUEL = "RACING_FUEL",
  MID_PLUS_2_10_PERCENT_BLEND = "MID_PLUS_2_10_PERCENT_BLEND",
  PREMIUM_SUPER_2_10_BLEND = "PREMIUM_SUPER_2_10_BLEND",
  MID_PLUS_ETHANOL_2_10_BLEND = "MID_PLUS_ETHANOL_2_10_BLEND",
  PREMIUM_SUPER_ETHANOL_2_10_BLEND = "PREMIUM_SUPER_ETHANOL_2_10_BLEND",
  PREMIUM_SUPER_ETHANOL_7_7_BLEND = "PREMIUM_SUPER_ETHANOL_7_7_BLEND",
  REGULAR_ETHANOL_10_BLEND = "REGULAR_ETHANOL_10_BLEND",
  MID_PLUS_ETHANOL_10_BLEND = "MID_PLUS_ETHANOL_10_BLEND",
  PREMIUM_SUPER_ETHANOL_10_BLEND = "PREMIUM_SUPER_ETHANOL_10_BLEND",
  B2_DIESEL_BLEND = "B2_DIESEL_BLEND",
  B5_DIESEL_BLEND = "B5_DIESEL_BLEND",
  B10_DIESEL_BLEND = "B10_DIESEL_BLEND",
  B11_DIESEL_BLEND = "B11_DIESEL_BLEND",
  B15_DIESEL_BLEND = "B15_DIESEL_BLEND",
  B20_DIESEL_BLEND = "B20_DIESEL_BLEND",
  B100_DIESEL_BLEND = "B100_DIESEL_BLEND",
  B1_DIESEL_BLEND = "B1_DIESEL_BLEND",
  ADDITIZED_DIESEL_2 = "ADDITIZED_DIESEL_2",
  ADDITIZED_DIESEL_3 = "ADDITIZED_DIESEL_3",
  RENEWABLE_DIESEL = "RENEWABLE_DIESEL",
  RENEWABLE_DIESEL_BIODIESEL = "RENEWABLE_DIESEL_BIODIESEL",
  DEF = "DEF",
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  REGULAR_ETHANOL_15_BLEND = "REGULAR_ETHANOL_15_BLEND",
  MID_PLUS_ETHANOL_15_BLEND = "MID_PLUS_ETHANOL_15_BLEND",
  PREMIUM_SUPER_ETHANOL_15_BLEND = "PREMIUM_SUPER_ETHANOL_15_BLEND",
  PREMIUM_DIESEL_BLEND_1 = "PREMIUM_DIESEL_BLEND_1",
  PREMIUM_DIESEL_BLEND_2 = "PREMIUM_DIESEL_BLEND_2",
  B75_DIESEL_BLEND = "B75_DIESEL_BLEND",
  B99_DIESEL_BLEND = "B99_DIESEL_BLEND",
  MISCELLANEOUS_FUEL = "MISCELLANEOUS_FUEL",
  JET_FUEL = "JET_FUEL",
  AVIATION_FUEL_REGULAR = "AVIATION_FUEL_REGULAR",
  AVIATION_FUEL_PREMIUM = "AVIATION_FUEL_PREMIUM",
  AVIATION_FUEL_JP8 = "AVIATION_FUEL_JP8",
  AVIATION_FUEL_4 = "AVIATION_FUEL_4",
  AVIATION_FUEL_5 = "AVIATION_FUEL_5",
  BIOJET = "BIOJET",
  AVIATION_BIOFUEL = "AVIATION_BIOFUEL",
  MISCELLANEOUS_AVIATION_FUEL = "MISCELLANEOUS_AVIATION_FUEL",
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  MARINE_OTHER = "MARINE_OTHER",
  MARINE_DIESEL = "MARINE_DIESEL",
  MISCELLANEOUS_MARINE_FUEL = "MISCELLANEOUS_MARINE_FUEL",
  KEROSENE_LOW_SULFUR = "KEROSENE_LOW_SULFUR",
  WHITE_GAS = "WHITE_GAS",
  HEATING_OIL = "HEATING_OIL",
  OTHER_FUEL = "OTHER_FUEL",
  KEROSENE_ULTRA_LOW_SULFUR = "KEROSENE_ULTRA_LOW_SULFUR",
  KEROSENE_LOW_SULFUR_NON_TAXABLE = "KEROSENE_LOW_SULFUR_NON_TAXABLE",
  KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE = "KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE",
  EVC_LEVEL_1_CHARGE = "EVC_LEVEL_1_CHARGE",
  EVC_LEVEL_2_CHARGE = "EVC_LEVEL_2_CHARGE",
  EVC_LEVEL_3_CHARGE = "EVC_LEVEL_3_CHARGE",
  BIODIESEL_BLEND_2_OFF_ROAD = "BIODIESEL_BLEND_2_OFF_ROAD",
  BIODIESEL_BLEND_5_OFF_ROAD = "BIODIESEL_BLEND_5_OFF_ROAD",
  BIODIESEL_BLEND_10_OFF_ROAD = "BIODIESEL_BLEND_10_OFF_ROAD",
  BIODIESEL_BLEND_11_OFF_ROAD = "BIODIESEL_BLEND_11_OFF_ROAD",
  BIODIESEL_BLEND_15_OFF_ROAD = "BIODIESEL_BLEND_15_OFF_ROAD",
  BIODIESEL_BLEND_20_OFF_ROAD = "BIODIESEL_BLEND_20_OFF_ROAD",
  DIESEL_1_OFF_ROAD = "DIESEL_1_OFF_ROAD",
  DIESEL_2_OFF_ROAD = "DIESEL_2_OFF_ROAD",
  DIESEL_1_PREMIUM_OFF_ROAD = "DIESEL_1_PREMIUM_OFF_ROAD",
  DIESEL_2_PREMIUM_OFF_ROAD = "DIESEL_2_PREMIUM_OFF_ROAD",
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  ETHANOL_BLENDS_E16_E84 = "ETHANOL_BLENDS_E16_E84",
  LOW_OCTANE_UNL = "LOW_OCTANE_UNL",
  BLENDED_DIESEL = "BLENDED_DIESEL",
  OFF_ROAD_REGULAR = "OFF_ROAD_REGULAR",
  OFF_ROAD_MID_PLUS = "OFF_ROAD_MID_PLUS",
  OFF_ROAD_PREMIUM_SUPER = "OFF_ROAD_PREMIUM_SUPER",
  OFF_ROAD_MID_PLUS_2 = "OFF_ROAD_MID_PLUS_2",
  OFF_ROAD_PREMIUM_SUPER_2 = "OFF_ROAD_PREMIUM_SUPER_2",
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  HYDROGEN_H35 = "HYDROGEN_H35",
  HYDROGEN_H70 = "HYDROGEN_H70",
  RENEWABLE_DIESEL_OFF_ROAD = "RENEWABLE_DIESEL_OFF_ROAD",
  BIODIESEL_BLEND_1_OFF_ROAD = "BIODIESEL_BLEND_1_OFF_ROAD",
  BIODIESEL_BLEND_75_OFF_ROAD = "BIODIESEL_BLEND_75_OFF_ROAD",
  BIODIESEL_BLEND_99_OFF_ROAD = "BIODIESEL_BLEND_99_OFF_ROAD",
  BIODIESEL_BLEND_100_OFF_ROAD = "BIODIESEL_BLEND_100_OFF_ROAD",
  RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD = "RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD",
  MISCELLANEOUS_OTHER_FUEL = "MISCELLANEOUS_OTHER_FUEL",
}


export type HNMastercardFleetAuthorizationDataNonFuelProduct = {
  __typename: "HNMastercardFleetAuthorizationDataNonFuelProduct",
  code?: HNMastercardFleetNonFuelProductCode | null,
  unitOfMeasure?: string | null,
  quantity?: number | null,
  quantityPrecision?: number | null,
  extendedItemAmount?: HNAmount | null,
};

export enum HNMastercardFleetNonFuelProductCode {
  GENERAL_AUTOMOTIVE_MERCHANDISE = "GENERAL_AUTOMOTIVE_MERCHANDISE",
  MOTOR_OIL = "MOTOR_OIL",
  CAR_WASH = "CAR_WASH",
  OIL_CHANGE = "OIL_CHANGE",
  OIL_FILTER = "OIL_FILTER",
  WORK_ORDER = "WORK_ORDER",
  ANTI_FREEZE = "ANTI_FREEZE",
  WASHER_FLUID = "WASHER_FLUID",
  BRAKE_FLUID = "BRAKE_FLUID",
  TIRES = "TIRES",
  FEDERAL_EXCISE_TAX_TIRES = "FEDERAL_EXCISE_TAX_TIRES",
  TIRE_ROTATION = "TIRE_ROTATION",
  BATTERIES = "BATTERIES",
  LUBE = "LUBE",
  INSPECTION = "INSPECTION",
  LABOR = "LABOR",
  TOWING = "TOWING",
  ROAD_SERVICE = "ROAD_SERVICE",
  VEHICLE_ACCESSORIES = "VEHICLE_ACCESSORIES",
  VEHICLE_PARTS = "VEHICLE_PARTS",
  PREVENTATIVE_MAINTENANCE = "PREVENTATIVE_MAINTENANCE",
  AIR_CONDITIONING_SERVICE = "AIR_CONDITIONING_SERVICE",
  ENGINE_SERVICE = "ENGINE_SERVICE",
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  BRAKE_SERVICE = "BRAKE_SERVICE",
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  BODY_WORK = "BODY_WORK",
  VEHICLE_GLASS = "VEHICLE_GLASS",
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  LAMPS = "LAMPS",
  WIPERS = "WIPERS",
  HOSES = "HOSES",
  TIRE_RELATED = "TIRE_RELATED",
  REPAIRS = "REPAIRS",
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  VEHICLE_PARKING = "VEHICLE_PARKING",
  TRUCK_TANK_CLEANING = "TRUCK_TANK_CLEANING",
  OTHER_LUBRICANTS = "OTHER_LUBRICANTS",
  VEHICLE_FUEL_ADDITIVES_TREATMENT = "VEHICLE_FUEL_ADDITIVES_TREATMENT",
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  AIR_FILTER = "AIR_FILTER",
  VEHICLE_PREP = "VEHICLE_PREP",
  FUEL_SYSTEM = "FUEL_SYSTEM",
  MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES = "MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES",
  STORAGE = "STORAGE",
  AIRCRAFT_GROUND_HANDLING = "AIRCRAFT_GROUND_HANDLING",
  AIRCRAFT_GROUND_POWER_UNIT = "AIRCRAFT_GROUND_POWER_UNIT",
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  AIRCRAFT_WORK_ORDER = "AIRCRAFT_WORK_ORDER",
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  TRANSPORTATION = "TRANSPORTATION",
  DE_ICING = "DE_ICING",
  RAMP_FEES = "RAMP_FEES",
  CATERING = "CATERING",
  HANGAR_FEE = "HANGAR_FEE",
  LANDING_FEE = "LANDING_FEE",
  CALL_OUT_FEE = "CALL_OUT_FEE",
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  FLIGHT_PLANS_WEATHER_BRIEF = "FLIGHT_PLANS_WEATHER_BRIEF",
  CHARTER_FEE = "CHARTER_FEE",
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  CARGO_HANDLING = "CARGO_HANDLING",
  AIRCRAFT_ACCESSORIES = "AIRCRAFT_ACCESSORIES",
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  AIRCRAFT_PARKING_FEES = "AIRCRAFT_PARKING_FEES",
  AIRCRAFT_TIE_DOWN_FEES = "AIRCRAFT_TIE_DOWN_FEES",
  AIRCRAFT_SANITATION_FEES = "AIRCRAFT_SANITATION_FEES",
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  AC_PARTS = "AC_PARTS",
  OXYGEN = "OXYGEN",
  DE_FUEL = "DE_FUEL",
  RE_SERVICE = "RE_SERVICE",
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  AIRPORT_FEES = "AIRPORT_FEES",
  OVERTIME_FEES = "OVERTIME_FEES",
  IT_BLADDER = "IT_BLADDER",
  GROUND_EQUIPMENT_SERVICE_FEES = "GROUND_EQUIPMENT_SERVICE_FEES",
  SECURE_FEES = "SECURE_FEES",
  FLOW_FEE = "FLOW_FEE",
  MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES = "MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES",
  MARINE_SERVICE = "MARINE_SERVICE",
  MARINE_LABOR = "MARINE_LABOR",
  MARINE_WORK_ORDER = "MARINE_WORK_ORDER",
  LAUNCH_FEE = "LAUNCH_FEE",
  SLIP_RENTAL = "SLIP_RENTAL",
  MISCELLANEOUS_MARINE_PRODUCTS_SERVICES = "MISCELLANEOUS_MARINE_PRODUCTS_SERVICES",
  GENERAL_MERCHANDISE = "GENERAL_MERCHANDISE",
  GENERAL_ICE = "GENERAL_ICE",
  GENERAL_TOBACCO = "GENERAL_TOBACCO",
  CIGARETTES = "CIGARETTES",
  TOBACCO_OTHER = "TOBACCO_OTHER",
  GENERAL_PACKAGED_BEVERAGE = "GENERAL_PACKAGED_BEVERAGE",
  PACKAGED_BEVERAGES_NON_ALCOHOLIC = "PACKAGED_BEVERAGES_NON_ALCOHOLIC",
  PACKAGED_JUICE = "PACKAGED_JUICE",
  OTHER_PACKAGED_BEVERAGES = "OTHER_PACKAGED_BEVERAGES",
  GENERAL_DISPENSED_BEVERAGE = "GENERAL_DISPENSED_BEVERAGE",
  HOT_DISPENSED_BEVERAGES = "HOT_DISPENSED_BEVERAGES",
  COLD_DISPENSED_BEVERAGES = "COLD_DISPENSED_BEVERAGES",
  FROZEN_DISPENSED_BEVERAGES = "FROZEN_DISPENSED_BEVERAGES",
  OTHER_DISPENSED_BEVERAGES = "OTHER_DISPENSED_BEVERAGES",
  GENERAL_SNACKS = "GENERAL_SNACKS",
  SALTY_SNACKS = "SALTY_SNACKS",
  ALTERNATIVE_SNACKS = "ALTERNATIVE_SNACKS",
  SWEET_SNACKS_PACKAGED = "SWEET_SNACKS_PACKAGED",
  GENERAL_CANDY = "GENERAL_CANDY",
  GENERAL_DAIRY = "GENERAL_DAIRY",
  FLUID_MILK_PRODUCTS = "FLUID_MILK_PRODUCTS",
  PACKAGED_ICE_CREAM_NOVELTIES = "PACKAGED_ICE_CREAM_NOVELTIES",
  OTHER_DAIRY = "OTHER_DAIRY",
  GENERAL_GROCERY = "GENERAL_GROCERY",
  GROCERIES_EDIBLE = "GROCERIES_EDIBLE",
  GROCERIES_NON_EDIBLE = "GROCERIES_NON_EDIBLE",
  GROCERIES_PERISHABLE = "GROCERIES_PERISHABLE",
  BREAD_PACKAGED = "BREAD_PACKAGED",
  FROZEN_FOODS = "FROZEN_FOODS",
  GENERAL_ALCOHOL = "GENERAL_ALCOHOL",
  BEER_ALCOHOLIC = "BEER_ALCOHOLIC",
  BEER_NON_ALCOHOLIC = "BEER_NON_ALCOHOLIC",
  WINE = "WINE",
  LIQUOR = "LIQUOR",
  GENERAL_DELI = "GENERAL_DELI",
  PACKAGED_SANDWICHES_DELI_PRODUCTS = "PACKAGED_SANDWICHES_DELI_PRODUCTS",
  PREPARED_FOODS = "PREPARED_FOODS",
  DELI_ITEMS = "DELI_ITEMS",
  GENERAL_FOOD_SERVICE = "GENERAL_FOOD_SERVICE",
  GENERAL_LOTTERY = "GENERAL_LOTTERY",
  LOTTERY_INSTANT = "LOTTERY_INSTANT",
  LOTTERY_ONLINE = "LOTTERY_ONLINE",
  LOTTERY_OTHER = "LOTTERY_OTHER",
  GENERAL_MONEY_ORDER = "GENERAL_MONEY_ORDER",
  MONEY_ORDER_VENDOR_PAYMENT = "MONEY_ORDER_VENDOR_PAYMENT",
  MONEY_ORDER_PAYROLL_CHECK = "MONEY_ORDER_PAYROLL_CHECK",
  MONEY_ORDER_GIFT_CERTIFICATE = "MONEY_ORDER_GIFT_CERTIFICATE",
  MONEY_ORDER_REFUND_CHECK = "MONEY_ORDER_REFUND_CHECK",
  MONEY_ORDER_OFFICIAL_CHECK = "MONEY_ORDER_OFFICIAL_CHECK",
  MONEY_ORDER_REBATE_CHECK = "MONEY_ORDER_REBATE_CHECK",
  MONEY_ORDER_DIVIDEND_CHECK = "MONEY_ORDER_DIVIDEND_CHECK",
  MONEY_ORDER_UTILITY_CHECK = "MONEY_ORDER_UTILITY_CHECK",
  GENERAL_STORE_SERVICE = "GENERAL_STORE_SERVICE",
  HOME_DELIVERY = "HOME_DELIVERY",
  PREPAID_CARDS_PURCHASE = "PREPAID_CARDS_PURCHASE",
  PREPAID_CARDS_ACTIVATION_RECHARGE = "PREPAID_CARDS_ACTIVATION_RECHARGE",
  MEMBERSHIP_LOYALTY = "MEMBERSHIP_LOYALTY",
  GENERAL_HEALTH_BEAUTY_CARE = "GENERAL_HEALTH_BEAUTY_CARE",
  GENERAL_PUBLICATIONS = "GENERAL_PUBLICATIONS",
  PIN_ACTIVATE_PREPAID_CARD = "PIN_ACTIVATE_PREPAID_CARD",
  PIN_RETURN_PREPAID_CARD = "PIN_RETURN_PREPAID_CARD",
  ENABLE_DEVICE_HANDSET_UNLOCK = "ENABLE_DEVICE_HANDSET_UNLOCK",
  DISABLE_DEVICE_HANDSET_LOCK = "DISABLE_DEVICE_HANDSET_LOCK",
  THIRD_PARTY_PREPAID_CARD_ACTIVATE = "THIRD_PARTY_PREPAID_CARD_ACTIVATE",
  THIRD_PARTY_PREPAID_CARD_RELOAD = "THIRD_PARTY_PREPAID_CARD_RELOAD",
  FINANCIAL_PREPAID_CARD_ACTIVATE = "FINANCIAL_PREPAID_CARD_ACTIVATE",
  FINANCIAL_PREPAID_CARD_RELOAD = "FINANCIAL_PREPAID_CARD_RELOAD",
  PROPRIETARY_PREPAID_CARD_ACTIVATE = "PROPRIETARY_PREPAID_CARD_ACTIVATE",
  PROPRIETARY_PREPAID_CARD_RELOAD = "PROPRIETARY_PREPAID_CARD_RELOAD",
  GENERAL_PURPOSE_ACTIVATE = "GENERAL_PURPOSE_ACTIVATE",
  GENERAL_PURPOSE_RELOAD = "GENERAL_PURPOSE_RELOAD",
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  WIRELESS_REAL_TIME_RECHARGE = "WIRELESS_REAL_TIME_RECHARGE",
  SINGLE_PAYEE_BILL_PAY = "SINGLE_PAYEE_BILL_PAY",
  MULTIPLE_PAYEE_BILL_PAY = "MULTIPLE_PAYEE_BILL_PAY",
  PACKAGED_DEF = "PACKAGED_DEF",
  PACKAGED_B99 = "PACKAGED_B99",
  PACKAGED_B100 = "PACKAGED_B100",
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  MISCELLANEOUS_PACKAGED_FUELS = "MISCELLANEOUS_PACKAGED_FUELS",
  SCALES = "SCALES",
  SHOWER = "SHOWER",
  TIRE_REPAIR = "TIRE_REPAIR",
  LODGING = "LODGING",
  WASH_OUT = "WASH_OUT",
  TRAILER_WASH = "TRAILER_WASH",
  RV_DUMP_FEE = "RV_DUMP_FEE",
  EV_CHARGING_FEE = "EV_CHARGING_FEE",
  EV_BATTERY_EXCHANGES = "EV_BATTERY_EXCHANGES",
  TOLL_PAYMENTS = "TOLL_PAYMENTS",
  CANNABIDIOL = "CANNABIDIOL",
  DISCOUNT_1 = "DISCOUNT_1",
  DISCOUNT_2 = "DISCOUNT_2",
  DISCOUNT_3 = "DISCOUNT_3",
  DISCOUNT_4 = "DISCOUNT_4",
  DISCOUNT_5 = "DISCOUNT_5",
  COUPON_1 = "COUPON_1",
  COUPON_2 = "COUPON_2",
  COUPON_3 = "COUPON_3",
  COUPON_4 = "COUPON_4",
  COUPON_5 = "COUPON_5",
  LOTTERY_PAY_OUT_INSTANT = "LOTTERY_PAY_OUT_INSTANT",
  LOTTERY_PAY_OUT_ONLINE = "LOTTERY_PAY_OUT_ONLINE",
  LOTTERY_PAY_OUT_OTHER = "LOTTERY_PAY_OUT_OTHER",
  SPLIT_TENDER = "SPLIT_TENDER",
  TAX_DISCOUNT_FORGIVEN = "TAX_DISCOUNT_FORGIVEN",
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  POS_LOYALTY_RESERVED_DISCOUNT_1 = "POS_LOYALTY_RESERVED_DISCOUNT_1",
  POS_LOYALTY_RESERVED_DISCOUNT_2 = "POS_LOYALTY_RESERVED_DISCOUNT_2",
  POS_LOYALTY_RESERVED_DISCOUNT_3 = "POS_LOYALTY_RESERVED_DISCOUNT_3",
  POS_LOYALTY_RESERVED_DISCOUNT_4 = "POS_LOYALTY_RESERVED_DISCOUNT_4",
  POS_LOYALTY_RESERVED_DISCOUNT_5 = "POS_LOYALTY_RESERVED_DISCOUNT_5",
  MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE = "MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE",
  TAX_1 = "TAX_1",
  TAX_2 = "TAX_2",
  TAX_3 = "TAX_3",
  TAX_4 = "TAX_4",
  TAX_5 = "TAX_5",
  CASH_BACK = "CASH_BACK",
  CASH_BACK_FEE = "CASH_BACK_FEE",
  FEE_1 = "FEE_1",
  FEE_2 = "FEE_2",
  FEE_3 = "FEE_3",
  FEE_4 = "FEE_4",
  FEE_5 = "FEE_5",
  MISCELLANEOUS_AVIATION_TAX = "MISCELLANEOUS_AVIATION_TAX",
  GST_HST_CANADIAN_VAT_1 = "GST_HST_CANADIAN_VAT_1",
  PST_QST_CANADIAN_VAT_2 = "PST_QST_CANADIAN_VAT_2",
  SWT_RATE_CANADIAN = "SWT_RATE_CANADIAN",
  TAX_6 = "TAX_6",
  TAX_7 = "TAX_7",
  TAX_8 = "TAX_8",
  JET_FEDERAL_EXCISE_TAX = "JET_FEDERAL_EXCISE_TAX",
  AVGAS_FEDERAL_EXCISE_TAX = "AVGAS_FEDERAL_EXCISE_TAX",
  CHARITY = "CHARITY",
  GRATUITY = "GRATUITY",
  MISCELLANEOUS_ADMINISTRATIVE = "MISCELLANEOUS_ADMINISTRATIVE",
}


export type HNVisaFleetAuthorizationData = {
  __typename: "HNVisaFleetAuthorizationData",
  id: string,
  purchaseType?: HNVisaFuelPurchaseType | null,
  serviceType?: HNVisaFuelServiceType | null,
  purchaseIdentifierFormat?: HNVisaFleetPurchaseIdentifierFormat | null,
  purchaseIdentifier?: string | null,
  fleetIdentifier?: string | null,
  odometer?: string | null,
  employeeNumber?: string | null,
  trailerNumber?: string | null,
  customPrompt1?: string | null,
  customPrompt2?: string | null,
  purchaseRestrictonsFlag?: boolean | null,
  nonFuelProductCodes?: Array< HNVisaNonFuelProductCode > | null,
};

export type HNAdviceDetail = {
  __typename: "HNAdviceDetail",
  responseCode?: HNTransactionAdviceEventResponseCode | null,
};

export enum HNTransactionAdviceEventResponseCode {
  APPROVED = "APPROVED",
  DO_NOT_HONOR = "DO_NOT_HONOR",
}


export type HNNotificationTargetActivationEvent = {
  __typename: "HNNotificationTargetActivationEvent",
  ping?: string | null,
};

export type HNNotificationPingTestEvent = {
  __typename: "HNNotificationPingTestEvent",
  ping: string,
};

export type HNSecureDepositInitiatedEvent = {
  __typename: "HNSecureDepositInitiatedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNACHTransferStatusDetails = HNNonFailureACHTransferStatus | HNFailureACHTransferStatus


export type HNNonFailureACHTransferStatus = {
  __typename: "HNNonFailureACHTransferStatus",
  status?: HNACHTransferStatus | null,
};

export enum HNACHTransferStatus {
  INITIATED = "INITIATED",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
}


export type HNFailureACHTransferStatus = {
  __typename: "HNFailureACHTransferStatus",
  status?: HNACHTransferStatus | null,
  statusReasonCode?: HNACHTransferStatusReasonCode | null,
};

export enum HNACHTransferStatusReasonCode {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
}


export type HNSecureDepositProcessingEvent = {
  __typename: "HNSecureDepositProcessingEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNSecureDepositProcessedEvent = {
  __typename: "HNSecureDepositProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNSecureDepositFailedEvent = {
  __typename: "HNSecureDepositFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  secureDepositACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export enum HNIntegratorInitiatedACHStatusReasonCode {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
}


export type HNSecureDepositReturnedEvent = {
  __typename: "HNSecureDepositReturnedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  secureDepositACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
};

export type HNSecureDepositCanceledEvent = {
  __typename: "HNSecureDepositCanceledEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsWithdrawalInitiatedEvent = {
  __typename: "HNFundsWithdrawalInitiatedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsWithdrawalProcessingEvent = {
  __typename: "HNFundsWithdrawalProcessingEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsWithdrawalProcessedEvent = {
  __typename: "HNFundsWithdrawalProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsWithdrawalFailedEvent = {
  __typename: "HNFundsWithdrawalFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  fundsWithdrawalACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsWithdrawalReturnedEvent = {
  __typename: "HNFundsWithdrawalReturnedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  fundsWithdrawalACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
};

export type HNFundsWithdrawalCanceledEvent = {
  __typename: "HNFundsWithdrawalCanceledEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsDepositInitiatedEvent = {
  __typename: "HNFundsDepositInitiatedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsDepositProcessingEvent = {
  __typename: "HNFundsDepositProcessingEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsDepositProcessedEvent = {
  __typename: "HNFundsDepositProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsDepositFailedEvent = {
  __typename: "HNFundsDepositFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  fundsDepositACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  paymentRelatedInformation?: string | null,
};

export type HNFundsDepositReturnedEvent = {
  __typename: "HNFundsDepositReturnedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  fundsDepositACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
};

export type HNFundsDepositCanceledEvent = {
  __typename: "HNFundsDepositCanceledEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  paymentRelatedInformation?: string | null,
};

export type HNRepaymentProcessedEvent = {
  __typename: "HNRepaymentProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNRepaymentProcessingEvent = {
  __typename: "HNRepaymentProcessingEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNRepaymentFailedEvent = {
  __typename: "HNRepaymentFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  repaymentACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
};

export type HNRepaymentReturnedEvent = {
  __typename: "HNRepaymentReturnedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fromFinancialAccountId?: string | null,
  toFinancialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  repaymentACHReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
};

export type HNAchExternallyInitatedDepositReceivedEvent = {
  __typename: "HNAchExternallyInitatedDepositReceivedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNAchExternallyInitatedEvent = {
  __typename: "HNAchExternallyInitatedEvent",
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNAchExternallyInitatedDepositProcessedEvent = {
  __typename: "HNAchExternallyInitatedDepositProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNAchExternallyInitatedDepositFailedEvent = {
  __typename: "HNAchExternallyInitatedDepositFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  externallyInitatedDepositACHReasonCode?: HNExternallyInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export enum HNExternallyInitiatedACHStatusReasonCode {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
}


export type HNAchExternallyInitiatedWithdrawalReceivedEvent = {
  __typename: "HNAchExternallyInitiatedWithdrawalReceivedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNAchExternallyInitiatedWithdrawalProcessedEvent = {
  __typename: "HNAchExternallyInitiatedWithdrawalProcessedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNAchExternallyInitiatedWithdrawalFailedEvent = {
  __typename: "HNAchExternallyInitiatedWithdrawalFailedEvent",
  id: string,
  transactionId?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  financialAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  externallyInitiatedWithdrawalACHReasonCode?: HNExternallyInitiatedACHStatusReasonCode | null,
  transferStatus?: HNACHTransferStatusDetails | null,
};

export type HNPaymentCardAuthorizationApprovedEvent = {
  __typename: "HNPaymentCardAuthorizationApprovedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export type HNPaymentCardTransactionEvent = {
  __typename: "HNPaymentCardTransactionEvent",
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
};

export type HNPaymentCardAuthorizationCreatedEvent = {
  __typename: "HNPaymentCardAuthorizationCreatedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardAuthorizationDeclinedEvent = {
  __typename: "HNPaymentCardAuthorizationDeclinedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardAuthorizationReversedEvent = {
  __typename: "HNPaymentCardAuthorizationReversedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  issuerExpiredAuthorization?: boolean | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
  settlementImpact?: boolean | null,
};

export type HNPaymentCardClearedEvent = {
  __typename: "HNPaymentCardClearedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export type HNPaymentCardAdjustmentEvent = {
  __typename: "HNPaymentCardAdjustmentEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardEnhancedDataEvent = {
  __typename: "HNPaymentCardEnhancedDataEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
};

export type HNPaymentCardAuthorizationAndClearApprovedEvent = {
  __typename: "HNPaymentCardAuthorizationAndClearApprovedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export type HNPaymentCardAuthorizationAndClearDeclinedEvent = {
  __typename: "HNPaymentCardAuthorizationAndClearDeclinedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardVerificationApprovedEvent = {
  __typename: "HNPaymentCardVerificationApprovedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardVerificationDeclinedEvent = {
  __typename: "HNPaymentCardVerificationDeclinedEvent",
  id: string,
  approvedAmount?: HNAmount | null,
  avsResponseCode?: HNAVSResponseCode | null,
  createdAt?: string | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  merchantDetails?: HNMerchantDetails | null,
  originalAmount?: HNAmount | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  requestedAmount?: HNAmount | null,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  accountHolderId?: string | null,
  financialAccountId?: string | null,
  cardId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNPaymentCardActivatedEvent = {
  __typename: "HNPaymentCardActivatedEvent",
  id: string,
  bin?: string | null,
  cardProductId?: string | null,
  expirationDate?: string | null,
  formFactor?: HNCardFormFactor | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  status?: HNPaymentCardStatus | null,
  previousStatus?: HNPaymentCardStatus | null,
  updatedAt?: string | null,
};

export type HNPaymentCardEvent = {
  __typename: "HNPaymentCardEvent",
  bin?: string | null,
  cardProductId?: string | null,
  expirationDate?: string | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  status?: HNPaymentCardStatus | null,
  previousStatus?: HNPaymentCardStatus | null,
  updatedAt?: string | null,
};

export type HNPaymentCardSuspendedEvent = {
  __typename: "HNPaymentCardSuspendedEvent",
  id: string,
  bin?: string | null,
  cardProductId?: string | null,
  expirationDate?: string | null,
  formFactor?: HNCardFormFactor | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  status?: HNPaymentCardStatus | null,
  previousStatus?: HNPaymentCardStatus | null,
  updatedAt?: string | null,
};

export type HNPaymentCardUnsuspendedEvent = {
  __typename: "HNPaymentCardUnsuspendedEvent",
  id: string,
  bin?: string | null,
  cardProductId?: string | null,
  expirationDate?: string | null,
  formFactor?: HNCardFormFactor | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  status?: HNPaymentCardStatus | null,
  previousStatus?: HNPaymentCardStatus | null,
  updatedAt?: string | null,
};

export type HNPaymentCardClosedEvent = {
  __typename: "HNPaymentCardClosedEvent",
  id: string,
  bin?: string | null,
  cardProductId?: string | null,
  expirationDate?: string | null,
  formFactor?: HNCardFormFactor | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  status?: HNPaymentCardStatus | null,
  previousStatus?: HNPaymentCardStatus | null,
  updatedAt?: string | null,
};

export type HNPhysicalPaymentCardShippedEvent = {
  __typename: "HNPhysicalPaymentCardShippedEvent",
  id: string,
  orderState?: HNPaymentCardOrderStateDetail | null,
  paymentCardId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPhysicalPaymentCardShipFailedEvent = {
  __typename: "HNPhysicalPaymentCardShipFailedEvent",
  id: string,
  orderState?: HNPaymentCardOrderStateDetail | null,
  paymentCardId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountStatementReadyEvent = {
  __typename: "HNFinancialAccountStatementReadyEvent",
  id: string,
  financialAccountId?: string | null,
};

export type HNFinancialAccountStatementEvent = {
  __typename: "HNFinancialAccountStatementEvent",
  id: string,
  financialAccountId?: string | null,
};

export type HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent = {
  __typename: "HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNInternalTransferEvent = {
  __typename: "HNInternalTransferEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent = {
  __typename: "HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNInterFinancialAccountTransferStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export type HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent = {
  __typename: "HNInternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  internalTransferStatusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNInterFinancialAccountTransferStatusReasonCode {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED",
  PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED",
  LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
}


export type HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent = {
  __typename: "HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent = {
  __typename: "HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent = {
  __typename: "HNInternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent",
  id: string,
  amount?: HNAmount | null,
  internalTransferStatus?: HNInterFinancialAccountTransferStatus | null,
  internalTransferStatusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPhysicalPaymentCardGroupOrderShippedEvent = {
  __typename: "HNPhysicalPaymentCardGroupOrderShippedEvent",
  id: string,
  groupOrderState?: HNPaymentCardGroupOrderStateDetail | null,
  cardProductId?: string | null,
  cardCount?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPhysicalPaymentCardGroupOrderShipFailedEvent = {
  __typename: "HNPhysicalPaymentCardGroupOrderShipFailedEvent",
  id: string,
  groupOrderState?: HNPaymentCardGroupOrderStateDetail | null,
  cardProductId?: string | null,
  cardCount?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPayrollAdvanceRepaymentCompletedEvent = {
  __typename: "HNPayrollAdvanceRepaymentCompletedEvent",
  id: string,
  financialAccountId?: string | null,
  employerFinancialAccountId: string,
  payrollTransferId?: string | null,
  payrollAdvance?: HNPayrollAdvance | null,
};

export type HNPayrollAdvanceEvent = {
  __typename: "HNPayrollAdvanceEvent",
  id: string,
  financialAccountId?: string | null,
  employerFinancialAccountId: string,
  payrollTransferId?: string | null,
  payrollAdvance?: HNPayrollAdvance | null,
};

export type HNPayrollAdvanceWriteOffCompletedEvent = {
  __typename: "HNPayrollAdvanceWriteOffCompletedEvent",
  id: string,
  financialAccountId?: string | null,
  employerFinancialAccountId: string,
  payrollTransferId?: string | null,
  payrollAdvance?: HNPayrollAdvance | null,
};

export type HNPayrollAdvance = {
  __typename: "HNPayrollAdvance",
  id: string,
  paymentAdvanceStatus?: HNPaymentAdvanceStatus | null,
  advanceAmount?: HNAmount | null,
  amountBefore?: HNAmount | null,
  amountApplied?: HNAmount | null,
  balanceAfter?: HNAmount | null,
  repaymentAttemptCount: number,
  writeOffReason?: HNPaymentAdvanceWriteOffReason | null,
  writeOffAmount?: HNAmount | null,
};

export type HNPaymentAdvance = {
  __typename: "HNPaymentAdvance",
  id: string,
  paymentAdvanceStatus?: HNPaymentAdvanceStatus | null,
  advanceAmount?: HNAmount | null,
  amountBefore?: HNAmount | null,
  amountApplied?: HNAmount | null,
  balanceAfter?: HNAmount | null,
  repaymentAttemptCount: number,
  writeOffReason?: HNPaymentAdvanceWriteOffReason | null,
  writeOffAmount?: HNAmount | null,
};

export enum HNPaymentAdvanceStatus {
  NOT_REPAID = "NOT_REPAID",
  PARTIALLY_REPAID = "PARTIALLY_REPAID",
  FULLY_REPAID = "FULLY_REPAID",
  WRITTEN_OFF = "WRITTEN_OFF",
}


export enum HNPaymentAdvanceWriteOffReason {
  EXCEED_MAX_ATTEMPT_COUNT = "EXCEED_MAX_ATTEMPT_COUNT",
}


export type HNAccountStatusActiveEvent = {
  __typename: "HNAccountStatusActiveEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNAccountStatusEvent = {
  __typename: "HNAccountStatusEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNAccountStatusSuspendedEvent = {
  __typename: "HNAccountStatusSuspendedEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNAccountStatusUnderReviewEvent = {
  __typename: "HNAccountStatusUnderReviewEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNAccountStatusPendingClosureEvent = {
  __typename: "HNAccountStatusPendingClosureEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNAccountStatusClosedEvent = {
  __typename: "HNAccountStatusClosedEvent",
  id: string,
  accountName?: string | null,
  externalId?: string | null,
  createdAt?: string | null,
};

export type HNExternalBankAccountAddedEvent = {
  __typename: "HNExternalBankAccountAddedEvent",
  id: string,
  accountName?: string | null,
  accountHolderId?: string | null,
  provider?: HNBankVerificationProvider | null,
  accountStatus?: string | null,
  externalBankAccountDetail?: HNExternalBankAccountDetail | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  addedAt?: string | null,
};

export type HNExternalBankAccountEvent = {
  __typename: "HNExternalBankAccountEvent",
  id: string,
  accountName?: string | null,
  accountHolderId?: string | null,
  provider?: HNBankVerificationProvider | null,
  accountStatus?: string | null,
  externalBankAccountDetail?: HNExternalBankAccountDetail | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNExternalBankAccountRemovedEvent = {
  __typename: "HNExternalBankAccountRemovedEvent",
  id: string,
  accountName?: string | null,
  accountHolderId?: string | null,
  provider?: HNBankVerificationProvider | null,
  accountStatus?: string | null,
  externalBankAccountDetail?: HNExternalBankAccountDetail | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  removedAt?: string | null,
};

export enum HNBankVerificationProvider {
  UNSPECIFIED = "UNSPECIFIED",
  SIMULATED = "SIMULATED",
  PLAID = "PLAID",
  FINICITY = "FINICITY",
}


export type HNExternalBankAccountDetail = {
  __typename: "HNExternalBankAccountDetail",
  id: string,
  last4?: string | null,
  type?: HNBankAccountType | null,
  routingNumber?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNBankAccountType {
  CHECKING = "CHECKING",
  SAVINGS = "SAVINGS",
}


export type HNCardDigitalWalletTokenActivatedEvent = {
  __typename: "HNCardDigitalWalletTokenActivatedEvent",
  id: string,
  paymentCardId?: string | null,
  tokenStatus?: HNDigitalWalletTokenStatus | null,
  tokenPreviousStatus?: HNDigitalWalletTokenStatus | null,
  reason?: HNDigitalWalletTokenStatusChangeReason | null,
};

export type HNCardDigitalWalletTokenEvent = {
  __typename: "HNCardDigitalWalletTokenEvent",
  id: string,
  paymentCardId?: string | null,
  tokenStatus?: HNDigitalWalletTokenStatus | null,
  tokenPreviousStatus?: HNDigitalWalletTokenStatus | null,
  reason?: HNDigitalWalletTokenStatusChangeReason | null,
};

export type HNCardDigitalWalletTokenSuspendedEvent = {
  __typename: "HNCardDigitalWalletTokenSuspendedEvent",
  id: string,
  paymentCardId?: string | null,
  tokenStatus?: HNDigitalWalletTokenStatus | null,
  tokenPreviousStatus?: HNDigitalWalletTokenStatus | null,
  reason?: HNDigitalWalletTokenStatusChangeReason | null,
};

export enum HNDigitalWalletTokenStatus {
  REQUESTED = "REQUESTED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
}


export enum HNDigitalWalletTokenStatusChangeReason {
  ACTIVATION_METHOD = "ACTIVATION_METHOD",
  CUSTOMER_SERVICE_AGENT = "CUSTOMER_SERVICE_AGENT",
  DEVICE_LOST = "DEVICE_LOST",
  DEVICE_STOLEN = "DEVICE_STOLEN",
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  DEVICE_FOUND = "DEVICE_FOUND",
  NON_FRAUDULENT_TRANSACTIONS = "NON_FRAUDULENT_TRANSACTIONS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_HOLDER_DELETED = "ACCOUNT_HOLDER_DELETED",
  NETWORK_INITIATED = "NETWORK_INITIATED",
  OTHER = "OTHER",
}


export type HNCardDigitalWalletTokenTerminatedEvent = {
  __typename: "HNCardDigitalWalletTokenTerminatedEvent",
  id: string,
  paymentCardId?: string | null,
  tokenStatus?: HNDigitalWalletTokenStatus | null,
  tokenPreviousStatus?: HNDigitalWalletTokenStatus | null,
  reason?: HNDigitalWalletTokenStatusChangeReason | null,
};

export type HNAchHoldAddedEvent = {
  __typename: "HNAchHoldAddedEvent",
  id: string,
  transactionId?: string | null,
  fromStatus?: HNAchHoldStatus | null,
  holdType?: HNAchHoldType | null,
  sourceAccountId?: string | null,
  receivingAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAchHoldEvent = {
  __typename: "HNAchHoldEvent",
  id: string,
  transactionId?: string | null,
  fromStatus?: HNAchHoldStatus | null,
  holdType?: HNAchHoldType | null,
  sourceAccountId?: string | null,
  receivingAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAchHoldRemovedEvent = {
  __typename: "HNAchHoldRemovedEvent",
  id: string,
  transactionId?: string | null,
  fromStatus?: HNAchHoldStatus | null,
  holdType?: HNAchHoldType | null,
  sourceAccountId?: string | null,
  receivingAccountId?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNAchHoldStatus {
  NO_HOLDS = "NO_HOLDS",
  ON_HOLD = "ON_HOLD",
  HOLD_REMOVED = "HOLD_REMOVED",
}


export enum HNAchHoldType {
  UNSPECIFIED = "UNSPECIFIED",
  RISK = "RISK",
}


export type HNReport = {
  __typename: "HNReport",
  id: string,
  status?: HNReportStatus | null,
  reportType?: HNReportType | null,
  statusReason?: string | null,
  download?: HNReportDownload | null,
  start?: string | null,
  end?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNReportStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum HNReportType {
  EXPERIAN_CREDIT_REPORT = "EXPERIAN_CREDIT_REPORT",
  LEDGER_ENTRY = "LEDGER_ENTRY",
  CARD_INTERCHANGE_ACTIVITY = "CARD_INTERCHANGE_ACTIVITY",
  CARD_TRANSACTION_ACTIVITY = "CARD_TRANSACTION_ACTIVITY",
  FLEET_ENHANCED_DATA_SUMMARY = "FLEET_ENHANCED_DATA_SUMMARY",
  RECEIVABLE_SALE_AGREEMENT = "RECEIVABLE_SALE_AGREEMENT",
  RECEIVABLE_SALE = "RECEIVABLE_SALE",
  RECEIVABLE_ACCOUNTS_SALE = "RECEIVABLE_ACCOUNTS_SALE",
  RECEIVABLE_SALE_TRANSACTIONS = "RECEIVABLE_SALE_TRANSACTIONS",
}


export type HNReportDownload = {
  __typename: "HNReportDownload",
  url?: string | null,
};

export type HNInterFinancialAccountTransfer = {
  __typename: "HNInterFinancialAccountTransfer",
  id: string,
  amount?: HNAmount | null,
  status?: HNInterFinancialAccountTransferStatus | null,
  statusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  purpose?: HNTransferPurpose | null,
  interFinancialAccountTransferRuleResults?:  Array<HNInterFinancialAccountTransferRuleResult > | null,
  fromFinancialAccount?: HNFinancialAccount | null,
  toFinancialAccount?: HNFinancialAccount | null,
  transferActivityType?: HNInterFinancialAccountTransferActivityType | null,
};

export type HNLedger = {
  __typename: "HNLedger",
  id: string,
  name?: HNLedgerName | null,
  description?: string | null,
  normalBalance?: HNNormalBalance | null,
  creditBalance?: HNAmount | null,
  debitBalance?: HNAmount | null,
  asOf?: string | null,
  financialAccount?: HNFinancialAccount | null,
  ledgerEntries?: HNLedgerEntryConnection | null,
};

export enum HNLedgerName {
  ACTIVITY = "ACTIVITY",
  AUTHORIZATION = "AUTHORIZATION",
  CASH = "CASH",
  CLEARED = "CLEARED",
  INTERCHANGE_REVENUE = "INTERCHANGE_REVENUE",
  NETWORK_PAYABLE = "NETWORK_PAYABLE",
  NETWORK_RECEIVABLE = "NETWORK_RECEIVABLE",
  NETWORK_CREDIT_RECEIVABLE = "NETWORK_CREDIT_RECEIVABLE",
  NETWORK_EXPENSE = "NETWORK_EXPENSE",
  CREDIT_AUTHORIZATION = "CREDIT_AUTHORIZATION",
  CREDIT_HOLD = "CREDIT_HOLD",
  RESERVE = "RESERVE",
  RISK_HOLD = "RISK_HOLD",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  CARD_PAYABLE = "CARD_PAYABLE",
  CARD_RECEIVABLE = "CARD_RECEIVABLE",
  FEE_AUTHORIZATION = "FEE_AUTHORIZATION",
  FEE_CLEARED = "FEE_CLEARED",
  AVAILABLE_CASH = "AVAILABLE_CASH",
  CASH_EXPENSE = "CASH_EXPENSE",
  DEPOSIT_HOLD = "DEPOSIT_HOLD",
  REFUND_HOLD = "REFUND_HOLD",
  FUND_IN_HOLD = "FUND_IN_HOLD",
  DEPOSIT_AUTHORIZATION = "DEPOSIT_AUTHORIZATION",
  REFUND_AUTHORIZATION = "REFUND_AUTHORIZATION",
  PAYROLL_ADVANCE_RECEIVABLE = "PAYROLL_ADVANCE_RECEIVABLE",
  PAYROLL_ADVANCE_PAYABLE = "PAYROLL_ADVANCE_PAYABLE",
  ACH_PENDING_SETTLEMENT = "ACH_PENDING_SETTLEMENT",
  DEPOSIT_RECEIVABLE = "DEPOSIT_RECEIVABLE",
  AVAILABLE_CREDIT = "AVAILABLE_CREDIT",
  CREDIT_OUTSTANDING = "CREDIT_OUTSTANDING",
  OUTSTANDING_BALANCE_PAYABLE = "OUTSTANDING_BALANCE_PAYABLE",
  OUTSTANDING_BALANCE_RECEIVABLE = "OUTSTANDING_BALANCE_RECEIVABLE",
  SECURED_DEPOSIT_PAYABLE = "SECURED_DEPOSIT_PAYABLE",
  SECURED_DEPOSIT_RECEIVABLE = "SECURED_DEPOSIT_RECEIVABLE",
  ACH_PENDING_SETTLEMENT_OUT = "ACH_PENDING_SETTLEMENT_OUT",
  SECURED_DEPOSIT_COLLATERAL = "SECURED_DEPOSIT_COLLATERAL",
  ACCOUNT_HOLDER_SECURED_DEPOSIT = "ACCOUNT_HOLDER_SECURED_DEPOSIT",
  PENDING_PAYMENT_RECEIVABLE = "PENDING_PAYMENT_RECEIVABLE",
  ACCOUNT_HOLDER_PAYMENT_PAYABLE = "ACCOUNT_HOLDER_PAYMENT_PAYABLE",
  ACCOUNT_HOLDER_PAYMENT_RECEIVABLE = "ACCOUNT_HOLDER_PAYMENT_RECEIVABLE",
  REWARDS_POINTS = "REWARDS_POINTS",
  REDEEMABLE_REWARDS_POINTS = "REDEEMABLE_REWARDS_POINTS",
  PROVISIONAL_CREDIT_RECEIVABLE = "PROVISIONAL_CREDIT_RECEIVABLE",
  PROVISIONAL_CREDIT_PAYABLE = "PROVISIONAL_CREDIT_PAYABLE",
  DISPUTE_EXPENSE = "DISPUTE_EXPENSE",
  DISPUTE_CREDIT = "DISPUTE_CREDIT",
  ACH_DEBIT_PAYABLE = "ACH_DEBIT_PAYABLE",
  ACCOUNT_HOLDER_CREDIT_LIMIT = "ACCOUNT_HOLDER_CREDIT_LIMIT",
  ALLOCATED_CREDIT_LIMIT = "ALLOCATED_CREDIT_LIMIT",
  CARD_TRANSACTION_CREDIT_HOLD = "CARD_TRANSACTION_CREDIT_HOLD",
  PAYROLL_ADVANCE_WRITE_OFF = "PAYROLL_ADVANCE_WRITE_OFF",
  PAYROLL_ADVANCE_WRITE_OFF_EXPENSE = "PAYROLL_ADVANCE_WRITE_OFF_EXPENSE",
  PSEUDO_AVAILABLE_CASH = "PSEUDO_AVAILABLE_CASH",
  PSEUDO_CASH = "PSEUDO_CASH",
  SETTLEMENT_PAYABLE = "SETTLEMENT_PAYABLE",
  TRANSFER_PAYABLE = "TRANSFER_PAYABLE",
  TRANSFER_RECEIVABLE = "TRANSFER_RECEIVABLE",
  TRANSFER_PENDING_SETTLEMENT = "TRANSFER_PENDING_SETTLEMENT",
  PAYMENT_PLATFORM_FEE_PAYABLE = "PAYMENT_PLATFORM_FEE_PAYABLE",
  PAYMENT_NETWORK_FEE_PAYABLE = "PAYMENT_NETWORK_FEE_PAYABLE",
  PAYMENT_INTERCHANGE_FEE_PAYABLE = "PAYMENT_INTERCHANGE_FEE_PAYABLE",
  PAYMENT_PAYOUT_PAYABLE = "PAYMENT_PAYOUT_PAYABLE",
  ACCOUNT_HOLDER_PSEUDO_LIMIT = "ACCOUNT_HOLDER_PSEUDO_LIMIT",
  ALLOCATED_PSEUDO_LIMIT = "ALLOCATED_PSEUDO_LIMIT",
  CHECK_PAYABLE = "CHECK_PAYABLE",
  CHECK_SETTLEMENT_DEPOSIT = "CHECK_SETTLEMENT_DEPOSIT",
  CHECK_PROCESSING = "CHECK_PROCESSING",
}


export enum HNNormalBalance {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}


export type HNLedgerEntryConnection = {
  __typename: "HNLedgerEntryConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNLedgerEntryEdge > | null,
};

export type HNLedgerEntryEdge = {
  __typename: "HNLedgerEntryEdge",
  cursor: string,
  node?: HNLedgerEntry | null,
};

export type HNLedgerEntry = {
  __typename: "HNLedgerEntry",
  id: string,
  financialAccount?: HNFinancialAccount | null,
  journalEntry?: HNJournalEntry | null,
  ledger?: HNLedger | null,
  amount?: HNAmount | null,
  memo?: string | null,
  financialEvent?: HNFinancialEvent | null,
  createdAt?: string | null,
  creditBalanceAtLedgerEntry?: HNAmount | null,
  debitBalanceAtLedgerEntry?: HNAmount | null,
};

export type HNCreditLedgerEntry = {
  __typename: "HNCreditLedgerEntry",
  id: string,
  financialAccount?: HNFinancialAccount | null,
  journalEntry?: HNJournalEntry | null,
  ledger?: HNLedger | null,
  amount?: HNAmount | null,
  memo?: string | null,
  financialEvent?: HNFinancialEvent | null,
  createdAt?: string | null,
  creditBalanceAtLedgerEntry?: HNAmount | null,
  debitBalanceAtLedgerEntry?: HNAmount | null,
};

export type HNJournalEntry = {
  __typename: "HNJournalEntry",
  id: string,
  credits?:  Array<HNCreditLedgerEntry > | null,
  debits?:  Array<HNDebitLedgerEntry > | null,
};

export type HNDebitLedgerEntry = {
  __typename: "HNDebitLedgerEntry",
  id: string,
  financialAccount?: HNFinancialAccount | null,
  journalEntry?: HNJournalEntry | null,
  ledger?: HNLedger | null,
  amount?: HNAmount | null,
  memo?: string | null,
  financialEvent?: HNFinancialEvent | null,
  createdAt?: string | null,
  creditBalanceAtLedgerEntry?: HNAmount | null,
  debitBalanceAtLedgerEntry?: HNAmount | null,
};

export type HNFinancialEvent = HNAuthorizationEvent | HNClearingEvent | HNReversalEvent | HNAdjustmentEvent | HNTransfer | HNAuthorizationAndClearEvent | HNRewardPointsTransfer | HNCreditFundsACHTransferEvent | HNDebitFundsACHTransferEvent | HNFeeTransferEvent | HNPayrollACHTransferEvent | HNSecureDepositTransferEvent | HNSecureDepositACHTransferEvent | HNSecureCardBalanceRepaymentACHTransferEvent | HNIntegratorInitiatedFundsWithdrawalACHTransferEvent | HNIntegratorInitiatedFundsDepositACHTransferEvent | HNFinancialAccountCreditLimitUpdateFromProductFunding | HNInterFinancialAccountTransfer | HNExternallyInitiatedAchReleaseHoldTransfer | HNPayrollAdvanceWriteoffTransfer | HNPayrollAdvanceRepaymentTransfer | HNIssuerPreliminaryAuthorizationEvent | HNFinancialAccountPseudoBalanceUpdate | HNManualAdjustmentEvent | HNCreditCardTransferEvent | HNDisbursementTransferEvent | HNWireTransfer


export type HNClearingEvent = {
  __typename: "HNClearingEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  transaction?: HNTransaction | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  additionalTransactionData?:  Array<HNAdditionalTransactionData > | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  disputes?:  Array<HNPaymentCardTransactionDispute > | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export type HNAdjustmentEvent = {
  __typename: "HNAdjustmentEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transactionId?: string | null,
  transaction?: HNTransaction | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNTransfer = {
  __typename: "HNTransfer",
  id: string,
  amount?: HNAmount | null,
  status?: HNTransferStatus | null,
  statusReason?: HNTransferStatusReasonCode | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export enum HNTransferStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum HNTransferStatusReasonCode {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
}


export type HNAuthorizationAndClearEvent = {
  __typename: "HNAuthorizationAndClearEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transaction?: HNTransaction | null,
  avsResponseCode?: HNAVSResponseCode | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  collaborativeAuthorizationDetails?: HNCollaborativeAuthorizationDetails | null,
  spendRuleResults?: HNSpendRuleResultConnection | null,
  accountHolderId?: string | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  disputes?:  Array<HNPaymentCardTransactionDispute > | null,
  partial?: boolean | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
  advice?: boolean | null,
  adviceDetail?: HNAdviceDetail | null,
};

export type HNRewardPointsTransfer = {
  __typename: "HNRewardPointsTransfer",
  id: string,
  rewardPointsAmount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNRewardPointsTransferStatusDetails | null,
  activity?: HNRewardPointsActivityType | null,
  source?: HNRewardPointsTransferSource | null,
  memo?: string | null,
  externalTransactionIdentifier?: string | null,
  rewardPointsValue?: HNAmount | null,
  redemptionConfiguration?: HNRewardRedemptionConfiguration | null,
  rewardEarnRule?: HNRewardEarnRule | null,
};

export type HNRewardPointsTransferStatusDetails = HNRewardPointsTransferSuccessStatus | HNRewardPointsTransferFailureStatus


export type HNRewardPointsTransferSuccessStatus = {
  __typename: "HNRewardPointsTransferSuccessStatus",
  status?: HNRewardPointsTransferStatus | null,
};

export enum HNRewardPointsTransferStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export type HNRewardPointsTransferFailureStatus = {
  __typename: "HNRewardPointsTransferFailureStatus",
  status?: HNRewardPointsTransferStatus | null,
  statusReasonCode?: HNRewardPointsTransferFailureReasonCode | null,
};

export enum HNRewardPointsTransferFailureReasonCode {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ACCOUNT_CURRENCY_MISMATCH = "ACCOUNT_CURRENCY_MISMATCH",
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
}


export enum HNRewardPointsActivityType {
  AWARD = "AWARD",
  REDEEM = "REDEEM",
  REFUND = "REFUND",
  DEDUCT = "DEDUCT",
}


export enum HNRewardPointsTransferSource {
  API = "API",
  CARD_TRANSACTION = "CARD_TRANSACTION",
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
}


export type HNCreditFundsACHTransferEvent = {
  __typename: "HNCreditFundsACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  toFinancialAccount?: HNFinancialAccount | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNACHTransferEvent = {
  __typename: "HNACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  returnDate?: string | null,
};

export type HNDebitFundsACHTransferEvent = {
  __typename: "HNDebitFundsACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNFinancialAccount | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNExternallyInitiatedACHStatusDetails = HNNonFailureExternallyInitiatedACHStatus | HNFailureExternallyInitiatedACHStatus


export type HNNonFailureExternallyInitiatedACHStatus = {
  __typename: "HNNonFailureExternallyInitiatedACHStatus",
  status?: HNExternallyInitiatedACHStatus | null,
};

export enum HNExternallyInitiatedACHStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
  REVERSED = "REVERSED",
  CANCELED = "CANCELED",
}


export type HNFailureExternallyInitiatedACHStatus = {
  __typename: "HNFailureExternallyInitiatedACHStatus",
  status?: HNExternallyInitiatedACHStatus | null,
  statusReasonCode?: HNExternallyInitiatedACHStatusReasonCode | null,
};

export type HNElectronicFundsTransfer = {
  __typename: "HNElectronicFundsTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export type HNPayrollTransfer = {
  __typename: "HNPayrollTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  toFinancialAccount?: HNFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  cardProduct?: HNCardProduct | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNExternallyInitiatedACHTransfer = {
  __typename: "HNExternallyInitiatedACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  cardProduct?: HNCardProduct | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNCreditFunds = {
  __typename: "HNCreditFunds",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  toFinancialAccount?: HNFinancialAccount | null,
  cardProduct?: HNCardProduct | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNACHDescriptor = {
  __typename: "HNACHDescriptor",
  companyEntryDescription?: string | null,
  individualName?: string | null,
  individualIdentificationNumber?: string | null,
};

export type HNDebitFunds = {
  __typename: "HNDebitFunds",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fromFinancialAccount?: HNFinancialAccount | null,
  cardProduct?: HNCardProduct | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNSecureDeposit = {
  __typename: "HNSecureDeposit",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  cardProduct?: HNCardProduct | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNAllFinancialAccount = HNFinancialAccount | HNExternalFinancialBankAccount | HNNonVerifiedExternalUSFinancialBankAccount


export type HNExternalFinancialBankAccount = {
  __typename: "HNExternalFinancialBankAccount",
  id: string,
  ledgers?:  Array<HNLedger > | null,
  owner?: HNFinancialAccountOwner | null,
  name?: string | null,
  provider?: HNBankVerificationProvider | null,
  accountStatus?: string | null,
  features?:  Array<HNFinancialAccountFeature > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  externalBankAccountDetails?: HNExternalBankAccountDetail | null,
  integratorInitiatedAchTransfers?: HNACHTransactionConnection | null,
  externallyInitiatedAchTransfers?: HNACHTransactionConnection | null,
  integratorInitiatedACHTransfer?: HNIntegratorInitiatedACHTransferConnection | null,
  integratorACHTransfers?: HNIntegratorInitiatedACHTransferConnection | null,
  externallyInitiatedACHTransfer?: HNExternallyInitiatedACHTransferConnection | null,
  externalACHTransfers?: HNExternallyInitiatedACHTransferConnection | null,
  originatedAchTransfers?: HNOriginatedAchTransferPayload | null,
  nonOriginatedAchTransfers?: HNNonOriginatedAchTransferPayload | null,
  transactionEvents?: HNTransactionEventConnection | null,
};

export type HNFinancialAccountOwner = HNOrganization | HNPaymentCard | HNUSPersonAccountHolder | HNUSBusinessAccountHolder


export type HNFinancialAccountFeature = {
  __typename: "HNFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNDirectDepositFinancialAccountFeature = {
  __typename: "HNDirectDepositFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPrePaidPaymentCardFinancialAccountFeature = {
  __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNDebitPaymentCardFinancialAccountFeature = {
  __typename: "HNDebitPaymentCardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCreditPaymentCardFinancialAccountFeature = {
  __typename: "HNCreditPaymentCardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPayrollAdvanceFinancialAccountFeature = {
  __typename: "HNPayrollAdvanceFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPayrollEmployerAdvanceFinancialAccountFeature = {
  __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNNegativeBalanceReserveFinancialAccountFeature = {
  __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNProductReserveFinancialAccountFeature = {
  __typename: "HNProductReserveFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNProductFundingFinancialAccountFeature = {
  __typename: "HNProductFundingFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNIncomeAccountFinancialAccountFeature = {
  __typename: "HNIncomeAccountFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNJustInTimeFundingFinancialAccountFeature = {
  __typename: "HNJustInTimeFundingFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNOnDemandFundingFinancialAccountFeature = {
  __typename: "HNOnDemandFundingFinancialAccountFeature",
  sourceFinancialAccountId?: string | null,
  pseudoBalanceEnabled?: boolean | null,
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNSecuredCreditPaymentCardFinancialAccountFeature = {
  __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  creditLimit?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNFleetCardAccountFeature = {
  __typename: "HNFleetCardAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  creditLimit?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCommercialCreditPayInFullCardAccountFeature = {
  __typename: "HNCommercialCreditPayInFullCardAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  creditLimit?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCreditCardAccountFeature = {
  __typename: "HNCreditCardAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  creditLimit?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCardFundingFinancialAccountFeature = {
  __typename: "HNCardFundingFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  creditLimit?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPointRewardFinancialAccountFeature = {
  __typename: "HNPointRewardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNNonVerifiedFinancialAccountFeature = {
  __typename: "HNNonVerifiedFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNAchCapableFinancialAccountFeature = {
  __typename: "HNAchCapableFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNVendorProvidedBankFinancialAccountFeature = {
  __typename: "HNVendorProvidedBankFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPartialFundingFinancialAccountFeature = {
  __typename: "HNPartialFundingFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  maximumAggregateCreditDistributionAmount?: HNAmount | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNRepaymentFinancialAccountFeature = {
  __typename: "HNRepaymentFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPreprintedCardFinancialAccountFeature = {
  __typename: "HNPreprintedCardFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNSecuredDepositFinancialAccountFeature = {
  __typename: "HNSecuredDepositFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNProductSecuredDepositFinancialAccountFeature = {
  __typename: "HNProductSecuredDepositFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNMerchantSettlementFinancialAccountFeature = {
  __typename: "HNMerchantSettlementFinancialAccountFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNACHTransactionConnection = {
  __typename: "HNACHTransactionConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNACHTransactionEdge > | null,
};

export type HNACHTransactionEdge = {
  __typename: "HNACHTransactionEdge",
  cursor: string,
  node?: HNACHTransactionEdgeNode | null,
};

export type HNACHTransactionEdgeNode = HNSecureDepositACHTransfer | HNSecureCardBalanceRepaymentACHTransfer | HNIntegratorInitiatedFundsWithdrawalACHTransfer | HNIntegratorInitiatedFundsDepositACHTransfer


export type HNSecureDepositACHTransfer = {
  __typename: "HNSecureDepositACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  cardProduct?: HNCardProduct | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNIntegratorInitiatedACHTransfer = {
  __typename: "HNIntegratorInitiatedACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  cardProduct?: HNCardProduct | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNIntegratorInitiatedFundsWithdrawalACHTransfer = {
  __typename: "HNIntegratorInitiatedFundsWithdrawalACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  sameDay?: boolean | null,
  cardProduct?: HNCardProduct | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNIntegratorInitiatedACHStatusDetails = HNNonFailureIntegratorInitiatedACHStatus | HNFailureIntegratorInitiatedACHStatus


export type HNNonFailureIntegratorInitiatedACHStatus = {
  __typename: "HNNonFailureIntegratorInitiatedACHStatus",
  status?: HNIntegratorInitiatedACHStatus | null,
};

export enum HNIntegratorInitiatedACHStatus {
  INITIATED = "INITIATED",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
}


export type HNFailureIntegratorInitiatedACHStatus = {
  __typename: "HNFailureIntegratorInitiatedACHStatus",
  status?: HNIntegratorInitiatedACHStatus | null,
  statusReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
};

export type HNIntegratorInitiatedFundsDepositACHTransfer = {
  __typename: "HNIntegratorInitiatedFundsDepositACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  sameDay?: boolean | null,
  cardProduct?: HNCardProduct | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNSecureCardBalanceRepaymentACHTransfer = {
  __typename: "HNSecureCardBalanceRepaymentACHTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  companyName?: string | null,
  descriptor?: HNACHDescriptor | null,
  companyIdentifier?: string | null,
  settlementDate?: string | null,
  fundsAvailableDate?: string | null,
  cardProduct?: HNCardProduct | null,
  paymentRelatedInformation?: string | null,
  returnDate?: string | null,
  traceNumber?: string | null,
};

export type HNIntegratorInitiatedACHTransferConnection = {
  __typename: "HNIntegratorInitiatedACHTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNIntegratorInitiatedACHTransferEdge > | null,
};

export type HNIntegratorInitiatedACHTransferEdge = {
  __typename: "HNIntegratorInitiatedACHTransferEdge",
  cursor: string,
  node?: HNIntegratorInitiatedACHTransferEdgeNode | null,
};

export type HNIntegratorInitiatedACHTransferEdgeNode = HNSecureDepositACHTransfer | HNSecureCardBalanceRepaymentACHTransfer | HNIntegratorInitiatedFundsWithdrawalACHTransfer | HNIntegratorInitiatedFundsDepositACHTransfer


export type HNExternallyInitiatedACHTransferConnection = {
  __typename: "HNExternallyInitiatedACHTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNExternallyInitiatedACHTransferEdge > | null,
};

export type HNExternallyInitiatedACHTransferEdge = {
  __typename: "HNExternallyInitiatedACHTransferEdge",
  cursor: string,
  node?: HNExternallyInitiatedACHTransferEdgeNode | null,
};

export type HNExternallyInitiatedACHTransferEdgeNode = HNPayrollTransfer | HNDebitFunds | HNCreditFunds | HNSecureDeposit


export type HNOriginatedAchTransferPayload = HNOriginatedAchTransferConnection | HNUserError | HNAccessDeniedError


export type HNOriginatedAchTransferConnection = {
  __typename: "HNOriginatedAchTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNOriginatedAchTransferEdge > | null,
};

export type HNOriginatedAchTransferEdge = {
  __typename: "HNOriginatedAchTransferEdge",
  cursor: string,
  node?: HNOriginatedAchTransfer | null,
};

export type HNOriginatedAchTransfer = {
  __typename: "HNOriginatedAchTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  type?: HNAchTransferType | null,
  purpose?: HNAchTransferPurpose | null,
  sign?: HNAchTransferSign | null,
  fromFinancialAccount?: HNAchFromFinancialAccount | null,
  toFinancialAccount?: HNAchToFinancialAccount | null,
  cardProduct?: HNCardProduct | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  individualName?: string | null,
  individualIdentificationNumber?: string | null,
  paymentRelatedInformation?: string | null,
  sameDay?: boolean | null,
  traceNumber?: string | null,
  status?: HNOriginatedAchTransferStatus | null,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  effectiveEntryDate?: string | null,
  sentToBankAt?: string | null,
  expectedProcessedAt?: string | null,
  processedAt?: string | null,
  returnProcessedAt?: string | null,
  canceledAt?: string | null,
  failedAt?: string | null,
};

export type HNAchTransfer = {
  __typename: "HNAchTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  type?: HNAchTransferType | null,
  purpose?: HNAchTransferPurpose | null,
  sign?: HNAchTransferSign | null,
  cardProduct?: HNCardProduct | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  individualName?: string | null,
  individualIdentificationNumber?: string | null,
  paymentRelatedInformation?: string | null,
  traceNumber?: string | null,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  failedAt?: string | null,
};

export type HNNonOriginatedAchTransfer = {
  __typename: "HNNonOriginatedAchTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  type?: HNAchTransferType | null,
  purpose?: HNAchTransferPurpose | null,
  sign?: HNAchTransferSign | null,
  financialAccount?: HNFinancialAccount | null,
  cardProduct?: HNCardProduct | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  individualName?: string | null,
  individualIdentificationNumber?: string | null,
  paymentRelatedInformation?: string | null,
  traceNumber?: string | null,
  status?: HNNonOriginatedAchTransferStatus | null,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  settlementDate?: string | null,
  processedAt?: string | null,
  failedAt?: string | null,
  returnSentToBankAt?: string | null,
};

export enum HNAchTransferType {
  PUSH = "PUSH",
  PULL = "PULL",
}


export enum HNAchTransferPurpose {
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  REPAYMENT = "REPAYMENT",
  PAYROLL = "PAYROLL",
  DEPOSIT = "DEPOSIT",
  WITHDRAWAL = "WITHDRAWAL",
}


export enum HNAchTransferSign {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}


export enum HNNonOriginatedAchTransferStatus {
  RECEIVED = "RECEIVED",
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
  CANCELED = "CANCELED",
}


export enum HNAchTransferStatusFailureReason {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  HIGHNOTE_ACCOUNT_FROZEN = "HIGHNOTE_ACCOUNT_FROZEN",
  EXTERNAL_ACCOUNT_FROZEN = "EXTERNAL_ACCOUNT_FROZEN",
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  INVALID_HIGHNOTE_ACCOUNT_NUMBER = "INVALID_HIGHNOTE_ACCOUNT_NUMBER",
  INVALID_EXTERNAL_ACCOUNT_NUMBER = "INVALID_EXTERNAL_ACCOUNT_NUMBER",
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  FILE_RECORD_EDIT_CRITERIA = "FILE_RECORD_EDIT_CRITERIA",
  BRANCH_SOLD_TO_ANOTHER_DFI = "BRANCH_SOLD_TO_ANOTHER_DFI",
  INVALID_ACH_ROUTING_NUMBER = "INVALID_ACH_ROUTING_NUMBER",
  REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY = "REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY",
  BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED = "BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED",
  CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER = "CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER",
  ADDENDA_ERROR = "ADDENDA_ERROR",
  MANDATORY_FIELD_ERROR = "MANDATORY_FIELD_ERROR",
  TRACE_NUMBER_ERROR = "TRACE_NUMBER_ERROR",
  ROUTING_NUMBER_CHECK_DIGIT_ERROR = "ROUTING_NUMBER_CHECK_DIGIT_ERROR",
  RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM = "RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM",
  PERMISSIBLE_RETURN_ENTRY = "PERMISSIBLE_RETURN_ENTRY",
  RDFI_NON_SETTLEMENT = "RDFI_NON_SETTLEMENT",
  RETURN_OF_XCK_ENTRY = "RETURN_OF_XCK_ENTRY",
  LIMITED_PARTICIPATION_DFI = "LIMITED_PARTICIPATION_DFI",
  RETURN_OF_IMPROPER_DEBIT_ENTRY = "RETURN_OF_IMPROPER_DEBIT_ENTRY",
  RETURN_OF_IMPROPER_CREDIT_ENTRY = "RETURN_OF_IMPROPER_CREDIT_ENTRY",
  SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT = "SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT",
  STOP_PAYMENT_ON_SOURCE_DOCUMENT = "STOP_PAYMENT_ON_SOURCE_DOCUMENT",
  IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT = "IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT",
  RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY = "RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY",
  INVALID_TRANSACTION_CODE = "INVALID_TRANSACTION_CODE",
  ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR = "ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR",
  INVALID_DFI_ACCOUNT_NUMBER = "INVALID_DFI_ACCOUNT_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER",
  INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME = "INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME",
  INVALID_REPRESENTATIVE_PAYEE_INDICATOR = "INVALID_REPRESENTATIVE_PAYEE_INDICATOR",
  DUPLICATE_ENROLLMENT = "DUPLICATE_ENROLLMENT",
  STATE_LAW_AFFECTING_RCK_ACCEPTANCE = "STATE_LAW_AFFECTING_RCK_ACCEPTANCE",
  ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER = "ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER",
  STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY = "STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY",
  ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT = "ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT",
  MISROUTED_RETURN = "MISROUTED_RETURN",
  ERRONEOUS_OR_REVERSING_DEBIT = "ERRONEOUS_OR_REVERSING_DEBIT",
  DUPLICATE_RETURN = "DUPLICATE_RETURN",
  UNTIMELY_RETURN = "UNTIMELY_RETURN",
  FIELD_ERRORS = "FIELD_ERRORS",
  PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI = "PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI",
  MISROUTED_DISHONORED_RETURN = "MISROUTED_DISHONORED_RETURN",
  UNTIMELY_DISHONORED_RETURN = "UNTIMELY_DISHONORED_RETURN",
  TIMELY_ORIGINAL_RETURN = "TIMELY_ORIGINAL_RETURN",
  CORRECTED_RETURN = "CORRECTED_RETURN",
  RETURN_NOT_A_DUPLICATE = "RETURN_NOT_A_DUPLICATE",
  NO_ERRORS_FOUND = "NO_ERRORS_FOUND",
  NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN = "NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN",
  IAT_ENTRY_CODING_ERRORS = "IAT_ENTRY_CODING_ERRORS",
  NON_PARTICIPANT_IN_IAT_PROGRAM = "NON_PARTICIPANT_IN_IAT_PROGRAM",
  INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION = "INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION",
  FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE = "FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE",
  ENTRY_NOT_PROCESSED_BY_GATEWAY = "ENTRY_NOT_PROCESSED_BY_GATEWAY",
  INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT = "INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT",
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT",
  HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED",
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED = "SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED",
  POINT_REWARDS_FEATURE_NOT_ENABLED = "POINT_REWARDS_FEATURE_NOT_ENABLED",
  NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED = "NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED",
  PRODUCT_RESERVE_FEATURE_NOT_ENABLED = "PRODUCT_RESERVE_FEATURE_NOT_ENABLED",
  DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED = "REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED",
  CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  REVOLVING_CARD_FEATURE_NOT_ENABLED = "REVOLVING_CARD_FEATURE_NOT_ENABLED",
  CHARGE_CARD_FEATURE_NOT_ENABLED = "CHARGE_CARD_FEATURE_NOT_ENABLED",
  COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED",
  JIT_FEATURE_NOT_ENABLED = "JIT_FEATURE_NOT_ENABLED",
  PARTIAL_FUNDING_FEATURE_NOT_ENABLED = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED",
  PREPRINTED_CARD_FEATURE_NOT_ENABLED = "PREPRINTED_CARD_FEATURE_NOT_ENABLED",
  INCOME_ACCOUNT_FEATURE_NOT_ENABLED = "INCOME_ACCOUNT_FEATURE_NOT_ENABLED",
  ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED = "BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED",
  PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED",
  SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED = "SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED",
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
}


export type HNAchFromFinancialAccount = HNFinancialAccount | HNExternalFinancialBankAccount


export type HNAchToFinancialAccount = HNFinancialAccount | HNExternalFinancialBankAccount | HNNonVerifiedExternalUSFinancialBankAccount


export type HNNonVerifiedExternalUSFinancialBankAccount = {
  __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
  id: string,
  name?: string | null,
  accountStatus?: string | null,
  externalBankAccountDetails?: HNNonVerifiedExternalUSFinancialBankAccountDetail | null,
  owner?: HNFinancialAccountOwner | null,
  features?:  Array<HNFinancialAccountFeature > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNNonVerifiedExternalUSFinancialBankAccountDetail = {
  __typename: "HNNonVerifiedExternalUSFinancialBankAccountDetail",
  id: string,
  last4?: string | null,
  type?: HNBankAccountType | null,
  routingNumber?: string | null,
  restrictedDetails?: HNNonVerifiedExternalUSFinancialBankAccountDetailRestrictedDetailsResult | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNNonVerifiedExternalUSFinancialBankAccountDetailRestrictedDetailsResult = HNNonVerifiedExternalUSFinancialBankAccountRestrictedDetails | HNAccessDeniedError


export type HNNonVerifiedExternalUSFinancialBankAccountRestrictedDetails = {
  __typename: "HNNonVerifiedExternalUSFinancialBankAccountRestrictedDetails",
  number?: string | null,
  routingNumber?: string | null,
};

export enum HNOriginatedAchTransferStatus {
  INITIATED = "INITIATED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  RETURNED = "RETURNED",
}


export type HNUserError = {
  __typename: "HNUserError",
  errors?:  Array<HNFieldUserError > | null,
};

export type HNFieldUserError = {
  __typename: "HNFieldUserError",
  path?: Array< string > | null,
  code?: string | null,
  description?: string | null,
  errorPath?: Array< string > | null,
};

export type HNNonOriginatedAchTransferPayload = HNNonOriginatedAchTransferConnection | HNUserError | HNAccessDeniedError


export type HNNonOriginatedAchTransferConnection = {
  __typename: "HNNonOriginatedAchTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNNonOriginatedAchTransferEdge > | null,
};

export type HNNonOriginatedAchTransferEdge = {
  __typename: "HNNonOriginatedAchTransferEdge",
  cursor: string,
  node?: HNNonOriginatedAchTransfer | null,
};

export type HNTransactionEventConnection = {
  __typename: "HNTransactionEventConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNTransactionEventEdge > | null,
};

export type HNTransactionEventEdge = {
  __typename: "HNTransactionEventEdge",
  cursor: string,
  node?: HNTransactionEvent | null,
};

export type HNExternallyInitiatedWireTransfer = {
  __typename: "HNExternallyInitiatedWireTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  status?: HNWireTransferStatusDetails | null,
  toFinancialAccount?: HNFinancialAccount | null,
};

export type HNWireTransferStatusDetails = HNNonFailureWireTransferStatus | HNFailureWireTransferStatus


export type HNNonFailureWireTransferStatus = {
  __typename: "HNNonFailureWireTransferStatus",
  status?: HNWireTransferStatus | null,
};

export enum HNWireTransferStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export type HNFailureWireTransferStatus = {
  __typename: "HNFailureWireTransferStatus",
  status?: HNWireTransferStatus | null,
  statusReasonCode?: HNWireStatusReasonCode | null,
};

export enum HNWireStatusReasonCode {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
}


export type HNPayrollACHTransferEvent = {
  __typename: "HNPayrollACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  toFinancialAccount?: HNFinancialAccount | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNSecureDepositACHTransferEvent = {
  __typename: "HNSecureDepositACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNExternalFinancialBankAccount | null,
  toFinancialAccount?: HNFinancialAccount | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNSecureDepositTransferEvent = {
  __typename: "HNSecureDepositTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  status?: HNExternallyInitiatedACHStatusDetails | null,
  toFinancialAccount?: HNFinancialAccount | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNSecureCardBalanceRepaymentACHTransferEvent = {
  __typename: "HNSecureCardBalanceRepaymentACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNExternalFinancialBankAccount | null,
  toFinancialAccount?: HNFinancialAccount | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNIntegratorInitiatedFundsWithdrawalACHTransferEvent = {
  __typename: "HNIntegratorInitiatedFundsWithdrawalACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNFinancialAccount | null,
  toFinancialAccount?: HNExternalFinancialAccount | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNExternalFinancialAccount = HNExternalFinancialBankAccount | HNNonVerifiedExternalUSFinancialBankAccount


export type HNIntegratorInitiatedFundsDepositACHTransferEvent = {
  __typename: "HNIntegratorInitiatedFundsDepositACHTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  status?: HNIntegratorInitiatedACHStatusDetails | null,
  fromFinancialAccount?: HNExternalFinancialAccount | null,
  toFinancialAccount?: HNFinancialAccount | null,
  companyName?: string | null,
  companyIdentifier?: string | null,
  companyEntryDescription?: string | null,
  settlementDate?: string | null,
  transfer?: HNElectronicFundsTransfer | null,
  returnDate?: string | null,
};

export type HNFeeTransferEvent = {
  __typename: "HNFeeTransferEvent",
  id: string,
  feeTransfer?: HNFeeTransfer | null,
};

export type HNFeeTransfer = HNChargedFeeTransfer | HNReversedFeeTransfer


export type HNChargedFeeTransfer = {
  __typename: "HNChargedFeeTransfer",
  originatingAccount?: HNFinancialAccount | null,
  receivingAccount?: HNFinancialAccount | null,
  cardProduct?: HNCardProduct | null,
  feeActivityType?: HNFeeTransferEventFeeActivityType | null,
  feeAmount?: HNAmount | null,
  transferedFeeAmount?: HNAmount | null,
  transferDate?: string | null,
  status?: HNFeeTransferStatusDetails | null,
  feeChargeRule?: HNFeeChargeRule | null,
  feeChargeActvity?: HNFeeChargeActivity | null,
};

export enum HNFeeTransferEventFeeActivityType {
  ATM_WITHDRAWAL_IN_NETWORK_FEE = "ATM_WITHDRAWAL_IN_NETWORK_FEE",
  ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE",
  ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE",
  ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  ATM_DECLINE_FEE = "ATM_DECLINE_FEE",
  ATM_DECLINE_INTERNATIONAL_FEE = "ATM_DECLINE_INTERNATIONAL_FEE",
  ATM_BALANCE_INQUIRY_IN_NETWORK_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_FEE",
  ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE",
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE",
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  INTERNATIONAL_TRANSACTION_FEE = "INTERNATIONAL_TRANSACTION_FEE",
  PHYSICAL_CARD_REISSUE_FEE = "PHYSICAL_CARD_REISSUE_FEE",
  EXPEDITED_PHYSICAL_CARD_FEE = "EXPEDITED_PHYSICAL_CARD_FEE",
  MONTHLY_ACCOUNT_ANNIVERSARY_FEE = "MONTHLY_ACCOUNT_ANNIVERSARY_FEE",
  VIRTUAL_CARD_REISSUE_FEE = "VIRTUAL_CARD_REISSUE_FEE",
  RETURN_PAYMENT_FEE = "RETURN_PAYMENT_FEE",
  ACCOUNT_INITIATION_FEE = "ACCOUNT_INITIATION_FEE",
  LATE_PAYMENT_FEE = "LATE_PAYMENT_FEE",
  CASH_BACK_POS_FEE = "CASH_BACK_POS_FEE",
  CASH_BACK_OTC_FEE = "CASH_BACK_OTC_FEE",
  ACCOUNT_INACTIVITY_FEE = "ACCOUNT_INACTIVITY_FEE",
}


export type HNFeeTransferStatusDetails = HNNonFailureFeeTransferStatus | HNFailureFeeTransferStatus


export type HNNonFailureFeeTransferStatus = {
  __typename: "HNNonFailureFeeTransferStatus",
  status?: HNFeeTransferEventStatus | null,
};

export enum HNFeeTransferEventStatus {
  PENDING = "PENDING",
  COMPLETE = "COMPLETE",
  FAIL = "FAIL",
}


export type HNFailureFeeTransferStatus = {
  __typename: "HNFailureFeeTransferStatus",
  status?: HNFeeTransferEventStatus | null,
  reasonDetails?: HNFeeTransferEventFailure | null,
};

export type HNFeeTransferEventFailure = {
  __typename: "HNFeeTransferEventFailure",
  type?: HNFeeTransferEventFailureType | null,
  reason?: string | null,
};

export enum HNFeeTransferEventFailureType {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
}


export type HNFeeChargeRule = {
  __typename: "HNFeeChargeRule",
  id: string,
  name?: string | null,
  order?: number | null,
  value?: HNFeeChargeValue | null,
  conditions?:  Array<HNFeeChargeRuleCondition > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFeeChargeValue = HNFixedFeeChargeValue | HNVariableFeeChargeValue


export type HNFixedFeeChargeValue = {
  __typename: "HNFixedFeeChargeValue",
  amount?: HNAmount | null,
};

export type HNVariableFeeChargeValue = {
  __typename: "HNVariableFeeChargeValue",
  percentage?: number | null,
  basisPoints?: number | null,
};

export type HNFeeChargeRuleCondition = HNFeeChargeRuleAmountCondition | HNFeeChargeRuleCountCondition


export type HNFeeChargeRuleAmountCondition = {
  __typename: "HNFeeChargeRuleAmountCondition",
  id: string,
  description?: string | null,
  condition?: HNAmountFeeCondition | null,
  aggregatedAt?: HNFeeConditionAggregation | null,
  aggregationDuration?: HNFeeChargeConditionDuration | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAmountFeeCondition = {
  __typename: "HNAmountFeeCondition",
  value?: HNAmountFeeConditionValue | null,
  operator?: HNFeeChargeOperator | null,
};

export type HNAmountFeeConditionValue = {
  __typename: "HNAmountFeeConditionValue",
  amount?: HNAmount | null,
  maximumAmount?: HNAmount | null,
};

export enum HNFeeChargeOperator {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  BETWEEN = "BETWEEN",
}


export enum HNFeeConditionAggregation {
  ACCOUNT = "ACCOUNT",
  PAYMENT_CARD = "PAYMENT_CARD",
}


export enum HNFeeChargeConditionDuration {
  NONE = "NONE",
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
  LIFETIME = "LIFETIME",
}


export type HNFeeChargeRuleCountCondition = {
  __typename: "HNFeeChargeRuleCountCondition",
  id: string,
  description?: string | null,
  condition?: HNCountFeeCondition | null,
  aggregatedAt?: HNFeeConditionAggregation | null,
  aggregationDuration?: HNFeeChargeConditionDuration | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCountFeeCondition = {
  __typename: "HNCountFeeCondition",
  value?: HNCountFeeConditionValue | null,
  operator?: HNFeeChargeOperator | null,
};

export type HNCountFeeConditionValue = {
  __typename: "HNCountFeeConditionValue",
  count?: number | null,
  maximumCount?: number | null,
};

export type HNFeeChargeActivity = HNPhysicalPaymentCardOrder | HNPaymentCard | HNFinancialAccount | HNSecureDepositACHTransfer | HNSecureCardBalanceRepaymentACHTransfer | HNIntegratorInitiatedFundsWithdrawalACHTransfer | HNIntegratorInitiatedFundsDepositACHTransfer | HNAuthorizationAndClearEvent | HNClearingEvent | HNBalanceInquiryEvent


export type HNBalanceInquiryEvent = {
  __typename: "HNBalanceInquiryEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transaction?: HNTransaction | null,
  networkResponseCode?: string | null,
  avsResponseCode?: HNAVSResponseCode | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  spendRuleResults?: HNSpendRuleResultConnection | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNReversedFeeTransfer = {
  __typename: "HNReversedFeeTransfer",
  originatingAccount?: HNFinancialAccount | null,
  receivingAccount?: HNFinancialAccount | null,
  transferedFeeAmount?: HNAmount | null,
  transferDate?: string | null,
  status?: HNFeeTransferStatusDetails | null,
  sourceFeeTransferEvent?: HNFeeTransferEvent | null,
};

export type HNFinancialAccountCreditLimitUpdateFromProductFunding = {
  __typename: "HNFinancialAccountCreditLimitUpdateFromProductFunding",
  id: string,
  amount?: HNAmount | null,
  status?: HNFinancialAccountCreditLimitUpdateFromProductFundingStatus | null,
  statusReason?: HNFinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  memo?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export enum HNFinancialAccountCreditLimitUpdateFromProductFundingStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum HNFinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
}


export type HNExternallyInitiatedAchReleaseHoldTransfer = {
  __typename: "HNExternallyInitiatedAchReleaseHoldTransfer",
  id: string,
  amount?: HNAmount | null,
  status?: HNInterFinancialAccountTransferStatus | null,
  statusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export type HNPayrollAdvanceWriteoffTransfer = {
  __typename: "HNPayrollAdvanceWriteoffTransfer",
  id: string,
  amount?: HNAmount | null,
  status?: HNInterFinancialAccountTransferStatus | null,
  statusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export type HNPayrollAdvanceRepaymentTransfer = {
  __typename: "HNPayrollAdvanceRepaymentTransfer",
  id: string,
  amount?: HNAmount | null,
  status?: HNInterFinancialAccountTransferStatus | null,
  statusReason?: HNInterFinancialAccountTransferStatusReasonCode | null,
  memo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
};

export type HNIssuerPreliminaryAuthorizationEvent = {
  __typename: "HNIssuerPreliminaryAuthorizationEvent",
  id: string,
  transaction?: HNTransaction | null,
  responseCode?: HNTransactionEventResponseCode | null,
  avsResponseCode?: HNAVSResponseCode | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  networkResponseCode?: string | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  authorizationExpiration?: string | null,
  spendRuleResults?: HNSpendRuleResultConnection | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export type HNFinancialAccountPseudoBalanceUpdate = {
  __typename: "HNFinancialAccountPseudoBalanceUpdate",
  id: string,
  status?: HNFinancialAccountPseudoBalanceUpdateStatus | null,
  statusReason?: HNFinancialAccountPseudoBalanceUpdateStatusReason | null,
  memo?: string | null,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNFinancialAccountPseudoBalanceUpdateStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum HNFinancialAccountPseudoBalanceUpdateStatusReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
}


export type HNManualAdjustmentEvent = {
  __typename: "HNManualAdjustmentEvent",
  id: string,
  adjustmentActivityType?: HNManualAdjustmentActivityType | null,
  manualAdjustmentDetails?:  Array<HNManualAdjustmentDetail > | null,
  originalFinancialEvent?: HNFinancialEvent | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  originalFinancialEventId?: string | null,
};

export enum HNManualAdjustmentActivityType {
  ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT = "ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT",
  ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF = "ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF",
  ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT = "ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT",
  ADJUST_FEE = "ADJUST_FEE",
  CARD_TRANSACTION_ADJUSTMENT = "CARD_TRANSACTION_ADJUSTMENT",
  CHARGEBACK = "CHARGEBACK",
  CHARGEBACK_CREATE_PROVISIONAL_CREDIT = "CHARGEBACK_CREATE_PROVISIONAL_CREDIT",
  EWA_REPAYMENT = "EWA_REPAYMENT",
  GENERAL_ADJUSTMENT = "GENERAL_ADJUSTMENT",
  NON_ORIGINATING_ACH_PAYROLL_LOAD = "NON_ORIGINATING_ACH_PAYROLL_LOAD",
  NON_ORIGINATING_ACH_UNLOAD = "NON_ORIGINATING_ACH_UNLOAD",
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT",
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT",
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT",
  RECEIVABLE_PURCHASE = "RECEIVABLE_PURCHASE",
  RISK_HOLD_CREDIT = "RISK_HOLD_CREDIT",
  WIRE_TRANSFER_ACCOUNT_LOAD = "WIRE_TRANSFER_ACCOUNT_LOAD",
  WIRE_TRANSFER_ACCOUNT_UNLOAD = "WIRE_TRANSFER_ACCOUNT_UNLOAD",
  REPAYMENT_ADJUSTMENT = "REPAYMENT_ADJUSTMENT",
  INTEREST_CHARGED_ADJUSTMENT = "INTEREST_CHARGED_ADJUSTMENT",
}


export type HNManualAdjustmentDetail = HNCreditManualAdjustmentDetail | HNDebitManualAdjustmentDetail


export type HNCreditManualAdjustmentDetail = {
  __typename: "HNCreditManualAdjustmentDetail",
  financialAccount?: HNFinancialAccount | null,
  amount?: HNAmount | null,
  normalBalance?: HNNormalBalance | null,
  ledgerName?: HNLedgerName | null,
};

export type HNDebitManualAdjustmentDetail = {
  __typename: "HNDebitManualAdjustmentDetail",
  financialAccount?: HNFinancialAccount | null,
  amount?: HNAmount | null,
  normalBalance?: HNNormalBalance | null,
  ledgerName?: HNLedgerName | null,
};

export type HNCreditCardTransferEvent = {
  __typename: "HNCreditCardTransferEvent",
  id: string,
  balanceType?: HNCreditBalanceType | null,
  interestDetails?: HNInterestDetails | null,
  accountingDirection?: HNAccountingDirection | null,
  statement?: HNFinancialAccountStatement | null,
  creditPlan?: HNCreditPlan | null,
};

export enum HNAccountingDirection {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}


export type HNFinancialAccountStatement = {
  __typename: "HNFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNSecuredDepositCommercialCreditCardFinancialAccountStatement = {
  __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountStatementEntryConnection = {
  __typename: "HNFinancialAccountStatementEntryConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFinancialAccountStatementEntryEdge > | null,
};

export type HNFinancialAccountStatementEntryEdge = {
  __typename: "HNFinancialAccountStatementEntryEdge",
  cursor: string,
  node?: HNFinancialAccountStatementEntry | null,
};

export type HNFinancialAccountStatementEntry = {
  __typename: "HNFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNSecuredDepositCommercialCreditCardFinancialAccountStatementEntry = {
  __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCreditPayInFullCardFinancialAccountStatementEntry = {
  __typename: "HNCreditPayInFullCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNConsumerChargeCardFinancialAccountStatementEntry = {
  __typename: "HNConsumerChargeCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNConsumerRevolvingCardFinancialAccountStatementEntry = {
  __typename: "HNConsumerRevolvingCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCommercialChargeCardFinancialAccountStatementEntry = {
  __typename: "HNCommercialChargeCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCommercialRevolvingCardFinancialAccountStatementEntry = {
  __typename: "HNCommercialRevolvingCardFinancialAccountStatementEntry",
  creditAmount?: HNAmount | null,
  debitAmount?: HNAmount | null,
  primaryCreditBalance?: HNAmount | null,
  primaryDebitBalance?: HNAmount | null,
  postDate?: string | null,
  ledgerEntry?: HNLedgerEntry | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCreditRepaymentStatementApplication = {
  __typename: "HNCreditRepaymentStatementApplication",
  statement?: HNFinancialAccountStatement | null,
  sourceRepayment?: HNCreditRepayment | null,
  appliedAmount?: HNAmount | null,
};

export type HNCreditRepayment = {
  __typename: "HNCreditRepayment",
  amount?: HNAmount | null,
  repaymentMethod?: HNCreditRepaymentMethod | null,
  repaymentType?: HNCreditRepaymentType | null,
  memo?: string | null,
  references?: Array< string > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNCreditRepaymentMethod {
  ACH = "ACH",
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
  FEE_ADJUSTMENT = "FEE_ADJUSTMENT",
  INTEREST_ADJUSTMENT = "INTEREST_ADJUSTMENT",
  REWARD_BALANCE = "REWARD_BALANCE",
}


export enum HNCreditRepaymentType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}


export type HNCreditPayInFullCardFinancialAccountStatement = {
  __typename: "HNCreditPayInFullCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  accumulatedAccountInterestAndFees?: HNAccumulatedAccountInterestAndFees | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAccumulatedAccountInterestAndFees = {
  __typename: "HNAccumulatedAccountInterestAndFees",
  yearToDateAccumulatedInterestDebit?: HNAmount | null,
  yearToDateAccumulatedInterestCredit?: HNAmount | null,
  yearToDateAccumulatedFeesDebit?: HNAmount | null,
  yearToDateAccumulatedFeesCredit?: HNAmount | null,
};

export type HNConsumerChargeCardFinancialAccountStatement = {
  __typename: "HNConsumerChargeCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  accumulatedAccountInterestAndFees?: HNAccumulatedAccountInterestAndFees | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNConsumerRevolvingCardFinancialAccountStatement = {
  __typename: "HNConsumerRevolvingCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodInterestCharges?: HNAmount | null,
  periodInterestCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  periodPurchaseCreditPlan?:  Array<HNFinancialAccountStatementPurchaseCreditPlan > | null,
  payOffWarning?: HNFinancialAccountStatementPayOffWarning | null,
  periodMinimumPaymentDue?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  accumulatedAccountInterestAndFees?: HNAccumulatedAccountInterestAndFees | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountStatementPurchaseCreditPlan = {
  __typename: "HNFinancialAccountStatementPurchaseCreditPlan",
  balanceType?: HNBalanceType | null,
  balanceSubjectToInterestAmount?: HNAmount | null,
  interestChargedAmount?: HNAmount | null,
  apr?: number | null,
};

export type HNFinancialAccountStatementBalanceType = {
  __typename: "HNFinancialAccountStatementBalanceType",
  balanceType?: HNBalanceType | null,
  balanceSubjectToInterestAmount?: HNAmount | null,
  interestChargedAmount?: HNAmount | null,
};

export enum HNBalanceType {
  PURCHASE = "PURCHASE",
}


export type HNFinancialAccountStatementPayOffWarning = {
  __typename: "HNFinancialAccountStatementPayOffWarning",
  paymentCycles?:  Array<HNFinancialAccountStatementPayOffPayment > | null,
};

export type HNFinancialAccountStatementPayOffPayment = {
  __typename: "HNFinancialAccountStatementPayOffPayment",
  payOffType?: HNPayOffType | null,
  paymentDetails?: HNPayOffPaymentDetails | null,
};

export enum HNPayOffType {
  MINIMUM_PAY_OFF = "MINIMUM_PAY_OFF",
  THREE_YEAR_PAY_OFF = "THREE_YEAR_PAY_OFF",
}


export type HNPayOffPaymentDetails = {
  __typename: "HNPayOffPaymentDetails",
  estimatedPayOffDays?: number | null,
  estimatedTotal?: HNAmount | null,
  periodPayment?: HNAmount | null,
};

export type HNCommercialChargeCardFinancialAccountStatement = {
  __typename: "HNCommercialChargeCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  accumulatedAccountInterestAndFees?: HNAccumulatedAccountInterestAndFees | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCommercialRevolvingCardFinancialAccountStatement = {
  __typename: "HNCommercialRevolvingCardFinancialAccountStatement",
  id: string,
  periodStart?: string | null,
  periodEnd?: string | null,
  openedAt?: string | null,
  closedAt?: string | null,
  startingPrimaryCreditBalance?: HNAmount | null,
  startingPrimaryDebitBalance?: HNAmount | null,
  endingPrimaryCreditBalance?: HNAmount | null,
  endingPrimaryDebitBalance?: HNAmount | null,
  primaryLedger?: HNLedger | null,
  startingSecondaryCreditBalance?: HNAmount | null,
  startingSecondaryDebitBalance?: HNAmount | null,
  endingSecondaryCreditBalance?: HNAmount | null,
  endingSecondaryDebitBalance?: HNAmount | null,
  secondaryLedger?: HNLedger | null,
  startingTertiaryCreditBalance?: HNAmount | null,
  startingTertiaryDebitBalance?: HNAmount | null,
  endingTertiaryCreditBalance?: HNAmount | null,
  endingTertiaryDebitBalance?: HNAmount | null,
  tertiaryLedger?: HNLedger | null,
  periodPurchasesAmount?: HNAmount | null,
  periodFeesAmount?: HNAmount | null,
  periodFeeCredit?: HNAmount | null,
  periodInterestCharges?: HNAmount | null,
  periodInterestCredit?: HNAmount | null,
  periodRefundsAndPaymentsAmount?: HNAmount | null,
  endingCreditLimit?: HNAmount | null,
  paymentDueOn?: string | null,
  pastDueAmount?: HNAmount | null,
  periodPurchaseCreditPlan?:  Array<HNFinancialAccountStatementPurchaseCreditPlan > | null,
  payOffWarning?: HNFinancialAccountStatementPayOffWarning | null,
  periodMinimumPaymentDue?: HNAmount | null,
  statementEntries?: HNFinancialAccountStatementEntryConnection | null,
  repaymentHistory?:  Array<HNCreditRepaymentStatementApplication > | null,
  accumulatedAccountInterestAndFees?: HNAccumulatedAccountInterestAndFees | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNDisbursementTransferEvent = {
  __typename: "HNDisbursementTransferEvent",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  eventType?: HNDisbursementTransferEventType | null,
  status?: HNDisbursementTransferEventStatus | null,
  failureReason?: HNDisbursementTransferEventFailureReason | null,
  toFinancialAccount?: HNFinancialAccount | null,
  ledgers?:  Array<HNLedger > | null,
};

export enum HNDisbursementTransferEventType {
  UNSPECIFIED = "UNSPECIFIED",
  DISBURSEMENT_PAYMENT = "DISBURSEMENT_PAYMENT",
  DISBURSEMENT_PLATFORM_FEE = "DISBURSEMENT_PLATFORM_FEE",
  DISBURSEMENT_INTERCHANGE_FEE = "DISBURSEMENT_INTERCHANGE_FEE",
  DISBURSEMENT_NETWORK_FEE = "DISBURSEMENT_NETWORK_FEE",
  DISBURSEMENT_PAYABLE = "DISBURSEMENT_PAYABLE",
}


export enum HNDisbursementTransferEventStatus {
  UNSPECIFIED = "UNSPECIFIED",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}


export enum HNDisbursementTransferEventFailureReason {
  UNSPECIFIED = "UNSPECIFIED",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  INVALID_DISBURSEMENT_AMOUNT = "INVALID_DISBURSEMENT_AMOUNT",
  MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
}


export type HNWireTransfer = {
  __typename: "HNWireTransfer",
  id: string,
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ledgers?:  Array<HNLedger > | null,
  type?: HNWireTransferType | null,
  status?: HNWireTransferStatus | null,
  statusReason?: HNWireTransferStatusReasonCode | null,
  financialAccount?: HNFinancialAccount | null,
  memo?: string | null,
};

export enum HNWireTransferType {
  INCOMING_WIRE_TRANSFER = "INCOMING_WIRE_TRANSFER",
  OUTGOING_WIRE_TRANSFER = "OUTGOING_WIRE_TRANSFER",
  INCOMING_WIRE_TRANSFER_REVERSAL = "INCOMING_WIRE_TRANSFER_REVERSAL",
  OUTGOING_WIRE_TRANSFER_REVERSAL = "OUTGOING_WIRE_TRANSFER_REVERSAL",
}


export enum HNWireTransferStatusReasonCode {
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
}


export enum HNTransferPurpose {
  REWARD = "REWARD",
  REWARD_REVERSAL = "REWARD_REVERSAL",
  TIP_DISBURSEMENT = "TIP_DISBURSEMENT",
  TIP_DISBURSEMENT_REVERSAL = "TIP_DISBURSEMENT_REVERSAL",
  EARNED_CREDIT = "EARNED_CREDIT",
  EARNED_CREDIT_REVERSAL = "EARNED_CREDIT_REVERSAL",
  GENERAL = "GENERAL",
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  INTRA_COMPANY = "INTRA_COMPANY",
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  SECURED_DEPOSIT_REVERSAL = "SECURED_DEPOSIT_REVERSAL",
  PAYOUT = "PAYOUT",
  PAYROLL = "PAYROLL",
  PAYROLL_REVERSAL = "PAYROLL_REVERSAL",
  PAYROLL_ADVANCE = "PAYROLL_ADVANCE",
  PAYROLL_ADVANCE_REVERSAL = "PAYROLL_ADVANCE_REVERSAL",
  PAYROLL_ADVANCE_REPAYMENT = "PAYROLL_ADVANCE_REPAYMENT",
  PAYROLL_ADVANCE_REPAYMENT_REVERSAL = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL",
  ADJUSTMENT = "ADJUSTMENT",
  REPAYMENT = "REPAYMENT",
  SET_LIMIT = "SET_LIMIT",
}


export type HNInterFinancialAccountTransferRuleResult = {
  __typename: "HNInterFinancialAccountTransferRuleResult",
  status?: HNInterFinancialAccountTransferRuleResultStatus | null,
  message?: string | null,
};

export type HNAmountLimitInterFinancialAccountTransferRuleResult = {
  __typename: "HNAmountLimitInterFinancialAccountTransferRuleResult",
  status?: HNInterFinancialAccountTransferRuleResultStatus | null,
  message?: string | null,
  interFinancialAccountTransferRule?: HNAmountLimitInterFinancialAccountTransferRule | null,
};

export enum HNInterFinancialAccountTransferRuleResultStatus {
  PASSED = "PASSED",
  FAILED = "FAILED",
  NOT_RAN = "NOT_RAN",
  NO_DECISION = "NO_DECISION",
  WARNING = "WARNING",
  EXCEPTION = "EXCEPTION",
}


export type HNTransferPurposeInterFinancialAccountTransferRuleResult = {
  __typename: "HNTransferPurposeInterFinancialAccountTransferRuleResult",
  status?: HNInterFinancialAccountTransferRuleResultStatus | null,
  message?: string | null,
  interFinancialAccountTransferRule?: HNTransferPurposeInterFinancialAccountTransferRule | null,
};

export type HNVelocityInterFinancialAccountTransferRuleResult = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleResult",
  status?: HNInterFinancialAccountTransferRuleResultStatus | null,
  message?: string | null,
  velocityInterFinancialAccountTransferRule?: HNVelocityInterFinancialAccountTransferRule | null,
  feedbackCode?: HNFeedbackCode | null,
};

export enum HNFeedbackCode {
  OVERRIDE_RULE_RESULTS_TO_ACCEPTED = "OVERRIDE_RULE_RESULTS_TO_ACCEPTED",
  OVERRIDE_RULE_RESULTS_TO_DENIED = "OVERRIDE_RULE_RESULTS_TO_DENIED",
}


export type HNWatchlistInterFinancialAccountTransferRuleResult = {
  __typename: "HNWatchlistInterFinancialAccountTransferRuleResult",
  status?: HNInterFinancialAccountTransferRuleResultStatus | null,
  message?: string | null,
  interFinancialAccountTransferRule?: HNWatchlistInterFinancialAccountTransferRule | null,
  feedbackCode?: HNFeedbackCode | null,
};

export enum HNInterFinancialAccountTransferActivityType {
  GENERAL = "GENERAL",
  PAYROLL_ADVANCE = "PAYROLL_ADVANCE",
  PAYROLL_ADVANCE_REPAYMENT = "PAYROLL_ADVANCE_REPAYMENT",
  LOAD_PAYMENT_CARD_ACCOUNT = "LOAD_PAYMENT_CARD_ACCOUNT",
  SET_LIMIT = "SET_LIMIT",
  PAYROLL_ADVANCE_CHARGE_OFF = "PAYROLL_ADVANCE_CHARGE_OFF",
  PAYROLL_DEPOSIT = "PAYROLL_DEPOSIT",
  REWARD = "REWARD",
  REWARD_REVERSAL = "REWARD_REVERSAL",
  EARNED_CREDIT = "EARNED_CREDIT",
  EARNED_CREDIT_REVERSAL = "EARNED_CREDIT_REVERSAL",
  SET_PSEUDO_BALANCE = "SET_PSEUDO_BALANCE",
  RECOVER_SECURED_DEPOSIT = "RECOVER_SECURED_DEPOSIT",
  CHARGEBACK_PROVISIONAL_CREDIT = "CHARGEBACK_PROVISIONAL_CREDIT",
  TIP_DISBURSEMENT = "TIP_DISBURSEMENT",
  TIP_DISBURSEMENT_REVERSAL = "TIP_DISBURSEMENT_REVERSAL",
  DISPUTE_CREDIT = "DISPUTE_CREDIT",
  CHARGEBACK_WIN = "CHARGEBACK_WIN",
  CHARGEBACK_LOSS = "CHARGEBACK_LOSS",
  CLOSE_LINE_OF_CREDIT = "CLOSE_LINE_OF_CREDIT",
  RECEIVABLE_PURCHASE = "RECEIVABLE_PURCHASE",
  RECEIVABLE_PURCHASE_REVERSAL = "RECEIVABLE_PURCHASE_REVERSAL",
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  INTRA_COMPANY = "INTRA_COMPANY",
  CHARGE_OFF = "CHARGE_OFF",
  REPAYMENT_ADJUSTMENT = "REPAYMENT_ADJUSTMENT",
  GENERAL_ADJUSTMENT = "GENERAL_ADJUSTMENT",
  PAYOUT = "PAYOUT",
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  SECURED_DEPOSIT_REVERSAL = "SECURED_DEPOSIT_REVERSAL",
  CASH_REDEEM_REWARD_POINTS = "CASH_REDEEM_REWARD_POINTS",
  CASH_REDEEM_REWARD_POINTS_REVERSAL = "CASH_REDEEM_REWARD_POINTS_REVERSAL",
  PAYROLL = "PAYROLL",
  PAYROLL_REVERSAL = "PAYROLL_REVERSAL",
  ACCOUNT_PAYROLL_ADVANCE = "ACCOUNT_PAYROLL_ADVANCE",
  PAYROLL_ADVANCE_REVERSAL = "PAYROLL_ADVANCE_REVERSAL",
  ACCOUNT_PAYROLL_ADVANCE_REPAYMENT = "ACCOUNT_PAYROLL_ADVANCE_REPAYMENT",
  PAYROLL_ADVANCE_REPAYMENT_REVERSAL = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL",
  ADJUSTMENT = "ADJUSTMENT",
  CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT = "CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT",
}


export type HNPersonAccountHolderIdentityUpdatedEvent = {
  __typename: "HNPersonAccountHolderIdentityUpdatedEvent",
  personAccountHolder?: HNUSPersonAccountHolder | null,
  createdAt?: string | null,
  updateTypes?: Array< HNPersonAccountHolderIdentityUpdateType > | null,
};

export enum HNPersonAccountHolderIdentityUpdateType {
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  BILLING_ADDRESS = "BILLING_ADDRESS",
  TOTAL_ANNUAL_INCOME = "TOTAL_ANNUAL_INCOME",
  CURRENT_DEBT_OBLIGATIONS = "CURRENT_DEBT_OBLIGATIONS",
  EMPLOYMENT_STATUS = "EMPLOYMENT_STATUS",
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
}


export type HNBusinessAccountHolderIdentityUpdatedEvent = {
  __typename: "HNBusinessAccountHolderIdentityUpdatedEvent",
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  updateTypes?: Array< HNBusinessAccountHolderIdentityUpdateType > | null,
};

export enum HNBusinessAccountHolderIdentityUpdateType {
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  LEGAL_BUSINESS_NAME = "LEGAL_BUSINESS_NAME",
  BILLING_ADDRESS = "BILLING_ADDRESS",
  ANNUAL_REVENUE = "ANNUAL_REVENUE",
}


export type HNBusinessAuthorizedPersonIdentityUpdatedEvent = {
  __typename: "HNBusinessAuthorizedPersonIdentityUpdatedEvent",
  businessAuthorizedPerson?: HNUSBusinessAuthorizedPerson | null,
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  updateTypes?: Array< HNBusinessAssociatedPersonIdentityUpdateType > | null,
};

export enum HNBusinessAssociatedPersonIdentityUpdateType {
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  HOME_ADDRESS = "HOME_ADDRESS",
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
}


export type HNBusinessUltimateBeneficialOwnerIdentityUpdatedEvent = {
  __typename: "HNBusinessUltimateBeneficialOwnerIdentityUpdatedEvent",
  businessUltimateBeneficialOwner?: HNUSBusinessUltimateBeneficialOwner | null,
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  updateTypes?: Array< HNBusinessAssociatedPersonIdentityUpdateType > | null,
};

export type HNPersonAccountHolderIdentityDocumentsRequestedEvent = {
  __typename: "HNPersonAccountHolderIdentityDocumentsRequestedEvent",
  personAccountHolder?: HNUSPersonAccountHolder | null,
  createdAt?: string | null,
  documentUploadSession?: HNIdentityVerificationDocumentUploadSession | null,
  reason?: HNIdentityVerificationDocumentRequestReason | null,
};

export enum HNIdentityVerificationDocumentRequestReason {
  CIP_VERIFICATION = "CIP_VERIFICATION",
  ACCOUNT_HOLDER_UPDATE = "ACCOUNT_HOLDER_UPDATE",
}


export type HNBusinessAccountHolderIdentityDocumentsRequestedEvent = {
  __typename: "HNBusinessAccountHolderIdentityDocumentsRequestedEvent",
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  documentUploadSession?: HNIdentityVerificationDocumentUploadSession | null,
  reason?: HNIdentityVerificationDocumentRequestReason | null,
};

export type HNBusinessAuthorizedPersonIdentityDocumentsRequestedEvent = {
  __typename: "HNBusinessAuthorizedPersonIdentityDocumentsRequestedEvent",
  businessAuthorizedPerson?: HNUSBusinessAuthorizedPerson | null,
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  documentUploadSession?: HNIdentityVerificationDocumentUploadSession | null,
  reason?: HNIdentityVerificationDocumentRequestReason | null,
};

export type HNBusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent = {
  __typename: "HNBusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent",
  businessUltimateBeneficialOwner?: HNUSBusinessUltimateBeneficialOwner | null,
  businessAccountHolder?: HNUSBusinessAccountHolder | null,
  createdAt?: string | null,
  documentUploadSession?: HNIdentityVerificationDocumentUploadSession | null,
  reason?: HNIdentityVerificationDocumentRequestReason | null,
};

export type HNOriginatedAchTransferInitiatedEvent = {
  __typename: "HNOriginatedAchTransferInitiatedEvent",
  id: string,
  createdAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferPendingEvent = {
  __typename: "HNOriginatedAchTransferPendingEvent",
  id: string,
  processedPendingAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferProcessingEvent = {
  __typename: "HNOriginatedAchTransferProcessingEvent",
  id: string,
  sentToBankAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferProcessedEvent = {
  __typename: "HNOriginatedAchTransferProcessedEvent",
  id: string,
  processedAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferCanceledEvent = {
  __typename: "HNOriginatedAchTransferCanceledEvent",
  id: string,
  canceledAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferFailedEvent = {
  __typename: "HNOriginatedAchTransferFailedEvent",
  id: string,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  failedAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNOriginatedAchTransferReturnedEvent = {
  __typename: "HNOriginatedAchTransferReturnedEvent",
  id: string,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  returnProcessedAt?: string | null,
  transfer: HNOriginatedAchTransfer,
};

export type HNNonOriginatedAchTransferReceivedEvent = {
  __typename: "HNNonOriginatedAchTransferReceivedEvent",
  id: string,
  createdAt?: string | null,
  transfer: HNNonOriginatedAchTransfer,
};

export type HNNonOriginatedAchTransferProcessedEvent = {
  __typename: "HNNonOriginatedAchTransferProcessedEvent",
  id: string,
  processedAt?: string | null,
  transfer: HNNonOriginatedAchTransfer,
};

export type HNNonOriginatedAchTransferFailedEvent = {
  __typename: "HNNonOriginatedAchTransferFailedEvent",
  id: string,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  failedAt?: string | null,
  transfer: HNNonOriginatedAchTransfer,
};

export type HNNonOriginatedAchTransferReturnedEvent = {
  __typename: "HNNonOriginatedAchTransferReturnedEvent",
  id: string,
  statusFailureReason?: HNAchTransferStatusFailureReason | null,
  returnSentToBankAt?: string | null,
  transfer: HNNonOriginatedAchTransfer,
};

export type HNCreditLimitChangeRequestStatusChangedEvent = {
  __typename: "HNCreditLimitChangeRequestStatusChangedEvent",
  creditLimitChangeRequestId?: string | null,
  financialAccountId?: string | null,
  creditLimitChangeRequestType?: HNCreditLimitChangeRequestType | null,
  creditLimitChangeRequestStatus?: HNCreditLimitChangeRequestStatus | null,
  creditLimitChangeRequestFailureReason?: HNCreditLimitChangeRequestFailureReason | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNCreditLimitChangeRequestType {
  INCREASE = "INCREASE",
  DECREASE = "DECREASE",
}


export enum HNCreditLimitChangeRequestStatus {
  INITIATED = "INITIATED",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  CLOSED = "CLOSED",
  PENDING = "PENDING",
  FAILED = "FAILED",
}


export enum HNCreditLimitChangeRequestFailureReason {
  NSF = "NSF",
  OTHER = "OTHER",
}


export type HNAchTransferHoldAddedEvent = {
  __typename: "HNAchTransferHoldAddedEvent",
  id: string,
  fromHoldStatus?: HNAchHoldStatus | null,
  fromHoldType?: HNAchHoldType | null,
  holdStatusAddedAt?: string | null,
  transfer: HNAchTransfer,
};

export type HNAchTransferHoldRemovedEvent = {
  __typename: "HNAchTransferHoldRemovedEvent",
  id: string,
  fromHoldStatus?: HNAchHoldStatus | null,
  fromHoldType?: HNAchHoldType | null,
  holdStatusRemovedAt?: string | null,
  transfer: HNAchTransfer,
};

export type HNNotificationTargetStatusHistoryConnection = {
  __typename: "HNNotificationTargetStatusHistoryConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNNotificationTargetStatusHistoryEdge > | null,
};

export type HNNotificationTargetStatusHistoryEdge = {
  __typename: "HNNotificationTargetStatusHistoryEdge",
  cursor: string,
  node?: HNNotificationTargetStatusHistory | null,
};

export type HNNotificationTargetStatusHistory = {
  __typename: "HNNotificationTargetStatusHistory",
  id: string,
  target?: HNNotificationTarget | null,
  createdAt?: string | null,
  newStatus?: HNNotificationTargetStatus | null,
  previousStatus?: HNNotificationTargetStatus | null,
};

export type HNNotificationTarget = HNWebhookNotificationTarget


export type HNWebhookNotificationTargetEventConnection = {
  __typename: "HNWebhookNotificationTargetEventConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNWebhookNotificationTargetEventEdge > | null,
};

export type HNWebhookNotificationTargetEventEdge = {
  __typename: "HNWebhookNotificationTargetEventEdge",
  cursor: string,
  node?: HNWebhookNotificationTargetEvent | null,
};

export type HNWebhookNotificationTargetEvent = {
  __typename: "HNWebhookNotificationTargetEvent",
  hasSuccessfulDelivery?: boolean | null,
  event?: HNNotificationEvent | null,
  deliveryAttempts?: HNDeliveryAttemptConnection | null,
};

export type HNCollaborativeAuthorizationEndpointConnection = {
  __typename: "HNCollaborativeAuthorizationEndpointConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCollaborativeAuthorizationEndpointEdge > | null,
};

export type HNCollaborativeAuthorizationEndpointEdge = {
  __typename: "HNCollaborativeAuthorizationEndpointEdge",
  cursor: string,
  node?: HNCollaborativeAuthorizationEndpoint | null,
};

export type HNCollaborativeAuthorizationEndpoint = {
  __typename: "HNCollaborativeAuthorizationEndpoint",
  id: string,
  name?: string | null,
  uri?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  signingKeys?:  Array<HNSigningKey > | null,
  status: HNCollaborativeAuthorizationEndpointStatus,
};

export enum HNCollaborativeAuthorizationEndpointStatus {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  ACTIVATION_FAILED = "ACTIVATION_FAILED",
}


export enum HNUserRole {
  UNSPECIFIED = "UNSPECIFIED",
  ADMIN = "ADMIN",
  DEVELOPER = "DEVELOPER",
  SUPPORT = "SUPPORT",
  FINANCE = "FINANCE",
  USER = "USER",
}


export type HNGlobalNotePrimaryEntity = HNFinancialAccount


export type HNGlobalNoteAggregateEntity = HNUSPersonAccountHolder | HNUSBusinessAccountHolder


export type HNAccountReviewConnectionPayload = HNAccountReviewConnection | HNUserError | HNAccessDeniedError


export type HNAccountReviewConnection = {
  __typename: "HNAccountReviewConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAccountReviewEdge > | null,
};

export type HNAccountReviewEdge = {
  __typename: "HNAccountReviewEdge",
  cursor: string,
  node?: HNAccountReview | null,
};

export type HNAccountReview = {
  __typename: "HNAccountReview",
  id: string,
  financialAccountId: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  closedAt?: string | null,
};

export type HNCreditLimitChangeRequest = {
  __typename: "HNCreditLimitChangeRequest",
  id: string,
  financialAccountId: string,
  financialAccount?: HNFinancialAccount | null,
  status?: HNCreditLimitChangeRequestStatus | null,
  statusHistory?:  Array<HNCreditLimitChangeRequestStatusHistory > | null,
  requestedChange?: HNCreditLimitChangeRequestDetails | null,
  existingCreditLimit?: HNAmount | null,
  updatedCreditLimit?: HNAmount | null,
  customerDetails?: HNCreditLimitChangeRequestCustomerDetails | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  closedAt?: string | null,
};

export type HNCreditLimitChangeRequestStatusHistory = {
  __typename: "HNCreditLimitChangeRequestStatusHistory",
  previousStatus?: HNCreditLimitChangeRequestStatus | null,
  newStatus?: HNCreditLimitChangeRequestStatus | null,
  createdAt?: string | null,
};

export type HNCreditLimitChangeRequestDetails = {
  __typename: "HNCreditLimitChangeRequestDetails",
  requestedChangeType?: HNCreditLimitChangeRequestType | null,
  requestedCreditLimit?: HNAmount | null,
  requestor?: HNCreditLimitChangeRequestor | null,
};

export enum HNCreditLimitChangeRequestor {
  CUSTOMER = "CUSTOMER",
  SUBSCRIBER = "SUBSCRIBER",
}


export type HNCreditLimitChangeRequestCustomerDetails = {
  __typename: "HNCreditLimitChangeRequestCustomerDetails",
  currentDebtObligations?:  Array<HNAmount > | null,
  annualIncome?:  Array<HNAmount > | null,
  annualRevenue?:  Array<HNAmount > | null,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  externalFinancialAccountBalance?:  Array<HNAmount > | null,
};

export type HNDirectDepositDetail = {
  __typename: "HNDirectDepositDetail",
  id: string,
  restrictedDetails?: HNDirectDepositDetailRestrictedDetailsResult | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNDirectDepositDetailRestrictedDetailsResult = HNDirectDepositDetailRestrictedDetails | HNAccessDeniedError


export type HNDirectDepositDetailRestrictedDetails = {
  __typename: "HNDirectDepositDetailRestrictedDetails",
  number?: string | null,
  routingNumber?: string | null,
  bank?: HNBankDetails | null,
  type?: HNBankAccountType | null,
};

export type HNBankDetails = {
  __typename: "HNBankDetails",
  name?: HNBankName | null,
  address?: HNAddress | null,
};

export enum HNBankName {
  SUTTON_BANK = "SUTTON_BANK",
}


export type HNBillingCycleConfiguration = {
  __typename: "HNBillingCycleConfiguration",
  id: string,
  paymentDueDayOfMonth?: number | null,
  billingCycleStartDayOfMonth?: number | null,
  billingCycleEndDayOfMonth?: number | null,
  from?: string | null,
  through?: string | null,
};

export type HNFinancialAccountStatementSnapshot = {
  __typename: "HNFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot = {
  __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNCreditPayInFullCardFinancialAccountStatementSnapshot = {
  __typename: "HNCreditPayInFullCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNConsumerChargeCardFinancialAccountStatementSnapshot = {
  __typename: "HNConsumerChargeCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNConsumerRevolvingCardFinancialAccountStatementSnapshot = {
  __typename: "HNConsumerRevolvingCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNCommercialChargeCardFinancialAccountStatementSnapshot = {
  __typename: "HNCommercialChargeCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNCommercialRevolvingCardFinancialAccountStatementSnapshot = {
  __typename: "HNCommercialRevolvingCardFinancialAccountStatementSnapshot",
  asOf?: string | null,
  currentOpenStatement?: HNFinancialAccountStatement | null,
  latestClosedStatement?: HNFinancialAccountStatement | null,
  currentAmountDue?: HNAmount | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountStatementConnection = {
  __typename: "HNFinancialAccountStatementConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFinancialAccountStatementEdge > | null,
};

export type HNFinancialAccountStatementEdge = {
  __typename: "HNFinancialAccountStatementEdge",
  cursor: string,
  node?: HNFinancialAccountStatement | null,
};

export type HNFinancialAccountActivityConnection = {
  __typename: "HNFinancialAccountActivityConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFinancialAccountActivityEdge > | null,
};

export type HNFinancialAccountActivityEdge = {
  __typename: "HNFinancialAccountActivityEdge",
  cursor: string,
  node?: HNFinancialAccountActivity | null,
};

export type HNFinancialAccountActivity = {
  __typename: "HNFinancialAccountActivity",
  sign?: HNFinancialAccountActivitySign | null,
  isComplete?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  pendingAmount?: HNAmount | null,
  postedAmount?: HNAmount | null,
  source?: HNFinancialAccountActivitySource | null,
};

export enum HNFinancialAccountActivitySign {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
}


export type HNFinancialAccountActivitySource = HNDebitTransaction | HNCreditTransaction | HNPayrollTransfer | HNCreditFunds | HNDebitFunds | HNSecureDeposit | HNSecureDepositACHTransfer | HNSecureCardBalanceRepaymentACHTransfer | HNIntegratorInitiatedFundsWithdrawalACHTransfer | HNIntegratorInitiatedFundsDepositACHTransfer | HNFeeTransferEvent | HNInterFinancialAccountTransfer


export type HNScheduledTransferConnection = {
  __typename: "HNScheduledTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNScheduledTransferEdge > | null,
};

export type HNScheduledTransferEdge = {
  __typename: "HNScheduledTransferEdge",
  cursor: string,
  node?: HNScheduledTransfer | null,
};

export type HNScheduledTransfer = {
  __typename: "HNScheduledTransfer",
  id: string,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
};

export type HNOneTimeACHTransfer = {
  __typename: "HNOneTimeACHTransfer",
  id: string,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  descriptor?: HNACHDescriptor | null,
  transferAmount?: HNTransferAmountStrategy | null,
  status?: HNScheduledTransferStatusCode | null,
  scheduledTransferDate?: string | null,
  transferEvents?: HNScheduledTransferEventConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNTransferAmountStrategy = HNTransferAmountCalculation | HNManualTransferAmount


export type HNTransferAmountCalculation = {
  __typename: "HNTransferAmountCalculation",
  calculatedType?: HNCalculatedTransferAmountType | null,
};

export enum HNCalculatedTransferAmountType {
  OUTSTANDING_BALANCE = "OUTSTANDING_BALANCE",
  OUTSTANDING_STATEMENT_BALANCE = "OUTSTANDING_STATEMENT_BALANCE",
  MINIMUM_PAYMENT = "MINIMUM_PAYMENT",
}


export type HNManualTransferAmount = {
  __typename: "HNManualTransferAmount",
  amount?: HNAmount | null,
};

export enum HNScheduledTransferStatusCode {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
}


export type HNScheduledTransferEventConnection = {
  __typename: "HNScheduledTransferEventConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNScheduledTransferEventEdge > | null,
};

export type HNScheduledTransferEventEdge = {
  __typename: "HNScheduledTransferEventEdge",
  cursor: string,
  node?: HNScheduledTransferEvent | null,
};

export type HNScheduledTransferEvent = {
  __typename: "HNScheduledTransferEvent",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNScheduledTransferAchEvent = {
  __typename: "HNScheduledTransferAchEvent",
  id: string,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  transferAmount?: HNAmount | null,
  transfers?:  Array<HNElectronicFundsTransfer | null > | null,
  status?: HNScheduledTransferEventStatusCode | null,
  paymentInitiatedAt?: string | null,
  paymentPostedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNScheduledTransferEventStatusCode {
  INITIATED = "INITIATED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  REJECTED = "REJECTED",
  NOT_EXECUTED = "NOT_EXECUTED",
}


export type HNRecurringACHTransfer = {
  __typename: "HNRecurringACHTransfer",
  id: string,
  fromFinancialAccount?: HNAllFinancialAccount | null,
  toFinancialAccount?: HNAllFinancialAccount | null,
  descriptor?: HNACHDescriptor | null,
  transferAmount?: HNTransferAmountStrategy | null,
  frequency?: HNRecurringAchTransferFrequencyCode | null,
  balanceAmountType?: HNTransferBalanceAmountCode | null,
  status?: HNScheduledTransferStatusCode | null,
  nextScheduledTransferDate?: string | null,
  transferEvents?: HNScheduledTransferEventConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNRecurringAchTransferFrequencyCode {
  MONTHLY = "MONTHLY",
}


export enum HNTransferBalanceAmountCode {
  OUTSTANDING_BALANCE = "OUTSTANDING_BALANCE",
  OUTSTANDING_STATEMENT_BALANCE = "OUTSTANDING_STATEMENT_BALANCE",
  MINIMUM_PAYMENT = "MINIMUM_PAYMENT",
}


export type HNInterFinancialAccountTransferConnection = {
  __typename: "HNInterFinancialAccountTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNInterFinancialAccountTransferEdge > | null,
};

export type HNInterFinancialAccountTransferEdge = {
  __typename: "HNInterFinancialAccountTransferEdge",
  cursor: string,
  node?: HNInterFinancialAccountTransfer | null,
};

export enum HNAccountClosureBlocker {
  ACCOUNT_BALANCE_PAYABLE = "ACCOUNT_BALANCE_PAYABLE",
  ACCOUNT_BALANCE_RECEIVABLE = "ACCOUNT_BALANCE_RECEIVABLE",
  SCHEDULED_TRANSFER = "SCHEDULED_TRANSFER",
  PENDING_TRANSFER = "PENDING_TRANSFER",
  PENDING_AUTHORIZATION = "PENDING_AUTHORIZATION",
  ACTIVE_PAYMENT_CARD = "ACTIVE_PAYMENT_CARD",
  NO_EXTERNAL_FINANCIAL_ACCOUNT = "NO_EXTERNAL_FINANCIAL_ACCOUNT",
  RISK_HOLD = "RISK_HOLD",
  OPEN_LINE_OF_CREDIT = "OPEN_LINE_OF_CREDIT",
  PAYROLL_ADVANCE_PAYABLE = "PAYROLL_ADVANCE_PAYABLE",
}


export enum HNFinancialAccountAttribute {
  PENDING_CLOSURE = "PENDING_CLOSURE",
  DELINQUENT = "DELINQUENT",
  DELINQUENT_SUSPENDED = "DELINQUENT_SUSPENDED",
  CHARGE_OFF = "CHARGE_OFF",
  ACH_RISK_HOLD = "ACH_RISK_HOLD",
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  OFAC_WARNING = "OFAC_WARNING",
  ACCOUNT_TAKEOVER = "ACCOUNT_TAKEOVER",
  IDENTITY_THEFT = "IDENTITY_THEFT",
  PROGRAM_OWNER_INITIATED_SUSPENSION = "PROGRAM_OWNER_INITIATED_SUSPENSION",
  CLOSED_WITH_BALANCE = "CLOSED_WITH_BALANCE",
}


export type HNFinancialAccountAttributeWithReason = {
  __typename: "HNFinancialAccountAttributeWithReason",
  attribute: HNFinancialAccountAttribute,
  reason?: HNFinancialAccountAttributeReason | null,
};

export enum HNFinancialAccountAttributeReason {
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD",
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW",
}


export type HNPaymentCardConnection = {
  __typename: "HNPaymentCardConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPaymentCardEdge > | null,
};

export type HNPaymentCardEdge = {
  __typename: "HNPaymentCardEdge",
  cursor: string,
  node?: HNPaymentCard | null,
};

export type HNVelocityRuleBalance = {
  __typename: "HNVelocityRuleBalance",
  currentBalance?: HNAmount | null,
  remainingBalance?: HNAmount | null,
  velocityRule?: HNVelocityRule | null,
};

export type HNVelocitySpendRuleBalance = HNVelocitySpendRuleAmountBalance | HNVelocitySpendRuleCountBalance


export type HNVelocitySpendRuleAmountBalance = {
  __typename: "HNVelocitySpendRuleAmountBalance",
  currentBalance?: HNAmount | null,
  remainingBalance?: HNAmount | null,
  computedCurrentBalance?: HNAmount | null,
  computedRemainingBalance?: HNAmount | null,
  asOfDate?: string | null,
  velocityRule?: HNVelocityRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export type HNVelocitySpendRuleCountBalance = {
  __typename: "HNVelocitySpendRuleCountBalance",
  currentCountBalance?: number | null,
  remainingCountBalance?: number | null,
  computedCurrentCountBalance?: number | null,
  computedRemainingCountBalance?: number | null,
  asOfDate?: string | null,
  velocityRule?: HNVelocityRule | null,
  attachedLevel?: HNAttachedLevel | null,
};

export enum HNPartnerBankName {
  SUTTON = "SUTTON",
  HIGHNOTE = "HIGHNOTE",
  BANCORP = "BANCORP",
  CFSB = "CFSB",
  CELTIC = "CELTIC",
  CROSS_RIVER = "CROSS_RIVER",
  BNY = "BNY",
}


export type HNFinancialAccountDelinquency = {
  __typename: "HNFinancialAccountDelinquency",
  delinquencyStartedOn?: string | null,
  totalDaysDelinquent?: number | null,
  totalAmount?: HNAmount | null,
  numberOfCycles?: number | null,
  currentDelinquentCycles?:  Array<HNFinancialAccountDelinquencyCycle | null > | null,
};

export type HNCreditPayInFullFinancialAccountDelinquency = {
  __typename: "HNCreditPayInFullFinancialAccountDelinquency",
  delinquencyStartedOn?: string | null,
  totalDaysDelinquent?: number | null,
  totalAmount?: HNAmount | null,
  numberOfCycles?: number | null,
  currentDelinquentCycles?:  Array<HNCreditPayInFullFinancialAccountDelinquencyCycle | null > | null,
};

export type HNCreditPayInFullFinancialAccountDelinquencyCycle = {
  __typename: "HNCreditPayInFullFinancialAccountDelinquencyCycle",
  statementId: string,
  statement?: HNFinancialAccountStatement | null,
  daysDelinquent?: number | null,
  amount?: HNAmount | null,
  totalRepaymentsApplied?: HNAmount | null,
  repayments?:  Array<HNCreditRepaymentStatementApplication > | null,
  state?: HNFinancialAccountDelinquencyState | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountDelinquencyCycle = {
  __typename: "HNFinancialAccountDelinquencyCycle",
  statementId: string,
  statement?: HNFinancialAccountStatement | null,
  daysDelinquent?: number | null,
  amount?: HNAmount | null,
  totalRepaymentsApplied?: HNAmount | null,
  repayments?:  Array<HNCreditRepaymentStatementApplication > | null,
  state?: HNFinancialAccountDelinquencyState | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export enum HNFinancialAccountDelinquencyState {
  CURRENT = "CURRENT",
  DELINQUENT = "DELINQUENT",
  CLOSING = "CLOSING",
}


export type HNCurrentFinancialAccountDelinquencyState = {
  __typename: "HNCurrentFinancialAccountDelinquencyState",
  state?: HNFinancialAccountDelinquencyState | null,
  updatedAt?: string | null,
};

export type HNBillingCycleConnection = {
  __typename: "HNBillingCycleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNBillingCycleEdge > | null,
};

export type HNBillingCycleEdge = {
  __typename: "HNBillingCycleEdge",
  cursor: string,
  node?: HNBillingCycle | null,
};

export type HNBillingCycle = {
  __typename: "HNBillingCycle",
  currentCycleState?: HNCurrentFinancialAccountDelinquencyState | null,
  statement?: HNFinancialAccountStatement | null,
  totalDaysDelinquent?: number | null,
  amountDelinquent?: HNAmount | null,
  stateTransitionHistory?:  Array<HNDelinquencyStateTransition | null > | null,
  repayments?:  Array<HNCreditRepaymentStatementApplication > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNDelinquencyStateTransition = {
  __typename: "HNDelinquencyStateTransition",
  newState?: HNFinancialAccountDelinquencyState | null,
  createdAt?: string | null,
};

export type HNCreditFinancialAccountConfiguration = {
  __typename: "HNCreditFinancialAccountConfiguration",
  servicemembersCivilReliefAct?: HNServicemembersCivilReliefActConfiguration | null,
  militaryLendingAct?: HNMilitaryLendingActConfiguration | null,
  interestRates?:  Array<HNCreditPlanFinancialAccountConfiguration > | null,
};

export type HNServicemembersCivilReliefActConfiguration = {
  __typename: "HNServicemembersCivilReliefActConfiguration",
  status?: HNServicemembersCivilReliefActStatus | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
  activeDutyFrom?: string | null,
  activeDutyThrough?: string | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export enum HNServicemembersCivilReliefActStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}


export type HNMilitaryLendingActConfiguration = {
  __typename: "HNMilitaryLendingActConfiguration",
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type HNCreditPlanFinancialAccountConfiguration = {
  __typename: "HNCreditPlanFinancialAccountConfiguration",
  balanceType?: HNCreditBalanceType | null,
  interest?: HNInterestDetails | null,
  creditPlan?: HNCreditPlan | null,
};

export type HNFeeTransferEventConnection = {
  __typename: "HNFeeTransferEventConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFeeTransferEventEdge > | null,
};

export type HNFeeTransferEventEdge = {
  __typename: "HNFeeTransferEventEdge",
  cursor: string,
  node?: HNFeeTransferEvent | null,
};

export type HNPaymentCardTransactionDisputeConnectionPayload = HNPaymentCardTransactionDisputeConnection | HNUserError | HNAccessDeniedError


export type HNCustomField = {
  __typename: "HNCustomField",
  key: string,
};

export type HNCustomStringField = {
  __typename: "HNCustomStringField",
  key: string,
  value: string,
};

export type HNFinancialAccountSnapshotConnection = {
  __typename: "HNFinancialAccountSnapshotConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFinancialAccountSnapshotEdge > | null,
};

export type HNFinancialAccountSnapshotEdge = {
  __typename: "HNFinancialAccountSnapshotEdge",
  cursor: string,
  node?: HNFinancialAccountSnapshot | null,
};

export type HNFinancialAccountSnapshot = {
  __typename: "HNFinancialAccountSnapshot",
  id: string,
  financialAccount?: HNFinancialAccount | null,
  financialAccountAttributes?: Array< HNFinancialAccountAttribute > | null,
  accountStatus?: string | null,
  cardProduct?: HNCardProduct | null,
  externalId?: string | null,
  name?: string | null,
  application?: HNAccountHolderCardProductApplication | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type HNRewardPointsTransferConnectionPayload = HNRewardPointsTransferConnection | HNUserError | HNAccessDeniedError


export type HNRewardPointsTransferConnection = {
  __typename: "HNRewardPointsTransferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNRewardPointsTransferEdge > | null,
};

export type HNRewardPointsTransferEdge = {
  __typename: "HNRewardPointsTransferEdge",
  cursor?: string | null,
  node?: HNRewardPointsTransfer | null,
};

export type HNVelocityInterFinancialAccountTransferRuleBalanceConnectionPayload = HNVelocityInterFinancialAccountTransferRuleBalanceConnection


export type HNVelocityInterFinancialAccountTransferRuleBalanceConnection = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleBalanceConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNVelocityInterFinancialAccountTransferRuleBalanceEdge > | null,
};

export type HNVelocityInterFinancialAccountTransferRuleBalanceEdge = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleBalanceEdge",
  cursor: string,
  node?: HNVelocityInterFinancialAccountTransferRuleBalance | null,
};

export type HNVelocityInterFinancialAccountTransferRuleBalance = HNVelocityInterFinancialAccountTransferRuleAmountBalance | HNVelocityInterFinancialAccountTransferRuleCountBalance


export type HNVelocityInterFinancialAccountTransferRuleAmountBalance = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleAmountBalance",
  currentBalance?: HNAmount | null,
  remainingBalance?: HNAmount | null,
  computedCurrentBalance?: HNAmount | null,
  computedRemainingBalance?: HNAmount | null,
  asOfDate?: string | null,
  velocityInterFinancialAccountTransferRule?: HNVelocityInterFinancialAccountTransferRule | null,
};

export type HNVelocityInterFinancialAccountTransferRuleCountBalance = {
  __typename: "HNVelocityInterFinancialAccountTransferRuleCountBalance",
  currentCount?: number | null,
  remainingCount?: number | null,
  computedCurrentCount?: number | null,
  computedRemainingCount?: number | null,
  asOfDate?: string | null,
  velocityInterFinancialAccountTransferRule?: HNVelocityInterFinancialAccountTransferRule | null,
};

export type HNAuthorizedUserCardProductApplicationSnapshotConnection = {
  __typename: "HNAuthorizedUserCardProductApplicationSnapshotConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAuthorizedUserCardProductApplicationSnapshotEdge | null > | null,
};

export type HNAuthorizedUserCardProductApplicationSnapshotEdge = {
  __typename: "HNAuthorizedUserCardProductApplicationSnapshotEdge",
  cursor: string,
  node?: HNAuthorizedUserCardProductApplicationSnapshot | null,
};

export type HNAuthorizedUserCardProductApplicationSnapshot = {
  __typename: "HNAuthorizedUserCardProductApplicationSnapshot",
  applicationState: HNAuthorizedUserApplicationState,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  authorizedUserSnapshot?: HNAuthorizedUserSnapshot | null,
  accountHolderCardProductApplication?: HNAccountHolderCardProductApplication | null,
  financialAccount?: HNFinancialAccount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAccountHolderConnection = {
  __typename: "HNAccountHolderConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAccountHolderEdge > | null,
};

export type HNAccountHolderEdge = {
  __typename: "HNAccountHolderEdge",
  cursor: string,
  node?: HNAccountHolder | null,
};

export type HNAccountHolder = HNUSBusinessAccountHolder | HNUSPersonAccountHolder


export type HNAccountHolderCardProductApplicationConnection = {
  __typename: "HNAccountHolderCardProductApplicationConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAccountHolderCardProductApplicationEdge > | null,
};

export type HNAccountHolderCardProductApplicationEdge = {
  __typename: "HNAccountHolderCardProductApplicationEdge",
  cursor: string,
  node?: HNAccountHolderCardProductApplication | null,
};

export type HNExternalFinancialAccountConnection = {
  __typename: "HNExternalFinancialAccountConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNExternalFinancialAccountEdge > | null,
};

export type HNExternalFinancialAccountEdge = {
  __typename: "HNExternalFinancialAccountEdge",
  cursor: string,
  node?: HNExternalFinancialAccount | null,
};

export type HNAccountHolderCardProductApplicationSnapshotConnection = {
  __typename: "HNAccountHolderCardProductApplicationSnapshotConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAccountHolderCardProductApplicationSnapshotEdge | null > | null,
};

export type HNAccountHolderCardProductApplicationSnapshotEdge = {
  __typename: "HNAccountHolderCardProductApplicationSnapshotEdge",
  cursor: string,
  node?: HNAccountHolderCardProductApplicationSnapshot | null,
};

export type HNAccountHolderCardProductApplicationSnapshot = {
  __typename: "HNAccountHolderCardProductApplicationSnapshot",
  applicationState: HNAccountHolderApplicationState,
  adverseActionReasons?:  Array<HNAdverseActionReason > | null,
  accountHolderSnapshot?: HNAccountHolderSnapshot | null,
  cardProduct?: HNCardProduct | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNAccountHolderCardProductApplicationOfferConnection = {
  __typename: "HNAccountHolderCardProductApplicationOfferConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNAccountHolderCardProductApplicationOfferEdge > | null,
};

export type HNAccountHolderCardProductApplicationOfferEdge = {
  __typename: "HNAccountHolderCardProductApplicationOfferEdge",
  cursor?: string | null,
  node?: HNAccountHolderCardProductApplicationOffer | null,
};

export type HNAccountHolderCardProductApplicationOffer = {
  __typename: "HNAccountHolderCardProductApplicationOffer",
  id: string,
  name?: string | null,
  status?: HNCardProductApplicationOfferStatus | null,
  category?: HNCardProductApplicationOfferCategory | null,
};

export enum HNCardProductApplicationOfferStatus {
  ACCEPTED = "ACCEPTED",
  OPEN = "OPEN",
  REJECTED = "REJECTED",
  DISQUALIFIED = "DISQUALIFIED",
  EXTENDED = "EXTENDED",
  EXPIRED = "EXPIRED",
}


export enum HNCardProductApplicationOfferCategory {
  SECURED_CREDIT = "SECURED_CREDIT",
  UNSECURED_CREDIT = "UNSECURED_CREDIT",
}


export type HNCreditReportFraudAlertVerificationResult = {
  __typename: "HNCreditReportFraudAlertVerificationResult",
  accountHolderInitiatedApplication: boolean,
  name: boolean,
  dateOfBirth: boolean,
  address: boolean,
};

export type HNPaymentCardRestrictedDetailsResult = HNPaymentCardRestrictedDetails | HNAccessDeniedError


export type HNPaymentCardRestrictedDetails = {
  __typename: "HNPaymentCardRestrictedDetails",
  number?: string | null,
  cvv?: string | null,
};

export type HNAtmLocationsResult = HNATMLocations | HNAccessDeniedError | HNUserError


export type HNATMLocations = {
  __typename: "HNATMLocations",
  atmLocations?:  Array<HNATMLocation > | null,
};

export type HNATMLocation = {
  __typename: "HNATMLocation",
  name?: string | null,
  description?: string | null,
  logo?: HNATMLocationLogoDetails | null,
  features?: Array< HNATMLocationFeature > | null,
  address?: HNAddress | null,
  coordinates?: HNCoordinates | null,
  distance?: HNDistance | null,
};

export type HNATMLocationLogoDetails = {
  __typename: "HNATMLocationLogoDetails",
  brand?: HNATMLocationBrand | null,
};

export enum HNATMLocationBrand {
  MONEY_PASS = "MONEY_PASS",
}


export enum HNATMLocationFeature {
  OPEN_24_HOURS = "OPEN_24_HOURS",
  DEPOSIT_AVAILABLE = "DEPOSIT_AVAILABLE",
  ACCESSIBLE = "ACCESSIBLE",
}


export type HNCoordinates = {
  __typename: "HNCoordinates",
  latitude: string,
  longitude: string,
};

export type HNDistance = {
  __typename: "HNDistance",
  length: number,
  unit: HNDistanceUnit,
};

export enum HNDistanceUnit {
  MILE = "MILE",
  KILOMETER = "KILOMETER",
}


export type HNCardDigitalWalletTokenConnection = {
  __typename: "HNCardDigitalWalletTokenConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCardDigitalWalletTokenEdge > | null,
};

export type HNCardDigitalWalletTokenEdge = {
  __typename: "HNCardDigitalWalletTokenEdge",
  cursor: string,
  node?: HNCardDigitalWalletToken | null,
};

export type HNCardDigitalWalletToken = {
  __typename: "HNCardDigitalWalletToken",
  id: string,
  status?: HNCardDigitalWalletTokenState | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  requesterName?: string | null,
  cardDigitalWalletTokenStateTransitions?: HNCardDigitalWalletTokenStateTransitionConnection | null,
  paymentCard?: HNPaymentCard | null,
};

export enum HNCardDigitalWalletTokenState {
  REQUESTED = "REQUESTED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
}


export type HNCardDigitalWalletTokenStateTransitionConnection = {
  __typename: "HNCardDigitalWalletTokenStateTransitionConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCardDigitalWalletTokenStateTransitionEdge > | null,
};

export type HNCardDigitalWalletTokenStateTransitionEdge = {
  __typename: "HNCardDigitalWalletTokenStateTransitionEdge",
  cursor: string,
  node?: HNCardDigitalWalletTokenStateTransition | null,
};

export type HNCardDigitalWalletTokenStateTransition = {
  __typename: "HNCardDigitalWalletTokenStateTransition",
  state?: HNCardDigitalWalletTokenState | null,
  reason?: HNCardDigitalWalletTokenStateReason | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNCardDigitalWalletTokenStateReason {
  ACTIVATION_METHOD = "ACTIVATION_METHOD",
  CUSTOMER_SERVICE_AGENT = "CUSTOMER_SERVICE_AGENT",
  DEVICE_LOST = "DEVICE_LOST",
  DEVICE_STOLEN = "DEVICE_STOLEN",
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  DEVICE_FOUND = "DEVICE_FOUND",
  NON_FRAUDULENT_TRANSACTIONS = "NON_FRAUDULENT_TRANSACTIONS",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_HOLDER_DELETED = "ACCOUNT_HOLDER_DELETED",
  NETWORK_INITIATED = "NETWORK_INITIATED",
  OTHER = "OTHER",
}


export type HNPaymentCardHolderDetails = {
  __typename: "HNPaymentCardHolderDetails",
  billingAddressOnCard?: HNAddress | null,
  paymentCardHolder?: HNPaymentCardHolder | null,
  associatedPaymentCardAccountHolder?: HNAccountHolder | null,
};

export type HNPaymentCardHolder = HNUSBusinessAuthorizedPerson | HNUSPersonAccountHolder | HNUSPersonAuthorizedUser


export type HNPaymentCardSnapshotConnection = {
  __typename: "HNPaymentCardSnapshotConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNPaymentCardSnapshotEdge > | null,
};

export type HNPaymentCardSnapshotEdge = {
  __typename: "HNPaymentCardSnapshotEdge",
  cursor: string,
  node?: HNPaymentCardSnapshot | null,
};

export type HNCardProfileSet = {
  __typename: "HNCardProfileSet",
  id: string,
  status?: HNCardProfileSetStatus | null,
  name?: string | null,
  intent?: HNCardProfileSetIntent | null,
  network?: HNCardProfileSetNetwork | null,
  preferredConfiguration?: boolean | null,
  cardProduct?: HNCardProduct | null,
  physicalCardProfiles?:  Array<HNPhysicalCardProfile > | null,
  digitalCardProfiles?:  Array<HNDigitalCardProfile > | null,
  virtualCardProfiles?:  Array<HNVirtualCardProfile > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  description?: string | null,
};

export type HNCardProfileSetInterface = {
  __typename: "HNCardProfileSetInterface",
  id: string,
  status?: HNCardProfileSetStatus | null,
  name?: string | null,
  intent?: HNCardProfileSetIntent | null,
  network?: HNCardProfileSetNetwork | null,
  preferredConfiguration?: boolean | null,
  cardProduct?: HNCardProduct | null,
  physicalCardProfiles?:  Array<HNPhysicalCardProfile > | null,
  digitalCardProfiles?:  Array<HNDigitalCardProfile > | null,
  virtualCardProfiles?:  Array<HNVirtualCardProfile > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  description?: string | null,
};

export type HNCardProfileSetRestricted = {
  __typename: "HNCardProfileSetRestricted",
  id: string,
  status?: HNCardProfileSetStatus | null,
  name?: string | null,
  intent?: HNCardProfileSetIntent | null,
  network?: HNCardProfileSetNetwork | null,
  cardProductBinAssignmentId?: string | null,
  preferredConfiguration?: boolean | null,
  cardProduct: HNCardProduct,
  physicalCardProfiles?:  Array<HNPhysicalCardProfile > | null,
  digitalCardProfiles?:  Array<HNDigitalCardProfile > | null,
  virtualCardProfiles?:  Array<HNVirtualCardProfile > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  description?: string | null,
};

export enum HNCardProfileSetStatus {
  PENDING = "PENDING",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
  INACTIVE = "INACTIVE",
}


export enum HNCardProfileSetIntent {
  PHYSICAL = "PHYSICAL",
  DIGITAL = "DIGITAL",
  VIRTUAL = "VIRTUAL",
}


export enum HNCardProfileSetNetwork {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
}


export type HNPhysicalCardProfile = {
  __typename: "HNPhysicalCardProfile",
  id: string,
  status?: HNCardProfileStatus | null,
  paymentNetworkStatus?: HNCardProfilePaymentNetworkStatus | null,
  vendorStatus?: HNCardProfileVendorStatus | null,
  bankStatus?: HNCardProfileBankStatus | null,
  vendorName?: HNPhysicalCardVendorName | null,
  vendorProgramExternalIdentifier?: string | null,
  carrier?: string | null,
  packaging?: string | null,
  fleetOptionConfigurationId?: string | null,
  fleetOptionConfigurationVersion?: number | null,
  externalContactlessProfileIdentifier?: string | null,
  chipProfileIdentifier?: string | null,
  physicalCardMaterial?: HNPhysicalCardMaterial | null,
  cardHolderAgreementId?: string | null,
  cardProduct?: HNCardProduct | null,
  cardPersonalization?: HNPhysicalCardPersonalization | null,
  defaultPaymentCardShipment?: HNCardProfileShipment | null,
  cardArt?:  Array<HNCardArtDocument > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  name?: string | null,
  description?: string | null,
  cardProfileSetRelationships?:  Array<HNCardProfileSetRelationship > | null,
};

export type HNCardProfile = {
  __typename: "HNCardProfile",
  id: string,
  status?: HNCardProfileStatus | null,
  cardHolderAgreementId?: string | null,
  cardProduct?: HNCardProduct | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  name?: string | null,
  description?: string | null,
  cardProfileSetRelationships?:  Array<HNCardProfileSetRelationship > | null,
};

export type HNVirtualCardProfile = {
  __typename: "HNVirtualCardProfile",
  id: string,
  status?: HNCardProfileStatus | null,
  paymentNetworkStatus?: HNCardProfilePaymentNetworkStatus | null,
  bankStatus?: HNCardProfileBankStatus | null,
  cardHolderAgreementId?: string | null,
  cardProduct?: HNCardProduct | null,
  personalization?: HNVirtualCardPersonalizationType | null,
  serviceCode?: HNServiceCode | null,
  cardArt?:  Array<HNCardArtDocument > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  name?: string | null,
  description?: string | null,
  cardProfileSetRelationships?:  Array<HNCardProfileSetRelationship > | null,
  browserText?: HNVirtualCardBrowserText | null,
  appText?: HNVirtualCardAppText | null,
};

export enum HNCardProfileStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  IN_REVIEW = "IN_REVIEW",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  INACTIVE = "INACTIVE",
}


export enum HNCardProfilePaymentNetworkStatus {
  PENDING = "PENDING",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
}


export enum HNCardProfileBankStatus {
  PENDING = "PENDING",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
}


export enum HNVirtualCardPersonalizationType {
  BUSINESS_NAME = "BUSINESS_NAME",
  PERSON_NAME = "PERSON_NAME",
  BUSINESS_AUTHORIZED_PERSON_NAME = "BUSINESS_AUTHORIZED_PERSON_NAME",
}


export enum HNServiceCode {
  INTERNATIONAL_NORMAL_NO_RESTRICTION = "INTERNATIONAL_NORMAL_NO_RESTRICTION",
  INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION = "INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION",
  NATIONAL_NORMAL_NO_RESTRICTION = "NATIONAL_NORMAL_NO_RESTRICTION",
}


export type HNCardProfileSetRelationship = {
  __typename: "HNCardProfileSetRelationship",
  id: string,
  cardProfileSet?: HNCardProfileSet | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNVirtualCardBrowserText = {
  __typename: "HNVirtualCardBrowserText",
  browserHelpText: string,
  browserTerms: string,
};

export type HNVirtualCardAppText = {
  __typename: "HNVirtualCardAppText",
  appHelpText: string,
  appInfo: string,
};

export type HNDigitalCardProfile = {
  __typename: "HNDigitalCardProfile",
  id: string,
  status?: HNCardProfileStatus | null,
  paymentNetworkStatus?: HNCardProfilePaymentNetworkStatus | null,
  bankStatus?: HNCardProfileBankStatus | null,
  cardHolderAgreementId?: string | null,
  cardProduct?: HNCardProduct | null,
  colors?: HNDigitalArtColors | null,
  cardArt?:  Array<HNDigitalCardArtDocument > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  externalProfileId?: string | null,
  name?: string | null,
  description?: string | null,
  cardProfileSetRelationships?:  Array<HNCardProfileSetRelationship > | null,
};

export type HNDigitalArtColors = {
  __typename: "HNDigitalArtColors",
  panColor: string,
  panColorRgb: string,
  backgroundColor: string,
  backgroundColorRgb: string,
  cardDescriptorColor: string,
  cardDescriptorColorRgb: string,
};

export type HNDigitalCardArtDocument = {
  __typename: "HNDigitalCardArtDocument",
  cardArt: HNCardArtDocument,
  digitalWalletProviders?: Array< HNDigitalWalletProvider > | null,
};

export enum HNDigitalWalletProvider {
  APPLE_PAY = "APPLE_PAY",
  GOOGLE_PAY = "GOOGLE_PAY",
  SAMSUNG_PAY = "SAMSUNG_PAY",
}


export enum HNCardProfileVendorStatus {
  PENDING = "PENDING",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
}


export enum HNPhysicalCardVendorName {
  TAG = "TAG",
  ARROW_EYE = "ARROW_EYE",
}


export enum HNPhysicalCardMaterial {
  PLASTIC = "PLASTIC",
  METAL = "METAL",
}


export type HNPhysicalCardPersonalization = {
  __typename: "HNPhysicalCardPersonalization",
  format: HNPhysicalCardPersonalizationFormat,
  line1: HNPhysicalCardPersonalizationLine,
  line2: HNPhysicalCardPersonalizationLine,
  physicalCardType?: HNPhysicalCardType | null,
};

export enum HNPhysicalCardPersonalizationFormat {
  EMBOSSED = "EMBOSSED",
  PRINTED = "PRINTED",
}


export type HNPhysicalCardPersonalizationLine = {
  __typename: "HNPhysicalCardPersonalizationLine",
  type?: HNPhysicalCardPersonalizationLineType | null,
  line?: string | null,
};

export enum HNPhysicalCardPersonalizationLineType {
  BUSINESS_NAME = "BUSINESS_NAME",
  ACCOUNT_HOLDER_NAME = "ACCOUNT_HOLDER_NAME",
  CUSTOM = "CUSTOM",
}


export enum HNPhysicalCardType {
  MAGNETIC_STRIPE_ONLY = "MAGNETIC_STRIPE_ONLY",
  EMV_CHIP_CONTACT_ONLY = "EMV_CHIP_CONTACT_ONLY",
  CONTACTLESS_ONLY = "CONTACTLESS_ONLY",
  EMV_CHIP_CONTACTLESS = "EMV_CHIP_CONTACTLESS",
}


export type HNCardProfileShipment = {
  __typename: "HNCardProfileShipment",
  courier?: HNCardProfileShipmentCourier | null,
  senderDetails?: HNPaymentCardSenderDetails | null,
};

export type HNCardProfileShipmentCourier = {
  __typename: "HNCardProfileShipmentCourier",
  method?: HNPaymentCardShippingMethod | null,
  signatureRequiredOnDelivery?: boolean | null,
};

export type HNPaymentCardSenderDetails = {
  __typename: "HNPaymentCardSenderDetails",
  address?: HNAddress | null,
  companyName?: string | null,
  name?: HNName | null,
};

export type HNPaymentCardPinDetails = {
  __typename: "HNPaymentCardPinDetails",
  isSet?: boolean | null,
  pinUpdateHistory?:  Array<HNPaymentCardPinUpdate > | null,
};

export type HNPaymentCardPinUpdate = {
  __typename: "HNPaymentCardPinUpdate",
  updatedAt?: string | null,
};

export enum HNPaymentCardSuspensionFlag {
  PROGRAM_OWNER_INITIATED_SUSPENSION = "PROGRAM_OWNER_INITIATED_SUSPENSION",
  ISSUER_INITIATED_SUSPENSION = "ISSUER_INITIATED_SUSPENSION",
}


export type HNEnhancedDataEvent = {
  __typename: "HNEnhancedDataEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transaction?: HNTransaction | null,
  networkTransactionId?: string | null,
  networkResponseCode?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  additionalTransactionData?:  Array<HNAdditionalTransactionData > | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
};

export type HNVerificationEvent = {
  __typename: "HNVerificationEvent",
  id: string,
  responseCode?: HNTransactionEventResponseCode | null,
  transaction?: HNTransaction | null,
  networkResponseCode?: string | null,
  avsResponseCode?: HNAVSResponseCode | null,
  postalCodeResponseCode?: HNPostalCodeResponseCode | null,
  cvvResponseCode?: HNCVVResponseCode | null,
  networkTransactionId?: string | null,
  approvedAmount?: HNAmount | null,
  requestedAmount?: HNAmount | null,
  originalAmount?: HNAmount | null,
  createdAt?: string | null,
  paymentCard?: HNPaymentCard | null,
  cardProduct?: HNCardProduct | null,
  merchantDetails?: HNMerchantDetails | null,
  spendRuleResults?: HNSpendRuleResultConnection | null,
  currentFinancialAccountAvailableToSpendAmount?: HNAmount | null,
  currentFinancialAccountMaximumBalanceAmount?: HNAmount | null,
  transactionProcessingType?: HNCardTransactionProcessingType | null,
  pointOfServiceDetails?: HNPointOfServiceDetails | null,
  additionalNetworkData?: HNAdditionalNetworkData | null,
  paymentCardSnapshot?: HNPaymentCardSnapshot | null,
};

export enum HNPaymentCardDisputeCustomerClaimType {
  WRITTEN = "WRITTEN",
  VERBAL = "VERBAL",
}


export type HNPaymentCardDisputeCustomerContact = {
  __typename: "HNPaymentCardDisputeCustomerContact",
  givenName?: string | null,
  familyName?: string | null,
  phone?: HNPhone | null,
  email?: string | null,
};

export type HNChargebackExternalNetwork = {
  __typename: "HNChargebackExternalNetwork",
  networkType?: HNChargebackExternalNetworkType | null,
  externalNetworkId: string,
};

export enum HNChargebackExternalNetworkType {
  NGOM = "NGOM",
}


export enum HNPaymentCardChargebackNetworkReasonCode {
  ACCOUNT_NUMBER_NOT_ON_FILE = "ACCOUNT_NUMBER_NOT_ON_FILE",
  AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM = "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM",
  CANCELLED_RECURRING_TRANSACTION = "CANCELLED_RECURRING_TRANSACTION",
  CARDHOLDER_DISPUTE = "CARDHOLDER_DISPUTE",
  CARDHOLDER_DISPUTE_US_ONLY = "CARDHOLDER_DISPUTE_US_ONLY",
  CHIP_LIABILITY_SHIFT = "CHIP_LIABILITY_SHIFT",
  CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN = "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN",
  CHIP_READ_POS_LATE_PRESENTMENT = "CHIP_READ_POS_LATE_PRESENTMENT",
  CREDIT_NOT_PROCESSED = "CREDIT_NOT_PROCESSED",
  DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE = "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE",
  INCORRECT_CURRENCY = "INCORRECT_CURRENCY",
  INCORRECT_TRANSACTION_CODE = "INCORRECT_TRANSACTION_CODE",
  INCORRECT_CURRENCY_OR_TRANSACTION_CODE = "INCORRECT_CURRENCY_OR_TRANSACTION_CODE",
  INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER = "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER",
  INSTALLMENT_BILLING_DISPUTE = "INSTALLMENT_BILLING_DISPUTE",
  LATE_PRESENTMENT = "LATE_PRESENTMENT",
  NO_AUTHORIZATION = "NO_AUTHORIZATION",
  NO_SHOW_ADDENDUM_OR_ATM_DISPUTE = "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE",
  NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM = "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
  NOT_AUTHORIZED_CARD_PRESENT = "NOT_AUTHORIZED_CARD_PRESENT",
  NOT_AUTHORIZED_CARD_ABSENT = "NOT_AUTHORIZED_CARD_ABSENT",
  NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE = "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
  POINT_OF_INTERACTION_ERRORS = "POINT_OF_INTERACTION_ERRORS",
  QUESTIONABLE_MERCHANT_ACTIVITY = "QUESTIONABLE_MERCHANT_ACTIVITY",
  SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED = "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
  WARNING_BULLETIN_FILE = "WARNING_BULLETIN_FILE",
}


export enum HNCardProductVertical {
  AP_INVOICE_AUTOMATION = "AP_INVOICE_AUTOMATION",
  COMMERCIAL_PREPAID = "COMMERCIAL_PREPAID",
  EARNED_WAGE_ACCESS = "EARNED_WAGE_ACCESS",
  FLEET = "FLEET",
  GENERAL_PURPOSE_RELOADABLE = "GENERAL_PURPOSE_RELOADABLE",
  SECURED_COMMERCIAL_CREDIT = "SECURED_COMMERCIAL_CREDIT",
  COMMERCIAL_DEBIT = "COMMERCIAL_DEBIT",
  CONSUMER_PREPAID = "CONSUMER_PREPAID",
  COMMERCIAL_CREDIT_PAY_IN_FULL = "COMMERCIAL_CREDIT_PAY_IN_FULL",
  PAYROLL = "PAYROLL",
  COMMERCIAL_CREDIT = "COMMERCIAL_CREDIT",
  CONSUMER_CREDIT = "CONSUMER_CREDIT",
  ACQUIRING = "ACQUIRING",
}


export type HNSearchCardProductApplicationConnection = {
  __typename: "HNSearchCardProductApplicationConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNSearchCardProductApplicationEdge > | null,
};

export type HNSearchCardProductApplicationEdge = HNAccountHolderCardProductApplicationEdge | HNAuthorizedUserCardProductApplicationEdge


export type HNCardProductFeature = {
  __typename: "HNCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCollaborativeAuthorizationCardProductFeature = {
  __typename: "HNCollaborativeAuthorizationCardProductFeature",
  enabled?: boolean | null,
  issuerStandInEnabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNCollaborativeApplicationUnderwritingCardProductFeature = {
  __typename: "HNCollaborativeApplicationUnderwritingCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNDisputeChargebackCardProductFeature = {
  __typename: "HNDisputeChargebackCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  chargebackMinimumThreshold?: HNAmount | null,
  chargebackProvisionalCreditEnabled?: boolean | null,
  disputeMaximumDaySinceTransaction?: number | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNOnDemandFundingCardProductFeature = {
  __typename: "HNOnDemandFundingCardProductFeature",
  enabled?: boolean | null,
  pseudoBalanceEnabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPartialFundingCardProductFeature = {
  __typename: "HNPartialFundingCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  receivablesPurchaseAgreementEnabled?: boolean | null,
  creditProcessorOnlyEnabled?: boolean | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNEarlyDirectDepositCardProductFeature = {
  __typename: "HNEarlyDirectDepositCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNAuthorizedUserCardProductFeature = {
  __typename: "HNAuthorizedUserCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNRevolvingCardProductFeature = {
  __typename: "HNRevolvingCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNChargeCardProductFeature = {
  __typename: "HNChargeCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNPointRewardCardProductFeature = {
  __typename: "HNPointRewardCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNSecuredDepositCardProductFeature = {
  __typename: "HNSecuredDepositCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNDirectMerchantAcquiringCardProductFeature = {
  __typename: "HNDirectMerchantAcquiringCardProductFeature",
  enabled?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
};

export type HNFeeScheduleConnection = {
  __typename: "HNFeeScheduleConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNFeeScheduleEdge > | null,
};

export type HNFeeScheduleEdge = {
  __typename: "HNFeeScheduleEdge",
  cursor: string,
  node?: HNFeeSchedule | null,
};

export type HNFeeSchedule = {
  __typename: "HNFeeSchedule",
  id: string,
  feeScheduleAssociatedTo?: HNFeeScheduleAssociatedTo | null,
  feeConfigurations?:  Array<HNFeeConfiguration > | null,
  activationDate?: string | null,
  status?: HNFeeScheduleStatus | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFeeScheduleAssociatedTo = HNCardProduct


export type HNFeeConfiguration = {
  __typename: "HNFeeConfiguration",
  id: string,
  feeActivityType?: HNFeeTransferEventFeeActivityType | null,
  feeChargeRules?:  Array<HNFeeChargeRule > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNFeeScheduleStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type HNCreditPlanTemplateConnection = {
  __typename: "HNCreditPlanTemplateConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCreditPlanTemplateEdge > | null,
};

export type HNCreditPlanTemplateEdge = {
  __typename: "HNCreditPlanTemplateEdge",
  cursor: string,
  node?: HNCreditPlanTemplate | null,
};

export type HNCreditPlanTemplate = {
  __typename: "HNCreditPlanTemplate",
  id: string,
  name?: string | null,
  status?: HNCreditPlanTemplateStatus | null,
  planType?: HNCreditPlanType | null,
  balanceType?: HNCreditBalanceType | null,
  riskBasedPricingPolicy?: HNRiskBasedPricingPolicy | null,
  interestPolicy?: HNCreditPlanTemplateInterestPolicy | null,
  maximumCreditLimit?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNCreditPlanTemplateStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEPRECATED = "DEPRECATED",
}


export type HNCreditPlanTemplateInterestPolicy = {
  __typename: "HNCreditPlanTemplateInterestPolicy",
  rateType?: HNInterestRateType | null,
  accrualType?: HNInterestAccrualType | null,
  accrualMethod?: HNInterestAccrualMethod | null,
  assessmentSchedule?: HNInterestAssessmentSchedule | null,
  aprRange?: HNInterestRateRange | null,
  variableAprIndex?: HNInterestRateIndex | null,
  scraApr?: number | null,
};

export type HNInterestRateRange = {
  __typename: "HNInterestRateRange",
  minimum?: number | null,
  maximum?: number | null,
};

export type HNCreditPlanConnection = {
  __typename: "HNCreditPlanConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCreditPlanEdge > | null,
};

export type HNCreditPlanEdge = {
  __typename: "HNCreditPlanEdge",
  cursor: string,
  node?: HNCreditPlan | null,
};

export type HNCardProfileSetConnectionPayload = HNCardProfileSetConnection | HNAccessDeniedError | HNUserError


export type HNCardProfileSetConnection = {
  __typename: "HNCardProfileSetConnection",
  pageInfo: HNPageInfo,
  edges?:  Array<HNCardProfileSetEdge > | null,
};

export type HNCardProfileSetEdge = {
  __typename: "HNCardProfileSetEdge",
  cursor: string,
  node?: HNCardProfileSet | null,
};

export type HNCreditCardProductConfiguration = {
  __typename: "HNCreditCardProductConfiguration",
  accountAging?: HNCreditAccountAgingCardProductConfiguration | null,
  minimumPayment?: HNCreditMinimumPaymentCardProductConfiguration | null,
  repayment?: HNCreditRepaymentCardProductConfiguration | null,
  interest?: HNCreditInterestApplicationCardProductConfiguration | null,
  billingCycleConfiguration?: HNCreditBillingCycleCardProductConfiguration | null,
};

export type HNCreditAccountAgingCardProductConfiguration = {
  __typename: "HNCreditAccountAgingCardProductConfiguration",
  delinquentInDays?: number | null,
  suspendedInDays?: number | null,
  chargeOffInDays?: number | null,
  lateFeeGracePeriodInDays?: number | null,
};

export type HNCreditMinimumPaymentCardProductConfiguration = {
  __typename: "HNCreditMinimumPaymentCardProductConfiguration",
  percentage?: number | null,
  thresholdAmount?: HNAmount | null,
  includesPastDueAmount?: boolean | null,
  includesInterestAmount?: boolean | null,
  includesFeesCharged?: boolean | null,
};

export type HNCreditRepaymentCardProductConfiguration = {
  __typename: "HNCreditRepaymentCardProductConfiguration",
  repaymentWaterfall?: Array< HNRepaymentCategory > | null,
};

export enum HNRepaymentCategory {
  PURCHASE = "PURCHASE",
  INTEREST = "INTEREST",
  FEES = "FEES",
}


export type HNCreditInterestApplicationCardProductConfiguration = {
  __typename: "HNCreditInterestApplicationCardProductConfiguration",
  includesPurchase?: boolean | null,
  includesFees?: boolean | null,
};

export type HNCreditBillingCycleCardProductConfiguration = {
  __typename: "HNCreditBillingCycleCardProductConfiguration",
  billingCyclePeriod?: HNCreditStatementCyclePeriod | null,
  billingCycleGracePeriodType?: HNCreditStatementGracePeriodType | null,
  billingCycleGracePeriodInDays?: number | null,
};

export enum HNCreditStatementCyclePeriod {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}


export enum HNCreditStatementGracePeriodType {
  FLOATING = "FLOATING",
  FIXED = "FIXED",
}


export enum HNCardArtDocumentType {
  PHYSICAL_FRONT_OF_CARD = "PHYSICAL_FRONT_OF_CARD",
  PHYSICAL_BACK_OF_CARD = "PHYSICAL_BACK_OF_CARD",
  DIGITAL_FRONT_OF_CARD = "DIGITAL_FRONT_OF_CARD",
  DIGITAL_BACKGROUND = "DIGITAL_BACKGROUND",
  DIGITAL_LOGO = "DIGITAL_LOGO",
  DIGITAL_ICON = "DIGITAL_ICON",
  VIRTUAL_FRONT_OF_CARD = "VIRTUAL_FRONT_OF_CARD",
  VIRTUAL_THREE_DS_VERIFICATION_LOGO = "VIRTUAL_THREE_DS_VERIFICATION_LOGO",
}


export type HNUploadRequirement = {
  __typename: "HNUploadRequirement",
  constraints?:  Array<HNUploadRequirementConstraint | null > | null,
};

export type HNUploadRequirementConstraint = HNDocumentUploadRequirementConstraint


export type HNDocumentUploadRequirementConstraint = {
  __typename: "HNDocumentUploadRequirementConstraint",
  documentType?: HNDocumentCategoryType | null,
  numberOfDocuments?: number | null,
};

export type HNDocumentUploadSessionContext = HNAccountHolderApplicationDocumentUploadSessionContext


export type HNAccountHolderApplicationDocumentUploadSessionContext = {
  __typename: "HNAccountHolderApplicationDocumentUploadSessionContext",
  documentVerificationResultCodeContext?: HNAccountHolderApplicationDocumentToVerificationResultCodeContext | null,
  verificationResultCodeDocumentContext?: HNAccountHolderApplicationVerificationResultCodeToDocumentContext | null,
};

export type HNAccountHolderApplicationDocumentToVerificationResultCodeContext = {
  __typename: "HNAccountHolderApplicationDocumentToVerificationResultCodeContext",
  entries?:  Array<HNAccountHolderApplicationDocumentToVerificationResultCodeEntry > | null,
};

export type HNAccountHolderApplicationDocumentToVerificationResultCodeEntry = {
  __typename: "HNAccountHolderApplicationDocumentToVerificationResultCodeEntry",
  document?: HNDocumentType | null,
  verificationResultCodes?: Array< HNAccountHolderVerificationResultCode > | null,
};

export type HNAccountHolderApplicationVerificationResultCodeToDocumentContext = {
  __typename: "HNAccountHolderApplicationVerificationResultCodeToDocumentContext",
  entries?:  Array<HNAccountHolderApplicationVerificationResultCodeToDocumentEntry > | null,
};

export type HNAccountHolderApplicationVerificationResultCodeToDocumentEntry = {
  __typename: "HNAccountHolderApplicationVerificationResultCodeToDocumentEntry",
  verificationResultCode?: HNAccountHolderVerificationResultCode | null,
  documents?: Array< HNDocumentType > | null,
};

export enum HNApplicationDocumentUploadSessionStatus {
  CREATED = "CREATED",
  EXPIRED = "EXPIRED",
  SUBMITTED = "SUBMITTED",
}


export type HNApplicationDocument = HNAccountHolderApplicationDocument


export type HNAccountHolderApplicationDocument = {
  __typename: "HNAccountHolderApplicationDocument",
  id: string,
  status?: HNApplicationDocumentUploadStatus | null,
  type?: HNDocumentType | null,
  revisions?:  Array<HNAccountHolderApplicationDocumentRevision | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fileReviewReasons?: Array< HNApplicationDocumentReviewReason > | null,
};

export enum HNApplicationDocumentUploadStatus {
  UPLOADED = "UPLOADED",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
}


export type HNAccountHolderApplicationDocumentRevision = {
  __typename: "HNAccountHolderApplicationDocumentRevision",
  status?: HNApplicationDocumentUploadStatus | null,
  type?: HNDocumentType | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  fileReviewReasons?: Array< HNApplicationDocumentReviewReason > | null,
};

export enum HNApplicationDocumentReviewReason {
  INCORRECT_DOCUMENT = "INCORRECT_DOCUMENT",
  EXPIRED_DOCUMENT = "EXPIRED_DOCUMENT",
  ILLEGIBLE_DOCUMENT = "ILLEGIBLE_DOCUMENT",
  PARTIAL_DOCUMENT = "PARTIAL_DOCUMENT",
  UNACCEPTABLE_DOCUMENT = "UNACCEPTABLE_DOCUMENT",
  DUPLICATE_DOCUMENT = "DUPLICATE_DOCUMENT",
  BLANK_DOCUMENT = "BLANK_DOCUMENT",
}


export type HNRequestedIdentityUpdate = {
  __typename: "HNRequestedIdentityUpdate",
  id: string,
  status?: HNRequestedIdentityUpdateStatus | null,
  referredBy?: HNRequestedIdentityUpdateSource | null,
  requestedFor?: HNRequestedIdentityUpdateParty | null,
  changesRequested?: Array< HNRequestedIdentityUpdateType > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  appliedUpdates?:  Array<HNRequestedIdentityAppliedUpdate > | null,
};

export enum HNRequestedIdentityUpdateStatus {
  OPEN = "OPEN",
  INITIATED = "INITIATED",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
}


export type HNRequestedIdentityUpdateSource = HNAccountHolderCardProductApplication | HNAuthorizedUserCardProductApplication


export type HNRequestedIdentityUpdateParty = HNUSBusinessProfile | HNUSBusinessAuthorizedPerson | HNUSBusinessUltimateBeneficialOwner | HNUSPersonAccountHolder | HNUSPersonAuthorizedUser


export enum HNRequestedIdentityUpdateType {
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  LEGAL_BUSINESS_NAME = "LEGAL_BUSINESS_NAME",
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  HOME_ADDRESS = "HOME_ADDRESS",
  BILLING_ADDRESS = "BILLING_ADDRESS",
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
}


export type HNRequestedIdentityAppliedUpdate = {
  __typename: "HNRequestedIdentityAppliedUpdate",
  appliedChanges?: Array< HNRequestedIdentityUpdateType > | null,
  requestedChange?: HNRequestedIdentityUpdateParty | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPersonCreditRiskAttributes = {
  __typename: "HNPersonCreditRiskAttributes",
  totalAnnualIncome?:  Array<HNAmount > | null,
  currentDebtObligations?:  Array<HNAmount > | null,
  employmentStatus?: HNEmploymentStatus | null,
};

export enum HNEmploymentStatus {
  EMPLOYED = "EMPLOYED",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  RETIRED = "RETIRED",
  STUDENT = "STUDENT",
  UNEMPLOYED = "UNEMPLOYED",
  OTHER = "OTHER",
}


export type HNOnboardingBusinessOrganizationInformation = {
  __typename: "HNOnboardingBusinessOrganizationInformation",
  id: string,
  applicantContact?: HNOnboardingApplicantContact | null,
  businessDetails?: HNOnboardingBusinessDetails | null,
  businessType?: HNOnboardingBusinessType | null,
  businessHistory?: HNOnboardingBusinessHistory | null,
  operatingDetails?: HNOnboardingBusinessProcessingAttributes | null,
  ownershipInformation?:  Array<HNOnboardingBusinessOwner > | null,
  controlProng?: HNOnboardingControlProng | null,
  eSignature?: HNESignature | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNOnboardingApplicantContact = {
  __typename: "HNOnboardingApplicantContact",
  name: HNName,
  phoneNumber: HNPhone,
  emailAddress?: string | null,
};

export type HNOnboardingBusinessDetails = {
  __typename: "HNOnboardingBusinessDetails",
  legalBusinessName: string,
  legalBusinessAddress?: HNAddress | null,
  mailingBusinessAddress?: HNAddress | null,
  businessNameOnTaxReturns: string,
  emailAddressOnTaxReturns: string,
  businessAddressOnTaxReturns: HNAddress,
  taxIdentifier?: string | null,
  acceptsTips: boolean,
};

export type HNOnboardingBusinessType = {
  __typename: "HNOnboardingBusinessType",
  businessWebsite: string,
  goodsAndServicesProvided: HNBusinessPlanOperatingGoodsAndServiceCategory,
  productDescription: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNOnboardingBusinessHistory = {
  __typename: "HNOnboardingBusinessHistory",
  businessStructure: HNBusinessStructure,
  regionOfFormation: string,
  publicilyOwned: boolean,
  stockExchange?: HNStockExchange | null,
  previousBankruptcy: boolean,
  yearsOfOperation?: number | null,
  yearsOfOwnership?: number | null,
  numberOfBusinessLocations?: number | null,
  usingFulfillmentPartners: boolean,
  fulfillmentPartnersNames?: string | null,
  forwardCommittment: boolean,
  forwardCommittmentBreakdown?: HNForwardCommittmentBreakdown | null,
  businessPhoneNumber: HNPhone,
  businessFaxNumber?: HNPhone | null,
  cardAcceptanceBreakdown?: HNCardAcceptanceMethodBreakdown | null,
  advertisingMethods?: Array< HNAdvertisingMethod > | null,
  businessDescription: string,
};

export enum HNStockExchange {
  NYSE = "NYSE",
  NASDAQ = "NASDAQ",
}


export type HNForwardCommittmentBreakdown = {
  __typename: "HNForwardCommittmentBreakdown",
  percentageOfTransactionZeroToSevenDays: number,
  percentageOfTransactionEightToFourteenDays: number,
  percentageOfTransactionFIfteenToThirtyDays: number,
  percentageOfTransactionMoreThanThirtyDays: number,
};

export type HNCardAcceptanceMethodBreakdown = {
  __typename: "HNCardAcceptanceMethodBreakdown",
  cardPresent: number,
  moto: number,
  eCommerce: number,
};

export enum HNAdvertisingMethod {
  INTERNET = "INTERNET",
  WORD_OF_MOUTH = "WORD_OF_MOUTH",
  MASS_OR_DIRECT_MAIL = "MASS_OR_DIRECT_MAIL",
  TELEMARKETING = "TELEMARKETING",
  CATALOG_AND_OR_PUBLICATIONS = "CATALOG_AND_OR_PUBLICATIONS",
  YELLOW_PAGES = "YELLOW_PAGES",
}


export type HNOnboardingBusinessProcessingAttributes = {
  __typename: "HNOnboardingBusinessProcessingAttributes",
  annualVolume?: HNBusinessPlanReportedAmount | null,
  largestTicket?: HNBusinessPlanReportedAmount | null,
  averageTicket?: HNBusinessPlanReportedAmount | null,
  largestMonthlyVolume?: HNBusinessPlanReportedAmount | null,
  isSeasonalBusiness: boolean,
  seasonalVolumeBreakdown?: HNSeasonalVolumeBreakdown | null,
  cardAcceptance?: Array< HNPaymentCardBrand > | null,
  nameOnBankAccount: string,
  accountNumber: string,
  routingNumber?: string | null,
};

export type HNSeasonalVolumeBreakdown = {
  __typename: "HNSeasonalVolumeBreakdown",
  january?: HNBusinessPlanReportedAmount | null,
  february?: HNBusinessPlanReportedAmount | null,
  march?: HNBusinessPlanReportedAmount | null,
  april?: HNBusinessPlanReportedAmount | null,
  may?: HNBusinessPlanReportedAmount | null,
  june?: HNBusinessPlanReportedAmount | null,
  july?: HNBusinessPlanReportedAmount | null,
  august?: HNBusinessPlanReportedAmount | null,
  september?: HNBusinessPlanReportedAmount | null,
  october?: HNBusinessPlanReportedAmount | null,
  november?: HNBusinessPlanReportedAmount | null,
  december?: HNBusinessPlanReportedAmount | null,
};

export enum HNPaymentCardBrand {
  ELECTRON = "ELECTRON",
  MAESTRO = "MAESTRO",
  DANKORT = "DANKORT",
  PAYMENT = "PAYMENT",
  UNION_PAY = "UNION_PAY",
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  DINERS = "DINERS",
  DISCOVER = "DISCOVER",
  JCB = "JCB",
}


export type HNOnboardingBusinessOwner = {
  __typename: "HNOnboardingBusinessOwner",
  id: string,
  name?: HNName | null,
  percentageOwnership?: number | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  identificationDocument?: HNIdentificationDocument | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNIdentificationDocument = {
  __typename: "HNIdentificationDocument",
  socialSecurityNumber?: HNTaxIdentificationDocument | null,
  passport?: HNPassportIdentificationDocument | null,
};

export type HNPassportIdentificationDocument = {
  __typename: "HNPassportIdentificationDocument",
  number: string,
  countryCodeAlpha3: string,
  issueDate: string,
  expirationDate: string,
};

export type HNOnboardingControlProng = {
  __typename: "HNOnboardingControlProng",
  isControlProngAnUltimateBeneficialOwner: boolean,
  nameOfUltimateBeneficialOwner?: HNName | null,
  authorizedPerson?: HNOnboardingBusinessAuthorizedPerson | null,
  yearsAtCurrentAddress: number,
};

export type HNOnboardingBusinessAuthorizedPerson = {
  __typename: "HNOnboardingBusinessAuthorizedPerson",
  id?: string | null,
  name?: HNName | null,
  percentageOwnership?: number | null,
  authorizingPersonTitle?: HNBusinessTitle | null,
  email?: string | null,
  phoneNumbers?:  Array<HNPhone > | null,
  homeAddress?: HNAddress | null,
  dateOfBirth?: string | null,
  identificationDocument?: HNIdentificationDocument | null,
};

export type HNESignature = {
  __typename: "HNESignature",
  eSignature?: string | null,
  confirmationOfESignature?: boolean | null,
  submissionDate?: string | null,
};

export type HNOnboardingPreliminaryBusinessInformation = {
  __typename: "HNOnboardingPreliminaryBusinessInformation",
  id: string,
  businessName: string,
  regionOfFormation: string,
  businessWebsite: string,
  goodsAndServicesProvided: HNBusinessPlanOperatingGoodsAndServiceCategory,
  productDescription: string,
  primaryContactEmail: string,
  preApproved?: boolean | null,
  status?: HNOnboardingPreApprovalStatus | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNOnboardingPreApprovalStatus {
  NOT_DECISIONED = "NOT_DECISIONED",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
}


export type HNAdminAgentOrganization = {
  __typename: "HNAdminAgentOrganization",
  id: string,
  tenantId: string,
  profile: HNOrganizationProfile,
  businessDetail?: HNBusinessDetail | null,
};

export type HNEmployerFinancialAccount = {
  __typename: "HNEmployerFinancialAccount",
  id: string,
  name?: string | null,
  owner?: HNFinancialAccountOwner | null,
  cardProduct?: HNCardProduct | null,
  application?: HNAccountHolderCardProductApplication | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  features?:  Array<HNFinancialAccountFeature > | null,
  companyIdentifier?: string | null,
};

export type HNPaymentCardBinRange = {
  __typename: "HNPaymentCardBinRange",
  id: string,
  binLength?: number | null,
  paymentCardBrand?: HNPaymentCardBrand | null,
  firstDigitsOfBin?: string | null,
  productName?: string | null,
  reloadable?: boolean | null,
  binClassification?: HNPaymentCardBinClassification | null,
  binFundingModel?: HNPaymentCardBinFundingModel | null,
  binProductCode?: HNPaymentCardBinProductCode | null,
  binSubProductCode?: HNPaymentCardBinSubProductCode | null,
  activeAtNetwork?: boolean | null,
  liveAtNetworkFrom?: string | null,
  activeAtPlatform?: boolean | null,
  liveAtPlatformFrom?: string | null,
  currencyCodes?: Array< string > | null,
  secondaryPointOfSaleNetworks?: Array< HNSecondaryPointOfSaleNetwork > | null,
  secondaryAtmNetworks?: Array< HNSecondaryAtmNetwork > | null,
  secondarySurchargeFreeAtmNetworks?: Array< HNSecondarySurchargeFreeAtmNetwork > | null,
  emvType?: HNPaymentCardEmvType | null,
  effectiveFrom?: string | null,
  effectiveThrough?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNPaymentCardBinClassification {
  COMMERCIAL = "COMMERCIAL",
  CONSUMER = "CONSUMER",
  BUSINESS = "BUSINESS",
  FLEET = "FLEET",
  GOVERNMENT = "GOVERNMENT",
}


export enum HNPaymentCardBinFundingModel {
  PREPAID = "PREPAID",
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}


export enum HNPaymentCardBinProductCode {
  MASTERCARD_MPW = "MASTERCARD_MPW",
  MASTERCARD_MDJ = "MASTERCARD_MDJ",
  MASTERCARD_MPG = "MASTERCARD_MPG",
  MASTERCARD_MPA = "MASTERCARD_MPA",
  MASTERCARD_MCF = "MASTERCARD_MCF",
  MASTERCARD_MDB = "MASTERCARD_MDB",
  MASTERCARD_MCO = "MASTERCARD_MCO",
  MASTERCARD_MPL = "MASTERCARD_MPL",
  MASTERCARD_MWF = "MASTERCARD_MWF",
  MASTERCARD_MPM = "MASTERCARD_MPM",
  VISA_F = "VISA_F",
  VISA_S1 = "VISA_S1",
  VISA_S = "VISA_S",
  VISA_G = "VISA_G",
  VISA_K = "VISA_K",
  VISA_A = "VISA_A",
  VISA_B = "VISA_B",
  VISA_C = "VISA_C",
  VISA_I = "VISA_I",
  VISA_G1 = "VISA_G1",
  VISA_G4 = "VISA_G4",
  VISA_X = "VISA_X",
  VISA_K1 = "VISA_K1",
  VISA_S2 = "VISA_S2",
  VISA_J3 = "VISA_J3",
  VISA_Q = "VISA_Q",
  VISA_Q2 = "VISA_Q2",
  VISA_Q3 = "VISA_Q3",
  VISA_Q4 = "VISA_Q4",
  VISA_Q5 = "VISA_Q5",
  VISA_Q6 = "VISA_Q6",
  VISA_R = "VISA_R",
}


export enum HNPaymentCardBinSubProductCode {
  VISA_MS = "VISA_MS",
  VISA_ST = "VISA_ST",
  VISA_GI = "VISA_GI",
  VISA_CB = "VISA_CB",
  VISA_IC = "VISA_IC",
  VISA_GP = "VISA_GP",
  VISA_GV = "VISA_GV",
  VISA_IP = "VISA_IP",
  VISA_OT = "VISA_OT",
  VISA_PP = "VISA_PP",
  VISA_TP = "VISA_TP",
  VISA_BX = "VISA_BX",
  VISA_HS = "VISA_HS",
  VISA_FS = "VISA_FS",
}


export enum HNSecondaryPointOfSaleNetwork {
  PULSE = "PULSE",
  NYCE = "NYCE",
  INTERLINK = "INTERLINK",
}


export enum HNSecondaryAtmNetwork {
  PULSE = "PULSE",
  PLUS = "PLUS",
  MAESTRO = "MAESTRO",
}


export enum HNSecondarySurchargeFreeAtmNetwork {
  MONEY_PASS = "MONEY_PASS",
  ALL_POINT = "ALL_POINT",
  SUM = "SUM",
}


export enum HNPaymentCardEmvType {
  NONE = "NONE",
  CONTACTLESS = "CONTACTLESS",
  CONTACT = "CONTACT",
}


export type HNRuleCollection = {
  __typename: "HNRuleCollection",
  id: string,
  name?: string | null,
  spendRules?:  Array<HNSpendRule > | null,
  interFinancialAccountTransferRules?:  Array<HNInterFinancialAccountTransferRule > | null,
  velocityInterFinancialAccountTransferRules?:  Array<HNVelocityInterFinancialAccountTransferRule > | null,
  velocitySpendRules?:  Array<HNVelocityRule > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPaymentDebitTransaction = {
  __typename: "HNPaymentDebitTransaction",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountingDirection?: HNAccountingDirection | null,
  instrument?: HNPaymentInstrument | null,
  status?: HNPaymentTransactionStatus | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  steps?:  Array<HNPaymentTransactionLifecycleStep > | null,
  authorizedRemainingAmount?: HNAmount | null,
  requestedAuthorizationAmount?: HNAmount | null,
  authorizedAmount?: HNAmount | null,
  settledAmount?: HNAmount | null,
  disbursedAmount?: HNAmount | null,
  canceledAmount?: HNAmount | null,
  refundedAmount?: HNAmount | null,
  responseCode?: HNPaymentTransactionResponseCode | null,
  refunds?:  Array<HNPaymentCreditTransaction > | null,
  networkTransactionIdentifier?: string | null,
  fees?:  Array<HNPaymentTransactionFee > | null,
  totalFeeAmount?: HNAmount | null,
  totalPayableAmount?: HNAmount | null,
};

export type HNPaymentTransaction = {
  __typename: "HNPaymentTransaction",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountingDirection?: HNAccountingDirection | null,
  instrument?: HNPaymentInstrument | null,
  status?: HNPaymentTransactionStatus | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  steps?:  Array<HNPaymentTransactionLifecycleStep > | null,
  authorizedRemainingAmount?: HNAmount | null,
  requestedAuthorizationAmount?: HNAmount | null,
  authorizedAmount?: HNAmount | null,
  settledAmount?: HNAmount | null,
  disbursedAmount?: HNAmount | null,
  canceledAmount?: HNAmount | null,
  refundedAmount?: HNAmount | null,
  responseCode?: HNPaymentTransactionResponseCode | null,
  fees?:  Array<HNPaymentTransactionFee > | null,
  totalFeeAmount?: HNAmount | null,
  totalPayableAmount?: HNAmount | null,
};

export type HNPaymentCreditTransaction = {
  __typename: "HNPaymentCreditTransaction",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountingDirection?: HNAccountingDirection | null,
  instrument?: HNPaymentInstrument | null,
  status?: HNPaymentTransactionStatus | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  steps?:  Array<HNPaymentTransactionLifecycleStep > | null,
  authorizedRemainingAmount?: HNAmount | null,
  requestedAuthorizationAmount?: HNAmount | null,
  authorizedAmount?: HNAmount | null,
  settledAmount?: HNAmount | null,
  disbursedAmount?: HNAmount | null,
  canceledAmount?: HNAmount | null,
  refundedAmount?: HNAmount | null,
  responseCode?: HNPaymentTransactionResponseCode | null,
  originatedPaymentTransaction?: HNPaymentDebitTransaction | null,
  fees?:  Array<HNPaymentTransactionFee > | null,
  totalFeeAmount?: HNAmount | null,
  totalPayableAmount?: HNAmount | null,
  refundReason?: HNPaymentCreditTransactionRefundReason | null,
  refundNote?: string | null,
};

export type HNPaymentInstrument = HNPaymentCardInstrument


export type HNPaymentCardInstrument = {
  __typename: "HNPaymentCardInstrument",
  brand?: HNAcquiringPaymentCardBrand | null,
  last4?: string | null,
  expiryYear?: string | null,
  expiryMonth?: string | null,
  cardHolder?: HNCardHolder | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum HNAcquiringPaymentCardBrand {
  UNKNOWN = "UNKNOWN",
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  DISCOVER = "DISCOVER",
  JCB = "JCB",
  DINERS_CLUB = "DINERS_CLUB",
  UNIONPAY = "UNIONPAY",
  MAESTRO = "MAESTRO",
}


export type HNCardHolder = {
  __typename: "HNCardHolder",
  fullName?: string | null,
  billingAddress?: HNAddress | null,
};

export enum HNPaymentTransactionStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  REVERSED = "REVERSED",
  PENDING_DISPUTE = "PENDING_DISPUTE",
  DISPUTED = "DISPUTED",
  DECLINED = "DECLINED",
}


export type HNPaymentTransactionEvent = {
  __typename: "HNPaymentTransactionEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentAuthorizedEvent = {
  __typename: "HNCardPaymentAuthorizedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentIncrementalAuthorizedEvent = {
  __typename: "HNCardPaymentIncrementalAuthorizedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentAuthorizationDeclinedEvent = {
  __typename: "HNCardPaymentAuthorizationDeclinedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentReversedEvent = {
  __typename: "HNCardPaymentReversedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentPartialReversedEvent = {
  __typename: "HNCardPaymentPartialReversedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentCapturingEvent = {
  __typename: "HNCardPaymentCapturingEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentCapturedEvent = {
  __typename: "HNCardPaymentCapturedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentCaptureProcessingEvent = {
  __typename: "HNCardPaymentCaptureProcessingEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentSettledEvent = {
  __typename: "HNCardPaymentSettledEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentDisbursedEvent = {
  __typename: "HNCardPaymentDisbursedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentIncrementalAuthorizationDeclinedEvent = {
  __typename: "HNCardPaymentIncrementalAuthorizationDeclinedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentReversalDeclinedEvent = {
  __typename: "HNCardPaymentReversalDeclinedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNCardPaymentCaptureDeclinedEvent = {
  __typename: "HNCardPaymentCaptureDeclinedEvent",
  amount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNPaymentTransactionLifecycleStep = {
  __typename: "HNPaymentTransactionLifecycleStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardAuthorizedStep = {
  __typename: "HNCardAuthorizedStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export enum HNPaymentTransactionLifecycleStepStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  DECLINED = "DECLINED",
  UNKNOWN = "UNKNOWN",
}


export type HNCardAuthorizationStep = {
  __typename: "HNCardAuthorizationStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardIncrementalAuthorizedStep = {
  __typename: "HNCardIncrementalAuthorizedStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardIncrementalAuthorizationStep = {
  __typename: "HNCardIncrementalAuthorizationStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardReversedStep = {
  __typename: "HNCardReversedStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardReversalStep = {
  __typename: "HNCardReversalStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardAuthorizationAndCaptureStep = {
  __typename: "HNCardAuthorizationAndCaptureStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardCreditedStep = {
  __typename: "HNCardCreditedStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardCreditStep = {
  __typename: "HNCardCreditStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardCapturedStep = {
  __typename: "HNCardCapturedStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNCardCaptureStep = {
  __typename: "HNCardCaptureStep",
  amount?: HNAmount | null,
  status?: HNPaymentTransactionLifecycleStepStatus | null,
  createdAt?: string | null,
  events?:  Array<HNPaymentTransactionEvent > | null,
  transaction?: HNPaymentTransaction | null,
};

export type HNPaymentTransactionResponseCode = {
  __typename: "HNPaymentTransactionResponseCode",
  authorizationIdentifier?: string | null,
  processorResponseCode?: HNPaymentTransactionResponseCodeProcessorResponseCode | null,
  addressCode?: HNPaymentTransactionAddressCodeResponseCode | null,
  postalCode?: HNPaymentTransactionPostalCodeResponseCode | null,
  securityCode?: HNPaymentTransactionSecurityCodeResponseCode | null,
};

export enum HNPaymentTransactionResponseCodeProcessorResponseCode {
  APPROVED = "APPROVED",
  DO_NOT_HONOR = "DO_NOT_HONOR",
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  EXPIRED_CARD = "EXPIRED_CARD",
  BAD_CVV2 = "BAD_CVV2",
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  SUSPENDED_CARD = "SUSPENDED_CARD",
  TERMINATED_CARD = "TERMINATED_CARD",
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  BLOCKED_CARD = "BLOCKED_CARD",
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  CLOSED_ACCOUNT = "CLOSED_ACCOUNT",
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  INVALID_MERCHANT = "INVALID_MERCHANT",
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  UNKNOWN = "UNKNOWN",
}


export enum HNPaymentTransactionAddressCodeResponseCode {
  SKIPPED = "SKIPPED",
  MATCHED = "MATCHED",
  NOT_MATCHED = "NOT_MATCHED",
  NOT_VERIFIED = "NOT_VERIFIED",
  NOT_PROVIDED = "NOT_PROVIDED",
  UNKNOWN = "UNKNOWN",
}


export enum HNPaymentTransactionPostalCodeResponseCode {
  SKIPPED = "SKIPPED",
  MATCHED = "MATCHED",
  NOT_MATCHED = "NOT_MATCHED",
  NOT_VERIFIED = "NOT_VERIFIED",
  NOT_PROVIDED = "NOT_PROVIDED",
  UNKNOWN = "UNKNOWN",
}


export enum HNPaymentTransactionSecurityCodeResponseCode {
  SKIPPED = "SKIPPED",
  MATCHED = "MATCHED",
  NOT_MATCHED = "NOT_MATCHED",
  NOT_VERIFIED = "NOT_VERIFIED",
  NOT_PROVIDED = "NOT_PROVIDED",
  UNKNOWN = "UNKNOWN",
}


export type HNPaymentTransactionFee = {
  __typename: "HNPaymentTransactionFee",
  feeAmount?: HNAmount | null,
  accountingDirection?: HNAccountingDirection | null,
};

export type HNInterchangeFeePaymentTransactionFee = {
  __typename: "HNInterchangeFeePaymentTransactionFee",
  feeAmount?: HNAmount | null,
  accountingDirection?: HNAccountingDirection | null,
};

export type HNNetworkFeePaymentTransactionFee = {
  __typename: "HNNetworkFeePaymentTransactionFee",
  feeAmount?: HNAmount | null,
  accountingDirection?: HNAccountingDirection | null,
};

export type HNMerchantFeePaymentTransactionFee = {
  __typename: "HNMerchantFeePaymentTransactionFee",
  feeAmount?: HNAmount | null,
  accountingDirection?: HNAccountingDirection | null,
};

export type HNUndeterminedFeePaymentTransactionFee = {
  __typename: "HNUndeterminedFeePaymentTransactionFee",
  feeAmount?: HNAmount | null,
  accountingDirection?: HNAccountingDirection | null,
};

export enum HNPaymentCreditTransactionRefundReason {
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
  CUSTOMER_REQUESTED = "CUSTOMER_REQUESTED",
  INCORRECT_RECIPIENT = "INCORRECT_RECIPIENT",
  FRAUD = "FRAUD",
  OTHER = "OTHER",
}


export type HNPaymentMethodToken = {
  __typename: "HNPaymentMethodToken",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  usage?: HNPaymentMethodTokenUsage | null,
  instrument?: HNPaymentInstrument | null,
};

export enum HNPaymentMethodTokenUsage {
  REUSABLE = "REUSABLE",
  SINGLE_USE = "SINGLE_USE",
}


export type HNAccountHolderProvisioning = {
  __typename: "HNAccountHolderProvisioning",
  idempotencyKey?: string | null,
  id: string,
  accountHolder?: HNAccountHolder | null,
  outcome?: HNAccountHolderProvisioningOutcome | null,
  nextAction?: HNAccountHolderProvisioningWorkflowAction | null,
  currentAction?: HNAccountHolderProvisioningWorkflowAction | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  workflowActions?:  Array<HNAccountHolderProvisioningWorkflowAction > | null,
};

export type HNAccountHolderProvisioningOutcome = {
  __typename: "HNAccountHolderProvisioningOutcome",
  status?: HNAccountHolderProvisioningStatus | null,
};

export enum HNAccountHolderProvisioningStatus {
  INITIATED = "INITIATED",
  IN_PROGRESS = "IN_PROGRESS",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
}


export type HNAccountHolderProvisioningWorkflowAction = {
  __typename: "HNAccountHolderProvisioningWorkflowAction",
  id: string,
  action?: HNProvisionAccountHolderAction | null,
  outcome?: HNAccountHolderProvisioningWorkflowActionDetail | null,
  actionInput?: HNProvisionAccountHolderActionDetail | null,
  executionOrder?: number | null,
  node?: HNAccountHolderProvisioningActionNode | null,
};

export enum HNProvisionAccountHolderAction {
  CREATE_APPLICATION = "CREATE_APPLICATION",
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  SET_CREDIT_LIMIT = "SET_CREDIT_LIMIT",
  ISSUE_PAYMENT_CARD = "ISSUE_PAYMENT_CARD",
  REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT = "REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT",
  NOTIFY_PROVIDER = "NOTIFY_PROVIDER",
  LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT = "LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT",
}


export type HNAccountHolderProvisioningWorkflowActionDetail = {
  __typename: "HNAccountHolderProvisioningWorkflowActionDetail",
  status?: HNAccountHolderProvisioningWorkflowActionStatus | null,
};

export enum HNAccountHolderProvisioningWorkflowActionStatus {
  INITIATED = "INITIATED",
  IN_PROGRESS = "IN_PROGRESS",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
  NOT_EXECUTED = "NOT_EXECUTED",
}


export type HNProvisionAccountHolderActionDetail = {
  __typename: "HNProvisionAccountHolderActionDetail",
  createApplicationInput?: HNProvisionAccountHolderApplicationActionDetail | null,
  createFinancialAccountInput?: HNProvisionCreateFinancialAccountActionDetail | null,
  setFinancialAccountCreditLimitInput?: HNProvisionSetFinancialAccountCreditLimitActionDetail | null,
  issuePaymentCardForFinancialAccountInput?: HNProvisionIssuedPaymentCardForFinancialAccountActionDetail | null,
};

export type HNProvisionAccountHolderApplicationActionDetail = {
  __typename: "HNProvisionAccountHolderApplicationActionDetail",
  cardHolderAgreementConsent?: HNConsentAgreement | null,
  accountHolderCreditReportPullConsent?: HNConsentAgreement | null,
};

export type HNConsentAgreement = {
  __typename: "HNConsentAgreement",
  primaryAuthorizedPerson?: HNConsentingParty | null,
  consentTimestamp?: string | null,
  consentIpAddress?: HNIPAddress | null,
};

export type HNConsentingParty = HNUSBusinessAuthorizedPerson | HNUSPersonAuthorizedUser


export type HNIPAddress = {
  __typename: "HNIPAddress",
  v4?: string | null,
  v6?: string | null,
};

export type HNProvisionCreateFinancialAccountActionDetail = {
  __typename: "HNProvisionCreateFinancialAccountActionDetail",
  name?: string | null,
};

export type HNProvisionSetFinancialAccountCreditLimitActionDetail = {
  __typename: "HNProvisionSetFinancialAccountCreditLimitActionDetail",
  amount?: HNAmount | null,
  memo?: string | null,
};

export type HNProvisionIssuedPaymentCardForFinancialAccountActionDetail = {
  __typename: "HNProvisionIssuedPaymentCardForFinancialAccountActionDetail",
  options?: HNIssuePaymentCardOptionsDetail | null,
};

export type HNIssuePaymentCardOptionsDetail = {
  __typename: "HNIssuePaymentCardOptionsDetail",
  expirationDate?: string | null,
  activateOnCreate?: boolean | null,
  cardProfileSet?: HNCardProfileSet | null,
};

export type HNAccountHolderProvisioningActionNode = HNAccountHolderCardProductApplication | HNFinancialAccount | HNPaymentCard | HNInterFinancialAccountTransfer | HNWorkflowActionResultOutcome | HNUserError


export type HNWorkflowActionResultOutcome = {
  __typename: "HNWorkflowActionResultOutcome",
  createdAt?: string | null,
  updatedAt?: string | null,
  result?: HNWorkflowActionResult | null,
};

export type HNWorkflowActionResult = HNWorkflowActionEmailNotificationResult | HNWorkflowActionVisaPayableAutomationResult | HNWorkflowActionLinkVerifiedExternalBankAccountResult


export type HNWorkflowActionEmailNotificationResult = {
  __typename: "HNWorkflowActionEmailNotificationResult",
  to?: string | null,
  from?: string | null,
  provider?: HNProvisionWorkflowProvider | null,
  deliveredAt?: string | null,
};

export enum HNProvisionWorkflowProvider {
  BOTTOM_LINE = "BOTTOM_LINE",
}


export type HNWorkflowActionVisaPayableAutomationResult = {
  __typename: "HNWorkflowActionVisaPayableAutomationResult",
  buyerIdentifier?: string | null,
  proxyPoolAccountIdentifier?: string | null,
};

export type HNWorkflowActionLinkVerifiedExternalBankAccountResult = {
  __typename: "HNWorkflowActionLinkVerifiedExternalBankAccountResult",
  externalFinancialBankAccounts?:  Array<HNExternalFinancialBankAccount > | null,
};

export type HNPaymentOrder = {
  __typename: "HNPaymentOrder",
  id: string,
  transactions?:  Array<HNPaymentTransaction > | null,
  lineItems?:  Array<HNPaymentOrderLineItem > | null,
  totalAmount?: HNAmount | null,
};

export type HNPaymentOrderLineItem = {
  __typename: "HNPaymentOrderLineItem",
  item?: HNPaymentOrderItem | null,
  quantity?: number | null,
};

export type HNPaymentOrderItem = {
  __typename: "HNPaymentOrderItem",
  name?: string | null,
  description?: string | null,
  amountPerItem?: HNAmount | null,
  paymentInstructions?:  Array<HNPaymentInstruction > | null,
  externalIdentifier?: string | null,
};

export type HNPaymentOrderItemFromCustomItem = {
  __typename: "HNPaymentOrderItemFromCustomItem",
  name?: string | null,
  description?: string | null,
  amountPerItem?: HNAmount | null,
  paymentInstructions?:  Array<HNPaymentInstruction > | null,
  externalIdentifier?: string | null,
};

export type HNPaymentInstruction = {
  __typename: "HNPaymentInstruction",
  disburseTo?: HNPaymentInstructionDisbursementTarget | null,
  disbursementPercent?: number | null,
  disbursementAmount?: HNAmount | null,
};

export type HNPaymentInstructionDisbursementTarget = HNFinancialAccount


export type HNPaymentOrderItemFromCatalogItem = {
  __typename: "HNPaymentOrderItemFromCatalogItem",
  name?: string | null,
  description?: string | null,
  amountPerItem?: HNAmount | null,
  paymentInstructions?:  Array<HNPaymentInstruction > | null,
  catalogItem?: HNCatalogItem | null,
  externalIdentifier?: string | null,
};

export type HNCatalogItem = {
  __typename: "HNCatalogItem",
  id: string,
  name?: string | null,
  description?: string | null,
  amountPerItem?: HNAmount | null,
  paymentInstructions?:  Array<HNPaymentInstruction > | null,
  externalIdentifier?: string | null,
};

export enum HNVelocityConstraintLevel {
  CARD = "CARD",
  ACCOUNT = "ACCOUNT",
  CARD_LINEAGE = "CARD_LINEAGE",
}


export type IssuePaymentCardProcoreEmployee = {
  __typename: "IssuePaymentCardProcoreEmployee",
  id: number,
  name: string,
  email_address?: string | null,
};

export type ModelPaidolUserToProjectGroupConnection = {
  __typename: "ModelPaidolUserToProjectGroupConnection",
  items:  Array<PaidolUserToProjectGroup | null >,
  nextToken?: string | null,
};

export type PaidolUserToProjectGroup = {
  __typename: "PaidolUserToProjectGroup",
  id: string,
  paidolId: string,
  paidolUserId: string,
  projectGroupId: string,
  paidolUser?: PaidolUser | null,
  projectGroup: ProjectGroup,
  approvalLevels?: Array< number | null > | null,
  isReviewer?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type ProjectGroup = {
  __typename: "ProjectGroup",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  groupProjects?: Array< string | null > | null,
  paymentCards?: ModelHighnotePaymentCardConnection | null,
  monthlyBudget?: Currency | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  spendGroup?: MerchantSpendRule | null,
  monthlyBudgetSpend?: ModelProjectGroupBudgetSpendByMonthConnection | null,
  transactions?: ModelHighnoteTransactionEventConnection | null,
  groupAdmins?: ModelPaidolUserToProjectGroupConnection | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettings | null,
  projectVisibilitySettings?: CodingFilteringSettings | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonth | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelProjectGroupBudgetSpendByMonthConnection = {
  __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
  items:  Array<ProjectGroupBudgetSpendByMonth | null >,
  nextToken?: string | null,
};

export type ProjectGroupBudgetSpendByMonth = {
  __typename: "ProjectGroupBudgetSpendByMonth",
  cardGroupId: string,
  paidolId: string,
  yearAndMonth: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UserColumnPreferences = {
  __typename: "UserColumnPreferences",
  paidolId: string,
  columns:  Array<ColumnPreference >,
};

export type ColumnPreference = {
  __typename: "ColumnPreference",
  columnId: string,
  visible: boolean,
  order: number,
};

export enum LandingPagePreference {
  TRANSACTIONS = "TRANSACTIONS",
  MY_TRANSACTIONS = "MY_TRANSACTIONS",
  INSIGHTS = "INSIGHTS",
  MY_CARDS = "MY_CARDS",
}


export type FirstRunBanner = {
  __typename: "FirstRunBanner",
  insights?: boolean | null,
  transactions?: boolean | null,
  reimbursements?: boolean | null,
  cardsManagement?: boolean | null,
  spendRules?: boolean | null,
  funding?: boolean | null,
  teamMembers?: boolean | null,
  groups?: boolean | null,
  wallet?: boolean | null,
  settings?: boolean | null,
  connections?: boolean | null,
};

export type CreatePaidolAgaveSyncInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  inProgress: boolean,
  error?: string | null,
  lastRunStart: string,
  lastRunEnd?: string | null,
  taskArn?: string | null,
  syncEntityFilter?: string | null,
};

export type ModelPaidolAgaveSyncConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  inProgress?: ModelBooleanInput | null,
  error?: ModelStringInput | null,
  lastRunStart?: ModelStringInput | null,
  lastRunEnd?: ModelStringInput | null,
  taskArn?: ModelStringInput | null,
  syncEntityFilter?: ModelStringInput | null,
  and?: Array< ModelPaidolAgaveSyncConditionInput | null > | null,
  or?: Array< ModelPaidolAgaveSyncConditionInput | null > | null,
  not?: ModelPaidolAgaveSyncConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PaidolAgaveSync = {
  __typename: "PaidolAgaveSync",
  id: string,
  paidolId: string,
  authPaidolId: string,
  inProgress: boolean,
  error?: string | null,
  lastRunStart: string,
  lastRunEnd?: string | null,
  taskArn?: string | null,
  syncEntityFilter?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePaidolAgaveSyncInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  inProgress?: boolean | null,
  error?: string | null,
  lastRunStart?: string | null,
  lastRunEnd?: string | null,
  taskArn?: string | null,
  syncEntityFilter?: string | null,
};

export type DeletePaidolAgaveSyncInput = {
  id: string,
};

export type CreatePaymentFileQueueInput = {
  id?: string | null,
  user_id: string,
  paidol_id: string,
  key: string,
  status: PaymentFileQueueStatusEnum,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_payments?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  total?: CurrencyInput | null,
  createdAt?: string | null,
  filename?: string | null,
  supplier_vendor_paidol_ids?: Array< string | null > | null,
  referenced_vendors?: Array< string | null > | null,
  invoice_ids?: Array< string | null > | null,
  invoice_spx_ids?: Array< string | null > | null,
  priority_status?: string | null,
  priority_file_id?: string | null,
  priority_process_on?: string | null,
  priority_response?: string | null,
};

// Represents the status of an uploaded payment file
export enum PaymentFileQueueStatusEnum {
  PROCESSED = "PROCESSED", // Payment has been submitted to CPX
  QUEUED = "QUEUED", // Payment has been uploaded and is awaiting processing
  ERROR = "ERROR", // A CPX error occurred
  NETWORKERROR = "NETWORKERROR", // CPX was unreachable
  COMPLETED = "COMPLETED", // Payment has been processed by CPX and has settled
}


export type CurrencyInput = {
  value: number,
  currency: string,
};

export type ModelPaymentFileQueueConditionInput = {
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  status?: ModelPaymentFileQueueStatusEnumInput | null,
  processed_at?: ModelStringInput | null,
  error_messages?: ModelStringInput | null,
  num_vendors?: ModelIntInput | null,
  num_payments?: ModelIntInput | null,
  num_success?: ModelIntInput | null,
  num_failed?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  supplier_vendor_paidol_ids?: ModelStringInput | null,
  referenced_vendors?: ModelStringInput | null,
  invoice_ids?: ModelStringInput | null,
  invoice_spx_ids?: ModelStringInput | null,
  priority_status?: ModelStringInput | null,
  priority_file_id?: ModelStringInput | null,
  priority_process_on?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  and?: Array< ModelPaymentFileQueueConditionInput | null > | null,
  or?: Array< ModelPaymentFileQueueConditionInput | null > | null,
  not?: ModelPaymentFileQueueConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPaymentFileQueueStatusEnumInput = {
  eq?: PaymentFileQueueStatusEnum | null,
  ne?: PaymentFileQueueStatusEnum | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type PaymentFileQueue = {
  __typename: "PaymentFileQueue",
  id: string,
  user_id: string,
  user?: User | null,
  paidol_id: string,
  paidol?: Paidol | null,
  key: string,
  status: PaymentFileQueueStatusEnum,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_payments?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  total?: Currency | null,
  createdAt?: string | null,
  filename?: string | null,
  supplier_vendor_paidol_ids?: Array< string | null > | null,
  referenced_vendors?: Array< string | null > | null,
  invoice_ids?: Array< string | null > | null,
  invoice_spx_ids?: Array< string | null > | null,
  priority_status?: string | null,
  priority_file_id?: string | null,
  priority_process_on?: string | null,
  priority_response?: string | null,
  updatedAt: string,
};

export type UpdatePaymentFileQueueInput = {
  id: string,
  user_id?: string | null,
  paidol_id?: string | null,
  key?: string | null,
  status?: PaymentFileQueueStatusEnum | null,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_payments?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  total?: CurrencyInput | null,
  createdAt?: string | null,
  filename?: string | null,
  supplier_vendor_paidol_ids?: Array< string | null > | null,
  referenced_vendors?: Array< string | null > | null,
  invoice_ids?: Array< string | null > | null,
  invoice_spx_ids?: Array< string | null > | null,
  priority_status?: string | null,
  priority_file_id?: string | null,
  priority_process_on?: string | null,
  priority_response?: string | null,
};

export type DeletePaymentFileQueueInput = {
  id: string,
};

export type CreatePaidolVendorInput = {
  id?: string | null,
  user_vendor_id: string,
  is_migration?: boolean | null,
  paidol_id: string,
  vendor_paidol_id: string,
  priority_active?: string | null,
  payment_terms?: string | null,
  priority_account_balance?: number | null,
  contact_name?: string | null,
  priority_billing_code?: string | null,
  priority_repeate_code?: string | null,
  priority_group_code?: string | null,
  email_addresses?: Array< string | null > | null,
  priority_document_delivery?: string | null,
  priority_regular_inv?: string | null,
  priority_summary_inv?: string | null,
  foreign_name?: string | null,
  remarks?: string | null,
  box_1099?: string | null,
  form_code_1099?: string | null,
  remark_1?: string | null,
  priority_response?: string | null,
  cron_status?: CronStatus | null,
  priority_status?: string | null,
  priority_supplier_id?: string | null,
  virtual_card_email?: string | null,
  bankAccounts?: Array< BankAccountsInput | null > | null,
  achEnabled?: boolean | null,
  virtualCardEnabled?: boolean | null,
  checkIssuingEnabled?: boolean | null,
  checkIssuingPayableTo?: string | null,
  checkIssuingStreet?: string | null,
  checkIssuingCity?: string | null,
  checkIssuingState?: string | null,
  checkIssuingCountry?: string | null,
  checkIssuingPostalCode?: string | null,
};

export type BankAccountsInput = {
  bankId?: string | null,
  accountType?: AccountTypeEnum | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  defaults?: Array< DefaultsEnum | null > | null,
  isActive?: boolean | null,
};

export type ModelPaidolVendorConditionInput = {
  user_vendor_id?: ModelStringInput | null,
  is_migration?: ModelBooleanInput | null,
  paidol_id?: ModelIDInput | null,
  vendor_paidol_id?: ModelIDInput | null,
  priority_active?: ModelStringInput | null,
  payment_terms?: ModelStringInput | null,
  priority_account_balance?: ModelFloatInput | null,
  contact_name?: ModelStringInput | null,
  priority_billing_code?: ModelStringInput | null,
  priority_repeate_code?: ModelStringInput | null,
  priority_group_code?: ModelStringInput | null,
  email_addresses?: ModelStringInput | null,
  priority_document_delivery?: ModelStringInput | null,
  priority_regular_inv?: ModelStringInput | null,
  priority_summary_inv?: ModelStringInput | null,
  foreign_name?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  box_1099?: ModelStringInput | null,
  form_code_1099?: ModelStringInput | null,
  remark_1?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  cron_status?: ModelCronStatusInput | null,
  priority_status?: ModelStringInput | null,
  priority_supplier_id?: ModelStringInput | null,
  virtual_card_email?: ModelStringInput | null,
  achEnabled?: ModelBooleanInput | null,
  virtualCardEnabled?: ModelBooleanInput | null,
  checkIssuingEnabled?: ModelBooleanInput | null,
  checkIssuingPayableTo?: ModelStringInput | null,
  checkIssuingStreet?: ModelStringInput | null,
  checkIssuingCity?: ModelStringInput | null,
  checkIssuingState?: ModelStringInput | null,
  checkIssuingCountry?: ModelStringInput | null,
  checkIssuingPostalCode?: ModelStringInput | null,
  and?: Array< ModelPaidolVendorConditionInput | null > | null,
  or?: Array< ModelPaidolVendorConditionInput | null > | null,
  not?: ModelPaidolVendorConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCronStatusInput = {
  eq?: CronStatus | null,
  ne?: CronStatus | null,
};

export type PaidolVendor = {
  __typename: "PaidolVendor",
  id: string,
  user_vendor_id: string,
  is_migration?: boolean | null,
  paidol_id: string,
  vendor?: Paidol | null,
  vendor_paidol_id: string,
  priority_active?: string | null,
  payment_terms?: string | null,
  priority_account_balance?: number | null,
  contact_name?: string | null,
  priority_billing_code?: string | null,
  priority_repeate_code?: string | null,
  priority_group_code?: string | null,
  email_addresses?: Array< string | null > | null,
  priority_document_delivery?: string | null,
  priority_regular_inv?: string | null,
  priority_summary_inv?: string | null,
  foreign_name?: string | null,
  remarks?: string | null,
  box_1099?: string | null,
  form_code_1099?: string | null,
  remark_1?: string | null,
  priority_response?: string | null,
  cron_status?: CronStatus | null,
  priority_status?: string | null,
  priority_supplier_id?: string | null,
  virtual_card_email?: string | null,
  bankAccounts?:  Array<BankAccounts | null > | null,
  achEnabled?: boolean | null,
  virtualCardEnabled?: boolean | null,
  checkIssuingEnabled?: boolean | null,
  checkIssuingPayableTo?: string | null,
  checkIssuingStreet?: string | null,
  checkIssuingCity?: string | null,
  checkIssuingState?: string | null,
  checkIssuingCountry?: string | null,
  checkIssuingPostalCode?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePaidolVendorInput = {
  id: string,
  user_vendor_id?: string | null,
  is_migration?: boolean | null,
  paidol_id?: string | null,
  vendor_paidol_id?: string | null,
  priority_active?: string | null,
  payment_terms?: string | null,
  priority_account_balance?: number | null,
  contact_name?: string | null,
  priority_billing_code?: string | null,
  priority_repeate_code?: string | null,
  priority_group_code?: string | null,
  email_addresses?: Array< string | null > | null,
  priority_document_delivery?: string | null,
  priority_regular_inv?: string | null,
  priority_summary_inv?: string | null,
  foreign_name?: string | null,
  remarks?: string | null,
  box_1099?: string | null,
  form_code_1099?: string | null,
  remark_1?: string | null,
  priority_response?: string | null,
  cron_status?: CronStatus | null,
  priority_status?: string | null,
  priority_supplier_id?: string | null,
  virtual_card_email?: string | null,
  bankAccounts?: Array< BankAccountsInput | null > | null,
  achEnabled?: boolean | null,
  virtualCardEnabled?: boolean | null,
  checkIssuingEnabled?: boolean | null,
  checkIssuingPayableTo?: string | null,
  checkIssuingStreet?: string | null,
  checkIssuingCity?: string | null,
  checkIssuingState?: string | null,
  checkIssuingCountry?: string | null,
  checkIssuingPostalCode?: string | null,
};

export type DeletePaidolVendorInput = {
  id: string,
};

export type CreateInvoiceInput = {
  id?: string | null,
  id_base58?: string | null,
  id_base58_short?: string | null,
  payment_file_queue_id?: string | null,
  buyer_paidol_id: string,
  paidol_vendor_id: string,
  supplier_paidol_id: string,
  user_invoice_id: string,
  date: string,
  balance_due: CurrencyInput,
  createdAt?: string | null,
  updatedAt?: string | null,
  transaction_id?: string | null,
  priority_payment_id?: string | null,
  priority_payment_status?: string | null,
  priority_payment_type?: string | null,
  priority_payment_date?: string | null,
  priority_payment_auth_message?: string | null,
  priority_response?: string | null,
  status: PaymentFileQueueStatusEnum,
};

export type ModelInvoiceConditionInput = {
  id_base58?: ModelStringInput | null,
  id_base58_short?: ModelStringInput | null,
  payment_file_queue_id?: ModelIDInput | null,
  buyer_paidol_id?: ModelIDInput | null,
  paidol_vendor_id?: ModelIDInput | null,
  supplier_paidol_id?: ModelIDInput | null,
  user_invoice_id?: ModelStringInput | null,
  date?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  transaction_id?: ModelStringInput | null,
  priority_payment_id?: ModelStringInput | null,
  priority_payment_status?: ModelStringInput | null,
  priority_payment_type?: ModelStringInput | null,
  priority_payment_date?: ModelStringInput | null,
  priority_payment_auth_message?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  status?: ModelPaymentFileQueueStatusEnumInput | null,
  and?: Array< ModelInvoiceConditionInput | null > | null,
  or?: Array< ModelInvoiceConditionInput | null > | null,
  not?: ModelInvoiceConditionInput | null,
};

export type Invoice = {
  __typename: "Invoice",
  id: string,
  id_base58?: string | null,
  id_base58_short?: string | null,
  payment_file_queue_id?: string | null,
  payment_file?: PaymentFileQueue | null,
  buyer_paidol_id: string,
  paidol_vendor_id: string,
  paidol_vendor: PaidolVendor,
  supplier_paidol_id: string,
  supplier_paidol: Paidol,
  user_invoice_id: string,
  date: string,
  balance_due: Currency,
  createdAt: string,
  updatedAt: string,
  transaction_id?: string | null,
  priority_payment_id?: string | null,
  priority_payment_status?: string | null,
  priority_payment_type?: string | null,
  priority_payment_date?: string | null,
  priority_payment_auth_message?: string | null,
  priority_response?: string | null,
  status: PaymentFileQueueStatusEnum,
};

export type UpdateInvoiceInput = {
  id: string,
  id_base58?: string | null,
  id_base58_short?: string | null,
  payment_file_queue_id?: string | null,
  buyer_paidol_id?: string | null,
  paidol_vendor_id?: string | null,
  supplier_paidol_id?: string | null,
  user_invoice_id?: string | null,
  date?: string | null,
  balance_due?: CurrencyInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  transaction_id?: string | null,
  priority_payment_id?: string | null,
  priority_payment_status?: string | null,
  priority_payment_type?: string | null,
  priority_payment_date?: string | null,
  priority_payment_auth_message?: string | null,
  priority_response?: string | null,
  status?: PaymentFileQueueStatusEnum | null,
};

export type DeleteInvoiceInput = {
  id: string,
};

export type CreateSupplierFileQueueInput = {
  id?: string | null,
  user_id: string,
  paidol_id: string,
  key: string,
  status: SupplierFileQueueStatusEnum,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  createdAt?: string | null,
  is_migration?: boolean | null,
};

export enum SupplierFileQueueStatusEnum {
  PROCESSED = "PROCESSED", // Finished processing (i.e. COMPLETED)
  QUEUED = "QUEUED", // Uploaded; awaiting processing
  ERROR = "ERROR", // An error occcurred (generally a CPX error)
}


export type ModelSupplierFileQueueConditionInput = {
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  status?: ModelSupplierFileQueueStatusEnumInput | null,
  processed_at?: ModelStringInput | null,
  error_messages?: ModelStringInput | null,
  num_vendors?: ModelIntInput | null,
  num_success?: ModelIntInput | null,
  num_failed?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  is_migration?: ModelBooleanInput | null,
  and?: Array< ModelSupplierFileQueueConditionInput | null > | null,
  or?: Array< ModelSupplierFileQueueConditionInput | null > | null,
  not?: ModelSupplierFileQueueConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSupplierFileQueueStatusEnumInput = {
  eq?: SupplierFileQueueStatusEnum | null,
  ne?: SupplierFileQueueStatusEnum | null,
};

export type SupplierFileQueue = {
  __typename: "SupplierFileQueue",
  id: string,
  user_id: string,
  user?: User | null,
  paidol_id: string,
  paidol?: Paidol | null,
  key: string,
  status: SupplierFileQueueStatusEnum,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  createdAt?: string | null,
  is_migration?: boolean | null,
  updatedAt: string,
};

export type UpdateSupplierFileQueueInput = {
  id: string,
  user_id?: string | null,
  paidol_id?: string | null,
  key?: string | null,
  status?: SupplierFileQueueStatusEnum | null,
  processed_at?: string | null,
  error_messages?: Array< string | null > | null,
  num_vendors?: number | null,
  num_success?: number | null,
  num_failed?: number | null,
  createdAt?: string | null,
  is_migration?: boolean | null,
};

export type DeleteSupplierFileQueueInput = {
  id: string,
};

export type CreatePaymentStatusDownloadInput = {
  id?: string | null,
  user_id: string,
  paidol_id: string,
  start_date: string,
  end_date: string,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt?: string | null,
};

export enum PaymentStatusDownloadStatusEnum {
  QUEUED = "QUEUED", // Has been queued for processing
  PROCESSED = "PROCESSED", // Report is ready for downloading
  ERROR = "ERROR", // An error occurred
}


export type ModelPaymentStatusDownloadConditionInput = {
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  s3_key?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPaymentStatusDownloadConditionInput | null > | null,
  or?: Array< ModelPaymentStatusDownloadConditionInput | null > | null,
  not?: ModelPaymentStatusDownloadConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPaymentStatusDownloadStatusEnumInput = {
  eq?: PaymentStatusDownloadStatusEnum | null,
  ne?: PaymentStatusDownloadStatusEnum | null,
};

export type PaymentStatusDownload = {
  __typename: "PaymentStatusDownload",
  id: string,
  user_id: string,
  paidol_id: string,
  start_date: string,
  end_date: string,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePaymentStatusDownloadInput = {
  id: string,
  user_id?: string | null,
  paidol_id?: string | null,
  start_date?: string | null,
  end_date?: string | null,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt?: string | null,
};

export type DeletePaymentStatusDownloadInput = {
  id: string,
};

export type UpdatePaidolHighnoteIntegrationInput = {
  id: string,
  paidolId?: string | null,
  userId?: string | null,
  legalBusinessName?: string | null,
  businessAccountHolderId?: string | null,
  primaryAuthorizedPersonId?: string | null,
  financialAccountId?: string | null,
  externalFinancialBankAccountId?: string | null,
  hasInitialFunding?: boolean | null,
  accountHolderCardProductApplicationId?: string | null,
  isApplicationAccepted?: boolean | null,
  isDisconnected?: boolean | null,
  highnoteProductId?: string | null,
  finicityCustomerId?: string | null,
  dwollaCustomerId?: string | null,
  cardProfileId?: string | null,
};

export type ModelPaidolHighnoteIntegrationConditionInput = {
  paidolId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  legalBusinessName?: ModelStringInput | null,
  businessAccountHolderId?: ModelIDInput | null,
  primaryAuthorizedPersonId?: ModelIDInput | null,
  financialAccountId?: ModelIDInput | null,
  externalFinancialBankAccountId?: ModelIDInput | null,
  hasInitialFunding?: ModelBooleanInput | null,
  accountHolderCardProductApplicationId?: ModelIDInput | null,
  isApplicationAccepted?: ModelBooleanInput | null,
  isDisconnected?: ModelBooleanInput | null,
  highnoteProductId?: ModelIDInput | null,
  finicityCustomerId?: ModelStringInput | null,
  dwollaCustomerId?: ModelStringInput | null,
  cardProfileId?: ModelStringInput | null,
  and?: Array< ModelPaidolHighnoteIntegrationConditionInput | null > | null,
  or?: Array< ModelPaidolHighnoteIntegrationConditionInput | null > | null,
  not?: ModelPaidolHighnoteIntegrationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PaidolHighnoteIntegration = {
  __typename: "PaidolHighnoteIntegration",
  // id and paidolId are the same; corresponds to Paidol.id
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  id: string,
  paidolId: string,
  userId?: string | null,
  legalBusinessName?: string | null,
  businessAccountHolderId?: string | null,
  primaryAuthorizedPersonId?: string | null,
  financialAccountId?: string | null,
  externalFinancialBankAccountId?: string | null,
  hasInitialFunding?: boolean | null,
  accountHolderCardProductApplicationId?: string | null,
  isApplicationAccepted?: boolean | null,
  isDisconnected?: boolean | null,
  highnoteProductId?: string | null,
  highnoteProduct?: HighnoteProduct | null,
  finicityCustomerId?: string | null,
  dwollaCustomerId?: string | null,
  cardProfileId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type HighnoteProduct = {
  __typename: "HighnoteProduct",
  id: string,
  type: HighnoteProductType,
  isActive: boolean,
  createdAt: string,
  updatedAt: string,
};

export enum HighnoteProductType {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}


export type CreateHighnotePaymentCardInput = {
  paymentCardId: string,
  paidolId: string,
  authPaidolId: string,
  name?: string | null,
  cardGroupId?: string | null,
  status?: HNPaymentCardStatus | null,
  bin?: string | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  formFactor?: HNCardFormFactor | null,
  expirationDate?: string | null,
  budget?: HNVelocityRuleConnectionInput | null,
  hasPin?: boolean | null,
  procoreEmployee?: IssuePaymentCardProcoreEmployeeInput | null,
  cardholderId?: string | null,
  cardholderName?: string | null,
  isAdminLocked?: boolean | null,
  lastActionByRole?: string | null,
  lastActionByPaidolUserId?: string | null,
  lastActionByName?: string | null,
  lastActionByEmail?: string | null,
  lastActionAt?: string | null,
  merchantSpendRuleId?: string | null,
  isAuthorizedUserCard?: boolean | null,
};

export type HNVelocityRuleConnectionInput = {
  pageInfo: HNPageInfoInput,
  edges?: Array< HNVelocityRuleEdgeInput > | null,
};

export type HNPageInfoInput = {
  hasNextPage: boolean,
  hasPreviousPage: boolean,
  startCursor: string,
  endCursor: string,
};

export type HNVelocityRuleEdgeInput = {
  cursor: string,
  node?: HNVelocityRuleInput | null,
};

export type HNVelocityRuleInput = {
  velocityRuleId: string,
  version?: string | null,
};

export type IssuePaymentCardProcoreEmployeeInput = {
  id: number,
  name: string,
  email_address?: string | null,
};

export type ModelHighnotePaymentCardConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  cardGroupId?: ModelIDInput | null,
  status?: ModelHNPaymentCardStatusInput | null,
  bin?: ModelStringInput | null,
  last4?: ModelStringInput | null,
  network?: ModelHNPaymentCardNetworkInput | null,
  formFactor?: ModelHNCardFormFactorInput | null,
  expirationDate?: ModelStringInput | null,
  hasPin?: ModelBooleanInput | null,
  cardholderId?: ModelIDInput | null,
  cardholderName?: ModelStringInput | null,
  isAdminLocked?: ModelBooleanInput | null,
  lastActionByRole?: ModelStringInput | null,
  lastActionByPaidolUserId?: ModelIDInput | null,
  lastActionByName?: ModelStringInput | null,
  lastActionByEmail?: ModelStringInput | null,
  lastActionAt?: ModelStringInput | null,
  merchantSpendRuleId?: ModelIDInput | null,
  isAuthorizedUserCard?: ModelBooleanInput | null,
  and?: Array< ModelHighnotePaymentCardConditionInput | null > | null,
  or?: Array< ModelHighnotePaymentCardConditionInput | null > | null,
  not?: ModelHighnotePaymentCardConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelHNPaymentCardStatusInput = {
  eq?: HNPaymentCardStatus | null,
  ne?: HNPaymentCardStatus | null,
};

export type ModelHNPaymentCardNetworkInput = {
  eq?: HNPaymentCardNetwork | null,
  ne?: HNPaymentCardNetwork | null,
};

export type ModelHNCardFormFactorInput = {
  eq?: HNCardFormFactor | null,
  ne?: HNCardFormFactor | null,
};

export type UpdateHighnotePaymentCardInput = {
  paymentCardId: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  cardGroupId?: string | null,
  status?: HNPaymentCardStatus | null,
  bin?: string | null,
  last4?: string | null,
  network?: HNPaymentCardNetwork | null,
  formFactor?: HNCardFormFactor | null,
  expirationDate?: string | null,
  budget?: HNVelocityRuleConnectionInput | null,
  hasPin?: boolean | null,
  procoreEmployee?: IssuePaymentCardProcoreEmployeeInput | null,
  cardholderId?: string | null,
  cardholderName?: string | null,
  isAdminLocked?: boolean | null,
  lastActionByRole?: string | null,
  lastActionByPaidolUserId?: string | null,
  lastActionByName?: string | null,
  lastActionByEmail?: string | null,
  lastActionAt?: string | null,
  merchantSpendRuleId?: string | null,
  isAuthorizedUserCard?: boolean | null,
};

export type DeleteHighnotePaymentCardInput = {
  paymentCardId: string,
};

export type CreateSpendRulesInput = {
  spendRuleId: string,
  paidolId: string,
  authPaidolId: string,
  name: string,
  maximumAmount?: HNAmountInput | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  streetAddressAllowed?: Array< string | null > | null,
  streetAddressBlocked?: Array< string | null > | null,
};

export type HNAmountInput = {
  value: number,
  currencyCode: HNISO4217Alpha3SupportedCurrency,
};

export enum HNISO4217Alpha3SupportedCurrency {
  USD = "USD",
}


export type ModelSpendRulesConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  merchantCategoryAllowed?: ModelStringInput | null,
  merchantCategoryBlocked?: ModelStringInput | null,
  merchantCountryAllowed?: ModelStringInput | null,
  merchantCountryBlocked?: ModelStringInput | null,
  streetAddressAllowed?: ModelStringInput | null,
  streetAddressBlocked?: ModelStringInput | null,
  and?: Array< ModelSpendRulesConditionInput | null > | null,
  or?: Array< ModelSpendRulesConditionInput | null > | null,
  not?: ModelSpendRulesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SpendRules = {
  __typename: "SpendRules",
  spendRuleId: string,
  paidolId: string,
  authPaidolId: string,
  name: string,
  maximumAmount?: HNAmount | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  streetAddressAllowed?: Array< string | null > | null,
  streetAddressBlocked?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSpendRulesInput = {
  spendRuleId: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  maximumAmount?: HNAmountInput | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  streetAddressAllowed?: Array< string | null > | null,
  streetAddressBlocked?: Array< string | null > | null,
};

export type DeleteSpendRulesInput = {
  spendRuleId: string,
};

export type CreateVelocityRulesInput = {
  velocityRuleId: string,
  paidolId: string,
  authPaidolId: string,
  name: string,
  maximumAmount: HNAmountInput,
  cumulativeRuleId: string,
  monthlyLimitResetTimestamp?: string | null,
};

export type ModelVelocityRulesConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  cumulativeRuleId?: ModelIDInput | null,
  monthlyLimitResetTimestamp?: ModelStringInput | null,
  and?: Array< ModelVelocityRulesConditionInput | null > | null,
  or?: Array< ModelVelocityRulesConditionInput | null > | null,
  not?: ModelVelocityRulesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type VelocityRules = {
  __typename: "VelocityRules",
  velocityRuleId: string,
  paidolId: string,
  authPaidolId: string,
  name: string,
  maximumAmount: HNAmount,
  cumulativeRuleId: string,
  monthlyLimitResetTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateVelocityRulesInput = {
  velocityRuleId: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  maximumAmount?: HNAmountInput | null,
  cumulativeRuleId?: string | null,
  monthlyLimitResetTimestamp?: string | null,
};

export type DeleteVelocityRulesInput = {
  velocityRuleId: string,
};

export type CreateReceiptSummaryFieldInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  receiptUploadId: string,
  type: NormalizedSummaryField,
  typeConfidenceScore?: number | null,
  label?: string | null,
  labelConfidenceScore?: number | null,
  value?: string | null,
  valueConfidenceScore?: number | null,
};

export type ModelReceiptSummaryFieldConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  type?: ModelNormalizedSummaryFieldInput | null,
  typeConfidenceScore?: ModelFloatInput | null,
  label?: ModelStringInput | null,
  labelConfidenceScore?: ModelFloatInput | null,
  value?: ModelStringInput | null,
  valueConfidenceScore?: ModelFloatInput | null,
  and?: Array< ModelReceiptSummaryFieldConditionInput | null > | null,
  or?: Array< ModelReceiptSummaryFieldConditionInput | null > | null,
  not?: ModelReceiptSummaryFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelNormalizedSummaryFieldInput = {
  eq?: NormalizedSummaryField | null,
  ne?: NormalizedSummaryField | null,
};

export type UpdateReceiptSummaryFieldInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  receiptUploadId?: string | null,
  type?: NormalizedSummaryField | null,
  typeConfidenceScore?: number | null,
  label?: string | null,
  labelConfidenceScore?: number | null,
  value?: string | null,
  valueConfidenceScore?: number | null,
};

export type DeleteReceiptSummaryFieldInput = {
  id: string,
};

export type CreateReceiptLineItemInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  receiptUploadId: string,
};

export type ModelReceiptLineItemConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  and?: Array< ModelReceiptLineItemConditionInput | null > | null,
  or?: Array< ModelReceiptLineItemConditionInput | null > | null,
  not?: ModelReceiptLineItemConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateReceiptLineItemInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  receiptUploadId?: string | null,
};

export type DeleteReceiptLineItemInput = {
  id: string,
};

export type CreateReceiptLineItemFieldInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  receiptLineItemId: string,
  type: NormalizedSummaryField,
  typeConfidenceScore: number,
  label: string,
  labelConfidenceScore: number,
  value: string,
  valueConfidenceScore: number,
};

export type ModelReceiptLineItemFieldConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptLineItemId?: ModelIDInput | null,
  type?: ModelNormalizedSummaryFieldInput | null,
  typeConfidenceScore?: ModelFloatInput | null,
  label?: ModelStringInput | null,
  labelConfidenceScore?: ModelFloatInput | null,
  value?: ModelStringInput | null,
  valueConfidenceScore?: ModelFloatInput | null,
  and?: Array< ModelReceiptLineItemFieldConditionInput | null > | null,
  or?: Array< ModelReceiptLineItemFieldConditionInput | null > | null,
  not?: ModelReceiptLineItemFieldConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateReceiptLineItemFieldInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  receiptLineItemId?: string | null,
  type?: NormalizedSummaryField | null,
  typeConfidenceScore?: number | null,
  label?: string | null,
  labelConfidenceScore?: number | null,
  value?: string | null,
  valueConfidenceScore?: number | null,
};

export type DeleteReceiptLineItemFieldInput = {
  id: string,
};

export type CreateReceiptUploadInput = {
  paidolId: string,
  authPaidolId: string,
  document: string,
  status: ReceiptUploadStatus,
  highnoteTransactionEventId?: string | null,
  reimbursementTransactionId?: string | null,
};

export type ModelReceiptUploadConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  document?: ModelStringInput | null,
  status?: ModelReceiptUploadStatusInput | null,
  and?: Array< ModelReceiptUploadConditionInput | null > | null,
  or?: Array< ModelReceiptUploadConditionInput | null > | null,
  not?: ModelReceiptUploadConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelReceiptUploadStatusInput = {
  eq?: ReceiptUploadStatus | null,
  ne?: ReceiptUploadStatus | null,
};

export type UpdateReceiptUploadInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  document?: string | null,
  status?: ReceiptUploadStatus | null,
};

export type DeleteReceiptUploadInput = {
  id: string,
};

export type CreateTransactionToReceiptUploadInput = {
  id?: string | null,
  highnoteTransactionEventId?: string | null,
  reimbursementTransactionId?: string | null,
  receiptUploadId: string,
  createdAt?: string | null,
  authPaidolId: string,
};

export type ModelTransactionToReceiptUploadConditionInput = {
  highnoteTransactionEventId?: ModelIDInput | null,
  reimbursementTransactionId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  authPaidolId?: ModelIDInput | null,
  and?: Array< ModelTransactionToReceiptUploadConditionInput | null > | null,
  or?: Array< ModelTransactionToReceiptUploadConditionInput | null > | null,
  not?: ModelTransactionToReceiptUploadConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TransactionToReceiptUpload = {
  __typename: "TransactionToReceiptUpload",
  id: string,
  highnoteTransactionEventId?: string | null,
  reimbursementTransactionId?: string | null,
  receiptUploadId: string,
  receiptUpload?: ReceiptUpload | null,
  createdAt: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  updatedAt: string,
};

export type UpdateTransactionToReceiptUploadInput = {
  id: string,
  highnoteTransactionEventId?: string | null,
  reimbursementTransactionId?: string | null,
  receiptUploadId?: string | null,
  createdAt?: string | null,
  authPaidolId?: string | null,
};

export type DeleteTransactionToReceiptUploadInput = {
  id: string,
};

export type CreateTransactionInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  transactionDate: string,
  reimbursementTransactionId?: string | null,
  highnoteTransactionId?: string | null,
};

export type ModelTransactionConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  transactionDate?: ModelStringInput | null,
  reimbursementTransactionId?: ModelIDInput | null,
  highnoteTransactionId?: ModelIDInput | null,
  and?: Array< ModelTransactionConditionInput | null > | null,
  or?: Array< ModelTransactionConditionInput | null > | null,
  not?: ModelTransactionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Transaction = {
  __typename: "Transaction",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  transactionDate: string,
  reimbursementTransactionId?: string | null,
  reimbursementTransaction?: ReimbursementTransaction | null,
  highnoteTransactionId?: string | null,
  highnoteTransaction?: HighnoteTransaction | null,
  createdAt: string,
  updatedAt: string,
};

export type ReimbursementTransaction = {
  __typename: "ReimbursementTransaction",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  dwollaTransferId?: string | null,
  transactionDate: string,
  amount: HNAmount,
  status: ReimbursementTransactionStatus,
  checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
  note?: string | null,
  contestNote?: string | null,
  deniedNote?: string | null,
  merchantName?: string | null,
  receiptLineItems: ReceiptLineItems,
  jobCodeId?: string | null,
  jobCode?: JobCode | null,
  reimbursementDate?: string | null,
  decisionDate?: string | null,
  reviewedByPaidolUserId?: string | null,
  reviewedByName?: string | null,
  reviewedByRole?: string | null,
  reviewedAt?: string | null,
  paidolUserId: string,
  paidolUser?: PaidolUser | null,
  transactionType: ReimbursementTransactionType,
  expenseTypeId?: string | null,
  expenseType?: ExpenseType | null,
  receiptId: string,
  receipt?: ReceiptUpload | null,
  procoreProjectId?: number | null,
  procoreProject?: GetProcoreProjectsPayload | null,
  procoreWBSCodeId?: number | null,
  procoreWBSCode?: GetProcoreWBSCodesPayload | null,
  agaveGlCodeId?: string | null,
  agaveGlCode?: AgaveGlCode | null,
  agaveProjectId?: string | null,
  agaveProject?: AgaveProject | null,
  agaveCostCodeId?: string | null,
  agaveCostCode?: AgaveCostCode | null,
  agaveCostTypeId?: string | null,
  agaveCostType?: AgaveCostType | null,
  agaveVendorId?: string | null,
  agaveVendor?: AgaveVendor | null,
  agaveSubJobId?: string | null,
  agaveSubJob?: AgaveSubJob | null,
  agaveLocationId?: string | null,
  agaveLocation?: AgaveLocation | null,
  agaveDepartmentId?: string | null,
  agaveDepartment?: AgaveDepartment | null,
  agaveSubaccountId?: string | null,
  agaveSubaccount?: AgaveSubaccount | null,
  agaveEmployeeId?: string | null,
  agaveEmployee?: AgaveEmployeeEntity | null,
  agaveEquipmentId?: string | null,
  agaveEquipment?: AgaveEquipment | null,
  agaveEmCostCodeId?: string | null,
  agaveEmCostCode?: AgaveEmCostCode | null,
  agaveEmCostTypeId?: string | null,
  agaveEmCostType?: AgaveEmCostType | null,
  codingType?: string | null,
  accountingDate?: string | null,
  flexGlCodeId?: string | null,
  flexGlCode?: FlexGlCode | null,
  flexCodeId?: string | null,
  flexCode?: FlexCode | null,
  flexCostCodeId?: string | null,
  flexCostCode?: FlexCostCode | null,
  flexCostTypeId?: string | null,
  flexCostType?: FlexCostType | null,
  flexVendorId?: string | null,
  flexVendor?: FlexVendor | null,
  createdAt: string,
  updatedAt: string,
};

export enum ReimbursementTransactionStatus {
  REQUESTED = "REQUESTED",
  REVIEWED = "REVIEWED",
  CONTESTED = "CONTESTED",
  APPROVED = "APPROVED",
  EXPORTED = "EXPORTED",
  PAID = "PAID",
  DENIED = "DENIED",
}


export enum ReimbursementTransactionCheckrunStatus {
  PROCESSING = "PROCESSING",
  PAYMENT_INITIATED = "PAYMENT_INITIATED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
}


export enum ReceiptLineItems {
  TOTAL = "TOTAL",
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}


export enum ReimbursementTransactionType {
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  CHECK = "CHECK",
  CASH = "CASH",
}


export type ExpenseType = {
  __typename: "ExpenseType",
  id: string,
  name: string,
  codes?: ModelExpenseTypeToMCCConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelExpenseTypeToMCCConnection = {
  __typename: "ModelExpenseTypeToMCCConnection",
  items:  Array<ExpenseTypeToMCC | null >,
  nextToken?: string | null,
};

export type ExpenseTypeToMCC = {
  __typename: "ExpenseTypeToMCC",
  id: string,
  mccID: string,
  expenseTypeID: string,
  mcc: Mcc,
  expenseType: ExpenseType,
  createdAt: string,
  updatedAt: string,
};

export type Mcc = {
  __typename: "Mcc",
  id: string,
  code: number,
  highnoteDescription: HNMerchantCategory,
  highnoteCategoryDescription?: string | null,
  speedchainDescription?: string | null,
  expenseTypes?: ModelExpenseTypeToMCCConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTransactionInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  transactionDate?: string | null,
  reimbursementTransactionId?: string | null,
  highnoteTransactionId?: string | null,
};

export type DeleteTransactionInput = {
  id: string,
};

export type CreateReimbursementTransactionInput = {
  paidolId: string,
  authPaidolId: string,
  paidolUserId: string,
  receiptId: string,
  receiptLineItems: ReceiptLineItems,
  status: ReimbursementTransactionStatus,
  transactionDate: string,
  transactionType: ReimbursementTransactionType,
  amount?: MoneyAmount | null,
  expenseTypeId?: string | null,
  jobCodeId?: string | null,
  merchantName?: string | null,
  note?: string | null,
  procoreProjectId?: number | null,
  procoreWBSCodeId?: number | null,
  reimbursementDate?: string | null,
  decisionDate?: string | null,
  dwollaTransferId?: string | null,
  contestNote?: string | null,
  deniedNote?: string | null,
  agaveGlCodeId?: string | null,
  agaveProjectId?: string | null,
  agaveCostCodeId?: string | null,
  agaveCostTypeId?: string | null,
  agaveVendorId?: string | null,
  agaveSubJobId?: string | null,
  agaveLocationId?: string | null,
  agaveDepartmentId?: string | null,
  agaveSubaccountId?: string | null,
  agaveEmployeeId?: string | null,
  accountingDate?: string | null,
  flexGlCodeId?: string | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexVendorId?: string | null,
};

export type MoneyAmount = {
  value?: number | null,
  currencyCode?: string | null,
};

export type ModelReimbursementTransactionConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  dwollaTransferId?: ModelIDInput | null,
  transactionDate?: ModelStringInput | null,
  status?: ModelReimbursementTransactionStatusInput | null,
  checkrunStatus?: ModelReimbursementTransactionCheckrunStatusInput | null,
  note?: ModelStringInput | null,
  contestNote?: ModelStringInput | null,
  deniedNote?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  receiptLineItems?: ModelReceiptLineItemsInput | null,
  jobCodeId?: ModelIDInput | null,
  reimbursementDate?: ModelStringInput | null,
  decisionDate?: ModelStringInput | null,
  reviewedByPaidolUserId?: ModelIDInput | null,
  reviewedByName?: ModelStringInput | null,
  reviewedByRole?: ModelStringInput | null,
  reviewedAt?: ModelStringInput | null,
  paidolUserId?: ModelIDInput | null,
  transactionType?: ModelReimbursementTransactionTypeInput | null,
  expenseTypeId?: ModelIDInput | null,
  receiptId?: ModelIDInput | null,
  procoreProjectId?: ModelFloatInput | null,
  procoreWBSCodeId?: ModelFloatInput | null,
  agaveGlCodeId?: ModelIDInput | null,
  agaveProjectId?: ModelIDInput | null,
  agaveCostCodeId?: ModelIDInput | null,
  agaveCostTypeId?: ModelIDInput | null,
  agaveVendorId?: ModelIDInput | null,
  agaveSubJobId?: ModelIDInput | null,
  agaveLocationId?: ModelIDInput | null,
  agaveDepartmentId?: ModelIDInput | null,
  agaveSubaccountId?: ModelIDInput | null,
  agaveEmployeeId?: ModelIDInput | null,
  agaveEquipmentId?: ModelIDInput | null,
  agaveEmCostCodeId?: ModelIDInput | null,
  agaveEmCostTypeId?: ModelIDInput | null,
  codingType?: ModelStringInput | null,
  accountingDate?: ModelStringInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  and?: Array< ModelReimbursementTransactionConditionInput | null > | null,
  or?: Array< ModelReimbursementTransactionConditionInput | null > | null,
  not?: ModelReimbursementTransactionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelReimbursementTransactionStatusInput = {
  eq?: ReimbursementTransactionStatus | null,
  ne?: ReimbursementTransactionStatus | null,
};

export type ModelReimbursementTransactionCheckrunStatusInput = {
  eq?: ReimbursementTransactionCheckrunStatus | null,
  ne?: ReimbursementTransactionCheckrunStatus | null,
};

export type ModelReceiptLineItemsInput = {
  eq?: ReceiptLineItems | null,
  ne?: ReceiptLineItems | null,
};

export type ModelReimbursementTransactionTypeInput = {
  eq?: ReimbursementTransactionType | null,
  ne?: ReimbursementTransactionType | null,
};

export type UpdateReimbursementTransactionInput = {
  id: string,
  amount?: MoneyAmount | null,
  expenseTypeId?: string | null,
  jobCodeId?: string | null,
  merchantName?: string | null,
  note?: string | null,
  procoreProjectId?: number | null,
  procoreWBSCodeId?: number | null,
  receiptId?: string | null,
  receiptLineItems?: ReceiptLineItems | null,
  reimbursementDate?: string | null,
  decisionDate?: string | null,
  status?: ReimbursementTransactionStatus | null,
  transactionDate?: string | null,
  transactionType?: ReimbursementTransactionType | null,
  dwollaTransferId?: string | null,
  contestNote?: string | null,
  deniedNote?: string | null,
  agaveGlCodeId?: string | null,
  agaveProjectId?: string | null,
  agaveCostCodeId?: string | null,
  agaveCostTypeId?: string | null,
  agaveVendorId?: string | null,
  agaveSubJobId?: string | null,
  agaveLocationId?: string | null,
  agaveDepartmentId?: string | null,
  agaveSubaccountId?: string | null,
  agaveEmployeeId?: string | null,
  accountingDate?: string | null,
  flexGlCodeId?: string | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexVendorId?: string | null,
};

export type DeleteReimbursementTransactionInput = {
  id: string,
};

export type CreateProjectGroupInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  groupProjects?: Array< string | null > | null,
  monthlyBudget?: CurrencyInput | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettingsInput | null,
  projectVisibilitySettings?: CodingFilteringSettingsInput | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonthInput | null,
};

export type CodingFilteringSettingsInput = {
  isAllAvailable: boolean,
  ids?: Array< string | null > | null,
};

export type AmountSpentThisMonthInput = {
  amount?: number | null,
  yearAndMonth?: string | null,
};

export type ModelProjectGroupConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  groupProjects?: ModelStringInput | null,
  isMonthlyBudgetUnlimited?: ModelBooleanInput | null,
  spendGroupId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  hasReviewers?: ModelBooleanInput | null,
  and?: Array< ModelProjectGroupConditionInput | null > | null,
  or?: Array< ModelProjectGroupConditionInput | null > | null,
  not?: ModelProjectGroupConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateProjectGroupInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  groupProjects?: Array< string | null > | null,
  monthlyBudget?: CurrencyInput | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettingsInput | null,
  projectVisibilitySettings?: CodingFilteringSettingsInput | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonthInput | null,
};

export type DeleteProjectGroupInput = {
  id: string,
};

export type CreateCardGroupInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  groupProjects?: Array< string | null > | null,
  monthlyBudget?: CurrencyInput | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettingsInput | null,
  projectVisibilitySettings?: CodingFilteringSettingsInput | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonthInput | null,
};

export type ModelCardGroupConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  groupProjects?: ModelStringInput | null,
  isMonthlyBudgetUnlimited?: ModelBooleanInput | null,
  spendGroupId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  hasReviewers?: ModelBooleanInput | null,
  and?: Array< ModelCardGroupConditionInput | null > | null,
  or?: Array< ModelCardGroupConditionInput | null > | null,
  not?: ModelCardGroupConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCardGroupInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  groupProjects?: Array< string | null > | null,
  monthlyBudget?: CurrencyInput | null,
  isMonthlyBudgetUnlimited?: boolean | null,
  spendGroupId?: string | null,
  deletedAt?: string | null,
  glCodeVisibilitySettings?: CodingFilteringSettingsInput | null,
  projectVisibilitySettings?: CodingFilteringSettingsInput | null,
  hasReviewers?: boolean | null,
  spentThisMonth?: AmountSpentThisMonthInput | null,
};

export type DeleteCardGroupInput = {
  id: string,
};

export type CreateUserNotificationPreferencesInput = {
  id?: string | null,
  userId: string,
  paidolId?: string | null,
  transactionAlertSms?: boolean | null,
  transactionAlertEmail?: boolean | null,
  cardLockedSms?: boolean | null,
  cardLockedEmail?: boolean | null,
  manualCardActionSms?: boolean | null,
  manualCardActionEmail?: boolean | null,
  lowBalanceAlertSms?: boolean | null,
  lowBalanceAlertEmail?: boolean | null,
  cardActivationSms?: boolean | null,
  cardActivationEmail?: boolean | null,
  statementReadySms?: boolean | null,
  statementReadyEmail?: boolean | null,
  txnReviewFrequency?: string | null,
  txnReviewCodeUpdateSms?: boolean | null,
  txnReviewCodeUpdateEmail?: boolean | null,
  txnReviewNoteUpdateSms?: boolean | null,
  txnReviewNoteUpdateEmail?: boolean | null,
  txnReviewReceiptUpdateSms?: boolean | null,
  txnReviewReceiptUpdateEmail?: boolean | null,
  txnReviewResubmissionSms?: boolean | null,
  txnReviewResubmissionEmail?: boolean | null,
  txnReviewReadySms?: boolean | null,
  txnReviewReadyEmail?: boolean | null,
  returnedTransactionSms?: boolean | null,
  returnedTransactionEmail?: boolean | null,
  smsConsentAccepted?: boolean | null,
  smsConsentAcceptedAt?: string | null,
  platformAgreementVersion?: string | null,
  hasReceivedWelcomeSms?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelUserNotificationPreferencesConditionInput = {
  userId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  transactionAlertSms?: ModelBooleanInput | null,
  transactionAlertEmail?: ModelBooleanInput | null,
  cardLockedSms?: ModelBooleanInput | null,
  cardLockedEmail?: ModelBooleanInput | null,
  manualCardActionSms?: ModelBooleanInput | null,
  manualCardActionEmail?: ModelBooleanInput | null,
  lowBalanceAlertSms?: ModelBooleanInput | null,
  lowBalanceAlertEmail?: ModelBooleanInput | null,
  cardActivationSms?: ModelBooleanInput | null,
  cardActivationEmail?: ModelBooleanInput | null,
  statementReadySms?: ModelBooleanInput | null,
  statementReadyEmail?: ModelBooleanInput | null,
  txnReviewFrequency?: ModelStringInput | null,
  txnReviewCodeUpdateSms?: ModelBooleanInput | null,
  txnReviewCodeUpdateEmail?: ModelBooleanInput | null,
  txnReviewNoteUpdateSms?: ModelBooleanInput | null,
  txnReviewNoteUpdateEmail?: ModelBooleanInput | null,
  txnReviewReceiptUpdateSms?: ModelBooleanInput | null,
  txnReviewReceiptUpdateEmail?: ModelBooleanInput | null,
  txnReviewResubmissionSms?: ModelBooleanInput | null,
  txnReviewResubmissionEmail?: ModelBooleanInput | null,
  txnReviewReadySms?: ModelBooleanInput | null,
  txnReviewReadyEmail?: ModelBooleanInput | null,
  returnedTransactionSms?: ModelBooleanInput | null,
  returnedTransactionEmail?: ModelBooleanInput | null,
  smsConsentAccepted?: ModelBooleanInput | null,
  smsConsentAcceptedAt?: ModelStringInput | null,
  platformAgreementVersion?: ModelStringInput | null,
  hasReceivedWelcomeSms?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserNotificationPreferencesConditionInput | null > | null,
  or?: Array< ModelUserNotificationPreferencesConditionInput | null > | null,
  not?: ModelUserNotificationPreferencesConditionInput | null,
};

export type UserNotificationPreferences = {
  __typename: "UserNotificationPreferences",
  id: string,
  userId: string,
  paidolId?: string | null,
  transactionAlertSms?: boolean | null,
  transactionAlertEmail?: boolean | null,
  cardLockedSms?: boolean | null,
  cardLockedEmail?: boolean | null,
  manualCardActionSms?: boolean | null,
  manualCardActionEmail?: boolean | null,
  lowBalanceAlertSms?: boolean | null,
  lowBalanceAlertEmail?: boolean | null,
  cardActivationSms?: boolean | null,
  cardActivationEmail?: boolean | null,
  statementReadySms?: boolean | null,
  statementReadyEmail?: boolean | null,
  txnReviewFrequency?: string | null,
  txnReviewCodeUpdateSms?: boolean | null,
  txnReviewCodeUpdateEmail?: boolean | null,
  txnReviewNoteUpdateSms?: boolean | null,
  txnReviewNoteUpdateEmail?: boolean | null,
  txnReviewReceiptUpdateSms?: boolean | null,
  txnReviewReceiptUpdateEmail?: boolean | null,
  txnReviewResubmissionSms?: boolean | null,
  txnReviewResubmissionEmail?: boolean | null,
  txnReviewReadySms?: boolean | null,
  txnReviewReadyEmail?: boolean | null,
  returnedTransactionSms?: boolean | null,
  returnedTransactionEmail?: boolean | null,
  smsConsentAccepted?: boolean | null,
  smsConsentAcceptedAt?: string | null,
  platformAgreementVersion?: string | null,
  hasReceivedWelcomeSms?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateUserNotificationPreferencesInput = {
  id: string,
  userId?: string | null,
  paidolId?: string | null,
  transactionAlertSms?: boolean | null,
  transactionAlertEmail?: boolean | null,
  cardLockedSms?: boolean | null,
  cardLockedEmail?: boolean | null,
  manualCardActionSms?: boolean | null,
  manualCardActionEmail?: boolean | null,
  lowBalanceAlertSms?: boolean | null,
  lowBalanceAlertEmail?: boolean | null,
  cardActivationSms?: boolean | null,
  cardActivationEmail?: boolean | null,
  statementReadySms?: boolean | null,
  statementReadyEmail?: boolean | null,
  txnReviewFrequency?: string | null,
  txnReviewCodeUpdateSms?: boolean | null,
  txnReviewCodeUpdateEmail?: boolean | null,
  txnReviewNoteUpdateSms?: boolean | null,
  txnReviewNoteUpdateEmail?: boolean | null,
  txnReviewReceiptUpdateSms?: boolean | null,
  txnReviewReceiptUpdateEmail?: boolean | null,
  txnReviewResubmissionSms?: boolean | null,
  txnReviewResubmissionEmail?: boolean | null,
  txnReviewReadySms?: boolean | null,
  txnReviewReadyEmail?: boolean | null,
  returnedTransactionSms?: boolean | null,
  returnedTransactionEmail?: boolean | null,
  smsConsentAccepted?: boolean | null,
  smsConsentAcceptedAt?: string | null,
  platformAgreementVersion?: string | null,
  hasReceivedWelcomeSms?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type CreateMerchantSpendRuleInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  paymentCards?: Array< string | null > | null,
  merchantCountrySpendRuleId?: string | null,
  merchantCategorySpendRuleId?: string | null,
  amountLimitSpendRuleId?: string | null,
  monthlyLimitSpendRuleId?: string | null,
  monthlyLimitCumulativeRuleId?: string | null,
  maximumAmount?: HNAmountInput | null,
  monthlyLimitAmount?: HNAmountInput | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  monthlyLimitResetTimestamp?: string | null,
};

export type ModelMerchantSpendRuleConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  paymentCards?: ModelStringInput | null,
  merchantCountrySpendRuleId?: ModelIDInput | null,
  merchantCategorySpendRuleId?: ModelIDInput | null,
  amountLimitSpendRuleId?: ModelIDInput | null,
  monthlyLimitSpendRuleId?: ModelIDInput | null,
  monthlyLimitCumulativeRuleId?: ModelIDInput | null,
  merchantCategoryAllowed?: ModelStringInput | null,
  merchantCategoryBlocked?: ModelStringInput | null,
  merchantCountryAllowed?: ModelStringInput | null,
  merchantCountryBlocked?: ModelStringInput | null,
  monthlyLimitResetTimestamp?: ModelStringInput | null,
  and?: Array< ModelMerchantSpendRuleConditionInput | null > | null,
  or?: Array< ModelMerchantSpendRuleConditionInput | null > | null,
  not?: ModelMerchantSpendRuleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateMerchantSpendRuleInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  paymentCards?: Array< string | null > | null,
  merchantCountrySpendRuleId?: string | null,
  merchantCategorySpendRuleId?: string | null,
  amountLimitSpendRuleId?: string | null,
  monthlyLimitSpendRuleId?: string | null,
  monthlyLimitCumulativeRuleId?: string | null,
  maximumAmount?: HNAmountInput | null,
  monthlyLimitAmount?: HNAmountInput | null,
  merchantCategoryAllowed?: Array< string | null > | null,
  merchantCategoryBlocked?: Array< string | null > | null,
  merchantCountryAllowed?: Array< string | null > | null,
  merchantCountryBlocked?: Array< string | null > | null,
  monthlyLimitResetTimestamp?: string | null,
};

export type DeleteMerchantSpendRuleInput = {
  id: string,
};

export type CreateTransactionsDownloadQueueInput = {
  id?: string | null,
  user_id: string,
  paidol_id: string,
  range_option: ExportDateRangeEnum,
  start_date?: string | null,
  end_date?: string | null,
  columns: Array< string >,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt?: string | null,
  paidolUserId?: string | null,
  mark_as_exported?: boolean | null,
  exported_count?: number | null,
  skipped_count?: number | null,
};

export enum ExportDateRangeEnum {
  // Start date equal to current date at 00:00:00.000
  // End date equal to current date at 23:59:59.999
  TODAY = "TODAY",
  // Start date equal to current date - 1 day at 00:00:00.000
  // End date equal to current date - 1 day at 23:59:59.999
  YESTERDAY = "YESTERDAY",
  // Start date equal to current date - 7 days at 00:00:00.000
  // End date equal to current date at 23:59:59.999
  LAST_SEVEN_DAYS = "LAST_SEVEN_DAYS",
  // Start date equal to first day of the current month at 00:00:00.000
  // End date equal to current date at 23:59:59.999
  MONTH_TO_DATE = "MONTH_TO_DATE",
  // Start date equal to first day of the previous month at 00:00:00.000
  // End date equal to last day of the previous month at 23:59:59.999
  LAST_MONTH = "LAST_MONTH",
  // Start date equal to first day of the current year at 00:00:00.000
  // End date equal to current date at 23:59:59.999
  YEAR_TO_DATE = "YEAR_TO_DATE",
  // Start date equal to first day of the previous year at 00:00:00.000
  // End date equal to last day of the previous year at 23:59:59.999
  LAST_YEAR = "LAST_YEAR",
  // Start date equal to the date provided at 00:00:00.000
  // End date equal to the date provided at 23:59:59.999
  CUSTOM_RANGE = "CUSTOM_RANGE",
}


export type ModelTransactionsDownloadQueueConditionInput = {
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  range_option?: ModelExportDateRangeEnumInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  columns?: ModelStringInput | null,
  s3_key?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  createdAt?: ModelStringInput | null,
  paidolUserId?: ModelIDInput | null,
  mark_as_exported?: ModelBooleanInput | null,
  exported_count?: ModelIntInput | null,
  skipped_count?: ModelIntInput | null,
  and?: Array< ModelTransactionsDownloadQueueConditionInput | null > | null,
  or?: Array< ModelTransactionsDownloadQueueConditionInput | null > | null,
  not?: ModelTransactionsDownloadQueueConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelExportDateRangeEnumInput = {
  eq?: ExportDateRangeEnum | null,
  ne?: ExportDateRangeEnum | null,
};

export type TransactionsDownloadQueue = {
  __typename: "TransactionsDownloadQueue",
  id: string,
  user_id: string,
  paidol_id: string,
  range_option: ExportDateRangeEnum,
  start_date?: string | null,
  end_date?: string | null,
  columns: Array< string >,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt: string,
  paidolUserId?: string | null,
  mark_as_exported?: boolean | null,
  exported_count?: number | null,
  skipped_count?: number | null,
  updatedAt: string,
};

export type UpdateTransactionsDownloadQueueInput = {
  id: string,
  user_id?: string | null,
  paidol_id?: string | null,
  range_option?: ExportDateRangeEnum | null,
  start_date?: string | null,
  end_date?: string | null,
  columns?: Array< string > | null,
  s3_key?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  createdAt?: string | null,
  paidolUserId?: string | null,
  mark_as_exported?: boolean | null,
  exported_count?: number | null,
  skipped_count?: number | null,
};

export type DeleteTransactionsDownloadQueueInput = {
  id: string,
};

export type CreateTransactionsReceiptsDownloadQueueInput = {
  id?: string | null,
  user_id: string,
  paidol_id: string,
  paidolUserId?: string | null,
  s3_key?: string | null,
  range_option?: ExportDateRangeEnum | null,
  start_date?: string | null,
  end_date?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  error_code?: string | null,
  createdAt?: string | null,
  filteredTransactionIds?: Array< string | null > | null,
};

export type ModelTransactionsReceiptsDownloadQueueConditionInput = {
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  paidolUserId?: ModelIDInput | null,
  s3_key?: ModelStringInput | null,
  range_option?: ModelExportDateRangeEnumInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  error_code?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  filteredTransactionIds?: ModelStringInput | null,
  and?: Array< ModelTransactionsReceiptsDownloadQueueConditionInput | null > | null,
  or?: Array< ModelTransactionsReceiptsDownloadQueueConditionInput | null > | null,
  not?: ModelTransactionsReceiptsDownloadQueueConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TransactionsReceiptsDownloadQueue = {
  __typename: "TransactionsReceiptsDownloadQueue",
  id: string,
  user_id: string,
  paidol_id: string,
  paidolUserId?: string | null,
  s3_key?: string | null,
  range_option?: ExportDateRangeEnum | null,
  start_date?: string | null,
  end_date?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
  // EXPORT_FAILED) so the frontend can show an honest message instead of a
  // generic "no receipts found".
  error_code?: string | null,
  createdAt: string,
  filteredTransactionIds?: Array< string | null > | null,
  updatedAt: string,
};

export type UpdateTransactionsReceiptsDownloadQueueInput = {
  id: string,
  user_id?: string | null,
  paidol_id?: string | null,
  paidolUserId?: string | null,
  s3_key?: string | null,
  range_option?: ExportDateRangeEnum | null,
  start_date?: string | null,
  end_date?: string | null,
  cron_status?: PaymentStatusDownloadStatusEnum | null,
  error_code?: string | null,
  createdAt?: string | null,
  filteredTransactionIds?: Array< string | null > | null,
};

export type DeleteTransactionsReceiptsDownloadQueueInput = {
  id: string,
};

export type CreateSpendRuleConfigInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  ruleId: string,
  ruleType: SpendRuleType,
};

export enum SpendRuleType {
  HNAmountLimitSpendRule = "HNAmountLimitSpendRule",
  HNMerchantCategorySpendRule = "HNMerchantCategorySpendRule",
  HNMerchantCountrySpendRule = "HNMerchantCountrySpendRule",
  HNCVVSpendRule = "HNCVVSpendRule",
  HNStreetAddressSpendRule = "HNStreetAddressSpendRule",
  HNCountLimitSpendRule = "HNCountLimitSpendRule",
  HNMerchantIdentifierSpendRule = "HNMerchantIdentifierSpendRule",
  HNPointOfServiceCategorySpendRule = "HNPointOfServiceCategorySpendRule",
}


export type ModelSpendRuleConfigConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  ruleId?: ModelIDInput | null,
  ruleType?: ModelSpendRuleTypeInput | null,
  and?: Array< ModelSpendRuleConfigConditionInput | null > | null,
  or?: Array< ModelSpendRuleConfigConditionInput | null > | null,
  not?: ModelSpendRuleConfigConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSpendRuleTypeInput = {
  eq?: SpendRuleType | null,
  ne?: SpendRuleType | null,
};

export type SpendRuleConfig = {
  __typename: "SpendRuleConfig",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  ruleId: string,
  ruleType: SpendRuleType,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSpendRuleConfigInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  ruleId?: string | null,
  ruleType?: SpendRuleType | null,
};

export type DeleteSpendRuleConfigInput = {
  id: string,
};

export type CreateJobCodeImportInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  createdAt?: string | null,
  storageFileKey: string,
  fileName: string,
  status: JobCodeImportStatus,
  errors?: string | null,
};

export type ModelJobCodeImportConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelJobCodeImportStatusInput | null,
  errors?: ModelStringInput | null,
  and?: Array< ModelJobCodeImportConditionInput | null > | null,
  or?: Array< ModelJobCodeImportConditionInput | null > | null,
  not?: ModelJobCodeImportConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelJobCodeImportStatusInput = {
  eq?: JobCodeImportStatus | null,
  ne?: JobCodeImportStatus | null,
};

export type UpdateJobCodeImportInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  createdAt?: string | null,
  storageFileKey?: string | null,
  fileName?: string | null,
  status?: JobCodeImportStatus | null,
  errors?: string | null,
};

export type DeleteJobCodeImportInput = {
  id: string,
};

export type CreateJobCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  description: string,
  code: string,
  isActive: boolean,
  budget?: number | null,
  jobCodeImportId: string,
};

export type ModelJobCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  code?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  budget?: ModelFloatInput | null,
  jobCodeImportId?: ModelIDInput | null,
  and?: Array< ModelJobCodeConditionInput | null > | null,
  or?: Array< ModelJobCodeConditionInput | null > | null,
  not?: ModelJobCodeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateJobCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  description?: string | null,
  code?: string | null,
  isActive?: boolean | null,
  budget?: number | null,
  jobCodeImportId?: string | null,
};

export type DeleteJobCodeInput = {
  id: string,
};

export type CreateFlexCodeImportInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  storageFileKey: string,
  fileName: string,
  status: FlexCodeImportStatus,
  errors?: string | null,
  searchSynced?: boolean | null,
  type: FlexCodeImportType,
};

export type ModelFlexCodeImportConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelFlexCodeImportStatusInput | null,
  errors?: ModelStringInput | null,
  searchSynced?: ModelBooleanInput | null,
  type?: ModelFlexCodeImportTypeInput | null,
  and?: Array< ModelFlexCodeImportConditionInput | null > | null,
  or?: Array< ModelFlexCodeImportConditionInput | null > | null,
  not?: ModelFlexCodeImportConditionInput | null,
};

export type ModelFlexCodeImportStatusInput = {
  eq?: FlexCodeImportStatus | null,
  ne?: FlexCodeImportStatus | null,
};

export type ModelFlexCodeImportTypeInput = {
  eq?: FlexCodeImportType | null,
  ne?: FlexCodeImportType | null,
};

export type UpdateFlexCodeImportInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  storageFileKey?: string | null,
  fileName?: string | null,
  status?: FlexCodeImportStatus | null,
  errors?: string | null,
  searchSynced?: boolean | null,
  type?: FlexCodeImportType | null,
};

export type DeleteFlexCodeImportInput = {
  id: string,
};

export type CreateV2FlexRelationshipsInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  flexGlCodeId?: string | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexVendorId?: string | null,
  flexCodeImportId: string,
  flexGlCodeName?: string | null,
  projectName?: string | null,
  projectCode?: string | null,
  flexCostCodeName?: string | null,
  flexCostTypeName?: string | null,
  flexVendorName?: string | null,
};

export type ModelV2FlexRelationshipsConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  flexCodeImportId?: ModelIDInput | null,
  flexGlCodeName?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  projectCode?: ModelStringInput | null,
  flexCostCodeName?: ModelStringInput | null,
  flexCostTypeName?: ModelStringInput | null,
  flexVendorName?: ModelStringInput | null,
  and?: Array< ModelV2FlexRelationshipsConditionInput | null > | null,
  or?: Array< ModelV2FlexRelationshipsConditionInput | null > | null,
  not?: ModelV2FlexRelationshipsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type V2FlexRelationships = {
  __typename: "V2FlexRelationships",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  flexGlCodeId?: string | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexVendorId?: string | null,
  flexCodeImportId: string,
  // Denormalized entity names cached at import time so the dropdown handlers can sort,
  // search, and display directly off this index without a second query against the entity
  // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
  // fields are a read-time cache for the dropdown query path only.
  flexGlCodeName?: string | null,
  projectName?: string | null,
  projectCode?: string | null,
  flexCostCodeName?: string | null,
  flexCostTypeName?: string | null,
  flexVendorName?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateV2FlexRelationshipsInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  flexGlCodeId?: string | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexVendorId?: string | null,
  flexCodeImportId?: string | null,
  flexGlCodeName?: string | null,
  projectName?: string | null,
  projectCode?: string | null,
  flexCostCodeName?: string | null,
  flexCostTypeName?: string | null,
  flexVendorName?: string | null,
};

export type DeleteV2FlexRelationshipsInput = {
  id: string,
};

export type CreateFlexGlCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
};

export type ModelFlexGlCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  and?: Array< ModelFlexGlCodeConditionInput | null > | null,
  or?: Array< ModelFlexGlCodeConditionInput | null > | null,
  not?: ModelFlexGlCodeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateFlexGlCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  flexCodeImportId?: string | null,
};

export type DeleteFlexGlCodeInput = {
  id: string,
};

export type CreateFlexCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  projectName: string,
  projectCode?: string | null,
  isActive: boolean,
  flexCodeImportId: string,
};

export type ModelFlexCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  projectCode?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  flexCodeImportId?: ModelIDInput | null,
  and?: Array< ModelFlexCodeConditionInput | null > | null,
  or?: Array< ModelFlexCodeConditionInput | null > | null,
  not?: ModelFlexCodeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateFlexCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  projectName?: string | null,
  projectCode?: string | null,
  isActive?: boolean | null,
  flexCodeImportId?: string | null,
};

export type DeleteFlexCodeInput = {
  id: string,
};

export type CreateFlexCostCodeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  code: string,
  flexCodeImportId: string,
};

export type ModelFlexCostCodeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  and?: Array< ModelFlexCostCodeConditionInput | null > | null,
  or?: Array< ModelFlexCostCodeConditionInput | null > | null,
  not?: ModelFlexCostCodeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateFlexCostCodeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  code?: string | null,
  flexCodeImportId?: string | null,
};

export type DeleteFlexCostCodeInput = {
  id: string,
};

export type CreateFlexCostTypeInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
};

export type ModelFlexCostTypeConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  and?: Array< ModelFlexCostTypeConditionInput | null > | null,
  or?: Array< ModelFlexCostTypeConditionInput | null > | null,
  not?: ModelFlexCostTypeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateFlexCostTypeInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  flexCodeImportId?: string | null,
};

export type DeleteFlexCostTypeInput = {
  id: string,
};

export type CreateFlexVendorInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  flexCodeImportId: string,
};

export type ModelFlexVendorConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  and?: Array< ModelFlexVendorConditionInput | null > | null,
  or?: Array< ModelFlexVendorConditionInput | null > | null,
  not?: ModelFlexVendorConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateFlexVendorInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  flexCodeImportId?: string | null,
};

export type DeleteFlexVendorInput = {
  id: string,
};

export type CreateFlexFieldInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  name: string,
  alias?: string | null,
  order?: number | null,
  source: FlexFieldSource,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

// Flex Field v2 types — abstract, extensible field system.
// These coexist with the existing FlexCode/FlexGlCode/etc. types above.
export enum FlexFieldSource {
  UPLOAD = "UPLOAD",
  MANUAL = "MANUAL",
}


export type ModelFlexFieldConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  alias?: ModelStringInput | null,
  order?: ModelIntInput | null,
  source?: ModelFlexFieldSourceInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldConditionInput | null > | null,
  or?: Array< ModelFlexFieldConditionInput | null > | null,
  not?: ModelFlexFieldConditionInput | null,
};

export type ModelFlexFieldSourceInput = {
  eq?: FlexFieldSource | null,
  ne?: FlexFieldSource | null,
};

export type FlexField = {
  __typename: "FlexField",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  name: string,
  alias?: string | null,
  order?: number | null,
  source: FlexFieldSource,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFlexFieldInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  name?: string | null,
  alias?: string | null,
  order?: number | null,
  source?: FlexFieldSource | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteFlexFieldInput = {
  id: string,
};

export type CreateFlexFieldValueInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  flexFieldId: string,
  externalId?: string | null,
  value: string,
  status: FlexFieldValueStatus,
  flexFieldUploadId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum FlexFieldValueStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type ModelFlexFieldValueConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexFieldId?: ModelIDInput | null,
  externalId?: ModelStringInput | null,
  value?: ModelStringInput | null,
  status?: ModelFlexFieldValueStatusInput | null,
  flexFieldUploadId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldValueConditionInput | null > | null,
  or?: Array< ModelFlexFieldValueConditionInput | null > | null,
  not?: ModelFlexFieldValueConditionInput | null,
};

export type ModelFlexFieldValueStatusInput = {
  eq?: FlexFieldValueStatus | null,
  ne?: FlexFieldValueStatus | null,
};

export type FlexFieldValue = {
  __typename: "FlexFieldValue",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  flexFieldId: string,
  externalId?: string | null,
  value: string,
  status: FlexFieldValueStatus,
  flexFieldUploadId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFlexFieldValueInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  flexFieldId?: string | null,
  externalId?: string | null,
  value?: string | null,
  status?: FlexFieldValueStatus | null,
  flexFieldUploadId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteFlexFieldValueInput = {
  id: string,
};

export type CreateFlexFieldUploadInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  flexFieldId: string,
  storageFileKey: string,
  fileName: string,
  status: FlexFieldUploadStatus,
  errors?: string | null,
  rowCount?: number | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum FlexFieldUploadStatus {
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}


export type ModelFlexFieldUploadConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexFieldId?: ModelIDInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelFlexFieldUploadStatusInput | null,
  errors?: ModelStringInput | null,
  rowCount?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldUploadConditionInput | null > | null,
  or?: Array< ModelFlexFieldUploadConditionInput | null > | null,
  not?: ModelFlexFieldUploadConditionInput | null,
};

export type ModelFlexFieldUploadStatusInput = {
  eq?: FlexFieldUploadStatus | null,
  ne?: FlexFieldUploadStatus | null,
};

export type FlexFieldUpload = {
  __typename: "FlexFieldUpload",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  flexFieldId: string,
  storageFileKey: string,
  fileName: string,
  status: FlexFieldUploadStatus,
  errors?: string | null,
  rowCount?: number | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFlexFieldUploadInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  flexFieldId?: string | null,
  storageFileKey?: string | null,
  fileName?: string | null,
  status?: FlexFieldUploadStatus | null,
  errors?: string | null,
  rowCount?: number | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteFlexFieldUploadInput = {
  id: string,
};

export type CreateStatementSummaryInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  startDate: string,
  endDate: string,
  statementBalance: number,
  paymentDueDate?: string | null,
  pdfLink: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelStatementSummaryConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  statementBalance?: ModelIntInput | null,
  paymentDueDate?: ModelStringInput | null,
  pdfLink?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStatementSummaryConditionInput | null > | null,
  or?: Array< ModelStatementSummaryConditionInput | null > | null,
  not?: ModelStatementSummaryConditionInput | null,
};

export type StatementSummary = {
  __typename: "StatementSummary",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  startDate: string,
  endDate: string,
  statementBalance: number,
  paymentDueDate?: string | null,
  pdfLink: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateStatementSummaryInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  statementBalance?: number | null,
  paymentDueDate?: string | null,
  pdfLink?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteStatementSummaryInput = {
  id: string,
};

export type CreateAutoPaymentInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  amountType: AutoPayAmountType,
  fixedAmountCents?: number | null,
  paymentDayOfMonth: number,
  externalBankAccountId: string,
  financialAccountId: string,
  active: boolean,
  createdBy: string,
  updatedBy?: string | null,
};

export enum AutoPayAmountType {
  STATEMENT_BALANCE = "STATEMENT_BALANCE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
}


export type ModelAutoPaymentConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  amountType?: ModelAutoPayAmountTypeInput | null,
  fixedAmountCents?: ModelIntInput | null,
  paymentDayOfMonth?: ModelIntInput | null,
  externalBankAccountId?: ModelStringInput | null,
  financialAccountId?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  and?: Array< ModelAutoPaymentConditionInput | null > | null,
  or?: Array< ModelAutoPaymentConditionInput | null > | null,
  not?: ModelAutoPaymentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAutoPayAmountTypeInput = {
  eq?: AutoPayAmountType | null,
  ne?: AutoPayAmountType | null,
};

export type AutoPayment = {
  __typename: "AutoPayment",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  amountType: AutoPayAmountType,
  fixedAmountCents?: number | null,
  paymentDayOfMonth: number,
  externalBankAccountId: string,
  financialAccountId: string,
  active: boolean,
  createdBy: string,
  updatedBy?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAutoPaymentInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  amountType?: AutoPayAmountType | null,
  fixedAmountCents?: number | null,
  paymentDayOfMonth?: number | null,
  externalBankAccountId?: string | null,
  financialAccountId?: string | null,
  active?: boolean | null,
  createdBy?: string | null,
  updatedBy?: string | null,
};

export type DeleteAutoPaymentInput = {
  id: string,
};

export type CreateTransactionFilterOptionsInput = {
  paidolId: string,
  authPaidolId: string,
  last4?: Array< string > | null,
  userId?: Array< FilterOptionInput > | null,
  merchantName?: Array< FilterOptionInput > | null,
  merchantCategory?: Array< FilterOptionInput > | null,
  cardGroup?: Array< FilterOptionInput > | null,
  projectGroup?: Array< FilterOptionInput > | null,
  receiptStatus?: Array< FilterOptionInput > | null,
  highnoteTransactionStatus?: Array< FilterOptionInput > | null,
  flexCodeTransactionStatus?: Array< FilterOptionInput > | null,
  flexGlCodeIds?: Array< FilterOptionInput > | null,
  flexCodeIds?: Array< FilterOptionInput > | null,
  flexCostCodeIds?: Array< FilterOptionInput > | null,
  flexCostTypeIds?: Array< FilterOptionInput > | null,
  flexVendorIds?: Array< FilterOptionInput > | null,
  agaveTransactionStatus?: Array< FilterOptionInput > | null,
  agaveGlCodeIds?: Array< FilterOptionInput > | null,
  agaveProjectIds?: Array< FilterOptionInput > | null,
  agaveCostCodeIds?: Array< FilterOptionInput > | null,
  agaveCostTypeIds?: Array< FilterOptionInput > | null,
  agaveVendorIds?: Array< FilterOptionInput > | null,
  agaveLocationIds?: Array< FilterOptionInput > | null,
  agaveDepartmentIds?: Array< FilterOptionInput > | null,
  agaveSubaccountIds?: Array< FilterOptionInput > | null,
  agaveSubJobIds?: Array< FilterOptionInput > | null,
  agaveEquipmentIds?: Array< FilterOptionInput > | null,
  agaveEmCostCodeIds?: Array< FilterOptionInput > | null,
  agaveEmCostTypeIds?: Array< FilterOptionInput > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type FilterOptionInput = {
  id: string,
  label: string,
};

export type ModelTransactionFilterOptionsConditionInput = {
  authPaidolId?: ModelIDInput | null,
  last4?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionFilterOptionsConditionInput | null > | null,
  or?: Array< ModelTransactionFilterOptionsConditionInput | null > | null,
  not?: ModelTransactionFilterOptionsConditionInput | null,
};

export type TransactionFilterOptions = {
  __typename: "TransactionFilterOptions",
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  last4?: Array< string > | null,
  userId?:  Array<FilterOption > | null,
  merchantName?:  Array<FilterOption > | null,
  merchantCategory?:  Array<FilterOption > | null,
  cardGroup?:  Array<FilterOption > | null,
  projectGroup?:  Array<FilterOption > | null,
  receiptStatus?:  Array<FilterOption > | null,
  highnoteTransactionStatus?:  Array<FilterOption > | null,
  flexCodeTransactionStatus?:  Array<FilterOption > | null,
  flexGlCodeIds?:  Array<FilterOption > | null,
  flexCodeIds?:  Array<FilterOption > | null,
  flexCostCodeIds?:  Array<FilterOption > | null,
  flexCostTypeIds?:  Array<FilterOption > | null,
  flexVendorIds?:  Array<FilterOption > | null,
  agaveTransactionStatus?:  Array<FilterOption > | null,
  agaveGlCodeIds?:  Array<FilterOption > | null,
  agaveProjectIds?:  Array<FilterOption > | null,
  agaveCostCodeIds?:  Array<FilterOption > | null,
  agaveCostTypeIds?:  Array<FilterOption > | null,
  agaveVendorIds?:  Array<FilterOption > | null,
  agaveLocationIds?:  Array<FilterOption > | null,
  agaveDepartmentIds?:  Array<FilterOption > | null,
  agaveSubaccountIds?:  Array<FilterOption > | null,
  agaveSubJobIds?:  Array<FilterOption > | null,
  agaveEquipmentIds?:  Array<FilterOption > | null,
  agaveEmCostCodeIds?:  Array<FilterOption > | null,
  agaveEmCostTypeIds?:  Array<FilterOption > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateTransactionFilterOptionsInput = {
  paidolId: string,
  authPaidolId?: string | null,
  last4?: Array< string > | null,
  userId?: Array< FilterOptionInput > | null,
  merchantName?: Array< FilterOptionInput > | null,
  merchantCategory?: Array< FilterOptionInput > | null,
  cardGroup?: Array< FilterOptionInput > | null,
  projectGroup?: Array< FilterOptionInput > | null,
  receiptStatus?: Array< FilterOptionInput > | null,
  highnoteTransactionStatus?: Array< FilterOptionInput > | null,
  flexCodeTransactionStatus?: Array< FilterOptionInput > | null,
  flexGlCodeIds?: Array< FilterOptionInput > | null,
  flexCodeIds?: Array< FilterOptionInput > | null,
  flexCostCodeIds?: Array< FilterOptionInput > | null,
  flexCostTypeIds?: Array< FilterOptionInput > | null,
  flexVendorIds?: Array< FilterOptionInput > | null,
  agaveTransactionStatus?: Array< FilterOptionInput > | null,
  agaveGlCodeIds?: Array< FilterOptionInput > | null,
  agaveProjectIds?: Array< FilterOptionInput > | null,
  agaveCostCodeIds?: Array< FilterOptionInput > | null,
  agaveCostTypeIds?: Array< FilterOptionInput > | null,
  agaveVendorIds?: Array< FilterOptionInput > | null,
  agaveLocationIds?: Array< FilterOptionInput > | null,
  agaveDepartmentIds?: Array< FilterOptionInput > | null,
  agaveSubaccountIds?: Array< FilterOptionInput > | null,
  agaveSubJobIds?: Array< FilterOptionInput > | null,
  agaveEquipmentIds?: Array< FilterOptionInput > | null,
  agaveEmCostCodeIds?: Array< FilterOptionInput > | null,
  agaveEmCostTypeIds?: Array< FilterOptionInput > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteTransactionFilterOptionsInput = {
  paidolId: string,
};

export type CreateHighnoteDisputeEventInput = {
  id?: string | null,
  disputeId: string,
  paidolId: string,
  paymentCardId: string,
  transactionEventId: string,
  amount?: HNAmountInput | null,
  enableListing: boolean,
  status: string,
  creditStatus?: string | null,
  category?: string | null,
  liability?: string | null,
  eventType: string,
  eventDate: string,
  source: string,
};

export type ModelHighnoteDisputeEventConditionInput = {
  disputeId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  paymentCardId?: ModelIDInput | null,
  transactionEventId?: ModelIDInput | null,
  enableListing?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  creditStatus?: ModelStringInput | null,
  category?: ModelStringInput | null,
  liability?: ModelStringInput | null,
  eventType?: ModelStringInput | null,
  eventDate?: ModelStringInput | null,
  source?: ModelStringInput | null,
  and?: Array< ModelHighnoteDisputeEventConditionInput | null > | null,
  or?: Array< ModelHighnoteDisputeEventConditionInput | null > | null,
  not?: ModelHighnoteDisputeEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type HighnoteDisputeEvent = {
  __typename: "HighnoteDisputeEvent",
  id: string,
  disputeId: string,
  paidolId: string,
  paymentCardId: string,
  transactionEventId: string,
  amount?: HNAmount | null,
  enableListing: boolean,
  status: string,
  creditStatus?: string | null,
  category?: string | null,
  liability?: string | null,
  eventType: string,
  eventDate: string,
  source: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateHighnoteDisputeEventInput = {
  id: string,
  disputeId?: string | null,
  paidolId?: string | null,
  paymentCardId?: string | null,
  transactionEventId?: string | null,
  amount?: HNAmountInput | null,
  enableListing?: boolean | null,
  status?: string | null,
  creditStatus?: string | null,
  category?: string | null,
  liability?: string | null,
  eventType?: string | null,
  eventDate?: string | null,
  source?: string | null,
};

export type DeleteHighnoteDisputeEventInput = {
  id: string,
};

export type CreateHighnoteTransactionEventInput = {
  id?: string | null,
  transactionId: string,
  paymentCardId: string,
  paidolId: string,
  reconciliationId?: string | null,
  authPaidolId: string,
  eventDate: string,
  processedAt?: string | null,
  origin: string,
  status: HighnoteTransactionStatus,
  partial?: boolean | null,
  settlementImpact?: boolean | null,
  approvedAmount: HNAmountInput,
  fees?: Array< HNAmountInput | null > | null,
  approvedAmountValue?: number | null,
  approvedAmountCurrencyCode?: string | null,
  eventData?: string | null,
  transactionOldState?: string | null,
  transactionNewState?: string | null,
  enableListing?: boolean | null,
  email?: string | null,
  userId?: string | null,
  last4?: string | null,
  groupApprovalLevels?: number | null,
  owningProjectGroupIds?: Array< string | null > | null,
  cardGroupId?: string | null,
  merchantCategory?: string | null,
  merchantCategoryCode?: string | null,
  merchantName?: string | null,
  jobCodeId?: string | null,
  flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
  workflowStatus?: WorkflowStatus | null,
  returnedStatus?: ReturnedStatus | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexGlCodeId?: string | null,
  flexVendorId?: string | null,
  agaveDepartmentId?: string | null,
  agaveLocationId?: string | null,
  agaveSubaccountId?: string | null,
  agaveEmployeeId?: string | null,
  agaveExpense?: CreateAgaveExpenseAPInvoiceInput | null,
  agaveExpenseId?: string | null,
  agaveProjectId?: string | null,
  agaveCostCodeId?: string | null,
  agaveCostTypeId?: string | null,
  agaveGlCodeId?: string | null,
  agaveVendorId?: string | null,
  agaveSubJobId?: string | null,
  agaveEquipmentId?: string | null,
  agaveEmCostCodeId?: string | null,
  agaveEmCostTypeId?: string | null,
  codingType?: string | null,
  accountingDate?: string | null,
  procoreDirectCostId?: number | null,
  procoreDirectCostLineItemId?: number | null,
  procoreProject?: GetProcoreProjectsPayloadInput | null,
  procoreProjectId?: number | null,
  procoreWBSCode?: GetProcoreWBSCodesPayloadInput | null,
  procoreWBSCodeId?: number | null,
  erpApprovalStatus?: boolean | null,
  erpBypassStatus?: boolean | null,
  erpBillableItemId?: string | null,
  erpBillableItemName?: string | null,
  erpBillable?: boolean | null,
  erpPostingStatus?: ERPPostingStatus | null,
  erpPostingError?: string | null,
  erpPostingWarning?: string | null,
  sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
  sage300APInvoiceError?: string | null,
  note?: string | null,
  approveWithoutNotes?: boolean | null,
  receiptPath?: string | null,
  receiptId?: string | null,
  hasReceipt?: boolean | null,
  approveWithoutReceipts?: boolean | null,
  fuelVehicleId?: string | null,
  fuelOdometerReading?: number | null,
  fuelGallons?: number | null,
  fuelCostPerGallon?: number | null,
  codedAt?: string | null,
  codingMethod?: string | null,
  receiptUploadedAt?: string | null,
  receiptUploadMethod?: string | null,
  erpExportedAt?: string | null,
  erpExportBatchId?: string | null,
};

export type CreateAgaveExpenseAPInvoiceInput = {
  id: string,
  source_id?: string | null,
  amount?: string | null,
  amount_due?: string | null,
  ap_payment_ids?: Array< string | null > | null,
  attachments?: Array< CreateAgaveExpenseAttachmentInput | null > | null,
  batch?: string | null,
  batch_id?: string | null,
  contract?: CreateAgaveExpenseContractInput | null,
  creator_id?: string | null,
  currency_code?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  discount_date?: string | null,
  due_date?: string | null,
  issue_date?: string | null,
  line_items?: Array< CreateAgaveExpenseAPInvoiceLineItemInput | null > | null,
  misc_amount?: string | null,
  net_amount?: string | null,
  number?: string | null,
  project_id?: string | null,
  retention_amount?: string | null,
  retention_percent?: string | null,
  status?: string | null,
  subtotal_amount?: string | null,
  tax_amount?: string | null,
  total_amount?: string | null,
  type?: string | null,
  vendor_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: CreateAgaveExpenseAPInvoiceSourceDataInput | null,
};

export type CreateAgaveExpenseAttachmentInput = {
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
  url?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type CreateAgaveExpenseContractInput = {
  id?: string | null,
  line_item_id?: string | null,
  type?: CreateAgaveExpenseContractTypeInput | null,
};

export enum CreateAgaveExpenseContractTypeInput {
  purchase_order = "purchase_order",
  subcontract = "subcontract",
}


export type CreateAgaveExpenseAPInvoiceLineItemInput = {
  id?: string | null,
  source_id?: string | null,
  amount?: string | null,
  change_order?: CreateAgaveExpenseChangeOrderInput | null,
  contract?: CreateAgaveExpenseContractInput | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  customer_id?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  item_id?: string | null,
  ledger_account_id?: string | null,
  project_id?: string | null,
  quantity?: string | null,
  retention_amount?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  tax_amount?: string | null,
  tax_code_id?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_of_measure?: string | null,
  vendor_id?: string | null,
  wbs_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type CreateAgaveExpenseChangeOrderInput = {
  id?: string | null,
  line_item_id?: string | null,
};

export type CreateAgaveExpenseAPInvoiceSourceDataInput = {
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type GetProcoreProjectsPayloadInput = {
  id: number,
  active: boolean,
  display_name: string,
  name: string,
  created_at: string,
  start_date?: string | null,
  completion_date?: string | null,
  project_number?: string | null,
  project_stage?: ProcoreProjectStageInput | null,
  project_template?: ProcoreProjectTemplateInput | null,
  total_value?: string | null,
};

export type ProcoreProjectStageInput = {
  id: number,
  name: string,
};

export type ProcoreProjectTemplateInput = {
  id: number,
  name: string,
};

export type GetProcoreWBSCodesPayloadInput = {
  id: number,
  flat_code?: string | null,
  flat_name?: string | null,
  description?: string | null,
  status?: string | null,
  segment_items?: Array< ProcoreSegmentItemInput > | null,
};

export type ProcoreSegmentItemInput = {
  id: number,
  code?: string | null,
  name?: string | null,
  status?: string | null,
  segment?: ProcoreSegmentInput | null,
};

export type ProcoreSegmentInput = {
  id: number,
  name?: string | null,
  type?: string | null,
};

export type ModelHighnoteTransactionEventConditionInput = {
  transactionId?: ModelIDInput | null,
  paymentCardId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  reconciliationId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  eventDate?: ModelStringInput | null,
  processedAt?: ModelStringInput | null,
  origin?: ModelStringInput | null,
  status?: ModelHighnoteTransactionStatusInput | null,
  partial?: ModelBooleanInput | null,
  settlementImpact?: ModelBooleanInput | null,
  approvedAmountValue?: ModelIntInput | null,
  approvedAmountCurrencyCode?: ModelStringInput | null,
  eventData?: ModelStringInput | null,
  transactionOldState?: ModelStringInput | null,
  transactionNewState?: ModelStringInput | null,
  enableListing?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  last4?: ModelStringInput | null,
  groupApprovalLevels?: ModelIntInput | null,
  owningProjectGroupIds?: ModelStringInput | null,
  cardGroupId?: ModelIDInput | null,
  merchantCategory?: ModelStringInput | null,
  merchantCategoryCode?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  jobCodeId?: ModelIDInput | null,
  flexCodeTransactionStatus?: ModelFlexCodeTransactionStatusInput | null,
  workflowStatus?: ModelWorkflowStatusInput | null,
  returnedStatus?: ModelReturnedStatusInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  agaveDepartmentId?: ModelIDInput | null,
  agaveLocationId?: ModelIDInput | null,
  agaveSubaccountId?: ModelIDInput | null,
  agaveEmployeeId?: ModelIDInput | null,
  agaveExpenseId?: ModelIDInput | null,
  agaveProjectId?: ModelIDInput | null,
  agaveCostCodeId?: ModelIDInput | null,
  agaveCostTypeId?: ModelIDInput | null,
  agaveGlCodeId?: ModelIDInput | null,
  agaveVendorId?: ModelIDInput | null,
  agaveSubJobId?: ModelIDInput | null,
  agaveEquipmentId?: ModelIDInput | null,
  agaveEmCostCodeId?: ModelIDInput | null,
  agaveEmCostTypeId?: ModelIDInput | null,
  codingType?: ModelStringInput | null,
  accountingDate?: ModelStringInput | null,
  procoreDirectCostId?: ModelFloatInput | null,
  procoreDirectCostLineItemId?: ModelFloatInput | null,
  procoreProjectId?: ModelFloatInput | null,
  procoreWBSCodeId?: ModelFloatInput | null,
  erpApprovalStatus?: ModelBooleanInput | null,
  erpBypassStatus?: ModelBooleanInput | null,
  erpBillableItemId?: ModelStringInput | null,
  erpBillableItemName?: ModelStringInput | null,
  erpBillable?: ModelBooleanInput | null,
  erpPostingStatus?: ModelERPPostingStatusInput | null,
  erpPostingError?: ModelStringInput | null,
  erpPostingWarning?: ModelStringInput | null,
  sage300APInvoiceStatus?: ModelSage300APInvoiceStatusInput | null,
  sage300APInvoiceError?: ModelStringInput | null,
  note?: ModelStringInput | null,
  approveWithoutNotes?: ModelBooleanInput | null,
  receiptPath?: ModelStringInput | null,
  receiptId?: ModelIDInput | null,
  hasReceipt?: ModelBooleanInput | null,
  approveWithoutReceipts?: ModelBooleanInput | null,
  fuelVehicleId?: ModelStringInput | null,
  fuelOdometerReading?: ModelIntInput | null,
  fuelGallons?: ModelIntInput | null,
  fuelCostPerGallon?: ModelIntInput | null,
  codedAt?: ModelStringInput | null,
  codingMethod?: ModelStringInput | null,
  receiptUploadedAt?: ModelStringInput | null,
  receiptUploadMethod?: ModelStringInput | null,
  erpExportedAt?: ModelStringInput | null,
  erpExportBatchId?: ModelStringInput | null,
  and?: Array< ModelHighnoteTransactionEventConditionInput | null > | null,
  or?: Array< ModelHighnoteTransactionEventConditionInput | null > | null,
  not?: ModelHighnoteTransactionEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelHighnoteTransactionStatusInput = {
  eq?: HighnoteTransactionStatus | null,
  ne?: HighnoteTransactionStatus | null,
};

export type ModelFlexCodeTransactionStatusInput = {
  eq?: FlexCodeTransactionStatus | null,
  ne?: FlexCodeTransactionStatus | null,
};

export type ModelWorkflowStatusInput = {
  eq?: WorkflowStatus | null,
  ne?: WorkflowStatus | null,
};

export type ModelReturnedStatusInput = {
  eq?: ReturnedStatus | null,
  ne?: ReturnedStatus | null,
};

export type ModelERPPostingStatusInput = {
  eq?: ERPPostingStatus | null,
  ne?: ERPPostingStatus | null,
};

export type ModelSage300APInvoiceStatusInput = {
  eq?: Sage300APInvoiceStatus | null,
  ne?: Sage300APInvoiceStatus | null,
};

export type UpdateHighnoteTransactionEventInput = {
  id: string,
  transactionId?: string | null,
  paymentCardId?: string | null,
  paidolId?: string | null,
  reconciliationId?: string | null,
  authPaidolId?: string | null,
  eventDate?: string | null,
  processedAt?: string | null,
  origin?: string | null,
  status?: HighnoteTransactionStatus | null,
  partial?: boolean | null,
  settlementImpact?: boolean | null,
  approvedAmount?: HNAmountInput | null,
  fees?: Array< HNAmountInput | null > | null,
  approvedAmountValue?: number | null,
  approvedAmountCurrencyCode?: string | null,
  eventData?: string | null,
  transactionOldState?: string | null,
  transactionNewState?: string | null,
  enableListing?: boolean | null,
  email?: string | null,
  userId?: string | null,
  last4?: string | null,
  groupApprovalLevels?: number | null,
  owningProjectGroupIds?: Array< string | null > | null,
  cardGroupId?: string | null,
  merchantCategory?: string | null,
  merchantCategoryCode?: string | null,
  merchantName?: string | null,
  jobCodeId?: string | null,
  flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
  workflowStatus?: WorkflowStatus | null,
  returnedStatus?: ReturnedStatus | null,
  flexCodeId?: string | null,
  flexCostCodeId?: string | null,
  flexCostTypeId?: string | null,
  flexGlCodeId?: string | null,
  flexVendorId?: string | null,
  agaveDepartmentId?: string | null,
  agaveLocationId?: string | null,
  agaveSubaccountId?: string | null,
  agaveEmployeeId?: string | null,
  agaveExpense?: CreateAgaveExpenseAPInvoiceInput | null,
  agaveExpenseId?: string | null,
  agaveProjectId?: string | null,
  agaveCostCodeId?: string | null,
  agaveCostTypeId?: string | null,
  agaveGlCodeId?: string | null,
  agaveVendorId?: string | null,
  agaveSubJobId?: string | null,
  agaveEquipmentId?: string | null,
  agaveEmCostCodeId?: string | null,
  agaveEmCostTypeId?: string | null,
  codingType?: string | null,
  accountingDate?: string | null,
  procoreDirectCostId?: number | null,
  procoreDirectCostLineItemId?: number | null,
  procoreProject?: GetProcoreProjectsPayloadInput | null,
  procoreProjectId?: number | null,
  procoreWBSCode?: GetProcoreWBSCodesPayloadInput | null,
  procoreWBSCodeId?: number | null,
  erpApprovalStatus?: boolean | null,
  erpBypassStatus?: boolean | null,
  erpBillableItemId?: string | null,
  erpBillableItemName?: string | null,
  erpBillable?: boolean | null,
  erpPostingStatus?: ERPPostingStatus | null,
  erpPostingError?: string | null,
  erpPostingWarning?: string | null,
  sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
  sage300APInvoiceError?: string | null,
  note?: string | null,
  approveWithoutNotes?: boolean | null,
  receiptPath?: string | null,
  receiptId?: string | null,
  hasReceipt?: boolean | null,
  approveWithoutReceipts?: boolean | null,
  fuelVehicleId?: string | null,
  fuelOdometerReading?: number | null,
  fuelGallons?: number | null,
  fuelCostPerGallon?: number | null,
  codedAt?: string | null,
  codingMethod?: string | null,
  receiptUploadedAt?: string | null,
  receiptUploadMethod?: string | null,
  erpExportedAt?: string | null,
  erpExportBatchId?: string | null,
};

export type DeleteHighnoteTransactionEventInput = {
  id: string,
};

export type CreateSyncBalanceCurrentCycleInput = {
  id?: string | null,
  paidolId: string,
  authPaidolId: string,
  startDate: string,
  endDate?: string | null,
};

export type ModelSyncBalanceCurrentCycleConditionInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  and?: Array< ModelSyncBalanceCurrentCycleConditionInput | null > | null,
  or?: Array< ModelSyncBalanceCurrentCycleConditionInput | null > | null,
  not?: ModelSyncBalanceCurrentCycleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SyncBalanceCurrentCycle = {
  __typename: "SyncBalanceCurrentCycle",
  id: string,
  paidolId: string,
  authPaidolId: string,
  startDate: string,
  endDate?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSyncBalanceCurrentCycleInput = {
  id: string,
  paidolId?: string | null,
  authPaidolId?: string | null,
  startDate?: string | null,
  endDate?: string | null,
};

export type DeleteSyncBalanceCurrentCycleInput = {
  id: string,
};

export type CreateSyncBalanceCurrentCyclePaymentCardsInput = {
  id?: string | null,
  authPaidolId: string,
  paidolId: string,
  syncBalanceCurrentCycleId: string,
  paymentCardId: string,
  balance?: HNAmountInput | null,
  syncedAt: string,
  error?: string | null,
};

export type ModelSyncBalanceCurrentCyclePaymentCardsConditionInput = {
  authPaidolId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  syncBalanceCurrentCycleId?: ModelIDInput | null,
  paymentCardId?: ModelStringInput | null,
  syncedAt?: ModelStringInput | null,
  error?: ModelStringInput | null,
  and?: Array< ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null > | null,
  or?: Array< ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null > | null,
  not?: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SyncBalanceCurrentCyclePaymentCards = {
  __typename: "SyncBalanceCurrentCyclePaymentCards",
  id: string,
  authPaidolId: string,
  paidolId: string,
  syncBalanceCurrentCycleId: string,
  paymentCardId: string,
  balance?: HNAmount | null,
  syncedAt: string,
  error?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSyncBalanceCurrentCyclePaymentCardsInput = {
  id: string,
  authPaidolId?: string | null,
  paidolId?: string | null,
  syncBalanceCurrentCycleId?: string | null,
  paymentCardId?: string | null,
  balance?: HNAmountInput | null,
  syncedAt?: string | null,
  error?: string | null,
};

export type DeleteSyncBalanceCurrentCyclePaymentCardsInput = {
  id: string,
};

export type CreateExpenseTypeToMCCInput = {
  id?: string | null,
  mccID: string,
  expenseTypeID: string,
};

export type ModelExpenseTypeToMCCConditionInput = {
  mccID?: ModelIDInput | null,
  expenseTypeID?: ModelIDInput | null,
  and?: Array< ModelExpenseTypeToMCCConditionInput | null > | null,
  or?: Array< ModelExpenseTypeToMCCConditionInput | null > | null,
  not?: ModelExpenseTypeToMCCConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateExpenseTypeToMCCInput = {
  id: string,
  mccID?: string | null,
  expenseTypeID?: string | null,
};

export type DeleteExpenseTypeToMCCInput = {
  id: string,
};

export type InviteUserToPaidol = {
  id?: string | null,
  paidol_id: string,
  user_id?: string | null,
  email: string,
  employee_id?: number | null,
  position?: string | null,
  phone?: string | null,
  roles?: Role | null,
};

export type RemoveUserFromPaymentCardPayload = {
  __typename: "RemoveUserFromPaymentCardPayload",
  id?: string | null,
  paidolUserID?: string | null,
  highnotePaymentCardID?: string | null,
  paidolUser?: PaidolUser | null,
  highnotePaymentCard?: HighnotePaymentCard | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type SupplierUpdateInput = {
  paidol_vendor_id?: string | null,
  paidol_id?: string | null,
  vendor_paidol_id?: string | null,
};

export type HNGenerateTokenizeAccountHolderClientTokenPayload = HNClientToken | HNUserError | HNAccessDeniedError


export type HNClientToken = {
  __typename: "HNClientToken",
  value: string,
  expirationDate?: string | null,
  usage?: HNClientTokenUsage | null,
};

export enum HNClientTokenUsage {
  UNTIL_EXPIRATION = "UNTIL_EXPIRATION",
  SINGLE_USE = "SINGLE_USE",
}


export type HNGeneratePaymentCardClientTokenInput = {
  paymentCardId: string,
  permissions: Array< HNPaymentCardClientTokenPermission >,
};

export enum HNPaymentCardClientTokenPermission {
  READ_RESTRICTED_DETAILS = "READ_RESTRICTED_DETAILS",
  SET_PAYMENT_CARD_PIN = "SET_PAYMENT_CARD_PIN",
  MANAGE_PAYMENT_CARD = "MANAGE_PAYMENT_CARD",
  MANAGE_CARD_FULFILLMENT = "MANAGE_CARD_FULFILLMENT",
  READ_FULFILLMENT_DETAILS = "READ_FULFILLMENT_DETAILS",
}


export type HNGeneratePaymentCardClientTokenPayload = HNClientToken | HNUserError | HNAccessDeniedError


export type HNAddExternalBankAccountVerifiedThroughPlaidInput = {
  accountHolderId: string,
  externalToken: HNExternalTokenInput,
};

export type HNExternalTokenInput = {
  value: string,
};

export type HNAddExternalBankAccountFromTokenPayload = HNExternalFinancialBankAccount | HNUserError | HNAccessDeniedError


export type HNAddExternalBankAccountVerifiedThroughFinicityInput = {
  accountHolderId: string,
  name: string,
  bankAccountType: HNBankAccountType,
  externalToken: HNExternalTokenFinicityInput,
  paidolHighnoteIntegrationId: string,
};

export type HNExternalTokenFinicityInput = {
  receiptId: string,
  customerId: string,
  products?: Array< HNFinicityProduct > | null,
};

export type HNFinicityProduct = {
  productType: HNFinicityProductType,
  accountId: string,
  callLimit: number,
  expirationDetail: HNExpirationDetail,
};

export enum HNFinicityProductType {
  ACH_DETAILS = "ACH_DETAILS",
  CURRENT_BALANCE = "CURRENT_BALANCE",
  APPROXIMATE_BALANCE = "APPROXIMATE_BALANCE",
  ACH_OWNER_DETAILS = "ACH_OWNER_DETAILS",
}


export type HNExpirationDetail = {
  start: string,
  expiry: string,
};

export type HNCreateOneTimeACHTransferInput = {
  fromFinancialAccountId: string,
  toFinancialAccountId: string,
  descriptor: HNACHDescriptorInput,
  transferAgreementConsent: HNTransferAgreementConsentInput,
  transferAmountStrategy: HNAmountStrategyInput,
  transferDate: string,
};

export type HNACHDescriptorInput = {
  companyEntryDescription: string,
  individualName: string,
  individualIdentificationNumber?: string | null,
};

export type HNTransferAgreementConsentInput = {
  consentTimestamp: string,
  authorizedPersonId: string,
  template: HNTransferAgreementConsentTemplateInput,
};

export type HNTransferAgreementConsentTemplateInput = {
  consentTemplateId: string,
  consentTemplateVersion: string,
};

export type HNAmountStrategyInput = {
  balanceAmountType?: HNTransferBalanceAmountCode | null,
  transferAmount?: HNAmountInput | null,
};

export type HNCreateOneTimeACHTransferPayload = HNOneTimeACHTransfer | HNUserError | HNAccessDeniedError


export type HNCancelScheduledTransferInput = {
  scheduledTransferId: string,
};

export type HNCancelScheduledTransferPayload = HNRecurringACHTransfer | HNOneTimeACHTransfer | HNUserError | HNAccessDeniedError


export type HNCreateRecurringACHTransferInput = {
  fromFinancialAccountId: string,
  toFinancialAccountId: string,
  frequency: HNRecurringAchTransferFrequencyCode,
  transferAmountStrategy: HNAmountStrategyInput,
  descriptor: HNACHDescriptorInput,
  transferDayOfMonth: number,
  transferAgreementConsent: HNTransferAgreementConsentInput,
};

export type HNCreateRecurringACHTransferPayload = HNRecurringACHTransfer | HNUserError | HNAccessDeniedError


export type HNInitiateFundsDepositACHTransferInput = {
  fromFinancialAccountId: string,
  toFinancialAccountId: string,
  amount: HNAmountInput,
  descriptor: HNACHDescriptorInput,
  transferAgreementConsent: HNTransferAgreementConsentInput,
  idempotencyKey?: string | null,
  cancellationPeriodMillis?: number | null,
  sameDay?: boolean | null,
  paymentRelatedInformation?: string | null,
};

export type HNInitiateFundsDepositACHTransferPayload = HNIntegratorInitiatedFundsDepositACHTransfer | HNUserError | HNAccessDeniedError


export type HNActivatePaymentCardInput = {
  paymentCardId: string,
};

export type HNActivatePaymentCardPayload = HNPaymentCard | HNUserError | HNAccessDeniedError


export type HNCreateAccountHolderCardProductApplicationInput = {
  cardProductId: string,
  accountHolderId: string,
  ipAddress?: HNIPAddressInput | null,
  cardHolderAgreementConsent: HNConsentInput,
  accountHolderCreditReportPullConsent?: HNConsentInput | null,
};

export type HNIPAddressInput = {
  v4?: string | null,
  v6?: string | null,
};

export type HNConsentInput = {
  primaryAuthorizedPersonId: string,
  consentTimestamp: string,
  consentIpAddress?: HNIPAddressInput | null,
};

export type HNCreateAccountHolderCardProductApplicationPayload = HNAccountHolderCardProductApplication | HNUserError | HNAccessDeniedError


export type HNStartDocumentUploadSessionInput = {
  documentUploadSessionId: string,
};

export type HNStartDocumentUploadSessionPayload = HNUSAccountHolderApplicationDocumentUploadSession | HNCardProfileDocumentUploadSession | HNIdentityVerificationDocumentUploadSession | HNUserError | HNAccessDeniedError


export type HNCreateDocumentUploadLinkInput = {
  documentUploadSessionId: string,
  documentType: HNDocumentType,
};

export type HNCreateDocumentUploadLinkPayload = HNDocumentUploadLink | HNCardArtDocument | HNUserError | HNAccessDeniedError


export type HNEndDocumentUploadSessionInput = {
  documentUploadSessionId: string,
};

export type HNEndDocumentUploadSessionPayload = HNUSAccountHolderApplicationDocumentUploadSession | HNCardProfileDocumentUploadSession | HNIdentityVerificationDocumentUploadSession | HNUserError | HNAccessDeniedError


export type PlaidLinkToken = {
  __typename: "PlaidLinkToken",
  link_token: string,
  expiration: string,
  request_id: string,
};

export type PlaidProcessorToken = {
  __typename: "PlaidProcessorToken",
  processor_token: string,
  request_id: string,
};

export type PlaidAccessToken = {
  __typename: "PlaidAccessToken",
  access_token: string,
  item_id: string,
  request_id: string,
};

export type LinkPlaidBankAccountInput = {
  publicToken: string,
  accountId: string,
  accountType: string,
  accountName: string,
  accountMask: string,
  paidolId: string,
  verificationMethod: string,
  highnoteAccountId?: string | null,
};

export type PlaidLinkedBankAccountSafe = {
  __typename: "PlaidLinkedBankAccountSafe",
  id: string,
  paidolId: string,
  plaidAccountId: string,
  plaidItemId: string,
  highnoteAccountId?: string | null,
  accountName: string,
  accountMask: string,
  accountType: string,
  verificationMethod: string,
  status: string,
  linkedAt: string,
  verifiedAt?: string | null,
  closedAt?: string | null,
  failureReason?: string | null,
};

export type VerificationCompleteResponse = {
  __typename: "VerificationCompleteResponse",
  processorToken: string,
  accountId: string,
};

export type HNCreateMerchantCategorySpendRuleInput = {
  name: string,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  allowedMcc?: Array< string > | null,
  blockedMcc?: Array< string > | null,
};

export type HNCreateMerchantCategorySpendRulePayload = HNMerchantCategorySpendRule | HNUserError | HNAccessDeniedError


export type HNCreateMerchantCountrySpendRuleInput = {
  name: string,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
};

export type HNCreateMerchantCountrySpendRulePayload = HNMerchantCountrySpendRule | HNUserError | HNAccessDeniedError


export type HNUpdateMerchantCategorySpendRuleInput = {
  spendRuleId: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
  allowedMcc?: Array< string > | null,
  blockedMcc?: Array< string > | null,
};

export type HNUpdateMerchantCategorySpendRulePayload = HNMerchantCategorySpendRule | HNUserError | HNAccessDeniedError


export type HNUpdateMerchantCountrySpendRuleInput = {
  spendRuleId: string,
  name?: string | null,
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
};

export type HNUpdateMerchantCountrySpendRulePayload = HNMerchantCountrySpendRule | HNUserError | HNAccessDeniedError


export type HNCreateAmountLimitSpendRuleInput = {
  name: string,
  maximumAmount: HNAmountInput,
};

export type HNCreateAmountLimitSpendRulePayload = HNAmountLimitSpendRule | HNUserError | HNAccessDeniedError


export type HNSuspendPaymentCardInput = {
  paymentCardId: string,
};

export type HNSuspendPaymentCardPayload = HNPaymentCard | HNUserError | HNAccessDeniedError


export type HNClosePaymentCardInput = {
  paymentCardId: string,
};

export type HNClosePaymentCardPayload = HNPaymentCard | HNUserError | HNAccessDeniedError


export type HNGenerateDirectDepositDetailClientTokenInput = {
  directDepositDetailId: string,
  permissions: Array< HNDirectDepositDetailClientTokenPermission >,
};

export enum HNDirectDepositDetailClientTokenPermission {
  READ_RESTRICTED_DETAILS = "READ_RESTRICTED_DETAILS",
}


export type HNGenerateDirectDepositDetailClientTokenPayload = HNClientToken | HNUserError | HNAccessDeniedError


export type IssuePaymentCard = {
  formType: string,
  selectedPaymentCardId?: string | null,
  financialAccountId: string,
  cardProfileId?: string | null,
  cardExpirationDate: string,
  cardType: HNCardFormFactor,
  email: string,
  procoreEmployee?: IssuePaymentCardProcoreEmployeeInput | null,
  paidolId: string,
  hostname: string,
  cardName: string,
  cardGroupId?: string | null,
  maximumTransactionAmount?: number | null,
  monthlySpendLimit?: number | null,
  merchantSpendRuleId?: string | null,
  categories?: CategoriesInput | null,
  countries?: CountriesInput | null,
  requireCardCode: boolean,
  requireAddress: boolean,
  addressFirstName?: string | null,
  addressLastName?: string | null,
  addressStreet1?: string | null,
  addressStreet2?: string | null,
  addressZip?: string | null,
  addressCity?: string | null,
  addressState?: string | null,
  shippingMethod?: HNPaymentCardShippingMethod | null,
  requireSignature?: boolean | null,
};

export type CategoriesInput = {
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
};

export type CountriesInput = {
  allowed?: Array< string > | null,
  blocked?: Array< string > | null,
};

export type IssuePaymentCardResponse = {
  __typename: "IssuePaymentCardResponse",
  statusCode?: number | null,
  errorMessage?: string | null,
  errorType?: string | null,
  paymentCardId?: string | null,
};

export type HNCloseExternalFinancialBankAccountInput = {
  externalFinancialBankAccountId: string,
};

export type HNCloseExternalFinancialBankAccountPayload = HNExternalFinancialBankAccount | HNUserError | HNAccessDeniedError


export type HNIssueFinancialAccountForApplicationInput = {
  applicationId: string,
  externalId?: string | null,
  name: string,
  customFields?: Array< HNCustomFieldInput > | null,
  idempotencyKey?: string | null,
};

export type HNCustomFieldInput = {
  key: string,
  value: string,
};

export type HNIssueFinancialAccountForApplicationPayload = HNFinancialAccount | HNUserError | HNAccessDeniedError


export type CreateFinicityConsentReceiptInput = {
  operationName: string,
  data: CreateFinicityConsentReceiptInputData,
};

export type CreateFinicityConsentReceiptInputData = {
  customerId: string,
  accountId: string,
};

export type CreateFinicityConsentReceiptPayload = {
  __typename: "CreateFinicityConsentReceiptPayload",
  receipt?: FinicityConsentReceiptPayload | null,
  proof?: FinicityConsentReceiptProof | null,
};

export type FinicityConsentReceiptPayload = {
  __typename: "FinicityConsentReceiptPayload",
  profile?: string | null,
  version?: string | null,
  receiptId?: string | null,
  receiptVersion?: string | null,
  customerId?: string | null,
  partnerId?: string | null,
  products?:  Array<FinicityConsentAvailableProducts | null > | null,
};

export type FinicityConsentAvailableProducts = {
  __typename: "FinicityConsentAvailableProducts",
  product?: string | null,
  accountId?: string | null,
  accessPeriod?: FinicityConsentAvailableProductsAccessPeriod | null,
};

export type FinicityConsentAvailableProductsAccessPeriod = {
  __typename: "FinicityConsentAvailableProductsAccessPeriod",
  type?: string | null,
  startTime?: string | null,
  endTime?: string | null,
};

export type FinicityConsentReceiptProof = {
  __typename: "FinicityConsentReceiptProof",
  signature?: string | null,
  keyId?: string | null,
  timestamp?: string | null,
};

export type CreateFinicityCustomerInput = {
  operationName: string,
  data: CreateFinicityCustomerInputData,
};

export type CreateFinicityCustomerInputData = {
  username: string,
};

export type CreateFinicityCustomerPayload = {
  __typename: "CreateFinicityCustomerPayload",
  id?: string | null,
  username?: string | null,
};

export type DeleteFinicityCustomerAccount = {
  operationName: string,
  data: DeleteFinicityCustomerAccountInput,
};

export type DeleteFinicityCustomerAccountInput = {
  customerId: string,
  accountId: string,
};

export type GetOrRefreshProcoreAccessTokenInput = {
  operationName: string,
  data: GetOrRefreshProcoreAccessTokenInputData,
};

export type GetOrRefreshProcoreAccessTokenInputData = {
  code?: string | null,
  refresh_token?: string | null,
  redirect_uri?: string | null,
};

export type GetOrRefreshProcoreAccessTokenPayload = {
  __typename: "GetOrRefreshProcoreAccessTokenPayload",
  access_token: string,
  token_type: string,
  expires_in: number,
  refresh_token: string,
  created_at: number,
};

export type CreateOrUpdateProcoreDirectCostInput = {
  operationName: string,
  data: CreateOrUpdateProcoreDirectCostInputData,
};

export type CreateOrUpdateProcoreDirectCostInputData = {
  auth: string,
  transactionId: string,
  companyId: number,
};

export type CreateOrUpdateProcoreDirectCostPayload = {
  __typename: "CreateOrUpdateProcoreDirectCostPayload",
  transactionId: string,
  directCostId: number,
  directCostLineItemId: number,
};

export type AgaveLinkToken = {
  __typename: "AgaveLinkToken",
  link_token?: string | null,
};

export type AgaveAccountTokenInput = {
  public_token?: string | null,
};

export type AgaveAccountToken = {
  __typename: "AgaveAccountToken",
  account_token?: string | null,
  account_id?: string | null,
  connection?: Connection | null,
  created_at?: string | null,
  linked_company?: LinkedCompany | null,
  linked_user?: LinkedUser | null,
  reference_id?: string | null,
  source_system?: SourceSystem | null,
  source_system_environment?: SourceSystemEnvironment | null,
  status?: string | null,
  supports_cross_account_uuid?: boolean | null,
  supports_cross_company_requests?: boolean | null,
};

export type Connection = {
  __typename: "Connection",
  type?: string | null,
  properties?: ConnectionProperties | null,
};

export type ConnectionProperties = {
  __typename: "ConnectionProperties",
  company_id?: string | null,
  database?: string | null,
  hostname?: string | null,
  port?: string | null,
  username?: string | null,
  password?: string | null,
  sql_server_timezone_offset?: string | null,
};

export type LinkedCompany = {
  __typename: "LinkedCompany",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
};

export type LinkedUser = {
  __typename: "LinkedUser",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
  email?: string | null,
};

export type SourceSystem = {
  __typename: "SourceSystem",
  name?: string | null,
  slug?: string | null,
};

export type SourceSystemEnvironment = {
  __typename: "SourceSystemEnvironment",
  name?: string | null,
  slug?: string | null,
};

export type CreateAgaveExpenseInput = {
  account_token?: string | null,
  batch?: string | null,
  bank_account_id?: string | null,
  description?: string | null,
  discount_date?: string | null,
  due_date?: string | null,
  erp?: string | null,
  expense_id?: string | null,
  issue_date?: string | null,
  line_items?: Array< CreateAgaveExpenseLineItemInput > | null,
  merchantName?: string | null,
  number: string,
  payment_date?: string | null,
  payment_method?: CreateAgaveExpensePaymentMethodInput | null,
  payment_number?: string | null,
  project_id?: string | null,
  source_data?: CreateAgaveExpenseSourceDataInput | null,
  transactionId?: string | null,
  vendor_id?: string | null,
};

export type CreateAgaveExpenseLineItemInput = {
  amount: string,
  contract?: CreateAgaveExpenseContractInput | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  customer_id?: string | null,
  description?: string | null,
  item_id?: string | null,
  project_id?: string | null,
  ledger_account_id?: string | null,
  quantity?: string | null,
  retention_amount?: string | null,
  status?: string | null,
  tax_amount?: string | null,
  tax_code_id?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_of_measure?: string | null,
};

export enum CreateAgaveExpensePaymentMethodInput {
  Check = "Check",
  Cash = "Cash",
  CreditCard = "CreditCard",
  CreditCardCharge = "CreditCardCharge",
  CreditCardCredit = "CreditCardCredit",
}


export type CreateAgaveExpenseSourceDataInput = {
  Mth?: string | null,
};

export type AgaveExpenseResult = AgaveError | CreateAgaveExpenseAPInvoice


export type AgaveError = {
  __typename: "AgaveError",
  message?: string | null,
};

export type AgavePostJobCostInput = {
  headers: string,
  data: AgavePostJobCostInputData,
};

export type AgavePostJobCostInputData = {
  accounting_date?: string | null,
  actual_amount?: string | null,
  actual_quantity?: string | null,
  actual_unit_cost?: string | null,
  actual_unit_of_measure?: string | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  description?: string | null,
  ledger_account_id?: string | null,
  name?: string | null,
  number?: string | null,
  posted_date?: string | null,
  prime_contract_id?: string | null,
  project_id?: string | null,
  reference_id?: string | null,
  reference_type?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  transaction_date?: string | null,
  type?: string | null,
  vendor_id?: string | null,
  transactionId?: string | null,
  source_data?: string | null,
};

export type AgaveJobCostResult = AgaveError | AgaveJobCost


export type AgaveJobCost = {
  __typename: "AgaveJobCost",
  id: string,
  source_id?: string | null,
  accounting_date?: string | null,
  actual_amount?: string | null,
  actual_quantity?: string | null,
  actual_unit_cost?: string | null,
  actual_unit_of_measure?: string | null,
  attachments?: Array< string | null > | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  description?: string | null,
  ledger_account_id?: string | null,
  name?: string | null,
  number?: string | null,
  posted_date?: string | null,
  prime_contract_id?: string | null,
  project_id?: string | null,
  reference_id?: string | null,
  reference_type?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  transaction_date?: string | null,
  type?: string | null,
  vendor_id?: string | null,
  wbs_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: string | null,
};

export type AgaveAPInvoicesCreateExpenseInput = {
  description?: string | null,
  account_token?: string | null,
  discount_date?: string | null,
  due_date?: string | null,
  issue_date?: string | null,
  line_items?: Array< AgaveAPInvoicesLineItemInput | null > | null,
  number?: string | null,
  retention_percent?: string | null,
  vendor_id?: string | null,
  merchantName?: string | null,
  id?: string | null,
  project_id?: string | null,
  status?: string | null,
  source_system?: AgaveAPInvoicesCreateExpenseSourceSystemInput | null,
  erp?: string | null,
  type?: string | null,
};

export type AgaveAPInvoicesLineItemInput = {
  amount?: string | null,
  contract?: AgaveAPInvoicesContractInput | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  customer_id?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  item_id?: string | null,
  ledger_account_id?: string | null,
  project_id?: string | null,
  quantity?: string | null,
  retention_amount?: string | null,
  source_data?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  tax_amount?: string | null,
  tax_code_id?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_of_measure?: string | null,
};

export type AgaveAPInvoicesContractInput = {
  id?: string | null,
  line_item_id?: string | null,
  type?: string | null,
};

export type AgaveAPInvoicesCreateExpenseSourceSystemInput = {
  InvoiceType?: string | null,
};

export type AgaveAPInvoicesResult = AgaveError | AgaveAPInvoicesPayload


export type AgaveAPInvoicesPayload = {
  __typename: "AgaveAPInvoicesPayload",
  id?: string | null,
  source_id?: string | null,
  amount?: string | null,
  amount_due?: string | null,
  ap_payment_ids?: Array< string | null > | null,
  attachments?:  Array<AgaveAPInvoicesResultAttachment | null > | null,
  batch?: string | null,
  batch_id?: string | null,
  contract?: AgaveAPInvoicesResultContract | null,
  creator_id?: string | null,
  currency_code?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  discount_date?: string | null,
  due_date?: string | null,
  issue_date?: string | null,
  line_items?:  Array<AgaveAPInvoicesResultLineItem | null > | null,
  misc_amount?: string | null,
  net_amount?: string | null,
  number?: string | null,
  project_id?: string | null,
  retention_amount?: string | null,
  retention_percent?: string | null,
  status?: string | null,
  subtotal_amount?: string | null,
  tax_amount?: string | null,
  total_amount?: string | null,
  type?: string | null,
  vendor_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  source_data?: AgaveAPInvoicesResultSourceData | null,
};

export type AgaveAPInvoicesResultAttachment = {
  __typename: "AgaveAPInvoicesResultAttachment",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
  url?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type AgaveAPInvoicesResultContract = {
  __typename: "AgaveAPInvoicesResultContract",
  id?: string | null,
  type?: string | null,
};

export type AgaveAPInvoicesResultLineItem = {
  __typename: "AgaveAPInvoicesResultLineItem",
  id?: string | null,
  source_id?: string | null,
  amount?: string | null,
  change_order?: AgaveAPInvoicesResultLineItemChangeOrder | null,
  contract?: AgaveAPInvoicesResultLineItemContract | null,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  customer_id?: string | null,
  description?: string | null,
  discount_amount?: string | null,
  item_id?: string | null,
  ledger_account_id?: string | null,
  project_id?: string | null,
  quantity?: string | null,
  retention_amount?: string | null,
  status?: string | null,
  sub_job_id?: string | null,
  tax_amount?: string | null,
  tax_code_id?: string | null,
  type?: string | null,
  unit_cost?: string | null,
  unit_of_measure?: string | null,
  vendor_id?: string | null,
  wbs_id?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
};

export type AgaveAPInvoicesResultLineItemChangeOrder = {
  __typename: "AgaveAPInvoicesResultLineItemChangeOrder",
  id?: string | null,
  line_item_id?: string | null,
};

export type AgaveAPInvoicesResultLineItemContract = {
  __typename: "AgaveAPInvoicesResultLineItemContract",
  id?: string | null,
  line_item_id?: string | null,
  type?: string | null,
};

export type AgaveAPInvoicesResultSourceData = {
  __typename: "AgaveAPInvoicesResultSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type AgaveResolverMutationInput = {
  account_token: string,
  headers?: string | null,
  data?: string | null,
};

export type AgaveResolverMutationResult = AgaveError | AgaveResolverMutationResponse


export type AgaveResolverMutationResponse = {
  __typename: "AgaveResolverMutationResponse",
  status?: number | null,
  content_type?: string | null,
  body?: string | null,
  headers?: AWSJSONWrapper | null,
};

export type AWSJSONWrapper = {
  __typename: "AWSJSONWrapper",
  raw?: string | null,
};

export type StartSage300APInvoiceInput = {
  transactionId: string,
  paidolId: string,
  invoiceData: Sage300APInvoiceInputData,
};

export type Sage300APInvoiceInputData = {
  description: string,
  due_date: string,
  issue_date: string,
  line_items: Array< Sage300APInvoiceLineItemInput >,
  number: string,
  vendor_id: string,
  account_token: string,
};

export type Sage300APInvoiceLineItemInput = {
  amount: string,
  description: string,
  quantity: string,
  cost_code_id?: string | null,
  cost_type_id?: string | null,
  project_id?: string | null,
  ledger_account_id?: string | null,
  sub_job_id?: string | null,
};

export type StartSage300APInvoiceResponse = {
  __typename: "StartSage300APInvoiceResponse",
  transactionId: string,
  status: Sage300APInvoiceStatus,
  error?: string | null,
};

export type StartSage300JobCostInput = {
  transactionId: string,
  paidolId: string,
  jobCostData: Sage300JobCostInputData,
};

export type Sage300JobCostInputData = {
  headers: string,
  data: AgavePostJobCostInputData,
};

export type StartSage300JobCostResponse = {
  __typename: "StartSage300JobCostResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type StartQBOPostingInput = {
  transactionId: string,
  paidolId: string,
  erp: string,
  postingType: string,
  postingData: string,
};

export type StartQBOPostingResponse = {
  __typename: "StartQBOPostingResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type StartQBDPostingInput = {
  transactionId: string,
  paidolId: string,
  erp: string,
  postingType: string,
  postingData: string,
};

export type StartQBDPostingResponse = {
  __typename: "StartQBDPostingResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type StartSageIntacctPostingInput = {
  transactionId: string,
  paidolId: string,
  erp: string,
  postingType: string,
  postingData: string,
};

export type StartSageIntacctPostingResponse = {
  __typename: "StartSageIntacctPostingResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type StartVistaPostingInput = {
  transactionId: string,
  paidolId: string,
  erp: string,
  postingType: string,
  postingData: string,
};

export type StartVistaPostingResponse = {
  __typename: "StartVistaPostingResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type StartAcumaticaPostingInput = {
  transactionId: string,
  paidolId: string,
  erp: string,
  postingType: string,
  postingData: string,
};

export type StartAcumaticaPostingResponse = {
  __typename: "StartAcumaticaPostingResponse",
  transactionId: string,
  status: ERPPostingStatus,
  error?: string | null,
};

export type AttachDirectCostReceiptInput = {
  operationName: string,
  data: AttachDirectCostReceiptInputData,
};

export type AttachDirectCostReceiptInputData = {
  auth: string,
  projectId: number,
  directCostId: number,
  companyId: number,
  receiptPath: string,
};

export type AttachDirectCostReceiptPayload = {
  __typename: "AttachDirectCostReceiptPayload",
  directCostId: number,
};

export type CreateReimbursementDirectCostInput = {
  operationName: string,
  data: CreateReimbursementDirectCostInputData,
};

export type CreateReimbursementDirectCostInputData = {
  auth: string,
  companyId: number,
  reimbursementTransactionId: string,
};

export type CreateReimbursementDirectCostPayload = {
  __typename: "CreateReimbursementDirectCostPayload",
  reimbursementTransactionId: string,
  directCostId: number,
  directCostLineItemId: number,
};

export type CompleteChecklistInput = {
  operationName: string,
  data: CompleteChecklistInputData,
};

export type CompleteChecklistInputData = {
  paidolId: string,
  firstRunValue: string,
};

export type CompleteChecklistPayload = {
  __typename: "CompleteChecklistPayload",
  paidolId?: string | null,
};

export type CompleteBannerInput = {
  operationName: string,
  data: CompleteBannerInputData,
};

export type CompleteBannerInputData = {
  userId: string,
  firstRunValue: string,
};

export type CompleteBannerPayload = {
  __typename: "CompleteBannerPayload",
  userId: string,
};

export type AttachSpendRulesToGroupCardsInput = {
  cardGroupId: string,
};

export type AttachSpendRulesToGroupCardsPayload = {
  __typename: "AttachSpendRulesToGroupCardsPayload",
  cardGroupId?: string | null,
  cardGroup?: CardGroup | null,
};

export type AgavePassThroughInput = {
  account_token: string,
  method: AgaveHttpMethod,
  // The request body. Optional for GET requests.
  data?: string | null,
};

export enum AgaveHttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}


export type AgavePassThroughResult = AgaveError | AgavePassThroughResponse


export type AgavePassThroughResponse = {
  __typename: "AgavePassThroughResponse",
  status: number,
  content_type: string,
  body?: string | null,
  headers?: AWSJSONWrapper | null,
};

export type RemoveCardGroupInput = {
  paidolId: string,
  cardGroupId: string,
};

export type HNCreateVelocityRuleInput = {
  name: string,
  cumulativeRule: HNAttachSpendRuleInput,
  spendRules?: Array< HNAttachSpendRuleInput > | null,
  velocityRuleWindow: HNVelocityRuleWindow,
  velocityConstraintLevelOverride?: HNVelocityConstraintLevel | null,
};

export type HNAttachSpendRuleInput = {
  id: string,
  version: string,
};

export type HNCreateVelocityRulePayload = HNVelocityRule | HNUserError | HNAccessDeniedError


export type PersistAgaveDataInput = {
  paidolId?: string | null,
};

export type AddMerchantSpendRuleInput = {
  paidol_id: string,
  name: string,
  categories?: CategoryCountryRuleInput | null,
  countries?: CategoryCountryRuleInput | null,
  maximumTransactionAmount?: MoneyAmount | null,
  monthlySpendLimit?: MoneyAmount | null,
  monthlyLimitResetTimestamp?: string | null,
  paymentCards?: Array< string | null > | null,
};

export type CategoryCountryRuleInput = {
  allowed?: Array< string | null > | null,
  blocked?: Array< string | null > | null,
};

export type V2UpdateBudget = {
  paidolId?: string | null,
};

export type EditMerchantSpendRuleInput = {
  id: string,
  name: string,
  categories?: CategoryCountryRuleInput | null,
  countries?: CategoryCountryRuleInput | null,
  maximumTransactionAmount?: MoneyAmount | null,
  monthlySpendLimit?: MoneyAmount | null,
  monthlyLimitResetTimestamp?: string | null,
  paymentCards?: Array< string | null > | null,
};

export type EditMerchantSpendRuleResult = MerchantSpendRule | MerchantSpendRuleError


export type MerchantSpendRuleError = {
  __typename: "MerchantSpendRuleError",
  errors: string,
};

export type LockUnlockPaymentCardInput = {
  paymentCardId: string,
  action: LockUnlockPaymentCardAction,
};

export enum LockUnlockPaymentCardAction {
  lock = "lock",
  unlock = "unlock",
}


export type LockUnlockPaymentCardPayload = {
  __typename: "LockUnlockPaymentCardPayload",
  statusCode: number,
  status: string,
  paymentCardId: string,
};

export type RemoveProjectGroupInput = {
  projectGroupId: string,
};

export type UpdateReimbursementsSettingsInput = {
  paidolId: string,
  isEnabled: boolean,
  maxAmount?: number | null,
  requireApproval?: boolean | null,
  autoApprove?: boolean | null,
};

export type DeleteTransactionToReceiptUploadByReceiptIdInput = {
  receiptUploadId: string,
};

export type DeleteTransactionToReceiptUploadPayload = {
  __typename: "DeleteTransactionToReceiptUploadPayload",
  success: boolean,
  message?: string | null,
};

export type ModelAgaveProjectFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  completion_date?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  start_date?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectFilterInput | null > | null,
  or?: Array< ModelAgaveProjectFilterInput | null > | null,
  not?: ModelAgaveProjectFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAgaveProjectConnection = {
  __typename: "ModelAgaveProjectConnection",
  items:  Array<AgaveProject | null >,
  nextToken?: string | null,
};

export type ModelAgaveGlCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  classification?: ModelStringInput | null,
  currency_code?: ModelStringInput | null,
  current_balance?: ModelFloatInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveGlCodeFilterInput | null > | null,
  or?: Array< ModelAgaveGlCodeFilterInput | null > | null,
  not?: ModelAgaveGlCodeFilterInput | null,
};

export type ModelAgaveGlCodeConnection = {
  __typename: "ModelAgaveGlCodeConnection",
  items:  Array<AgaveGlCode | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelAgaveCostCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  asset_account_id?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  formatted_full_code?: ModelStringInput | null,
  code?: ModelStringInput | null,
  full_code?: ModelStringInput | null,
  cost_unit_of_measure?: ModelStringInput | null,
  description?: ModelStringInput | null,
  expense_account_id?: ModelStringInput | null,
  income_account_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  parent_id?: ModelStringInput | null,
  project_id?: ModelStringInput | null,
  price_unit_of_measure?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  unit_cost?: ModelStringInput | null,
  unit_price?: ModelStringInput | null,
  vendor_id?: ModelStringInput | null,
  sub_job_id?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  paidolProject?: ModelIDInput | null,
  projectIds?: ModelStringInput | null,
  cost_type_ids?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeFilterInput | null > | null,
  or?: Array< ModelAgaveCostCodeFilterInput | null > | null,
  not?: ModelAgaveCostCodeFilterInput | null,
};

export type ModelAgaveCostCodeConnection = {
  __typename: "ModelAgaveCostCodeConnection",
  items:  Array<AgaveCostCode | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelAgaveSubJobFilterInput = {
  id?: ModelIDInput | null,
  agaveSubJobId?: ModelStringInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  number?: ModelStringInput | null,
  code?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  fullName?: ModelStringInput | null,
  cost_code_ids?: ModelStringInput | null,
  and?: Array< ModelAgaveSubJobFilterInput | null > | null,
  or?: Array< ModelAgaveSubJobFilterInput | null > | null,
  not?: ModelAgaveSubJobFilterInput | null,
};

export type ModelAgaveSubJobConnection = {
  __typename: "ModelAgaveSubJobConnection",
  items:  Array<AgaveSubJob | null >,
  nextToken?: string | null,
};

export type ModelAgaveProjectCostCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  projectIdCostCodeId?: ModelIDInput | null,
  costCodeName?: ModelStringInput | null,
  costCodeCode?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectCostCodeFilterInput | null > | null,
  or?: Array< ModelAgaveProjectCostCodeFilterInput | null > | null,
  not?: ModelAgaveProjectCostCodeFilterInput | null,
};

export type ModelAgaveProjectCostCodeConnection = {
  __typename: "ModelAgaveProjectCostCodeConnection",
  items:  Array<AgaveProjectCostCode | null >,
  nextToken?: string | null,
};

export type ModelAgaveProjectSubJobFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  subJobId?: ModelIDInput | null,
  projectIdSubJobId?: ModelIDInput | null,
  subJobName?: ModelStringInput | null,
  subJobNumber?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectSubJobFilterInput | null > | null,
  or?: Array< ModelAgaveProjectSubJobFilterInput | null > | null,
  not?: ModelAgaveProjectSubJobFilterInput | null,
};

export type ModelAgaveProjectSubJobConnection = {
  __typename: "ModelAgaveProjectSubJobConnection",
  items:  Array<AgaveProjectSubJob | null >,
  nextToken?: string | null,
};

export type ModelAgaveSubJobCostCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  subJobId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  subJobIdCostCodeId?: ModelIDInput | null,
  costCodeName?: ModelStringInput | null,
  costCodeCode?: ModelStringInput | null,
  subJobName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveSubJobCostCodeFilterInput | null > | null,
  or?: Array< ModelAgaveSubJobCostCodeFilterInput | null > | null,
  not?: ModelAgaveSubJobCostCodeFilterInput | null,
};

export type ModelAgaveSubJobCostCodeConnection = {
  __typename: "ModelAgaveSubJobCostCodeConnection",
  items:  Array<AgaveSubJobCostCode | null >,
  nextToken?: string | null,
};

export type ModelAgaveProjectLocationFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectLocationFilterInput | null > | null,
  or?: Array< ModelAgaveProjectLocationFilterInput | null > | null,
  not?: ModelAgaveProjectLocationFilterInput | null,
};

export type ModelAgaveProjectLocationConnection = {
  __typename: "ModelAgaveProjectLocationConnection",
  items:  Array<AgaveProjectLocation | null >,
  nextToken?: string | null,
};

export type ModelAgaveProjectDepartmentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  departmentId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  departmentName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveProjectDepartmentFilterInput | null > | null,
  or?: Array< ModelAgaveProjectDepartmentFilterInput | null > | null,
  not?: ModelAgaveProjectDepartmentFilterInput | null,
};

export type ModelAgaveProjectDepartmentConnection = {
  __typename: "ModelAgaveProjectDepartmentConnection",
  items:  Array<AgaveProjectDepartment | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmployeeEntityFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeEntityFilterInput | null > | null,
  or?: Array< ModelAgaveEmployeeEntityFilterInput | null > | null,
  not?: ModelAgaveEmployeeEntityFilterInput | null,
};

export type ModelAgaveEmployeeEntityConnection = {
  __typename: "ModelAgaveEmployeeEntityConnection",
  items:  Array<AgaveEmployeeEntity | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmployeeLocationFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  employeeId?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  employeeName?: ModelStringInput | null,
  locationName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeLocationFilterInput | null > | null,
  or?: Array< ModelAgaveEmployeeLocationFilterInput | null > | null,
  not?: ModelAgaveEmployeeLocationFilterInput | null,
};

export type ModelAgaveEmployeeLocationConnection = {
  __typename: "ModelAgaveEmployeeLocationConnection",
  items:  Array<AgaveEmployeeLocation | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmployeeDepartmentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  employeeId?: ModelIDInput | null,
  departmentId?: ModelIDInput | null,
  employeeName?: ModelStringInput | null,
  departmentName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmployeeDepartmentFilterInput | null > | null,
  or?: Array< ModelAgaveEmployeeDepartmentFilterInput | null > | null,
  not?: ModelAgaveEmployeeDepartmentFilterInput | null,
};

export type ModelAgaveEmployeeDepartmentConnection = {
  __typename: "ModelAgaveEmployeeDepartmentConnection",
  items:  Array<AgaveEmployeeDepartment | null >,
  nextToken?: string | null,
};

export type ModelAgaveCostTypeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  project_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  paidolProject?: ModelIDInput | null,
  and?: Array< ModelAgaveCostTypeFilterInput | null > | null,
  or?: Array< ModelAgaveCostTypeFilterInput | null > | null,
  not?: ModelAgaveCostTypeFilterInput | null,
};

export type ModelAgaveCostTypeConnection = {
  __typename: "ModelAgaveCostTypeConnection",
  items:  Array<AgaveCostType | null >,
  nextToken?: string | null,
};

export type ModelAgaveEquipmentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  emCo?: ModelStringInput | null,
  category?: ModelStringInput | null,
  department?: ModelStringInput | null,
  status?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEquipmentFilterInput | null > | null,
  or?: Array< ModelAgaveEquipmentFilterInput | null > | null,
  not?: ModelAgaveEquipmentFilterInput | null,
};

export type ModelAgaveEquipmentConnection = {
  __typename: "ModelAgaveEquipmentConnection",
  items:  Array<AgaveEquipment | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmCostCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  emCostTypeCodes?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostCodeFilterInput | null > | null,
  or?: Array< ModelAgaveEmCostCodeFilterInput | null > | null,
  not?: ModelAgaveEmCostCodeFilterInput | null,
};

export type ModelAgaveEmCostCodeConnection = {
  __typename: "ModelAgaveEmCostCodeConnection",
  items:  Array<AgaveEmCostCode | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmDepartmentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emCo?: ModelStringInput | null,
  costCodeKeys?: ModelStringInput | null,
  costTypeKeys?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmDepartmentFilterInput | null > | null,
  or?: Array< ModelAgaveEmDepartmentFilterInput | null > | null,
  not?: ModelAgaveEmDepartmentFilterInput | null,
};

export type ModelAgaveEmDepartmentConnection = {
  __typename: "ModelAgaveEmDepartmentConnection",
  items:  Array<AgaveEmDepartment | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmCostTypeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  emGroup?: ModelStringInput | null,
  abbreviation?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostTypeFilterInput | null > | null,
  or?: Array< ModelAgaveEmCostTypeFilterInput | null > | null,
  not?: ModelAgaveEmCostTypeFilterInput | null,
};

export type ModelAgaveEmCostTypeConnection = {
  __typename: "ModelAgaveEmCostTypeConnection",
  items:  Array<AgaveEmCostType | null >,
  nextToken?: string | null,
};

export type ModelAgaveCostCodeCostTypeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  costTypeId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeCode?: ModelStringInput | null,
  costCodeName?: ModelStringInput | null,
  costTypeCode?: ModelStringInput | null,
  costTypeName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeCostTypeFilterInput | null > | null,
  or?: Array< ModelAgaveCostCodeCostTypeFilterInput | null > | null,
  not?: ModelAgaveCostCodeCostTypeFilterInput | null,
};

export type ModelAgaveCostCodeCostTypeConnection = {
  __typename: "ModelAgaveCostCodeCostTypeConnection",
  items:  Array<AgaveCostCodeCostType | null >,
  nextToken?: string | null,
};

export type ModelAgaveEmCostCodeCostTypeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  emCostCodeId?: ModelIDInput | null,
  emCostTypeId?: ModelIDInput | null,
  emGroup?: ModelStringInput | null,
  emCostCodeCode?: ModelStringInput | null,
  emCostCodeName?: ModelStringInput | null,
  emCostTypeCode?: ModelStringInput | null,
  emCostTypeName?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveEmCostCodeCostTypeFilterInput | null > | null,
  or?: Array< ModelAgaveEmCostCodeCostTypeFilterInput | null > | null,
  not?: ModelAgaveEmCostCodeCostTypeFilterInput | null,
};

export type ModelAgaveEmCostCodeCostTypeConnection = {
  __typename: "ModelAgaveEmCostCodeCostTypeConnection",
  items:  Array<AgaveEmCostCodeCostType | null >,
  nextToken?: string | null,
};

export type ModelAgaveCostCodeCostTypeGlFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  costCodeId?: ModelIDInput | null,
  costTypeId?: ModelIDInput | null,
  glCodeId?: ModelIDInput | null,
  projectCostCodeCostTypeKey?: ModelIDInput | null,
  glCodeSourceId?: ModelStringInput | null,
  glCodeNumber?: ModelStringInput | null,
  itemSourceId?: ModelStringInput | null,
  itemName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAgaveCostCodeCostTypeGlFilterInput | null > | null,
  or?: Array< ModelAgaveCostCodeCostTypeGlFilterInput | null > | null,
  not?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
};

export type ModelAgaveCostCodeCostTypeGlConnection = {
  __typename: "ModelAgaveCostCodeCostTypeGlConnection",
  items:  Array<AgaveCostCodeCostTypeGl | null >,
  nextToken?: string | null,
};

export type ModelAgaveLocationFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  parent_id?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveLocationFilterInput | null > | null,
  or?: Array< ModelAgaveLocationFilterInput | null > | null,
  not?: ModelAgaveLocationFilterInput | null,
};

export type ModelAgaveLocationConnection = {
  __typename: "ModelAgaveLocationConnection",
  items:  Array<AgaveLocation | null >,
  nextToken?: string | null,
};

export type ModelAgaveDepartmentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  relatedIds?: ModelStringInput | null,
  and?: Array< ModelAgaveDepartmentFilterInput | null > | null,
  or?: Array< ModelAgaveDepartmentFilterInput | null > | null,
  not?: ModelAgaveDepartmentFilterInput | null,
};

export type ModelAgaveDepartmentConnection = {
  __typename: "ModelAgaveDepartmentConnection",
  items:  Array<AgaveDepartment | null >,
  nextToken?: string | null,
};

export type ModelAgaveSubaccountFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  type?: ModelStringInput | null,
  source_id?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  source_data?: ModelStringInput | null,
  and?: Array< ModelAgaveSubaccountFilterInput | null > | null,
  or?: Array< ModelAgaveSubaccountFilterInput | null > | null,
  not?: ModelAgaveSubaccountFilterInput | null,
};

export type ModelAgaveSubaccountConnection = {
  __typename: "ModelAgaveSubaccountConnection",
  items:  Array<AgaveSubaccount | null >,
  nextToken?: string | null,
};

export type ModelAgaveVendorFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  source_id?: ModelStringInput | null,
  code?: ModelStringInput | null,
  email?: ModelStringInput | null,
  fax?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  status?: ModelAgaveVendorStatusInput | null,
  tax_number?: ModelStringInput | null,
  terms?: ModelStringInput | null,
  type?: ModelAgaveVendorTypeInput | null,
  website?: ModelStringInput | null,
  source_create_time?: ModelStringInput | null,
  source_update_time?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  and?: Array< ModelAgaveVendorFilterInput | null > | null,
  or?: Array< ModelAgaveVendorFilterInput | null > | null,
  not?: ModelAgaveVendorFilterInput | null,
};

export type ModelAgaveVendorConnection = {
  __typename: "ModelAgaveVendorConnection",
  items:  Array<AgaveVendor | null >,
  nextToken?: string | null,
};

export type PaidolTheme = {
  __typename: "PaidolTheme",
  id: string,
  paidolId: string,
  palette?: ColorPalette | null,
  createdAt: string,
  updatedAt: string,
};

export type ColorPalette = {
  __typename: "ColorPalette",
  primary?: string | null,
  primaryDark?: string | null,
  primaryDarker?: string | null,
  primaryLight?: string | null,
  primaryLighter?: string | null,
  secondary?: string | null,
  secondaryDark?: string | null,
  textPrimary?: string | null,
  textSecondary?: string | null,
  whiteColor?: string | null,
  successColor?: string | null,
  warningColor?: string | null,
  errorColor?: string | null,
  errorLightColor?: string | null,
  lightestGrayColor?: string | null,
  lightGrayColor?: string | null,
  lightBlueColor?: string | null,
  info?: string | null,
  statusSuccess?: string | null,
  statusWarning?: string | null,
  statusError?: string | null,
  neutral95?: string | null,
  neutralVariant25?: string | null,
  neutral50?: string | null,
  neutral90?: string | null,
  surfaceContainerHigh?: string | null,
  orange100?: string | null,
  orange300?: string | null,
  orange700?: string | null,
  green50?: string | null,
  green700?: string | null,
  red50?: string | null,
  red700?: string | null,
  link400?: string | null,
};

export type ModelPaidolThemeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolThemeFilterInput | null > | null,
  or?: Array< ModelPaidolThemeFilterInput | null > | null,
  not?: ModelPaidolThemeFilterInput | null,
};

export type ModelPaidolThemeConnection = {
  __typename: "ModelPaidolThemeConnection",
  items:  Array<PaidolTheme | null >,
  nextToken?: string | null,
};

export type ModelPaidolUserFilterInput = {
  id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  position?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  roles?: ModelRoleInput | null,
  is_test_fixture?: ModelBooleanInput | null,
  authorizedUserId?: ModelStringInput | null,
  authorizedUserApplicationId?: ModelStringInput | null,
  allowedJobCodes?: ModelStringInput | null,
  employee_id?: ModelIntInput | null,
  defaultAgaveEmployeeId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  landingPagePreference?: ModelLandingPagePreferenceInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolUserFilterInput | null > | null,
  or?: Array< ModelPaidolUserFilterInput | null > | null,
  not?: ModelPaidolUserFilterInput | null,
};

export type ModelRoleInput = {
  eq?: Role | null,
  ne?: Role | null,
};

export type ModelLandingPagePreferenceInput = {
  eq?: LandingPagePreference | null,
  ne?: LandingPagePreference | null,
};

export type ModelPaidolFilterInput = {
  id?: ModelIDInput | null,
  id_base58?: ModelStringInput | null,
  id_base58_short?: ModelStringInput | null,
  owner_paidol_id?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  legal_name?: ModelStringInput | null,
  account_balance?: ModelStringInput | null,
  name?: ModelStringInput | null,
  dba?: ModelStringInput | null,
  ein?: ModelStringInput | null,
  mcc?: ModelStringInput | null,
  corp_type?: ModelStringInput | null,
  industry?: ModelStringInput | null,
  company_email?: ModelStringInput | null,
  customer_facing_email?: ModelStringInput | null,
  company_phone?: ModelStringInput | null,
  website?: ModelStringInput | null,
  business_owner_ssn?: ModelStringInput | null,
  dwolla_business_industry_classification?: ModelStringInput | null,
  admin_user_id?: ModelStringInput | null,
  low_balance_alert_threshold?: ModelIntInput | null,
  low_balance_auto_funding_amount?: ModelIntInput | null,
  low_balance_auto_funding_threshold?: ModelIntInput | null,
  speedscore?: ModelIntInput | null,
  priority_status?: ModelStringInput | null,
  deleted_at?: ModelStringInput | null,
  company_id?: ModelStringInput | null,
  logo?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  agave_data_sync_in_progress?: ModelBooleanInput | null,
  submittedBankAccounts?: ModelStringInput | null,
  achEnabled?: ModelBooleanInput | null,
  virtualCardRequested?: ModelBooleanInput | null,
  virtualCardEnabled?: ModelBooleanInput | null,
  achRequested?: ModelBooleanInput | null,
  cron_status?: ModelCronStatusInput | null,
  owner_sub?: ModelStringInput | null,
  is_test_fixture?: ModelBooleanInput | null,
  is_migration?: ModelBooleanInput | null,
  enablePCards?: ModelBooleanInput | null,
  approveWithoutReceipts?: ModelBooleanInput | null,
  isConstructionType?: ModelBooleanInput | null,
  agaveAccountToken?: ModelStringInput | null,
  agaveSourceSystemSlug?: ModelStringInput | null,
  isAgaveClient?: ModelBooleanInput | null,
  erpSpeedchain?: ModelBooleanInput | null,
  erpConnectionId?: ModelStringInput | null,
  priorErpRealmId?: ModelStringInput | null,
  priorErpName?: ModelStringInput | null,
  erpCutoverReconciledAt?: ModelStringInput | null,
  selectedERP?: ModelERPInput | null,
  logoUrl?: ModelStringInput | null,
  isProcoreClient?: ModelBooleanInput | null,
  creditLimit?: ModelFloatInput | null,
  intacctProjectsNotLicensed?: ModelBooleanInput | null,
  intacctTopLevelProjectPosting?: ModelBooleanInput | null,
  paymentTermDays?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolFilterInput | null > | null,
  or?: Array< ModelPaidolFilterInput | null > | null,
  not?: ModelPaidolFilterInput | null,
};

export type ModelERPInput = {
  eq?: ERP | null,
  ne?: ERP | null,
};

export type ModelPaidolConnection = {
  __typename: "ModelPaidolConnection",
  items?:  Array<Paidol | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchablePaidolFilterInput = {
  id?: SearchableIDFilterInput | null,
  id_base58?: SearchableStringFilterInput | null,
  id_base58_short?: SearchableStringFilterInput | null,
  owner_paidol_id?: SearchableIDFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  legal_name?: SearchableStringFilterInput | null,
  account_balance?: SearchableStringFilterInput | null,
  name?: SearchableStringFilterInput | null,
  dba?: SearchableStringFilterInput | null,
  ein?: SearchableStringFilterInput | null,
  mcc?: SearchableStringFilterInput | null,
  corp_type?: SearchableStringFilterInput | null,
  industry?: SearchableStringFilterInput | null,
  company_email?: SearchableStringFilterInput | null,
  customer_facing_email?: SearchableStringFilterInput | null,
  company_phone?: SearchableStringFilterInput | null,
  website?: SearchableStringFilterInput | null,
  business_owner_ssn?: SearchableStringFilterInput | null,
  dwolla_business_industry_classification?: SearchableStringFilterInput | null,
  admin_user_id?: SearchableStringFilterInput | null,
  low_balance_alert_threshold?: SearchableIntFilterInput | null,
  low_balance_auto_funding_amount?: SearchableIntFilterInput | null,
  low_balance_auto_funding_threshold?: SearchableIntFilterInput | null,
  speedscore?: SearchableIntFilterInput | null,
  priority_status?: SearchableStringFilterInput | null,
  deleted_at?: SearchableStringFilterInput | null,
  company_id?: SearchableStringFilterInput | null,
  logo?: SearchableStringFilterInput | null,
  priority_response?: SearchableStringFilterInput | null,
  agave_data_sync_in_progress?: SearchableBooleanFilterInput | null,
  submittedBankAccounts?: SearchableStringFilterInput | null,
  achEnabled?: SearchableBooleanFilterInput | null,
  virtualCardRequested?: SearchableBooleanFilterInput | null,
  virtualCardEnabled?: SearchableBooleanFilterInput | null,
  achRequested?: SearchableBooleanFilterInput | null,
  owner_sub?: SearchableStringFilterInput | null,
  is_test_fixture?: SearchableBooleanFilterInput | null,
  is_migration?: SearchableBooleanFilterInput | null,
  enablePCards?: SearchableBooleanFilterInput | null,
  approveWithoutReceipts?: SearchableBooleanFilterInput | null,
  isConstructionType?: SearchableBooleanFilterInput | null,
  agaveAccountToken?: SearchableStringFilterInput | null,
  agaveSourceSystemSlug?: SearchableStringFilterInput | null,
  isAgaveClient?: SearchableBooleanFilterInput | null,
  erpSpeedchain?: SearchableBooleanFilterInput | null,
  erpConnectionId?: SearchableStringFilterInput | null,
  priorErpRealmId?: SearchableStringFilterInput | null,
  priorErpName?: SearchableStringFilterInput | null,
  erpCutoverReconciledAt?: SearchableStringFilterInput | null,
  logoUrl?: SearchableStringFilterInput | null,
  isProcoreClient?: SearchableBooleanFilterInput | null,
  creditLimit?: SearchableFloatFilterInput | null,
  intacctProjectsNotLicensed?: SearchableBooleanFilterInput | null,
  intacctTopLevelProjectPosting?: SearchableBooleanFilterInput | null,
  paymentTermDays?: SearchableIntFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  cron_status?: SearchableStringFilterInput | null,
  selectedERP?: SearchableStringFilterInput | null,
  and?: Array< SearchablePaidolFilterInput | null > | null,
  or?: Array< SearchablePaidolFilterInput | null > | null,
  not?: SearchablePaidolFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchablePaidolSortInput = {
  field?: SearchablePaidolSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePaidolSortableFields {
  id = "id",
  id_base58 = "id_base58",
  id_base58_short = "id_base58_short",
  owner_paidol_id = "owner_paidol_id",
  slug = "slug",
  legal_name = "legal_name",
  account_balance = "account_balance",
  name = "name",
  dba = "dba",
  ein = "ein",
  mcc = "mcc",
  corp_type = "corp_type",
  industry = "industry",
  company_email = "company_email",
  customer_facing_email = "customer_facing_email",
  company_phone = "company_phone",
  website = "website",
  business_owner_ssn = "business_owner_ssn",
  dwolla_business_industry_classification = "dwolla_business_industry_classification",
  admin_user_id = "admin_user_id",
  low_balance_alert_threshold = "low_balance_alert_threshold",
  low_balance_auto_funding_amount = "low_balance_auto_funding_amount",
  low_balance_auto_funding_threshold = "low_balance_auto_funding_threshold",
  speedscore = "speedscore",
  priority_status = "priority_status",
  deleted_at = "deleted_at",
  company_id = "company_id",
  logo = "logo",
  priority_response = "priority_response",
  agave_data_sync_in_progress = "agave_data_sync_in_progress",
  submittedBankAccounts = "submittedBankAccounts",
  achEnabled = "achEnabled",
  virtualCardRequested = "virtualCardRequested",
  virtualCardEnabled = "virtualCardEnabled",
  achRequested = "achRequested",
  owner_sub = "owner_sub",
  is_test_fixture = "is_test_fixture",
  is_migration = "is_migration",
  enablePCards = "enablePCards",
  approveWithoutReceipts = "approveWithoutReceipts",
  isConstructionType = "isConstructionType",
  agaveAccountToken = "agaveAccountToken",
  agaveSourceSystemSlug = "agaveSourceSystemSlug",
  isAgaveClient = "isAgaveClient",
  erpSpeedchain = "erpSpeedchain",
  erpConnectionId = "erpConnectionId",
  priorErpRealmId = "priorErpRealmId",
  priorErpName = "priorErpName",
  erpCutoverReconciledAt = "erpCutoverReconciledAt",
  logoUrl = "logoUrl",
  isProcoreClient = "isProcoreClient",
  creditLimit = "creditLimit",
  intacctProjectsNotLicensed = "intacctProjectsNotLicensed",
  intacctTopLevelProjectPosting = "intacctTopLevelProjectPosting",
  paymentTermDays = "paymentTermDays",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchablePaidolAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePaidolAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
  cardinality = "cardinality",
}


export enum SearchablePaidolAggregateField {
  id = "id",
  id_base58 = "id_base58",
  id_base58_short = "id_base58_short",
  owner_paidol_id = "owner_paidol_id",
  slug = "slug",
  legal_name = "legal_name",
  account_balance = "account_balance",
  name = "name",
  dba = "dba",
  ein = "ein",
  mcc = "mcc",
  corp_type = "corp_type",
  industry = "industry",
  company_email = "company_email",
  customer_facing_email = "customer_facing_email",
  company_phone = "company_phone",
  website = "website",
  business_owner_ssn = "business_owner_ssn",
  dwolla_business_industry_classification = "dwolla_business_industry_classification",
  admin_user_id = "admin_user_id",
  low_balance_alert_threshold = "low_balance_alert_threshold",
  low_balance_auto_funding_amount = "low_balance_auto_funding_amount",
  low_balance_auto_funding_threshold = "low_balance_auto_funding_threshold",
  speedscore = "speedscore",
  priority_status = "priority_status",
  deleted_at = "deleted_at",
  company_id = "company_id",
  logo = "logo",
  priority_response = "priority_response",
  agave_data_sync_in_progress = "agave_data_sync_in_progress",
  submittedBankAccounts = "submittedBankAccounts",
  achEnabled = "achEnabled",
  virtualCardRequested = "virtualCardRequested",
  virtualCardEnabled = "virtualCardEnabled",
  achRequested = "achRequested",
  cron_status = "cron_status",
  owner_sub = "owner_sub",
  is_test_fixture = "is_test_fixture",
  is_migration = "is_migration",
  enablePCards = "enablePCards",
  approveWithoutReceipts = "approveWithoutReceipts",
  isConstructionType = "isConstructionType",
  agaveAccountToken = "agaveAccountToken",
  agaveSourceSystemSlug = "agaveSourceSystemSlug",
  isAgaveClient = "isAgaveClient",
  erpSpeedchain = "erpSpeedchain",
  erpConnectionId = "erpConnectionId",
  priorErpRealmId = "priorErpRealmId",
  priorErpName = "priorErpName",
  erpCutoverReconciledAt = "erpCutoverReconciledAt",
  selectedERP = "selectedERP",
  logoUrl = "logoUrl",
  isProcoreClient = "isProcoreClient",
  creditLimit = "creditLimit",
  intacctProjectsNotLicensed = "intacctProjectsNotLicensed",
  intacctTopLevelProjectPosting = "intacctTopLevelProjectPosting",
  paymentTermDays = "paymentTermDays",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePaidolConnection = {
  __typename: "SearchablePaidolConnection",
  items:  Array<Paidol | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type ModelPaidolAgaveSyncFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  inProgress?: ModelBooleanInput | null,
  error?: ModelStringInput | null,
  lastRunStart?: ModelStringInput | null,
  lastRunEnd?: ModelStringInput | null,
  taskArn?: ModelStringInput | null,
  syncEntityFilter?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolAgaveSyncFilterInput | null > | null,
  or?: Array< ModelPaidolAgaveSyncFilterInput | null > | null,
  not?: ModelPaidolAgaveSyncFilterInput | null,
};

export type ModelPaidolAgaveSyncConnection = {
  __typename: "ModelPaidolAgaveSyncConnection",
  items:  Array<PaidolAgaveSync | null >,
  nextToken?: string | null,
};

export type ModelPaymentFileQueueFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  status?: ModelPaymentFileQueueStatusEnumInput | null,
  processed_at?: ModelStringInput | null,
  error_messages?: ModelStringInput | null,
  num_vendors?: ModelIntInput | null,
  num_payments?: ModelIntInput | null,
  num_success?: ModelIntInput | null,
  num_failed?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  supplier_vendor_paidol_ids?: ModelStringInput | null,
  referenced_vendors?: ModelStringInput | null,
  invoice_ids?: ModelStringInput | null,
  invoice_spx_ids?: ModelStringInput | null,
  priority_status?: ModelStringInput | null,
  priority_file_id?: ModelStringInput | null,
  priority_process_on?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaymentFileQueueFilterInput | null > | null,
  or?: Array< ModelPaymentFileQueueFilterInput | null > | null,
  not?: ModelPaymentFileQueueFilterInput | null,
};

export type ModelPaymentFileQueueConnection = {
  __typename: "ModelPaymentFileQueueConnection",
  items:  Array<PaymentFileQueue | null >,
  nextToken?: string | null,
};

export type SearchablePaymentFileQueueFilterInput = {
  id?: SearchableIDFilterInput | null,
  user_id?: SearchableIDFilterInput | null,
  paidol_id?: SearchableIDFilterInput | null,
  key?: SearchableStringFilterInput | null,
  processed_at?: SearchableStringFilterInput | null,
  error_messages?: SearchableStringFilterInput | null,
  num_vendors?: SearchableIntFilterInput | null,
  num_payments?: SearchableIntFilterInput | null,
  num_success?: SearchableIntFilterInput | null,
  num_failed?: SearchableIntFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  filename?: SearchableStringFilterInput | null,
  supplier_vendor_paidol_ids?: SearchableStringFilterInput | null,
  referenced_vendors?: SearchableStringFilterInput | null,
  invoice_ids?: SearchableStringFilterInput | null,
  invoice_spx_ids?: SearchableStringFilterInput | null,
  priority_status?: SearchableStringFilterInput | null,
  priority_file_id?: SearchableStringFilterInput | null,
  priority_process_on?: SearchableStringFilterInput | null,
  priority_response?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  and?: Array< SearchablePaymentFileQueueFilterInput | null > | null,
  or?: Array< SearchablePaymentFileQueueFilterInput | null > | null,
  not?: SearchablePaymentFileQueueFilterInput | null,
};

export type SearchablePaymentFileQueueSortInput = {
  field?: SearchablePaymentFileQueueSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePaymentFileQueueSortableFields {
  id = "id",
  user_id = "user_id",
  paidol_id = "paidol_id",
  key = "key",
  processed_at = "processed_at",
  error_messages = "error_messages",
  num_vendors = "num_vendors",
  num_payments = "num_payments",
  num_success = "num_success",
  num_failed = "num_failed",
  createdAt = "createdAt",
  filename = "filename",
  supplier_vendor_paidol_ids = "supplier_vendor_paidol_ids",
  referenced_vendors = "referenced_vendors",
  invoice_ids = "invoice_ids",
  invoice_spx_ids = "invoice_spx_ids",
  priority_status = "priority_status",
  priority_file_id = "priority_file_id",
  priority_process_on = "priority_process_on",
  priority_response = "priority_response",
  updatedAt = "updatedAt",
}


export type SearchablePaymentFileQueueAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePaymentFileQueueAggregateField,
};

export enum SearchablePaymentFileQueueAggregateField {
  id = "id",
  user_id = "user_id",
  paidol_id = "paidol_id",
  key = "key",
  status = "status",
  processed_at = "processed_at",
  error_messages = "error_messages",
  num_vendors = "num_vendors",
  num_payments = "num_payments",
  num_success = "num_success",
  num_failed = "num_failed",
  createdAt = "createdAt",
  filename = "filename",
  supplier_vendor_paidol_ids = "supplier_vendor_paidol_ids",
  referenced_vendors = "referenced_vendors",
  invoice_ids = "invoice_ids",
  invoice_spx_ids = "invoice_spx_ids",
  priority_status = "priority_status",
  priority_file_id = "priority_file_id",
  priority_process_on = "priority_process_on",
  priority_response = "priority_response",
  updatedAt = "updatedAt",
}


export type SearchablePaymentFileQueueConnection = {
  __typename: "SearchablePaymentFileQueueConnection",
  items:  Array<PaymentFileQueue | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPaidolVendorFilterInput = {
  id?: ModelIDInput | null,
  user_vendor_id?: ModelStringInput | null,
  is_migration?: ModelBooleanInput | null,
  paidol_id?: ModelIDInput | null,
  vendor_paidol_id?: ModelIDInput | null,
  priority_active?: ModelStringInput | null,
  payment_terms?: ModelStringInput | null,
  priority_account_balance?: ModelFloatInput | null,
  contact_name?: ModelStringInput | null,
  priority_billing_code?: ModelStringInput | null,
  priority_repeate_code?: ModelStringInput | null,
  priority_group_code?: ModelStringInput | null,
  email_addresses?: ModelStringInput | null,
  priority_document_delivery?: ModelStringInput | null,
  priority_regular_inv?: ModelStringInput | null,
  priority_summary_inv?: ModelStringInput | null,
  foreign_name?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  box_1099?: ModelStringInput | null,
  form_code_1099?: ModelStringInput | null,
  remark_1?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  cron_status?: ModelCronStatusInput | null,
  priority_status?: ModelStringInput | null,
  priority_supplier_id?: ModelStringInput | null,
  virtual_card_email?: ModelStringInput | null,
  achEnabled?: ModelBooleanInput | null,
  virtualCardEnabled?: ModelBooleanInput | null,
  checkIssuingEnabled?: ModelBooleanInput | null,
  checkIssuingPayableTo?: ModelStringInput | null,
  checkIssuingStreet?: ModelStringInput | null,
  checkIssuingCity?: ModelStringInput | null,
  checkIssuingState?: ModelStringInput | null,
  checkIssuingCountry?: ModelStringInput | null,
  checkIssuingPostalCode?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolVendorFilterInput | null > | null,
  or?: Array< ModelPaidolVendorFilterInput | null > | null,
  not?: ModelPaidolVendorFilterInput | null,
};

export type ModelPaidolVendorConnection = {
  __typename: "ModelPaidolVendorConnection",
  items:  Array<PaidolVendor | null >,
  nextToken?: string | null,
};

export type SearchablePaidolVendorFilterInput = {
  id?: SearchableIDFilterInput | null,
  user_vendor_id?: SearchableStringFilterInput | null,
  is_migration?: SearchableBooleanFilterInput | null,
  paidol_id?: SearchableIDFilterInput | null,
  vendor_paidol_id?: SearchableIDFilterInput | null,
  priority_active?: SearchableStringFilterInput | null,
  payment_terms?: SearchableStringFilterInput | null,
  priority_account_balance?: SearchableFloatFilterInput | null,
  contact_name?: SearchableStringFilterInput | null,
  priority_billing_code?: SearchableStringFilterInput | null,
  priority_repeate_code?: SearchableStringFilterInput | null,
  priority_group_code?: SearchableStringFilterInput | null,
  email_addresses?: SearchableStringFilterInput | null,
  priority_document_delivery?: SearchableStringFilterInput | null,
  priority_regular_inv?: SearchableStringFilterInput | null,
  priority_summary_inv?: SearchableStringFilterInput | null,
  foreign_name?: SearchableStringFilterInput | null,
  remarks?: SearchableStringFilterInput | null,
  box_1099?: SearchableStringFilterInput | null,
  form_code_1099?: SearchableStringFilterInput | null,
  remark_1?: SearchableStringFilterInput | null,
  priority_response?: SearchableStringFilterInput | null,
  priority_status?: SearchableStringFilterInput | null,
  priority_supplier_id?: SearchableStringFilterInput | null,
  virtual_card_email?: SearchableStringFilterInput | null,
  achEnabled?: SearchableBooleanFilterInput | null,
  virtualCardEnabled?: SearchableBooleanFilterInput | null,
  checkIssuingEnabled?: SearchableBooleanFilterInput | null,
  checkIssuingPayableTo?: SearchableStringFilterInput | null,
  checkIssuingStreet?: SearchableStringFilterInput | null,
  checkIssuingCity?: SearchableStringFilterInput | null,
  checkIssuingState?: SearchableStringFilterInput | null,
  checkIssuingCountry?: SearchableStringFilterInput | null,
  checkIssuingPostalCode?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  cron_status?: SearchableStringFilterInput | null,
  and?: Array< SearchablePaidolVendorFilterInput | null > | null,
  or?: Array< SearchablePaidolVendorFilterInput | null > | null,
  not?: SearchablePaidolVendorFilterInput | null,
};

export type SearchablePaidolVendorSortInput = {
  field?: SearchablePaidolVendorSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePaidolVendorSortableFields {
  id = "id",
  user_vendor_id = "user_vendor_id",
  is_migration = "is_migration",
  paidol_id = "paidol_id",
  vendor_paidol_id = "vendor_paidol_id",
  priority_active = "priority_active",
  payment_terms = "payment_terms",
  priority_account_balance = "priority_account_balance",
  contact_name = "contact_name",
  priority_billing_code = "priority_billing_code",
  priority_repeate_code = "priority_repeate_code",
  priority_group_code = "priority_group_code",
  email_addresses = "email_addresses",
  priority_document_delivery = "priority_document_delivery",
  priority_regular_inv = "priority_regular_inv",
  priority_summary_inv = "priority_summary_inv",
  foreign_name = "foreign_name",
  remarks = "remarks",
  box_1099 = "box_1099",
  form_code_1099 = "form_code_1099",
  remark_1 = "remark_1",
  priority_response = "priority_response",
  priority_status = "priority_status",
  priority_supplier_id = "priority_supplier_id",
  virtual_card_email = "virtual_card_email",
  achEnabled = "achEnabled",
  virtualCardEnabled = "virtualCardEnabled",
  checkIssuingEnabled = "checkIssuingEnabled",
  checkIssuingPayableTo = "checkIssuingPayableTo",
  checkIssuingStreet = "checkIssuingStreet",
  checkIssuingCity = "checkIssuingCity",
  checkIssuingState = "checkIssuingState",
  checkIssuingCountry = "checkIssuingCountry",
  checkIssuingPostalCode = "checkIssuingPostalCode",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePaidolVendorAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePaidolVendorAggregateField,
};

export enum SearchablePaidolVendorAggregateField {
  id = "id",
  user_vendor_id = "user_vendor_id",
  is_migration = "is_migration",
  paidol_id = "paidol_id",
  vendor_paidol_id = "vendor_paidol_id",
  priority_active = "priority_active",
  payment_terms = "payment_terms",
  priority_account_balance = "priority_account_balance",
  contact_name = "contact_name",
  priority_billing_code = "priority_billing_code",
  priority_repeate_code = "priority_repeate_code",
  priority_group_code = "priority_group_code",
  email_addresses = "email_addresses",
  priority_document_delivery = "priority_document_delivery",
  priority_regular_inv = "priority_regular_inv",
  priority_summary_inv = "priority_summary_inv",
  foreign_name = "foreign_name",
  remarks = "remarks",
  box_1099 = "box_1099",
  form_code_1099 = "form_code_1099",
  remark_1 = "remark_1",
  priority_response = "priority_response",
  cron_status = "cron_status",
  priority_status = "priority_status",
  priority_supplier_id = "priority_supplier_id",
  virtual_card_email = "virtual_card_email",
  achEnabled = "achEnabled",
  virtualCardEnabled = "virtualCardEnabled",
  checkIssuingEnabled = "checkIssuingEnabled",
  checkIssuingPayableTo = "checkIssuingPayableTo",
  checkIssuingStreet = "checkIssuingStreet",
  checkIssuingCity = "checkIssuingCity",
  checkIssuingState = "checkIssuingState",
  checkIssuingCountry = "checkIssuingCountry",
  checkIssuingPostalCode = "checkIssuingPostalCode",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePaidolVendorConnection = {
  __typename: "SearchablePaidolVendorConnection",
  items:  Array<PaidolVendor | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelInvoiceFilterInput = {
  id?: ModelIDInput | null,
  id_base58?: ModelStringInput | null,
  id_base58_short?: ModelStringInput | null,
  payment_file_queue_id?: ModelIDInput | null,
  buyer_paidol_id?: ModelIDInput | null,
  paidol_vendor_id?: ModelIDInput | null,
  supplier_paidol_id?: ModelIDInput | null,
  user_invoice_id?: ModelStringInput | null,
  date?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  transaction_id?: ModelStringInput | null,
  priority_payment_id?: ModelStringInput | null,
  priority_payment_status?: ModelStringInput | null,
  priority_payment_type?: ModelStringInput | null,
  priority_payment_date?: ModelStringInput | null,
  priority_payment_auth_message?: ModelStringInput | null,
  priority_response?: ModelStringInput | null,
  status?: ModelPaymentFileQueueStatusEnumInput | null,
  and?: Array< ModelInvoiceFilterInput | null > | null,
  or?: Array< ModelInvoiceFilterInput | null > | null,
  not?: ModelInvoiceFilterInput | null,
};

export type ModelInvoiceConnection = {
  __typename: "ModelInvoiceConnection",
  items:  Array<Invoice | null >,
  nextToken?: string | null,
};

export type ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyConditionInput = {
  eq?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
  le?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
  lt?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
  ge?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
  gt?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
  between?: Array< ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null > | null,
  beginsWith?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput | null,
};

export type ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyInput = {
  user_invoice_id?: string | null,
  supplier_paidol_id?: string | null,
};

export type ModelInvoiceByUserInvoiceIdCompositeKeyConditionInput = {
  eq?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
  le?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
  lt?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
  ge?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
  gt?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
  between?: Array< ModelInvoiceByUserInvoiceIdCompositeKeyInput | null > | null,
  beginsWith?: ModelInvoiceByUserInvoiceIdCompositeKeyInput | null,
};

export type ModelInvoiceByUserInvoiceIdCompositeKeyInput = {
  buyer_paidol_id?: string | null,
  supplier_paidol_id?: string | null,
};

export type ModelSupplierFileQueueFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  status?: ModelSupplierFileQueueStatusEnumInput | null,
  processed_at?: ModelStringInput | null,
  error_messages?: ModelStringInput | null,
  num_vendors?: ModelIntInput | null,
  num_success?: ModelIntInput | null,
  num_failed?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  is_migration?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSupplierFileQueueFilterInput | null > | null,
  or?: Array< ModelSupplierFileQueueFilterInput | null > | null,
  not?: ModelSupplierFileQueueFilterInput | null,
};

export type ModelSupplierFileQueueConnection = {
  __typename: "ModelSupplierFileQueueConnection",
  items:  Array<SupplierFileQueue | null >,
  nextToken?: string | null,
};

export type ModelPaymentStatusDownloadFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  s3_key?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaymentStatusDownloadFilterInput | null > | null,
  or?: Array< ModelPaymentStatusDownloadFilterInput | null > | null,
  not?: ModelPaymentStatusDownloadFilterInput | null,
};

export type ModelPaymentStatusDownloadConnection = {
  __typename: "ModelPaymentStatusDownloadConnection",
  items:  Array<PaymentStatusDownload | null >,
  nextToken?: string | null,
};

export type ModelPaidolHighnoteIntegrationFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  legalBusinessName?: ModelStringInput | null,
  businessAccountHolderId?: ModelIDInput | null,
  primaryAuthorizedPersonId?: ModelIDInput | null,
  financialAccountId?: ModelIDInput | null,
  externalFinancialBankAccountId?: ModelIDInput | null,
  hasInitialFunding?: ModelBooleanInput | null,
  accountHolderCardProductApplicationId?: ModelIDInput | null,
  isApplicationAccepted?: ModelBooleanInput | null,
  isDisconnected?: ModelBooleanInput | null,
  highnoteProductId?: ModelIDInput | null,
  finicityCustomerId?: ModelStringInput | null,
  dwollaCustomerId?: ModelStringInput | null,
  cardProfileId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolHighnoteIntegrationFilterInput | null > | null,
  or?: Array< ModelPaidolHighnoteIntegrationFilterInput | null > | null,
  not?: ModelPaidolHighnoteIntegrationFilterInput | null,
};

export type ModelPaidolHighnoteIntegrationConnection = {
  __typename: "ModelPaidolHighnoteIntegrationConnection",
  items:  Array<PaidolHighnoteIntegration | null >,
  nextToken?: string | null,
};

export type ModelHighnotePaymentCardFilterInput = {
  paymentCardId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  cardGroupId?: ModelIDInput | null,
  status?: ModelHNPaymentCardStatusInput | null,
  bin?: ModelStringInput | null,
  last4?: ModelStringInput | null,
  network?: ModelHNPaymentCardNetworkInput | null,
  formFactor?: ModelHNCardFormFactorInput | null,
  expirationDate?: ModelStringInput | null,
  hasPin?: ModelBooleanInput | null,
  cardholderId?: ModelIDInput | null,
  cardholderName?: ModelStringInput | null,
  isAdminLocked?: ModelBooleanInput | null,
  lastActionByRole?: ModelStringInput | null,
  lastActionByPaidolUserId?: ModelIDInput | null,
  lastActionByName?: ModelStringInput | null,
  lastActionByEmail?: ModelStringInput | null,
  lastActionAt?: ModelStringInput | null,
  merchantSpendRuleId?: ModelIDInput | null,
  isAuthorizedUserCard?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHighnotePaymentCardFilterInput | null > | null,
  or?: Array< ModelHighnotePaymentCardFilterInput | null > | null,
  not?: ModelHighnotePaymentCardFilterInput | null,
};

export type SearchableHighnotePaymentCardFilterInput = {
  paymentCardId?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  cardGroupId?: SearchableIDFilterInput | null,
  bin?: SearchableStringFilterInput | null,
  last4?: SearchableStringFilterInput | null,
  expirationDate?: SearchableStringFilterInput | null,
  hasPin?: SearchableBooleanFilterInput | null,
  cardholderId?: SearchableIDFilterInput | null,
  cardholderName?: SearchableStringFilterInput | null,
  isAdminLocked?: SearchableBooleanFilterInput | null,
  lastActionByRole?: SearchableStringFilterInput | null,
  lastActionByPaidolUserId?: SearchableIDFilterInput | null,
  lastActionByName?: SearchableStringFilterInput | null,
  lastActionByEmail?: SearchableStringFilterInput | null,
  lastActionAt?: SearchableStringFilterInput | null,
  merchantSpendRuleId?: SearchableIDFilterInput | null,
  isAuthorizedUserCard?: SearchableBooleanFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  network?: SearchableStringFilterInput | null,
  formFactor?: SearchableStringFilterInput | null,
  and?: Array< SearchableHighnotePaymentCardFilterInput | null > | null,
  or?: Array< SearchableHighnotePaymentCardFilterInput | null > | null,
  not?: SearchableHighnotePaymentCardFilterInput | null,
};

export type SearchableHighnotePaymentCardSortInput = {
  field?: SearchableHighnotePaymentCardSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableHighnotePaymentCardSortableFields {
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  cardGroupId = "cardGroupId",
  bin = "bin",
  last4 = "last4",
  expirationDate = "expirationDate",
  hasPin = "hasPin",
  cardholderId = "cardholderId",
  cardholderName = "cardholderName",
  isAdminLocked = "isAdminLocked",
  lastActionByRole = "lastActionByRole",
  lastActionByPaidolUserId = "lastActionByPaidolUserId",
  lastActionByName = "lastActionByName",
  lastActionByEmail = "lastActionByEmail",
  lastActionAt = "lastActionAt",
  merchantSpendRuleId = "merchantSpendRuleId",
  isAuthorizedUserCard = "isAuthorizedUserCard",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnotePaymentCardAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableHighnotePaymentCardAggregateField,
};

export enum SearchableHighnotePaymentCardAggregateField {
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  cardGroupId = "cardGroupId",
  status = "status",
  bin = "bin",
  last4 = "last4",
  network = "network",
  formFactor = "formFactor",
  expirationDate = "expirationDate",
  hasPin = "hasPin",
  cardholderId = "cardholderId",
  cardholderName = "cardholderName",
  isAdminLocked = "isAdminLocked",
  lastActionByRole = "lastActionByRole",
  lastActionByPaidolUserId = "lastActionByPaidolUserId",
  lastActionByName = "lastActionByName",
  lastActionByEmail = "lastActionByEmail",
  lastActionAt = "lastActionAt",
  merchantSpendRuleId = "merchantSpendRuleId",
  isAuthorizedUserCard = "isAuthorizedUserCard",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnotePaymentCardConnection = {
  __typename: "SearchableHighnotePaymentCardConnection",
  items:  Array<HighnotePaymentCard | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSpendRulesFilterInput = {
  spendRuleId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  merchantCategoryAllowed?: ModelStringInput | null,
  merchantCategoryBlocked?: ModelStringInput | null,
  merchantCountryAllowed?: ModelStringInput | null,
  merchantCountryBlocked?: ModelStringInput | null,
  streetAddressAllowed?: ModelStringInput | null,
  streetAddressBlocked?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSpendRulesFilterInput | null > | null,
  or?: Array< ModelSpendRulesFilterInput | null > | null,
  not?: ModelSpendRulesFilterInput | null,
};

export type ModelSpendRulesConnection = {
  __typename: "ModelSpendRulesConnection",
  items:  Array<SpendRules | null >,
  nextToken?: string | null,
};

export type ModelVelocityRulesFilterInput = {
  velocityRuleId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  cumulativeRuleId?: ModelIDInput | null,
  monthlyLimitResetTimestamp?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVelocityRulesFilterInput | null > | null,
  or?: Array< ModelVelocityRulesFilterInput | null > | null,
  not?: ModelVelocityRulesFilterInput | null,
};

export type ModelVelocityRulesConnection = {
  __typename: "ModelVelocityRulesConnection",
  items:  Array<VelocityRules | null >,
  nextToken?: string | null,
};

export type BudgetSpendByMonth = {
  __typename: "BudgetSpendByMonth",
  paidolId: string,
  authPaidolId: string,
  yearAndMonth: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBudgetSpendByMonthFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBudgetSpendByMonthFilterInput | null > | null,
  or?: Array< ModelBudgetSpendByMonthFilterInput | null > | null,
  not?: ModelBudgetSpendByMonthFilterInput | null,
};

export type ModelBudgetSpendByMonthConnection = {
  __typename: "ModelBudgetSpendByMonthConnection",
  items:  Array<BudgetSpendByMonth | null >,
  nextToken?: string | null,
};

export type BudgetSpendByMonthAndMerchant = {
  __typename: "BudgetSpendByMonthAndMerchant",
  paidolId: string,
  authPaidolId: string,
  yearAndMonth: string,
  merchantName: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyInput = {
  yearAndMonth?: string | null,
  merchantName?: string | null,
};

export type ModelBudgetSpendByMonthAndMerchantFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBudgetSpendByMonthAndMerchantFilterInput | null > | null,
  or?: Array< ModelBudgetSpendByMonthAndMerchantFilterInput | null > | null,
  not?: ModelBudgetSpendByMonthAndMerchantFilterInput | null,
};

export type ModelBudgetSpendByMonthAndMerchantConnection = {
  __typename: "ModelBudgetSpendByMonthAndMerchantConnection",
  items:  Array<BudgetSpendByMonthAndMerchant | null >,
  nextToken?: string | null,
};

export type ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyInput = {
  yearAndMonth?: string | null,
  amount?: number | null,
};

export type BudgetSpendByMonthAndCategory = {
  __typename: "BudgetSpendByMonthAndCategory",
  paidolId: string,
  authPaidolId: string,
  yearAndMonth: string,
  category: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyInput = {
  yearAndMonth?: string | null,
  category?: string | null,
};

export type ModelBudgetSpendByMonthAndCategoryFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  category?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBudgetSpendByMonthAndCategoryFilterInput | null > | null,
  or?: Array< ModelBudgetSpendByMonthAndCategoryFilterInput | null > | null,
  not?: ModelBudgetSpendByMonthAndCategoryFilterInput | null,
};

export type ModelBudgetSpendByMonthAndCategoryConnection = {
  __typename: "ModelBudgetSpendByMonthAndCategoryConnection",
  items:  Array<BudgetSpendByMonthAndCategory | null >,
  nextToken?: string | null,
};

export type ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyInput = {
  yearAndMonth?: string | null,
  amount?: number | null,
};

export type BudgetSpendByMonthAndPaymentCard = {
  __typename: "BudgetSpendByMonthAndPaymentCard",
  paidolId: string,
  authPaidolId: string,
  yearAndMonth: string,
  paymentCardId: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyInput = {
  yearAndMonth?: string | null,
  paymentCardId?: string | null,
};

export type ModelBudgetSpendByMonthAndPaymentCardFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  paymentCardId?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBudgetSpendByMonthAndPaymentCardFilterInput | null > | null,
  or?: Array< ModelBudgetSpendByMonthAndPaymentCardFilterInput | null > | null,
  not?: ModelBudgetSpendByMonthAndPaymentCardFilterInput | null,
};

export type ModelBudgetSpendByMonthAndPaymentCardConnection = {
  __typename: "ModelBudgetSpendByMonthAndPaymentCardConnection",
  items:  Array<BudgetSpendByMonthAndPaymentCard | null >,
  nextToken?: string | null,
};

export type BudgetSpendByMonthAndJobCodeId = {
  __typename: "BudgetSpendByMonthAndJobCodeId",
  paidolId: string,
  authPaidolId: string,
  yearAndMonth: string,
  jobCodeId: string,
  amount?: number | null,
  transactionCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyInput = {
  yearAndMonth?: string | null,
  jobCodeId?: string | null,
};

export type ModelBudgetSpendByMonthAndJobCodeIdFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  jobCodeId?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBudgetSpendByMonthAndJobCodeIdFilterInput | null > | null,
  or?: Array< ModelBudgetSpendByMonthAndJobCodeIdFilterInput | null > | null,
  not?: ModelBudgetSpendByMonthAndJobCodeIdFilterInput | null,
};

export type ModelBudgetSpendByMonthAndJobCodeIdConnection = {
  __typename: "ModelBudgetSpendByMonthAndJobCodeIdConnection",
  items:  Array<BudgetSpendByMonthAndJobCodeId | null >,
  nextToken?: string | null,
};

export type ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyConditionInput = {
  eq?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
  le?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
  lt?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
  ge?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
  gt?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
  between?: Array< ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null > | null,
  beginsWith?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput | null,
};

export type ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyInput = {
  yearAndMonth?: string | null,
  amount?: number | null,
};

export type ModelMccFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelIntInput | null,
  highnoteDescription?: ModelHNMerchantCategoryInput | null,
  highnoteCategoryDescription?: ModelStringInput | null,
  speedchainDescription?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMccFilterInput | null > | null,
  or?: Array< ModelMccFilterInput | null > | null,
  not?: ModelMccFilterInput | null,
};

export type ModelHNMerchantCategoryInput = {
  eq?: HNMerchantCategory | null,
  ne?: HNMerchantCategory | null,
};

export type ModelMccConnection = {
  __typename: "ModelMccConnection",
  items:  Array<Mcc | null >,
  nextToken?: string | null,
};

export type ModelExpenseTypeFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelExpenseTypeFilterInput | null > | null,
  or?: Array< ModelExpenseTypeFilterInput | null > | null,
  not?: ModelExpenseTypeFilterInput | null,
};

export type ModelExpenseTypeConnection = {
  __typename: "ModelExpenseTypeConnection",
  items:  Array<ExpenseType | null >,
  nextToken?: string | null,
};

export type ModelReceiptSummaryFieldFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  type?: ModelNormalizedSummaryFieldInput | null,
  typeConfidenceScore?: ModelFloatInput | null,
  label?: ModelStringInput | null,
  labelConfidenceScore?: ModelFloatInput | null,
  value?: ModelStringInput | null,
  valueConfidenceScore?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceiptSummaryFieldFilterInput | null > | null,
  or?: Array< ModelReceiptSummaryFieldFilterInput | null > | null,
  not?: ModelReceiptSummaryFieldFilterInput | null,
};

export type SearchableReceiptSummaryFieldFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  receiptUploadId?: SearchableIDFilterInput | null,
  typeConfidenceScore?: SearchableFloatFilterInput | null,
  label?: SearchableStringFilterInput | null,
  labelConfidenceScore?: SearchableFloatFilterInput | null,
  value?: SearchableStringFilterInput | null,
  valueConfidenceScore?: SearchableFloatFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  and?: Array< SearchableReceiptSummaryFieldFilterInput | null > | null,
  or?: Array< SearchableReceiptSummaryFieldFilterInput | null > | null,
  not?: SearchableReceiptSummaryFieldFilterInput | null,
};

export type SearchableReceiptSummaryFieldSortInput = {
  field?: SearchableReceiptSummaryFieldSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReceiptSummaryFieldSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptUploadId = "receiptUploadId",
  typeConfidenceScore = "typeConfidenceScore",
  label = "label",
  labelConfidenceScore = "labelConfidenceScore",
  value = "value",
  valueConfidenceScore = "valueConfidenceScore",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptSummaryFieldAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReceiptSummaryFieldAggregateField,
};

export enum SearchableReceiptSummaryFieldAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptUploadId = "receiptUploadId",
  type = "type",
  typeConfidenceScore = "typeConfidenceScore",
  label = "label",
  labelConfidenceScore = "labelConfidenceScore",
  value = "value",
  valueConfidenceScore = "valueConfidenceScore",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptSummaryFieldConnection = {
  __typename: "SearchableReceiptSummaryFieldConnection",
  items:  Array<ReceiptSummaryField | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReceiptLineItemFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceiptLineItemFilterInput | null > | null,
  or?: Array< ModelReceiptLineItemFilterInput | null > | null,
  not?: ModelReceiptLineItemFilterInput | null,
};

export type SearchableReceiptLineItemFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  receiptUploadId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableReceiptLineItemFilterInput | null > | null,
  or?: Array< SearchableReceiptLineItemFilterInput | null > | null,
  not?: SearchableReceiptLineItemFilterInput | null,
};

export type SearchableReceiptLineItemSortInput = {
  field?: SearchableReceiptLineItemSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReceiptLineItemSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptUploadId = "receiptUploadId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptLineItemAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReceiptLineItemAggregateField,
};

export enum SearchableReceiptLineItemAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptUploadId = "receiptUploadId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptLineItemConnection = {
  __typename: "SearchableReceiptLineItemConnection",
  items:  Array<ReceiptLineItem | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReceiptLineItemFieldFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  receiptLineItemId?: ModelIDInput | null,
  type?: ModelNormalizedSummaryFieldInput | null,
  typeConfidenceScore?: ModelFloatInput | null,
  label?: ModelStringInput | null,
  labelConfidenceScore?: ModelFloatInput | null,
  value?: ModelStringInput | null,
  valueConfidenceScore?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceiptLineItemFieldFilterInput | null > | null,
  or?: Array< ModelReceiptLineItemFieldFilterInput | null > | null,
  not?: ModelReceiptLineItemFieldFilterInput | null,
};

export type SearchableReceiptLineItemFieldFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  receiptLineItemId?: SearchableIDFilterInput | null,
  typeConfidenceScore?: SearchableFloatFilterInput | null,
  label?: SearchableStringFilterInput | null,
  labelConfidenceScore?: SearchableFloatFilterInput | null,
  value?: SearchableStringFilterInput | null,
  valueConfidenceScore?: SearchableFloatFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  and?: Array< SearchableReceiptLineItemFieldFilterInput | null > | null,
  or?: Array< SearchableReceiptLineItemFieldFilterInput | null > | null,
  not?: SearchableReceiptLineItemFieldFilterInput | null,
};

export type SearchableReceiptLineItemFieldSortInput = {
  field?: SearchableReceiptLineItemFieldSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReceiptLineItemFieldSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptLineItemId = "receiptLineItemId",
  typeConfidenceScore = "typeConfidenceScore",
  label = "label",
  labelConfidenceScore = "labelConfidenceScore",
  value = "value",
  valueConfidenceScore = "valueConfidenceScore",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptLineItemFieldAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReceiptLineItemFieldAggregateField,
};

export enum SearchableReceiptLineItemFieldAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  receiptLineItemId = "receiptLineItemId",
  type = "type",
  typeConfidenceScore = "typeConfidenceScore",
  label = "label",
  labelConfidenceScore = "labelConfidenceScore",
  value = "value",
  valueConfidenceScore = "valueConfidenceScore",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptLineItemFieldConnection = {
  __typename: "SearchableReceiptLineItemFieldConnection",
  items:  Array<ReceiptLineItemField | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReceiptUploadFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  document?: ModelStringInput | null,
  status?: ModelReceiptUploadStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceiptUploadFilterInput | null > | null,
  or?: Array< ModelReceiptUploadFilterInput | null > | null,
  not?: ModelReceiptUploadFilterInput | null,
};

export type ModelReceiptUploadConnection = {
  __typename: "ModelReceiptUploadConnection",
  items:  Array<ReceiptUpload | null >,
  nextToken?: string | null,
};

export type SearchableReceiptUploadFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  document?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  and?: Array< SearchableReceiptUploadFilterInput | null > | null,
  or?: Array< SearchableReceiptUploadFilterInput | null > | null,
  not?: SearchableReceiptUploadFilterInput | null,
};

export type SearchableReceiptUploadSortInput = {
  field?: SearchableReceiptUploadSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReceiptUploadSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  document = "document",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptUploadAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReceiptUploadAggregateField,
};

export enum SearchableReceiptUploadAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  document = "document",
  status = "status",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReceiptUploadConnection = {
  __typename: "SearchableReceiptUploadConnection",
  items:  Array<ReceiptUpload | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelTransactionToReceiptUploadFilterInput = {
  id?: ModelIDInput | null,
  highnoteTransactionEventId?: ModelIDInput | null,
  reimbursementTransactionId?: ModelIDInput | null,
  receiptUploadId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  authPaidolId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionToReceiptUploadFilterInput | null > | null,
  or?: Array< ModelTransactionToReceiptUploadFilterInput | null > | null,
  not?: ModelTransactionToReceiptUploadFilterInput | null,
};

export type ModelTransactionToReceiptUploadConnection = {
  __typename: "ModelTransactionToReceiptUploadConnection",
  items:  Array<TransactionToReceiptUpload | null >,
  nextToken?: string | null,
};

export type SearchableTransactionToReceiptUploadFilterInput = {
  id?: SearchableIDFilterInput | null,
  highnoteTransactionEventId?: SearchableIDFilterInput | null,
  reimbursementTransactionId?: SearchableIDFilterInput | null,
  receiptUploadId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableTransactionToReceiptUploadFilterInput | null > | null,
  or?: Array< SearchableTransactionToReceiptUploadFilterInput | null > | null,
  not?: SearchableTransactionToReceiptUploadFilterInput | null,
};

export type SearchableTransactionToReceiptUploadSortInput = {
  field?: SearchableTransactionToReceiptUploadSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableTransactionToReceiptUploadSortableFields {
  id = "id",
  highnoteTransactionEventId = "highnoteTransactionEventId",
  reimbursementTransactionId = "reimbursementTransactionId",
  receiptUploadId = "receiptUploadId",
  createdAt = "createdAt",
  authPaidolId = "authPaidolId",
  updatedAt = "updatedAt",
}


export type SearchableTransactionToReceiptUploadAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableTransactionToReceiptUploadAggregateField,
};

export enum SearchableTransactionToReceiptUploadAggregateField {
  id = "id",
  highnoteTransactionEventId = "highnoteTransactionEventId",
  reimbursementTransactionId = "reimbursementTransactionId",
  receiptUploadId = "receiptUploadId",
  createdAt = "createdAt",
  authPaidolId = "authPaidolId",
  updatedAt = "updatedAt",
}


export type SearchableTransactionToReceiptUploadConnection = {
  __typename: "SearchableTransactionToReceiptUploadConnection",
  items:  Array<TransactionToReceiptUpload | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelTransactionFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  transactionDate?: ModelStringInput | null,
  reimbursementTransactionId?: ModelIDInput | null,
  highnoteTransactionId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
};

export type ModelTransactionConnection = {
  __typename: "ModelTransactionConnection",
  items:  Array<Transaction | null >,
  nextToken?: string | null,
};

export type SearchableTransactionFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  transactionDate?: SearchableStringFilterInput | null,
  reimbursementTransactionId?: SearchableIDFilterInput | null,
  highnoteTransactionId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableTransactionFilterInput | null > | null,
  or?: Array< SearchableTransactionFilterInput | null > | null,
  not?: SearchableTransactionFilterInput | null,
};

export type SearchableTransactionSortInput = {
  field?: SearchableTransactionSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableTransactionSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  transactionDate = "transactionDate",
  reimbursementTransactionId = "reimbursementTransactionId",
  highnoteTransactionId = "highnoteTransactionId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableTransactionAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableTransactionAggregateField,
};

export enum SearchableTransactionAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  transactionDate = "transactionDate",
  reimbursementTransactionId = "reimbursementTransactionId",
  highnoteTransactionId = "highnoteTransactionId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableTransactionConnection = {
  __typename: "SearchableTransactionConnection",
  items:  Array<Transaction | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReimbursementTransactionFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  dwollaTransferId?: ModelIDInput | null,
  transactionDate?: ModelStringInput | null,
  status?: ModelReimbursementTransactionStatusInput | null,
  checkrunStatus?: ModelReimbursementTransactionCheckrunStatusInput | null,
  note?: ModelStringInput | null,
  contestNote?: ModelStringInput | null,
  deniedNote?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  receiptLineItems?: ModelReceiptLineItemsInput | null,
  jobCodeId?: ModelIDInput | null,
  reimbursementDate?: ModelStringInput | null,
  decisionDate?: ModelStringInput | null,
  reviewedByPaidolUserId?: ModelIDInput | null,
  reviewedByName?: ModelStringInput | null,
  reviewedByRole?: ModelStringInput | null,
  reviewedAt?: ModelStringInput | null,
  paidolUserId?: ModelIDInput | null,
  transactionType?: ModelReimbursementTransactionTypeInput | null,
  expenseTypeId?: ModelIDInput | null,
  receiptId?: ModelIDInput | null,
  procoreProjectId?: ModelFloatInput | null,
  procoreWBSCodeId?: ModelFloatInput | null,
  agaveGlCodeId?: ModelIDInput | null,
  agaveProjectId?: ModelIDInput | null,
  agaveCostCodeId?: ModelIDInput | null,
  agaveCostTypeId?: ModelIDInput | null,
  agaveVendorId?: ModelIDInput | null,
  agaveSubJobId?: ModelIDInput | null,
  agaveLocationId?: ModelIDInput | null,
  agaveDepartmentId?: ModelIDInput | null,
  agaveSubaccountId?: ModelIDInput | null,
  agaveEmployeeId?: ModelIDInput | null,
  agaveEquipmentId?: ModelIDInput | null,
  agaveEmCostCodeId?: ModelIDInput | null,
  agaveEmCostTypeId?: ModelIDInput | null,
  codingType?: ModelStringInput | null,
  accountingDate?: ModelStringInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReimbursementTransactionFilterInput | null > | null,
  or?: Array< ModelReimbursementTransactionFilterInput | null > | null,
  not?: ModelReimbursementTransactionFilterInput | null,
};

export type ModelReimbursementTransactionConnection = {
  __typename: "ModelReimbursementTransactionConnection",
  items:  Array<ReimbursementTransaction | null >,
  nextToken?: string | null,
};

export type SearchableReimbursementTransactionFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  dwollaTransferId?: SearchableIDFilterInput | null,
  transactionDate?: SearchableStringFilterInput | null,
  note?: SearchableStringFilterInput | null,
  contestNote?: SearchableStringFilterInput | null,
  deniedNote?: SearchableStringFilterInput | null,
  merchantName?: SearchableStringFilterInput | null,
  jobCodeId?: SearchableIDFilterInput | null,
  reimbursementDate?: SearchableStringFilterInput | null,
  decisionDate?: SearchableStringFilterInput | null,
  reviewedByPaidolUserId?: SearchableIDFilterInput | null,
  reviewedByName?: SearchableStringFilterInput | null,
  reviewedByRole?: SearchableStringFilterInput | null,
  reviewedAt?: SearchableStringFilterInput | null,
  paidolUserId?: SearchableIDFilterInput | null,
  expenseTypeId?: SearchableIDFilterInput | null,
  receiptId?: SearchableIDFilterInput | null,
  procoreProjectId?: SearchableFloatFilterInput | null,
  procoreWBSCodeId?: SearchableFloatFilterInput | null,
  agaveGlCodeId?: SearchableIDFilterInput | null,
  agaveProjectId?: SearchableIDFilterInput | null,
  agaveCostCodeId?: SearchableIDFilterInput | null,
  agaveCostTypeId?: SearchableIDFilterInput | null,
  agaveVendorId?: SearchableIDFilterInput | null,
  agaveSubJobId?: SearchableIDFilterInput | null,
  agaveLocationId?: SearchableIDFilterInput | null,
  agaveDepartmentId?: SearchableIDFilterInput | null,
  agaveSubaccountId?: SearchableIDFilterInput | null,
  agaveEmployeeId?: SearchableIDFilterInput | null,
  agaveEquipmentId?: SearchableIDFilterInput | null,
  agaveEmCostCodeId?: SearchableIDFilterInput | null,
  agaveEmCostTypeId?: SearchableIDFilterInput | null,
  codingType?: SearchableStringFilterInput | null,
  accountingDate?: SearchableStringFilterInput | null,
  flexGlCodeId?: SearchableIDFilterInput | null,
  flexCodeId?: SearchableIDFilterInput | null,
  flexCostCodeId?: SearchableIDFilterInput | null,
  flexCostTypeId?: SearchableIDFilterInput | null,
  flexVendorId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  checkrunStatus?: SearchableStringFilterInput | null,
  receiptLineItems?: SearchableStringFilterInput | null,
  transactionType?: SearchableStringFilterInput | null,
  and?: Array< SearchableReimbursementTransactionFilterInput | null > | null,
  or?: Array< SearchableReimbursementTransactionFilterInput | null > | null,
  not?: SearchableReimbursementTransactionFilterInput | null,
};

export type SearchableReimbursementTransactionSortInput = {
  field?: SearchableReimbursementTransactionSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReimbursementTransactionSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  dwollaTransferId = "dwollaTransferId",
  transactionDate = "transactionDate",
  note = "note",
  contestNote = "contestNote",
  deniedNote = "deniedNote",
  merchantName = "merchantName",
  jobCodeId = "jobCodeId",
  reimbursementDate = "reimbursementDate",
  decisionDate = "decisionDate",
  reviewedByPaidolUserId = "reviewedByPaidolUserId",
  reviewedByName = "reviewedByName",
  reviewedByRole = "reviewedByRole",
  reviewedAt = "reviewedAt",
  paidolUserId = "paidolUserId",
  expenseTypeId = "expenseTypeId",
  receiptId = "receiptId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveVendorId = "agaveVendorId",
  agaveSubJobId = "agaveSubJobId",
  agaveLocationId = "agaveLocationId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveSubaccountId = "agaveSubaccountId",
  agaveEmployeeId = "agaveEmployeeId",
  agaveEquipmentId = "agaveEquipmentId",
  agaveEmCostCodeId = "agaveEmCostCodeId",
  agaveEmCostTypeId = "agaveEmCostTypeId",
  codingType = "codingType",
  accountingDate = "accountingDate",
  flexGlCodeId = "flexGlCodeId",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexVendorId = "flexVendorId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReimbursementTransactionAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReimbursementTransactionAggregateField,
};

export enum SearchableReimbursementTransactionAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  dwollaTransferId = "dwollaTransferId",
  transactionDate = "transactionDate",
  status = "status",
  checkrunStatus = "checkrunStatus",
  note = "note",
  contestNote = "contestNote",
  deniedNote = "deniedNote",
  merchantName = "merchantName",
  receiptLineItems = "receiptLineItems",
  jobCodeId = "jobCodeId",
  reimbursementDate = "reimbursementDate",
  decisionDate = "decisionDate",
  reviewedByPaidolUserId = "reviewedByPaidolUserId",
  reviewedByName = "reviewedByName",
  reviewedByRole = "reviewedByRole",
  reviewedAt = "reviewedAt",
  paidolUserId = "paidolUserId",
  transactionType = "transactionType",
  expenseTypeId = "expenseTypeId",
  receiptId = "receiptId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveVendorId = "agaveVendorId",
  agaveSubJobId = "agaveSubJobId",
  agaveLocationId = "agaveLocationId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveSubaccountId = "agaveSubaccountId",
  agaveEmployeeId = "agaveEmployeeId",
  agaveEquipmentId = "agaveEquipmentId",
  agaveEmCostCodeId = "agaveEmCostCodeId",
  agaveEmCostTypeId = "agaveEmCostTypeId",
  codingType = "codingType",
  accountingDate = "accountingDate",
  flexGlCodeId = "flexGlCodeId",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexVendorId = "flexVendorId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReimbursementTransactionConnection = {
  __typename: "SearchableReimbursementTransactionConnection",
  items:  Array<ReimbursementTransaction | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelHighnoteTransactionFilterInput = {
  transactionId?: ModelIDInput | null,
  paymentCardId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  cardGroupId?: ModelIDInput | null,
  status?: ModelHighnoteTransactionStatusInput | null,
  transactionDate?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  merchantCategoryCode?: ModelStringInput | null,
  merchantCategory?: ModelStringInput | null,
  transactionEvents?: ModelStringInput | null,
  note?: ModelStringInput | null,
  jobCodeId?: ModelIDInput | null,
  procoreCompanyId?: ModelFloatInput | null,
  procoreProjectId?: ModelFloatInput | null,
  procoreWBSCodeId?: ModelFloatInput | null,
  procoreDirectCostId?: ModelFloatInput | null,
  procoreDirectCostLineItemId?: ModelFloatInput | null,
  agaveProjectId?: ModelIDInput | null,
  agaveCostCodeId?: ModelIDInput | null,
  agaveCostTypeId?: ModelIDInput | null,
  agaveExpenseId?: ModelIDInput | null,
  agaveVendorId?: ModelIDInput | null,
  agaveGlCodeId?: ModelIDInput | null,
  agaveDepartmentId?: ModelIDInput | null,
  agaveLocationId?: ModelIDInput | null,
  agaveSubaccountId?: ModelIDInput | null,
  receiptPath?: ModelStringInput | null,
  receiptId?: ModelIDInput | null,
  erpApprovalStatus?: ModelBooleanInput | null,
  erpBypassStatus?: ModelBooleanInput | null,
  last4?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  email?: ModelStringInput | null,
  approvedAmountValue?: ModelIntInput | null,
  approvedAmountCurrencyCode?: ModelStringInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  selectedCodingOption?: ModelCodingOptionsInput | null,
  agaveGlCostTypeId?: ModelStringInput | null,
  flexCodeTransactionStatus?: ModelFlexCodeTransactionStatusInput | null,
  approveWithoutNotes?: ModelBooleanInput | null,
  approveWithoutReceipts?: ModelBooleanInput | null,
  fuelVehicleId?: ModelStringInput | null,
  fuelOdometerReading?: ModelIntInput | null,
  fuelGallons?: ModelIntInput | null,
  fuelCostPerGallon?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHighnoteTransactionFilterInput | null > | null,
  or?: Array< ModelHighnoteTransactionFilterInput | null > | null,
  not?: ModelHighnoteTransactionFilterInput | null,
};

export type ModelCodingOptionsInput = {
  eq?: CodingOptions | null,
  ne?: CodingOptions | null,
};

export type ModelHighnoteTransactionConnection = {
  __typename: "ModelHighnoteTransactionConnection",
  items:  Array<HighnoteTransaction | null >,
  nextToken?: string | null,
};

export type SearchableHighnoteTransactionFilterInput = {
  transactionId?: SearchableIDFilterInput | null,
  paymentCardId?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  cardGroupId?: SearchableIDFilterInput | null,
  transactionDate?: SearchableStringFilterInput | null,
  merchantName?: SearchableStringFilterInput | null,
  merchantCategoryCode?: SearchableStringFilterInput | null,
  merchantCategory?: SearchableStringFilterInput | null,
  transactionEvents?: SearchableStringFilterInput | null,
  note?: SearchableStringFilterInput | null,
  jobCodeId?: SearchableIDFilterInput | null,
  procoreCompanyId?: SearchableFloatFilterInput | null,
  procoreProjectId?: SearchableFloatFilterInput | null,
  procoreWBSCodeId?: SearchableFloatFilterInput | null,
  procoreDirectCostId?: SearchableFloatFilterInput | null,
  procoreDirectCostLineItemId?: SearchableFloatFilterInput | null,
  agaveProjectId?: SearchableIDFilterInput | null,
  agaveCostCodeId?: SearchableIDFilterInput | null,
  agaveCostTypeId?: SearchableIDFilterInput | null,
  agaveExpenseId?: SearchableIDFilterInput | null,
  agaveVendorId?: SearchableIDFilterInput | null,
  agaveGlCodeId?: SearchableIDFilterInput | null,
  agaveDepartmentId?: SearchableIDFilterInput | null,
  agaveLocationId?: SearchableIDFilterInput | null,
  agaveSubaccountId?: SearchableIDFilterInput | null,
  receiptPath?: SearchableStringFilterInput | null,
  receiptId?: SearchableIDFilterInput | null,
  erpApprovalStatus?: SearchableBooleanFilterInput | null,
  erpBypassStatus?: SearchableBooleanFilterInput | null,
  last4?: SearchableStringFilterInput | null,
  userId?: SearchableIDFilterInput | null,
  email?: SearchableStringFilterInput | null,
  approvedAmountValue?: SearchableIntFilterInput | null,
  approvedAmountCurrencyCode?: SearchableStringFilterInput | null,
  flexCodeId?: SearchableIDFilterInput | null,
  flexCostCodeId?: SearchableIDFilterInput | null,
  flexCostTypeId?: SearchableIDFilterInput | null,
  flexGlCodeId?: SearchableIDFilterInput | null,
  flexVendorId?: SearchableIDFilterInput | null,
  agaveGlCostTypeId?: SearchableStringFilterInput | null,
  approveWithoutNotes?: SearchableBooleanFilterInput | null,
  approveWithoutReceipts?: SearchableBooleanFilterInput | null,
  fuelVehicleId?: SearchableStringFilterInput | null,
  fuelOdometerReading?: SearchableIntFilterInput | null,
  fuelGallons?: SearchableIntFilterInput | null,
  fuelCostPerGallon?: SearchableIntFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  selectedCodingOption?: SearchableStringFilterInput | null,
  flexCodeTransactionStatus?: SearchableStringFilterInput | null,
  and?: Array< SearchableHighnoteTransactionFilterInput | null > | null,
  or?: Array< SearchableHighnoteTransactionFilterInput | null > | null,
  not?: SearchableHighnoteTransactionFilterInput | null,
};

export type SearchableHighnoteTransactionSortInput = {
  field?: SearchableHighnoteTransactionSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableHighnoteTransactionSortableFields {
  transactionId = "transactionId",
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  cardGroupId = "cardGroupId",
  transactionDate = "transactionDate",
  merchantName = "merchantName",
  merchantCategoryCode = "merchantCategoryCode",
  merchantCategory = "merchantCategory",
  transactionEvents = "transactionEvents",
  note = "note",
  jobCodeId = "jobCodeId",
  procoreCompanyId = "procoreCompanyId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  procoreDirectCostId = "procoreDirectCostId",
  procoreDirectCostLineItemId = "procoreDirectCostLineItemId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveExpenseId = "agaveExpenseId",
  agaveVendorId = "agaveVendorId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveLocationId = "agaveLocationId",
  agaveSubaccountId = "agaveSubaccountId",
  receiptPath = "receiptPath",
  receiptId = "receiptId",
  erpApprovalStatus = "erpApprovalStatus",
  erpBypassStatus = "erpBypassStatus",
  last4 = "last4",
  userId = "userId",
  email = "email",
  approvedAmountValue = "approvedAmountValue",
  approvedAmountCurrencyCode = "approvedAmountCurrencyCode",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexGlCodeId = "flexGlCodeId",
  flexVendorId = "flexVendorId",
  agaveGlCostTypeId = "agaveGlCostTypeId",
  approveWithoutNotes = "approveWithoutNotes",
  approveWithoutReceipts = "approveWithoutReceipts",
  fuelVehicleId = "fuelVehicleId",
  fuelOdometerReading = "fuelOdometerReading",
  fuelGallons = "fuelGallons",
  fuelCostPerGallon = "fuelCostPerGallon",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnoteTransactionAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableHighnoteTransactionAggregateField,
};

export enum SearchableHighnoteTransactionAggregateField {
  transactionId = "transactionId",
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  cardGroupId = "cardGroupId",
  status = "status",
  transactionDate = "transactionDate",
  merchantName = "merchantName",
  merchantCategoryCode = "merchantCategoryCode",
  merchantCategory = "merchantCategory",
  transactionEvents = "transactionEvents",
  note = "note",
  jobCodeId = "jobCodeId",
  procoreCompanyId = "procoreCompanyId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  procoreDirectCostId = "procoreDirectCostId",
  procoreDirectCostLineItemId = "procoreDirectCostLineItemId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveExpenseId = "agaveExpenseId",
  agaveVendorId = "agaveVendorId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveLocationId = "agaveLocationId",
  agaveSubaccountId = "agaveSubaccountId",
  receiptPath = "receiptPath",
  receiptId = "receiptId",
  erpApprovalStatus = "erpApprovalStatus",
  erpBypassStatus = "erpBypassStatus",
  last4 = "last4",
  userId = "userId",
  email = "email",
  approvedAmountValue = "approvedAmountValue",
  approvedAmountCurrencyCode = "approvedAmountCurrencyCode",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexGlCodeId = "flexGlCodeId",
  flexVendorId = "flexVendorId",
  selectedCodingOption = "selectedCodingOption",
  agaveGlCostTypeId = "agaveGlCostTypeId",
  flexCodeTransactionStatus = "flexCodeTransactionStatus",
  approveWithoutNotes = "approveWithoutNotes",
  approveWithoutReceipts = "approveWithoutReceipts",
  fuelVehicleId = "fuelVehicleId",
  fuelOdometerReading = "fuelOdometerReading",
  fuelGallons = "fuelGallons",
  fuelCostPerGallon = "fuelCostPerGallon",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnoteTransactionConnection = {
  __typename: "SearchableHighnoteTransactionConnection",
  items:  Array<HighnoteTransaction | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelProjectGroupFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  groupProjects?: ModelStringInput | null,
  isMonthlyBudgetUnlimited?: ModelBooleanInput | null,
  spendGroupId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  hasReviewers?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProjectGroupFilterInput | null > | null,
  or?: Array< ModelProjectGroupFilterInput | null > | null,
  not?: ModelProjectGroupFilterInput | null,
};

export type ModelProjectGroupConnection = {
  __typename: "ModelProjectGroupConnection",
  items:  Array<ProjectGroup | null >,
  nextToken?: string | null,
};

export type ModelCardGroupFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  groupProjects?: ModelStringInput | null,
  isMonthlyBudgetUnlimited?: ModelBooleanInput | null,
  spendGroupId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  hasReviewers?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCardGroupFilterInput | null > | null,
  or?: Array< ModelCardGroupFilterInput | null > | null,
  not?: ModelCardGroupFilterInput | null,
};

export type ModelCardGroupConnection = {
  __typename: "ModelCardGroupConnection",
  items:  Array<CardGroup | null >,
  nextToken?: string | null,
};

export type ModelPaidolUserToProjectGroupFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  paidolUserId?: ModelIDInput | null,
  projectGroupId?: ModelIDInput | null,
  approvalLevels?: ModelIntInput | null,
  isReviewer?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolUserToProjectGroupFilterInput | null > | null,
  or?: Array< ModelPaidolUserToProjectGroupFilterInput | null > | null,
  not?: ModelPaidolUserToProjectGroupFilterInput | null,
};

export type ModelPaidolUserToCardGroupFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  paidolUserId?: ModelIDInput | null,
  cardGroupId?: ModelIDInput | null,
  approvalLevels?: ModelIntInput | null,
  isReviewer?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolUserToCardGroupFilterInput | null > | null,
  or?: Array< ModelPaidolUserToCardGroupFilterInput | null > | null,
  not?: ModelPaidolUserToCardGroupFilterInput | null,
};

export type ModelProjectGroupBudgetSpendByMonthFilterInput = {
  cardGroupId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProjectGroupBudgetSpendByMonthFilterInput | null > | null,
  or?: Array< ModelProjectGroupBudgetSpendByMonthFilterInput | null > | null,
  not?: ModelProjectGroupBudgetSpendByMonthFilterInput | null,
};

export type ModelCardGroupBudgetSpendByMonthFilterInput = {
  cardGroupId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  yearAndMonth?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  transactionCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCardGroupBudgetSpendByMonthFilterInput | null > | null,
  or?: Array< ModelCardGroupBudgetSpendByMonthFilterInput | null > | null,
  not?: ModelCardGroupBudgetSpendByMonthFilterInput | null,
};

export type ModelPaidolUserToHighnotePaymentCardFilterInput = {
  id?: ModelIDInput | null,
  paidolUserID?: ModelIDInput | null,
  highnotePaymentCardID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaidolUserToHighnotePaymentCardFilterInput | null > | null,
  or?: Array< ModelPaidolUserToHighnotePaymentCardFilterInput | null > | null,
  not?: ModelPaidolUserToHighnotePaymentCardFilterInput | null,
};

export type ModelUserNotificationPreferencesFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  transactionAlertSms?: ModelBooleanInput | null,
  transactionAlertEmail?: ModelBooleanInput | null,
  cardLockedSms?: ModelBooleanInput | null,
  cardLockedEmail?: ModelBooleanInput | null,
  manualCardActionSms?: ModelBooleanInput | null,
  manualCardActionEmail?: ModelBooleanInput | null,
  lowBalanceAlertSms?: ModelBooleanInput | null,
  lowBalanceAlertEmail?: ModelBooleanInput | null,
  cardActivationSms?: ModelBooleanInput | null,
  cardActivationEmail?: ModelBooleanInput | null,
  statementReadySms?: ModelBooleanInput | null,
  statementReadyEmail?: ModelBooleanInput | null,
  txnReviewFrequency?: ModelStringInput | null,
  txnReviewCodeUpdateSms?: ModelBooleanInput | null,
  txnReviewCodeUpdateEmail?: ModelBooleanInput | null,
  txnReviewNoteUpdateSms?: ModelBooleanInput | null,
  txnReviewNoteUpdateEmail?: ModelBooleanInput | null,
  txnReviewReceiptUpdateSms?: ModelBooleanInput | null,
  txnReviewReceiptUpdateEmail?: ModelBooleanInput | null,
  txnReviewResubmissionSms?: ModelBooleanInput | null,
  txnReviewResubmissionEmail?: ModelBooleanInput | null,
  txnReviewReadySms?: ModelBooleanInput | null,
  txnReviewReadyEmail?: ModelBooleanInput | null,
  returnedTransactionSms?: ModelBooleanInput | null,
  returnedTransactionEmail?: ModelBooleanInput | null,
  smsConsentAccepted?: ModelBooleanInput | null,
  smsConsentAcceptedAt?: ModelStringInput | null,
  platformAgreementVersion?: ModelStringInput | null,
  hasReceivedWelcomeSms?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserNotificationPreferencesFilterInput | null > | null,
  or?: Array< ModelUserNotificationPreferencesFilterInput | null > | null,
  not?: ModelUserNotificationPreferencesFilterInput | null,
};

export type ModelUserNotificationPreferencesConnection = {
  __typename: "ModelUserNotificationPreferencesConnection",
  items:  Array<UserNotificationPreferences | null >,
  nextToken?: string | null,
};

export type ModelMerchantSpendRuleFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  paymentCards?: ModelStringInput | null,
  merchantCountrySpendRuleId?: ModelIDInput | null,
  merchantCategorySpendRuleId?: ModelIDInput | null,
  amountLimitSpendRuleId?: ModelIDInput | null,
  monthlyLimitSpendRuleId?: ModelIDInput | null,
  monthlyLimitCumulativeRuleId?: ModelIDInput | null,
  merchantCategoryAllowed?: ModelStringInput | null,
  merchantCategoryBlocked?: ModelStringInput | null,
  merchantCountryAllowed?: ModelStringInput | null,
  merchantCountryBlocked?: ModelStringInput | null,
  monthlyLimitResetTimestamp?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMerchantSpendRuleFilterInput | null > | null,
  or?: Array< ModelMerchantSpendRuleFilterInput | null > | null,
  not?: ModelMerchantSpendRuleFilterInput | null,
};

export type ModelMerchantSpendRuleConnection = {
  __typename: "ModelMerchantSpendRuleConnection",
  items:  Array<MerchantSpendRule | null >,
  nextToken?: string | null,
};

export type ModelTransactionsDownloadQueueFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  range_option?: ModelExportDateRangeEnumInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  columns?: ModelStringInput | null,
  s3_key?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  createdAt?: ModelStringInput | null,
  paidolUserId?: ModelIDInput | null,
  mark_as_exported?: ModelBooleanInput | null,
  exported_count?: ModelIntInput | null,
  skipped_count?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionsDownloadQueueFilterInput | null > | null,
  or?: Array< ModelTransactionsDownloadQueueFilterInput | null > | null,
  not?: ModelTransactionsDownloadQueueFilterInput | null,
};

export type ModelTransactionsDownloadQueueConnection = {
  __typename: "ModelTransactionsDownloadQueueConnection",
  items:  Array<TransactionsDownloadQueue | null >,
  nextToken?: string | null,
};

export type ModelTransactionsReceiptsDownloadQueueFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  paidol_id?: ModelIDInput | null,
  paidolUserId?: ModelIDInput | null,
  s3_key?: ModelStringInput | null,
  range_option?: ModelExportDateRangeEnumInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  cron_status?: ModelPaymentStatusDownloadStatusEnumInput | null,
  error_code?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  filteredTransactionIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionsReceiptsDownloadQueueFilterInput | null > | null,
  or?: Array< ModelTransactionsReceiptsDownloadQueueFilterInput | null > | null,
  not?: ModelTransactionsReceiptsDownloadQueueFilterInput | null,
};

export type ModelTransactionsReceiptsDownloadQueueConnection = {
  __typename: "ModelTransactionsReceiptsDownloadQueueConnection",
  items:  Array<TransactionsReceiptsDownloadQueue | null >,
  nextToken?: string | null,
};

export type ModelSpendRuleConfigFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  ruleId?: ModelIDInput | null,
  ruleType?: ModelSpendRuleTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSpendRuleConfigFilterInput | null > | null,
  or?: Array< ModelSpendRuleConfigFilterInput | null > | null,
  not?: ModelSpendRuleConfigFilterInput | null,
};

export type ModelSpendRuleConfigConnection = {
  __typename: "ModelSpendRuleConfigConnection",
  items:  Array<SpendRuleConfig | null >,
  nextToken?: string | null,
};

export type ModelJobCodeImportFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelJobCodeImportStatusInput | null,
  errors?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelJobCodeImportFilterInput | null > | null,
  or?: Array< ModelJobCodeImportFilterInput | null > | null,
  not?: ModelJobCodeImportFilterInput | null,
};

export type ModelJobCodeImportConnection = {
  __typename: "ModelJobCodeImportConnection",
  items:  Array<JobCodeImport | null >,
  nextToken?: string | null,
};

export type ModelJobCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  code?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  budget?: ModelFloatInput | null,
  jobCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelJobCodeFilterInput | null > | null,
  or?: Array< ModelJobCodeFilterInput | null > | null,
  not?: ModelJobCodeFilterInput | null,
};

export type ModelFlexCodeImportFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelFlexCodeImportStatusInput | null,
  errors?: ModelStringInput | null,
  searchSynced?: ModelBooleanInput | null,
  type?: ModelFlexCodeImportTypeInput | null,
  and?: Array< ModelFlexCodeImportFilterInput | null > | null,
  or?: Array< ModelFlexCodeImportFilterInput | null > | null,
  not?: ModelFlexCodeImportFilterInput | null,
};

export type ModelFlexCodeImportConnection = {
  __typename: "ModelFlexCodeImportConnection",
  items:  Array<FlexCodeImport | null >,
  nextToken?: string | null,
};

export type FlexTransactionExport = {
  __typename: "FlexTransactionExport",
  id: string,
  paidolId: string,
  // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
  authPaidolId: string,
  createdAt: string,
  updatedAt: string,
  // fileName/s3Key are the INTENDED destination, decided before upload — real at
  // create time and truthful on every status, including runs that failed before
  // the file reached the bucket.
  fileName: string,
  // Key of the delivered CSV in the customer's sftp-<slug>-<env> mailbox bucket.
  s3Key: string,
  // Number of transactions in the DELIVERED file. Set when the run finishes
  // (COMPLETED); absent while PROCESSING and on runs that failed before upload —
  // a 0 there would be a claim, not a fact. Does NOT include baseline stamps;
  // those are counted separately in baselineTransactionCount.
  transactionCount?: number | null,
  // Pre-enablement transactions this run marked handled-before-switch-on
  // ("baseline-<id>" on erpExportBatchId) instead of delivering. Those stamps are
  // permanent and never rolled back, so this field is the only durable record
  // they were written — set on ANY outcome (including ERROR), and never to be
  // surfaced to the customer as exported. Absent when the run baselined nothing.
  baselineTransactionCount?: number | null,
  // Oldest/newest transaction eventDate in the delivered batch — the run's
  // effective "window" for support. (Selection is state-driven — "qualifying and
  // not yet stamped" — with ONE permanent time bound: nothing dated before the
  // company's enablement window ever exports; see erpExportedAt on
  // HighnoteTransactionEvent.) Absent on empty runs.
  firstEventDate?: string | null,
  lastEventDate?: string | null,
  // byStatus exists for the operational lookup the unwind procedure starts from:
  // "which runs are stuck in PROCESSING right now, across all companies". A killed
  // process leaves a PROCESSING row and no alert naming the company, so without
  // this index finding it means a scan or a per-company query.
  // 
  // Deliberately NO queryField: this model's only auth is per-company dynamic
  // groups, so no AppSync principal has the cross-company read this index exists
  // for — a generated query would serve nobody and let each company page through
  // the global partitions. Incident responders use the console/CLI/the
  // V2DataAccess ByStatus entity index, which bypass AppSync.
  status: FlexTransactionExportStatus,
  // Customer-safe summary only (this field is group-readable by the company's own
  // users). Raw exception detail stays in CloudWatch + the internal alert.
  errors?: string | null,
};

export enum FlexTransactionExportStatus {
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}


export type ModelFlexTransactionExportFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  transactionCount?: ModelIntInput | null,
  baselineTransactionCount?: ModelIntInput | null,
  firstEventDate?: ModelStringInput | null,
  lastEventDate?: ModelStringInput | null,
  status?: ModelFlexTransactionExportStatusInput | null,
  errors?: ModelStringInput | null,
  and?: Array< ModelFlexTransactionExportFilterInput | null > | null,
  or?: Array< ModelFlexTransactionExportFilterInput | null > | null,
  not?: ModelFlexTransactionExportFilterInput | null,
};

export type ModelFlexTransactionExportStatusInput = {
  eq?: FlexTransactionExportStatus | null,
  ne?: FlexTransactionExportStatus | null,
};

export type ModelFlexTransactionExportConnection = {
  __typename: "ModelFlexTransactionExportConnection",
  items:  Array<FlexTransactionExport | null >,
  nextToken?: string | null,
};

export type ModelV2FlexRelationshipsFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  flexCodeImportId?: ModelIDInput | null,
  flexGlCodeName?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  projectCode?: ModelStringInput | null,
  flexCostCodeName?: ModelStringInput | null,
  flexCostTypeName?: ModelStringInput | null,
  flexVendorName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelV2FlexRelationshipsFilterInput | null > | null,
  or?: Array< ModelV2FlexRelationshipsFilterInput | null > | null,
  not?: ModelV2FlexRelationshipsFilterInput | null,
};

export type ModelV2FlexRelationshipsConnection = {
  __typename: "ModelV2FlexRelationshipsConnection",
  items:  Array<V2FlexRelationships | null >,
  nextToken?: string | null,
};

export type SearchableV2FlexRelationshipsFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  flexGlCodeId?: SearchableIDFilterInput | null,
  flexCodeId?: SearchableIDFilterInput | null,
  flexCostCodeId?: SearchableIDFilterInput | null,
  flexCostTypeId?: SearchableIDFilterInput | null,
  flexVendorId?: SearchableIDFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  flexGlCodeName?: SearchableStringFilterInput | null,
  projectName?: SearchableStringFilterInput | null,
  projectCode?: SearchableStringFilterInput | null,
  flexCostCodeName?: SearchableStringFilterInput | null,
  flexCostTypeName?: SearchableStringFilterInput | null,
  flexVendorName?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableV2FlexRelationshipsFilterInput | null > | null,
  or?: Array< SearchableV2FlexRelationshipsFilterInput | null > | null,
  not?: SearchableV2FlexRelationshipsFilterInput | null,
};

export type SearchableV2FlexRelationshipsSortInput = {
  field?: SearchableV2FlexRelationshipsSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableV2FlexRelationshipsSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  flexGlCodeId = "flexGlCodeId",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexVendorId = "flexVendorId",
  flexCodeImportId = "flexCodeImportId",
  flexGlCodeName = "flexGlCodeName",
  projectName = "projectName",
  projectCode = "projectCode",
  flexCostCodeName = "flexCostCodeName",
  flexCostTypeName = "flexCostTypeName",
  flexVendorName = "flexVendorName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableV2FlexRelationshipsAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableV2FlexRelationshipsAggregateField,
};

export enum SearchableV2FlexRelationshipsAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  flexGlCodeId = "flexGlCodeId",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexVendorId = "flexVendorId",
  flexCodeImportId = "flexCodeImportId",
  flexGlCodeName = "flexGlCodeName",
  projectName = "projectName",
  projectCode = "projectCode",
  flexCostCodeName = "flexCostCodeName",
  flexCostTypeName = "flexCostTypeName",
  flexVendorName = "flexVendorName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableV2FlexRelationshipsConnection = {
  __typename: "SearchableV2FlexRelationshipsConnection",
  items:  Array<V2FlexRelationships | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexGlCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexGlCodeFilterInput | null > | null,
  or?: Array< ModelFlexGlCodeFilterInput | null > | null,
  not?: ModelFlexGlCodeFilterInput | null,
};

export type ModelFlexGlCodeConnection = {
  __typename: "ModelFlexGlCodeConnection",
  items:  Array<FlexGlCode | null >,
  nextToken?: string | null,
};

export type SearchableFlexGlCodeFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexGlCodeFilterInput | null > | null,
  or?: Array< SearchableFlexGlCodeFilterInput | null > | null,
  not?: SearchableFlexGlCodeFilterInput | null,
};

export type SearchableFlexGlCodeSortInput = {
  field?: SearchableFlexGlCodeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexGlCodeSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexGlCodeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexGlCodeAggregateField,
};

export enum SearchableFlexGlCodeAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexGlCodeConnection = {
  __typename: "SearchableFlexGlCodeConnection",
  items:  Array<FlexGlCode | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  projectName?: ModelStringInput | null,
  projectCode?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  flexCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexCodeFilterInput | null > | null,
  or?: Array< ModelFlexCodeFilterInput | null > | null,
  not?: ModelFlexCodeFilterInput | null,
};

export type SearchableFlexCodeFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  projectName?: SearchableStringFilterInput | null,
  projectCode?: SearchableStringFilterInput | null,
  isActive?: SearchableBooleanFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexCodeFilterInput | null > | null,
  or?: Array< SearchableFlexCodeFilterInput | null > | null,
  not?: SearchableFlexCodeFilterInput | null,
};

export type SearchableFlexCodeSortInput = {
  field?: SearchableFlexCodeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexCodeSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  projectName = "projectName",
  projectCode = "projectCode",
  isActive = "isActive",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCodeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexCodeAggregateField,
};

export enum SearchableFlexCodeAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  projectName = "projectName",
  projectCode = "projectCode",
  isActive = "isActive",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCodeConnection = {
  __typename: "SearchableFlexCodeConnection",
  items:  Array<FlexCode | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexCostCodeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  code?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexCostCodeFilterInput | null > | null,
  or?: Array< ModelFlexCostCodeFilterInput | null > | null,
  not?: ModelFlexCostCodeFilterInput | null,
};

export type ModelFlexCostCodeConnection = {
  __typename: "ModelFlexCostCodeConnection",
  items:  Array<FlexCostCode | null >,
  nextToken?: string | null,
};

export type SearchableFlexCostCodeFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  code?: SearchableStringFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexCostCodeFilterInput | null > | null,
  or?: Array< SearchableFlexCostCodeFilterInput | null > | null,
  not?: SearchableFlexCostCodeFilterInput | null,
};

export type SearchableFlexCostCodeSortInput = {
  field?: SearchableFlexCostCodeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexCostCodeSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  code = "code",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCostCodeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexCostCodeAggregateField,
};

export enum SearchableFlexCostCodeAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  code = "code",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCostCodeConnection = {
  __typename: "SearchableFlexCostCodeConnection",
  items:  Array<FlexCostCode | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexCostTypeFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexCostTypeFilterInput | null > | null,
  or?: Array< ModelFlexCostTypeFilterInput | null > | null,
  not?: ModelFlexCostTypeFilterInput | null,
};

export type ModelFlexCostTypeConnection = {
  __typename: "ModelFlexCostTypeConnection",
  items:  Array<FlexCostType | null >,
  nextToken?: string | null,
};

export type SearchableFlexCostTypeFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexCostTypeFilterInput | null > | null,
  or?: Array< SearchableFlexCostTypeFilterInput | null > | null,
  not?: SearchableFlexCostTypeFilterInput | null,
};

export type SearchableFlexCostTypeSortInput = {
  field?: SearchableFlexCostTypeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexCostTypeSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCostTypeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexCostTypeAggregateField,
};

export enum SearchableFlexCostTypeAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexCostTypeConnection = {
  __typename: "SearchableFlexCostTypeConnection",
  items:  Array<FlexCostType | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexVendorFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  flexCodeImportId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexVendorFilterInput | null > | null,
  or?: Array< ModelFlexVendorFilterInput | null > | null,
  not?: ModelFlexVendorFilterInput | null,
};

export type ModelFlexVendorConnection = {
  __typename: "ModelFlexVendorConnection",
  items:  Array<FlexVendor | null >,
  nextToken?: string | null,
};

export type SearchableFlexVendorFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  flexCodeImportId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexVendorFilterInput | null > | null,
  or?: Array< SearchableFlexVendorFilterInput | null > | null,
  not?: SearchableFlexVendorFilterInput | null,
};

export type SearchableFlexVendorSortInput = {
  field?: SearchableFlexVendorSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexVendorSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexVendorAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexVendorAggregateField,
};

export enum SearchableFlexVendorAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  flexCodeImportId = "flexCodeImportId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexVendorConnection = {
  __typename: "SearchableFlexVendorConnection",
  items:  Array<FlexVendor | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexFieldFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  alias?: ModelStringInput | null,
  order?: ModelIntInput | null,
  source?: ModelFlexFieldSourceInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldFilterInput | null > | null,
  or?: Array< ModelFlexFieldFilterInput | null > | null,
  not?: ModelFlexFieldFilterInput | null,
};

export type ModelFlexFieldConnection = {
  __typename: "ModelFlexFieldConnection",
  items:  Array<FlexField | null >,
  nextToken?: string | null,
};

export type SearchableFlexFieldFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  alias?: SearchableStringFilterInput | null,
  order?: SearchableIntFilterInput | null,
  createdBy?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  source?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexFieldFilterInput | null > | null,
  or?: Array< SearchableFlexFieldFilterInput | null > | null,
  not?: SearchableFlexFieldFilterInput | null,
};

export type SearchableFlexFieldSortInput = {
  field?: SearchableFlexFieldSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexFieldSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  alias = "alias",
  order = "order",
  createdBy = "createdBy",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexFieldAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexFieldAggregateField,
};

export enum SearchableFlexFieldAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  name = "name",
  alias = "alias",
  order = "order",
  source = "source",
  createdBy = "createdBy",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexFieldConnection = {
  __typename: "SearchableFlexFieldConnection",
  items:  Array<FlexField | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexFieldValueFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexFieldId?: ModelIDInput | null,
  externalId?: ModelStringInput | null,
  value?: ModelStringInput | null,
  status?: ModelFlexFieldValueStatusInput | null,
  flexFieldUploadId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldValueFilterInput | null > | null,
  or?: Array< ModelFlexFieldValueFilterInput | null > | null,
  not?: ModelFlexFieldValueFilterInput | null,
};

export type ModelFlexFieldValueConnection = {
  __typename: "ModelFlexFieldValueConnection",
  items:  Array<FlexFieldValue | null >,
  nextToken?: string | null,
};

export type SearchableFlexFieldValueFilterInput = {
  id?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  flexFieldId?: SearchableIDFilterInput | null,
  externalId?: SearchableStringFilterInput | null,
  value?: SearchableStringFilterInput | null,
  flexFieldUploadId?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlexFieldValueFilterInput | null > | null,
  or?: Array< SearchableFlexFieldValueFilterInput | null > | null,
  not?: SearchableFlexFieldValueFilterInput | null,
};

export type SearchableFlexFieldValueSortInput = {
  field?: SearchableFlexFieldValueSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlexFieldValueSortableFields {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  flexFieldId = "flexFieldId",
  externalId = "externalId",
  value = "value",
  flexFieldUploadId = "flexFieldUploadId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexFieldValueAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlexFieldValueAggregateField,
};

export enum SearchableFlexFieldValueAggregateField {
  id = "id",
  paidolId = "paidolId",
  authPaidolId = "authPaidolId",
  flexFieldId = "flexFieldId",
  externalId = "externalId",
  value = "value",
  status = "status",
  flexFieldUploadId = "flexFieldUploadId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlexFieldValueConnection = {
  __typename: "SearchableFlexFieldValueConnection",
  items:  Array<FlexFieldValue | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlexFieldUploadFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  flexFieldId?: ModelIDInput | null,
  storageFileKey?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  status?: ModelFlexFieldUploadStatusInput | null,
  errors?: ModelStringInput | null,
  rowCount?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlexFieldUploadFilterInput | null > | null,
  or?: Array< ModelFlexFieldUploadFilterInput | null > | null,
  not?: ModelFlexFieldUploadFilterInput | null,
};

export type ModelFlexFieldUploadConnection = {
  __typename: "ModelFlexFieldUploadConnection",
  items:  Array<FlexFieldUpload | null >,
  nextToken?: string | null,
};

export type ModelStatementSummaryFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  statementBalance?: ModelIntInput | null,
  paymentDueDate?: ModelStringInput | null,
  pdfLink?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStatementSummaryFilterInput | null > | null,
  or?: Array< ModelStatementSummaryFilterInput | null > | null,
  not?: ModelStatementSummaryFilterInput | null,
};

export type ModelStatementSummaryConnection = {
  __typename: "ModelStatementSummaryConnection",
  items:  Array<StatementSummary | null >,
  nextToken?: string | null,
};

export type ModelAutoPaymentFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  amountType?: ModelAutoPayAmountTypeInput | null,
  fixedAmountCents?: ModelIntInput | null,
  paymentDayOfMonth?: ModelIntInput | null,
  externalBankAccountId?: ModelStringInput | null,
  financialAccountId?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAutoPaymentFilterInput | null > | null,
  or?: Array< ModelAutoPaymentFilterInput | null > | null,
  not?: ModelAutoPaymentFilterInput | null,
};

export type ModelAutoPaymentConnection = {
  __typename: "ModelAutoPaymentConnection",
  items:  Array<AutoPayment | null >,
  nextToken?: string | null,
};

export type ModelTransactionFilterOptionsFilterInput = {
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  last4?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  and?: Array< ModelTransactionFilterOptionsFilterInput | null > | null,
  or?: Array< ModelTransactionFilterOptionsFilterInput | null > | null,
  not?: ModelTransactionFilterOptionsFilterInput | null,
};

export type ModelTransactionFilterOptionsConnection = {
  __typename: "ModelTransactionFilterOptionsConnection",
  items:  Array<TransactionFilterOptions | null >,
  nextToken?: string | null,
};

export type ModelHighnoteDisputeEventFilterInput = {
  id?: ModelIDInput | null,
  disputeId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  paymentCardId?: ModelIDInput | null,
  transactionEventId?: ModelIDInput | null,
  enableListing?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  creditStatus?: ModelStringInput | null,
  category?: ModelStringInput | null,
  liability?: ModelStringInput | null,
  eventType?: ModelStringInput | null,
  eventDate?: ModelStringInput | null,
  source?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHighnoteDisputeEventFilterInput | null > | null,
  or?: Array< ModelHighnoteDisputeEventFilterInput | null > | null,
  not?: ModelHighnoteDisputeEventFilterInput | null,
};

export type ModelHighnoteDisputeEventConnection = {
  __typename: "ModelHighnoteDisputeEventConnection",
  items:  Array<HighnoteDisputeEvent | null >,
  nextToken?: string | null,
};

export type ModelHighnoteTransactionEventFilterInput = {
  id?: ModelIDInput | null,
  transactionId?: ModelIDInput | null,
  paymentCardId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  reconciliationId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  eventDate?: ModelStringInput | null,
  processedAt?: ModelStringInput | null,
  origin?: ModelStringInput | null,
  status?: ModelHighnoteTransactionStatusInput | null,
  partial?: ModelBooleanInput | null,
  settlementImpact?: ModelBooleanInput | null,
  approvedAmountValue?: ModelIntInput | null,
  approvedAmountCurrencyCode?: ModelStringInput | null,
  eventData?: ModelStringInput | null,
  transactionOldState?: ModelStringInput | null,
  transactionNewState?: ModelStringInput | null,
  enableListing?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  last4?: ModelStringInput | null,
  groupApprovalLevels?: ModelIntInput | null,
  owningProjectGroupIds?: ModelStringInput | null,
  cardGroupId?: ModelIDInput | null,
  merchantCategory?: ModelStringInput | null,
  merchantCategoryCode?: ModelStringInput | null,
  merchantName?: ModelStringInput | null,
  jobCodeId?: ModelIDInput | null,
  flexCodeTransactionStatus?: ModelFlexCodeTransactionStatusInput | null,
  workflowStatus?: ModelWorkflowStatusInput | null,
  returnedStatus?: ModelReturnedStatusInput | null,
  flexCodeId?: ModelIDInput | null,
  flexCostCodeId?: ModelIDInput | null,
  flexCostTypeId?: ModelIDInput | null,
  flexGlCodeId?: ModelIDInput | null,
  flexVendorId?: ModelIDInput | null,
  agaveDepartmentId?: ModelIDInput | null,
  agaveLocationId?: ModelIDInput | null,
  agaveSubaccountId?: ModelIDInput | null,
  agaveEmployeeId?: ModelIDInput | null,
  agaveExpenseId?: ModelIDInput | null,
  agaveProjectId?: ModelIDInput | null,
  agaveCostCodeId?: ModelIDInput | null,
  agaveCostTypeId?: ModelIDInput | null,
  agaveGlCodeId?: ModelIDInput | null,
  agaveVendorId?: ModelIDInput | null,
  agaveSubJobId?: ModelIDInput | null,
  agaveEquipmentId?: ModelIDInput | null,
  agaveEmCostCodeId?: ModelIDInput | null,
  agaveEmCostTypeId?: ModelIDInput | null,
  codingType?: ModelStringInput | null,
  accountingDate?: ModelStringInput | null,
  procoreDirectCostId?: ModelFloatInput | null,
  procoreDirectCostLineItemId?: ModelFloatInput | null,
  procoreProjectId?: ModelFloatInput | null,
  procoreWBSCodeId?: ModelFloatInput | null,
  erpApprovalStatus?: ModelBooleanInput | null,
  erpBypassStatus?: ModelBooleanInput | null,
  erpBillableItemId?: ModelStringInput | null,
  erpBillableItemName?: ModelStringInput | null,
  erpBillable?: ModelBooleanInput | null,
  erpPostingStatus?: ModelERPPostingStatusInput | null,
  erpPostingError?: ModelStringInput | null,
  erpPostingWarning?: ModelStringInput | null,
  sage300APInvoiceStatus?: ModelSage300APInvoiceStatusInput | null,
  sage300APInvoiceError?: ModelStringInput | null,
  note?: ModelStringInput | null,
  approveWithoutNotes?: ModelBooleanInput | null,
  receiptPath?: ModelStringInput | null,
  receiptId?: ModelIDInput | null,
  hasReceipt?: ModelBooleanInput | null,
  approveWithoutReceipts?: ModelBooleanInput | null,
  fuelVehicleId?: ModelStringInput | null,
  fuelOdometerReading?: ModelIntInput | null,
  fuelGallons?: ModelIntInput | null,
  fuelCostPerGallon?: ModelIntInput | null,
  codedAt?: ModelStringInput | null,
  codingMethod?: ModelStringInput | null,
  receiptUploadedAt?: ModelStringInput | null,
  receiptUploadMethod?: ModelStringInput | null,
  erpExportedAt?: ModelStringInput | null,
  erpExportBatchId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHighnoteTransactionEventFilterInput | null > | null,
  or?: Array< ModelHighnoteTransactionEventFilterInput | null > | null,
  not?: ModelHighnoteTransactionEventFilterInput | null,
};

export type SearchableHighnoteTransactionEventFilterInput = {
  id?: SearchableIDFilterInput | null,
  transactionId?: SearchableIDFilterInput | null,
  paymentCardId?: SearchableIDFilterInput | null,
  paidolId?: SearchableIDFilterInput | null,
  reconciliationId?: SearchableIDFilterInput | null,
  authPaidolId?: SearchableIDFilterInput | null,
  eventDate?: SearchableStringFilterInput | null,
  processedAt?: SearchableStringFilterInput | null,
  origin?: SearchableStringFilterInput | null,
  partial?: SearchableBooleanFilterInput | null,
  settlementImpact?: SearchableBooleanFilterInput | null,
  approvedAmountValue?: SearchableIntFilterInput | null,
  approvedAmountCurrencyCode?: SearchableStringFilterInput | null,
  eventData?: SearchableStringFilterInput | null,
  transactionOldState?: SearchableStringFilterInput | null,
  transactionNewState?: SearchableStringFilterInput | null,
  enableListing?: SearchableBooleanFilterInput | null,
  email?: SearchableStringFilterInput | null,
  userId?: SearchableIDFilterInput | null,
  last4?: SearchableStringFilterInput | null,
  groupApprovalLevels?: SearchableIntFilterInput | null,
  owningProjectGroupIds?: SearchableStringFilterInput | null,
  cardGroupId?: SearchableIDFilterInput | null,
  merchantCategory?: SearchableStringFilterInput | null,
  merchantCategoryCode?: SearchableStringFilterInput | null,
  merchantName?: SearchableStringFilterInput | null,
  jobCodeId?: SearchableIDFilterInput | null,
  flexCodeId?: SearchableIDFilterInput | null,
  flexCostCodeId?: SearchableIDFilterInput | null,
  flexCostTypeId?: SearchableIDFilterInput | null,
  flexGlCodeId?: SearchableIDFilterInput | null,
  flexVendorId?: SearchableIDFilterInput | null,
  agaveDepartmentId?: SearchableIDFilterInput | null,
  agaveLocationId?: SearchableIDFilterInput | null,
  agaveSubaccountId?: SearchableIDFilterInput | null,
  agaveEmployeeId?: SearchableIDFilterInput | null,
  agaveExpenseId?: SearchableIDFilterInput | null,
  agaveProjectId?: SearchableIDFilterInput | null,
  agaveCostCodeId?: SearchableIDFilterInput | null,
  agaveCostTypeId?: SearchableIDFilterInput | null,
  agaveGlCodeId?: SearchableIDFilterInput | null,
  agaveVendorId?: SearchableIDFilterInput | null,
  agaveSubJobId?: SearchableIDFilterInput | null,
  agaveEquipmentId?: SearchableIDFilterInput | null,
  agaveEmCostCodeId?: SearchableIDFilterInput | null,
  agaveEmCostTypeId?: SearchableIDFilterInput | null,
  codingType?: SearchableStringFilterInput | null,
  accountingDate?: SearchableStringFilterInput | null,
  procoreDirectCostId?: SearchableFloatFilterInput | null,
  procoreDirectCostLineItemId?: SearchableFloatFilterInput | null,
  procoreProjectId?: SearchableFloatFilterInput | null,
  procoreWBSCodeId?: SearchableFloatFilterInput | null,
  erpApprovalStatus?: SearchableBooleanFilterInput | null,
  erpBypassStatus?: SearchableBooleanFilterInput | null,
  erpBillableItemId?: SearchableStringFilterInput | null,
  erpBillableItemName?: SearchableStringFilterInput | null,
  erpBillable?: SearchableBooleanFilterInput | null,
  erpPostingError?: SearchableStringFilterInput | null,
  erpPostingWarning?: SearchableStringFilterInput | null,
  sage300APInvoiceError?: SearchableStringFilterInput | null,
  note?: SearchableStringFilterInput | null,
  approveWithoutNotes?: SearchableBooleanFilterInput | null,
  receiptPath?: SearchableStringFilterInput | null,
  receiptId?: SearchableIDFilterInput | null,
  hasReceipt?: SearchableBooleanFilterInput | null,
  approveWithoutReceipts?: SearchableBooleanFilterInput | null,
  fuelVehicleId?: SearchableStringFilterInput | null,
  fuelOdometerReading?: SearchableIntFilterInput | null,
  fuelGallons?: SearchableIntFilterInput | null,
  fuelCostPerGallon?: SearchableIntFilterInput | null,
  codedAt?: SearchableStringFilterInput | null,
  codingMethod?: SearchableStringFilterInput | null,
  receiptUploadedAt?: SearchableStringFilterInput | null,
  receiptUploadMethod?: SearchableStringFilterInput | null,
  erpExportedAt?: SearchableStringFilterInput | null,
  erpExportBatchId?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  flexCodeTransactionStatus?: SearchableStringFilterInput | null,
  workflowStatus?: SearchableStringFilterInput | null,
  returnedStatus?: SearchableStringFilterInput | null,
  erpPostingStatus?: SearchableStringFilterInput | null,
  sage300APInvoiceStatus?: SearchableStringFilterInput | null,
  and?: Array< SearchableHighnoteTransactionEventFilterInput | null > | null,
  or?: Array< SearchableHighnoteTransactionEventFilterInput | null > | null,
  not?: SearchableHighnoteTransactionEventFilterInput | null,
};

export type SearchableHighnoteTransactionEventSortInput = {
  field?: SearchableHighnoteTransactionEventSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableHighnoteTransactionEventSortableFields {
  id = "id",
  transactionId = "transactionId",
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  reconciliationId = "reconciliationId",
  authPaidolId = "authPaidolId",
  eventDate = "eventDate",
  processedAt = "processedAt",
  origin = "origin",
  partial = "partial",
  settlementImpact = "settlementImpact",
  approvedAmountValue = "approvedAmountValue",
  approvedAmountCurrencyCode = "approvedAmountCurrencyCode",
  eventData = "eventData",
  transactionOldState = "transactionOldState",
  transactionNewState = "transactionNewState",
  enableListing = "enableListing",
  email = "email",
  userId = "userId",
  last4 = "last4",
  groupApprovalLevels = "groupApprovalLevels",
  owningProjectGroupIds = "owningProjectGroupIds",
  cardGroupId = "cardGroupId",
  merchantCategory = "merchantCategory",
  merchantCategoryCode = "merchantCategoryCode",
  merchantName = "merchantName",
  jobCodeId = "jobCodeId",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexGlCodeId = "flexGlCodeId",
  flexVendorId = "flexVendorId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveLocationId = "agaveLocationId",
  agaveSubaccountId = "agaveSubaccountId",
  agaveEmployeeId = "agaveEmployeeId",
  agaveExpenseId = "agaveExpenseId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveVendorId = "agaveVendorId",
  agaveSubJobId = "agaveSubJobId",
  agaveEquipmentId = "agaveEquipmentId",
  agaveEmCostCodeId = "agaveEmCostCodeId",
  agaveEmCostTypeId = "agaveEmCostTypeId",
  codingType = "codingType",
  accountingDate = "accountingDate",
  procoreDirectCostId = "procoreDirectCostId",
  procoreDirectCostLineItemId = "procoreDirectCostLineItemId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  erpApprovalStatus = "erpApprovalStatus",
  erpBypassStatus = "erpBypassStatus",
  erpBillableItemId = "erpBillableItemId",
  erpBillableItemName = "erpBillableItemName",
  erpBillable = "erpBillable",
  erpPostingError = "erpPostingError",
  erpPostingWarning = "erpPostingWarning",
  sage300APInvoiceError = "sage300APInvoiceError",
  note = "note",
  approveWithoutNotes = "approveWithoutNotes",
  receiptPath = "receiptPath",
  receiptId = "receiptId",
  hasReceipt = "hasReceipt",
  approveWithoutReceipts = "approveWithoutReceipts",
  fuelVehicleId = "fuelVehicleId",
  fuelOdometerReading = "fuelOdometerReading",
  fuelGallons = "fuelGallons",
  fuelCostPerGallon = "fuelCostPerGallon",
  codedAt = "codedAt",
  codingMethod = "codingMethod",
  receiptUploadedAt = "receiptUploadedAt",
  receiptUploadMethod = "receiptUploadMethod",
  erpExportedAt = "erpExportedAt",
  erpExportBatchId = "erpExportBatchId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnoteTransactionEventAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableHighnoteTransactionEventAggregateField,
};

export enum SearchableHighnoteTransactionEventAggregateField {
  id = "id",
  transactionId = "transactionId",
  paymentCardId = "paymentCardId",
  paidolId = "paidolId",
  reconciliationId = "reconciliationId",
  authPaidolId = "authPaidolId",
  eventDate = "eventDate",
  processedAt = "processedAt",
  origin = "origin",
  status = "status",
  partial = "partial",
  settlementImpact = "settlementImpact",
  approvedAmountValue = "approvedAmountValue",
  approvedAmountCurrencyCode = "approvedAmountCurrencyCode",
  eventData = "eventData",
  transactionOldState = "transactionOldState",
  transactionNewState = "transactionNewState",
  enableListing = "enableListing",
  email = "email",
  userId = "userId",
  last4 = "last4",
  groupApprovalLevels = "groupApprovalLevels",
  owningProjectGroupIds = "owningProjectGroupIds",
  cardGroupId = "cardGroupId",
  merchantCategory = "merchantCategory",
  merchantCategoryCode = "merchantCategoryCode",
  merchantName = "merchantName",
  jobCodeId = "jobCodeId",
  flexCodeTransactionStatus = "flexCodeTransactionStatus",
  workflowStatus = "workflowStatus",
  returnedStatus = "returnedStatus",
  flexCodeId = "flexCodeId",
  flexCostCodeId = "flexCostCodeId",
  flexCostTypeId = "flexCostTypeId",
  flexGlCodeId = "flexGlCodeId",
  flexVendorId = "flexVendorId",
  agaveDepartmentId = "agaveDepartmentId",
  agaveLocationId = "agaveLocationId",
  agaveSubaccountId = "agaveSubaccountId",
  agaveEmployeeId = "agaveEmployeeId",
  agaveExpenseId = "agaveExpenseId",
  agaveProjectId = "agaveProjectId",
  agaveCostCodeId = "agaveCostCodeId",
  agaveCostTypeId = "agaveCostTypeId",
  agaveGlCodeId = "agaveGlCodeId",
  agaveVendorId = "agaveVendorId",
  agaveSubJobId = "agaveSubJobId",
  agaveEquipmentId = "agaveEquipmentId",
  agaveEmCostCodeId = "agaveEmCostCodeId",
  agaveEmCostTypeId = "agaveEmCostTypeId",
  codingType = "codingType",
  accountingDate = "accountingDate",
  procoreDirectCostId = "procoreDirectCostId",
  procoreDirectCostLineItemId = "procoreDirectCostLineItemId",
  procoreProjectId = "procoreProjectId",
  procoreWBSCodeId = "procoreWBSCodeId",
  erpApprovalStatus = "erpApprovalStatus",
  erpBypassStatus = "erpBypassStatus",
  erpBillableItemId = "erpBillableItemId",
  erpBillableItemName = "erpBillableItemName",
  erpBillable = "erpBillable",
  erpPostingStatus = "erpPostingStatus",
  erpPostingError = "erpPostingError",
  erpPostingWarning = "erpPostingWarning",
  sage300APInvoiceStatus = "sage300APInvoiceStatus",
  sage300APInvoiceError = "sage300APInvoiceError",
  note = "note",
  approveWithoutNotes = "approveWithoutNotes",
  receiptPath = "receiptPath",
  receiptId = "receiptId",
  hasReceipt = "hasReceipt",
  approveWithoutReceipts = "approveWithoutReceipts",
  fuelVehicleId = "fuelVehicleId",
  fuelOdometerReading = "fuelOdometerReading",
  fuelGallons = "fuelGallons",
  fuelCostPerGallon = "fuelCostPerGallon",
  codedAt = "codedAt",
  codingMethod = "codingMethod",
  receiptUploadedAt = "receiptUploadedAt",
  receiptUploadMethod = "receiptUploadMethod",
  erpExportedAt = "erpExportedAt",
  erpExportBatchId = "erpExportBatchId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHighnoteTransactionEventConnection = {
  __typename: "SearchableHighnoteTransactionEventConnection",
  items:  Array<HighnoteTransactionEvent | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSyncBalanceCurrentCycleFilterInput = {
  id?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSyncBalanceCurrentCycleFilterInput | null > | null,
  or?: Array< ModelSyncBalanceCurrentCycleFilterInput | null > | null,
  not?: ModelSyncBalanceCurrentCycleFilterInput | null,
};

export type ModelSyncBalanceCurrentCycleConnection = {
  __typename: "ModelSyncBalanceCurrentCycleConnection",
  items:  Array<SyncBalanceCurrentCycle | null >,
  nextToken?: string | null,
};

export type ModelSyncBalanceCurrentCyclePaymentCardsFilterInput = {
  id?: ModelIDInput | null,
  authPaidolId?: ModelIDInput | null,
  paidolId?: ModelIDInput | null,
  syncBalanceCurrentCycleId?: ModelIDInput | null,
  paymentCardId?: ModelStringInput | null,
  syncedAt?: ModelStringInput | null,
  error?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null > | null,
  or?: Array< ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null > | null,
  not?: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
};

export type ModelSyncBalanceCurrentCyclePaymentCardsConnection = {
  __typename: "ModelSyncBalanceCurrentCyclePaymentCardsConnection",
  items:  Array<SyncBalanceCurrentCyclePaymentCards | null >,
  nextToken?: string | null,
};

export type ModelExpenseTypeToMCCFilterInput = {
  id?: ModelIDInput | null,
  mccID?: ModelIDInput | null,
  expenseTypeID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelExpenseTypeToMCCFilterInput | null > | null,
  or?: Array< ModelExpenseTypeToMCCFilterInput | null > | null,
  not?: ModelExpenseTypeToMCCFilterInput | null,
};

export type PlaidLinkedBankAccountsResponse = {
  __typename: "PlaidLinkedBankAccountsResponse",
  items:  Array<PlaidLinkedBankAccountSafe >,
};

export type SpeedchatUser = {
  __typename: "SpeedchatUser",
  userId: string,
  nickname: string,
};

export type speedchatUnreadMessages = {
  __typename: "speedchatUnreadMessages",
  unread_count: number,
};

export type dispatchSpeedchatMessage = {
  __typename: "dispatchSpeedchatMessage",
  channel_url: string,
  message: string,
};

export type HNAccountHolderPaymentCardsFilterInput = {
  bin?: HNStringFilterInput | null,
  cardNetwork?: HNPaymentCardNetworkFilterInput | null,
  expirationDate?: HNTimestampFilterInput | null,
  last4?: HNStringFilterInput | null,
  cardProductId?: HNIDFilterInput | null,
  status?: HNPaymentCardStatusFilterInput | null,
  formFactor?: HNCardFormFactorFilterInput | null,
  createDate?: HNTimestampFilterInput | null,
  updateDate?: HNTimestampFilterInput | null,
  customFields?: HNCustomFieldsFilterInput | null,
};

export type HNStringFilterInput = {
  equals?: string | null,
  notEquals?: string | null,
  includes?: Array< string > | null,
  excludes?: Array< string > | null,
};

export type HNPaymentCardNetworkFilterInput = {
  equals?: HNPaymentCardNetwork | null,
  notEquals?: HNPaymentCardNetwork | null,
  includes?: Array< HNPaymentCardNetwork > | null,
  excludes?: Array< HNPaymentCardNetwork > | null,
};

export type HNTimestampFilterInput = {
  equals?: string | null,
  notEquals?: string | null,
  lessThan?: string | null,
  lessThanOrEquals?: string | null,
  greaterThan?: string | null,
  greaterThanOrEquals?: string | null,
  between?: HNTimestampFilterInputRange | null,
};

export type HNTimestampFilterInputRange = {
  start?: string | null,
  end?: string | null,
};

export type HNIDFilterInput = {
  equals?: string | null,
  notEquals?: string | null,
  includes?: Array< string > | null,
  excludes?: Array< string > | null,
};

export type HNPaymentCardStatusFilterInput = {
  equals?: HNPaymentCardStatus | null,
  notEquals?: HNPaymentCardStatus | null,
  includes?: Array< HNPaymentCardStatus > | null,
  excludes?: Array< HNPaymentCardStatus > | null,
};

export type HNCardFormFactorFilterInput = {
  equals?: HNCardFormFactor | null,
  notEquals?: HNCardFormFactor | null,
  includes?: Array< HNCardFormFactor > | null,
  excludes?: Array< HNCardFormFactor > | null,
};

export type HNCustomFieldsFilterInput = {
  equals?: HNCustomFieldInput | null,
  notEquals?: HNCustomFieldInput | null,
  includes?: Array< HNCustomFieldInput > | null,
  excludes?: Array< HNCustomFieldInput > | null,
};

export type HNMerchantSpendRule = {
  __typename: "HNMerchantSpendRule",
  id?: string | null,
  name?: string | null,
  blockedCountry?: Array< string | null > | null,
  allowedCategory?: Array< string | null > | null,
  blockedCategory?: Array< string | null > | null,
  allowedCountry?: Array< string | null > | null,
  maximumAmount?: HNAmount | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HNFinancialAccountActivitiesFilterInput = {
  postedAmount?: HNMoneyFilterInput | null,
  pendingAmount?: HNMoneyFilterInput | null,
  createdAt?: HNTimestampFilterInput | null,
  updatedAt?: HNTimestampFilterInput | null,
  isComplete?: HNBooleanFilterInput | null,
  isSignNegative?: HNBooleanFilterInput | null,
  activityType?: HNFinancialAccountActivityTypeFilterInput | null,
};

export type HNMoneyFilterInput = {
  currencyCode: HNISO4217Alpha3CurrencyCode,
  equals?: number | null,
  notEquals?: number | null,
  lessThan?: number | null,
  lessThanOrEquals?: number | null,
  greaterThan?: number | null,
  greaterThanOrEquals?: number | null,
  includes?: Array< number > | null,
  excludes?: Array< number > | null,
  between?: HNMoneyFilterInputRange | null,
};

export enum HNISO4217Alpha3CurrencyCode {
  ESB = "ESB",
  XUA = "XUA",
  AFA = "AFA",
  AFN = "AFN",
  DZD = "DZD",
  ADP = "ADP",
  ARS = "ARS",
  AMD = "AMD",
  AWG = "AWG",
  ARA = "ARA",
  AUD = "AUD",
  AYM = "AYM",
  AZN = "AZN",
  AZM = "AZM",
  BSD = "BSD",
  BHD = "BHD",
  THB = "THB",
  PAB = "PAB",
  BBD = "BBD",
  BYB = "BYB",
  BYN = "BYN",
  BYR = "BYR",
  BEF = "BEF",
  BZD = "BZD",
  BMD = "BMD",
  VES = "VES",
  VEB = "VEB",
  VEF = "VEF",
  BOB = "BOB",
  XBA = "XBA",
  XBB = "XBB",
  XBD = "XBD",
  XBC = "XBC",
  BRL = "BRL",
  BND = "BND",
  BGN = "BGN",
  BIF = "BIF",
  XOF = "XOF",
  XAF = "XAF",
  XPF = "XPF",
  CVE = "CVE",
  CAD = "CAD",
  KYD = "KYD",
  GHC = "GHC",
  CLP = "CLP",
  XTS = "XTS",
  COP = "COP",
  KMF = "KMF",
  CDF = "CDF",
  BEC = "BEC",
  BAM = "BAM",
  NIO = "NIO",
  NIC = "NIC",
  CRC = "CRC",
  HRD = "HRD",
  HRK = "HRK",
  BRC = "BRC",
  BRR = "BRR",
  BRB = "BRB",
  BRE = "BRE",
  CUP = "CUP",
  CYP = "CYP",
  CZK = "CZK",
  GMD = "GMD",
  DKK = "DKK",
  MKD = "MKD",
  DEM = "DEM",
  BAD = "BAD",
  DJF = "DJF",
  STD = "STD",
  STN = "STN",
  DOP = "DOP",
  VND = "VND",
  GRD = "GRD",
  XCD = "XCD",
  EGP = "EGP",
  GQE = "GQE",
  SVC = "SVC",
  ETB = "ETB",
  EUR = "EUR",
  XEU = "XEU",
  FKP = "FKP",
  FJD = "FJD",
  BEL = "BEL",
  ZAL = "ZAL",
  HUF = "HUF",
  FRF = "FRF",
  GEK = "GEK",
  GHP = "GHP",
  GHS = "GHS",
  GIP = "GIP",
  XAU = "XAU",
  XFO = "XFO",
  HTG = "HTG",
  PYG = "PYG",
  GWE = "GWE",
  GWP = "GWP",
  GNF = "GNF",
  GYD = "GYD",
  HKD = "HKD",
  UAH = "UAH",
  ISK = "ISK",
  INR = "INR",
  PEI = "PEI",
  IRR = "IRR",
  IQD = "IQD",
  IEP = "IEP",
  ITL = "ITL",
  JMD = "JMD",
  JOD = "JOD",
  UAK = "UAK",
  KES = "KES",
  PGK = "PGK",
  CSK = "CSK",
  CSJ = "CSJ",
  EEK = "EEK",
  KWD = "KWD",
  MWK = "MWK",
  AOR = "AOR",
  AOA = "AOA",
  AOK = "AOK",
  BUK = "BUK",
  MMK = "MMK",
  LAK = "LAK",
  GEL = "GEL",
  LVL = "LVL",
  LVR = "LVR",
  LBP = "LBP",
  ALL = "ALL",
  HNL = "HNL",
  SLL = "SLL",
  ROK = "ROK",
  BGJ = "BGJ",
  BGK = "BGK",
  BGL = "BGL",
  LRD = "LRD",
  LYD = "LYD",
  SZL = "SZL",
  LTL = "LTL",
  LSL = "LSL",
  LSM = "LSM",
  LUC = "LUC",
  LUL = "LUL",
  LUF = "LUF",
  MGA = "MGA",
  MGF = "MGF",
  MYR = "MYR",
  MVQ = "MVQ",
  MLF = "MLF",
  MTL = "MTL",
  MTP = "MTP",
  DDM = "DDM",
  FIM = "FIM",
  MUR = "MUR",
  MXN = "MXN",
  MXP = "MXP",
  MXV = "MXV",
  MDL = "MDL",
  MAD = "MAD",
  MZE = "MZE",
  MZM = "MZM",
  MZN = "MZN",
  BOV = "BOV",
  NGN = "NGN",
  ERN = "ERN",
  NAD = "NAD",
  NPR = "NPR",
  ANG = "ANG",
  NLG = "NLG",
  BRN = "BRN",
  YUM = "YUM",
  ILS = "ILS",
  AON = "AON",
  RON = "RON",
  TWD = "TWD",
  YUD = "YUD",
  ZRN = "ZRN",
  NZD = "NZD",
  BTN = "BTN",
  KPW = "KPW",
  NOK = "NOK",
  VNC = "VNC",
  ISJ = "ISJ",
  ALK = "ALK",
  ROL = "ROL",
  ILR = "ILR",
  UGW = "UGW",
  TRL = "TRL",
  UYN = "UYN",
  MRO = "MRO",
  MRU = "MRU",
  TOP = "TOP",
  PKR = "PKR",
  XPD = "XPD",
  MOP = "MOP",
  LAJ = "LAJ",
  ARP = "ARP",
  CUC = "CUC",
  UYU = "UYU",
  BOP = "BOP",
  ARY = "ARY",
  PHP = "PHP",
  XPT = "XPT",
  PTE = "PTE",
  GBP = "GBP",
  ILP = "ILP",
  BWP = "BWP",
  QAR = "QAR",
  GTQ = "GTQ",
  XRE = "XRE",
  ZAR = "ZAR",
  RHD = "RHD",
  ZWC = "ZWC",
  OMR = "OMR",
  KHR = "KHR",
  SUR = "SUR",
  MVR = "MVR",
  IDR = "IDR",
  RUB = "RUB",
  RUR = "RUR",
  RWF = "RWF",
  XDR = "XDR",
  SHP = "SHP",
  SAR = "SAR",
  ATS = "ATS",
  CSD = "CSD",
  RSD = "RSD",
  SCR = "SCR",
  XAG = "XAG",
  SGD = "SGD",
  SKK = "SKK",
  PEH = "PEH",
  PEN = "PEN",
  PES = "PES",
  SBD = "SBD",
  KGS = "KGS",
  SOS = "SOS",
  TJS = "TJS",
  SSP = "SSP",
  ESA = "ESA",
  ESP = "ESP",
  LKR = "LKR",
  ECS = "ECS",
  XSU = "XSU",
  SDD = "SDD",
  SDG = "SDG",
  SDP = "SDP",
  SRD = "SRD",
  SRG = "SRG",
  SEK = "SEK",
  CHF = "CHF",
  GNE = "GNE",
  GNS = "GNS",
  SYP = "SYP",
  TJR = "TJR",
  BDT = "BDT",
  WST = "WST",
  LTT = "LTT",
  TZS = "TZS",
  KZT = "KZT",
  XXX = "XXX",
  TPE = "TPE",
  SIT = "SIT",
  TTD = "TTD",
  MNT = "MNT",
  TND = "TND",
  TRY = "TRY",
  TMM = "TMM",
  TMT = "TMT",
  AED = "AED",
  XFU = "XFU",
  USN = "USN",
  USS = "USS",
  USD = "USD",
  UGS = "UGS",
  UGX = "UGX",
  UYW = "UYW",
  CLF = "CLF",
  ECV = "ECV",
  COU = "COU",
  UYI = "UYI",
  UYP = "UYP",
  UZS = "UZS",
  VUV = "VUV",
  CHE = "CHE",
  CHC = "CHC",
  CHW = "CHW",
  KRW = "KRW",
  YDD = "YDD",
  YER = "YER",
  JPY = "JPY",
  CNY = "CNY",
  YUN = "YUN",
  ZRZ = "ZRZ",
  ZMK = "ZMK",
  ZMW = "ZMW",
  ZWN = "ZWN",
  ZWD = "ZWD",
  ZWL = "ZWL",
  ZWR = "ZWR",
  PLN = "PLN",
  PLZ = "PLZ",
}


export type HNMoneyFilterInputRange = {
  start?: number | null,
  end?: number | null,
};

export type HNBooleanFilterInput = {
  equals: boolean,
};

export type HNFinancialAccountActivityTypeFilterInput = {
  equals?: HNFinancialAccountActivityType | null,
  notEquals?: HNFinancialAccountActivityType | null,
  includes?: Array< HNFinancialAccountActivityType > | null,
  excludes?: Array< HNFinancialAccountActivityType > | null,
};

export enum HNFinancialAccountActivityType {
  PAYMENT_CARD = "PAYMENT_CARD",
  EXTERNALLY_INITIATED_ACH = "EXTERNALLY_INITIATED_ACH",
  INTEGRATOR_INITIATED_ACH = "INTEGRATOR_INITIATED_ACH",
  ACCOUNT_HOLDER_FEE = "ACCOUNT_HOLDER_FEE",
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
}


export type GetCardsInput = {
  filter?: GetCardsFilterInput | null,
  nextToken?: string | null,
  sort?: SortFilterInput | null,
  limit?: number | null,
};

export type GetCardsFilterInput = {
  userId?: EqualCondition | null,
  paidolId?: EqualCondition | null,
  cardId?: EqualCondition | null,
  and?: Array< GetCardsOrConditionFilterInput | null > | null,
};

export type EqualCondition = {
  eq?: string | null,
  ne?: string | null,
  wildcard?: string | null,
};

export type GetCardsOrConditionFilterInput = {
  or?: Array< GetCardsOptionalFilterInput | null > | null,
};

export type GetCardsOptionalFilterInput = {
  paymentCardId?: EqualCondition | null,
  yearAndMonth?: RangeCondition | null,
  cardholderName?: EqualCondition | null,
  name?: EqualCondition | null,
  last4?: EqualCondition | null,
  status?: EqualCondition | null,
  cardholderId?: ExistsCondition | null,
  cardGroupId?: ExistsCondition | null,
};

export type RangeCondition = {
  gt?: string | null,
  lt?: string | null,
};

export type ExistsCondition = {
  eq?: string | null,
  ne?: string | null,
  exists?: boolean | null,
};

export type SortFilterInput = {
  field: string,
  direction: string,
};

export type GetCardsPayloadResult = {
  __typename: "GetCardsPayloadResult",
  nextToken?: string | null,
  total?: number | null,
  items?:  Array<GetCardsPayload > | null,
};

export type GetCardsPayload = {
  __typename: "GetCardsPayload",
  last4: string,
  paymentCardId: string,
  formFactor: HNCardFormFactor,
  paidolId: string,
  name?: string | null,
  velocityRuleBalances?:  Array<HNVelocityRuleBalance > | null,
  status: HNPaymentCardStatus,
  spent: HNAmount,
  expirationDate: string,
  procoreEmployee?: GetCardsProcoreEmployeePayload | null,
  cardholder?: GetCardsCardholderPayload | null,
  cardGroup?: GetCardsCardGroupPayload | null,
  spxSpendRule?: GetCardsSpendRulePayload | null,
  monthlySpendLimit?: GetCardsMonthlySpendLimitPayload | null,
  maximumTransactionAmount?: GetCardsMaximumTransactionAmountPayload | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  network?: HNPaymentCardNetwork | null,
  isAdminLocked?: boolean | null,
  isAuthorizedUserCard?: boolean | null,
};

export type GetCardsProcoreEmployeePayload = {
  __typename: "GetCardsProcoreEmployeePayload",
  id: number,
  name: string,
  email_address?: string | null,
};

export type GetCardsCardholderPayload = {
  __typename: "GetCardsCardholderPayload",
  id: string,
  userId?: string | null,
  name?: string | null,
  email: string,
  picture?: string | null,
};

export type GetCardsCardGroupPayload = {
  __typename: "GetCardsCardGroupPayload",
  id: string,
  name?: string | null,
};

export type GetCardsSpendRulePayload = {
  __typename: "GetCardsSpendRulePayload",
  id?: string | null,
  name?: string | null,
  merchantCountrySpendRuleId?: string | null,
  merchantCategorySpendRuleId?: string | null,
  paymentCards?: Array< string > | null,
};

export type GetCardsMonthlySpendLimitPayload = {
  __typename: "GetCardsMonthlySpendLimitPayload",
  id: string,
  name: string,
  amount: number,
  currency: string,
  cumulativeRuleId: string,
};

export type GetCardsMaximumTransactionAmountPayload = {
  __typename: "GetCardsMaximumTransactionAmountPayload",
  id: string,
  amount: number,
  currency: string,
};

export type GetCardsLitePayloadResult = {
  __typename: "GetCardsLitePayloadResult",
  nextToken?: string | null,
  total?: number | null,
  items?:  Array<GetCardsLitePayload > | null,
};

export type GetCardsLitePayload = {
  __typename: "GetCardsLitePayload",
  paymentCardId: string,
  last4: string,
  name?: string | null,
  cardholder?: GetCardsLiteCardholderPayload | null,
  monthlySpendLimit?: GetCardsLiteMonthlySpendLimitPayload | null,
};

export type GetCardsLiteCardholderPayload = {
  __typename: "GetCardsLiteCardholderPayload",
  name?: string | null,
  picture?: string | null,
};

export type GetCardsLiteMonthlySpendLimitPayload = {
  __typename: "GetCardsLiteMonthlySpendLimitPayload",
  name: string,
  amount: number,
};

export type GetJobCodesInput = {
  paidolId: string,
  nextToken?: string | null,
  paidolUserId?: string | null,
  yearAndMonth?: string | null,
};

export type GetJobCodesPayloadResult = {
  __typename: "GetJobCodesPayloadResult",
  jobCodeImport?: GetJobCodesJobCodeImportPayload | null,
  paidolUsersMap:  Array<GetJobCodesPaidolUserMapPayload >,
};

export type GetJobCodesJobCodeImportPayload = {
  __typename: "GetJobCodesJobCodeImportPayload",
  id: string,
  paidolId: string,
  authPaidolId: string,
  createdAt: string,
  storageFileKey: string,
  fileName: string,
  status: JobCodeImportStatus,
  errors?: string | null,
  jobCodes?: ModelJobCodeConnection | null,
  updatedAt: string,
};

export type GetJobCodesPaidolUserMapPayload = {
  __typename: "GetJobCodesPaidolUserMapPayload",
  code: string,
  paidolUsers:  Array<PaidolUser >,
};

export type GetFinicityConnectUrlInput = {
  operationName?: string | null,
  data?: GetFinicityConnectUrlData | null,
};

export type GetFinicityConnectUrlData = {
  customerId: string,
  type: FinicityConnectUrlType,
};

export enum FinicityConnectUrlType {
  PAIDOL = "PAIDOL",
  USER = "USER",
}


export type GetFinicityConnectUrlResult = {
  __typename: "GetFinicityConnectUrlResult",
  link?: string | null,
};

export type GetFinicityCustomerAccountsInput = {
  operationName?: string | null,
  data?: GetFinicityCustomerAccountsData | null,
};

export type GetFinicityCustomerAccountsData = {
  customerId?: string | null,
};

export type FinicityBankAccountInfo = {
  __typename: "FinicityBankAccountInfo",
  id?: string | null,
  accountNumberDisplay?: string | null,
  name?: string | null,
  type?: string | null,
  balance?: number | null,
  status?: string | null,
  institutionId?: string | null,
  institution?: FinicityBankInstitution | null,
};

export type FinicityBankInstitution = {
  __typename: "FinicityBankInstitution",
  name?: string | null,
  urlHomeApp?: string | null,
  branding?: FinicityBankInstitutionBranding | null,
};

export type FinicityBankInstitutionBranding = {
  __typename: "FinicityBankInstitutionBranding",
  logo?: string | null,
  alternateLogo?: string | null,
  icon?: string | null,
  primaryColor?: string | null,
  tile?: string | null,
};

export type GetProcoreCompaniesInput = {
  operationName: string,
  data: GetProcoreCompaniesInputData,
};

export type GetProcoreCompaniesInputData = {
  auth: string,
};

export type GetProcoreProjectsInput = {
  operationName: string,
  data: GetProcoreProjectsInputData,
};

export type GetProcoreProjectsInputData = {
  auth: string,
  companyId: number,
};

export type GetProcoreProjectUsersInput = {
  operationName: string,
  data: GetProcoreProjectUsersInputData,
};

export type GetProcoreProjectUsersInputData = {
  auth: string,
  search: string,
  projectId: number,
  companyId: number,
};

export type GetProcoreProjectUsersPayload = {
  __typename: "GetProcoreProjectUsersPayload",
  id: number,
  name: string,
  email_address?: string | null,
};

export type GetProcoreWBSCodesInput = {
  operationName: string,
  data: GetProcoreWBSCodesInputData,
};

export type GetProcoreWBSCodesInputData = {
  auth: string,
  projectId: number,
  companyId: number,
};

export type GetCardsManagementFilterOptionsInput = {
  paidolId: string,
};

export type GetCardsManagementFilterOptionsResult = {
  __typename: "GetCardsManagementFilterOptionsResult",
  cardGroupId?:  Array<FilterOption > | null,
  cardNames?:  Array<FilterOption > | null,
  cardholders?:  Array<FilterOption > | null,
  last4?:  Array<FilterOption > | null,
  status?:  Array<FilterOption > | null,
};

export type AgaveProjectsInput = {
  account_token?: string | null,
};

export type AgaveGlCodesInput = {
  account_token?: string | null,
};

export type AgaveCostCodesInput = {
  project_id?: string | null,
  account_token: string,
};

export type AgaveEmployeesInput = {
  account_token?: string | null,
};

export type AgaveEmployee = {
  __typename: "AgaveEmployee",
  id?: string | null,
  source_id?: string | null,
  address?: AgaveEmployeeAddress | null,
  company?: string | null,
  email?: string | null,
  first_name?: string | null,
  full_name?: string | null,
  gender?: string | null,
  hire_date?: string | null,
  industry?: string | null,
  job_title?: string | null,
  last_name?: string | null,
  mobile_phone?: string | null,
  phone?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  status?: string | null,
  termination_date?: string | null,
  type?: string | null,
  source_data?: AgaveEmployeeSourceData | null,
};

export type AgaveEmployeeAddress = {
  __typename: "AgaveEmployeeAddress",
  city?: string | null,
  country?: string | null,
  postal_code?: string | null,
  state?: string | null,
  street_1?: string | null,
  street_2?: string | null,
  type?: string | null,
};

export type AgaveEmployeeSourceData = {
  __typename: "AgaveEmployeeSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: AgaveEmployeeSourceDataDetails | null,
};

export type AgaveEmployeeSourceDataDetails = {
  __typename: "AgaveEmployeeSourceDataDetails",
  PRCo?: number | null,
  Employee?: number | null,
  LastName?: string | null,
  FirstName?: string | null,
  MidName?: string | null,
  SortName?: string | null,
  Address?: string | null,
  City?: string | null,
  State?: string | null,
  Zip?: string | null,
  Address2?: string | null,
  Phone?: string | null,
  SSN?: string | null,
  Race?: string | null,
  Sex?: string | null,
  BirthDate?: string | null,
  HireDate?: string | null,
  TermDate?: string | null,
  PRGroup?: number | null,
  PRDept?: string | null,
  Craft?: string | null,
  Class?: string | null,
  InsCode?: string | null,
  TaxState?: string | null,
  UnempState?: string | null,
  InsState?: string | null,
  LocalCode?: string | null,
  GLCo?: number | null,
  UseState?: string | null,
  UseIns?: string | null,
  JCCo?: number | null,
  Job?: string | null,
  Crew?: string | null,
  LastUpdated?: string | null,
  EarnCode?: number | null,
  HrlyRate?: string | null,
  SalaryAmt?: string | null,
  OTOpt?: string | null,
  OTSched?: string | null,
  JCFixedRate?: string | null,
  EMFixedRate?: string | null,
  SMFixedRate?: string | null,
  YTDSUI?: string | null,
  OccupCat?: string | null,
  CatStatus?: string | null,
  DirDeposit?: string | null,
  RoutingId?: string | null,
  BankAcct?: string | null,
  AcctType?: string | null,
  ActiveYN?: string | null,
  PensionYN?: string | null,
  PostToAll?: string | null,
  CertYN?: string | null,
  ChkSort?: string | null,
  AuditYN?: string | null,
  Notes?: string | null,
  UniqueAttchID?: string | null,
  Email?: string | null,
  DefaultPaySeq?: string | null,
  DDPaySeq?: string | null,
  Suffix?: string | null,
  TradeSeq?: string | null,
  CSLimit?: string | null,
  CSGarnGroup?: string | null,
  CSAllocMethod?: string | null,
  Shift?: string | null,
  NonResAlienYN?: string | null,
  KeyID?: string | null,
  Country?: string | null,
  HDAmt?: string | null,
  F1Amt?: string | null,
  LCFStock?: string | null,
  LCPStock?: string | null,
  NAICS?: string | null,
  AUEFTYN?: string | null,
  AUAccountNumber?: string | null,
  AUBSB?: string | null,
  AUReference?: string | null,
  EMCo?: number | null,
  Equipment?: string | null,
  EMGroup?: number | null,
  PayMethodDelivery?: string | null,
  CPPQPPExempt?: string | null,
  EIExempt?: string | null,
  PPIPExempt?: string | null,
  TimesheetRevGroup?: string | null,
  UpdatePRAEYN?: string | null,
  WOTaxState?: string | null,
  WOLocalCode?: string | null,
  UseLocal?: string | null,
  UseUnempState?: string | null,
  UseInsState?: string | null,
  NewHireActStartDate?: string | null,
  NewHireActEndDate?: string | null,
  CellPhone?: string | null,
  ArrearsActiveYN?: string | null,
  RecentRehireDate?: string | null,
  RecentSeparationDate?: string | null,
  SeparationReason?: string | null,
  SeparationReasonExplanation?: string | null,
  WeeklyHours?: string | null,
  ETPPostedYN?: string | null,
  AdditionalSourceDedns?: string | null,
  AuthorizedSourceDedns?: string | null,
  ExemptHealthContribution?: string | null,
  AlwaysCalcQPIP?: string | null,
  PrintInFrench?: string | null,
  CAProgramAccount?: string | null,
  QCFileNumber?: string | null,
  EmailW2YN?: string | null,
  Email1095CYN?: string | null,
  EmailT4YN?: string | null,
  EmailPAYGSumYN?: string | null,
  PAYGIncomeType?: string | null,
  StatusIndianYN?: string | null,
  APVendorGroup?: number | null,
  APVendor?: string | null,
  PRUpdateAPVMYN?: string | null,
  GeographicCode?: string | null,
  JobKeeperStartFN?: string | null,
  JobKeeperFinishFN?: string | null,
  JobKeeperTierLevel?: string | null,
  JobMakerNominate?: string | null,
  JobMakerRenominate?: string | null,
  JobMakerEligPeriod01?: string | null,
  JobMakerEligPeriod02?: string | null,
  JobMakerEligPeriod03?: string | null,
  JobMakerEligPeriod04?: string | null,
  JobMakerEligPeriod05?: string | null,
  JobMakerEligPeriod06?: string | null,
  JobMakerEligPeriod07?: string | null,
  JobMakerEligPeriod08?: string | null,
  GenderIdentity?: string | null,
  GenderIdentityOther?: string | null,
  EmploymentBasis?: string | null,
  CessationType?: string | null,
  MedicareLevySurchargeYN?: string | null,
  MedicareLevySurchargeTier?: string | null,
  MedicareLevyReductionYN?: string | null,
  IncomeStreamCountry?: string | null,
  FederalTaxExemptYN?: string | null,
};

export type AgaveCostTypesInput = {
  project_id?: string | null,
  account_token: string,
};

export type AgaveGlCostTypesInput = {
  project_id?: string | null,
  account_token: string,
};

export type GetAgaveVendorsInput = {
  project_id?: string | null,
  account_token: string,
};

export type AgaveBankAccountsInput = {
  account_token: string,
  project_id?: string | null,
};

export type AgaveBankAccount = {
  __typename: "AgaveBankAccount",
  id?: string | null,
  source_id?: string | null,
  bank_name?: string | null,
  currency_code?: string | null,
  current_balance?: string | null,
  description?: string | null,
  ledger_account_id?: string | null,
  name?: string | null,
  number?: string | null,
  source_create_time?: string | null,
  source_update_time?: string | null,
  status?: string | null,
  type?: string | null,
  source_data?: AgaveBankAccountSourceData | null,
};

export type AgaveBankAccountSourceData = {
  __typename: "AgaveBankAccountSourceData",
  path?: string | null,
  content_type?: string | null,
  data?: string | null,
};

export type GetAgaveVendorInput = {
  account_token: string,
  project_id?: string | null,
  merchantName: string,
};

export type AgaveAccountInput = {
  account_token?: string | null,
};

export type AgaveAccount = {
  __typename: "AgaveAccount",
  account_id?: string | null,
  connection?: AgaveAccountConnection | null,
  created_at?: string | null,
  linked_company?: AgaveAccountLinkedCompany | null,
  linked_user?: AgaveAccountLinkedUser | null,
  reference_id?: string | null,
  source_system?: AgaveAccountSourceSystem | null,
  source_system_environment?: AgaveAccountSourceSystemEnvironment | null,
  status?: string | null,
  supports_cross_account_uuid?: boolean | null,
  supports_cross_company_requests?: boolean | null,
};

export type AgaveAccountConnection = {
  __typename: "AgaveAccountConnection",
  type?: string | null,
  properties?: AgaveAccountConnectionProperties | null,
};

export type AgaveAccountConnectionProperties = {
  __typename: "AgaveAccountConnectionProperties",
  company_id?: string | null,
  database?: string | null,
  hostname?: string | null,
  port?: string | null,
  username?: string | null,
  password?: string | null,
  sql_server_timezone_offset?: string | null,
  prefer_views_over_tables?: boolean | null,
};

export type AgaveAccountLinkedCompany = {
  __typename: "AgaveAccountLinkedCompany",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
};

export type AgaveAccountLinkedUser = {
  __typename: "AgaveAccountLinkedUser",
  id?: string | null,
  source_id?: string | null,
  name?: string | null,
  email?: string | null,
};

export type AgaveAccountSourceSystem = {
  __typename: "AgaveAccountSourceSystem",
  name?: string | null,
  slug?: string | null,
};

export type AgaveAccountSourceSystemEnvironment = {
  __typename: "AgaveAccountSourceSystemEnvironment",
  name?: string | null,
  slug?: string | null,
};

export type GetAgaveAPInvoiceByFilterSageIntacctInput = {
  account_token: string,
  field?: string | null,
  operator?: string | null,
  value?: string | null,
};

export type SearchSpxTransactionsInput = {
  filter?: SpxTransactionsFilterInput | null,
  nextToken?: string | null,
  sort?: SortFilterInput | null,
  limit?: number | null,
};

export type SpxTransactionsFilterInput = {
  paidolId: EqualCondition,
  eventDate?: RangeCondition | null,
  approveWithoutReceipts?: EqualBooleanCondition | null,
  receiptPath?: ExistsCondition | null,
  flexCodeTransactionStatus?: EqualCondition | null,
  workflowStatus?: EqualCondition | null,
  paymentCardId?: EqualCondition | null,
  jobCodeId?: ExistsCondition | null,
  mobileActions?: EqualBooleanCondition | null,
  excludeApproved?: EqualBooleanCondition | null,
  codingType?: EqualCondition | null,
  // Array of date ranges for statement period filtering with OR logic.
  // Each range represents a statement period, and transactions matching ANY period are returned.
  statementPeriodDateRanges?: Array< RangeCondition > | null,
  or?: Array< SpxTransactionsPaymentCardsFilterInput | null > | null,
  and?: Array< SpxTransactionsOrConditionFilterInput | null > | null,
};

export type EqualBooleanCondition = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SpxTransactionsPaymentCardsFilterInput = {
  paymentCardId?: EqualCondition | null,
};

export type SpxTransactionsOrConditionFilterInput = {
  or?: Array< SpxTransactionsOptionalFilterInput | null > | null,
};

export type SpxTransactionsOptionalFilterInput = {
  merchantName?: EqualCondition | null,
  merchantCategory?: EqualCondition | null,
  cardGroupId?: EqualCondition | null,
  projectGroupId?: EqualCondition | null,
  last4?: EqualCondition | null,
  userId?: EqualCondition | null,
  approvedAmountValue?: FloatRangeCondition | null,
  status?: EqualCondition | null,
  flexCodeTransactionStatus?: EqualCondition | null,
  workflowStatus?: EqualCondition | null,
  agaveTransactionStatus?: EqualCondition | null,
  returnedStatus?: EqualCondition | null,
  receiptStatus?: EqualCondition | null,
  flexGlCodeId?: EqualCondition | null,
  flexCodeId?: EqualCondition | null,
  flexCostCodeId?: EqualCondition | null,
  flexCostTypeId?: EqualCondition | null,
  flexVendorId?: EqualCondition | null,
  agaveGlCodeId?: EqualCondition | null,
  agaveProjectId?: EqualCondition | null,
  agaveCostCodeId?: EqualCondition | null,
  agaveCostTypeId?: EqualCondition | null,
  agaveVendorId?: EqualCondition | null,
  agaveLocationId?: EqualCondition | null,
  agaveDepartmentId?: EqualCondition | null,
  agaveSubaccountId?: EqualCondition | null,
  agaveSubJobId?: EqualCondition | null,
  agaveEquipmentId?: EqualCondition | null,
  agaveEmCostCodeId?: EqualCondition | null,
  agaveEmCostTypeId?: EqualCondition | null,
  erpBillableItemId?: EqualCondition | null,
  codingType?: EqualCondition | null,
};

export type FloatRangeCondition = {
  gt?: number | null,
  gte?: number | null,
  lt?: number | null,
  lte?: number | null,
};

export type SearchSpxTransactionsPayload = {
  __typename: "SearchSpxTransactionsPayload",
  items?:  Array<HighnoteTransactionEvent > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchFlexCodingInput = {
  filter?: SearchFlexCodingFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  retrieve_all?: boolean | null,
};

export type SearchFlexCodingFilterInput = {
  paidolId: EqualCondition,
  glCodeId?: EqualCondition | null,
  flexCodeId?: EqualCondition | null,
  specificIds?: Array< string | null > | null,
  searchTerm?: string | null,
  cardGroupId?: string | null,
  isSettingsRequest?: boolean | null,
};

export type SearchFlexGlCodePayload = {
  __typename: "SearchFlexGlCodePayload",
  items?:  Array<FlexGlCode > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type GetProjectGroupInput = {
  group_id: string,
};

export type GetProjectGroupPayload = {
  __typename: "GetProjectGroupPayload",
  projectGroup?: ProjectGroup | null,
  projects?:  Array<GetProjectGroupProjects > | null,
  groupAdmins?:  Array<PaidolUserToProjectGroup | null > | null,
};

export type GetProjectGroupProjects = {
  __typename: "GetProjectGroupProjects",
  id: string,
  name: string,
};

export type SearchFlexCodesPayload = {
  __typename: "SearchFlexCodesPayload",
  items?:  Array<FlexCode > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchFlexCostCodesPayload = {
  __typename: "SearchFlexCostCodesPayload",
  items?:  Array<FlexCostCode > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchFlexCostTypesPayload = {
  __typename: "SearchFlexCostTypesPayload",
  items?:  Array<FlexCostType > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchFlexVendorsPayload = {
  __typename: "SearchFlexVendorsPayload",
  items?:  Array<FlexVendor > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type GetAgaveSyncByPaidolIdInput = {
  paidolId: string,
  finished?: boolean | null,
};

export type GetAgaveSyncByPaidolIdPayload = {
  __typename: "GetAgaveSyncByPaidolIdPayload",
  sync?: PaidolAgaveSync | null,
};

export type MigrateERPEndpointSettingsPayload = {
  __typename: "MigrateERPEndpointSettingsPayload",
  migrated?: boolean | null,
  paidol?: Paidol | null,
};

export type ListMerchantSpendRulesInput = {
  paidol_id: string,
};

export type v2ListCardGroupsByPaidolIdInput = {
  nextToken?: string | null,
  sortDirection?: SortDirection | null,
  limit?: number | null,
  filter?: v2ListCardGroupsByPaidolIdFilterInput | null,
  sort?: CardGroupSortInput | null,
  advancedFilter?: CardGroupFilterInput | null,
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type v2ListCardGroupsByPaidolIdFilterInput = {
  paidolId?: EqualCondition | null,
};

export type CardGroupSortInput = {
  field: string,
  direction: string,
};

export type CardGroupFilterInput = {
  and?: Array< CardGroupOrConditionFilterInput | null > | null,
};

export type CardGroupOrConditionFilterInput = {
  or?: Array< CardGroupFilterCondition | null > | null,
};

export type CardGroupFilterCondition = {
  hasGroupAdmin?: BooleanFilterInput | null,
  isMonthlyBudgetUnlimited?: BooleanFilterInput | null,
  visibilitySettings?: StringFilterInput | null,
  projectVisibilityIds?: StringArrayFilterInput | null,
  glCodeVisibilityIds?: StringArrayFilterInput | null,
  groupAdminId?: StringArrayFilterInput | null,
  cardholderId?: StringArrayFilterInput | null,
  last4?: StringArrayFilterInput | null,
};

export type BooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type StringFilterInput = {
  eq?: string | null,
  ne?: string | null,
};

export type StringArrayFilterInput = {
  contains?: string | null,
  notContains?: string | null,
};

export type v2ListCardGroupsByPaidolIdPayload = {
  __typename: "v2ListCardGroupsByPaidolIdPayload",
  items:  Array<CardGroup >,
  nextToken?: string | null,
  total?: number | null,
};

export type v2ListProjectGroupsByPaidolIdInput = {
  nextToken?: string | null,
  sortDirection?: SortDirection | null,
  limit?: number | null,
  filter?: v2ListProjectGroupsByPaidolIdFilterInput | null,
  sort?: ProjectGroupSortInput | null,
  advancedFilter?: ProjectGroupFilterInput | null,
};

export type v2ListProjectGroupsByPaidolIdFilterInput = {
  paidolId?: EqualCondition | null,
};

export type ProjectGroupSortInput = {
  field: string,
  direction: string,
};

export type ProjectGroupFilterInput = {
  and?: Array< ProjectGroupOrConditionFilterInput | null > | null,
};

export type ProjectGroupOrConditionFilterInput = {
  or?: Array< ProjectGroupFilterCondition | null > | null,
};

export type ProjectGroupFilterCondition = {
  hasGroupAdmin?: BooleanFilterInput | null,
  isMonthlyBudgetUnlimited?: BooleanFilterInput | null,
  groupAdminId?: StringArrayFilterInput | null,
  projectAssociation?: StringArrayFilterInput | null,
};

export type v2ListProjectGroupsByPaidolIdPayload = {
  __typename: "v2ListProjectGroupsByPaidolIdPayload",
  items:  Array<ProjectGroup >,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveGLCodesInput = {
  filter?: SearchAgaveGLCodesFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveGLCodesFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  cardGroupId?: string | null,
  isSettingsRequest?: boolean | null,
};

export type SearchAgaveGLCodesPayload = {
  __typename: "SearchAgaveGLCodesPayload",
  items?:  Array<AgaveGlCode > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveProjectsInput = {
  filter?: SearchAgaveProjectsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveProjectsFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  cardGroupId?: string | null,
  isSettingsRequest?: boolean | null,
  locationId?: string | null,
};

export type SearchAgaveProjectsPayload = {
  __typename: "SearchAgaveProjectsPayload",
  items?:  Array<AgaveProject > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveCostCodesInput = {
  filter?: SearchAgaveCostCodesFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveCostCodesFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  subJobId?: string | null,
  projectId?: string | null,
};

export type SearchAgaveCostCodesPayload = {
  __typename: "SearchAgaveCostCodesPayload",
  items?:  Array<AgaveCostCode > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type GetAgaveGlCodesByCostingInput = {
  paidolId: string,
  projectId: string,
  costCodeId: string,
  costTypeId: string,
};

export type GetAgaveGlCodesByCostingPayload = {
  __typename: "GetAgaveGlCodesByCostingPayload",
  items?:  Array<AgaveGlCode > | null,
  total?: number | null,
  itemSourceId?: string | null,
  itemName?: string | null,
};

export type SearchAgaveVendorsInput = {
  filter?: SearchAgaveVendorsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveVendorsFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
};

export type SearchAgaveVendorsPayload = {
  __typename: "SearchAgaveVendorsPayload",
  items?:  Array<AgaveVendor > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveCostTypesInput = {
  filter?: SearchAgaveCostTypesFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveCostTypesFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  projectId?: string | null,
  costCodeId?: string | null,
};

export type SearchAgaveCostTypesPayload = {
  __typename: "SearchAgaveCostTypesPayload",
  items?:  Array<AgaveCostType > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveSubJobsInput = {
  filter?: SearchAgaveSubJobsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveSubJobsFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  projectId?: string | null,
  costCodeId?: string | null,
};

export type SearchAgaveSubJobsPayload = {
  __typename: "SearchAgaveSubJobsPayload",
  items?:  Array<AgaveSubJob > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveLocationsInput = {
  filter?: SearchAgaveLocationsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveLocationsFilterInput = {
  paidolId?: string | null,
  projectId?: string | null,
  employeeId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  isSettingsRequest?: boolean | null,
};

export type SearchAgaveLocationsPayload = {
  __typename: "SearchAgaveLocationsPayload",
  items?:  Array<AgaveLocation > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveDepartmentsInput = {
  filter?: SearchAgaveDepartmentsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveDepartmentsFilterInput = {
  paidolId?: string | null,
  projectId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  isSettingsRequest?: boolean | null,
};

export type SearchAgaveDepartmentsPayload = {
  __typename: "SearchAgaveDepartmentsPayload",
  items?:  Array<AgaveDepartment > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveSubaccountsInput = {
  filter?: SearchAgaveSubaccountsFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveSubaccountsFilterInput = {
  paidolId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
};

export type SearchAgaveSubaccountsPayload = {
  __typename: "SearchAgaveSubaccountsPayload",
  items?:  Array<AgaveSubaccount > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchAgaveEmployeesInput = {
  filter?: SearchAgaveEmployeesFilterInput | null,
  nextToken?: string | null,
  limit?: number | null,
  sortDirection?: string | null,
};

export type SearchAgaveEmployeesFilterInput = {
  paidolId?: string | null,
  locationId?: string | null,
  ids?: Array< string | null > | null,
  searchTerm?: string | null,
  isSettingsRequest?: boolean | null,
};

export type SearchAgaveEmployeesPayload = {
  __typename: "SearchAgaveEmployeesPayload",
  items?:  Array<AgaveEmployeeEntity > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type GetReimbursementTransactionInput = {
  id: string,
};

export type GetReimbursementTransactionsByPaidolIdInput = {
  paidolId: string,
  status?: ReimbursementTransactionStatus | null,
  paidolUserId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetReimbursementTransactionsByPaidolIdPayload = {
  __typename: "GetReimbursementTransactionsByPaidolIdPayload",
  items:  Array<ReimbursementTransaction >,
  nextToken?: string | null,
};

export type GetReceiptUploadInput = {
  id: string,
};

export type GetReceiptsByTransactionIdInput = {
  highnoteTransactionEventId?: string | null,
  reimbursementTransactionId?: string | null,
};

export type GetReceiptsByTransactionIdPayload = {
  __typename: "GetReceiptsByTransactionIdPayload",
  items:  Array<ReceiptUpload >,
  nextToken?: string | null,
};

export type ExportReimbursementsInput = {
  paidolId: string,
  reimbursementStatus: ReimbursementTransactionStatus,
  startDate?: string | null,
  endDate?: string | null,
  rangeOption?: ExportDateRangeEnum | null,
  // When true and reimbursementStatus is APPROVED, the export will also
  // transition every successfully-exported transaction from APPROVED to EXPORTED
  // via a conditional update. Items whose status changed concurrently are
  // skipped and surfaced in skippedIds.
  moveToExported?: boolean | null,
};

export type ExportReimbursementsPayload = {
  __typename: "ExportReimbursementsPayload",
  csvContent?: string | null,
  filename?: string | null,
  success: boolean,
  message?: string | null,
  exportedIds?: Array< string > | null,
  skippedIds?: Array< string > | null,
};

export type BudgetSpendByCurrentCycle = {
  __typename: "BudgetSpendByCurrentCycle",
  paymentCardId: string,
  paidolId: string,
  authPaidolId: string,
  amount?: number | null,
  transactionCount?: number | null,
  lastResetAt?: string | null,
  lastTransactionAt?: string | null,
  processedTransactionIds?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
};

export type V2GetTransactionFilterOptionsInput = {
  paidolId: string,
};

export type V2TransactionFilterOptionsPayload = {
  __typename: "V2TransactionFilterOptionsPayload",
  paidolId: string,
  authPaidolId: string,
  last4?: Array< string > | null,
  userId?:  Array<FilterOption > | null,
  merchantName?:  Array<FilterOption > | null,
  merchantCategory?:  Array<FilterOption > | null,
  cardGroup?:  Array<FilterOption > | null,
  projectGroup?:  Array<FilterOption > | null,
  receiptStatus?:  Array<FilterOption > | null,
  highnoteTransactionStatus?:  Array<FilterOption > | null,
  flexCodeTransactionStatus?:  Array<FilterOption > | null,
  flexGlCodeIds?:  Array<FilterOption > | null,
  flexCodeIds?:  Array<FilterOption > | null,
  flexCostCodeIds?:  Array<FilterOption > | null,
  flexCostTypeIds?:  Array<FilterOption > | null,
  flexVendorIds?:  Array<FilterOption > | null,
  agaveTransactionStatus?:  Array<FilterOption > | null,
  agaveGlCodeIds?:  Array<FilterOption > | null,
  agaveProjectIds?:  Array<FilterOption > | null,
  agaveCostCodeIds?:  Array<FilterOption > | null,
  agaveCostTypeIds?:  Array<FilterOption > | null,
  agaveVendorIds?:  Array<FilterOption > | null,
  agaveLocationIds?:  Array<FilterOption > | null,
  agaveDepartmentIds?:  Array<FilterOption > | null,
  agaveSubaccountIds?:  Array<FilterOption > | null,
  agaveSubJobIds?:  Array<FilterOption > | null,
  agaveEquipmentIds?:  Array<FilterOption > | null,
  agaveEmCostCodeIds?:  Array<FilterOption > | null,
  agaveEmCostTypeIds?:  Array<FilterOption > | null,
  erpBillableItemIds?:  Array<FilterOption > | null,
  statementPeriods?:  Array<StatementPeriodOption > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type StatementPeriodOption = {
  __typename: "StatementPeriodOption",
  id: string,
  label: string,
  startDate: string,
  endDate: string,
};

export type ModelSubscriptionAgaveProjectFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  completion_date?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  number?: ModelSubscriptionStringInput | null,
  start_date?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  relatedIds?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveProjectFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveProjectFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAgaveGlCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  classification?: ModelSubscriptionStringInput | null,
  currency_code?: ModelSubscriptionStringInput | null,
  current_balance?: ModelSubscriptionFloatInput | null,
  description?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  number?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  relatedIds?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveGlCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveGlCodeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveCostCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  asset_account_id?: ModelSubscriptionStringInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  formatted_full_code?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  full_code?: ModelSubscriptionStringInput | null,
  cost_unit_of_measure?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  expense_account_id?: ModelSubscriptionStringInput | null,
  income_account_id?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  parent_id?: ModelSubscriptionStringInput | null,
  project_id?: ModelSubscriptionStringInput | null,
  price_unit_of_measure?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  unit_cost?: ModelSubscriptionStringInput | null,
  unit_price?: ModelSubscriptionStringInput | null,
  vendor_id?: ModelSubscriptionStringInput | null,
  sub_job_id?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  paidolProject?: ModelSubscriptionIDInput | null,
  projectIds?: ModelSubscriptionStringInput | null,
  cost_type_ids?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveCostCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveCostCodeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveSubJobFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  agaveSubJobId?: ModelSubscriptionStringInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  number?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  cost_code_ids?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveSubJobFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveSubJobFilterInput | null > | null,
};

export type ModelSubscriptionAgaveProjectCostCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  costCodeId?: ModelSubscriptionIDInput | null,
  projectIdCostCodeId?: ModelSubscriptionIDInput | null,
  costCodeName?: ModelSubscriptionStringInput | null,
  costCodeCode?: ModelSubscriptionStringInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveProjectCostCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveProjectCostCodeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveProjectSubJobFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  subJobId?: ModelSubscriptionIDInput | null,
  projectIdSubJobId?: ModelSubscriptionIDInput | null,
  subJobName?: ModelSubscriptionStringInput | null,
  subJobNumber?: ModelSubscriptionStringInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveProjectSubJobFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveProjectSubJobFilterInput | null > | null,
};

export type ModelSubscriptionAgaveSubJobCostCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  subJobId?: ModelSubscriptionIDInput | null,
  costCodeId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  subJobIdCostCodeId?: ModelSubscriptionIDInput | null,
  costCodeName?: ModelSubscriptionStringInput | null,
  costCodeCode?: ModelSubscriptionStringInput | null,
  subJobName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveSubJobCostCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveSubJobCostCodeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveProjectLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  locationId?: ModelSubscriptionIDInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  locationName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveProjectLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveProjectLocationFilterInput | null > | null,
};

export type ModelSubscriptionAgaveProjectDepartmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  departmentId?: ModelSubscriptionIDInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  departmentName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveProjectDepartmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveProjectDepartmentFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmployeeEntityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  source_data?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmployeeEntityFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmployeeEntityFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmployeeLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  employeeId?: ModelSubscriptionIDInput | null,
  locationId?: ModelSubscriptionIDInput | null,
  employeeName?: ModelSubscriptionStringInput | null,
  locationName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmployeeLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmployeeLocationFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmployeeDepartmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  employeeId?: ModelSubscriptionIDInput | null,
  departmentId?: ModelSubscriptionIDInput | null,
  employeeName?: ModelSubscriptionStringInput | null,
  departmentName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmployeeDepartmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmployeeDepartmentFilterInput | null > | null,
};

export type ModelSubscriptionAgaveCostTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  project_id?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  paidolProject?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionAgaveCostTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveCostTypeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEquipmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  emGroup?: ModelSubscriptionStringInput | null,
  emCo?: ModelSubscriptionStringInput | null,
  category?: ModelSubscriptionStringInput | null,
  department?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  lastSeenAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEquipmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEquipmentFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmCostCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  emGroup?: ModelSubscriptionStringInput | null,
  emCostTypeCodes?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  lastSeenAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmCostCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmCostCodeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmDepartmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  emCo?: ModelSubscriptionStringInput | null,
  costCodeKeys?: ModelSubscriptionStringInput | null,
  costTypeKeys?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  lastSeenAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmDepartmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmDepartmentFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmCostTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  emGroup?: ModelSubscriptionStringInput | null,
  abbreviation?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  lastSeenAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmCostTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmCostTypeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveCostCodeCostTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  costCodeId?: ModelSubscriptionIDInput | null,
  costTypeId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  costCodeCode?: ModelSubscriptionStringInput | null,
  costCodeName?: ModelSubscriptionStringInput | null,
  costTypeCode?: ModelSubscriptionStringInput | null,
  costTypeName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveCostCodeCostTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveCostCodeCostTypeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  emCostCodeId?: ModelSubscriptionIDInput | null,
  emCostTypeId?: ModelSubscriptionIDInput | null,
  emGroup?: ModelSubscriptionStringInput | null,
  emCostCodeCode?: ModelSubscriptionStringInput | null,
  emCostCodeName?: ModelSubscriptionStringInput | null,
  emCostTypeCode?: ModelSubscriptionStringInput | null,
  emCostTypeName?: ModelSubscriptionStringInput | null,
  unitOfMeasure?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput | null > | null,
};

export type ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  costCodeId?: ModelSubscriptionIDInput | null,
  costTypeId?: ModelSubscriptionIDInput | null,
  glCodeId?: ModelSubscriptionIDInput | null,
  projectCostCodeCostTypeKey?: ModelSubscriptionIDInput | null,
  glCodeSourceId?: ModelSubscriptionStringInput | null,
  glCodeNumber?: ModelSubscriptionStringInput | null,
  itemSourceId?: ModelSubscriptionStringInput | null,
  itemName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput | null > | null,
};

export type ModelSubscriptionAgaveLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  parent_id?: ModelSubscriptionStringInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  source_data?: ModelSubscriptionStringInput | null,
  relatedIds?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveLocationFilterInput | null > | null,
};

export type ModelSubscriptionAgaveDepartmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  source_data?: ModelSubscriptionStringInput | null,
  relatedIds?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveDepartmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveDepartmentFilterInput | null > | null,
};

export type ModelSubscriptionAgaveSubaccountFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  source_data?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveSubaccountFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveSubaccountFilterInput | null > | null,
};

export type ModelSubscriptionAgaveVendorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  source_id?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  fax?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  tax_number?: ModelSubscriptionStringInput | null,
  terms?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  website?: ModelSubscriptionStringInput | null,
  source_create_time?: ModelSubscriptionStringInput | null,
  source_update_time?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgaveVendorFilterInput | null > | null,
  or?: Array< ModelSubscriptionAgaveVendorFilterInput | null > | null,
};

export type ModelSubscriptionPaidolAgaveSyncFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  inProgress?: ModelSubscriptionBooleanInput | null,
  error?: ModelSubscriptionStringInput | null,
  lastRunStart?: ModelSubscriptionStringInput | null,
  lastRunEnd?: ModelSubscriptionStringInput | null,
  taskArn?: ModelSubscriptionStringInput | null,
  syncEntityFilter?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPaidolAgaveSyncFilterInput | null > | null,
  or?: Array< ModelSubscriptionPaidolAgaveSyncFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionPaymentStatusDownloadFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  start_date?: ModelSubscriptionStringInput | null,
  end_date?: ModelSubscriptionStringInput | null,
  s3_key?: ModelSubscriptionStringInput | null,
  cron_status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPaymentStatusDownloadFilterInput | null > | null,
  or?: Array< ModelSubscriptionPaymentStatusDownloadFilterInput | null > | null,
  user_id?: ModelStringInput | null,
};

export type ModelSubscriptionPaidolHighnoteIntegrationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  legalBusinessName?: ModelSubscriptionStringInput | null,
  businessAccountHolderId?: ModelSubscriptionIDInput | null,
  primaryAuthorizedPersonId?: ModelSubscriptionIDInput | null,
  financialAccountId?: ModelSubscriptionIDInput | null,
  externalFinancialBankAccountId?: ModelSubscriptionIDInput | null,
  hasInitialFunding?: ModelSubscriptionBooleanInput | null,
  accountHolderCardProductApplicationId?: ModelSubscriptionIDInput | null,
  isApplicationAccepted?: ModelSubscriptionBooleanInput | null,
  isDisconnected?: ModelSubscriptionBooleanInput | null,
  highnoteProductId?: ModelSubscriptionIDInput | null,
  finicityCustomerId?: ModelSubscriptionStringInput | null,
  dwollaCustomerId?: ModelSubscriptionStringInput | null,
  cardProfileId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPaidolHighnoteIntegrationFilterInput | null > | null,
  or?: Array< ModelSubscriptionPaidolHighnoteIntegrationFilterInput | null > | null,
};

export type ModelSubscriptionHighnotePaymentCardFilterInput = {
  paymentCardId?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  cardGroupId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  bin?: ModelSubscriptionStringInput | null,
  last4?: ModelSubscriptionStringInput | null,
  network?: ModelSubscriptionStringInput | null,
  formFactor?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  hasPin?: ModelSubscriptionBooleanInput | null,
  cardholderId?: ModelSubscriptionIDInput | null,
  cardholderName?: ModelSubscriptionStringInput | null,
  isAdminLocked?: ModelSubscriptionBooleanInput | null,
  lastActionByRole?: ModelSubscriptionStringInput | null,
  lastActionByPaidolUserId?: ModelSubscriptionIDInput | null,
  lastActionByName?: ModelSubscriptionStringInput | null,
  lastActionByEmail?: ModelSubscriptionStringInput | null,
  lastActionAt?: ModelSubscriptionStringInput | null,
  merchantSpendRuleId?: ModelSubscriptionIDInput | null,
  isAuthorizedUserCard?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHighnotePaymentCardFilterInput | null > | null,
  or?: Array< ModelSubscriptionHighnotePaymentCardFilterInput | null > | null,
};

export type ModelSubscriptionSpendRulesFilterInput = {
  spendRuleId?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  merchantCategoryAllowed?: ModelSubscriptionStringInput | null,
  merchantCategoryBlocked?: ModelSubscriptionStringInput | null,
  merchantCountryAllowed?: ModelSubscriptionStringInput | null,
  merchantCountryBlocked?: ModelSubscriptionStringInput | null,
  streetAddressAllowed?: ModelSubscriptionStringInput | null,
  streetAddressBlocked?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSpendRulesFilterInput | null > | null,
  or?: Array< ModelSubscriptionSpendRulesFilterInput | null > | null,
};

export type ModelSubscriptionVelocityRulesFilterInput = {
  velocityRuleId?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  cumulativeRuleId?: ModelSubscriptionIDInput | null,
  monthlyLimitResetTimestamp?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVelocityRulesFilterInput | null > | null,
  or?: Array< ModelSubscriptionVelocityRulesFilterInput | null > | null,
};

export type ModelSubscriptionReceiptSummaryFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  receiptUploadId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  typeConfidenceScore?: ModelSubscriptionFloatInput | null,
  label?: ModelSubscriptionStringInput | null,
  labelConfidenceScore?: ModelSubscriptionFloatInput | null,
  value?: ModelSubscriptionStringInput | null,
  valueConfidenceScore?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReceiptSummaryFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionReceiptSummaryFieldFilterInput | null > | null,
};

export type ModelSubscriptionReceiptLineItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  receiptUploadId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReceiptLineItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionReceiptLineItemFilterInput | null > | null,
};

export type ModelSubscriptionReceiptLineItemFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  receiptLineItemId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  typeConfidenceScore?: ModelSubscriptionFloatInput | null,
  label?: ModelSubscriptionStringInput | null,
  labelConfidenceScore?: ModelSubscriptionFloatInput | null,
  value?: ModelSubscriptionStringInput | null,
  valueConfidenceScore?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReceiptLineItemFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionReceiptLineItemFieldFilterInput | null > | null,
};

export type ModelSubscriptionReceiptUploadFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  document?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReceiptUploadFilterInput | null > | null,
  or?: Array< ModelSubscriptionReceiptUploadFilterInput | null > | null,
};

export type ModelSubscriptionTransactionToReceiptUploadFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  highnoteTransactionEventId?: ModelSubscriptionIDInput | null,
  reimbursementTransactionId?: ModelSubscriptionIDInput | null,
  receiptUploadId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTransactionToReceiptUploadFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionToReceiptUploadFilterInput | null > | null,
};

export type ModelSubscriptionTransactionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  transactionDate?: ModelSubscriptionStringInput | null,
  reimbursementTransactionId?: ModelSubscriptionIDInput | null,
  highnoteTransactionId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
};

export type ModelSubscriptionReimbursementTransactionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  dwollaTransferId?: ModelSubscriptionIDInput | null,
  transactionDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  checkrunStatus?: ModelSubscriptionStringInput | null,
  note?: ModelSubscriptionStringInput | null,
  contestNote?: ModelSubscriptionStringInput | null,
  deniedNote?: ModelSubscriptionStringInput | null,
  merchantName?: ModelSubscriptionStringInput | null,
  receiptLineItems?: ModelSubscriptionStringInput | null,
  jobCodeId?: ModelSubscriptionIDInput | null,
  reimbursementDate?: ModelSubscriptionStringInput | null,
  decisionDate?: ModelSubscriptionStringInput | null,
  reviewedByPaidolUserId?: ModelSubscriptionIDInput | null,
  reviewedByName?: ModelSubscriptionStringInput | null,
  reviewedByRole?: ModelSubscriptionStringInput | null,
  reviewedAt?: ModelSubscriptionStringInput | null,
  paidolUserId?: ModelSubscriptionIDInput | null,
  transactionType?: ModelSubscriptionStringInput | null,
  expenseTypeId?: ModelSubscriptionIDInput | null,
  receiptId?: ModelSubscriptionIDInput | null,
  procoreProjectId?: ModelSubscriptionFloatInput | null,
  procoreWBSCodeId?: ModelSubscriptionFloatInput | null,
  agaveGlCodeId?: ModelSubscriptionIDInput | null,
  agaveProjectId?: ModelSubscriptionIDInput | null,
  agaveCostCodeId?: ModelSubscriptionIDInput | null,
  agaveCostTypeId?: ModelSubscriptionIDInput | null,
  agaveVendorId?: ModelSubscriptionIDInput | null,
  agaveSubJobId?: ModelSubscriptionIDInput | null,
  agaveLocationId?: ModelSubscriptionIDInput | null,
  agaveDepartmentId?: ModelSubscriptionIDInput | null,
  agaveSubaccountId?: ModelSubscriptionIDInput | null,
  agaveEmployeeId?: ModelSubscriptionIDInput | null,
  agaveEquipmentId?: ModelSubscriptionIDInput | null,
  agaveEmCostCodeId?: ModelSubscriptionIDInput | null,
  agaveEmCostTypeId?: ModelSubscriptionIDInput | null,
  codingType?: ModelSubscriptionStringInput | null,
  accountingDate?: ModelSubscriptionStringInput | null,
  flexGlCodeId?: ModelSubscriptionIDInput | null,
  flexCodeId?: ModelSubscriptionIDInput | null,
  flexCostCodeId?: ModelSubscriptionIDInput | null,
  flexCostTypeId?: ModelSubscriptionIDInput | null,
  flexVendorId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReimbursementTransactionFilterInput | null > | null,
  or?: Array< ModelSubscriptionReimbursementTransactionFilterInput | null > | null,
};

export type ModelSubscriptionProjectGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  groupProjects?: ModelSubscriptionStringInput | null,
  isMonthlyBudgetUnlimited?: ModelSubscriptionBooleanInput | null,
  spendGroupId?: ModelSubscriptionIDInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  hasReviewers?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProjectGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionProjectGroupFilterInput | null > | null,
};

export type ModelSubscriptionCardGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  groupProjects?: ModelSubscriptionStringInput | null,
  isMonthlyBudgetUnlimited?: ModelSubscriptionBooleanInput | null,
  spendGroupId?: ModelSubscriptionIDInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  hasReviewers?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCardGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionCardGroupFilterInput | null > | null,
};

export type ModelSubscriptionMerchantSpendRuleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  paymentCards?: ModelSubscriptionStringInput | null,
  merchantCountrySpendRuleId?: ModelSubscriptionIDInput | null,
  merchantCategorySpendRuleId?: ModelSubscriptionIDInput | null,
  amountLimitSpendRuleId?: ModelSubscriptionIDInput | null,
  monthlyLimitSpendRuleId?: ModelSubscriptionIDInput | null,
  monthlyLimitCumulativeRuleId?: ModelSubscriptionIDInput | null,
  merchantCategoryAllowed?: ModelSubscriptionStringInput | null,
  merchantCategoryBlocked?: ModelSubscriptionStringInput | null,
  merchantCountryAllowed?: ModelSubscriptionStringInput | null,
  merchantCountryBlocked?: ModelSubscriptionStringInput | null,
  monthlyLimitResetTimestamp?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMerchantSpendRuleFilterInput | null > | null,
  or?: Array< ModelSubscriptionMerchantSpendRuleFilterInput | null > | null,
};

export type ModelSubscriptionSpendRuleConfigFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  ruleId?: ModelSubscriptionIDInput | null,
  ruleType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSpendRuleConfigFilterInput | null > | null,
  or?: Array< ModelSubscriptionSpendRuleConfigFilterInput | null > | null,
};

export type ModelSubscriptionJobCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  description?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  budget?: ModelSubscriptionFloatInput | null,
  jobCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionJobCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionJobCodeFilterInput | null > | null,
};

export type ModelSubscriptionV2FlexRelationshipsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  flexGlCodeId?: ModelSubscriptionIDInput | null,
  flexCodeId?: ModelSubscriptionIDInput | null,
  flexCostCodeId?: ModelSubscriptionIDInput | null,
  flexCostTypeId?: ModelSubscriptionIDInput | null,
  flexVendorId?: ModelSubscriptionIDInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  flexGlCodeName?: ModelSubscriptionStringInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  projectCode?: ModelSubscriptionStringInput | null,
  flexCostCodeName?: ModelSubscriptionStringInput | null,
  flexCostTypeName?: ModelSubscriptionStringInput | null,
  flexVendorName?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionV2FlexRelationshipsFilterInput | null > | null,
  or?: Array< ModelSubscriptionV2FlexRelationshipsFilterInput | null > | null,
};

export type ModelSubscriptionFlexGlCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexGlCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexGlCodeFilterInput | null > | null,
};

export type ModelSubscriptionFlexCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  projectCode?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexCodeFilterInput | null > | null,
};

export type ModelSubscriptionFlexCostCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexCostCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexCostCodeFilterInput | null > | null,
};

export type ModelSubscriptionFlexCostTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexCostTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexCostTypeFilterInput | null > | null,
};

export type ModelSubscriptionFlexVendorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  flexCodeImportId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexVendorFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexVendorFilterInput | null > | null,
};

export type ModelSubscriptionFlexFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  alias?: ModelSubscriptionStringInput | null,
  order?: ModelSubscriptionIntInput | null,
  source?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexFieldFilterInput | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionFlexFieldValueFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  flexFieldId?: ModelSubscriptionIDInput | null,
  externalId?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  flexFieldUploadId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlexFieldValueFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlexFieldValueFilterInput | null > | null,
};

export type ModelSubscriptionStatementSummaryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  statementBalance?: ModelSubscriptionIntInput | null,
  paymentDueDate?: ModelSubscriptionStringInput | null,
  pdfLink?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStatementSummaryFilterInput | null > | null,
  or?: Array< ModelSubscriptionStatementSummaryFilterInput | null > | null,
};

export type ModelSubscriptionAutoPaymentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  amountType?: ModelSubscriptionStringInput | null,
  fixedAmountCents?: ModelSubscriptionIntInput | null,
  paymentDayOfMonth?: ModelSubscriptionIntInput | null,
  externalBankAccountId?: ModelSubscriptionStringInput | null,
  financialAccountId?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionBooleanInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  updatedBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAutoPaymentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAutoPaymentFilterInput | null > | null,
};

export type ModelSubscriptionTransactionFilterOptionsFilterInput = {
  paidolId?: ModelSubscriptionIDInput | null,
  last4?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionTransactionFilterOptionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionFilterOptionsFilterInput | null > | null,
};

export type ModelSubscriptionHighnoteDisputeEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  disputeId?: ModelSubscriptionIDInput | null,
  paymentCardId?: ModelSubscriptionIDInput | null,
  transactionEventId?: ModelSubscriptionIDInput | null,
  enableListing?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  creditStatus?: ModelSubscriptionStringInput | null,
  category?: ModelSubscriptionStringInput | null,
  liability?: ModelSubscriptionStringInput | null,
  eventType?: ModelSubscriptionStringInput | null,
  eventDate?: ModelSubscriptionStringInput | null,
  source?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHighnoteDisputeEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionHighnoteDisputeEventFilterInput | null > | null,
};

export type ModelSubscriptionHighnoteTransactionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  transactionId?: ModelSubscriptionIDInput | null,
  paymentCardId?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  reconciliationId?: ModelSubscriptionIDInput | null,
  eventDate?: ModelSubscriptionStringInput | null,
  processedAt?: ModelSubscriptionStringInput | null,
  origin?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  partial?: ModelSubscriptionBooleanInput | null,
  settlementImpact?: ModelSubscriptionBooleanInput | null,
  approvedAmountValue?: ModelSubscriptionIntInput | null,
  approvedAmountCurrencyCode?: ModelSubscriptionStringInput | null,
  eventData?: ModelSubscriptionStringInput | null,
  transactionOldState?: ModelSubscriptionStringInput | null,
  transactionNewState?: ModelSubscriptionStringInput | null,
  enableListing?: ModelSubscriptionBooleanInput | null,
  email?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  last4?: ModelSubscriptionStringInput | null,
  groupApprovalLevels?: ModelSubscriptionIntInput | null,
  owningProjectGroupIds?: ModelSubscriptionStringInput | null,
  cardGroupId?: ModelSubscriptionIDInput | null,
  merchantCategory?: ModelSubscriptionStringInput | null,
  merchantCategoryCode?: ModelSubscriptionStringInput | null,
  merchantName?: ModelSubscriptionStringInput | null,
  jobCodeId?: ModelSubscriptionIDInput | null,
  flexCodeTransactionStatus?: ModelSubscriptionStringInput | null,
  workflowStatus?: ModelSubscriptionStringInput | null,
  returnedStatus?: ModelSubscriptionStringInput | null,
  flexCodeId?: ModelSubscriptionIDInput | null,
  flexCostCodeId?: ModelSubscriptionIDInput | null,
  flexCostTypeId?: ModelSubscriptionIDInput | null,
  flexGlCodeId?: ModelSubscriptionIDInput | null,
  flexVendorId?: ModelSubscriptionIDInput | null,
  agaveDepartmentId?: ModelSubscriptionIDInput | null,
  agaveLocationId?: ModelSubscriptionIDInput | null,
  agaveSubaccountId?: ModelSubscriptionIDInput | null,
  agaveEmployeeId?: ModelSubscriptionIDInput | null,
  agaveExpenseId?: ModelSubscriptionIDInput | null,
  agaveProjectId?: ModelSubscriptionIDInput | null,
  agaveCostCodeId?: ModelSubscriptionIDInput | null,
  agaveCostTypeId?: ModelSubscriptionIDInput | null,
  agaveGlCodeId?: ModelSubscriptionIDInput | null,
  agaveVendorId?: ModelSubscriptionIDInput | null,
  agaveSubJobId?: ModelSubscriptionIDInput | null,
  agaveEquipmentId?: ModelSubscriptionIDInput | null,
  agaveEmCostCodeId?: ModelSubscriptionIDInput | null,
  agaveEmCostTypeId?: ModelSubscriptionIDInput | null,
  codingType?: ModelSubscriptionStringInput | null,
  accountingDate?: ModelSubscriptionStringInput | null,
  procoreDirectCostId?: ModelSubscriptionFloatInput | null,
  procoreDirectCostLineItemId?: ModelSubscriptionFloatInput | null,
  procoreProjectId?: ModelSubscriptionFloatInput | null,
  procoreWBSCodeId?: ModelSubscriptionFloatInput | null,
  erpApprovalStatus?: ModelSubscriptionBooleanInput | null,
  erpBypassStatus?: ModelSubscriptionBooleanInput | null,
  erpBillableItemId?: ModelSubscriptionStringInput | null,
  erpBillableItemName?: ModelSubscriptionStringInput | null,
  erpBillable?: ModelSubscriptionBooleanInput | null,
  erpPostingStatus?: ModelSubscriptionStringInput | null,
  erpPostingError?: ModelSubscriptionStringInput | null,
  erpPostingWarning?: ModelSubscriptionStringInput | null,
  sage300APInvoiceStatus?: ModelSubscriptionStringInput | null,
  sage300APInvoiceError?: ModelSubscriptionStringInput | null,
  note?: ModelSubscriptionStringInput | null,
  approveWithoutNotes?: ModelSubscriptionBooleanInput | null,
  receiptPath?: ModelSubscriptionStringInput | null,
  receiptId?: ModelSubscriptionIDInput | null,
  hasReceipt?: ModelSubscriptionBooleanInput | null,
  approveWithoutReceipts?: ModelSubscriptionBooleanInput | null,
  fuelVehicleId?: ModelSubscriptionStringInput | null,
  fuelOdometerReading?: ModelSubscriptionIntInput | null,
  fuelGallons?: ModelSubscriptionIntInput | null,
  fuelCostPerGallon?: ModelSubscriptionIntInput | null,
  codedAt?: ModelSubscriptionStringInput | null,
  codingMethod?: ModelSubscriptionStringInput | null,
  receiptUploadedAt?: ModelSubscriptionStringInput | null,
  receiptUploadMethod?: ModelSubscriptionStringInput | null,
  erpExportedAt?: ModelSubscriptionStringInput | null,
  erpExportBatchId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHighnoteTransactionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionHighnoteTransactionEventFilterInput | null > | null,
};

export type ModelSubscriptionSyncBalanceCurrentCycleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSyncBalanceCurrentCycleFilterInput | null > | null,
  or?: Array< ModelSubscriptionSyncBalanceCurrentCycleFilterInput | null > | null,
};

export type ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  paidolId?: ModelSubscriptionIDInput | null,
  syncBalanceCurrentCycleId?: ModelSubscriptionIDInput | null,
  paymentCardId?: ModelSubscriptionStringInput | null,
  syncedAt?: ModelSubscriptionStringInput | null,
  error?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput | null > | null,
  or?: Array< ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput | null > | null,
};

export type ModelSubscriptionExpenseTypeToMCCFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  mccID?: ModelSubscriptionIDInput | null,
  expenseTypeID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExpenseTypeToMCCFilterInput | null > | null,
  or?: Array< ModelSubscriptionExpenseTypeToMCCFilterInput | null > | null,
};

export type AddCardsToCardGroupMutationVariables = {
  input: AddCardsToCardGroupInput,
};

export type AddCardsToCardGroupMutation = {
  addCardsToCardGroup?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type CreateAgaveProjectMutationVariables = {
  input: CreateAgaveProjectInput,
  condition?: ModelAgaveProjectConditionInput | null,
};

export type CreateAgaveProjectMutation = {
  createAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type UpdateAgaveProjectMutationVariables = {
  input: UpdateAgaveProjectInput,
  condition?: ModelAgaveProjectConditionInput | null,
};

export type UpdateAgaveProjectMutation = {
  updateAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type DeleteAgaveProjectMutationVariables = {
  input: DeleteAgaveProjectInput,
  condition?: ModelAgaveProjectConditionInput | null,
};

export type DeleteAgaveProjectMutation = {
  deleteAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type CreateAgaveGlCodeMutationVariables = {
  input: CreateAgaveGlCodeInput,
  condition?: ModelAgaveGlCodeConditionInput | null,
};

export type CreateAgaveGlCodeMutation = {
  createAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type UpdateAgaveGlCodeMutationVariables = {
  input: UpdateAgaveGlCodeInput,
  condition?: ModelAgaveGlCodeConditionInput | null,
};

export type UpdateAgaveGlCodeMutation = {
  updateAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type DeleteAgaveGlCodeMutationVariables = {
  input: DeleteAgaveGlCodeInput,
  condition?: ModelAgaveGlCodeConditionInput | null,
};

export type DeleteAgaveGlCodeMutation = {
  deleteAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type CreateAgaveCostCodeMutationVariables = {
  input: CreateAgaveCostCodeInput,
  condition?: ModelAgaveCostCodeConditionInput | null,
};

export type CreateAgaveCostCodeMutation = {
  createAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type UpdateAgaveCostCodeMutationVariables = {
  input: UpdateAgaveCostCodeInput,
  condition?: ModelAgaveCostCodeConditionInput | null,
};

export type UpdateAgaveCostCodeMutation = {
  updateAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type DeleteAgaveCostCodeMutationVariables = {
  input: DeleteAgaveCostCodeInput,
  condition?: ModelAgaveCostCodeConditionInput | null,
};

export type DeleteAgaveCostCodeMutation = {
  deleteAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type CreateAgaveSubJobMutationVariables = {
  input: CreateAgaveSubJobInput,
  condition?: ModelAgaveSubJobConditionInput | null,
};

export type CreateAgaveSubJobMutation = {
  createAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type UpdateAgaveSubJobMutationVariables = {
  input: UpdateAgaveSubJobInput,
  condition?: ModelAgaveSubJobConditionInput | null,
};

export type UpdateAgaveSubJobMutation = {
  updateAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type DeleteAgaveSubJobMutationVariables = {
  input: DeleteAgaveSubJobInput,
  condition?: ModelAgaveSubJobConditionInput | null,
};

export type DeleteAgaveSubJobMutation = {
  deleteAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type CreateAgaveProjectCostCodeMutationVariables = {
  input: CreateAgaveProjectCostCodeInput,
  condition?: ModelAgaveProjectCostCodeConditionInput | null,
};

export type CreateAgaveProjectCostCodeMutation = {
  createAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveProjectCostCodeMutationVariables = {
  input: UpdateAgaveProjectCostCodeInput,
  condition?: ModelAgaveProjectCostCodeConditionInput | null,
};

export type UpdateAgaveProjectCostCodeMutation = {
  updateAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveProjectCostCodeMutationVariables = {
  input: DeleteAgaveProjectCostCodeInput,
  condition?: ModelAgaveProjectCostCodeConditionInput | null,
};

export type DeleteAgaveProjectCostCodeMutation = {
  deleteAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveProjectSubJobMutationVariables = {
  input: CreateAgaveProjectSubJobInput,
  condition?: ModelAgaveProjectSubJobConditionInput | null,
};

export type CreateAgaveProjectSubJobMutation = {
  createAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveProjectSubJobMutationVariables = {
  input: UpdateAgaveProjectSubJobInput,
  condition?: ModelAgaveProjectSubJobConditionInput | null,
};

export type UpdateAgaveProjectSubJobMutation = {
  updateAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveProjectSubJobMutationVariables = {
  input: DeleteAgaveProjectSubJobInput,
  condition?: ModelAgaveProjectSubJobConditionInput | null,
};

export type DeleteAgaveProjectSubJobMutation = {
  deleteAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveSubJobCostCodeMutationVariables = {
  input: CreateAgaveSubJobCostCodeInput,
  condition?: ModelAgaveSubJobCostCodeConditionInput | null,
};

export type CreateAgaveSubJobCostCodeMutation = {
  createAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveSubJobCostCodeMutationVariables = {
  input: UpdateAgaveSubJobCostCodeInput,
  condition?: ModelAgaveSubJobCostCodeConditionInput | null,
};

export type UpdateAgaveSubJobCostCodeMutation = {
  updateAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveSubJobCostCodeMutationVariables = {
  input: DeleteAgaveSubJobCostCodeInput,
  condition?: ModelAgaveSubJobCostCodeConditionInput | null,
};

export type DeleteAgaveSubJobCostCodeMutation = {
  deleteAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveProjectLocationMutationVariables = {
  input: CreateAgaveProjectLocationInput,
  condition?: ModelAgaveProjectLocationConditionInput | null,
};

export type CreateAgaveProjectLocationMutation = {
  createAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveProjectLocationMutationVariables = {
  input: UpdateAgaveProjectLocationInput,
  condition?: ModelAgaveProjectLocationConditionInput | null,
};

export type UpdateAgaveProjectLocationMutation = {
  updateAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveProjectLocationMutationVariables = {
  input: DeleteAgaveProjectLocationInput,
  condition?: ModelAgaveProjectLocationConditionInput | null,
};

export type DeleteAgaveProjectLocationMutation = {
  deleteAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveProjectDepartmentMutationVariables = {
  input: CreateAgaveProjectDepartmentInput,
  condition?: ModelAgaveProjectDepartmentConditionInput | null,
};

export type CreateAgaveProjectDepartmentMutation = {
  createAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveProjectDepartmentMutationVariables = {
  input: UpdateAgaveProjectDepartmentInput,
  condition?: ModelAgaveProjectDepartmentConditionInput | null,
};

export type UpdateAgaveProjectDepartmentMutation = {
  updateAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveProjectDepartmentMutationVariables = {
  input: DeleteAgaveProjectDepartmentInput,
  condition?: ModelAgaveProjectDepartmentConditionInput | null,
};

export type DeleteAgaveProjectDepartmentMutation = {
  deleteAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmployeeEntityMutationVariables = {
  input: CreateAgaveEmployeeEntityInput,
  condition?: ModelAgaveEmployeeEntityConditionInput | null,
};

export type CreateAgaveEmployeeEntityMutation = {
  createAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type UpdateAgaveEmployeeEntityMutationVariables = {
  input: UpdateAgaveEmployeeEntityInput,
  condition?: ModelAgaveEmployeeEntityConditionInput | null,
};

export type UpdateAgaveEmployeeEntityMutation = {
  updateAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type DeleteAgaveEmployeeEntityMutationVariables = {
  input: DeleteAgaveEmployeeEntityInput,
  condition?: ModelAgaveEmployeeEntityConditionInput | null,
};

export type DeleteAgaveEmployeeEntityMutation = {
  deleteAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type CreateAgaveEmployeeLocationMutationVariables = {
  input: CreateAgaveEmployeeLocationInput,
  condition?: ModelAgaveEmployeeLocationConditionInput | null,
};

export type CreateAgaveEmployeeLocationMutation = {
  createAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmployeeLocationMutationVariables = {
  input: UpdateAgaveEmployeeLocationInput,
  condition?: ModelAgaveEmployeeLocationConditionInput | null,
};

export type UpdateAgaveEmployeeLocationMutation = {
  updateAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmployeeLocationMutationVariables = {
  input: DeleteAgaveEmployeeLocationInput,
  condition?: ModelAgaveEmployeeLocationConditionInput | null,
};

export type DeleteAgaveEmployeeLocationMutation = {
  deleteAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmployeeDepartmentMutationVariables = {
  input: CreateAgaveEmployeeDepartmentInput,
  condition?: ModelAgaveEmployeeDepartmentConditionInput | null,
};

export type CreateAgaveEmployeeDepartmentMutation = {
  createAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmployeeDepartmentMutationVariables = {
  input: UpdateAgaveEmployeeDepartmentInput,
  condition?: ModelAgaveEmployeeDepartmentConditionInput | null,
};

export type UpdateAgaveEmployeeDepartmentMutation = {
  updateAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmployeeDepartmentMutationVariables = {
  input: DeleteAgaveEmployeeDepartmentInput,
  condition?: ModelAgaveEmployeeDepartmentConditionInput | null,
};

export type DeleteAgaveEmployeeDepartmentMutation = {
  deleteAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveCostTypeMutationVariables = {
  input: CreateAgaveCostTypeInput,
  condition?: ModelAgaveCostTypeConditionInput | null,
};

export type CreateAgaveCostTypeMutation = {
  createAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type UpdateAgaveCostTypeMutationVariables = {
  input: UpdateAgaveCostTypeInput,
  condition?: ModelAgaveCostTypeConditionInput | null,
};

export type UpdateAgaveCostTypeMutation = {
  updateAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type DeleteAgaveCostTypeMutationVariables = {
  input: DeleteAgaveCostTypeInput,
  condition?: ModelAgaveCostTypeConditionInput | null,
};

export type DeleteAgaveCostTypeMutation = {
  deleteAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type CreateAgaveEquipmentMutationVariables = {
  input: CreateAgaveEquipmentInput,
  condition?: ModelAgaveEquipmentConditionInput | null,
};

export type CreateAgaveEquipmentMutation = {
  createAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEquipmentMutationVariables = {
  input: UpdateAgaveEquipmentInput,
  condition?: ModelAgaveEquipmentConditionInput | null,
};

export type UpdateAgaveEquipmentMutation = {
  updateAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEquipmentMutationVariables = {
  input: DeleteAgaveEquipmentInput,
  condition?: ModelAgaveEquipmentConditionInput | null,
};

export type DeleteAgaveEquipmentMutation = {
  deleteAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmCostCodeMutationVariables = {
  input: CreateAgaveEmCostCodeInput,
  condition?: ModelAgaveEmCostCodeConditionInput | null,
};

export type CreateAgaveEmCostCodeMutation = {
  createAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmCostCodeMutationVariables = {
  input: UpdateAgaveEmCostCodeInput,
  condition?: ModelAgaveEmCostCodeConditionInput | null,
};

export type UpdateAgaveEmCostCodeMutation = {
  updateAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmCostCodeMutationVariables = {
  input: DeleteAgaveEmCostCodeInput,
  condition?: ModelAgaveEmCostCodeConditionInput | null,
};

export type DeleteAgaveEmCostCodeMutation = {
  deleteAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmDepartmentMutationVariables = {
  input: CreateAgaveEmDepartmentInput,
  condition?: ModelAgaveEmDepartmentConditionInput | null,
};

export type CreateAgaveEmDepartmentMutation = {
  createAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmDepartmentMutationVariables = {
  input: UpdateAgaveEmDepartmentInput,
  condition?: ModelAgaveEmDepartmentConditionInput | null,
};

export type UpdateAgaveEmDepartmentMutation = {
  updateAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmDepartmentMutationVariables = {
  input: DeleteAgaveEmDepartmentInput,
  condition?: ModelAgaveEmDepartmentConditionInput | null,
};

export type DeleteAgaveEmDepartmentMutation = {
  deleteAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmCostTypeMutationVariables = {
  input: CreateAgaveEmCostTypeInput,
  condition?: ModelAgaveEmCostTypeConditionInput | null,
};

export type CreateAgaveEmCostTypeMutation = {
  createAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmCostTypeMutationVariables = {
  input: UpdateAgaveEmCostTypeInput,
  condition?: ModelAgaveEmCostTypeConditionInput | null,
};

export type UpdateAgaveEmCostTypeMutation = {
  updateAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmCostTypeMutationVariables = {
  input: DeleteAgaveEmCostTypeInput,
  condition?: ModelAgaveEmCostTypeConditionInput | null,
};

export type DeleteAgaveEmCostTypeMutation = {
  deleteAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveCostCodeCostTypeMutationVariables = {
  input: CreateAgaveCostCodeCostTypeInput,
  condition?: ModelAgaveCostCodeCostTypeConditionInput | null,
};

export type CreateAgaveCostCodeCostTypeMutation = {
  createAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveCostCodeCostTypeMutationVariables = {
  input: UpdateAgaveCostCodeCostTypeInput,
  condition?: ModelAgaveCostCodeCostTypeConditionInput | null,
};

export type UpdateAgaveCostCodeCostTypeMutation = {
  updateAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveCostCodeCostTypeMutationVariables = {
  input: DeleteAgaveCostCodeCostTypeInput,
  condition?: ModelAgaveCostCodeCostTypeConditionInput | null,
};

export type DeleteAgaveCostCodeCostTypeMutation = {
  deleteAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveEmCostCodeCostTypeMutationVariables = {
  input: CreateAgaveEmCostCodeCostTypeInput,
  condition?: ModelAgaveEmCostCodeCostTypeConditionInput | null,
};

export type CreateAgaveEmCostCodeCostTypeMutation = {
  createAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveEmCostCodeCostTypeMutationVariables = {
  input: UpdateAgaveEmCostCodeCostTypeInput,
  condition?: ModelAgaveEmCostCodeCostTypeConditionInput | null,
};

export type UpdateAgaveEmCostCodeCostTypeMutation = {
  updateAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveEmCostCodeCostTypeMutationVariables = {
  input: DeleteAgaveEmCostCodeCostTypeInput,
  condition?: ModelAgaveEmCostCodeCostTypeConditionInput | null,
};

export type DeleteAgaveEmCostCodeCostTypeMutation = {
  deleteAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveCostCodeCostTypeGlMutationVariables = {
  input: CreateAgaveCostCodeCostTypeGlInput,
  condition?: ModelAgaveCostCodeCostTypeGlConditionInput | null,
};

export type CreateAgaveCostCodeCostTypeGlMutation = {
  createAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAgaveCostCodeCostTypeGlMutationVariables = {
  input: UpdateAgaveCostCodeCostTypeGlInput,
  condition?: ModelAgaveCostCodeCostTypeGlConditionInput | null,
};

export type UpdateAgaveCostCodeCostTypeGlMutation = {
  updateAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAgaveCostCodeCostTypeGlMutationVariables = {
  input: DeleteAgaveCostCodeCostTypeGlInput,
  condition?: ModelAgaveCostCodeCostTypeGlConditionInput | null,
};

export type DeleteAgaveCostCodeCostTypeGlMutation = {
  deleteAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAgaveLocationMutationVariables = {
  input: CreateAgaveLocationInput,
  condition?: ModelAgaveLocationConditionInput | null,
};

export type CreateAgaveLocationMutation = {
  createAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type UpdateAgaveLocationMutationVariables = {
  input: UpdateAgaveLocationInput,
  condition?: ModelAgaveLocationConditionInput | null,
};

export type UpdateAgaveLocationMutation = {
  updateAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type DeleteAgaveLocationMutationVariables = {
  input: DeleteAgaveLocationInput,
  condition?: ModelAgaveLocationConditionInput | null,
};

export type DeleteAgaveLocationMutation = {
  deleteAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type CreateAgaveDepartmentMutationVariables = {
  input: CreateAgaveDepartmentInput,
  condition?: ModelAgaveDepartmentConditionInput | null,
};

export type CreateAgaveDepartmentMutation = {
  createAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type UpdateAgaveDepartmentMutationVariables = {
  input: UpdateAgaveDepartmentInput,
  condition?: ModelAgaveDepartmentConditionInput | null,
};

export type UpdateAgaveDepartmentMutation = {
  updateAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type DeleteAgaveDepartmentMutationVariables = {
  input: DeleteAgaveDepartmentInput,
  condition?: ModelAgaveDepartmentConditionInput | null,
};

export type DeleteAgaveDepartmentMutation = {
  deleteAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type CreateAgaveSubaccountMutationVariables = {
  input: CreateAgaveSubaccountInput,
  condition?: ModelAgaveSubaccountConditionInput | null,
};

export type CreateAgaveSubaccountMutation = {
  createAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type UpdateAgaveSubaccountMutationVariables = {
  input: UpdateAgaveSubaccountInput,
  condition?: ModelAgaveSubaccountConditionInput | null,
};

export type UpdateAgaveSubaccountMutation = {
  updateAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type DeleteAgaveSubaccountMutationVariables = {
  input: DeleteAgaveSubaccountInput,
  condition?: ModelAgaveSubaccountConditionInput | null,
};

export type DeleteAgaveSubaccountMutation = {
  deleteAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type CreateAgaveVendorMutationVariables = {
  input: CreateAgaveVendorInput,
  condition?: ModelAgaveVendorConditionInput | null,
};

export type CreateAgaveVendorMutation = {
  createAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type UpdateAgaveVendorMutationVariables = {
  input: UpdateAgaveVendorInput,
  condition?: ModelAgaveVendorConditionInput | null,
};

export type UpdateAgaveVendorMutation = {
  updateAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type DeleteAgaveVendorMutationVariables = {
  input: DeleteAgaveVendorInput,
  condition?: ModelAgaveVendorConditionInput | null,
};

export type DeleteAgaveVendorMutation = {
  deleteAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    first_name: string,
    middle_name?: string | null,
    last_name: string,
    suffix?: string | null,
    paidol_users?:  {
      __typename: "ModelPaidolUserConnection",
      nextToken?: string | null,
    } | null,
    picture?: string | null,
    is_speedster?: string | null,
    birthdate?: string | null,
    address?: string | null,
    phone_number?: string | null,
    phone_extension?: string | null,
    password_updated_at?: string | null,
    finicityCustomerId?: string | null,
    dwollaCustomerId?: string | null,
    firstRunBanner?:  {
      __typename: "FirstRunBanner",
      insights?: boolean | null,
      transactions?: boolean | null,
      reimbursements?: boolean | null,
      cardsManagement?: boolean | null,
      spendRules?: boolean | null,
      funding?: boolean | null,
      teamMembers?: boolean | null,
      groups?: boolean | null,
      wallet?: boolean | null,
      settings?: boolean | null,
      connections?: boolean | null,
    } | null,
    is_support?: boolean | null,
    deletedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePaidolAgaveSyncMutationVariables = {
  input: CreatePaidolAgaveSyncInput,
  condition?: ModelPaidolAgaveSyncConditionInput | null,
};

export type CreatePaidolAgaveSyncMutation = {
  createPaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePaidolAgaveSyncMutationVariables = {
  input: UpdatePaidolAgaveSyncInput,
  condition?: ModelPaidolAgaveSyncConditionInput | null,
};

export type UpdatePaidolAgaveSyncMutation = {
  updatePaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePaidolAgaveSyncMutationVariables = {
  input: DeletePaidolAgaveSyncInput,
  condition?: ModelPaidolAgaveSyncConditionInput | null,
};

export type DeletePaidolAgaveSyncMutation = {
  deletePaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePaymentFileQueueMutationVariables = {
  input: CreatePaymentFileQueueInput,
  condition?: ModelPaymentFileQueueConditionInput | null,
};

export type CreatePaymentFileQueueMutation = {
  createPaymentFileQueue?:  {
    __typename: "PaymentFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: PaymentFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_payments?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    total?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    createdAt?: string | null,
    filename?: string | null,
    supplier_vendor_paidol_ids?: Array< string | null > | null,
    referenced_vendors?: Array< string | null > | null,
    invoice_ids?: Array< string | null > | null,
    invoice_spx_ids?: Array< string | null > | null,
    priority_status?: string | null,
    priority_file_id?: string | null,
    priority_process_on?: string | null,
    priority_response?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePaymentFileQueueMutationVariables = {
  input: UpdatePaymentFileQueueInput,
  condition?: ModelPaymentFileQueueConditionInput | null,
};

export type UpdatePaymentFileQueueMutation = {
  updatePaymentFileQueue?:  {
    __typename: "PaymentFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: PaymentFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_payments?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    total?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    createdAt?: string | null,
    filename?: string | null,
    supplier_vendor_paidol_ids?: Array< string | null > | null,
    referenced_vendors?: Array< string | null > | null,
    invoice_ids?: Array< string | null > | null,
    invoice_spx_ids?: Array< string | null > | null,
    priority_status?: string | null,
    priority_file_id?: string | null,
    priority_process_on?: string | null,
    priority_response?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePaymentFileQueueMutationVariables = {
  input: DeletePaymentFileQueueInput,
  condition?: ModelPaymentFileQueueConditionInput | null,
};

export type DeletePaymentFileQueueMutation = {
  deletePaymentFileQueue?:  {
    __typename: "PaymentFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: PaymentFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_payments?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    total?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    createdAt?: string | null,
    filename?: string | null,
    supplier_vendor_paidol_ids?: Array< string | null > | null,
    referenced_vendors?: Array< string | null > | null,
    invoice_ids?: Array< string | null > | null,
    invoice_spx_ids?: Array< string | null > | null,
    priority_status?: string | null,
    priority_file_id?: string | null,
    priority_process_on?: string | null,
    priority_response?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePaidolVendorMutationVariables = {
  input: CreatePaidolVendorInput,
  condition?: ModelPaidolVendorConditionInput | null,
};

export type CreatePaidolVendorMutation = {
  createPaidolVendor?:  {
    __typename: "PaidolVendor",
    id: string,
    user_vendor_id: string,
    is_migration?: boolean | null,
    paidol_id: string,
    vendor?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    vendor_paidol_id: string,
    priority_active?: string | null,
    payment_terms?: string | null,
    priority_account_balance?: number | null,
    contact_name?: string | null,
    priority_billing_code?: string | null,
    priority_repeate_code?: string | null,
    priority_group_code?: string | null,
    email_addresses?: Array< string | null > | null,
    priority_document_delivery?: string | null,
    priority_regular_inv?: string | null,
    priority_summary_inv?: string | null,
    foreign_name?: string | null,
    remarks?: string | null,
    box_1099?: string | null,
    form_code_1099?: string | null,
    remark_1?: string | null,
    priority_response?: string | null,
    cron_status?: CronStatus | null,
    priority_status?: string | null,
    priority_supplier_id?: string | null,
    virtual_card_email?: string | null,
    bankAccounts?:  Array< {
      __typename: "BankAccounts",
      bankId?: string | null,
      accountType?: AccountTypeEnum | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
      defaults?: Array< DefaultsEnum | null > | null,
      isActive?: boolean | null,
    } | null > | null,
    achEnabled?: boolean | null,
    virtualCardEnabled?: boolean | null,
    checkIssuingEnabled?: boolean | null,
    checkIssuingPayableTo?: string | null,
    checkIssuingStreet?: string | null,
    checkIssuingCity?: string | null,
    checkIssuingState?: string | null,
    checkIssuingCountry?: string | null,
    checkIssuingPostalCode?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePaidolVendorMutationVariables = {
  input: UpdatePaidolVendorInput,
  condition?: ModelPaidolVendorConditionInput | null,
};

export type UpdatePaidolVendorMutation = {
  updatePaidolVendor?:  {
    __typename: "PaidolVendor",
    id: string,
    user_vendor_id: string,
    is_migration?: boolean | null,
    paidol_id: string,
    vendor?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    vendor_paidol_id: string,
    priority_active?: string | null,
    payment_terms?: string | null,
    priority_account_balance?: number | null,
    contact_name?: string | null,
    priority_billing_code?: string | null,
    priority_repeate_code?: string | null,
    priority_group_code?: string | null,
    email_addresses?: Array< string | null > | null,
    priority_document_delivery?: string | null,
    priority_regular_inv?: string | null,
    priority_summary_inv?: string | null,
    foreign_name?: string | null,
    remarks?: string | null,
    box_1099?: string | null,
    form_code_1099?: string | null,
    remark_1?: string | null,
    priority_response?: string | null,
    cron_status?: CronStatus | null,
    priority_status?: string | null,
    priority_supplier_id?: string | null,
    virtual_card_email?: string | null,
    bankAccounts?:  Array< {
      __typename: "BankAccounts",
      bankId?: string | null,
      accountType?: AccountTypeEnum | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
      defaults?: Array< DefaultsEnum | null > | null,
      isActive?: boolean | null,
    } | null > | null,
    achEnabled?: boolean | null,
    virtualCardEnabled?: boolean | null,
    checkIssuingEnabled?: boolean | null,
    checkIssuingPayableTo?: string | null,
    checkIssuingStreet?: string | null,
    checkIssuingCity?: string | null,
    checkIssuingState?: string | null,
    checkIssuingCountry?: string | null,
    checkIssuingPostalCode?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePaidolVendorMutationVariables = {
  input: DeletePaidolVendorInput,
  condition?: ModelPaidolVendorConditionInput | null,
};

export type DeletePaidolVendorMutation = {
  deletePaidolVendor?:  {
    __typename: "PaidolVendor",
    id: string,
    user_vendor_id: string,
    is_migration?: boolean | null,
    paidol_id: string,
    vendor?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    vendor_paidol_id: string,
    priority_active?: string | null,
    payment_terms?: string | null,
    priority_account_balance?: number | null,
    contact_name?: string | null,
    priority_billing_code?: string | null,
    priority_repeate_code?: string | null,
    priority_group_code?: string | null,
    email_addresses?: Array< string | null > | null,
    priority_document_delivery?: string | null,
    priority_regular_inv?: string | null,
    priority_summary_inv?: string | null,
    foreign_name?: string | null,
    remarks?: string | null,
    box_1099?: string | null,
    form_code_1099?: string | null,
    remark_1?: string | null,
    priority_response?: string | null,
    cron_status?: CronStatus | null,
    priority_status?: string | null,
    priority_supplier_id?: string | null,
    virtual_card_email?: string | null,
    bankAccounts?:  Array< {
      __typename: "BankAccounts",
      bankId?: string | null,
      accountType?: AccountTypeEnum | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
      defaults?: Array< DefaultsEnum | null > | null,
      isActive?: boolean | null,
    } | null > | null,
    achEnabled?: boolean | null,
    virtualCardEnabled?: boolean | null,
    checkIssuingEnabled?: boolean | null,
    checkIssuingPayableTo?: string | null,
    checkIssuingStreet?: string | null,
    checkIssuingCity?: string | null,
    checkIssuingState?: string | null,
    checkIssuingCountry?: string | null,
    checkIssuingPostalCode?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInvoiceMutationVariables = {
  input: CreateInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type CreateInvoiceMutation = {
  createInvoice?:  {
    __typename: "Invoice",
    id: string,
    id_base58?: string | null,
    id_base58_short?: string | null,
    payment_file_queue_id?: string | null,
    payment_file?:  {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null,
    buyer_paidol_id: string,
    paidol_vendor_id: string,
    paidol_vendor:  {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    supplier_paidol_id: string,
    supplier_paidol:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    user_invoice_id: string,
    date: string,
    balance_due:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    },
    createdAt: string,
    updatedAt: string,
    transaction_id?: string | null,
    priority_payment_id?: string | null,
    priority_payment_status?: string | null,
    priority_payment_type?: string | null,
    priority_payment_date?: string | null,
    priority_payment_auth_message?: string | null,
    priority_response?: string | null,
    status: PaymentFileQueueStatusEnum,
  } | null,
};

export type UpdateInvoiceMutationVariables = {
  input: UpdateInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type UpdateInvoiceMutation = {
  updateInvoice?:  {
    __typename: "Invoice",
    id: string,
    id_base58?: string | null,
    id_base58_short?: string | null,
    payment_file_queue_id?: string | null,
    payment_file?:  {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null,
    buyer_paidol_id: string,
    paidol_vendor_id: string,
    paidol_vendor:  {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    supplier_paidol_id: string,
    supplier_paidol:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    user_invoice_id: string,
    date: string,
    balance_due:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    },
    createdAt: string,
    updatedAt: string,
    transaction_id?: string | null,
    priority_payment_id?: string | null,
    priority_payment_status?: string | null,
    priority_payment_type?: string | null,
    priority_payment_date?: string | null,
    priority_payment_auth_message?: string | null,
    priority_response?: string | null,
    status: PaymentFileQueueStatusEnum,
  } | null,
};

export type DeleteInvoiceMutationVariables = {
  input: DeleteInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type DeleteInvoiceMutation = {
  deleteInvoice?:  {
    __typename: "Invoice",
    id: string,
    id_base58?: string | null,
    id_base58_short?: string | null,
    payment_file_queue_id?: string | null,
    payment_file?:  {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null,
    buyer_paidol_id: string,
    paidol_vendor_id: string,
    paidol_vendor:  {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    supplier_paidol_id: string,
    supplier_paidol:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    user_invoice_id: string,
    date: string,
    balance_due:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    },
    createdAt: string,
    updatedAt: string,
    transaction_id?: string | null,
    priority_payment_id?: string | null,
    priority_payment_status?: string | null,
    priority_payment_type?: string | null,
    priority_payment_date?: string | null,
    priority_payment_auth_message?: string | null,
    priority_response?: string | null,
    status: PaymentFileQueueStatusEnum,
  } | null,
};

export type CreateSupplierFileQueueMutationVariables = {
  input: CreateSupplierFileQueueInput,
  condition?: ModelSupplierFileQueueConditionInput | null,
};

export type CreateSupplierFileQueueMutation = {
  createSupplierFileQueue?:  {
    __typename: "SupplierFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: SupplierFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    createdAt?: string | null,
    is_migration?: boolean | null,
    updatedAt: string,
  } | null,
};

export type UpdateSupplierFileQueueMutationVariables = {
  input: UpdateSupplierFileQueueInput,
  condition?: ModelSupplierFileQueueConditionInput | null,
};

export type UpdateSupplierFileQueueMutation = {
  updateSupplierFileQueue?:  {
    __typename: "SupplierFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: SupplierFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    createdAt?: string | null,
    is_migration?: boolean | null,
    updatedAt: string,
  } | null,
};

export type DeleteSupplierFileQueueMutationVariables = {
  input: DeleteSupplierFileQueueInput,
  condition?: ModelSupplierFileQueueConditionInput | null,
};

export type DeleteSupplierFileQueueMutation = {
  deleteSupplierFileQueue?:  {
    __typename: "SupplierFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: SupplierFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    createdAt?: string | null,
    is_migration?: boolean | null,
    updatedAt: string,
  } | null,
};

export type CreatePaymentStatusDownloadMutationVariables = {
  input: CreatePaymentStatusDownloadInput,
  condition?: ModelPaymentStatusDownloadConditionInput | null,
};

export type CreatePaymentStatusDownloadMutation = {
  createPaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePaymentStatusDownloadMutationVariables = {
  input: UpdatePaymentStatusDownloadInput,
  condition?: ModelPaymentStatusDownloadConditionInput | null,
};

export type UpdatePaymentStatusDownloadMutation = {
  updatePaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePaymentStatusDownloadMutationVariables = {
  input: DeletePaymentStatusDownloadInput,
  condition?: ModelPaymentStatusDownloadConditionInput | null,
};

export type DeletePaymentStatusDownloadMutation = {
  deletePaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePaidolHighnoteIntegrationMutationVariables = {
  input: UpdatePaidolHighnoteIntegrationInput,
  condition?: ModelPaidolHighnoteIntegrationConditionInput | null,
};

export type UpdatePaidolHighnoteIntegrationMutation = {
  updatePaidolHighnoteIntegration?:  {
    __typename: "PaidolHighnoteIntegration",
    // id and paidolId are the same; corresponds to Paidol.id
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    id: string,
    paidolId: string,
    userId?: string | null,
    legalBusinessName?: string | null,
    businessAccountHolderId?: string | null,
    primaryAuthorizedPersonId?: string | null,
    financialAccountId?: string | null,
    externalFinancialBankAccountId?: string | null,
    hasInitialFunding?: boolean | null,
    accountHolderCardProductApplicationId?: string | null,
    isApplicationAccepted?: boolean | null,
    isDisconnected?: boolean | null,
    highnoteProductId?: string | null,
    highnoteProduct?:  {
      __typename: "HighnoteProduct",
      id: string,
      type: HighnoteProductType,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    finicityCustomerId?: string | null,
    dwollaCustomerId?: string | null,
    cardProfileId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHighnotePaymentCardMutationVariables = {
  input: CreateHighnotePaymentCardInput,
  condition?: ModelHighnotePaymentCardConditionInput | null,
};

export type CreateHighnotePaymentCardMutation = {
  createHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHighnotePaymentCardMutationVariables = {
  input: UpdateHighnotePaymentCardInput,
  condition?: ModelHighnotePaymentCardConditionInput | null,
};

export type UpdateHighnotePaymentCardMutation = {
  updateHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHighnotePaymentCardMutationVariables = {
  input: DeleteHighnotePaymentCardInput,
  condition?: ModelHighnotePaymentCardConditionInput | null,
};

export type DeleteHighnotePaymentCardMutation = {
  deleteHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSpendRulesMutationVariables = {
  input: CreateSpendRulesInput,
  condition?: ModelSpendRulesConditionInput | null,
};

export type CreateSpendRulesMutation = {
  createSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSpendRulesMutationVariables = {
  input: UpdateSpendRulesInput,
  condition?: ModelSpendRulesConditionInput | null,
};

export type UpdateSpendRulesMutation = {
  updateSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSpendRulesMutationVariables = {
  input: DeleteSpendRulesInput,
  condition?: ModelSpendRulesConditionInput | null,
};

export type DeleteSpendRulesMutation = {
  deleteSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVelocityRulesMutationVariables = {
  input: CreateVelocityRulesInput,
  condition?: ModelVelocityRulesConditionInput | null,
};

export type CreateVelocityRulesMutation = {
  createVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVelocityRulesMutationVariables = {
  input: UpdateVelocityRulesInput,
  condition?: ModelVelocityRulesConditionInput | null,
};

export type UpdateVelocityRulesMutation = {
  updateVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVelocityRulesMutationVariables = {
  input: DeleteVelocityRulesInput,
  condition?: ModelVelocityRulesConditionInput | null,
};

export type DeleteVelocityRulesMutation = {
  deleteVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReceiptSummaryFieldMutationVariables = {
  input: CreateReceiptSummaryFieldInput,
  condition?: ModelReceiptSummaryFieldConditionInput | null,
};

export type CreateReceiptSummaryFieldMutation = {
  createReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReceiptSummaryFieldMutationVariables = {
  input: UpdateReceiptSummaryFieldInput,
  condition?: ModelReceiptSummaryFieldConditionInput | null,
};

export type UpdateReceiptSummaryFieldMutation = {
  updateReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReceiptSummaryFieldMutationVariables = {
  input: DeleteReceiptSummaryFieldInput,
  condition?: ModelReceiptSummaryFieldConditionInput | null,
};

export type DeleteReceiptSummaryFieldMutation = {
  deleteReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReceiptLineItemMutationVariables = {
  input: CreateReceiptLineItemInput,
  condition?: ModelReceiptLineItemConditionInput | null,
};

export type CreateReceiptLineItemMutation = {
  createReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReceiptLineItemMutationVariables = {
  input: UpdateReceiptLineItemInput,
  condition?: ModelReceiptLineItemConditionInput | null,
};

export type UpdateReceiptLineItemMutation = {
  updateReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReceiptLineItemMutationVariables = {
  input: DeleteReceiptLineItemInput,
  condition?: ModelReceiptLineItemConditionInput | null,
};

export type DeleteReceiptLineItemMutation = {
  deleteReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReceiptLineItemFieldMutationVariables = {
  input: CreateReceiptLineItemFieldInput,
  condition?: ModelReceiptLineItemFieldConditionInput | null,
};

export type CreateReceiptLineItemFieldMutation = {
  createReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReceiptLineItemFieldMutationVariables = {
  input: UpdateReceiptLineItemFieldInput,
  condition?: ModelReceiptLineItemFieldConditionInput | null,
};

export type UpdateReceiptLineItemFieldMutation = {
  updateReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReceiptLineItemFieldMutationVariables = {
  input: DeleteReceiptLineItemFieldInput,
  condition?: ModelReceiptLineItemFieldConditionInput | null,
};

export type DeleteReceiptLineItemFieldMutation = {
  deleteReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReceiptUploadMutationVariables = {
  input: CreateReceiptUploadInput,
  condition?: ModelReceiptUploadConditionInput | null,
};

export type CreateReceiptUploadMutation = {
  createReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReceiptUploadMutationVariables = {
  input: UpdateReceiptUploadInput,
  condition?: ModelReceiptUploadConditionInput | null,
};

export type UpdateReceiptUploadMutation = {
  updateReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReceiptUploadMutationVariables = {
  input: DeleteReceiptUploadInput,
  condition?: ModelReceiptUploadConditionInput | null,
};

export type DeleteReceiptUploadMutation = {
  deleteReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTransactionToReceiptUploadMutationVariables = {
  input: CreateTransactionToReceiptUploadInput,
  condition?: ModelTransactionToReceiptUploadConditionInput | null,
};

export type CreateTransactionToReceiptUploadMutation = {
  createTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type UpdateTransactionToReceiptUploadMutationVariables = {
  input: UpdateTransactionToReceiptUploadInput,
  condition?: ModelTransactionToReceiptUploadConditionInput | null,
};

export type UpdateTransactionToReceiptUploadMutation = {
  updateTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type DeleteTransactionToReceiptUploadMutationVariables = {
  input: DeleteTransactionToReceiptUploadInput,
  condition?: ModelTransactionToReceiptUploadConditionInput | null,
};

export type DeleteTransactionToReceiptUploadMutation = {
  deleteTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type CreateTransactionMutation = {
  createTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type DeleteTransactionMutation = {
  deleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReimbursementTransactionMutationVariables = {
  input: CreateReimbursementTransactionInput,
  condition?: ModelReimbursementTransactionConditionInput | null,
};

export type CreateReimbursementTransactionMutation = {
  createReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReimbursementTransactionMutationVariables = {
  input: UpdateReimbursementTransactionInput,
  condition?: ModelReimbursementTransactionConditionInput | null,
};

export type UpdateReimbursementTransactionMutation = {
  updateReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReimbursementTransactionMutationVariables = {
  input: DeleteReimbursementTransactionInput,
  condition?: ModelReimbursementTransactionConditionInput | null,
};

export type DeleteReimbursementTransactionMutation = {
  deleteReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProjectGroupMutationVariables = {
  input: CreateProjectGroupInput,
  condition?: ModelProjectGroupConditionInput | null,
};

export type CreateProjectGroupMutation = {
  createProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProjectGroupMutationVariables = {
  input: UpdateProjectGroupInput,
  condition?: ModelProjectGroupConditionInput | null,
};

export type UpdateProjectGroupMutation = {
  updateProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProjectGroupMutationVariables = {
  input: DeleteProjectGroupInput,
  condition?: ModelProjectGroupConditionInput | null,
};

export type DeleteProjectGroupMutation = {
  deleteProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCardGroupMutationVariables = {
  input: CreateCardGroupInput,
  condition?: ModelCardGroupConditionInput | null,
};

export type CreateCardGroupMutation = {
  createCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCardGroupMutationVariables = {
  input: UpdateCardGroupInput,
  condition?: ModelCardGroupConditionInput | null,
};

export type UpdateCardGroupMutation = {
  updateCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCardGroupMutationVariables = {
  input: DeleteCardGroupInput,
  condition?: ModelCardGroupConditionInput | null,
};

export type DeleteCardGroupMutation = {
  deleteCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserNotificationPreferencesMutationVariables = {
  input: CreateUserNotificationPreferencesInput,
  condition?: ModelUserNotificationPreferencesConditionInput | null,
};

export type CreateUserNotificationPreferencesMutation = {
  createUserNotificationPreferences?:  {
    __typename: "UserNotificationPreferences",
    id: string,
    userId: string,
    paidolId?: string | null,
    transactionAlertSms?: boolean | null,
    transactionAlertEmail?: boolean | null,
    cardLockedSms?: boolean | null,
    cardLockedEmail?: boolean | null,
    manualCardActionSms?: boolean | null,
    manualCardActionEmail?: boolean | null,
    lowBalanceAlertSms?: boolean | null,
    lowBalanceAlertEmail?: boolean | null,
    cardActivationSms?: boolean | null,
    cardActivationEmail?: boolean | null,
    statementReadySms?: boolean | null,
    statementReadyEmail?: boolean | null,
    txnReviewFrequency?: string | null,
    txnReviewCodeUpdateSms?: boolean | null,
    txnReviewCodeUpdateEmail?: boolean | null,
    txnReviewNoteUpdateSms?: boolean | null,
    txnReviewNoteUpdateEmail?: boolean | null,
    txnReviewReceiptUpdateSms?: boolean | null,
    txnReviewReceiptUpdateEmail?: boolean | null,
    txnReviewResubmissionSms?: boolean | null,
    txnReviewResubmissionEmail?: boolean | null,
    txnReviewReadySms?: boolean | null,
    txnReviewReadyEmail?: boolean | null,
    returnedTransactionSms?: boolean | null,
    returnedTransactionEmail?: boolean | null,
    smsConsentAccepted?: boolean | null,
    smsConsentAcceptedAt?: string | null,
    platformAgreementVersion?: string | null,
    hasReceivedWelcomeSms?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateUserNotificationPreferencesMutationVariables = {
  input: UpdateUserNotificationPreferencesInput,
  condition?: ModelUserNotificationPreferencesConditionInput | null,
};

export type UpdateUserNotificationPreferencesMutation = {
  updateUserNotificationPreferences?:  {
    __typename: "UserNotificationPreferences",
    id: string,
    userId: string,
    paidolId?: string | null,
    transactionAlertSms?: boolean | null,
    transactionAlertEmail?: boolean | null,
    cardLockedSms?: boolean | null,
    cardLockedEmail?: boolean | null,
    manualCardActionSms?: boolean | null,
    manualCardActionEmail?: boolean | null,
    lowBalanceAlertSms?: boolean | null,
    lowBalanceAlertEmail?: boolean | null,
    cardActivationSms?: boolean | null,
    cardActivationEmail?: boolean | null,
    statementReadySms?: boolean | null,
    statementReadyEmail?: boolean | null,
    txnReviewFrequency?: string | null,
    txnReviewCodeUpdateSms?: boolean | null,
    txnReviewCodeUpdateEmail?: boolean | null,
    txnReviewNoteUpdateSms?: boolean | null,
    txnReviewNoteUpdateEmail?: boolean | null,
    txnReviewReceiptUpdateSms?: boolean | null,
    txnReviewReceiptUpdateEmail?: boolean | null,
    txnReviewResubmissionSms?: boolean | null,
    txnReviewResubmissionEmail?: boolean | null,
    txnReviewReadySms?: boolean | null,
    txnReviewReadyEmail?: boolean | null,
    returnedTransactionSms?: boolean | null,
    returnedTransactionEmail?: boolean | null,
    smsConsentAccepted?: boolean | null,
    smsConsentAcceptedAt?: string | null,
    platformAgreementVersion?: string | null,
    hasReceivedWelcomeSms?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateMerchantSpendRuleMutationVariables = {
  input: CreateMerchantSpendRuleInput,
  condition?: ModelMerchantSpendRuleConditionInput | null,
};

export type CreateMerchantSpendRuleMutation = {
  createMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMerchantSpendRuleMutationVariables = {
  input: UpdateMerchantSpendRuleInput,
  condition?: ModelMerchantSpendRuleConditionInput | null,
};

export type UpdateMerchantSpendRuleMutation = {
  updateMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMerchantSpendRuleMutationVariables = {
  input: DeleteMerchantSpendRuleInput,
  condition?: ModelMerchantSpendRuleConditionInput | null,
};

export type DeleteMerchantSpendRuleMutation = {
  deleteMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTransactionsDownloadQueueMutationVariables = {
  input: CreateTransactionsDownloadQueueInput,
  condition?: ModelTransactionsDownloadQueueConditionInput | null,
};

export type CreateTransactionsDownloadQueueMutation = {
  createTransactionsDownloadQueue?:  {
    __typename: "TransactionsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    range_option: ExportDateRangeEnum,
    start_date?: string | null,
    end_date?: string | null,
    columns: Array< string >,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    paidolUserId?: string | null,
    mark_as_exported?: boolean | null,
    exported_count?: number | null,
    skipped_count?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateTransactionsDownloadQueueMutationVariables = {
  input: UpdateTransactionsDownloadQueueInput,
  condition?: ModelTransactionsDownloadQueueConditionInput | null,
};

export type UpdateTransactionsDownloadQueueMutation = {
  updateTransactionsDownloadQueue?:  {
    __typename: "TransactionsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    range_option: ExportDateRangeEnum,
    start_date?: string | null,
    end_date?: string | null,
    columns: Array< string >,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    paidolUserId?: string | null,
    mark_as_exported?: boolean | null,
    exported_count?: number | null,
    skipped_count?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteTransactionsDownloadQueueMutationVariables = {
  input: DeleteTransactionsDownloadQueueInput,
  condition?: ModelTransactionsDownloadQueueConditionInput | null,
};

export type DeleteTransactionsDownloadQueueMutation = {
  deleteTransactionsDownloadQueue?:  {
    __typename: "TransactionsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    range_option: ExportDateRangeEnum,
    start_date?: string | null,
    end_date?: string | null,
    columns: Array< string >,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    paidolUserId?: string | null,
    mark_as_exported?: boolean | null,
    exported_count?: number | null,
    skipped_count?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateTransactionsReceiptsDownloadQueueMutationVariables = {
  input: CreateTransactionsReceiptsDownloadQueueInput,
  condition?: ModelTransactionsReceiptsDownloadQueueConditionInput | null,
};

export type CreateTransactionsReceiptsDownloadQueueMutation = {
  createTransactionsReceiptsDownloadQueue?:  {
    __typename: "TransactionsReceiptsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    paidolUserId?: string | null,
    s3_key?: string | null,
    range_option?: ExportDateRangeEnum | null,
    start_date?: string | null,
    end_date?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
    // EXPORT_FAILED) so the frontend can show an honest message instead of a
    // generic "no receipts found".
    error_code?: string | null,
    createdAt: string,
    filteredTransactionIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type UpdateTransactionsReceiptsDownloadQueueMutationVariables = {
  input: UpdateTransactionsReceiptsDownloadQueueInput,
  condition?: ModelTransactionsReceiptsDownloadQueueConditionInput | null,
};

export type UpdateTransactionsReceiptsDownloadQueueMutation = {
  updateTransactionsReceiptsDownloadQueue?:  {
    __typename: "TransactionsReceiptsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    paidolUserId?: string | null,
    s3_key?: string | null,
    range_option?: ExportDateRangeEnum | null,
    start_date?: string | null,
    end_date?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
    // EXPORT_FAILED) so the frontend can show an honest message instead of a
    // generic "no receipts found".
    error_code?: string | null,
    createdAt: string,
    filteredTransactionIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type DeleteTransactionsReceiptsDownloadQueueMutationVariables = {
  input: DeleteTransactionsReceiptsDownloadQueueInput,
  condition?: ModelTransactionsReceiptsDownloadQueueConditionInput | null,
};

export type DeleteTransactionsReceiptsDownloadQueueMutation = {
  deleteTransactionsReceiptsDownloadQueue?:  {
    __typename: "TransactionsReceiptsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    paidolUserId?: string | null,
    s3_key?: string | null,
    range_option?: ExportDateRangeEnum | null,
    start_date?: string | null,
    end_date?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
    // EXPORT_FAILED) so the frontend can show an honest message instead of a
    // generic "no receipts found".
    error_code?: string | null,
    createdAt: string,
    filteredTransactionIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type CreateSpendRuleConfigMutationVariables = {
  input: CreateSpendRuleConfigInput,
  condition?: ModelSpendRuleConfigConditionInput | null,
};

export type CreateSpendRuleConfigMutation = {
  createSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSpendRuleConfigMutationVariables = {
  input: UpdateSpendRuleConfigInput,
  condition?: ModelSpendRuleConfigConditionInput | null,
};

export type UpdateSpendRuleConfigMutation = {
  updateSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSpendRuleConfigMutationVariables = {
  input: DeleteSpendRuleConfigInput,
  condition?: ModelSpendRuleConfigConditionInput | null,
};

export type DeleteSpendRuleConfigMutation = {
  deleteSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateJobCodeImportMutationVariables = {
  input: CreateJobCodeImportInput,
  condition?: ModelJobCodeImportConditionInput | null,
};

export type CreateJobCodeImportMutation = {
  createJobCodeImport?:  {
    __typename: "JobCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    storageFileKey: string,
    fileName: string,
    status: JobCodeImportStatus,
    errors?: string | null,
    jobCodes?:  {
      __typename: "ModelJobCodeConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdateJobCodeImportMutationVariables = {
  input: UpdateJobCodeImportInput,
  condition?: ModelJobCodeImportConditionInput | null,
};

export type UpdateJobCodeImportMutation = {
  updateJobCodeImport?:  {
    __typename: "JobCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    storageFileKey: string,
    fileName: string,
    status: JobCodeImportStatus,
    errors?: string | null,
    jobCodes?:  {
      __typename: "ModelJobCodeConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeleteJobCodeImportMutationVariables = {
  input: DeleteJobCodeImportInput,
  condition?: ModelJobCodeImportConditionInput | null,
};

export type DeleteJobCodeImportMutation = {
  deleteJobCodeImport?:  {
    __typename: "JobCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    storageFileKey: string,
    fileName: string,
    status: JobCodeImportStatus,
    errors?: string | null,
    jobCodes?:  {
      __typename: "ModelJobCodeConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreateJobCodeMutationVariables = {
  input: CreateJobCodeInput,
  condition?: ModelJobCodeConditionInput | null,
};

export type CreateJobCodeMutation = {
  createJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateJobCodeMutationVariables = {
  input: UpdateJobCodeInput,
  condition?: ModelJobCodeConditionInput | null,
};

export type UpdateJobCodeMutation = {
  updateJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteJobCodeMutationVariables = {
  input: DeleteJobCodeInput,
  condition?: ModelJobCodeConditionInput | null,
};

export type DeleteJobCodeMutation = {
  deleteJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexCodeImportMutationVariables = {
  input: CreateFlexCodeImportInput,
  condition?: ModelFlexCodeImportConditionInput | null,
};

export type CreateFlexCodeImportMutation = {
  createFlexCodeImport?:  {
    __typename: "FlexCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    updatedAt: string,
    storageFileKey: string,
    fileName: string,
    status: FlexCodeImportStatus,
    errors?: string | null,
    searchSynced?: boolean | null,
    flexCodes?:  {
      __typename: "ModelFlexCodeConnection",
      nextToken?: string | null,
    } | null,
    type: FlexCodeImportType,
  } | null,
};

export type UpdateFlexCodeImportMutationVariables = {
  input: UpdateFlexCodeImportInput,
  condition?: ModelFlexCodeImportConditionInput | null,
};

export type UpdateFlexCodeImportMutation = {
  updateFlexCodeImport?:  {
    __typename: "FlexCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    updatedAt: string,
    storageFileKey: string,
    fileName: string,
    status: FlexCodeImportStatus,
    errors?: string | null,
    searchSynced?: boolean | null,
    flexCodes?:  {
      __typename: "ModelFlexCodeConnection",
      nextToken?: string | null,
    } | null,
    type: FlexCodeImportType,
  } | null,
};

export type DeleteFlexCodeImportMutationVariables = {
  input: DeleteFlexCodeImportInput,
  condition?: ModelFlexCodeImportConditionInput | null,
};

export type DeleteFlexCodeImportMutation = {
  deleteFlexCodeImport?:  {
    __typename: "FlexCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    updatedAt: string,
    storageFileKey: string,
    fileName: string,
    status: FlexCodeImportStatus,
    errors?: string | null,
    searchSynced?: boolean | null,
    flexCodes?:  {
      __typename: "ModelFlexCodeConnection",
      nextToken?: string | null,
    } | null,
    type: FlexCodeImportType,
  } | null,
};

export type CreateV2FlexRelationshipsMutationVariables = {
  input: CreateV2FlexRelationshipsInput,
  condition?: ModelV2FlexRelationshipsConditionInput | null,
};

export type CreateV2FlexRelationshipsMutation = {
  createV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateV2FlexRelationshipsMutationVariables = {
  input: UpdateV2FlexRelationshipsInput,
  condition?: ModelV2FlexRelationshipsConditionInput | null,
};

export type UpdateV2FlexRelationshipsMutation = {
  updateV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteV2FlexRelationshipsMutationVariables = {
  input: DeleteV2FlexRelationshipsInput,
  condition?: ModelV2FlexRelationshipsConditionInput | null,
};

export type DeleteV2FlexRelationshipsMutation = {
  deleteV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexGlCodeMutationVariables = {
  input: CreateFlexGlCodeInput,
  condition?: ModelFlexGlCodeConditionInput | null,
};

export type CreateFlexGlCodeMutation = {
  createFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexGlCodeMutationVariables = {
  input: UpdateFlexGlCodeInput,
  condition?: ModelFlexGlCodeConditionInput | null,
};

export type UpdateFlexGlCodeMutation = {
  updateFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexGlCodeMutationVariables = {
  input: DeleteFlexGlCodeInput,
  condition?: ModelFlexGlCodeConditionInput | null,
};

export type DeleteFlexGlCodeMutation = {
  deleteFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexCodeMutationVariables = {
  input: CreateFlexCodeInput,
  condition?: ModelFlexCodeConditionInput | null,
};

export type CreateFlexCodeMutation = {
  createFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexCodeMutationVariables = {
  input: UpdateFlexCodeInput,
  condition?: ModelFlexCodeConditionInput | null,
};

export type UpdateFlexCodeMutation = {
  updateFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexCodeMutationVariables = {
  input: DeleteFlexCodeInput,
  condition?: ModelFlexCodeConditionInput | null,
};

export type DeleteFlexCodeMutation = {
  deleteFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexCostCodeMutationVariables = {
  input: CreateFlexCostCodeInput,
  condition?: ModelFlexCostCodeConditionInput | null,
};

export type CreateFlexCostCodeMutation = {
  createFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexCostCodeMutationVariables = {
  input: UpdateFlexCostCodeInput,
  condition?: ModelFlexCostCodeConditionInput | null,
};

export type UpdateFlexCostCodeMutation = {
  updateFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexCostCodeMutationVariables = {
  input: DeleteFlexCostCodeInput,
  condition?: ModelFlexCostCodeConditionInput | null,
};

export type DeleteFlexCostCodeMutation = {
  deleteFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexCostTypeMutationVariables = {
  input: CreateFlexCostTypeInput,
  condition?: ModelFlexCostTypeConditionInput | null,
};

export type CreateFlexCostTypeMutation = {
  createFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexCostTypeMutationVariables = {
  input: UpdateFlexCostTypeInput,
  condition?: ModelFlexCostTypeConditionInput | null,
};

export type UpdateFlexCostTypeMutation = {
  updateFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexCostTypeMutationVariables = {
  input: DeleteFlexCostTypeInput,
  condition?: ModelFlexCostTypeConditionInput | null,
};

export type DeleteFlexCostTypeMutation = {
  deleteFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexVendorMutationVariables = {
  input: CreateFlexVendorInput,
  condition?: ModelFlexVendorConditionInput | null,
};

export type CreateFlexVendorMutation = {
  createFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexVendorMutationVariables = {
  input: UpdateFlexVendorInput,
  condition?: ModelFlexVendorConditionInput | null,
};

export type UpdateFlexVendorMutation = {
  updateFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexVendorMutationVariables = {
  input: DeleteFlexVendorInput,
  condition?: ModelFlexVendorConditionInput | null,
};

export type DeleteFlexVendorMutation = {
  deleteFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexFieldMutationVariables = {
  input: CreateFlexFieldInput,
  condition?: ModelFlexFieldConditionInput | null,
};

export type CreateFlexFieldMutation = {
  createFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexFieldMutationVariables = {
  input: UpdateFlexFieldInput,
  condition?: ModelFlexFieldConditionInput | null,
};

export type UpdateFlexFieldMutation = {
  updateFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexFieldMutationVariables = {
  input: DeleteFlexFieldInput,
  condition?: ModelFlexFieldConditionInput | null,
};

export type DeleteFlexFieldMutation = {
  deleteFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexFieldValueMutationVariables = {
  input: CreateFlexFieldValueInput,
  condition?: ModelFlexFieldValueConditionInput | null,
};

export type CreateFlexFieldValueMutation = {
  createFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexFieldValueMutationVariables = {
  input: UpdateFlexFieldValueInput,
  condition?: ModelFlexFieldValueConditionInput | null,
};

export type UpdateFlexFieldValueMutation = {
  updateFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexFieldValueMutationVariables = {
  input: DeleteFlexFieldValueInput,
  condition?: ModelFlexFieldValueConditionInput | null,
};

export type DeleteFlexFieldValueMutation = {
  deleteFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlexFieldUploadMutationVariables = {
  input: CreateFlexFieldUploadInput,
  condition?: ModelFlexFieldUploadConditionInput | null,
};

export type CreateFlexFieldUploadMutation = {
  createFlexFieldUpload?:  {
    __typename: "FlexFieldUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    storageFileKey: string,
    fileName: string,
    status: FlexFieldUploadStatus,
    errors?: string | null,
    rowCount?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlexFieldUploadMutationVariables = {
  input: UpdateFlexFieldUploadInput,
  condition?: ModelFlexFieldUploadConditionInput | null,
};

export type UpdateFlexFieldUploadMutation = {
  updateFlexFieldUpload?:  {
    __typename: "FlexFieldUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    storageFileKey: string,
    fileName: string,
    status: FlexFieldUploadStatus,
    errors?: string | null,
    rowCount?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlexFieldUploadMutationVariables = {
  input: DeleteFlexFieldUploadInput,
  condition?: ModelFlexFieldUploadConditionInput | null,
};

export type DeleteFlexFieldUploadMutation = {
  deleteFlexFieldUpload?:  {
    __typename: "FlexFieldUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    storageFileKey: string,
    fileName: string,
    status: FlexFieldUploadStatus,
    errors?: string | null,
    rowCount?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStatementSummaryMutationVariables = {
  input: CreateStatementSummaryInput,
  condition?: ModelStatementSummaryConditionInput | null,
};

export type CreateStatementSummaryMutation = {
  createStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateStatementSummaryMutationVariables = {
  input: UpdateStatementSummaryInput,
  condition?: ModelStatementSummaryConditionInput | null,
};

export type UpdateStatementSummaryMutation = {
  updateStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteStatementSummaryMutationVariables = {
  input: DeleteStatementSummaryInput,
  condition?: ModelStatementSummaryConditionInput | null,
};

export type DeleteStatementSummaryMutation = {
  deleteStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAutoPaymentMutationVariables = {
  input: CreateAutoPaymentInput,
  condition?: ModelAutoPaymentConditionInput | null,
};

export type CreateAutoPaymentMutation = {
  createAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAutoPaymentMutationVariables = {
  input: UpdateAutoPaymentInput,
  condition?: ModelAutoPaymentConditionInput | null,
};

export type UpdateAutoPaymentMutation = {
  updateAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAutoPaymentMutationVariables = {
  input: DeleteAutoPaymentInput,
  condition?: ModelAutoPaymentConditionInput | null,
};

export type DeleteAutoPaymentMutation = {
  deleteAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTransactionFilterOptionsMutationVariables = {
  input: CreateTransactionFilterOptionsInput,
  condition?: ModelTransactionFilterOptionsConditionInput | null,
};

export type CreateTransactionFilterOptionsMutation = {
  createTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateTransactionFilterOptionsMutationVariables = {
  input: UpdateTransactionFilterOptionsInput,
  condition?: ModelTransactionFilterOptionsConditionInput | null,
};

export type UpdateTransactionFilterOptionsMutation = {
  updateTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteTransactionFilterOptionsMutationVariables = {
  input: DeleteTransactionFilterOptionsInput,
  condition?: ModelTransactionFilterOptionsConditionInput | null,
};

export type DeleteTransactionFilterOptionsMutation = {
  deleteTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateHighnoteDisputeEventMutationVariables = {
  input: CreateHighnoteDisputeEventInput,
  condition?: ModelHighnoteDisputeEventConditionInput | null,
};

export type CreateHighnoteDisputeEventMutation = {
  createHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHighnoteDisputeEventMutationVariables = {
  input: UpdateHighnoteDisputeEventInput,
  condition?: ModelHighnoteDisputeEventConditionInput | null,
};

export type UpdateHighnoteDisputeEventMutation = {
  updateHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHighnoteDisputeEventMutationVariables = {
  input: DeleteHighnoteDisputeEventInput,
  condition?: ModelHighnoteDisputeEventConditionInput | null,
};

export type DeleteHighnoteDisputeEventMutation = {
  deleteHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHighnoteTransactionEventMutationVariables = {
  input: CreateHighnoteTransactionEventInput,
  condition?: ModelHighnoteTransactionEventConditionInput | null,
};

export type CreateHighnoteTransactionEventMutation = {
  createHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHighnoteTransactionEventMutationVariables = {
  input: UpdateHighnoteTransactionEventInput,
  condition?: ModelHighnoteTransactionEventConditionInput | null,
};

export type UpdateHighnoteTransactionEventMutation = {
  updateHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHighnoteTransactionEventMutationVariables = {
  input: DeleteHighnoteTransactionEventInput,
  condition?: ModelHighnoteTransactionEventConditionInput | null,
};

export type DeleteHighnoteTransactionEventMutation = {
  deleteHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSyncBalanceCurrentCycleMutationVariables = {
  input: CreateSyncBalanceCurrentCycleInput,
  condition?: ModelSyncBalanceCurrentCycleConditionInput | null,
};

export type CreateSyncBalanceCurrentCycleMutation = {
  createSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSyncBalanceCurrentCycleMutationVariables = {
  input: UpdateSyncBalanceCurrentCycleInput,
  condition?: ModelSyncBalanceCurrentCycleConditionInput | null,
};

export type UpdateSyncBalanceCurrentCycleMutation = {
  updateSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSyncBalanceCurrentCycleMutationVariables = {
  input: DeleteSyncBalanceCurrentCycleInput,
  condition?: ModelSyncBalanceCurrentCycleConditionInput | null,
};

export type DeleteSyncBalanceCurrentCycleMutation = {
  deleteSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSyncBalanceCurrentCyclePaymentCardsMutationVariables = {
  input: CreateSyncBalanceCurrentCyclePaymentCardsInput,
  condition?: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null,
};

export type CreateSyncBalanceCurrentCyclePaymentCardsMutation = {
  createSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSyncBalanceCurrentCyclePaymentCardsMutationVariables = {
  input: UpdateSyncBalanceCurrentCyclePaymentCardsInput,
  condition?: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null,
};

export type UpdateSyncBalanceCurrentCyclePaymentCardsMutation = {
  updateSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSyncBalanceCurrentCyclePaymentCardsMutationVariables = {
  input: DeleteSyncBalanceCurrentCyclePaymentCardsInput,
  condition?: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput | null,
};

export type DeleteSyncBalanceCurrentCyclePaymentCardsMutation = {
  deleteSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateExpenseTypeToMCCMutationVariables = {
  input: CreateExpenseTypeToMCCInput,
  condition?: ModelExpenseTypeToMCCConditionInput | null,
};

export type CreateExpenseTypeToMCCMutation = {
  createExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateExpenseTypeToMCCMutationVariables = {
  input: UpdateExpenseTypeToMCCInput,
  condition?: ModelExpenseTypeToMCCConditionInput | null,
};

export type UpdateExpenseTypeToMCCMutation = {
  updateExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteExpenseTypeToMCCMutationVariables = {
  input: DeleteExpenseTypeToMCCInput,
  condition?: ModelExpenseTypeToMCCConditionInput | null,
};

export type DeleteExpenseTypeToMCCMutation = {
  deleteExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type AssignCardMutationVariables = {
  input: InviteUserToPaidol,
  hostname: string,
  highnotePaymentCardId?: string | null,
};

export type AssignCardMutation = {
  assignCard?:  {
    __typename: "PaidolUser",
    id: string,
    paidol_id?: string | null,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_id?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    email?: string | null,
    position?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    roles?: Role | null,
    is_test_fixture?: boolean | null,
    paymentCards?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    authorizedUserId?: string | null,
    authorizedUserApplicationId?: string | null,
    allowedJobCodes?: Array< string > | null,
    employee_id?: number | null,
    managedGroups?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    managedProjectsGroups?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    departmentVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    columnPreferences?:  Array< {
      __typename: "UserColumnPreferences",
      paidolId: string,
    } > | null,
    widgetPreferences?:  Array< {
      __typename: "UserWidgetPreference",
      widgetId: string,
      hidden: boolean,
    } > | null,
    // Default Agave (Sage Intacct) employee for this cardholder in this company.
    // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
    defaultAgaveEmployeeId?: string | null,
    defaultAgaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    deletedAt?: string | null,
    landingPagePreference?: LandingPagePreference | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type RemoveUserFromPaymentCardMutationVariables = {
  paidolUserToHighnotePaymentCardId: string,
};

export type RemoveUserFromPaymentCardMutation = {
  removeUserFromPaymentCard?:  {
    __typename: "RemoveUserFromPaymentCardPayload",
    id?: string | null,
    paidolUserID?: string | null,
    highnotePaymentCardID?: string | null,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnotePaymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateSupplierMutationVariables = {
  input: SupplierUpdateInput,
};

export type UpdateSupplierMutation = {
  updateSupplier?: string | null,
};

export type HnGenerateTokenizeAccountHolderClientTokenMutationVariables = {
};

export type HnGenerateTokenizeAccountHolderClientTokenMutation = {
  hnGenerateTokenizeAccountHolderClientToken: ( {
      __typename: "HNClientToken",
      value: string,
      expirationDate?: string | null,
      usage?: HNClientTokenUsage | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnGeneratePaymentCardClientTokenMutationVariables = {
  input: HNGeneratePaymentCardClientTokenInput,
};

export type HnGeneratePaymentCardClientTokenMutation = {
  hnGeneratePaymentCardClientToken: ( {
      __typename: "HNClientToken",
      value: string,
      expirationDate?: string | null,
      usage?: HNClientTokenUsage | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnAddExternalBankAccountVerifiedThroughPlaidMutationVariables = {
  input: HNAddExternalBankAccountVerifiedThroughPlaidInput,
};

export type HnAddExternalBankAccountVerifiedThroughPlaidMutation = {
  hnAddExternalBankAccountVerifiedThroughPlaid: ( {
      __typename: "HNExternalFinancialBankAccount",
      id: string,
      ledgers?:  Array< {
        __typename: string,
        id: string,
        name?: HNLedgerName | null,
        description?: string | null,
        normalBalance?: HNNormalBalance | null,
        asOf?: string | null,
      } > | null,
      owner: ( {
          __typename: "HNOrganization",
          id: string,
        } | {
          __typename: "HNPaymentCard",
          id: string,
          externalId?: string | null,
          bin?: string | null,
          last4?: string | null,
          expirationDate?: string | null,
          expirationMonth?: string | null,
          expirationYear?: string | null,
          network?: HNPaymentCardNetwork | null,
          status?: HNPaymentCardStatus | null,
          formFactor?: HNCardFormFactor | null,
          suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
        } | {
          __typename: "HNUSPersonAccountHolder",
          id: string,
          email?: string | null,
          dateOfBirth?: string | null,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNUSBusinessAccountHolder",
          id: string,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      name?: string | null,
      provider?: HNBankVerificationProvider | null,
      accountStatus?: string | null,
      features:  Array<( {
          __typename: "HNDirectDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNDebitPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNIncomeAccountFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNJustInTimeFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNOnDemandFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
          sourceFinancialAccountId?: string | null,
          pseudoBalanceEnabled?: boolean | null,
        } | {
          __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNFleetCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCommercialCreditPayInFullCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCardFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPointRewardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNonVerifiedFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNAchCapableFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNVendorProvidedBankFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPartialFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNRepaymentFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPreprintedCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNMerchantSettlementFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        }
      ) > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      externalBankAccountDetails?:  {
        __typename: string,
        id: string,
        last4?: string | null,
        type?: HNBankAccountType | null,
        routingNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      integratorInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      integratorInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      integratorACHTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      externalACHTransfers?:  {
        __typename: string,
      } | null,
      originatedAchTransfers: ( {
          __typename: "HNOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      nonOriginatedAchTransfers: ( {
          __typename: "HNNonOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnAddExternalBankAccountVerifiedThroughFinicityMutationVariables = {
  input: HNAddExternalBankAccountVerifiedThroughFinicityInput,
};

export type HnAddExternalBankAccountVerifiedThroughFinicityMutation = {
  hnAddExternalBankAccountVerifiedThroughFinicity: ( {
      __typename: "HNExternalFinancialBankAccount",
      id: string,
      ledgers?:  Array< {
        __typename: string,
        id: string,
        name?: HNLedgerName | null,
        description?: string | null,
        normalBalance?: HNNormalBalance | null,
        asOf?: string | null,
      } > | null,
      owner: ( {
          __typename: "HNOrganization",
          id: string,
        } | {
          __typename: "HNPaymentCard",
          id: string,
          externalId?: string | null,
          bin?: string | null,
          last4?: string | null,
          expirationDate?: string | null,
          expirationMonth?: string | null,
          expirationYear?: string | null,
          network?: HNPaymentCardNetwork | null,
          status?: HNPaymentCardStatus | null,
          formFactor?: HNCardFormFactor | null,
          suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
        } | {
          __typename: "HNUSPersonAccountHolder",
          id: string,
          email?: string | null,
          dateOfBirth?: string | null,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNUSBusinessAccountHolder",
          id: string,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      name?: string | null,
      provider?: HNBankVerificationProvider | null,
      accountStatus?: string | null,
      features:  Array<( {
          __typename: "HNDirectDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNDebitPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNIncomeAccountFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNJustInTimeFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNOnDemandFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
          sourceFinancialAccountId?: string | null,
          pseudoBalanceEnabled?: boolean | null,
        } | {
          __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNFleetCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCommercialCreditPayInFullCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCardFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPointRewardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNonVerifiedFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNAchCapableFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNVendorProvidedBankFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPartialFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNRepaymentFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPreprintedCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNMerchantSettlementFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        }
      ) > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      externalBankAccountDetails?:  {
        __typename: string,
        id: string,
        last4?: string | null,
        type?: HNBankAccountType | null,
        routingNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      integratorInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      integratorInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      integratorACHTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      externalACHTransfers?:  {
        __typename: string,
      } | null,
      originatedAchTransfers: ( {
          __typename: "HNOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      nonOriginatedAchTransfers: ( {
          __typename: "HNNonOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateOneTimeACHTransferMutationVariables = {
  input: HNCreateOneTimeACHTransferInput,
};

export type HnCreateOneTimeACHTransferMutation = {
  hnCreateOneTimeACHTransfer: ( {
      __typename: "HNOneTimeACHTransfer",
      id: string,
      fromFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      toFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      descriptor?:  {
        __typename: string,
        companyEntryDescription?: string | null,
        individualName?: string | null,
        individualIdentificationNumber?: string | null,
      } | null,
      transferAmount: ( {
          __typename: "HNTransferAmountCalculation",
          calculatedType?: HNCalculatedTransferAmountType | null,
        } | {
          __typename: "HNManualTransferAmount",
        }
      ) | null,
      status?: HNScheduledTransferStatusCode | null,
      scheduledTransferDate?: string | null,
      transferEvents?:  {
        __typename: string,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCancelScheduledTransferMutationVariables = {
  input: HNCancelScheduledTransferInput,
};

export type HnCancelScheduledTransferMutation = {
  hnCancelScheduledTransfer: ( {
      __typename: "HNRecurringACHTransfer",
      id: string,
      fromFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      toFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      descriptor?:  {
        __typename: string,
        companyEntryDescription?: string | null,
        individualName?: string | null,
        individualIdentificationNumber?: string | null,
      } | null,
      transferAmount: ( {
          __typename: "HNTransferAmountCalculation",
          calculatedType?: HNCalculatedTransferAmountType | null,
        } | {
          __typename: "HNManualTransferAmount",
        }
      ) | null,
      frequency?: HNRecurringAchTransferFrequencyCode | null,
      balanceAmountType?: HNTransferBalanceAmountCode | null,
      status?: HNScheduledTransferStatusCode | null,
      nextScheduledTransferDate?: string | null,
      transferEvents?:  {
        __typename: string,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNOneTimeACHTransfer",
      id: string,
      fromFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      toFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      descriptor?:  {
        __typename: string,
        companyEntryDescription?: string | null,
        individualName?: string | null,
        individualIdentificationNumber?: string | null,
      } | null,
      transferAmount: ( {
          __typename: "HNTransferAmountCalculation",
          calculatedType?: HNCalculatedTransferAmountType | null,
        } | {
          __typename: "HNManualTransferAmount",
        }
      ) | null,
      status?: HNScheduledTransferStatusCode | null,
      scheduledTransferDate?: string | null,
      transferEvents?:  {
        __typename: string,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateRecurringACHTransferMutationVariables = {
  input: HNCreateRecurringACHTransferInput,
};

export type HnCreateRecurringACHTransferMutation = {
  hnCreateRecurringACHTransfer: ( {
      __typename: "HNRecurringACHTransfer",
      id: string,
      fromFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      toFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      descriptor?:  {
        __typename: string,
        companyEntryDescription?: string | null,
        individualName?: string | null,
        individualIdentificationNumber?: string | null,
      } | null,
      transferAmount: ( {
          __typename: "HNTransferAmountCalculation",
          calculatedType?: HNCalculatedTransferAmountType | null,
        } | {
          __typename: "HNManualTransferAmount",
        }
      ) | null,
      frequency?: HNRecurringAchTransferFrequencyCode | null,
      balanceAmountType?: HNTransferBalanceAmountCode | null,
      status?: HNScheduledTransferStatusCode | null,
      nextScheduledTransferDate?: string | null,
      transferEvents?:  {
        __typename: string,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnInitiateFundsDepositACHTransferMutationVariables = {
  input: HNInitiateFundsDepositACHTransferInput,
};

export type HnInitiateFundsDepositACHTransferMutation = {
  hnInitiateFundsDepositACHTransfer: ( {
      __typename: "HNIntegratorInitiatedFundsDepositACHTransfer",
      id: string,
      amount?:  {
        __typename: string,
        value?: number | null,
        currencyCode?: string | null,
        decimalPlaces?: number | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      ledgers?:  Array< {
        __typename: string,
        id: string,
        name?: HNLedgerName | null,
        description?: string | null,
        normalBalance?: HNNormalBalance | null,
        asOf?: string | null,
      } > | null,
      status: ( {
          __typename: "HNNonFailureIntegratorInitiatedACHStatus",
          status?: HNIntegratorInitiatedACHStatus | null,
        } | {
          __typename: "HNFailureIntegratorInitiatedACHStatus",
          status?: HNIntegratorInitiatedACHStatus | null,
          statusReasonCode?: HNIntegratorInitiatedACHStatusReasonCode | null,
        }
      ) | null,
      fromFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      toFinancialAccount: ( {
          __typename: "HNFinancialAccount",
          id: string,
          externalId?: string | null,
          name?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
          accountStatus?: string | null,
          accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
          partnerBankName?: HNPartnerBankName | null,
        } | {
          __typename: "HNExternalFinancialBankAccount",
          id: string,
          name?: string | null,
          provider?: HNBankVerificationProvider | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNNonVerifiedExternalUSFinancialBankAccount",
          id: string,
          name?: string | null,
          accountStatus?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      companyName?: string | null,
      descriptor?:  {
        __typename: string,
        companyEntryDescription?: string | null,
        individualName?: string | null,
        individualIdentificationNumber?: string | null,
      } | null,
      companyIdentifier?: string | null,
      settlementDate?: string | null,
      fundsAvailableDate?: string | null,
      sameDay?: boolean | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      paymentRelatedInformation?: string | null,
      returnDate?: string | null,
      traceNumber?: string | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnActivatePaymentCardMutationVariables = {
  input: HNActivatePaymentCardInput,
};

export type HnActivatePaymentCardMutation = {
  hnActivatePaymentCard: ( {
      __typename: "HNPaymentCard",
      id: string,
      externalId?: string | null,
      bin?: string | null,
      last4?: string | null,
      expirationDate?: string | null,
      expirationMonth?: string | null,
      expirationYear?: string | null,
      network?: HNPaymentCardNetwork | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      cardProductApplication: ( {
          __typename: "HNAccountHolderCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNAuthorizedUserCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      application?:  {
        __typename: string,
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      status?: HNPaymentCardStatus | null,
      formFactor?: HNCardFormFactor | null,
      originalPaymentCard?:  {
        __typename: string,
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | null,
      restrictedDetails: ( {
          __typename: "HNPaymentCardRestrictedDetails",
          number?: string | null,
          cvv?: string | null,
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      atmLocations: ( {
          __typename: "HNATMLocations",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        } | {
          __typename: "HNUserError",
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
      financialAccounts?:  Array< {
        __typename: string,
        id: string,
        externalId?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
        accountStatus?: string | null,
        accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
        partnerBankName?: HNPartnerBankName | null,
      } > | null,
      physicalPaymentCardOrders?:  Array< {
        __typename: string,
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null > | null,
      attachedSpendRules?:  {
        __typename: string,
      } | null,
      cardDigitalWalletTokens?:  {
        __typename: string,
      } | null,
      velocityRuleBalances?:  Array< {
        __typename: string,
      } | null > | null,
      velocitySpendRuleBalances:  Array<( {
          __typename: "HNVelocitySpendRuleAmountBalance",
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        } | {
          __typename: "HNVelocitySpendRuleCountBalance",
          currentCountBalance?: number | null,
          remainingCountBalance?: number | null,
          computedCurrentCountBalance?: number | null,
          computedRemainingCountBalance?: number | null,
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        }
      ) | null > | null,
      attachedVelocityRules?:  {
        __typename: string,
      } | null,
      paymentCardHolderDetails?:  {
        __typename: string,
      } | null,
      customFields:  Array<( {
          __typename: "HNCustomStringField",
          key: string,
          value: string,
        }
      ) > | null,
      revisionSnapshots?:  {
        __typename: string,
      } | null,
      cardProfileSet?:  {
        __typename: string,
        id: string,
        status?: HNCardProfileSetStatus | null,
        name?: string | null,
        intent?: HNCardProfileSetIntent | null,
        network?: HNCardProfileSetNetwork | null,
        preferredConfiguration?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        description?: string | null,
      } | null,
      pinDetails?:  {
        __typename: string,
        isSet?: boolean | null,
      } | null,
      suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateAccountHolderCardProductApplicationMutationVariables = {
  input: HNCreateAccountHolderCardProductApplicationInput,
};

export type HnCreateAccountHolderCardProductApplicationMutation = {
  hnCreateAccountHolderCardProductApplication: ( {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationState?:  {
        __typename: string,
        status: HNAccountHolderApplicationStatusCode,
      } | null,
      adverseActionReasons?:  Array< {
        __typename: string,
        code?: HNAdverseActionCode | null,
        description?: string | null,
      } > | null,
      applicationDenialReason?: HNApplicationDenialReason | null,
      accountHolderSnapshot: ( {
          __typename: "HNUSPersonAccountHolderSnapshot",
          email?: string | null,
          dateOfBirth?: string | null,
        } | {
          __typename: "HNUSBusinessAccountHolderSnapshot",
        }
      ) | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      applicationHistory?:  {
        __typename: string,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      financialAccounts?:  {
        __typename: string,
      } | null,
      offers?:  {
        __typename: string,
      } | null,
      creditReportFraudAlertVerificationResult?:  {
        __typename: string,
        accountHolderInitiatedApplication: boolean,
        name: boolean,
        dateOfBirth: boolean,
        address: boolean,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnStartDocumentUploadSessionMutationVariables = {
  input: HNStartDocumentUploadSessionInput,
};

export type HnStartDocumentUploadSessionMutation = {
  hnStartDocumentUploadSession: ( {
      __typename: "HNUSAccountHolderApplicationDocumentUploadSession",
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      primaryDocumentTypes?: Array< HNDocumentType > | null,
      secondaryDocumentTypes?: Array< HNDocumentType > | null,
      supportingDocumentTypes?: Array< HNDocumentType > | null,
      uploadRequirements?:  Array< {
        __typename: string,
      } > | null,
      uploadLinks:  Array<( {
          __typename: "HNDocumentUploadLink",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          documentCategoryType?: HNDocumentCategoryType | null,
        } | {
          __typename: "HNCardArtDocument",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          downloadUrl?: string | null,
        }
      ) | null > | null,
      recommendedDocumentTypes?: Array< HNDocumentType > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNCardProfileDocumentUploadSession",
      cardArtDocuments?:  Array< {
        __typename: string,
        createdAt?: string | null,
        documentType?: HNDocumentType | null,
        id: string,
        status?: HNDocumentUploadLinkStatusCode | null,
        updatedAt?: string | null,
        uploadUrl?: string | null,
        downloadUrl?: string | null,
      } > | null,
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      updatedAt?: string | null,
      createdAt?: string | null,
      expiration?: string | null,
      cardProduct:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      },
      allowedDocumentTypes?: Array< HNCardArtDocumentType > | null,
    } | {
      __typename: "HNIdentityVerificationDocumentUploadSession",
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      expiresAt?: string | null,
      requestedDocuments?: Array< HNDocumentType > | null,
      uploadLinks:  Array<( {
          __typename: "HNDocumentUploadLink",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          documentCategoryType?: HNDocumentCategoryType | null,
        } | {
          __typename: "HNCardArtDocument",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          downloadUrl?: string | null,
        }
      ) | null > | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateDocumentUploadLinkMutationVariables = {
  input: HNCreateDocumentUploadLinkInput,
};

export type HnCreateDocumentUploadLinkMutation = {
  hnCreateDocumentUploadLink: ( {
      __typename: "HNDocumentUploadLink",
      id: string,
      documentUploadSession: ( {
          __typename: "HNIdentityVerificationDocumentUploadSession",
          id: string,
          status?: HNDocumentUploadSessionStatusCode | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          expiresAt?: string | null,
          requestedDocuments?: Array< HNDocumentType > | null,
        } | {
          __typename: "HNUSAccountHolderApplicationDocumentUploadSession",
          id: string,
          status?: HNDocumentUploadSessionStatusCode | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          primaryDocumentTypes?: Array< HNDocumentType > | null,
          secondaryDocumentTypes?: Array< HNDocumentType > | null,
          supportingDocumentTypes?: Array< HNDocumentType > | null,
          recommendedDocumentTypes?: Array< HNDocumentType > | null,
        } | {
          __typename: "HNCardProfileDocumentUploadSession",
          id: string,
          status?: HNDocumentUploadSessionStatusCode | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          expiration?: string | null,
          allowedDocumentTypes?: Array< HNCardArtDocumentType > | null,
        }
      ) | null,
      documentType?: HNDocumentType | null,
      status?: HNDocumentUploadLinkStatusCode | null,
      documentCategoryType?: HNDocumentCategoryType | null,
      uploadUrl?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNCardArtDocument",
      createdAt?: string | null,
      documentType?: HNDocumentType | null,
      documentUploadSession?:  {
        __typename: string,
        id: string,
        status?: HNDocumentUploadSessionStatusCode | null,
        updatedAt?: string | null,
        createdAt?: string | null,
        expiration?: string | null,
        allowedDocumentTypes?: Array< HNCardArtDocumentType > | null,
      } | null,
      id: string,
      status?: HNDocumentUploadLinkStatusCode | null,
      updatedAt?: string | null,
      uploadUrl?: string | null,
      downloadUrl?: string | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnEndDocumentUploadSessionMutationVariables = {
  input: HNEndDocumentUploadSessionInput,
};

export type HnEndDocumentUploadSessionMutation = {
  hnEndDocumentUploadSession: ( {
      __typename: "HNUSAccountHolderApplicationDocumentUploadSession",
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      primaryDocumentTypes?: Array< HNDocumentType > | null,
      secondaryDocumentTypes?: Array< HNDocumentType > | null,
      supportingDocumentTypes?: Array< HNDocumentType > | null,
      uploadRequirements?:  Array< {
        __typename: string,
      } > | null,
      uploadLinks:  Array<( {
          __typename: "HNDocumentUploadLink",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          documentCategoryType?: HNDocumentCategoryType | null,
        } | {
          __typename: "HNCardArtDocument",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          downloadUrl?: string | null,
        }
      ) | null > | null,
      recommendedDocumentTypes?: Array< HNDocumentType > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | {
      __typename: "HNCardProfileDocumentUploadSession",
      cardArtDocuments?:  Array< {
        __typename: string,
        createdAt?: string | null,
        documentType?: HNDocumentType | null,
        id: string,
        status?: HNDocumentUploadLinkStatusCode | null,
        updatedAt?: string | null,
        uploadUrl?: string | null,
        downloadUrl?: string | null,
      } > | null,
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      updatedAt?: string | null,
      createdAt?: string | null,
      expiration?: string | null,
      cardProduct:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      },
      allowedDocumentTypes?: Array< HNCardArtDocumentType > | null,
    } | {
      __typename: "HNIdentityVerificationDocumentUploadSession",
      id: string,
      status?: HNDocumentUploadSessionStatusCode | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      expiresAt?: string | null,
      requestedDocuments?: Array< HNDocumentType > | null,
      uploadLinks:  Array<( {
          __typename: "HNDocumentUploadLink",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          documentCategoryType?: HNDocumentCategoryType | null,
        } | {
          __typename: "HNCardArtDocument",
          id: string,
          status?: HNDocumentUploadLinkStatusCode | null,
          uploadUrl?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          documentType?: HNDocumentType | null,
          downloadUrl?: string | null,
        }
      ) | null > | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type PlaidLinkTokenCreateMutationVariables = {
  userId: string,
  redirectUri: string,
  stepUpGrant?: string | null,
};

export type PlaidLinkTokenCreateMutation = {
  // Create a Plaid Link token. `stepUpGrant` is the short-lived signed token from
  // verifyBankLinkStepUp (SEE-221); the resolver requires it for single-factor
  // sessions and rejects the call without a valid one.
  plaidLinkTokenCreate?:  {
    __typename: "PlaidLinkToken",
    link_token: string,
    expiration: string,
    request_id: string,
  } | null,
};

export type PlaidLinkTokenExchangeMutationVariables = {
  publicToken: string,
  accountId: string,
  accountType: string,
};

export type PlaidLinkTokenExchangeMutation = {
  // Exchange public_token for processor_token (used for instantly verified accounts).
  // accountType must be 'checking' or 'savings' - Highnote only supports these types.
  plaidLinkTokenExchange?:  {
    __typename: "PlaidProcessorToken",
    processor_token: string,
    request_id: string,
  } | null,
};

export type PlaidExchangeForAccessTokenMutationVariables = {
  publicToken: string,
};

export type PlaidExchangeForAccessTokenMutation = {
  // Exchange public_token for access_token only (used for micro-deposit pending accounts).
  // Does NOT create a processor_token - that happens after verification.
  plaidExchangeForAccessToken?:  {
    __typename: "PlaidAccessToken",
    access_token: string,
    item_id: string,
    request_id: string,
  } | null,
};

export type LinkPlaidBankAccountMutationVariables = {
  input: LinkPlaidBankAccountInput,
};

export type LinkPlaidBankAccountMutation = {
  // Link a bank account via Plaid securely.
  // Exchanges public_token, stores access_token server-side, and returns only safe data.
  linkPlaidBankAccount?:  {
    __typename: "PlaidLinkedBankAccountSafe",
    id: string,
    paidolId: string,
    plaidAccountId: string,
    plaidItemId: string,
    highnoteAccountId?: string | null,
    accountName: string,
    accountMask: string,
    accountType: string,
    verificationMethod: string,
    status: string,
    linkedAt: string,
    verifiedAt?: string | null,
    closedAt?: string | null,
    failureReason?: string | null,
  } | null,
};

export type UpdatePlaidLinkedBankAccountStatusMutationVariables = {
  id: string,
  status: string,
  highnoteAccountId?: string | null,
  failureReason?: string | null,
};

export type UpdatePlaidLinkedBankAccountStatusMutation = {
  // Update the status of a PlaidLinkedBankAccount.
  // Used after verification or to close an account.
  updatePlaidLinkedBankAccountStatus?:  {
    __typename: "PlaidLinkedBankAccountSafe",
    id: string,
    paidolId: string,
    plaidAccountId: string,
    plaidItemId: string,
    highnoteAccountId?: string | null,
    accountName: string,
    accountMask: string,
    accountType: string,
    verificationMethod: string,
    status: string,
    linkedAt: string,
    verifiedAt?: string | null,
    closedAt?: string | null,
    failureReason?: string | null,
  } | null,
};

export type CreateVerificationLinkTokenForAccountMutationVariables = {
  accountId: string,
  userId: string,
  stepUpGrant?: string | null,
};

export type CreateVerificationLinkTokenForAccountMutation = {
  // Create a verification link token for a pending micro-deposit account.
  // Uses the stored access_token server-side - never exposes it to frontend.
  createVerificationLinkTokenForAccount?:  {
    __typename: "PlaidLinkToken",
    link_token: string,
    expiration: string,
    request_id: string,
  } | null,
};

export type CompleteVerificationAndCreateProcessorTokenMutationVariables = {
  accountId: string,
  highnoteAccountId?: string | null,
};

export type CompleteVerificationAndCreateProcessorTokenMutation = {
  // Complete verification and create processor token for a pending account.
  // Returns the processor_token needed for Highnote, but keeps access_token server-side.
  completeVerificationAndCreateProcessorToken?:  {
    __typename: "VerificationCompleteResponse",
    processorToken: string,
    accountId: string,
  } | null,
};

export type HnCreateMerchantCategorySpendRuleMutationVariables = {
  input: HNCreateMerchantCategorySpendRuleInput,
};

export type HnCreateMerchantCategorySpendRuleMutation = {
  hnCreateMerchantCategorySpendRule: ( {
      __typename: "HNMerchantCategorySpendRule",
      id: string,
      name?: string | null,
      allowed?: Array< string > | null,
      blocked?: Array< string > | null,
      allowedMcc?: Array< string > | null,
      blockedMcc?: Array< string > | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateMerchantCountrySpendRuleMutationVariables = {
  input: HNCreateMerchantCountrySpendRuleInput,
};

export type HnCreateMerchantCountrySpendRuleMutation = {
  hnCreateMerchantCountrySpendRule: ( {
      __typename: "HNMerchantCountrySpendRule",
      id: string,
      name?: string | null,
      allowed?: Array< string > | null,
      blocked?: Array< string > | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnUpdateMerchantCategorySpendRuleMutationVariables = {
  input: HNUpdateMerchantCategorySpendRuleInput,
};

export type HnUpdateMerchantCategorySpendRuleMutation = {
  hnUpdateMerchantCategorySpendRule: ( {
      __typename: "HNMerchantCategorySpendRule",
      id: string,
      name?: string | null,
      allowed?: Array< string > | null,
      blocked?: Array< string > | null,
      allowedMcc?: Array< string > | null,
      blockedMcc?: Array< string > | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnUpdateMerchantCountrySpendRuleMutationVariables = {
  input: HNUpdateMerchantCountrySpendRuleInput,
};

export type HnUpdateMerchantCountrySpendRuleMutation = {
  hnUpdateMerchantCountrySpendRule: ( {
      __typename: "HNMerchantCountrySpendRule",
      id: string,
      name?: string | null,
      allowed?: Array< string > | null,
      blocked?: Array< string > | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnCreateAmountLimitSpendRuleMutationVariables = {
  input: HNCreateAmountLimitSpendRuleInput,
};

export type HnCreateAmountLimitSpendRuleMutation = {
  hnCreateAmountLimitSpendRule: ( {
      __typename: "HNAmountLimitSpendRule",
      id: string,
      name?: string | null,
      maximumAmount?:  {
        __typename: string,
        value?: number | null,
        currencyCode?: string | null,
        decimalPlaces?: number | null,
      } | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnSuspendPaymentCardMutationVariables = {
  input: HNSuspendPaymentCardInput,
};

export type HnSuspendPaymentCardMutation = {
  hnSuspendPaymentCard: ( {
      __typename: "HNPaymentCard",
      id: string,
      externalId?: string | null,
      bin?: string | null,
      last4?: string | null,
      expirationDate?: string | null,
      expirationMonth?: string | null,
      expirationYear?: string | null,
      network?: HNPaymentCardNetwork | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      cardProductApplication: ( {
          __typename: "HNAccountHolderCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNAuthorizedUserCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      application?:  {
        __typename: string,
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      status?: HNPaymentCardStatus | null,
      formFactor?: HNCardFormFactor | null,
      originalPaymentCard?:  {
        __typename: string,
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | null,
      restrictedDetails: ( {
          __typename: "HNPaymentCardRestrictedDetails",
          number?: string | null,
          cvv?: string | null,
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      atmLocations: ( {
          __typename: "HNATMLocations",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        } | {
          __typename: "HNUserError",
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
      financialAccounts?:  Array< {
        __typename: string,
        id: string,
        externalId?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
        accountStatus?: string | null,
        accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
        partnerBankName?: HNPartnerBankName | null,
      } > | null,
      physicalPaymentCardOrders?:  Array< {
        __typename: string,
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null > | null,
      attachedSpendRules?:  {
        __typename: string,
      } | null,
      cardDigitalWalletTokens?:  {
        __typename: string,
      } | null,
      velocityRuleBalances?:  Array< {
        __typename: string,
      } | null > | null,
      velocitySpendRuleBalances:  Array<( {
          __typename: "HNVelocitySpendRuleAmountBalance",
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        } | {
          __typename: "HNVelocitySpendRuleCountBalance",
          currentCountBalance?: number | null,
          remainingCountBalance?: number | null,
          computedCurrentCountBalance?: number | null,
          computedRemainingCountBalance?: number | null,
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        }
      ) | null > | null,
      attachedVelocityRules?:  {
        __typename: string,
      } | null,
      paymentCardHolderDetails?:  {
        __typename: string,
      } | null,
      customFields:  Array<( {
          __typename: "HNCustomStringField",
          key: string,
          value: string,
        }
      ) > | null,
      revisionSnapshots?:  {
        __typename: string,
      } | null,
      cardProfileSet?:  {
        __typename: string,
        id: string,
        status?: HNCardProfileSetStatus | null,
        name?: string | null,
        intent?: HNCardProfileSetIntent | null,
        network?: HNCardProfileSetNetwork | null,
        preferredConfiguration?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        description?: string | null,
      } | null,
      pinDetails?:  {
        __typename: string,
        isSet?: boolean | null,
      } | null,
      suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnClosePaymentCardMutationVariables = {
  input: HNClosePaymentCardInput,
};

export type HnClosePaymentCardMutation = {
  hnClosePaymentCard: ( {
      __typename: "HNPaymentCard",
      id: string,
      externalId?: string | null,
      bin?: string | null,
      last4?: string | null,
      expirationDate?: string | null,
      expirationMonth?: string | null,
      expirationYear?: string | null,
      network?: HNPaymentCardNetwork | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      cardProductApplication: ( {
          __typename: "HNAccountHolderCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNAuthorizedUserCardProductApplication",
          id: string,
          applicationDenialReason?: HNApplicationDenialReason | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      application?:  {
        __typename: string,
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      status?: HNPaymentCardStatus | null,
      formFactor?: HNCardFormFactor | null,
      originalPaymentCard?:  {
        __typename: string,
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | null,
      restrictedDetails: ( {
          __typename: "HNPaymentCardRestrictedDetails",
          number?: string | null,
          cvv?: string | null,
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      atmLocations: ( {
          __typename: "HNATMLocations",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        } | {
          __typename: "HNUserError",
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
      financialAccounts?:  Array< {
        __typename: string,
        id: string,
        externalId?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
        accountStatus?: string | null,
        accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
        partnerBankName?: HNPartnerBankName | null,
      } > | null,
      physicalPaymentCardOrders?:  Array< {
        __typename: string,
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null > | null,
      attachedSpendRules?:  {
        __typename: string,
      } | null,
      cardDigitalWalletTokens?:  {
        __typename: string,
      } | null,
      velocityRuleBalances?:  Array< {
        __typename: string,
      } | null > | null,
      velocitySpendRuleBalances:  Array<( {
          __typename: "HNVelocitySpendRuleAmountBalance",
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        } | {
          __typename: "HNVelocitySpendRuleCountBalance",
          currentCountBalance?: number | null,
          remainingCountBalance?: number | null,
          computedCurrentCountBalance?: number | null,
          computedRemainingCountBalance?: number | null,
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        }
      ) | null > | null,
      attachedVelocityRules?:  {
        __typename: string,
      } | null,
      paymentCardHolderDetails?:  {
        __typename: string,
      } | null,
      customFields:  Array<( {
          __typename: "HNCustomStringField",
          key: string,
          value: string,
        }
      ) > | null,
      revisionSnapshots?:  {
        __typename: string,
      } | null,
      cardProfileSet?:  {
        __typename: string,
        id: string,
        status?: HNCardProfileSetStatus | null,
        name?: string | null,
        intent?: HNCardProfileSetIntent | null,
        network?: HNCardProfileSetNetwork | null,
        preferredConfiguration?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        description?: string | null,
      } | null,
      pinDetails?:  {
        __typename: string,
        isSet?: boolean | null,
      } | null,
      suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnGenerateDirectDepositDetailClientTokenMutationVariables = {
  input: HNGenerateDirectDepositDetailClientTokenInput,
};

export type HnGenerateDirectDepositDetailClientTokenMutation = {
  hnGenerateDirectDepositDetailClientToken: ( {
      __typename: "HNClientToken",
      value: string,
      expirationDate?: string | null,
      usage?: HNClientTokenUsage | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type IssuePaymentCardMutationVariables = {
  input: IssuePaymentCard,
};

export type IssuePaymentCardMutation = {
  issuePaymentCard?:  {
    __typename: "IssuePaymentCardResponse",
    statusCode?: number | null,
    errorMessage?: string | null,
    errorType?: string | null,
    paymentCardId?: string | null,
  } | null,
};

export type HnCloseExternalFinancialBankAccountMutationVariables = {
  input: HNCloseExternalFinancialBankAccountInput,
};

export type HnCloseExternalFinancialBankAccountMutation = {
  hnCloseExternalFinancialBankAccount: ( {
      __typename: "HNExternalFinancialBankAccount",
      id: string,
      ledgers?:  Array< {
        __typename: string,
        id: string,
        name?: HNLedgerName | null,
        description?: string | null,
        normalBalance?: HNNormalBalance | null,
        asOf?: string | null,
      } > | null,
      owner: ( {
          __typename: "HNOrganization",
          id: string,
        } | {
          __typename: "HNPaymentCard",
          id: string,
          externalId?: string | null,
          bin?: string | null,
          last4?: string | null,
          expirationDate?: string | null,
          expirationMonth?: string | null,
          expirationYear?: string | null,
          network?: HNPaymentCardNetwork | null,
          status?: HNPaymentCardStatus | null,
          formFactor?: HNCardFormFactor | null,
          suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
        } | {
          __typename: "HNUSPersonAccountHolder",
          id: string,
          email?: string | null,
          dateOfBirth?: string | null,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNUSBusinessAccountHolder",
          id: string,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      name?: string | null,
      provider?: HNBankVerificationProvider | null,
      accountStatus?: string | null,
      features:  Array<( {
          __typename: "HNDirectDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNDebitPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNIncomeAccountFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNJustInTimeFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNOnDemandFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
          sourceFinancialAccountId?: string | null,
          pseudoBalanceEnabled?: boolean | null,
        } | {
          __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNFleetCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCommercialCreditPayInFullCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCardFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPointRewardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNonVerifiedFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNAchCapableFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNVendorProvidedBankFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPartialFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNRepaymentFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPreprintedCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNMerchantSettlementFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        }
      ) > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      externalBankAccountDetails?:  {
        __typename: string,
        id: string,
        last4?: string | null,
        type?: HNBankAccountType | null,
        routingNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      integratorInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      integratorInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      integratorACHTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      externalACHTransfers?:  {
        __typename: string,
      } | null,
      originatedAchTransfers: ( {
          __typename: "HNOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      nonOriginatedAchTransfers: ( {
          __typename: "HNNonOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type HnIssueFinancialAccountForApplicationMutationVariables = {
  input: HNIssueFinancialAccountForApplicationInput,
};

export type HnIssueFinancialAccountForApplicationMutation = {
  hnIssueFinancialAccountForApplication: ( {
      __typename: "HNFinancialAccount",
      paymentCardTransactionChargebacks?:  {
        __typename: string,
      } | null,
      globalNotes: ( {
          __typename: "HNGlobalNoteConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      accountReviewHistory: ( {
          __typename: "HNAccountReviewConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      id: string,
      externalId?: string | null,
      ledgers?:  Array< {
        __typename: string,
        id: string,
        name?: HNLedgerName | null,
        description?: string | null,
        normalBalance?: HNNormalBalance | null,
        asOf?: string | null,
      } > | null,
      owner: ( {
          __typename: "HNOrganization",
          id: string,
        } | {
          __typename: "HNPaymentCard",
          id: string,
          externalId?: string | null,
          bin?: string | null,
          last4?: string | null,
          expirationDate?: string | null,
          expirationMonth?: string | null,
          expirationYear?: string | null,
          network?: HNPaymentCardNetwork | null,
          status?: HNPaymentCardStatus | null,
          formFactor?: HNCardFormFactor | null,
          suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
        } | {
          __typename: "HNUSPersonAccountHolder",
          id: string,
          email?: string | null,
          dateOfBirth?: string | null,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNUSBusinessAccountHolder",
          id: string,
          externalId?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      name?: string | null,
      cardProduct?:  {
        __typename: string,
        id: string,
        name?: string | null,
        usage?: HNCardUsage | null,
        vertical?: HNCardProductVertical | null,
        commercial?: boolean | null,
        sourceTemplateId?: string | null,
      } | null,
      application?:  {
        __typename: string,
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      features:  Array<( {
          __typename: "HNDirectDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNDebitPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductReserveFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNIncomeAccountFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNJustInTimeFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNOnDemandFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
          sourceFinancialAccountId?: string | null,
          pseudoBalanceEnabled?: boolean | null,
        } | {
          __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNFleetCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCommercialCreditPayInFullCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCreditCardAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNCardFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPointRewardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNNonVerifiedFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNAchCapableFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNVendorProvidedBankFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPartialFundingFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNRepaymentFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNPreprintedCardFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNProductSecuredDepositFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        } | {
          __typename: "HNMerchantSettlementFinancialAccountFeature",
          enabled?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          effectiveFrom?: string | null,
          effectiveThrough?: string | null,
        }
      ) > | null,
      directDepositDetails?:  {
        __typename: string,
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      activeBillingCycleConfiguration?:  {
        __typename: string,
        id: string,
        paymentDueDayOfMonth?: number | null,
        billingCycleStartDayOfMonth?: number | null,
        billingCycleEndDayOfMonth?: number | null,
        from?: string | null,
        through?: string | null,
      } | null,
      statementSnapshot: ( {
          __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNCreditPayInFullCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNConsumerChargeCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNConsumerRevolvingCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNCommercialChargeCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNCommercialRevolvingCardFinancialAccountStatementSnapshot",
          asOf?: string | null,
          updatedAt?: string | null,
        }
      ) | null,
      statements?:  {
        __typename: string,
      } | null,
      financialAccountActivities?:  {
        __typename: string,
      } | null,
      integratorInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      integratorInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      integratorACHTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedAchTransfers?:  {
        __typename: string,
      } | null,
      externallyInitiatedACHTransfer?:  {
        __typename: string,
      } | null,
      externalACHTransfers?:  {
        __typename: string,
      } | null,
      originatedAchTransfers: ( {
          __typename: "HNOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      nonOriginatedAchTransfers: ( {
          __typename: "HNNonOriginatedAchTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      incomingScheduledTransfers?:  {
        __typename: string,
      } | null,
      transactionEvents?:  {
        __typename: string,
      } | null,
      interFinancialAccountTransfers?:  {
        __typename: string,
      } | null,
      accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
      accountStatus?: string | null,
      accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
      financialAccountAttributesWithReason?:  Array< {
        __typename: string,
        attribute: HNFinancialAccountAttribute,
        reason?: HNFinancialAccountAttributeReason | null,
      } > | null,
      paymentCards?:  {
        __typename: string,
      } | null,
      velocityRuleBalances?:  Array< {
        __typename: string,
      } | null > | null,
      velocitySpendRuleBalances:  Array<( {
          __typename: "HNVelocitySpendRuleAmountBalance",
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        } | {
          __typename: "HNVelocitySpendRuleCountBalance",
          currentCountBalance?: number | null,
          remainingCountBalance?: number | null,
          computedCurrentCountBalance?: number | null,
          computedRemainingCountBalance?: number | null,
          asOfDate?: string | null,
          attachedLevel?: HNAttachedLevel | null,
        }
      ) | null > | null,
      partnerBankName?: HNPartnerBankName | null,
      delinquency: ( {
          __typename: "HNCreditPayInFullFinancialAccountDelinquency",
          delinquencyStartedOn?: string | null,
          totalDaysDelinquent?: number | null,
          numberOfCycles?: number | null,
        }
      ) | null,
      delinquencyState?:  {
        __typename: string,
        state?: HNFinancialAccountDelinquencyState | null,
        updatedAt?: string | null,
      } | null,
      billingCycleHistory?:  {
        __typename: string,
      } | null,
      creditConfiguration?:  {
        __typename: string,
      } | null,
      feeTransferEvents?:  {
        __typename: string,
      } | null,
      paymentCardTransactionDisputes: ( {
          __typename: "HNPaymentCardTransactionDisputeConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      customFields:  Array<( {
          __typename: "HNCustomStringField",
          key: string,
          value: string,
        }
      ) > | null,
      revisionSnapshots?:  {
        __typename: string,
      } | null,
      rewardPointsTransfers: ( {
          __typename: "HNRewardPointsTransferConnection",
        } | {
          __typename: "HNUserError",
        } | {
          __typename: "HNAccessDeniedError",
          message: string,
        }
      ) | null,
      attachedSpendRules?:  {
        __typename: string,
      } | null,
      attachedVelocityRules?:  {
        __typename: string,
      } | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type CreateDwollaFinicityConsentReceiptMutationVariables = {
  input: CreateFinicityConsentReceiptInput,
};

export type CreateDwollaFinicityConsentReceiptMutation = {
  createDwollaFinicityConsentReceipt?:  Array< {
    __typename: "CreateFinicityConsentReceiptPayload",
    receipt?:  {
      __typename: "FinicityConsentReceiptPayload",
      profile?: string | null,
      version?: string | null,
      receiptId?: string | null,
      receiptVersion?: string | null,
      customerId?: string | null,
      partnerId?: string | null,
    } | null,
    proof?:  {
      __typename: "FinicityConsentReceiptProof",
      signature?: string | null,
      keyId?: string | null,
      timestamp?: string | null,
    } | null,
  } > | null,
};

export type CreateHighnoteFinicityConsentReceiptMutationVariables = {
  input: CreateFinicityConsentReceiptInput,
};

export type CreateHighnoteFinicityConsentReceiptMutation = {
  createHighnoteFinicityConsentReceipt?:  Array< {
    __typename: "CreateFinicityConsentReceiptPayload",
    receipt?:  {
      __typename: "FinicityConsentReceiptPayload",
      profile?: string | null,
      version?: string | null,
      receiptId?: string | null,
      receiptVersion?: string | null,
      customerId?: string | null,
      partnerId?: string | null,
    } | null,
    proof?:  {
      __typename: "FinicityConsentReceiptProof",
      signature?: string | null,
      keyId?: string | null,
      timestamp?: string | null,
    } | null,
  } > | null,
};

export type CreateFinicityCustomerMutationVariables = {
  input: CreateFinicityCustomerInput,
};

export type CreateFinicityCustomerMutation = {
  createFinicityCustomer?:  {
    __typename: "CreateFinicityCustomerPayload",
    id?: string | null,
    username?: string | null,
  } | null,
};

export type DeleteFinicityFinancialAccountMutationVariables = {
  input: DeleteFinicityCustomerAccount,
};

export type DeleteFinicityFinancialAccountMutation = {
  deleteFinicityFinancialAccount?: boolean | null,
};

export type GetOrRefreshProcoreAccessTokenMutationVariables = {
  input: GetOrRefreshProcoreAccessTokenInput,
};

export type GetOrRefreshProcoreAccessTokenMutation = {
  getOrRefreshProcoreAccessToken?:  {
    __typename: "GetOrRefreshProcoreAccessTokenPayload",
    access_token: string,
    token_type: string,
    expires_in: number,
    refresh_token: string,
    created_at: number,
  } | null,
};

export type CreateOrUpdateProcoreDirectCostMutationVariables = {
  input: CreateOrUpdateProcoreDirectCostInput,
};

export type CreateOrUpdateProcoreDirectCostMutation = {
  createOrUpdateProcoreDirectCost?:  {
    __typename: "CreateOrUpdateProcoreDirectCostPayload",
    transactionId: string,
    directCostId: number,
    directCostLineItemId: number,
  } | null,
};

export type AgaveLinkTokenCreateMutationVariables = {
};

export type AgaveLinkTokenCreateMutation = {
  agaveLinkTokenCreate?:  {
    __typename: "AgaveLinkToken",
    link_token?: string | null,
  } | null,
};

export type AgaveLinkTokenExchangeMutationVariables = {
  input: AgaveAccountTokenInput,
};

export type AgaveLinkTokenExchangeMutation = {
  agaveLinkTokenExchange?:  {
    __typename: "AgaveAccountToken",
    account_token?: string | null,
    account_id?: string | null,
    connection?:  {
      __typename: "Connection",
      type?: string | null,
    } | null,
    created_at?: string | null,
    linked_company?:  {
      __typename: "LinkedCompany",
      id?: string | null,
      source_id?: string | null,
      name?: string | null,
    } | null,
    linked_user?:  {
      __typename: "LinkedUser",
      id?: string | null,
      source_id?: string | null,
      name?: string | null,
      email?: string | null,
    } | null,
    reference_id?: string | null,
    source_system?:  {
      __typename: "SourceSystem",
      name?: string | null,
      slug?: string | null,
    } | null,
    source_system_environment?:  {
      __typename: "SourceSystemEnvironment",
      name?: string | null,
      slug?: string | null,
    } | null,
    status?: string | null,
    supports_cross_account_uuid?: boolean | null,
    supports_cross_company_requests?: boolean | null,
  } | null,
};

export type AgaveCreateExpenseMutationVariables = {
  input: CreateAgaveExpenseInput,
};

export type AgaveCreateExpenseMutation = {
  agaveCreateExpense: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      attachments?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        name?: string | null,
        url?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      contract?:  {
        __typename: string,
        id?: string | null,
        type?: string | null,
      } | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      line_items?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        amount?: string | null,
        cost_code_id?: string | null,
        cost_type_id?: string | null,
        customer_id?: string | null,
        description?: string | null,
        discount_amount?: string | null,
        item_id?: string | null,
        ledger_account_id?: string | null,
        project_id?: string | null,
        quantity?: string | null,
        retention_amount?: string | null,
        status?: string | null,
        sub_job_id?: string | null,
        tax_amount?: string | null,
        tax_code_id?: string | null,
        type?: string | null,
        unit_cost?: string | null,
        unit_of_measure?: string | null,
        vendor_id?: string | null,
        wbs_id?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      source_data?:  {
        __typename: string,
        path?: string | null,
        content_type?: string | null,
        data?: string | null,
      } | null,
    }
  ) | null,
};

export type AgavePostJobCostMutationVariables = {
  input: AgavePostJobCostInput,
};

export type AgavePostJobCostMutation = {
  agavePostJobCost: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "AgaveJobCost",
      id: string,
      source_id?: string | null,
      accounting_date?: string | null,
      actual_amount?: string | null,
      actual_quantity?: string | null,
      actual_unit_cost?: string | null,
      actual_unit_of_measure?: string | null,
      attachments?: Array< string | null > | null,
      cost_code_id?: string | null,
      cost_type_id?: string | null,
      description?: string | null,
      ledger_account_id?: string | null,
      name?: string | null,
      number?: string | null,
      posted_date?: string | null,
      prime_contract_id?: string | null,
      project_id?: string | null,
      reference_id?: string | null,
      reference_type?: string | null,
      status?: string | null,
      sub_job_id?: string | null,
      transaction_date?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      wbs_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      source_data?: string | null,
    }
  ) | null,
};

export type AgaveAPInvoicesCreateExpenseMutationVariables = {
  input: AgaveAPInvoicesCreateExpenseInput,
};

export type AgaveAPInvoicesCreateExpenseMutation = {
  agaveAPInvoicesCreateExpense: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "AgaveAPInvoicesPayload",
      id?: string | null,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      attachments?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        name?: string | null,
        url?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      contract?:  {
        __typename: string,
        id?: string | null,
        type?: string | null,
      } | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      line_items?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        amount?: string | null,
        cost_code_id?: string | null,
        cost_type_id?: string | null,
        customer_id?: string | null,
        description?: string | null,
        discount_amount?: string | null,
        item_id?: string | null,
        ledger_account_id?: string | null,
        project_id?: string | null,
        quantity?: string | null,
        retention_amount?: string | null,
        status?: string | null,
        sub_job_id?: string | null,
        tax_amount?: string | null,
        tax_code_id?: string | null,
        type?: string | null,
        unit_cost?: string | null,
        unit_of_measure?: string | null,
        vendor_id?: string | null,
        wbs_id?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      source_data?:  {
        __typename: string,
        path?: string | null,
        content_type?: string | null,
        data?: string | null,
      } | null,
    }
  ) | null,
};

export type AgaveResolverMutationMutationVariables = {
  input: AgaveResolverMutationInput,
};

export type AgaveResolverMutationMutation = {
  agaveResolverMutation: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "AgaveResolverMutationResponse",
      status?: number | null,
      content_type?: string | null,
      body?: string | null,
      headers?:  {
        __typename: string,
        raw?: string | null,
      } | null,
    }
  ) | null,
};

export type StartSage300APInvoiceMutationVariables = {
  input: StartSage300APInvoiceInput,
};

export type StartSage300APInvoiceMutation = {
  startSage300APInvoice?:  {
    __typename: "StartSage300APInvoiceResponse",
    transactionId: string,
    status: Sage300APInvoiceStatus,
    error?: string | null,
  } | null,
};

export type StartSage300JobCostMutationVariables = {
  input: StartSage300JobCostInput,
};

export type StartSage300JobCostMutation = {
  startSage300JobCost?:  {
    __typename: "StartSage300JobCostResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type StartQBOPostingMutationVariables = {
  input: StartQBOPostingInput,
};

export type StartQBOPostingMutation = {
  startQBOPosting?:  {
    __typename: "StartQBOPostingResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type StartQBDPostingMutationVariables = {
  input: StartQBDPostingInput,
};

export type StartQBDPostingMutation = {
  startQBDPosting?:  {
    __typename: "StartQBDPostingResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type StartSageIntacctPostingMutationVariables = {
  input: StartSageIntacctPostingInput,
};

export type StartSageIntacctPostingMutation = {
  startSageIntacctPosting?:  {
    __typename: "StartSageIntacctPostingResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type StartVistaPostingMutationVariables = {
  input: StartVistaPostingInput,
};

export type StartVistaPostingMutation = {
  startVistaPosting?:  {
    __typename: "StartVistaPostingResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type StartAcumaticaPostingMutationVariables = {
  input: StartAcumaticaPostingInput,
};

export type StartAcumaticaPostingMutation = {
  startAcumaticaPosting?:  {
    __typename: "StartAcumaticaPostingResponse",
    transactionId: string,
    status: ERPPostingStatus,
    error?: string | null,
  } | null,
};

export type AgaveCreateCreditCardCreditMutationVariables = {
  input: AgaveResolverMutationInput,
};

export type AgaveCreateCreditCardCreditMutation = {
  agaveCreateCreditCardCredit: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      attachments?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        name?: string | null,
        url?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      contract?:  {
        __typename: string,
        id?: string | null,
        type?: string | null,
      } | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      line_items?:  Array< {
        __typename: string,
        id?: string | null,
        source_id?: string | null,
        amount?: string | null,
        cost_code_id?: string | null,
        cost_type_id?: string | null,
        customer_id?: string | null,
        description?: string | null,
        discount_amount?: string | null,
        item_id?: string | null,
        ledger_account_id?: string | null,
        project_id?: string | null,
        quantity?: string | null,
        retention_amount?: string | null,
        status?: string | null,
        sub_job_id?: string | null,
        tax_amount?: string | null,
        tax_code_id?: string | null,
        type?: string | null,
        unit_cost?: string | null,
        unit_of_measure?: string | null,
        vendor_id?: string | null,
        wbs_id?: string | null,
        source_create_time?: string | null,
        source_update_time?: string | null,
      } | null > | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      source_data?:  {
        __typename: string,
        path?: string | null,
        content_type?: string | null,
        data?: string | null,
      } | null,
    }
  ) | null,
};

export type AttachDirectCostReceiptMutationVariables = {
  input: AttachDirectCostReceiptInput,
};

export type AttachDirectCostReceiptMutation = {
  attachDirectCostReceipt?:  {
    __typename: "AttachDirectCostReceiptPayload",
    directCostId: number,
  } | null,
};

export type CreateReimbursementDirectCostMutationVariables = {
  input: CreateReimbursementDirectCostInput,
};

export type CreateReimbursementDirectCostMutation = {
  createReimbursementDirectCost?:  {
    __typename: "CreateReimbursementDirectCostPayload",
    reimbursementTransactionId: string,
    directCostId: number,
    directCostLineItemId: number,
  } | null,
};

export type CompleteFirstRunChecklistMutationVariables = {
  input: CompleteChecklistInput,
};

export type CompleteFirstRunChecklistMutation = {
  completeFirstRunChecklist?:  {
    __typename: "CompleteChecklistPayload",
    paidolId?: string | null,
  } | null,
};

export type CheckAndUpdateChecklistMutationVariables = {
  input: CompleteChecklistInput,
};

export type CheckAndUpdateChecklistMutation = {
  checkAndUpdateChecklist?:  {
    __typename: "CompleteChecklistPayload",
    paidolId?: string | null,
  } | null,
};

export type CompleteFirstRunBannerMutationVariables = {
  input: CompleteBannerInput,
};

export type CompleteFirstRunBannerMutation = {
  completeFirstRunBanner?:  {
    __typename: "CompleteBannerPayload",
    userId: string,
  } | null,
};

export type CheckAndUpdateBannerMutationVariables = {
  input: CompleteBannerInput,
};

export type CheckAndUpdateBannerMutation = {
  checkAndUpdateBanner?:  {
    __typename: "CompleteBannerPayload",
    userId: string,
  } | null,
};

export type AttachSpendRulesToGroupCardsMutationVariables = {
  input: AttachSpendRulesToGroupCardsInput,
};

export type AttachSpendRulesToGroupCardsMutation = {
  attachSpendRulesToGroupCards?:  {
    __typename: "AttachSpendRulesToGroupCardsPayload",
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type PostAgavePassThroughMutationVariables = {
  input: AgavePassThroughInput,
};

export type PostAgavePassThroughMutation = {
  postAgavePassThrough: ( {
      __typename: "AgaveError",
      message?: string | null,
    } | {
      __typename: "AgavePassThroughResponse",
      status: number,
      content_type: string,
      body?: string | null,
      headers?:  {
        __typename: string,
        raw?: string | null,
      } | null,
    }
  ),
};

export type RemoveCardGroupMutationVariables = {
  input: RemoveCardGroupInput,
};

export type RemoveCardGroupMutation = {
  removeCardGroup?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type HnCreateVelocityRuleMutationVariables = {
  input: HNCreateVelocityRuleInput,
};

export type HnCreateVelocityRuleMutation = {
  hnCreateVelocityRule: ( {
      __typename: "HNVelocityRule",
      id: string,
      name?: string | null,
      velocityRuleWindow?: HNVelocityRuleWindow | null,
      cumulativeRule: ( {
          __typename: "HNMerchantCategorySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
          allowedMcc?: Array< string > | null,
          blockedMcc?: Array< string > | null,
        } | {
          __typename: "HNCVVSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNStreetAddressSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNMerchantIdentifierSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNMerchantCountrySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNAmountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNCountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          maximumCount?: number | null,
        } | {
          __typename: "HNPointOfServiceCategorySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNPostalCodeVerificationSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNDepositAmountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNDepositProcessingNetworkSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNDepositCountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          maximumCount?: number | null,
        } | {
          __typename: "HNConditionalRuleSetSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allow?: boolean | null,
        } | {
          __typename: "HNCardTransactionProcessingTypeConditionSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNRestrictedAccountHolderSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNPanEntryModeSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNCardDataInputCapabilitySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        }
      ) | null,
      spendRules:  Array<( {
          __typename: "HNMerchantCategorySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
          allowedMcc?: Array< string > | null,
          blockedMcc?: Array< string > | null,
        } | {
          __typename: "HNCVVSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNStreetAddressSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNMerchantIdentifierSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNMerchantCountrySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNAmountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNCountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          maximumCount?: number | null,
        } | {
          __typename: "HNPointOfServiceCategorySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNPostalCodeVerificationSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNDepositAmountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | {
          __typename: "HNDepositProcessingNetworkSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNDepositCountLimitSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          maximumCount?: number | null,
        } | {
          __typename: "HNConditionalRuleSetSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allow?: boolean | null,
        } | {
          __typename: "HNCardTransactionProcessingTypeConditionSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNRestrictedAccountHolderSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNPanEntryModeSpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        } | {
          __typename: "HNCardDataInputCapabilitySpendRule",
          id: string,
          name?: string | null,
          version?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          allowed?: Array< string > | null,
          blocked?: Array< string > | null,
        }
      ) | null > | null,
      version?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      revisions?:  {
        __typename: string,
      } | null,
      velocityConstraintLevelOverride?: HNVelocityConstraintLevel | null,
    } | {
      __typename: "HNUserError",
      errors?:  Array< {
        __typename: string,
        path?: Array< string > | null,
        code?: string | null,
        description?: string | null,
        errorPath?: Array< string > | null,
      } > | null,
    } | {
      __typename: "HNAccessDeniedError",
      message: string,
    }
  ) | null,
};

export type PersistAgaveDataMutationVariables = {
  input: PersistAgaveDataInput,
};

export type PersistAgaveDataMutation = {
  persistAgaveData?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type AddMerchantSpendRuleMutationVariables = {
  input: AddMerchantSpendRuleInput,
};

export type AddMerchantSpendRuleMutation = {
  addMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2UpdateBudgetSpentMutationVariables = {
  input: V2UpdateBudget,
};

export type V2UpdateBudgetSpentMutation = {
  v2UpdateBudgetSpent?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type EditMerchantSpendRuleMutationVariables = {
  input: EditMerchantSpendRuleInput,
};

export type EditMerchantSpendRuleMutation = {
  editMerchantSpendRule: ( {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      maximumAmount?:  {
        __typename: string,
        value?: number | null,
        currencyCode?: string | null,
        decimalPlaces?: number | null,
      } | null,
      monthlyLimitAmount?:  {
        __typename: string,
        value?: number | null,
        currencyCode?: string | null,
        decimalPlaces?: number | null,
      } | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | {
      __typename: "MerchantSpendRuleError",
      errors: string,
    }
  ) | null,
};

export type RemoveMerchantSpendRuleMutationVariables = {
  input: string,
};

export type RemoveMerchantSpendRuleMutation = {
  removeMerchantSpendRule?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type LockUnlockPaymentCardMutationVariables = {
  input: LockUnlockPaymentCardInput,
};

export type LockUnlockPaymentCardMutation = {
  lockUnlockPaymentCard?:  {
    __typename: "LockUnlockPaymentCardPayload",
    statusCode: number,
    status: string,
    paymentCardId: string,
  } | null,
};

export type RemoveProjectGroupMutationVariables = {
  input: RemoveProjectGroupInput,
};

export type RemoveProjectGroupMutation = {
  removeProjectGroup?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type V2CreateReimbursementTransactionMutationVariables = {
  input: CreateReimbursementTransactionInput,
};

export type V2CreateReimbursementTransactionMutation = {
  v2CreateReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2UpdateReimbursementTransactionMutationVariables = {
  input: UpdateReimbursementTransactionInput,
};

export type V2UpdateReimbursementTransactionMutation = {
  v2UpdateReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2CreateReceiptUploadMutationVariables = {
  input: CreateReceiptUploadInput,
};

export type V2CreateReceiptUploadMutation = {
  v2CreateReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2UpdateReimbursementsSettingsMutationVariables = {
  input: UpdateReimbursementsSettingsInput,
};

export type V2UpdateReimbursementsSettingsMutation = {
  v2UpdateReimbursementsSettings?:  {
    __typename: "BasicHTTPResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type V2DeleteTransactionToReceiptUploadMutationVariables = {
  input: DeleteTransactionToReceiptUploadByReceiptIdInput,
};

export type V2DeleteTransactionToReceiptUploadMutation = {
  v2DeleteTransactionToReceiptUpload?:  {
    __typename: "DeleteTransactionToReceiptUploadPayload",
    success: boolean,
    message?: string | null,
  } | null,
};

export type GetAgaveProjectQueryVariables = {
  id: string,
};

export type GetAgaveProjectQuery = {
  getAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type ListAgaveProjectsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveProjectsQuery = {
  listAgaveProjects?:  {
    __typename: "ModelAgaveProjectConnection",
    items:  Array< {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectsByPaidolIdQuery = {
  listAgaveProjectsByPaidolId?:  {
    __typename: "ModelAgaveProjectConnection",
    items:  Array< {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveGlCodeQueryVariables = {
  id: string,
};

export type GetAgaveGlCodeQuery = {
  getAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type ListAgaveGlCodesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveGlCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveGlCodesQuery = {
  listAgaveGlCodes?:  {
    __typename: "ModelAgaveGlCodeConnection",
    items:  Array< {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveGlCodesByPaidolIdQueryVariables = {
  paidolId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveGlCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveGlCodesByPaidolIdQuery = {
  listAgaveGlCodesByPaidolId?:  {
    __typename: "ModelAgaveGlCodeConnection",
    items:  Array< {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveCostCodeQueryVariables = {
  id: string,
};

export type GetAgaveCostCodeQuery = {
  getAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type ListAgaveCostCodesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveCostCodesQuery = {
  listAgaveCostCodes?:  {
    __typename: "ModelAgaveCostCodeConnection",
    items:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodesByPaidolIdQuery = {
  listAgaveCostCodesByPaidolId?:  {
    __typename: "ModelAgaveCostCodeConnection",
    items:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodesBySubJobIdQueryVariables = {
  sub_job_id: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodesBySubJobIdQuery = {
  listAgaveCostCodesBySubJobId?:  {
    __typename: "ModelAgaveCostCodeConnection",
    items:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodesByProjectIdQuery = {
  listAgaveCostCodesByProjectId?:  {
    __typename: "ModelAgaveCostCodeConnection",
    items:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodesByPaidolAndProjectQueryVariables = {
  paidolProject: string,
  projectId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodesByPaidolAndProjectQuery = {
  listAgaveCostCodesByPaidolAndProject?:  {
    __typename: "ModelAgaveCostCodeConnection",
    items:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveSubJobQueryVariables = {
  id: string,
};

export type GetAgaveSubJobQuery = {
  getAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type ListAgaveSubJobsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveSubJobsQuery = {
  listAgaveSubJobs?:  {
    __typename: "ModelAgaveSubJobConnection",
    items:  Array< {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobsByPaidolIdQuery = {
  listAgaveSubJobsByPaidolId?:  {
    __typename: "ModelAgaveSubJobConnection",
    items:  Array< {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobsByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobsByProjectIdQuery = {
  listAgaveSubJobsByProjectId?:  {
    __typename: "ModelAgaveSubJobConnection",
    items:  Array< {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobsByPaidolAndProjectQueryVariables = {
  fullName: string,
  projectId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobsByPaidolAndProjectQuery = {
  listAgaveSubJobsByPaidolAndProject?:  {
    __typename: "ModelAgaveSubJobConnection",
    items:  Array< {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveProjectCostCodeQueryVariables = {
  id: string,
};

export type GetAgaveProjectCostCodeQuery = {
  getAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveProjectCostCodesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveProjectCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveProjectCostCodesQuery = {
  listAgaveProjectCostCodes?:  {
    __typename: "ModelAgaveProjectCostCodeConnection",
    items:  Array< {
      __typename: "AgaveProjectCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      projectIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectCostCodesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectCostCodesByPaidolIdQuery = {
  listAgaveProjectCostCodesByPaidolId?:  {
    __typename: "ModelAgaveProjectCostCodeConnection",
    items:  Array< {
      __typename: "AgaveProjectCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      projectIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectCostCodesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectCostCodesByProjectIdQuery = {
  listAgaveProjectCostCodesByProjectId?:  {
    __typename: "ModelAgaveProjectCostCodeConnection",
    items:  Array< {
      __typename: "AgaveProjectCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      projectIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectCostCodesByCostCodeIdQueryVariables = {
  costCodeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectCostCodesByCostCodeIdQuery = {
  listAgaveProjectCostCodesByCostCodeId?:  {
    __typename: "ModelAgaveProjectCostCodeConnection",
    items:  Array< {
      __typename: "AgaveProjectCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      projectIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectCostCodesByProjectAndCostCodeQueryVariables = {
  projectIdCostCodeId: string,
  costCodeId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectCostCodesByProjectAndCostCodeQuery = {
  listAgaveProjectCostCodesByProjectAndCostCode?:  {
    __typename: "ModelAgaveProjectCostCodeConnection",
    items:  Array< {
      __typename: "AgaveProjectCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      projectIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveProjectSubJobQueryVariables = {
  id: string,
};

export type GetAgaveProjectSubJobQuery = {
  getAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveProjectSubJobsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveProjectSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveProjectSubJobsQuery = {
  listAgaveProjectSubJobs?:  {
    __typename: "ModelAgaveProjectSubJobConnection",
    items:  Array< {
      __typename: "AgaveProjectSubJob",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      subJobId: string,
      projectIdSubJobId?: string | null,
      subJobName?: string | null,
      subJobNumber?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectSubJobsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectSubJobsByPaidolIdQuery = {
  listAgaveProjectSubJobsByPaidolId?:  {
    __typename: "ModelAgaveProjectSubJobConnection",
    items:  Array< {
      __typename: "AgaveProjectSubJob",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      subJobId: string,
      projectIdSubJobId?: string | null,
      subJobName?: string | null,
      subJobNumber?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectSubJobsByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectSubJobsByProjectIdQuery = {
  listAgaveProjectSubJobsByProjectId?:  {
    __typename: "ModelAgaveProjectSubJobConnection",
    items:  Array< {
      __typename: "AgaveProjectSubJob",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      subJobId: string,
      projectIdSubJobId?: string | null,
      subJobName?: string | null,
      subJobNumber?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectSubJobsBySubJobIdQueryVariables = {
  subJobId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectSubJobsBySubJobIdQuery = {
  listAgaveProjectSubJobsBySubJobId?:  {
    __typename: "ModelAgaveProjectSubJobConnection",
    items:  Array< {
      __typename: "AgaveProjectSubJob",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      subJobId: string,
      projectIdSubJobId?: string | null,
      subJobName?: string | null,
      subJobNumber?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectSubJobsByProjectAndSubJobQueryVariables = {
  projectIdSubJobId: string,
  subJobId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectSubJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectSubJobsByProjectAndSubJobQuery = {
  listAgaveProjectSubJobsByProjectAndSubJob?:  {
    __typename: "ModelAgaveProjectSubJobConnection",
    items:  Array< {
      __typename: "AgaveProjectSubJob",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      subJobId: string,
      projectIdSubJobId?: string | null,
      subJobName?: string | null,
      subJobNumber?: string | null,
      projectName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveSubJobCostCodeQueryVariables = {
  id: string,
};

export type GetAgaveSubJobCostCodeQuery = {
  getAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveSubJobCostCodesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveSubJobCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveSubJobCostCodesQuery = {
  listAgaveSubJobCostCodes?:  {
    __typename: "ModelAgaveSubJobCostCodeConnection",
    items:  Array< {
      __typename: "AgaveSubJobCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      subJobId: string,
      costCodeId: string,
      projectId?: string | null,
      subJobIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      subJobName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobCostCodesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobCostCodesByPaidolIdQuery = {
  listAgaveSubJobCostCodesByPaidolId?:  {
    __typename: "ModelAgaveSubJobCostCodeConnection",
    items:  Array< {
      __typename: "AgaveSubJobCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      subJobId: string,
      costCodeId: string,
      projectId?: string | null,
      subJobIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      subJobName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobCostCodesBySubJobIdQueryVariables = {
  subJobId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobCostCodesBySubJobIdQuery = {
  listAgaveSubJobCostCodesBySubJobId?:  {
    __typename: "ModelAgaveSubJobCostCodeConnection",
    items:  Array< {
      __typename: "AgaveSubJobCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      subJobId: string,
      costCodeId: string,
      projectId?: string | null,
      subJobIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      subJobName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobCostCodesByCostCodeIdQueryVariables = {
  costCodeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobCostCodesByCostCodeIdQuery = {
  listAgaveSubJobCostCodesByCostCodeId?:  {
    __typename: "ModelAgaveSubJobCostCodeConnection",
    items:  Array< {
      __typename: "AgaveSubJobCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      subJobId: string,
      costCodeId: string,
      projectId?: string | null,
      subJobIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      subJobName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubJobCostCodesBySubJobAndCostCodeQueryVariables = {
  subJobIdCostCodeId: string,
  costCodeId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubJobCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubJobCostCodesBySubJobAndCostCodeQuery = {
  listAgaveSubJobCostCodesBySubJobAndCostCode?:  {
    __typename: "ModelAgaveSubJobCostCodeConnection",
    items:  Array< {
      __typename: "AgaveSubJobCostCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      subJobId: string,
      costCodeId: string,
      projectId?: string | null,
      subJobIdCostCodeId?: string | null,
      costCodeName?: string | null,
      costCodeCode?: string | null,
      subJobName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveProjectLocationQueryVariables = {
  id: string,
};

export type GetAgaveProjectLocationQuery = {
  getAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveProjectLocationsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveProjectLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveProjectLocationsQuery = {
  listAgaveProjectLocations?:  {
    __typename: "ModelAgaveProjectLocationConnection",
    items:  Array< {
      __typename: "AgaveProjectLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      locationId: string,
      projectName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectLocationsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectLocationsByPaidolIdQuery = {
  listAgaveProjectLocationsByPaidolId?:  {
    __typename: "ModelAgaveProjectLocationConnection",
    items:  Array< {
      __typename: "AgaveProjectLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      locationId: string,
      projectName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectLocationsByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectLocationsByProjectIdQuery = {
  listAgaveProjectLocationsByProjectId?:  {
    __typename: "ModelAgaveProjectLocationConnection",
    items:  Array< {
      __typename: "AgaveProjectLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      locationId: string,
      projectName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectLocationsByLocationIdQueryVariables = {
  locationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectLocationsByLocationIdQuery = {
  listAgaveProjectLocationsByLocationId?:  {
    __typename: "ModelAgaveProjectLocationConnection",
    items:  Array< {
      __typename: "AgaveProjectLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      locationId: string,
      projectName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveProjectDepartmentQueryVariables = {
  id: string,
};

export type GetAgaveProjectDepartmentQuery = {
  getAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveProjectDepartmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveProjectDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveProjectDepartmentsQuery = {
  listAgaveProjectDepartments?:  {
    __typename: "ModelAgaveProjectDepartmentConnection",
    items:  Array< {
      __typename: "AgaveProjectDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      departmentId: string,
      projectName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectDepartmentsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectDepartmentsByPaidolIdQuery = {
  listAgaveProjectDepartmentsByPaidolId?:  {
    __typename: "ModelAgaveProjectDepartmentConnection",
    items:  Array< {
      __typename: "AgaveProjectDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      departmentId: string,
      projectName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectDepartmentsByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectDepartmentsByProjectIdQuery = {
  listAgaveProjectDepartmentsByProjectId?:  {
    __typename: "ModelAgaveProjectDepartmentConnection",
    items:  Array< {
      __typename: "AgaveProjectDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      departmentId: string,
      projectName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveProjectDepartmentsByDepartmentIdQueryVariables = {
  departmentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveProjectDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveProjectDepartmentsByDepartmentIdQuery = {
  listAgaveProjectDepartmentsByDepartmentId?:  {
    __typename: "ModelAgaveProjectDepartmentConnection",
    items:  Array< {
      __typename: "AgaveProjectDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      departmentId: string,
      projectName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmployeeEntityQueryVariables = {
  id: string,
};

export type GetAgaveEmployeeEntityQuery = {
  getAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type ListAgaveEmployeeEntitiesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmployeeEntityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmployeeEntitiesQuery = {
  listAgaveEmployeeEntities?:  {
    __typename: "ModelAgaveEmployeeEntityConnection",
    items:  Array< {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeEntityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeesByPaidolIdQuery = {
  listAgaveEmployeesByPaidolId?:  {
    __typename: "ModelAgaveEmployeeEntityConnection",
    items:  Array< {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmployeeLocationQueryVariables = {
  id: string,
};

export type GetAgaveEmployeeLocationQuery = {
  getAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmployeeLocationsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmployeeLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmployeeLocationsQuery = {
  listAgaveEmployeeLocations?:  {
    __typename: "ModelAgaveEmployeeLocationConnection",
    items:  Array< {
      __typename: "AgaveEmployeeLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      locationId: string,
      employeeName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeLocationsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeLocationsByPaidolIdQuery = {
  listAgaveEmployeeLocationsByPaidolId?:  {
    __typename: "ModelAgaveEmployeeLocationConnection",
    items:  Array< {
      __typename: "AgaveEmployeeLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      locationId: string,
      employeeName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeLocationsByEmployeeIdQueryVariables = {
  employeeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeLocationsByEmployeeIdQuery = {
  listAgaveEmployeeLocationsByEmployeeId?:  {
    __typename: "ModelAgaveEmployeeLocationConnection",
    items:  Array< {
      __typename: "AgaveEmployeeLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      locationId: string,
      employeeName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeLocationsByLocationIdQueryVariables = {
  locationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeLocationsByLocationIdQuery = {
  listAgaveEmployeeLocationsByLocationId?:  {
    __typename: "ModelAgaveEmployeeLocationConnection",
    items:  Array< {
      __typename: "AgaveEmployeeLocation",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      locationId: string,
      employeeName?: string | null,
      locationName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmployeeDepartmentQueryVariables = {
  id: string,
};

export type GetAgaveEmployeeDepartmentQuery = {
  getAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmployeeDepartmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmployeeDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmployeeDepartmentsQuery = {
  listAgaveEmployeeDepartments?:  {
    __typename: "ModelAgaveEmployeeDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmployeeDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      departmentId: string,
      employeeName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeDepartmentsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeDepartmentsByPaidolIdQuery = {
  listAgaveEmployeeDepartmentsByPaidolId?:  {
    __typename: "ModelAgaveEmployeeDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmployeeDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      departmentId: string,
      employeeName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeDepartmentsByEmployeeIdQueryVariables = {
  employeeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeDepartmentsByEmployeeIdQuery = {
  listAgaveEmployeeDepartmentsByEmployeeId?:  {
    __typename: "ModelAgaveEmployeeDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmployeeDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      departmentId: string,
      employeeName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmployeeDepartmentsByDepartmentIdQueryVariables = {
  departmentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmployeeDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmployeeDepartmentsByDepartmentIdQuery = {
  listAgaveEmployeeDepartmentsByDepartmentId?:  {
    __typename: "ModelAgaveEmployeeDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmployeeDepartment",
      id: string,
      paidolId: string,
      authPaidolId: string,
      employeeId: string,
      departmentId: string,
      employeeName?: string | null,
      departmentName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveCostTypeQueryVariables = {
  id: string,
};

export type GetAgaveCostTypeQuery = {
  getAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type ListAgaveCostTypesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveCostTypesQuery = {
  listAgaveCostTypes?:  {
    __typename: "ModelAgaveCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostTypesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostTypesByPaidolIdQuery = {
  listAgaveCostTypesByPaidolId?:  {
    __typename: "ModelAgaveCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostTypesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostTypesByProjectIdQuery = {
  listAgaveCostTypesByProjectId?:  {
    __typename: "ModelAgaveCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostTypesByPaidolAndProjectQueryVariables = {
  paidolProject: string,
  projectId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostTypesByPaidolAndProjectQuery = {
  listAgaveCostTypesByPaidolAndProject?:  {
    __typename: "ModelAgaveCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEquipmentQueryVariables = {
  id: string,
};

export type GetAgaveEquipmentQuery = {
  getAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEquipmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEquipmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEquipmentsQuery = {
  listAgaveEquipments?:  {
    __typename: "ModelAgaveEquipmentConnection",
    items:  Array< {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEquipmentByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEquipmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEquipmentByPaidolIdQuery = {
  listAgaveEquipmentByPaidolId?:  {
    __typename: "ModelAgaveEquipmentConnection",
    items:  Array< {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmCostCodeQueryVariables = {
  id: string,
};

export type GetAgaveEmCostCodeQuery = {
  getAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmCostCodesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmCostCodesQuery = {
  listAgaveEmCostCodes?:  {
    __typename: "ModelAgaveEmCostCodeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmCostCodesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmCostCodesByPaidolIdQuery = {
  listAgaveEmCostCodesByPaidolId?:  {
    __typename: "ModelAgaveEmCostCodeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmDepartmentQueryVariables = {
  id: string,
};

export type GetAgaveEmDepartmentQuery = {
  getAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmDepartmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmDepartmentsQuery = {
  listAgaveEmDepartments?:  {
    __typename: "ModelAgaveEmDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emCo?: string | null,
      costCodeKeys?: Array< string | null > | null,
      costTypeKeys?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmDepartmentsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmDepartmentsByPaidolIdQuery = {
  listAgaveEmDepartmentsByPaidolId?:  {
    __typename: "ModelAgaveEmDepartmentConnection",
    items:  Array< {
      __typename: "AgaveEmDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emCo?: string | null,
      costCodeKeys?: Array< string | null > | null,
      costTypeKeys?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmCostTypeQueryVariables = {
  id: string,
};

export type GetAgaveEmCostTypeQuery = {
  getAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmCostTypesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmCostTypesQuery = {
  listAgaveEmCostTypes?:  {
    __typename: "ModelAgaveEmCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmCostTypesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmCostTypesByPaidolIdQuery = {
  listAgaveEmCostTypesByPaidolId?:  {
    __typename: "ModelAgaveEmCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveCostCodeCostTypeQueryVariables = {
  id: string,
};

export type GetAgaveCostCodeCostTypeQuery = {
  getAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveCostCodeCostTypesQuery = {
  listAgaveCostCodeCostTypes?:  {
    __typename: "ModelAgaveCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      costCodeId: string,
      costTypeId: string,
      projectId?: string | null,
      costCodeCode?: string | null,
      costCodeName?: string | null,
      costTypeCode?: string | null,
      costTypeName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypesByPaidolIdQuery = {
  listAgaveCostCodeCostTypesByPaidolId?:  {
    __typename: "ModelAgaveCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      costCodeId: string,
      costTypeId: string,
      projectId?: string | null,
      costCodeCode?: string | null,
      costCodeName?: string | null,
      costTypeCode?: string | null,
      costTypeName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypesByCostCodeIdQueryVariables = {
  costCodeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypesByCostCodeIdQuery = {
  listAgaveCostCodeCostTypesByCostCodeId?:  {
    __typename: "ModelAgaveCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      costCodeId: string,
      costTypeId: string,
      projectId?: string | null,
      costCodeCode?: string | null,
      costCodeName?: string | null,
      costTypeCode?: string | null,
      costTypeName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypesByCostTypeIdQueryVariables = {
  costTypeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypesByCostTypeIdQuery = {
  listAgaveCostCodeCostTypesByCostTypeId?:  {
    __typename: "ModelAgaveCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      costCodeId: string,
      costTypeId: string,
      projectId?: string | null,
      costCodeCode?: string | null,
      costCodeName?: string | null,
      costTypeCode?: string | null,
      costTypeName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypesByProjectIdQuery = {
  listAgaveCostCodeCostTypesByProjectId?:  {
    __typename: "ModelAgaveCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      costCodeId: string,
      costTypeId: string,
      projectId?: string | null,
      costCodeCode?: string | null,
      costCodeName?: string | null,
      costTypeCode?: string | null,
      costTypeName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveEmCostCodeCostTypeQueryVariables = {
  id: string,
};

export type GetAgaveEmCostCodeCostTypeQuery = {
  getAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveEmCostCodeCostTypesQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveEmCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveEmCostCodeCostTypesQuery = {
  listAgaveEmCostCodeCostTypes?:  {
    __typename: "ModelAgaveEmCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      emCostCodeId: string,
      emCostTypeId: string,
      emGroup?: string | null,
      emCostCodeCode?: string | null,
      emCostCodeName?: string | null,
      emCostTypeCode?: string | null,
      emCostTypeName?: string | null,
      unitOfMeasure?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmCostCodeCostTypesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmCostCodeCostTypesByPaidolIdQuery = {
  listAgaveEmCostCodeCostTypesByPaidolId?:  {
    __typename: "ModelAgaveEmCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      emCostCodeId: string,
      emCostTypeId: string,
      emGroup?: string | null,
      emCostCodeCode?: string | null,
      emCostCodeName?: string | null,
      emCostTypeCode?: string | null,
      emCostTypeName?: string | null,
      unitOfMeasure?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmCostCodeCostTypesByEmCostCodeIdQueryVariables = {
  emCostCodeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmCostCodeCostTypesByEmCostCodeIdQuery = {
  listAgaveEmCostCodeCostTypesByEmCostCodeId?:  {
    __typename: "ModelAgaveEmCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      emCostCodeId: string,
      emCostTypeId: string,
      emGroup?: string | null,
      emCostCodeCode?: string | null,
      emCostCodeName?: string | null,
      emCostTypeCode?: string | null,
      emCostTypeName?: string | null,
      unitOfMeasure?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveEmCostCodeCostTypesByEmCostTypeIdQueryVariables = {
  emCostTypeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveEmCostCodeCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveEmCostCodeCostTypesByEmCostTypeIdQuery = {
  listAgaveEmCostCodeCostTypesByEmCostTypeId?:  {
    __typename: "ModelAgaveEmCostCodeCostTypeConnection",
    items:  Array< {
      __typename: "AgaveEmCostCodeCostType",
      id: string,
      paidolId: string,
      authPaidolId: string,
      emCostCodeId: string,
      emCostTypeId: string,
      emGroup?: string | null,
      emCostCodeCode?: string | null,
      emCostCodeName?: string | null,
      emCostTypeCode?: string | null,
      emCostTypeName?: string | null,
      unitOfMeasure?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveCostCodeCostTypeGlQueryVariables = {
  id: string,
};

export type GetAgaveCostCodeCostTypeGlQuery = {
  getAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveCostCodeCostTypeGlsQuery = {
  listAgaveCostCodeCostTypeGls?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypeGlsByPaidolIdQuery = {
  listAgaveCostCodeCostTypeGlsByPaidolId?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostTypeQueryVariables = {
  paidolId: string,
  projectCostCodeCostTypeKey?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostTypeQuery = {
  listAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostType?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypeGlsByProjectIdQuery = {
  listAgaveCostCodeCostTypeGlsByProjectId?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsByCostCodeIdQueryVariables = {
  costCodeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypeGlsByCostCodeIdQuery = {
  listAgaveCostCodeCostTypeGlsByCostCodeId?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveCostCodeCostTypeGlsByCostTypeIdQueryVariables = {
  costTypeId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveCostCodeCostTypeGlFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveCostCodeCostTypeGlsByCostTypeIdQuery = {
  listAgaveCostCodeCostTypeGlsByCostTypeId?:  {
    __typename: "ModelAgaveCostCodeCostTypeGlConnection",
    items:  Array< {
      __typename: "AgaveCostCodeCostTypeGl",
      id: string,
      paidolId: string,
      authPaidolId: string,
      projectId: string,
      costCodeId: string,
      costTypeId: string,
      glCodeId: string,
      projectCostCodeCostTypeKey: string,
      glCodeSourceId?: string | null,
      glCodeNumber?: string | null,
      itemSourceId?: string | null,
      itemName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveLocationQueryVariables = {
  id: string,
};

export type GetAgaveLocationQuery = {
  getAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type ListAgaveLocationsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveLocationsQuery = {
  listAgaveLocations?:  {
    __typename: "ModelAgaveLocationConnection",
    items:  Array< {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveLocationsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveLocationsByPaidolIdQuery = {
  listAgaveLocationsByPaidolId?:  {
    __typename: "ModelAgaveLocationConnection",
    items:  Array< {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveDepartmentQueryVariables = {
  id: string,
};

export type GetAgaveDepartmentQuery = {
  getAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type ListAgaveDepartmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveDepartmentsQuery = {
  listAgaveDepartments?:  {
    __typename: "ModelAgaveDepartmentConnection",
    items:  Array< {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveDepartmentsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveDepartmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveDepartmentsByPaidolIdQuery = {
  listAgaveDepartmentsByPaidolId?:  {
    __typename: "ModelAgaveDepartmentConnection",
    items:  Array< {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveSubaccountQueryVariables = {
  id: string,
};

export type GetAgaveSubaccountQuery = {
  getAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type ListAgaveSubaccountsQueryVariables = {
  id?: string | null,
  filter?: ModelAgaveSubaccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgaveSubaccountsQuery = {
  listAgaveSubaccounts?:  {
    __typename: "ModelAgaveSubaccountConnection",
    items:  Array< {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveSubaccountsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveSubaccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveSubaccountsByPaidolIdQuery = {
  listAgaveSubaccountsByPaidolId?:  {
    __typename: "ModelAgaveSubaccountConnection",
    items:  Array< {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgaveVendorQueryVariables = {
  id: string,
};

export type GetAgaveVendorQuery = {
  getAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type ListAgaveVendorsQueryVariables = {
  filter?: ModelAgaveVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveVendorsQuery = {
  listAgaveVendors?:  {
    __typename: "ModelAgaveVendorConnection",
    items:  Array< {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgaveVendorsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAgaveVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgaveVendorsByPaidolIdQuery = {
  listAgaveVendorsByPaidolId?:  {
    __typename: "ModelAgaveVendorConnection",
    items:  Array< {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolThemeQueryVariables = {
  id: string,
};

export type GetPaidolThemeQuery = {
  getPaidolTheme?:  {
    __typename: "PaidolTheme",
    id: string,
    paidolId: string,
    palette?:  {
      __typename: "ColorPalette",
      primary?: string | null,
      primaryDark?: string | null,
      primaryDarker?: string | null,
      primaryLight?: string | null,
      primaryLighter?: string | null,
      secondary?: string | null,
      secondaryDark?: string | null,
      textPrimary?: string | null,
      textSecondary?: string | null,
      whiteColor?: string | null,
      successColor?: string | null,
      warningColor?: string | null,
      errorColor?: string | null,
      errorLightColor?: string | null,
      lightestGrayColor?: string | null,
      lightGrayColor?: string | null,
      lightBlueColor?: string | null,
      info?: string | null,
      statusSuccess?: string | null,
      statusWarning?: string | null,
      statusError?: string | null,
      neutral95?: string | null,
      neutralVariant25?: string | null,
      neutral50?: string | null,
      neutral90?: string | null,
      surfaceContainerHigh?: string | null,
      orange100?: string | null,
      orange300?: string | null,
      orange700?: string | null,
      green50?: string | null,
      green700?: string | null,
      red50?: string | null,
      red700?: string | null,
      link400?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolThemesQueryVariables = {
  id?: string | null,
  filter?: ModelPaidolThemeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPaidolThemesQuery = {
  listPaidolThemes?:  {
    __typename: "ModelPaidolThemeConnection",
    items:  Array< {
      __typename: "PaidolTheme",
      id: string,
      paidolId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPaidolThemeByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolThemeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolThemeByPaidolIdQuery = {
  listPaidolThemeByPaidolId?:  {
    __typename: "ModelPaidolThemeConnection",
    items:  Array< {
      __typename: "PaidolTheme",
      id: string,
      paidolId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolUserQueryVariables = {
  id: string,
};

export type GetPaidolUserQuery = {
  getPaidolUser?:  {
    __typename: "PaidolUser",
    id: string,
    paidol_id?: string | null,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_id?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    email?: string | null,
    position?: string | null,
    phone?: string | null,
    address?:  {
      __typename: "Address",
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    roles?: Role | null,
    is_test_fixture?: boolean | null,
    paymentCards?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    authorizedUserId?: string | null,
    authorizedUserApplicationId?: string | null,
    allowedJobCodes?: Array< string > | null,
    employee_id?: number | null,
    managedGroups?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    managedProjectsGroups?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    departmentVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    columnPreferences?:  Array< {
      __typename: "UserColumnPreferences",
      paidolId: string,
    } > | null,
    widgetPreferences?:  Array< {
      __typename: "UserWidgetPreference",
      widgetId: string,
      hidden: boolean,
    } > | null,
    // Default Agave (Sage Intacct) employee for this cardholder in this company.
    // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
    defaultAgaveEmployeeId?: string | null,
    defaultAgaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    deletedAt?: string | null,
    landingPagePreference?: LandingPagePreference | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolUsersQueryVariables = {
  filter?: ModelPaidolUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolUsersQuery = {
  listPaidolUsers?:  {
    __typename: "ModelPaidolUserConnection",
    items:  Array< {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaidolUserByPaidolIdQueryVariables = {
  paidol_id: string,
  roles?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolUserByPaidolIdQuery = {
  paidolUserByPaidolId?:  {
    __typename: "ModelPaidolUserConnection",
    items:  Array< {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaidolUserByUserIdQueryVariables = {
  user_id: string,
  paidol_id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolUserByUserIdQuery = {
  paidolUserByUserId?:  {
    __typename: "ModelPaidolUserConnection",
    items:  Array< {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaidolUserByEmailQueryVariables = {
  email: string,
  paidol_id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolUserByEmailQuery = {
  paidolUserByEmail?:  {
    __typename: "ModelPaidolUserConnection",
    items:  Array< {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    first_name: string,
    middle_name?: string | null,
    last_name: string,
    suffix?: string | null,
    paidol_users?:  {
      __typename: "ModelPaidolUserConnection",
      nextToken?: string | null,
    } | null,
    picture?: string | null,
    is_speedster?: string | null,
    birthdate?: string | null,
    address?: string | null,
    phone_number?: string | null,
    phone_extension?: string | null,
    password_updated_at?: string | null,
    finicityCustomerId?: string | null,
    dwollaCustomerId?: string | null,
    firstRunBanner?:  {
      __typename: "FirstRunBanner",
      insights?: boolean | null,
      transactions?: boolean | null,
      reimbursements?: boolean | null,
      cardsManagement?: boolean | null,
      spendRules?: boolean | null,
      funding?: boolean | null,
      teamMembers?: boolean | null,
      groups?: boolean | null,
      wallet?: boolean | null,
      settings?: boolean | null,
      connections?: boolean | null,
    } | null,
    is_support?: boolean | null,
    deletedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetPaidolQueryVariables = {
  id: string,
};

export type GetPaidolQuery = {
  getPaidol?:  {
    __typename: "Paidol",
    id: string,
    id_base58?: string | null,
    id_base58_short?: string | null,
    // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
    // that are associated w/ their Suppliers... this will probably need
    // to be rethought once we start onboarding Suppliers into the system
    // as Paidol administrators
    owner_paidol_id?: string | null,
    slug?: string | null,
    legal_name?: string | null,
    account_balance?: string | null,
    name: string,
    dba?: string | null,
    ein?: string | null,
    mcc?: string | null,
    corp_type?: string | null,
    industry?: string | null,
    company_email?: string | null,
    customer_facing_email?: string | null,
    company_phone?: string | null,
    website?: string | null,
    company_address?:  {
      __typename: "Address",
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    customer_facing_address?:  {
      __typename: "Address",
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    legal_address?:  {
      __typename: "Address",
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    business_owner_ssn?: string | null,
    dwolla_business_industry_classification?: string | null,
    admin_user_id?: string | null,
    low_balance_alert_threshold?: number | null,
    low_balance_auto_funding_amount?: number | null,
    low_balance_auto_funding_threshold?: number | null,
    speedscore?: number | null,
    priority_status?: string | null,
    deleted_at?: string | null,
    company_id?: string | null,
    logo?: string | null,
    priority_response?: string | null,
    // Indicates whether agave data is currently being synced to the Paidol
    agave_data_sync_in_progress?: boolean | null,
    // These are not trustworthy; validation happens in CPX and we
    // currently do not update this data if there is a validation error
    bankAccounts?:  Array< {
      __typename: "BankAccounts",
      bankId?: string | null,
      accountType?: AccountTypeEnum | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
      defaults?: Array< DefaultsEnum | null > | null,
      isActive?: boolean | null,
    } | null > | null,
    submittedBankAccounts?: Array< string | null > | null,
    achEnabled?: boolean | null,
    virtualCardRequested?: boolean | null,
    virtualCardEnabled?: boolean | null,
    achRequested?: boolean | null,
    cron_status?: CronStatus | null,
    // The Cognito user ID of the user who signed-up for Speedchain
    owner_sub?: string | null,
    is_test_fixture?: boolean | null,
    is_migration?: boolean | null,
    // Enables Payment Cards when signed-in to Speedchain
    enablePCards?: boolean | null,
    accountingDateSettings?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    reimbursementSettings?:  {
      __typename: "ReimbursementSettings",
      isEnabled: boolean,
      isCheckrunEnabled: boolean,
      rhythm?: ReimbursementRhythm | null,
      day?: number | null,
      weekday?: Weekday | null,
      ordinal?: Ordinal | null,
      mileageRate?: number | null,
      mileageRateEffectiveFrom?: string | null,
    } | null,
    receiptsSettings?:  {
      __typename: "ReceiptSettings",
      isEnabled: boolean,
      minimumAmount?: number | null,
      exemptCardIds?: Array< string | null > | null,
    } | null,
    approveWithoutReceipts?: boolean | null,
    notesSettings?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    editLockingSettings?:  {
      __typename: "EditLockingSettings",
      isEnabled: boolean,
    } | null,
    jobCodeSettings?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    flexCodingSettings?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    flexFieldSettings?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    fuelCaptureSettings?:  {
      __typename: "FuelCaptureToggleableSetting",
      isEnabled: boolean,
      isVehicleIdRequired?: boolean | null,
      isGallonsRequired?: boolean | null,
      isOdometerRequired?: boolean | null,
      isMCC5542Required?: boolean | null,
      isMCC5541Required?: boolean | null,
    } | null,
    // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
    isConstructionType?: boolean | null,
    // Account token that is getting persisted after a user authenticates with the agave widget
    agaveAccountToken?: string | null,
    // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
    // Persisted when user authenticates with Agave to avoid async lookup
    agaveSourceSystemSlug?: string | null,
    // Is this paidol an Agave client or not
    isAgaveClient?: boolean | null,
    // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
    erpSpeedchain?: boolean | null,
    // References the ERPConnection record for this paidol's direct ERP integration
    erpConnectionId?: string | null,
    // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
    // captured at swap time (before the Agave token is cleared). The direct-ERP
    // cutover reconciliation compares it to the reconnected realmId to confirm a
    // same-company migration before remapping coding references.
    priorErpRealmId?: string | null,
    // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
    priorErpName?: string | null,
    // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
    // this paidol, so subsequent direct syncs skip the bridge/clear step.
    erpCutoverReconciledAt?: string | null,
    // Track which ERP system a user wants to integrate their SC transactions with
    selectedERP?: ERP | null,
    primaryAuthorizedPerson?:  {
      __typename: "PrimaryPaidolAuthorizedPerson",
      firstName: string,
      lastName: string,
      email: string,
      hasExtension?: boolean | null,
      birthdate: string,
      socialSecurityNumber?: string | null,
      jobTitle: string,
      percentageOwnership?: number | null,
    } | null,
    firstRunChecklist?:  {
      __typename: "FirstRunChecklist",
      connectFinancialAccount?: boolean | null,
      addAdmin?: boolean | null,
      addTeamMember?: boolean | null,
      createSpendRule?: boolean | null,
      issueCard?: boolean | null,
      createGroup?: boolean | null,
      setReimbursement?: boolean | null,
      integrateERP?: boolean | null,
      dismissWelcomePage?: boolean | null,
      isStepperComplete?: boolean | null,
    } | null,
    logoUrl?: string | null,
    isProcoreClient?: boolean | null,
    cardLockSettings?:  {
      __typename: "CardLockToggleableSetting",
      isEnabled: boolean,
      daysToLock?: number | null,
      isReceiptsRequired?: boolean | null,
      isNotesRequired?: boolean | null,
      isFuelCaptureRequired?: boolean | null,
      applyImmediately?: boolean | null,
      disableAutoUnlock?: boolean | null,
      includePendingCharges?: boolean | null,
    } | null,
    sessionTimeoutSettings?:  {
      __typename: "SessionTimeoutSetting",
      isEnabled: boolean,
      timeoutMinutes?: number | null,
    } | null,
    approvalWorkflowSettings?:  {
      __typename: "ApprovalWorkflowSettings",
      isEnabled?: boolean | null,
      approvalLevels?: number | null,
      groupApprovalsEnabled?: boolean | null,
    } | null,
    projectFilteringByUser?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    glCodeFilteringByUser?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    locationFilteringByUser?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    departmentFilteringByUser?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    locationVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    creditLimit?: number | null,
    qboPostingSettings?:  {
      __typename: "ERPPostingToggleableSetting",
      isEnabled?: boolean | null,
    } | null,
    // SEE-1763: QBO only. When on, any coded field (Item, Class, Vendor, ...) is
    // enough to attempt a post and QuickBooks validates; off keeps the GL-or-Project rule.
    qboAnyCodingPostingSettings?:  {
      __typename: "ERPPostingToggleableSetting",
      isEnabled?: boolean | null,
    } | null,
    erpCostCodesUseDescriptionSetting?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    // SEE-1325: when enabled, every ERP coding dropdown is ordered by code/number
    // (natural sort) and rendered "code - name". Off (the default) keeps ordering by
    // name/description and the "name - (code)" format. Written by the CDK
    // updatePaidolSettings mutation; read here so the frontend can pick the label
    // format and skip its own client-side sort when the server already ordered.
    erpDropdownSortByCodeSetting?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    erpProjectsEndpointSetting?:  {
      __typename: "ERPEndpointSettings",
      selectedEndpoint?: string | null,
      isEnabled?: boolean | null,
      shouldDisplay?: boolean | null,
    } | null,
    // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
    // Their projects/codes live as GL dimensions, so coding is sourced from them
    // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
    // filtering is bypassed (show all, no relationships exist), and posting routes the
    // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
    intacctProjectsNotLicensed?: boolean | null,
    // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
    // at the Sage top level posts on the top-level session, so Sage owns the record at
    // the top level and Projects > Generate Invoices sees it from the top level too.
    intacctTopLevelProjectPosting?: boolean | null,
    erpDepartmentLocationSetting?:  {
      __typename: "ERPDepartmentLocationSetting",
      isEnabled?: boolean | null,
      departmentEnabled?: boolean | null,
      locationEnabled?: boolean | null,
      filterProjectsByEmployeeLocationEnabled?: boolean | null,
    } | null,
    sage300PostingSettings?:  {
      __typename: "ERPPostingToggleableSetting",
      isEnabled?: boolean | null,
    } | null,
    sageIntacctBillableSettings?:  {
      __typename: "ERPPostingToggleableSetting",
      isEnabled?: boolean | null,
    } | null,
    receiptAgentSettings?:  {
      __typename: "ReceiptAgentSettings",
      isEnabled: boolean,
    } | null,
    codingColumnsConfig?:  {
      __typename: "CodingColumnsConfig",
      isEnabled?: boolean | null,
    } | null,
    codingRequirements?:  {
      __typename: "CodingRequirementsSettings",
      isEnabled?: boolean | null,
    } | null,
    widgetVisibilityConfig?:  Array< {
      __typename: "UserWidgetPreference",
      widgetId: string,
      hidden: boolean,
    } > | null,
    requireProjectBeforeCostCode?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    scopeEquipmentCodesToEmDepartment?:  {
      __typename: "ToggleableSetting",
      isEnabled: boolean,
    } | null,
    paymentTermDays?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolsQueryVariables = {
  filter?: ModelPaidolFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolsQuery = {
  listPaidols?:  {
    __typename: "ModelPaidolConnection",
    items?:  Array< {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type PaidolByCronStatusQueryVariables = {
  cron_status: CronStatus,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolByCronStatusQuery = {
  paidolByCronStatus?:  {
    __typename: "ModelPaidolConnection",
    items?:  Array< {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SearchPaidolsQueryVariables = {
  filter?: SearchablePaidolFilterInput | null,
  sort?: Array< SearchablePaidolSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePaidolAggregationInput | null > | null,
};

export type SearchPaidolsQuery = {
  searchPaidols?:  {
    __typename: "SearchablePaidolConnection",
    items:  Array< {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPaidolAgaveSyncQueryVariables = {
  id: string,
};

export type GetPaidolAgaveSyncQuery = {
  getPaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolAgaveSyncsQueryVariables = {
  filter?: ModelPaidolAgaveSyncFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolAgaveSyncsQuery = {
  listPaidolAgaveSyncs?:  {
    __typename: "ModelPaidolAgaveSyncConnection",
    items:  Array< {
      __typename: "PaidolAgaveSync",
      id: string,
      paidolId: string,
      authPaidolId: string,
      inProgress: boolean,
      error?: string | null,
      lastRunStart: string,
      lastRunEnd?: string | null,
      taskArn?: string | null,
      syncEntityFilter?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaidolAgaveSyncByPaidolIdQueryVariables = {
  paidolId: string,
  lastRunStart?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolAgaveSyncFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolAgaveSyncByPaidolIdQuery = {
  paidolAgaveSyncByPaidolId?:  {
    __typename: "ModelPaidolAgaveSyncConnection",
    items:  Array< {
      __typename: "PaidolAgaveSync",
      id: string,
      paidolId: string,
      authPaidolId: string,
      inProgress: boolean,
      error?: string | null,
      lastRunStart: string,
      lastRunEnd?: string | null,
      taskArn?: string | null,
      syncEntityFilter?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaymentFileQueueQueryVariables = {
  id: string,
};

export type GetPaymentFileQueueQuery = {
  getPaymentFileQueue?:  {
    __typename: "PaymentFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: PaymentFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_payments?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    total?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    createdAt?: string | null,
    filename?: string | null,
    supplier_vendor_paidol_ids?: Array< string | null > | null,
    referenced_vendors?: Array< string | null > | null,
    invoice_ids?: Array< string | null > | null,
    invoice_spx_ids?: Array< string | null > | null,
    priority_status?: string | null,
    priority_file_id?: string | null,
    priority_process_on?: string | null,
    priority_response?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPaymentFileQueuesQueryVariables = {
  filter?: ModelPaymentFileQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentFileQueuesQuery = {
  listPaymentFileQueues?:  {
    __typename: "ModelPaymentFileQueueConnection",
    items:  Array< {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaymentFileQueuesByPaidolQueryVariables = {
  paidol_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentFileQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaymentFileQueuesByPaidolQuery = {
  paymentFileQueuesByPaidol?:  {
    __typename: "ModelPaymentFileQueueConnection",
    items:  Array< {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaymentFileQueuesByStatusQueryVariables = {
  status: PaymentFileQueueStatusEnum,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentFileQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaymentFileQueuesByStatusQuery = {
  paymentFileQueuesByStatus?:  {
    __typename: "ModelPaymentFileQueueConnection",
    items:  Array< {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPaymentFileQueuesQueryVariables = {
  filter?: SearchablePaymentFileQueueFilterInput | null,
  sort?: Array< SearchablePaymentFileQueueSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePaymentFileQueueAggregationInput | null > | null,
};

export type SearchPaymentFileQueuesQuery = {
  searchPaymentFileQueues?:  {
    __typename: "SearchablePaymentFileQueueConnection",
    items:  Array< {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPaidolVendorQueryVariables = {
  id: string,
};

export type GetPaidolVendorQuery = {
  getPaidolVendor?:  {
    __typename: "PaidolVendor",
    id: string,
    user_vendor_id: string,
    is_migration?: boolean | null,
    paidol_id: string,
    vendor?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    vendor_paidol_id: string,
    priority_active?: string | null,
    payment_terms?: string | null,
    priority_account_balance?: number | null,
    contact_name?: string | null,
    priority_billing_code?: string | null,
    priority_repeate_code?: string | null,
    priority_group_code?: string | null,
    email_addresses?: Array< string | null > | null,
    priority_document_delivery?: string | null,
    priority_regular_inv?: string | null,
    priority_summary_inv?: string | null,
    foreign_name?: string | null,
    remarks?: string | null,
    box_1099?: string | null,
    form_code_1099?: string | null,
    remark_1?: string | null,
    priority_response?: string | null,
    cron_status?: CronStatus | null,
    priority_status?: string | null,
    priority_supplier_id?: string | null,
    virtual_card_email?: string | null,
    bankAccounts?:  Array< {
      __typename: "BankAccounts",
      bankId?: string | null,
      accountType?: AccountTypeEnum | null,
      accountNumber?: string | null,
      routingNumber?: string | null,
      defaults?: Array< DefaultsEnum | null > | null,
      isActive?: boolean | null,
    } | null > | null,
    achEnabled?: boolean | null,
    virtualCardEnabled?: boolean | null,
    checkIssuingEnabled?: boolean | null,
    checkIssuingPayableTo?: string | null,
    checkIssuingStreet?: string | null,
    checkIssuingCity?: string | null,
    checkIssuingState?: string | null,
    checkIssuingCountry?: string | null,
    checkIssuingPostalCode?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolVendorsQueryVariables = {
  filter?: ModelPaidolVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolVendorsQuery = {
  listPaidolVendors?:  {
    __typename: "ModelPaidolVendorConnection",
    items:  Array< {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VendorByPaidolQueryVariables = {
  paidol_id: string,
  user_vendor_id?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VendorByPaidolQuery = {
  vendorByPaidol?:  {
    __typename: "ModelPaidolVendorConnection",
    items:  Array< {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaidolVendorsByCronStatusQueryVariables = {
  cron_status: CronStatus,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaidolVendorsByCronStatusQuery = {
  paidolVendorsByCronStatus?:  {
    __typename: "ModelPaidolVendorConnection",
    items:  Array< {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPaidolVendorsQueryVariables = {
  filter?: SearchablePaidolVendorFilterInput | null,
  sort?: Array< SearchablePaidolVendorSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePaidolVendorAggregationInput | null > | null,
};

export type SearchPaidolVendorsQuery = {
  searchPaidolVendors?:  {
    __typename: "SearchablePaidolVendorConnection",
    items:  Array< {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetInvoiceQueryVariables = {
  id: string,
};

export type GetInvoiceQuery = {
  getInvoice?:  {
    __typename: "Invoice",
    id: string,
    id_base58?: string | null,
    id_base58_short?: string | null,
    payment_file_queue_id?: string | null,
    payment_file?:  {
      __typename: "PaymentFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: PaymentFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_payments?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      filename?: string | null,
      supplier_vendor_paidol_ids?: Array< string | null > | null,
      referenced_vendors?: Array< string | null > | null,
      invoice_ids?: Array< string | null > | null,
      invoice_spx_ids?: Array< string | null > | null,
      priority_status?: string | null,
      priority_file_id?: string | null,
      priority_process_on?: string | null,
      priority_response?: string | null,
      updatedAt: string,
    } | null,
    buyer_paidol_id: string,
    paidol_vendor_id: string,
    paidol_vendor:  {
      __typename: "PaidolVendor",
      id: string,
      user_vendor_id: string,
      is_migration?: boolean | null,
      paidol_id: string,
      vendor_paidol_id: string,
      priority_active?: string | null,
      payment_terms?: string | null,
      priority_account_balance?: number | null,
      contact_name?: string | null,
      priority_billing_code?: string | null,
      priority_repeate_code?: string | null,
      priority_group_code?: string | null,
      email_addresses?: Array< string | null > | null,
      priority_document_delivery?: string | null,
      priority_regular_inv?: string | null,
      priority_summary_inv?: string | null,
      foreign_name?: string | null,
      remarks?: string | null,
      box_1099?: string | null,
      form_code_1099?: string | null,
      remark_1?: string | null,
      priority_response?: string | null,
      cron_status?: CronStatus | null,
      priority_status?: string | null,
      priority_supplier_id?: string | null,
      virtual_card_email?: string | null,
      achEnabled?: boolean | null,
      virtualCardEnabled?: boolean | null,
      checkIssuingEnabled?: boolean | null,
      checkIssuingPayableTo?: string | null,
      checkIssuingStreet?: string | null,
      checkIssuingCity?: string | null,
      checkIssuingState?: string | null,
      checkIssuingCountry?: string | null,
      checkIssuingPostalCode?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    supplier_paidol_id: string,
    supplier_paidol:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    user_invoice_id: string,
    date: string,
    balance_due:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    },
    createdAt: string,
    updatedAt: string,
    transaction_id?: string | null,
    priority_payment_id?: string | null,
    priority_payment_status?: string | null,
    priority_payment_type?: string | null,
    priority_payment_date?: string | null,
    priority_payment_auth_message?: string | null,
    priority_response?: string | null,
    status: PaymentFileQueueStatusEnum,
  } | null,
};

export type ListInvoicesQueryVariables = {
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInvoicesQuery = {
  listInvoices?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByPaymentFileQueueQueryVariables = {
  payment_file_queue_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByPaymentFileQueueQuery = {
  invoicesByPaymentFileQueue?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByBuyerPaidolQueryVariables = {
  buyer_paidol_id: string,
  date?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByBuyerPaidolQuery = {
  invoicesByBuyerPaidol?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdQueryVariables = {
  buyer_paidol_id: string,
  user_invoice_idSupplier_paidol_id?: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdQuery = {
  invoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceId?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByBuyerPaidolIdAndUpdatedAtQueryVariables = {
  buyer_paidol_id: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByBuyerPaidolIdAndUpdatedAtQuery = {
  invoicesByBuyerPaidolIdAndUpdatedAt?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByUserInvoiceIdQueryVariables = {
  user_invoice_id: string,
  buyer_paidol_idSupplier_paidol_id?: ModelInvoiceByUserInvoiceIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByUserInvoiceIdQuery = {
  invoicesByUserInvoiceId?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByPriorityPaymentIdQueryVariables = {
  priority_payment_id: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByPriorityPaymentIdQuery = {
  invoicesByPriorityPaymentId?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type InvoicesByPriorityPaymentStatusQueryVariables = {
  priority_payment_status: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type InvoicesByPriorityPaymentStatusQuery = {
  invoicesByPriorityPaymentStatus?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      payment_file_queue_id?: string | null,
      buyer_paidol_id: string,
      paidol_vendor_id: string,
      supplier_paidol_id: string,
      user_invoice_id: string,
      date: string,
      createdAt: string,
      updatedAt: string,
      transaction_id?: string | null,
      priority_payment_id?: string | null,
      priority_payment_status?: string | null,
      priority_payment_type?: string | null,
      priority_payment_date?: string | null,
      priority_payment_auth_message?: string | null,
      priority_response?: string | null,
      status: PaymentFileQueueStatusEnum,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSupplierFileQueueQueryVariables = {
  id: string,
};

export type GetSupplierFileQueueQuery = {
  getSupplierFileQueue?:  {
    __typename: "SupplierFileQueue",
    id: string,
    user_id: string,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidol_id: string,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    key: string,
    status: SupplierFileQueueStatusEnum,
    processed_at?: string | null,
    error_messages?: Array< string | null > | null,
    num_vendors?: number | null,
    num_success?: number | null,
    num_failed?: number | null,
    createdAt?: string | null,
    is_migration?: boolean | null,
    updatedAt: string,
  } | null,
};

export type ListSupplierFileQueuesQueryVariables = {
  filter?: ModelSupplierFileQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSupplierFileQueuesQuery = {
  listSupplierFileQueues?:  {
    __typename: "ModelSupplierFileQueueConnection",
    items:  Array< {
      __typename: "SupplierFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: SupplierFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      is_migration?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SupplierFileQueuesByPaidolQueryVariables = {
  paidol_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSupplierFileQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SupplierFileQueuesByPaidolQuery = {
  supplierFileQueuesByPaidol?:  {
    __typename: "ModelSupplierFileQueueConnection",
    items:  Array< {
      __typename: "SupplierFileQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      key: string,
      status: SupplierFileQueueStatusEnum,
      processed_at?: string | null,
      error_messages?: Array< string | null > | null,
      num_vendors?: number | null,
      num_success?: number | null,
      num_failed?: number | null,
      createdAt?: string | null,
      is_migration?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaymentStatusDownloadQueryVariables = {
  id: string,
};

export type GetPaymentStatusDownloadQuery = {
  getPaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaymentStatusDownloadsQueryVariables = {
  filter?: ModelPaymentStatusDownloadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentStatusDownloadsQuery = {
  listPaymentStatusDownloads?:  {
    __typename: "ModelPaymentStatusDownloadConnection",
    items:  Array< {
      __typename: "PaymentStatusDownload",
      id: string,
      user_id: string,
      paidol_id: string,
      start_date: string,
      end_date: string,
      s3_key?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PaymentStatusDownloadByPaidolIdQueryVariables = {
  paidol_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentStatusDownloadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaymentStatusDownloadByPaidolIdQuery = {
  paymentStatusDownloadByPaidolId?:  {
    __typename: "ModelPaymentStatusDownloadConnection",
    items:  Array< {
      __typename: "PaymentStatusDownload",
      id: string,
      user_id: string,
      paidol_id: string,
      start_date: string,
      end_date: string,
      s3_key?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolHighnoteIntegrationQueryVariables = {
  id: string,
};

export type GetPaidolHighnoteIntegrationQuery = {
  getPaidolHighnoteIntegration?:  {
    __typename: "PaidolHighnoteIntegration",
    // id and paidolId are the same; corresponds to Paidol.id
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    id: string,
    paidolId: string,
    userId?: string | null,
    legalBusinessName?: string | null,
    businessAccountHolderId?: string | null,
    primaryAuthorizedPersonId?: string | null,
    financialAccountId?: string | null,
    externalFinancialBankAccountId?: string | null,
    hasInitialFunding?: boolean | null,
    accountHolderCardProductApplicationId?: string | null,
    isApplicationAccepted?: boolean | null,
    isDisconnected?: boolean | null,
    highnoteProductId?: string | null,
    highnoteProduct?:  {
      __typename: "HighnoteProduct",
      id: string,
      type: HighnoteProductType,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    finicityCustomerId?: string | null,
    dwollaCustomerId?: string | null,
    cardProfileId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolHighnoteIntegrationsQueryVariables = {
  filter?: ModelPaidolHighnoteIntegrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolHighnoteIntegrationsQuery = {
  listPaidolHighnoteIntegrations?:  {
    __typename: "ModelPaidolHighnoteIntegrationConnection",
    items:  Array< {
      __typename: "PaidolHighnoteIntegration",
      // id and paidolId are the same; corresponds to Paidol.id
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      id: string,
      paidolId: string,
      userId?: string | null,
      legalBusinessName?: string | null,
      businessAccountHolderId?: string | null,
      primaryAuthorizedPersonId?: string | null,
      financialAccountId?: string | null,
      externalFinancialBankAccountId?: string | null,
      hasInitialFunding?: boolean | null,
      accountHolderCardProductApplicationId?: string | null,
      isApplicationAccepted?: boolean | null,
      isDisconnected?: boolean | null,
      highnoteProductId?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      cardProfileId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPaidolHighnoteIntegrationByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaidolHighnoteIntegrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolHighnoteIntegrationByPaidolIdQuery = {
  listPaidolHighnoteIntegrationByPaidolId?:  {
    __typename: "ModelPaidolHighnoteIntegrationConnection",
    items:  Array< {
      __typename: "PaidolHighnoteIntegration",
      // id and paidolId are the same; corresponds to Paidol.id
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      id: string,
      paidolId: string,
      userId?: string | null,
      legalBusinessName?: string | null,
      businessAccountHolderId?: string | null,
      primaryAuthorizedPersonId?: string | null,
      financialAccountId?: string | null,
      externalFinancialBankAccountId?: string | null,
      hasInitialFunding?: boolean | null,
      accountHolderCardProductApplicationId?: string | null,
      isApplicationAccepted?: boolean | null,
      isDisconnected?: boolean | null,
      highnoteProductId?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      cardProfileId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHighnotePaymentCardQueryVariables = {
  paymentCardId: string,
};

export type GetHighnotePaymentCardQuery = {
  getHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHighnotePaymentCardsQueryVariables = {
  paymentCardId?: string | null,
  filter?: ModelHighnotePaymentCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHighnotePaymentCardsQuery = {
  listHighnotePaymentCards?:  {
    __typename: "ModelHighnotePaymentCardConnection",
    items:  Array< {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnotePaymentCardsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnotePaymentCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnotePaymentCardsByPaidolIdQuery = {
  listHighnotePaymentCardsByPaidolId?:  {
    __typename: "ModelHighnotePaymentCardConnection",
    items:  Array< {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchHighnotePaymentCardsQueryVariables = {
  filter?: SearchableHighnotePaymentCardFilterInput | null,
  sort?: Array< SearchableHighnotePaymentCardSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableHighnotePaymentCardAggregationInput | null > | null,
};

export type SearchHighnotePaymentCardsQuery = {
  searchHighnotePaymentCards?:  {
    __typename: "SearchableHighnotePaymentCardConnection",
    items:  Array< {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSpendRulesQueryVariables = {
  spendRuleId: string,
};

export type GetSpendRulesQuery = {
  getSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSpendRulesQueryVariables = {
  spendRuleId?: string | null,
  filter?: ModelSpendRulesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSpendRulesQuery = {
  listSpendRules?:  {
    __typename: "ModelSpendRulesConnection",
    items:  Array< {
      __typename: "SpendRules",
      spendRuleId: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      streetAddressAllowed?: Array< string | null > | null,
      streetAddressBlocked?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSpendRulesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSpendRulesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSpendRulesByPaidolIdQuery = {
  listSpendRulesByPaidolId?:  {
    __typename: "ModelSpendRulesConnection",
    items:  Array< {
      __typename: "SpendRules",
      spendRuleId: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      streetAddressAllowed?: Array< string | null > | null,
      streetAddressBlocked?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVelocityRulesQueryVariables = {
  velocityRuleId: string,
};

export type GetVelocityRulesQuery = {
  getVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVelocityRulesQueryVariables = {
  velocityRuleId?: string | null,
  filter?: ModelVelocityRulesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListVelocityRulesQuery = {
  listVelocityRules?:  {
    __typename: "ModelVelocityRulesConnection",
    items:  Array< {
      __typename: "VelocityRules",
      velocityRuleId: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      cumulativeRuleId: string,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVelocityRulesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVelocityRulesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVelocityRulesByPaidolIdQuery = {
  listVelocityRulesByPaidolId?:  {
    __typename: "ModelVelocityRulesConnection",
    items:  Array< {
      __typename: "VelocityRules",
      velocityRuleId: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      cumulativeRuleId: string,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBudgetSpendByMonthQueryVariables = {
  paidolId: string,
  yearAndMonth: string,
};

export type GetBudgetSpendByMonthQuery = {
  getBudgetSpendByMonth?:  {
    __typename: "BudgetSpendByMonth",
    paidolId: string,
    authPaidolId: string,
    yearAndMonth: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBudgetSpendByMonthsQueryVariables = {
  paidolId?: string | null,
  yearAndMonth?: ModelStringKeyConditionInput | null,
  filter?: ModelBudgetSpendByMonthFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBudgetSpendByMonthsQuery = {
  listBudgetSpendByMonths?:  {
    __typename: "ModelBudgetSpendByMonthConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonth",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBudgetSpendByMonthAndMerchantQueryVariables = {
  paidolId: string,
  yearAndMonth: string,
  merchantName: string,
};

export type GetBudgetSpendByMonthAndMerchantQuery = {
  getBudgetSpendByMonthAndMerchant?:  {
    __typename: "BudgetSpendByMonthAndMerchant",
    paidolId: string,
    authPaidolId: string,
    yearAndMonth: string,
    merchantName: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBudgetSpendByMonthAndMerchantsQueryVariables = {
  paidolId?: string | null,
  yearAndMonthMerchantName?: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyConditionInput | null,
  filter?: ModelBudgetSpendByMonthAndMerchantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBudgetSpendByMonthAndMerchantsQuery = {
  listBudgetSpendByMonthAndMerchants?:  {
    __typename: "ModelBudgetSpendByMonthAndMerchantConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndMerchant",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      merchantName: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBudgetSpendByMonthAndMerchantByAmountQueryVariables = {
  paidolId: string,
  yearAndMonthAmount?: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBudgetSpendByMonthAndMerchantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBudgetSpendByMonthAndMerchantByAmountQuery = {
  listBudgetSpendByMonthAndMerchantByAmount?:  {
    __typename: "ModelBudgetSpendByMonthAndMerchantConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndMerchant",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      merchantName: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBudgetSpendByMonthAndCategoryQueryVariables = {
  paidolId: string,
  yearAndMonth: string,
  category: string,
};

export type GetBudgetSpendByMonthAndCategoryQuery = {
  getBudgetSpendByMonthAndCategory?:  {
    __typename: "BudgetSpendByMonthAndCategory",
    paidolId: string,
    authPaidolId: string,
    yearAndMonth: string,
    category: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBudgetSpendByMonthAndCategoriesQueryVariables = {
  paidolId?: string | null,
  yearAndMonthCategory?: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyConditionInput | null,
  filter?: ModelBudgetSpendByMonthAndCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBudgetSpendByMonthAndCategoriesQuery = {
  listBudgetSpendByMonthAndCategories?:  {
    __typename: "ModelBudgetSpendByMonthAndCategoryConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndCategory",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      category: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBudgetSpendByMonthAndCategoryByAmountQueryVariables = {
  paidolId: string,
  yearAndMonthAmount?: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBudgetSpendByMonthAndCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBudgetSpendByMonthAndCategoryByAmountQuery = {
  listBudgetSpendByMonthAndCategoryByAmount?:  {
    __typename: "ModelBudgetSpendByMonthAndCategoryConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndCategory",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      category: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBudgetSpendByMonthAndPaymentCardQueryVariables = {
  paidolId: string,
  yearAndMonth: string,
  paymentCardId: string,
};

export type GetBudgetSpendByMonthAndPaymentCardQuery = {
  getBudgetSpendByMonthAndPaymentCard?:  {
    __typename: "BudgetSpendByMonthAndPaymentCard",
    paidolId: string,
    authPaidolId: string,
    yearAndMonth: string,
    paymentCardId: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBudgetSpendByMonthAndPaymentCardsQueryVariables = {
  paidolId?: string | null,
  yearAndMonthPaymentCardId?: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyConditionInput | null,
  filter?: ModelBudgetSpendByMonthAndPaymentCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBudgetSpendByMonthAndPaymentCardsQuery = {
  listBudgetSpendByMonthAndPaymentCards?:  {
    __typename: "ModelBudgetSpendByMonthAndPaymentCardConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndPaymentCard",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      paymentCardId: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBudgetSpendByMonthAndJobCodeIdQueryVariables = {
  paidolId: string,
  yearAndMonth: string,
  jobCodeId: string,
};

export type GetBudgetSpendByMonthAndJobCodeIdQuery = {
  getBudgetSpendByMonthAndJobCodeId?:  {
    __typename: "BudgetSpendByMonthAndJobCodeId",
    paidolId: string,
    authPaidolId: string,
    yearAndMonth: string,
    jobCodeId: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBudgetSpendByMonthAndJobCodeIdsQueryVariables = {
  paidolId?: string | null,
  yearAndMonthJobCodeId?: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyConditionInput | null,
  filter?: ModelBudgetSpendByMonthAndJobCodeIdFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBudgetSpendByMonthAndJobCodeIdsQuery = {
  listBudgetSpendByMonthAndJobCodeIds?:  {
    __typename: "ModelBudgetSpendByMonthAndJobCodeIdConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndJobCodeId",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      jobCodeId: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBudgetSpendByMonthAndJobCodeIdByAmountQueryVariables = {
  paidolId: string,
  yearAndMonthAmount?: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBudgetSpendByMonthAndJobCodeIdFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBudgetSpendByMonthAndJobCodeIdByAmountQuery = {
  listBudgetSpendByMonthAndJobCodeIdByAmount?:  {
    __typename: "ModelBudgetSpendByMonthAndJobCodeIdConnection",
    items:  Array< {
      __typename: "BudgetSpendByMonthAndJobCodeId",
      paidolId: string,
      authPaidolId: string,
      yearAndMonth: string,
      jobCodeId: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMccQueryVariables = {
  id: string,
};

export type GetMccQuery = {
  getMcc?:  {
    __typename: "Mcc",
    id: string,
    code: number,
    highnoteDescription: HNMerchantCategory,
    highnoteCategoryDescription?: string | null,
    speedchainDescription?: string | null,
    expenseTypes?:  {
      __typename: "ModelExpenseTypeToMCCConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMccsQueryVariables = {
  id?: string | null,
  filter?: ModelMccFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMccsQuery = {
  listMccs?:  {
    __typename: "ModelMccConnection",
    items:  Array< {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetExpenseTypeQueryVariables = {
  id: string,
};

export type GetExpenseTypeQuery = {
  getExpenseType?:  {
    __typename: "ExpenseType",
    id: string,
    name: string,
    codes?:  {
      __typename: "ModelExpenseTypeToMCCConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListExpenseTypesQueryVariables = {
  id?: string | null,
  filter?: ModelExpenseTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpenseTypesQuery = {
  listExpenseTypes?:  {
    __typename: "ModelExpenseTypeConnection",
    items:  Array< {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReceiptSummaryFieldQueryVariables = {
  id: string,
};

export type GetReceiptSummaryFieldQuery = {
  getReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReceiptSummaryFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelReceiptSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReceiptSummaryFieldsQuery = {
  listReceiptSummaryFields?:  {
    __typename: "ModelReceiptSummaryFieldConnection",
    items:  Array< {
      __typename: "ReceiptSummaryField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore?: number | null,
      label?: string | null,
      labelConfidenceScore?: number | null,
      value?: string | null,
      valueConfidenceScore?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReceiptSummaryFieldsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReceiptSummaryFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReceiptSummaryFieldsByPaidolIdQuery = {
  listReceiptSummaryFieldsByPaidolId?:  {
    __typename: "ModelReceiptSummaryFieldConnection",
    items:  Array< {
      __typename: "ReceiptSummaryField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore?: number | null,
      label?: string | null,
      labelConfidenceScore?: number | null,
      value?: string | null,
      valueConfidenceScore?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReceiptSummaryFieldsQueryVariables = {
  filter?: SearchableReceiptSummaryFieldFilterInput | null,
  sort?: Array< SearchableReceiptSummaryFieldSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReceiptSummaryFieldAggregationInput | null > | null,
};

export type SearchReceiptSummaryFieldsQuery = {
  searchReceiptSummaryFields?:  {
    __typename: "SearchableReceiptSummaryFieldConnection",
    items:  Array< {
      __typename: "ReceiptSummaryField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore?: number | null,
      label?: string | null,
      labelConfidenceScore?: number | null,
      value?: string | null,
      valueConfidenceScore?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReceiptLineItemQueryVariables = {
  id: string,
};

export type GetReceiptLineItemQuery = {
  getReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReceiptLineItemsQueryVariables = {
  id?: string | null,
  filter?: ModelReceiptLineItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReceiptLineItemsQuery = {
  listReceiptLineItems?:  {
    __typename: "ModelReceiptLineItemConnection",
    items:  Array< {
      __typename: "ReceiptLineItem",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReceiptLineItemByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReceiptLineItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReceiptLineItemByPaidolIdQuery = {
  listReceiptLineItemByPaidolId?:  {
    __typename: "ModelReceiptLineItemConnection",
    items:  Array< {
      __typename: "ReceiptLineItem",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReceiptLineItemsQueryVariables = {
  filter?: SearchableReceiptLineItemFilterInput | null,
  sort?: Array< SearchableReceiptLineItemSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReceiptLineItemAggregationInput | null > | null,
};

export type SearchReceiptLineItemsQuery = {
  searchReceiptLineItems?:  {
    __typename: "SearchableReceiptLineItemConnection",
    items:  Array< {
      __typename: "ReceiptLineItem",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptUploadId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReceiptLineItemFieldQueryVariables = {
  id: string,
};

export type GetReceiptLineItemFieldQuery = {
  getReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReceiptLineItemFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelReceiptLineItemFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReceiptLineItemFieldsQuery = {
  listReceiptLineItemFields?:  {
    __typename: "ModelReceiptLineItemFieldConnection",
    items:  Array< {
      __typename: "ReceiptLineItemField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptLineItemId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore: number,
      label: string,
      labelConfidenceScore: number,
      value: string,
      valueConfidenceScore: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReceiptLineItemFieldsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReceiptLineItemFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReceiptLineItemFieldsByPaidolIdQuery = {
  listReceiptLineItemFieldsByPaidolId?:  {
    __typename: "ModelReceiptLineItemFieldConnection",
    items:  Array< {
      __typename: "ReceiptLineItemField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptLineItemId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore: number,
      label: string,
      labelConfidenceScore: number,
      value: string,
      valueConfidenceScore: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReceiptLineItemFieldsQueryVariables = {
  filter?: SearchableReceiptLineItemFieldFilterInput | null,
  sort?: Array< SearchableReceiptLineItemFieldSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReceiptLineItemFieldAggregationInput | null > | null,
};

export type SearchReceiptLineItemFieldsQuery = {
  searchReceiptLineItemFields?:  {
    __typename: "SearchableReceiptLineItemFieldConnection",
    items:  Array< {
      __typename: "ReceiptLineItemField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      receiptLineItemId: string,
      type: NormalizedSummaryField,
      typeConfidenceScore: number,
      label: string,
      labelConfidenceScore: number,
      value: string,
      valueConfidenceScore: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReceiptUploadQueryVariables = {
  id: string,
};

export type GetReceiptUploadQuery = {
  getReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReceiptUploadsQueryVariables = {
  id?: string | null,
  filter?: ModelReceiptUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReceiptUploadsQuery = {
  listReceiptUploads?:  {
    __typename: "ModelReceiptUploadConnection",
    items:  Array< {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReceiptUploadsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReceiptUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReceiptUploadsByPaidolIdQuery = {
  listReceiptUploadsByPaidolId?:  {
    __typename: "ModelReceiptUploadConnection",
    items:  Array< {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReceiptUploadsQueryVariables = {
  filter?: SearchableReceiptUploadFilterInput | null,
  sort?: Array< SearchableReceiptUploadSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReceiptUploadAggregationInput | null > | null,
};

export type SearchReceiptUploadsQuery = {
  searchReceiptUploads?:  {
    __typename: "SearchableReceiptUploadConnection",
    items:  Array< {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetTransactionToReceiptUploadQueryVariables = {
  id: string,
};

export type GetTransactionToReceiptUploadQuery = {
  getTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type ListTransactionToReceiptUploadsQueryVariables = {
  id?: string | null,
  filter?: ModelTransactionToReceiptUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTransactionToReceiptUploadsQuery = {
  listTransactionToReceiptUploads?:  {
    __typename: "ModelTransactionToReceiptUploadConnection",
    items:  Array< {
      __typename: "TransactionToReceiptUpload",
      id: string,
      highnoteTransactionEventId?: string | null,
      reimbursementTransactionId?: string | null,
      receiptUploadId: string,
      createdAt: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTransactionToReceiptUploadsByHighnoteTransactionEventIdQueryVariables = {
  highnoteTransactionEventId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionToReceiptUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionToReceiptUploadsByHighnoteTransactionEventIdQuery = {
  listTransactionToReceiptUploadsByHighnoteTransactionEventId?:  {
    __typename: "ModelTransactionToReceiptUploadConnection",
    items:  Array< {
      __typename: "TransactionToReceiptUpload",
      id: string,
      highnoteTransactionEventId?: string | null,
      reimbursementTransactionId?: string | null,
      receiptUploadId: string,
      createdAt: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTransactionToReceiptUploadsByReimbursementTransactionIdQueryVariables = {
  reimbursementTransactionId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionToReceiptUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionToReceiptUploadsByReimbursementTransactionIdQuery = {
  listTransactionToReceiptUploadsByReimbursementTransactionId?:  {
    __typename: "ModelTransactionToReceiptUploadConnection",
    items:  Array< {
      __typename: "TransactionToReceiptUpload",
      id: string,
      highnoteTransactionEventId?: string | null,
      reimbursementTransactionId?: string | null,
      receiptUploadId: string,
      createdAt: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchTransactionToReceiptUploadsQueryVariables = {
  filter?: SearchableTransactionToReceiptUploadFilterInput | null,
  sort?: Array< SearchableTransactionToReceiptUploadSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTransactionToReceiptUploadAggregationInput | null > | null,
};

export type SearchTransactionToReceiptUploadsQuery = {
  searchTransactionToReceiptUploads?:  {
    __typename: "SearchableTransactionToReceiptUploadConnection",
    items:  Array< {
      __typename: "TransactionToReceiptUpload",
      id: string,
      highnoteTransactionEventId?: string | null,
      reimbursementTransactionId?: string | null,
      receiptUploadId: string,
      createdAt: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTransactionsQueryVariables = {
  id?: string | null,
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTransactionsQuery = {
  listTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      transactionDate: string,
      reimbursementTransactionId?: string | null,
      highnoteTransactionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTransactionsByPaidolIdQueryVariables = {
  paidolId: string,
  transactionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsByPaidolIdQuery = {
  listTransactionsByPaidolId?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      transactionDate: string,
      reimbursementTransactionId?: string | null,
      highnoteTransactionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchTransactionsQueryVariables = {
  filter?: SearchableTransactionFilterInput | null,
  sort?: Array< SearchableTransactionSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTransactionAggregationInput | null > | null,
};

export type SearchTransactionsQuery = {
  searchTransactions?:  {
    __typename: "SearchableTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      transactionDate: string,
      reimbursementTransactionId?: string | null,
      highnoteTransactionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReimbursementTransactionQueryVariables = {
  id: string,
};

export type GetReimbursementTransactionQuery = {
  getReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReimbursementTransactionsQueryVariables = {
  id?: string | null,
  filter?: ModelReimbursementTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReimbursementTransactionsQuery = {
  listReimbursementTransactions?:  {
    __typename: "ModelReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReimbursementTransactionsByPaidolIdQueryVariables = {
  paidolId: string,
  transactionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReimbursementTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReimbursementTransactionsByPaidolIdQuery = {
  listReimbursementTransactionsByPaidolId?:  {
    __typename: "ModelReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReimbursementTransactionByPaidolUserIdQueryVariables = {
  paidolUserId: string,
  paidolId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReimbursementTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ReimbursementTransactionByPaidolUserIdQuery = {
  reimbursementTransactionByPaidolUserId?:  {
    __typename: "ModelReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReimbursementTransactionByExpenseTypeIdQueryVariables = {
  expenseTypeId: string,
  paidolId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReimbursementTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ReimbursementTransactionByExpenseTypeIdQuery = {
  reimbursementTransactionByExpenseTypeId?:  {
    __typename: "ModelReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReimbursementTransactionByReceiptIdQueryVariables = {
  receiptId: string,
  paidolId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReimbursementTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ReimbursementTransactionByReceiptIdQuery = {
  reimbursementTransactionByReceiptId?:  {
    __typename: "ModelReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReimbursementTransactionsQueryVariables = {
  filter?: SearchableReimbursementTransactionFilterInput | null,
  sort?: Array< SearchableReimbursementTransactionSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReimbursementTransactionAggregationInput | null > | null,
};

export type SearchReimbursementTransactionsQuery = {
  searchReimbursementTransactions?:  {
    __typename: "SearchableReimbursementTransactionConnection",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetHighnoteTransactionQueryVariables = {
  transactionId: string,
};

export type GetHighnoteTransactionQuery = {
  getHighnoteTransaction?:  {
    __typename: "HighnoteTransaction",
    transactionId: string,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status: HighnoteTransactionStatus,
    transactionDate: string,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    merchantName?: string | null,
    merchantCategoryCode?: string | null,
    // Our custom category mapping, based on original MCCCode
    merchantCategory?: string | null,
    // An array of source TransactionEvents payloads from the Highnote API.
    // May be useful in future if we need to backfill this data with additional
    // fields. This data is in its original JSON-serialized format.
    transactionEvents?: Array< string | null > | null,
    note?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreCompanyId?: number | null,
    procoreCompany?:  {
      __typename: "GetProcoreCompaniesPayload",
      id: number,
      name: string,
      is_active: boolean,
      logo_url?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocationId?: string | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    // AWS S3 receipt upload path
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
    erpApprovalStatus?: boolean | null,
    // Track when a transaction is marked to bypass ERP posting (acts like posted)
    erpBypassStatus?: boolean | null,
    last4?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The email from paidolUser assigned to the Highnote Payment Card
    email?: string | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    selectedCodingOption?: CodingOptions | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveGlCostTypeId?: string | null,
    agaveGlCostType?:  {
      __typename: "AgaveGlCostType",
      id?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    approveWithoutNotes?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHighnoteTransactionsQueryVariables = {
  transactionId?: string | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHighnoteTransactionsQuery = {
  listHighnoteTransactions?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionsByPaymentCardIdQueryVariables = {
  paymentCardId: string,
  transactionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionsByPaymentCardIdQuery = {
  listHighnoteTransactionsByPaymentCardId?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionsByPaidolIdQueryVariables = {
  paidolId: string,
  transactionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionsByPaidolIdQuery = {
  listHighnoteTransactionsByPaidolId?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionsByCardGroupIdQueryVariables = {
  cardGroupId: string,
  transactionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionsByCardGroupIdQuery = {
  listHighnoteTransactionsByCardGroupId?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionsByAgaveVendorIdQueryVariables = {
  agaveVendorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionsByAgaveVendorIdQuery = {
  listHighnoteTransactionsByAgaveVendorId?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HighnoteTransactionByReceiptIdQueryVariables = {
  receiptId: string,
  paidolId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HighnoteTransactionByReceiptIdQuery = {
  highnoteTransactionByReceiptId?:  {
    __typename: "ModelHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchHighnoteTransactionsQueryVariables = {
  filter?: SearchableHighnoteTransactionFilterInput | null,
  sort?: Array< SearchableHighnoteTransactionSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableHighnoteTransactionAggregationInput | null > | null,
};

export type SearchHighnoteTransactionsQuery = {
  searchHighnoteTransactions?:  {
    __typename: "SearchableHighnoteTransactionConnection",
    items:  Array< {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetProjectGroupQueryVariables = {
  id: string,
};

export type GetProjectGroupQuery = {
  getProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProjectGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelProjectGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProjectGroupsQuery = {
  listProjectGroups?:  {
    __typename: "ModelProjectGroupConnection",
    items:  Array< {
      __typename: "ProjectGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProjectGroupsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProjectGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProjectGroupsByPaidolIdQuery = {
  listProjectGroupsByPaidolId?:  {
    __typename: "ModelProjectGroupConnection",
    items:  Array< {
      __typename: "ProjectGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCardGroupQueryVariables = {
  id: string,
};

export type GetCardGroupQuery = {
  getCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCardGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelCardGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCardGroupsQuery = {
  listCardGroups?:  {
    __typename: "ModelCardGroupConnection",
    items:  Array< {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCardGroupsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCardGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCardGroupsByPaidolIdQuery = {
  listCardGroupsByPaidolId?:  {
    __typename: "ModelCardGroupConnection",
    items:  Array< {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolUserToProjectGroupQueryVariables = {
  id: string,
};

export type GetPaidolUserToProjectGroupQuery = {
  getPaidolUserToProjectGroup?:  {
    __typename: "PaidolUserToProjectGroup",
    id: string,
    paidolId: string,
    paidolUserId: string,
    projectGroupId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    projectGroup:  {
      __typename: "ProjectGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    approvalLevels?: Array< number | null > | null,
    isReviewer?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolUserToProjectGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelPaidolUserToProjectGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPaidolUserToProjectGroupsQuery = {
  listPaidolUserToProjectGroups?:  {
    __typename: "ModelPaidolUserToProjectGroupConnection",
    items:  Array< {
      __typename: "PaidolUserToProjectGroup",
      id: string,
      paidolId: string,
      paidolUserId: string,
      projectGroupId: string,
      approvalLevels?: Array< number | null > | null,
      isReviewer?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolUserToCardGroupQueryVariables = {
  id: string,
};

export type GetPaidolUserToCardGroupQuery = {
  getPaidolUserToCardGroup?:  {
    __typename: "PaidolUserToCardGroup",
    id: string,
    paidolId: string,
    paidolUserId: string,
    cardGroupId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardGroup:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    approvalLevels?: Array< number | null > | null,
    isReviewer?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaidolUserToCardGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelPaidolUserToCardGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPaidolUserToCardGroupsQuery = {
  listPaidolUserToCardGroups?:  {
    __typename: "ModelPaidolUserToCardGroupConnection",
    items:  Array< {
      __typename: "PaidolUserToCardGroup",
      id: string,
      paidolId: string,
      paidolUserId: string,
      cardGroupId: string,
      approvalLevels?: Array< number | null > | null,
      isReviewer?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProjectGroupBudgetSpendByMonthQueryVariables = {
  cardGroupId: string,
  yearAndMonth: string,
};

export type GetProjectGroupBudgetSpendByMonthQuery = {
  getProjectGroupBudgetSpendByMonth?:  {
    __typename: "ProjectGroupBudgetSpendByMonth",
    cardGroupId: string,
    paidolId: string,
    yearAndMonth: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProjectGroupBudgetSpendByMonthsQueryVariables = {
  cardGroupId?: string | null,
  yearAndMonth?: ModelStringKeyConditionInput | null,
  filter?: ModelProjectGroupBudgetSpendByMonthFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProjectGroupBudgetSpendByMonthsQuery = {
  listProjectGroupBudgetSpendByMonths?:  {
    __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
    items:  Array< {
      __typename: "ProjectGroupBudgetSpendByMonth",
      cardGroupId: string,
      paidolId: string,
      yearAndMonth: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCardGroupBudgetSpendByMonthQueryVariables = {
  cardGroupId: string,
  yearAndMonth: string,
};

export type GetCardGroupBudgetSpendByMonthQuery = {
  getCardGroupBudgetSpendByMonth?:  {
    __typename: "CardGroupBudgetSpendByMonth",
    cardGroupId: string,
    paidolId: string,
    yearAndMonth: string,
    amount?: number | null,
    transactionCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCardGroupBudgetSpendByMonthsQueryVariables = {
  cardGroupId?: string | null,
  yearAndMonth?: ModelStringKeyConditionInput | null,
  filter?: ModelCardGroupBudgetSpendByMonthFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCardGroupBudgetSpendByMonthsQuery = {
  listCardGroupBudgetSpendByMonths?:  {
    __typename: "ModelCardGroupBudgetSpendByMonthConnection",
    items:  Array< {
      __typename: "CardGroupBudgetSpendByMonth",
      cardGroupId: string,
      paidolId: string,
      yearAndMonth: string,
      amount?: number | null,
      transactionCount?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaidolUserToHighnotePaymentCardQueryVariables = {
  id: string,
};

export type GetPaidolUserToHighnotePaymentCardQuery = {
  getPaidolUserToHighnotePaymentCard?:  {
    __typename: "PaidolUserToHighnotePaymentCard",
    id?: string | null,
    paidolUserID?: string | null,
    highnotePaymentCardID?: string | null,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnotePaymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListPaidolUserToHighnotePaymentCardsQueryVariables = {
  filter?: ModelPaidolUserToHighnotePaymentCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaidolUserToHighnotePaymentCardsQuery = {
  listPaidolUserToHighnotePaymentCards?:  {
    __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
    items:  Array< {
      __typename: "PaidolUserToHighnotePaymentCard",
      id?: string | null,
      paidolUserID?: string | null,
      highnotePaymentCardID?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserNotificationPreferencesQueryVariables = {
  id: string,
};

export type GetUserNotificationPreferencesQuery = {
  getUserNotificationPreferences?:  {
    __typename: "UserNotificationPreferences",
    id: string,
    userId: string,
    paidolId?: string | null,
    transactionAlertSms?: boolean | null,
    transactionAlertEmail?: boolean | null,
    cardLockedSms?: boolean | null,
    cardLockedEmail?: boolean | null,
    manualCardActionSms?: boolean | null,
    manualCardActionEmail?: boolean | null,
    lowBalanceAlertSms?: boolean | null,
    lowBalanceAlertEmail?: boolean | null,
    cardActivationSms?: boolean | null,
    cardActivationEmail?: boolean | null,
    statementReadySms?: boolean | null,
    statementReadyEmail?: boolean | null,
    txnReviewFrequency?: string | null,
    txnReviewCodeUpdateSms?: boolean | null,
    txnReviewCodeUpdateEmail?: boolean | null,
    txnReviewNoteUpdateSms?: boolean | null,
    txnReviewNoteUpdateEmail?: boolean | null,
    txnReviewReceiptUpdateSms?: boolean | null,
    txnReviewReceiptUpdateEmail?: boolean | null,
    txnReviewResubmissionSms?: boolean | null,
    txnReviewResubmissionEmail?: boolean | null,
    txnReviewReadySms?: boolean | null,
    txnReviewReadyEmail?: boolean | null,
    returnedTransactionSms?: boolean | null,
    returnedTransactionEmail?: boolean | null,
    smsConsentAccepted?: boolean | null,
    smsConsentAcceptedAt?: string | null,
    platformAgreementVersion?: string | null,
    hasReceivedWelcomeSms?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListUserNotificationPreferencesQueryVariables = {
  filter?: ModelUserNotificationPreferencesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserNotificationPreferencesQuery = {
  listUserNotificationPreferences?:  {
    __typename: "ModelUserNotificationPreferencesConnection",
    items:  Array< {
      __typename: "UserNotificationPreferences",
      id: string,
      userId: string,
      paidolId?: string | null,
      transactionAlertSms?: boolean | null,
      transactionAlertEmail?: boolean | null,
      cardLockedSms?: boolean | null,
      cardLockedEmail?: boolean | null,
      manualCardActionSms?: boolean | null,
      manualCardActionEmail?: boolean | null,
      lowBalanceAlertSms?: boolean | null,
      lowBalanceAlertEmail?: boolean | null,
      cardActivationSms?: boolean | null,
      cardActivationEmail?: boolean | null,
      statementReadySms?: boolean | null,
      statementReadyEmail?: boolean | null,
      txnReviewFrequency?: string | null,
      txnReviewCodeUpdateSms?: boolean | null,
      txnReviewCodeUpdateEmail?: boolean | null,
      txnReviewNoteUpdateSms?: boolean | null,
      txnReviewNoteUpdateEmail?: boolean | null,
      txnReviewReceiptUpdateSms?: boolean | null,
      txnReviewReceiptUpdateEmail?: boolean | null,
      txnReviewResubmissionSms?: boolean | null,
      txnReviewResubmissionEmail?: boolean | null,
      txnReviewReadySms?: boolean | null,
      txnReviewReadyEmail?: boolean | null,
      returnedTransactionSms?: boolean | null,
      returnedTransactionEmail?: boolean | null,
      smsConsentAccepted?: boolean | null,
      smsConsentAcceptedAt?: string | null,
      platformAgreementVersion?: string | null,
      hasReceivedWelcomeSms?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMerchantSpendRuleQueryVariables = {
  id: string,
};

export type GetMerchantSpendRuleQuery = {
  getMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMerchantSpendRulesQueryVariables = {
  id?: string | null,
  filter?: ModelMerchantSpendRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMerchantSpendRulesQuery = {
  listMerchantSpendRules?:  {
    __typename: "ModelMerchantSpendRuleConnection",
    items:  Array< {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMerchantSpendRulesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMerchantSpendRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMerchantSpendRulesByPaidolIdQuery = {
  listMerchantSpendRulesByPaidolId?:  {
    __typename: "ModelMerchantSpendRuleConnection",
    items:  Array< {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTransactionsDownloadQueueQueryVariables = {
  id: string,
};

export type GetTransactionsDownloadQueueQuery = {
  getTransactionsDownloadQueue?:  {
    __typename: "TransactionsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    range_option: ExportDateRangeEnum,
    start_date?: string | null,
    end_date?: string | null,
    columns: Array< string >,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    paidolUserId?: string | null,
    mark_as_exported?: boolean | null,
    exported_count?: number | null,
    skipped_count?: number | null,
    updatedAt: string,
  } | null,
};

export type ListTransactionsDownloadQueuesQueryVariables = {
  filter?: ModelTransactionsDownloadQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsDownloadQueuesQuery = {
  listTransactionsDownloadQueues?:  {
    __typename: "ModelTransactionsDownloadQueueConnection",
    items:  Array< {
      __typename: "TransactionsDownloadQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      range_option: ExportDateRangeEnum,
      start_date?: string | null,
      end_date?: string | null,
      columns: Array< string >,
      s3_key?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      createdAt: string,
      paidolUserId?: string | null,
      mark_as_exported?: boolean | null,
      exported_count?: number | null,
      skipped_count?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TransactionsDownloadByPaidolIdQueryVariables = {
  paidol_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionsDownloadQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TransactionsDownloadByPaidolIdQuery = {
  transactionsDownloadByPaidolId?:  {
    __typename: "ModelTransactionsDownloadQueueConnection",
    items:  Array< {
      __typename: "TransactionsDownloadQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      range_option: ExportDateRangeEnum,
      start_date?: string | null,
      end_date?: string | null,
      columns: Array< string >,
      s3_key?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      createdAt: string,
      paidolUserId?: string | null,
      mark_as_exported?: boolean | null,
      exported_count?: number | null,
      skipped_count?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTransactionsReceiptsDownloadQueueQueryVariables = {
  id: string,
};

export type GetTransactionsReceiptsDownloadQueueQuery = {
  getTransactionsReceiptsDownloadQueue?:  {
    __typename: "TransactionsReceiptsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    paidolUserId?: string | null,
    s3_key?: string | null,
    range_option?: ExportDateRangeEnum | null,
    start_date?: string | null,
    end_date?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
    // EXPORT_FAILED) so the frontend can show an honest message instead of a
    // generic "no receipts found".
    error_code?: string | null,
    createdAt: string,
    filteredTransactionIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type ListTransactionsReceiptsDownloadQueuesQueryVariables = {
  filter?: ModelTransactionsReceiptsDownloadQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsReceiptsDownloadQueuesQuery = {
  listTransactionsReceiptsDownloadQueues?:  {
    __typename: "ModelTransactionsReceiptsDownloadQueueConnection",
    items:  Array< {
      __typename: "TransactionsReceiptsDownloadQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      paidolUserId?: string | null,
      s3_key?: string | null,
      range_option?: ExportDateRangeEnum | null,
      start_date?: string | null,
      end_date?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
      // EXPORT_FAILED) so the frontend can show an honest message instead of a
      // generic "no receipts found".
      error_code?: string | null,
      createdAt: string,
      filteredTransactionIds?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TransactionsReceiptsDownloadByPaidolIdQueryVariables = {
  paidol_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionsReceiptsDownloadQueueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TransactionsReceiptsDownloadByPaidolIdQuery = {
  transactionsReceiptsDownloadByPaidolId?:  {
    __typename: "ModelTransactionsReceiptsDownloadQueueConnection",
    items:  Array< {
      __typename: "TransactionsReceiptsDownloadQueue",
      id: string,
      user_id: string,
      paidol_id: string,
      paidolUserId?: string | null,
      s3_key?: string | null,
      range_option?: ExportDateRangeEnum | null,
      start_date?: string | null,
      end_date?: string | null,
      cron_status?: PaymentStatusDownloadStatusEnum | null,
      // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
      // EXPORT_FAILED) so the frontend can show an honest message instead of a
      // generic "no receipts found".
      error_code?: string | null,
      createdAt: string,
      filteredTransactionIds?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSpendRuleConfigQueryVariables = {
  id: string,
};

export type GetSpendRuleConfigQuery = {
  getSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSpendRuleConfigsQueryVariables = {
  id?: string | null,
  filter?: ModelSpendRuleConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSpendRuleConfigsQuery = {
  listSpendRuleConfigs?:  {
    __typename: "ModelSpendRuleConfigConnection",
    items:  Array< {
      __typename: "SpendRuleConfig",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      ruleId: string,
      ruleType: SpendRuleType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSpendRulesConfigByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSpendRuleConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSpendRulesConfigByPaidolIdQuery = {
  listSpendRulesConfigByPaidolId?:  {
    __typename: "ModelSpendRuleConfigConnection",
    items:  Array< {
      __typename: "SpendRuleConfig",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      ruleId: string,
      ruleType: SpendRuleType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetJobCodeImportQueryVariables = {
  id: string,
};

export type GetJobCodeImportQuery = {
  getJobCodeImport?:  {
    __typename: "JobCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    storageFileKey: string,
    fileName: string,
    status: JobCodeImportStatus,
    errors?: string | null,
    jobCodes?:  {
      __typename: "ModelJobCodeConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListJobCodeImportsQueryVariables = {
  id?: string | null,
  filter?: ModelJobCodeImportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListJobCodeImportsQuery = {
  listJobCodeImports?:  {
    __typename: "ModelJobCodeImportConnection",
    items:  Array< {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type JobCodeImportByPaidolIdQueryVariables = {
  paidolId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobCodeImportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobCodeImportByPaidolIdQuery = {
  jobCodeImportByPaidolId?:  {
    __typename: "ModelJobCodeImportConnection",
    items:  Array< {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetJobCodeQueryVariables = {
  id: string,
};

export type GetJobCodeQuery = {
  getJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListJobCodesQueryVariables = {
  id?: string | null,
  filter?: ModelJobCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListJobCodesQuery = {
  listJobCodes?:  {
    __typename: "ModelJobCodeConnection",
    items?:  Array< {
      __typename: "GetJobCodesJobCodePayload",
      id: string,
      paidolId: string,
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type JobCodeByJobCodeImportIdQueryVariables = {
  jobCodeImportId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobCodeByJobCodeImportIdQuery = {
  jobCodeByJobCodeImportId?:  {
    __typename: "ModelJobCodeConnection",
    items?:  Array< {
      __typename: "GetJobCodesJobCodePayload",
      id: string,
      paidolId: string,
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetFlexCodeImportQueryVariables = {
  id: string,
};

export type GetFlexCodeImportQuery = {
  getFlexCodeImport?:  {
    __typename: "FlexCodeImport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    updatedAt: string,
    storageFileKey: string,
    fileName: string,
    status: FlexCodeImportStatus,
    errors?: string | null,
    searchSynced?: boolean | null,
    flexCodes?:  {
      __typename: "ModelFlexCodeConnection",
      nextToken?: string | null,
    } | null,
    type: FlexCodeImportType,
  } | null,
};

export type ListFlexCodeImportsQueryVariables = {
  id?: string | null,
  filter?: ModelFlexCodeImportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexCodeImportsQuery = {
  listFlexCodeImports?:  {
    __typename: "ModelFlexCodeImportConnection",
    items:  Array< {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexCodeImportByPaidolIdQueryVariables = {
  paidolId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCodeImportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexCodeImportByPaidolIdQuery = {
  flexCodeImportByPaidolId?:  {
    __typename: "ModelFlexCodeImportConnection",
    items:  Array< {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFlexTransactionExportQueryVariables = {
  id: string,
};

export type GetFlexTransactionExportQuery = {
  getFlexTransactionExport?:  {
    __typename: "FlexTransactionExport",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    createdAt: string,
    updatedAt: string,
    // fileName/s3Key are the INTENDED destination, decided before upload — real at
    // create time and truthful on every status, including runs that failed before
    // the file reached the bucket.
    fileName: string,
    // Key of the delivered CSV in the customer's sftp-<slug>-<env> mailbox bucket.
    s3Key: string,
    // Number of transactions in the DELIVERED file. Set when the run finishes
    // (COMPLETED); absent while PROCESSING and on runs that failed before upload —
    // a 0 there would be a claim, not a fact. Does NOT include baseline stamps;
    // those are counted separately in baselineTransactionCount.
    transactionCount?: number | null,
    // Pre-enablement transactions this run marked handled-before-switch-on
    // ("baseline-<id>" on erpExportBatchId) instead of delivering. Those stamps are
    // permanent and never rolled back, so this field is the only durable record
    // they were written — set on ANY outcome (including ERROR), and never to be
    // surfaced to the customer as exported. Absent when the run baselined nothing.
    baselineTransactionCount?: number | null,
    // Oldest/newest transaction eventDate in the delivered batch — the run's
    // effective "window" for support. (Selection is state-driven — "qualifying and
    // not yet stamped" — with ONE permanent time bound: nothing dated before the
    // company's enablement window ever exports; see erpExportedAt on
    // HighnoteTransactionEvent.) Absent on empty runs.
    firstEventDate?: string | null,
    lastEventDate?: string | null,
    // byStatus exists for the operational lookup the unwind procedure starts from:
    // "which runs are stuck in PROCESSING right now, across all companies". A killed
    // process leaves a PROCESSING row and no alert naming the company, so without
    // this index finding it means a scan or a per-company query.
    // 
    // Deliberately NO queryField: this model's only auth is per-company dynamic
    // groups, so no AppSync principal has the cross-company read this index exists
    // for — a generated query would serve nobody and let each company page through
    // the global partitions. Incident responders use the console/CLI/the
    // V2DataAccess ByStatus entity index, which bypass AppSync.
    status: FlexTransactionExportStatus,
    // Customer-safe summary only (this field is group-readable by the company's own
    // users). Raw exception detail stays in CloudWatch + the internal alert.
    errors?: string | null,
  } | null,
};

export type ListFlexTransactionExportsQueryVariables = {
  id?: string | null,
  filter?: ModelFlexTransactionExportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexTransactionExportsQuery = {
  listFlexTransactionExports?:  {
    __typename: "ModelFlexTransactionExportConnection",
    items:  Array< {
      __typename: "FlexTransactionExport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      // fileName/s3Key are the INTENDED destination, decided before upload — real at
      // create time and truthful on every status, including runs that failed before
      // the file reached the bucket.
      fileName: string,
      // Key of the delivered CSV in the customer's sftp-<slug>-<env> mailbox bucket.
      s3Key: string,
      // Number of transactions in the DELIVERED file. Set when the run finishes
      // (COMPLETED); absent while PROCESSING and on runs that failed before upload —
      // a 0 there would be a claim, not a fact. Does NOT include baseline stamps;
      // those are counted separately in baselineTransactionCount.
      transactionCount?: number | null,
      // Pre-enablement transactions this run marked handled-before-switch-on
      // ("baseline-<id>" on erpExportBatchId) instead of delivering. Those stamps are
      // permanent and never rolled back, so this field is the only durable record
      // they were written — set on ANY outcome (including ERROR), and never to be
      // surfaced to the customer as exported. Absent when the run baselined nothing.
      baselineTransactionCount?: number | null,
      // Oldest/newest transaction eventDate in the delivered batch — the run's
      // effective "window" for support. (Selection is state-driven — "qualifying and
      // not yet stamped" — with ONE permanent time bound: nothing dated before the
      // company's enablement window ever exports; see erpExportedAt on
      // HighnoteTransactionEvent.) Absent on empty runs.
      firstEventDate?: string | null,
      lastEventDate?: string | null,
      // byStatus exists for the operational lookup the unwind procedure starts from:
      // "which runs are stuck in PROCESSING right now, across all companies". A killed
      // process leaves a PROCESSING row and no alert naming the company, so without
      // this index finding it means a scan or a per-company query.
      // 
      // Deliberately NO queryField: this model's only auth is per-company dynamic
      // groups, so no AppSync principal has the cross-company read this index exists
      // for — a generated query would serve nobody and let each company page through
      // the global partitions. Incident responders use the console/CLI/the
      // V2DataAccess ByStatus entity index, which bypass AppSync.
      status: FlexTransactionExportStatus,
      // Customer-safe summary only (this field is group-readable by the company's own
      // users). Raw exception detail stays in CloudWatch + the internal alert.
      errors?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexTransactionExportByPaidolIdQueryVariables = {
  paidolId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexTransactionExportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexTransactionExportByPaidolIdQuery = {
  flexTransactionExportByPaidolId?:  {
    __typename: "ModelFlexTransactionExportConnection",
    items:  Array< {
      __typename: "FlexTransactionExport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      // fileName/s3Key are the INTENDED destination, decided before upload — real at
      // create time and truthful on every status, including runs that failed before
      // the file reached the bucket.
      fileName: string,
      // Key of the delivered CSV in the customer's sftp-<slug>-<env> mailbox bucket.
      s3Key: string,
      // Number of transactions in the DELIVERED file. Set when the run finishes
      // (COMPLETED); absent while PROCESSING and on runs that failed before upload —
      // a 0 there would be a claim, not a fact. Does NOT include baseline stamps;
      // those are counted separately in baselineTransactionCount.
      transactionCount?: number | null,
      // Pre-enablement transactions this run marked handled-before-switch-on
      // ("baseline-<id>" on erpExportBatchId) instead of delivering. Those stamps are
      // permanent and never rolled back, so this field is the only durable record
      // they were written — set on ANY outcome (including ERROR), and never to be
      // surfaced to the customer as exported. Absent when the run baselined nothing.
      baselineTransactionCount?: number | null,
      // Oldest/newest transaction eventDate in the delivered batch — the run's
      // effective "window" for support. (Selection is state-driven — "qualifying and
      // not yet stamped" — with ONE permanent time bound: nothing dated before the
      // company's enablement window ever exports; see erpExportedAt on
      // HighnoteTransactionEvent.) Absent on empty runs.
      firstEventDate?: string | null,
      lastEventDate?: string | null,
      // byStatus exists for the operational lookup the unwind procedure starts from:
      // "which runs are stuck in PROCESSING right now, across all companies". A killed
      // process leaves a PROCESSING row and no alert naming the company, so without
      // this index finding it means a scan or a per-company query.
      // 
      // Deliberately NO queryField: this model's only auth is per-company dynamic
      // groups, so no AppSync principal has the cross-company read this index exists
      // for — a generated query would serve nobody and let each company page through
      // the global partitions. Incident responders use the console/CLI/the
      // V2DataAccess ByStatus entity index, which bypass AppSync.
      status: FlexTransactionExportStatus,
      // Customer-safe summary only (this field is group-readable by the company's own
      // users). Raw exception detail stays in CloudWatch + the internal alert.
      errors?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetV2FlexRelationshipsQueryVariables = {
  id: string,
};

export type GetV2FlexRelationshipsQuery = {
  getV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListV2FlexRelationshipsQueryVariables = {
  id?: string | null,
  filter?: ModelV2FlexRelationshipsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListV2FlexRelationshipsQuery = {
  listV2FlexRelationships?:  {
    __typename: "ModelV2FlexRelationshipsConnection",
    items:  Array< {
      __typename: "V2FlexRelationships",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      flexCodeImportId: string,
      // Denormalized entity names cached at import time so the dropdown handlers can sort,
      // search, and display directly off this index without a second query against the entity
      // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
      // fields are a read-time cache for the dropdown query path only.
      flexGlCodeName?: string | null,
      projectName?: string | null,
      projectCode?: string | null,
      flexCostCodeName?: string | null,
      flexCostTypeName?: string | null,
      flexVendorName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexRelationshipsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelV2FlexRelationshipsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexRelationshipsByPaidolIdQuery = {
  listFlexRelationshipsByPaidolId?:  {
    __typename: "ModelV2FlexRelationshipsConnection",
    items:  Array< {
      __typename: "V2FlexRelationships",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      flexCodeImportId: string,
      // Denormalized entity names cached at import time so the dropdown handlers can sort,
      // search, and display directly off this index without a second query against the entity
      // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
      // fields are a read-time cache for the dropdown query path only.
      flexGlCodeName?: string | null,
      projectName?: string | null,
      projectCode?: string | null,
      flexCostCodeName?: string | null,
      flexCostTypeName?: string | null,
      flexVendorName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexRelationshipsByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelV2FlexRelationshipsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexRelationshipsByFlexCodeImportIdQuery = {
  flexRelationshipsByFlexCodeImportId?:  {
    __typename: "ModelV2FlexRelationshipsConnection",
    items:  Array< {
      __typename: "V2FlexRelationships",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      flexCodeImportId: string,
      // Denormalized entity names cached at import time so the dropdown handlers can sort,
      // search, and display directly off this index without a second query against the entity
      // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
      // fields are a read-time cache for the dropdown query path only.
      flexGlCodeName?: string | null,
      projectName?: string | null,
      projectCode?: string | null,
      flexCostCodeName?: string | null,
      flexCostTypeName?: string | null,
      flexVendorName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchV2FlexRelationshipsQueryVariables = {
  filter?: SearchableV2FlexRelationshipsFilterInput | null,
  sort?: Array< SearchableV2FlexRelationshipsSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableV2FlexRelationshipsAggregationInput | null > | null,
};

export type SearchV2FlexRelationshipsQuery = {
  searchV2FlexRelationships?:  {
    __typename: "SearchableV2FlexRelationshipsConnection",
    items:  Array< {
      __typename: "V2FlexRelationships",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      flexCodeImportId: string,
      // Denormalized entity names cached at import time so the dropdown handlers can sort,
      // search, and display directly off this index without a second query against the entity
      // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
      // fields are a read-time cache for the dropdown query path only.
      flexGlCodeName?: string | null,
      projectName?: string | null,
      projectCode?: string | null,
      flexCostCodeName?: string | null,
      flexCostTypeName?: string | null,
      flexVendorName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexGlCodeQueryVariables = {
  id: string,
};

export type GetFlexGlCodeQuery = {
  getFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexGlCodesQueryVariables = {
  id?: string | null,
  filter?: ModelFlexGlCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexGlCodesQuery = {
  listFlexGlCodes?:  {
    __typename: "ModelFlexGlCodeConnection",
    items:  Array< {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexGlCodeByPaidolIdQueryVariables = {
  paidolId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexGlCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexGlCodeByPaidolIdQuery = {
  listFlexGlCodeByPaidolId?:  {
    __typename: "ModelFlexGlCodeConnection",
    items:  Array< {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexGlCodeByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexGlCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexGlCodeByFlexCodeImportIdQuery = {
  flexGlCodeByFlexCodeImportId?:  {
    __typename: "ModelFlexGlCodeConnection",
    items:  Array< {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexGlCodesQueryVariables = {
  filter?: SearchableFlexGlCodeFilterInput | null,
  sort?: Array< SearchableFlexGlCodeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexGlCodeAggregationInput | null > | null,
};

export type SearchFlexGlCodesQuery = {
  searchFlexGlCodes?:  {
    __typename: "SearchableFlexGlCodeConnection",
    items:  Array< {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexCodeQueryVariables = {
  id: string,
};

export type GetFlexCodeQuery = {
  getFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexCodesQueryVariables = {
  id?: string | null,
  filter?: ModelFlexCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexCodesQuery = {
  listFlexCodes?:  {
    __typename: "ModelFlexCodeConnection",
    items:  Array< {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexCodesByPaidolIdQueryVariables = {
  paidolId: string,
  projectName?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexCodesByPaidolIdQuery = {
  listFlexCodesByPaidolId?:  {
    __typename: "ModelFlexCodeConnection",
    items:  Array< {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexCodesByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  projectName?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexCodesByFlexCodeImportIdQuery = {
  flexCodesByFlexCodeImportId?:  {
    __typename: "ModelFlexCodeConnection",
    items:  Array< {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexCodesQueryVariables = {
  filter?: SearchableFlexCodeFilterInput | null,
  sort?: Array< SearchableFlexCodeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexCodeAggregationInput | null > | null,
};

export type SearchFlexCodesQuery = {
  searchFlexCodes?:  {
    __typename: "SearchableFlexCodeConnection",
    items:  Array< {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexCostCodeQueryVariables = {
  id: string,
};

export type GetFlexCostCodeQuery = {
  getFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexCostCodesQueryVariables = {
  id?: string | null,
  filter?: ModelFlexCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexCostCodesQuery = {
  listFlexCostCodes?:  {
    __typename: "ModelFlexCostCodeConnection",
    items:  Array< {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexCostCodesByPaidolIdQueryVariables = {
  paidolId: string,
  code?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexCostCodesByPaidolIdQuery = {
  listFlexCostCodesByPaidolId?:  {
    __typename: "ModelFlexCostCodeConnection",
    items:  Array< {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexCostCodesByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  code?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCostCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexCostCodesByFlexCodeImportIdQuery = {
  flexCostCodesByFlexCodeImportId?:  {
    __typename: "ModelFlexCostCodeConnection",
    items:  Array< {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexCostCodesQueryVariables = {
  filter?: SearchableFlexCostCodeFilterInput | null,
  sort?: Array< SearchableFlexCostCodeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexCostCodeAggregationInput | null > | null,
};

export type SearchFlexCostCodesQuery = {
  searchFlexCostCodes?:  {
    __typename: "SearchableFlexCostCodeConnection",
    items:  Array< {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexCostTypeQueryVariables = {
  id: string,
};

export type GetFlexCostTypeQuery = {
  getFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexCostTypesQueryVariables = {
  id?: string | null,
  filter?: ModelFlexCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexCostTypesQuery = {
  listFlexCostTypes?:  {
    __typename: "ModelFlexCostTypeConnection",
    items:  Array< {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexCostTypesByPaidolIdQueryVariables = {
  paidolId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexCostTypesByPaidolIdQuery = {
  listFlexCostTypesByPaidolId?:  {
    __typename: "ModelFlexCostTypeConnection",
    items:  Array< {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexCostTypesByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexCostTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexCostTypesByFlexCodeImportIdQuery = {
  flexCostTypesByFlexCodeImportId?:  {
    __typename: "ModelFlexCostTypeConnection",
    items:  Array< {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexCostTypesQueryVariables = {
  filter?: SearchableFlexCostTypeFilterInput | null,
  sort?: Array< SearchableFlexCostTypeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexCostTypeAggregationInput | null > | null,
};

export type SearchFlexCostTypesQuery = {
  searchFlexCostTypes?:  {
    __typename: "SearchableFlexCostTypeConnection",
    items:  Array< {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexVendorQueryVariables = {
  id: string,
};

export type GetFlexVendorQuery = {
  getFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexVendorsQueryVariables = {
  id?: string | null,
  filter?: ModelFlexVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexVendorsQuery = {
  listFlexVendors?:  {
    __typename: "ModelFlexVendorConnection",
    items:  Array< {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexVendorsByPaidolIdQueryVariables = {
  paidolId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexVendorsByPaidolIdQuery = {
  listFlexVendorsByPaidolId?:  {
    __typename: "ModelFlexVendorConnection",
    items:  Array< {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexVendorsByFlexCodeImportIdQueryVariables = {
  flexCodeImportId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexVendorsByFlexCodeImportIdQuery = {
  flexVendorsByFlexCodeImportId?:  {
    __typename: "ModelFlexVendorConnection",
    items:  Array< {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexVendorsQueryVariables = {
  filter?: SearchableFlexVendorFilterInput | null,
  sort?: Array< SearchableFlexVendorSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexVendorAggregationInput | null > | null,
};

export type SearchFlexVendorsQuery = {
  searchFlexVendors?:  {
    __typename: "SearchableFlexVendorConnection",
    items:  Array< {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexFieldQueryVariables = {
  id: string,
};

export type GetFlexFieldQuery = {
  getFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexFieldsQueryVariables = {
  id?: string | null,
  filter?: ModelFlexFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexFieldsQuery = {
  listFlexFields?:  {
    __typename: "ModelFlexFieldConnection",
    items:  Array< {
      __typename: "FlexField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      alias?: string | null,
      order?: number | null,
      source: FlexFieldSource,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexFieldsByPaidolIdQueryVariables = {
  paidolId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexFieldsByPaidolIdQuery = {
  flexFieldsByPaidolId?:  {
    __typename: "ModelFlexFieldConnection",
    items:  Array< {
      __typename: "FlexField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      alias?: string | null,
      order?: number | null,
      source: FlexFieldSource,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexFieldsQueryVariables = {
  filter?: SearchableFlexFieldFilterInput | null,
  sort?: Array< SearchableFlexFieldSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexFieldAggregationInput | null > | null,
};

export type SearchFlexFieldsQuery = {
  searchFlexFields?:  {
    __typename: "SearchableFlexFieldConnection",
    items:  Array< {
      __typename: "FlexField",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      alias?: string | null,
      order?: number | null,
      source: FlexFieldSource,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexFieldValueQueryVariables = {
  id: string,
};

export type GetFlexFieldValueQuery = {
  getFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexFieldValuesQueryVariables = {
  id?: string | null,
  filter?: ModelFlexFieldValueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexFieldValuesQuery = {
  listFlexFieldValues?:  {
    __typename: "ModelFlexFieldValueConnection",
    items:  Array< {
      __typename: "FlexFieldValue",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      externalId?: string | null,
      value: string,
      status: FlexFieldValueStatus,
      flexFieldUploadId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFlexFieldValuesByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldValueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlexFieldValuesByPaidolIdQuery = {
  listFlexFieldValuesByPaidolId?:  {
    __typename: "ModelFlexFieldValueConnection",
    items:  Array< {
      __typename: "FlexFieldValue",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      externalId?: string | null,
      value: string,
      status: FlexFieldValueStatus,
      flexFieldUploadId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexFieldValuesByFlexFieldIdQueryVariables = {
  flexFieldId: string,
  value?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldValueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexFieldValuesByFlexFieldIdQuery = {
  flexFieldValuesByFlexFieldId?:  {
    __typename: "ModelFlexFieldValueConnection",
    items:  Array< {
      __typename: "FlexFieldValue",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      externalId?: string | null,
      value: string,
      status: FlexFieldValueStatus,
      flexFieldUploadId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexFieldValuesByUploadIdQueryVariables = {
  flexFieldUploadId: string,
  value?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldValueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexFieldValuesByUploadIdQuery = {
  flexFieldValuesByUploadId?:  {
    __typename: "ModelFlexFieldValueConnection",
    items:  Array< {
      __typename: "FlexFieldValue",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      externalId?: string | null,
      value: string,
      status: FlexFieldValueStatus,
      flexFieldUploadId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlexFieldValuesQueryVariables = {
  filter?: SearchableFlexFieldValueFilterInput | null,
  sort?: Array< SearchableFlexFieldValueSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlexFieldValueAggregationInput | null > | null,
};

export type SearchFlexFieldValuesQuery = {
  searchFlexFieldValues?:  {
    __typename: "SearchableFlexFieldValueConnection",
    items:  Array< {
      __typename: "FlexFieldValue",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      externalId?: string | null,
      value: string,
      status: FlexFieldValueStatus,
      flexFieldUploadId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlexFieldUploadQueryVariables = {
  id: string,
};

export type GetFlexFieldUploadQuery = {
  getFlexFieldUpload?:  {
    __typename: "FlexFieldUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    storageFileKey: string,
    fileName: string,
    status: FlexFieldUploadStatus,
    errors?: string | null,
    rowCount?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlexFieldUploadsQueryVariables = {
  id?: string | null,
  filter?: ModelFlexFieldUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlexFieldUploadsQuery = {
  listFlexFieldUploads?:  {
    __typename: "ModelFlexFieldUploadConnection",
    items:  Array< {
      __typename: "FlexFieldUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      storageFileKey: string,
      fileName: string,
      status: FlexFieldUploadStatus,
      errors?: string | null,
      rowCount?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexFieldUploadsByPaidolIdQueryVariables = {
  paidolId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexFieldUploadsByPaidolIdQuery = {
  flexFieldUploadsByPaidolId?:  {
    __typename: "ModelFlexFieldUploadConnection",
    items:  Array< {
      __typename: "FlexFieldUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      storageFileKey: string,
      fileName: string,
      status: FlexFieldUploadStatus,
      errors?: string | null,
      rowCount?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FlexFieldUploadsByFlexFieldIdQueryVariables = {
  flexFieldId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFlexFieldUploadFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FlexFieldUploadsByFlexFieldIdQuery = {
  flexFieldUploadsByFlexFieldId?:  {
    __typename: "ModelFlexFieldUploadConnection",
    items:  Array< {
      __typename: "FlexFieldUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      flexFieldId: string,
      storageFileKey: string,
      fileName: string,
      status: FlexFieldUploadStatus,
      errors?: string | null,
      rowCount?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStatementSummaryQueryVariables = {
  id: string,
};

export type GetStatementSummaryQuery = {
  getStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListStatementSummariesQueryVariables = {
  id?: string | null,
  filter?: ModelStatementSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListStatementSummariesQuery = {
  listStatementSummaries?:  {
    __typename: "ModelStatementSummaryConnection",
    items:  Array< {
      __typename: "StatementSummary",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      startDate: string,
      endDate: string,
      statementBalance: number,
      paymentDueDate?: string | null,
      pdfLink: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStatementSummariesByPaidolIdQueryVariables = {
  paidolId: string,
  startDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStatementSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStatementSummariesByPaidolIdQuery = {
  listStatementSummariesByPaidolId?:  {
    __typename: "ModelStatementSummaryConnection",
    items:  Array< {
      __typename: "StatementSummary",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      startDate: string,
      endDate: string,
      statementBalance: number,
      paymentDueDate?: string | null,
      pdfLink: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutoPaymentQueryVariables = {
  id: string,
};

export type GetAutoPaymentQuery = {
  getAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAutoPaymentsQueryVariables = {
  id?: string | null,
  filter?: ModelAutoPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAutoPaymentsQuery = {
  listAutoPayments?:  {
    __typename: "ModelAutoPaymentConnection",
    items:  Array< {
      __typename: "AutoPayment",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      amountType: AutoPayAmountType,
      fixedAmountCents?: number | null,
      paymentDayOfMonth: number,
      externalBankAccountId: string,
      financialAccountId: string,
      active: boolean,
      createdBy: string,
      updatedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAutoPaymentsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAutoPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAutoPaymentsByPaidolIdQuery = {
  listAutoPaymentsByPaidolId?:  {
    __typename: "ModelAutoPaymentConnection",
    items:  Array< {
      __typename: "AutoPayment",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      amountType: AutoPayAmountType,
      fixedAmountCents?: number | null,
      paymentDayOfMonth: number,
      externalBankAccountId: string,
      financialAccountId: string,
      active: boolean,
      createdBy: string,
      updatedBy?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTransactionFilterOptionsQueryVariables = {
  paidolId: string,
};

export type GetTransactionFilterOptionsQuery = {
  getTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListTransactionFilterOptionsQueryVariables = {
  paidolId?: string | null,
  filter?: ModelTransactionFilterOptionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTransactionFilterOptionsQuery = {
  listTransactionFilterOptions?:  {
    __typename: "ModelTransactionFilterOptionsConnection",
    items:  Array< {
      __typename: "TransactionFilterOptions",
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      last4?: Array< string > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHighnoteDisputeEventQueryVariables = {
  id: string,
};

export type GetHighnoteDisputeEventQuery = {
  getHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHighnoteDisputeEventsQueryVariables = {
  id?: string | null,
  filter?: ModelHighnoteDisputeEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHighnoteDisputeEventsQuery = {
  listHighnoteDisputeEvents?:  {
    __typename: "ModelHighnoteDisputeEventConnection",
    items:  Array< {
      __typename: "HighnoteDisputeEvent",
      id: string,
      disputeId: string,
      paidolId: string,
      paymentCardId: string,
      transactionEventId: string,
      enableListing: boolean,
      status: string,
      creditStatus?: string | null,
      category?: string | null,
      liability?: string | null,
      eventType: string,
      eventDate: string,
      source: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteDisputeEventsByPaidolIdQueryVariables = {
  paidolId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteDisputeEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteDisputeEventsByPaidolIdQuery = {
  listHighnoteDisputeEventsByPaidolId?:  {
    __typename: "ModelHighnoteDisputeEventConnection",
    items:  Array< {
      __typename: "HighnoteDisputeEvent",
      id: string,
      disputeId: string,
      paidolId: string,
      paymentCardId: string,
      transactionEventId: string,
      enableListing: boolean,
      status: string,
      creditStatus?: string | null,
      category?: string | null,
      liability?: string | null,
      eventType: string,
      eventDate: string,
      source: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHighnoteTransactionEventQueryVariables = {
  id: string,
};

export type GetHighnoteTransactionEventQuery = {
  getHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHighnoteTransactionEventsQueryVariables = {
  id?: string | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListHighnoteTransactionEventsQuery = {
  listHighnoteTransactionEvents?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionEventsByTransactionIdQueryVariables = {
  transactionId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionEventsByTransactionIdQuery = {
  listHighnoteTransactionEventsByTransactionId?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionEventsByPaymentCardIdQueryVariables = {
  paymentCardId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionEventsByPaymentCardIdQuery = {
  listHighnoteTransactionEventsByPaymentCardId?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionEventsByPaidolIdQueryVariables = {
  paidolId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionEventsByPaidolIdQuery = {
  listHighnoteTransactionEventsByPaidolId?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionEventsByReconciliationIdQueryVariables = {
  reconciliationId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionEventsByReconciliationIdQuery = {
  listHighnoteTransactionEventsByReconciliationId?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHighnoteTransactionEventsByCardGroupIdQueryVariables = {
  cardGroupId: string,
  eventDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHighnoteTransactionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHighnoteTransactionEventsByCardGroupIdQuery = {
  listHighnoteTransactionEventsByCardGroupId?:  {
    __typename: "ModelHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchHighnoteTransactionEventsQueryVariables = {
  filter?: SearchableHighnoteTransactionEventFilterInput | null,
  sort?: Array< SearchableHighnoteTransactionEventSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableHighnoteTransactionEventAggregationInput | null > | null,
};

export type SearchHighnoteTransactionEventsQuery = {
  searchHighnoteTransactionEvents?:  {
    __typename: "SearchableHighnoteTransactionEventConnection",
    items:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSyncBalanceCurrentCycleQueryVariables = {
  id: string,
};

export type GetSyncBalanceCurrentCycleQuery = {
  getSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSyncBalanceCurrentCyclesQueryVariables = {
  id?: string | null,
  filter?: ModelSyncBalanceCurrentCycleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSyncBalanceCurrentCyclesQuery = {
  listSyncBalanceCurrentCycles?:  {
    __typename: "ModelSyncBalanceCurrentCycleConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCycle",
      id: string,
      paidolId: string,
      authPaidolId: string,
      startDate: string,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SyncBalanceCurrentCycleByPaidolIdQueryVariables = {
  paidolId: string,
  startDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSyncBalanceCurrentCycleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SyncBalanceCurrentCycleByPaidolIdQuery = {
  syncBalanceCurrentCycleByPaidolId?:  {
    __typename: "ModelSyncBalanceCurrentCycleConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCycle",
      id: string,
      paidolId: string,
      authPaidolId: string,
      startDate: string,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSyncBalanceCurrentCyclePaymentCardsQueryVariables = {
  id: string,
};

export type GetSyncBalanceCurrentCyclePaymentCardsQuery = {
  getSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSyncBalanceCurrentCyclePaymentCardsQueryVariables = {
  id?: string | null,
  filter?: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSyncBalanceCurrentCyclePaymentCardsQuery = {
  listSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "ModelSyncBalanceCurrentCyclePaymentCardsConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCyclePaymentCards",
      id: string,
      authPaidolId: string,
      paidolId: string,
      syncBalanceCurrentCycleId: string,
      paymentCardId: string,
      syncedAt: string,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SyncBalanceCurrentCyclePaymentCardsByPaidolIdQueryVariables = {
  paidolId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SyncBalanceCurrentCyclePaymentCardsByPaidolIdQuery = {
  syncBalanceCurrentCyclePaymentCardsByPaidolId?:  {
    __typename: "ModelSyncBalanceCurrentCyclePaymentCardsConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCyclePaymentCards",
      id: string,
      authPaidolId: string,
      paidolId: string,
      syncBalanceCurrentCycleId: string,
      paymentCardId: string,
      syncedAt: string,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SyncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleIdQueryVariables = {
  syncBalanceCurrentCycleId: string,
  syncedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SyncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleIdQuery = {
  syncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleId?:  {
    __typename: "ModelSyncBalanceCurrentCyclePaymentCardsConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCyclePaymentCards",
      id: string,
      authPaidolId: string,
      paidolId: string,
      syncBalanceCurrentCycleId: string,
      paymentCardId: string,
      syncedAt: string,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SyncBalanceCurrentCyclePaymentCardsByPaymentCardIdQueryVariables = {
  paymentCardId: string,
  syncBalanceCurrentCycleId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SyncBalanceCurrentCyclePaymentCardsByPaymentCardIdQuery = {
  syncBalanceCurrentCyclePaymentCardsByPaymentCardId?:  {
    __typename: "ModelSyncBalanceCurrentCyclePaymentCardsConnection",
    items:  Array< {
      __typename: "SyncBalanceCurrentCyclePaymentCards",
      id: string,
      authPaidolId: string,
      paidolId: string,
      syncBalanceCurrentCycleId: string,
      paymentCardId: string,
      syncedAt: string,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetExpenseTypeToMCCQueryVariables = {
  id: string,
};

export type GetExpenseTypeToMCCQuery = {
  getExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListExpenseTypeToMCCSQueryVariables = {
  filter?: ModelExpenseTypeToMCCFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExpenseTypeToMCCSQuery = {
  listExpenseTypeToMCCS?:  {
    __typename: "ModelExpenseTypeToMCCConnection",
    items:  Array< {
      __typename: "ExpenseTypeToMCC",
      id: string,
      mccID: string,
      expenseTypeID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlaidLinkedBankAccountsByPaidolIdQueryVariables = {
  paidolId: string,
  status?: string | null,
};

export type GetPlaidLinkedBankAccountsByPaidolIdQuery = {
  // Get PlaidLinkedBankAccounts by paidolId.
  // Returns only safe data - access_token is never exposed.
  getPlaidLinkedBankAccountsByPaidolId?:  {
    __typename: "PlaidLinkedBankAccountsResponse",
    items:  Array< {
      __typename: "PlaidLinkedBankAccountSafe",
      id: string,
      paidolId: string,
      plaidAccountId: string,
      plaidItemId: string,
      highnoteAccountId?: string | null,
      accountName: string,
      accountMask: string,
      accountType: string,
      verificationMethod: string,
      status: string,
      linkedAt: string,
      verifiedAt?: string | null,
      closedAt?: string | null,
      failureReason?: string | null,
    } >,
  } | null,
};

export type UserListQueryVariables = {
  user_id: string,
  paidol_id: string,
};

export type UserListQuery = {
  userList?:  Array< {
    __typename: "SpeedchatUser",
    userId: string,
    nickname: string,
  } | null > | null,
};

export type UnreadMessagesQueryVariables = {
  userId: string,
};

export type UnreadMessagesQuery = {
  unreadMessages?:  {
    __typename: "speedchatUnreadMessages",
    unread_count: number,
  } | null,
};

export type DispatchMessageQueryVariables = {
  userId: string,
  message: string,
  paidolId: string,
};

export type DispatchMessageQuery = {
  dispatchMessage?:  {
    __typename: "dispatchSpeedchatMessage",
    channel_url: string,
    message: string,
  } | null,
};

export type HnGetBusinessAccountHolderQueryVariables = {
  id: string,
};

export type HnGetBusinessAccountHolderQuery = {
  hnGetBusinessAccountHolder?:  {
    __typename: "HNUSBusinessAccountHolder",
    id: string,
    primaryAuthorizedPerson?:  {
      __typename: "HNUSBusinessAuthorizedPerson",
      id: string,
      percentageOwnership?: number | null,
      authorizingPersonTitle?: HNBusinessTitle | null,
      email?: string | null,
      dateOfBirth?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    businessProfile?:  {
      __typename: "HNUSBusinessProfile",
      id: string,
      businessType?: HNBusinessStructure | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    externalId?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    cardProductApplications?:  {
      __typename: "HNAccountHolderCardProductApplicationConnection",
    } | null,
    paymentCards?:  {
      __typename: "HNPaymentCardConnection",
    } | null,
    externalFinancialAccounts?:  {
      __typename: "HNExternalFinancialAccountConnection",
    } | null,
    financialAccounts?:  {
      __typename: "HNFinancialAccountConnection",
    } | null,
    globalNotes: ( {
        __typename: "HNGlobalNoteConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
  } | null,
};

export type HnGetPaymentCardsForBusinessIdQueryVariables = {
  id: string,
  first?: number | null,
  after?: string | null,
  filterBy?: HNAccountHolderPaymentCardsFilterInput | null,
};

export type HnGetPaymentCardsForBusinessIdQuery = {
  hnGetPaymentCardsForBusinessId?:  {
    __typename: "HNUSBusinessAccountHolder",
    id: string,
    primaryAuthorizedPerson?:  {
      __typename: "HNUSBusinessAuthorizedPerson",
      id: string,
      percentageOwnership?: number | null,
      authorizingPersonTitle?: HNBusinessTitle | null,
      email?: string | null,
      dateOfBirth?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    businessProfile?:  {
      __typename: "HNUSBusinessProfile",
      id: string,
      businessType?: HNBusinessStructure | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    externalId?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    cardProductApplications?:  {
      __typename: "HNAccountHolderCardProductApplicationConnection",
    } | null,
    paymentCards?:  {
      __typename: "HNPaymentCardConnection",
    } | null,
    externalFinancialAccounts?:  {
      __typename: "HNExternalFinancialAccountConnection",
    } | null,
    financialAccounts?:  {
      __typename: "HNFinancialAccountConnection",
    } | null,
    globalNotes: ( {
        __typename: "HNGlobalNoteConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
  } | null,
};

export type HnGetDetailsForPaymentCardQueryVariables = {
  id: string,
};

export type HnGetDetailsForPaymentCardQuery = {
  hnGetDetailsForPaymentCard?:  {
    __typename: "HNPaymentCard",
    id: string,
    externalId?: string | null,
    bin?: string | null,
    last4?: string | null,
    expirationDate?: string | null,
    expirationMonth?: string | null,
    expirationYear?: string | null,
    network?: HNPaymentCardNetwork | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    cardProductApplication: ( {
        __typename: "HNAccountHolderCardProductApplication",
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNAuthorizedUserCardProductApplication",
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    application?:  {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationDenialReason?: HNApplicationDenialReason | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    status?: HNPaymentCardStatus | null,
    formFactor?: HNCardFormFactor | null,
    originalPaymentCard?:  {
      __typename: "HNPaymentCard",
      id: string,
      externalId?: string | null,
      bin?: string | null,
      last4?: string | null,
      expirationDate?: string | null,
      expirationMonth?: string | null,
      expirationYear?: string | null,
      network?: HNPaymentCardNetwork | null,
      status?: HNPaymentCardStatus | null,
      formFactor?: HNCardFormFactor | null,
      suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
    } | null,
    restrictedDetails: ( {
        __typename: "HNPaymentCardRestrictedDetails",
        number?: string | null,
        cvv?: string | null,
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    atmLocations: ( {
        __typename: "HNATMLocations",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      } | {
        __typename: "HNUserError",
      }
    ) | null,
    transactionEvents?:  {
      __typename: "HNTransactionEventConnection",
    } | null,
    financialAccounts?:  Array< {
      __typename: "HNFinancialAccount",
      id: string,
      externalId?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
      accountStatus?: string | null,
      accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
      partnerBankName?: HNPartnerBankName | null,
    } > | null,
    physicalPaymentCardOrders?:  Array< {
      __typename: "HNPhysicalPaymentCardOrder",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    attachedSpendRules?:  {
      __typename: "HNSpendRuleConnection",
    } | null,
    cardDigitalWalletTokens?:  {
      __typename: "HNCardDigitalWalletTokenConnection",
    } | null,
    velocityRuleBalances?:  Array< {
      __typename: "HNVelocityRuleBalance",
    } | null > | null,
    velocitySpendRuleBalances:  Array<( {
        __typename: "HNVelocitySpendRuleAmountBalance",
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      } | {
        __typename: "HNVelocitySpendRuleCountBalance",
        currentCountBalance?: number | null,
        remainingCountBalance?: number | null,
        computedCurrentCountBalance?: number | null,
        computedRemainingCountBalance?: number | null,
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      }
    ) | null > | null,
    attachedVelocityRules?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    paymentCardHolderDetails?:  {
      __typename: "HNPaymentCardHolderDetails",
    } | null,
    customFields:  Array<( {
        __typename: "HNCustomStringField",
        key: string,
        value: string,
      }
    ) > | null,
    revisionSnapshots?:  {
      __typename: "HNPaymentCardSnapshotConnection",
    } | null,
    cardProfileSet?:  {
      __typename: "HNCardProfileSet",
      id: string,
      status?: HNCardProfileSetStatus | null,
      name?: string | null,
      intent?: HNCardProfileSetIntent | null,
      network?: HNCardProfileSetNetwork | null,
      preferredConfiguration?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      description?: string | null,
    } | null,
    pinDetails?:  {
      __typename: "HNPaymentCardPinDetails",
      isSet?: boolean | null,
    } | null,
    suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
  } | null,
};

export type HnGetAccountHolderCardProductApplicationQueryVariables = {
  id: string,
};

export type HnGetAccountHolderCardProductApplicationQuery = {
  hnGetAccountHolderCardProductApplication?:  {
    __typename: "HNAccountHolderCardProductApplication",
    id: string,
    applicationState?:  {
      __typename: "HNAccountHolderApplicationState",
      status: HNAccountHolderApplicationStatusCode,
    } | null,
    adverseActionReasons?:  Array< {
      __typename: "HNAdverseActionReason",
      code?: HNAdverseActionCode | null,
      description?: string | null,
    } > | null,
    applicationDenialReason?: HNApplicationDenialReason | null,
    accountHolderSnapshot: ( {
        __typename: "HNUSPersonAccountHolderSnapshot",
        email?: string | null,
        dateOfBirth?: string | null,
      } | {
        __typename: "HNUSBusinessAccountHolderSnapshot",
      }
    ) | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    applicationHistory?:  {
      __typename: "HNAccountHolderCardProductApplicationSnapshotConnection",
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    financialAccounts?:  {
      __typename: "HNFinancialAccountConnection",
    } | null,
    offers?:  {
      __typename: "HNAccountHolderCardProductApplicationOfferConnection",
    } | null,
    creditReportFraudAlertVerificationResult?:  {
      __typename: "HNCreditReportFraudAlertVerificationResult",
      accountHolderInitiatedApplication: boolean,
      name: boolean,
      dateOfBirth: boolean,
      address: boolean,
    } | null,
  } | null,
};

export type HnGetSpendRuleByIdQueryVariables = {
  ruleId: string,
};

export type HnGetSpendRuleByIdQuery = {
  hnGetSpendRuleById?:  {
    __typename: "HNMerchantSpendRule",
    id?: string | null,
    name?: string | null,
    blockedCountry?: Array< string | null > | null,
    allowedCategory?: Array< string | null > | null,
    blockedCategory?: Array< string | null > | null,
    allowedCountry?: Array< string | null > | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type HnGetPaymentCardDetailsQueryVariables = {
  id: string,
};

export type HnGetPaymentCardDetailsQuery = {
  hnGetPaymentCardDetails?:  {
    __typename: "HNPaymentCard",
    id: string,
    externalId?: string | null,
    bin?: string | null,
    last4?: string | null,
    expirationDate?: string | null,
    expirationMonth?: string | null,
    expirationYear?: string | null,
    network?: HNPaymentCardNetwork | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    cardProductApplication: ( {
        __typename: "HNAccountHolderCardProductApplication",
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNAuthorizedUserCardProductApplication",
        id: string,
        applicationDenialReason?: HNApplicationDenialReason | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    application?:  {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationDenialReason?: HNApplicationDenialReason | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    status?: HNPaymentCardStatus | null,
    formFactor?: HNCardFormFactor | null,
    originalPaymentCard?:  {
      __typename: "HNPaymentCard",
      id: string,
      externalId?: string | null,
      bin?: string | null,
      last4?: string | null,
      expirationDate?: string | null,
      expirationMonth?: string | null,
      expirationYear?: string | null,
      network?: HNPaymentCardNetwork | null,
      status?: HNPaymentCardStatus | null,
      formFactor?: HNCardFormFactor | null,
      suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
    } | null,
    restrictedDetails: ( {
        __typename: "HNPaymentCardRestrictedDetails",
        number?: string | null,
        cvv?: string | null,
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    atmLocations: ( {
        __typename: "HNATMLocations",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      } | {
        __typename: "HNUserError",
      }
    ) | null,
    transactionEvents?:  {
      __typename: "HNTransactionEventConnection",
    } | null,
    financialAccounts?:  Array< {
      __typename: "HNFinancialAccount",
      id: string,
      externalId?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
      accountStatus?: string | null,
      accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
      partnerBankName?: HNPartnerBankName | null,
    } > | null,
    physicalPaymentCardOrders?:  Array< {
      __typename: "HNPhysicalPaymentCardOrder",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    attachedSpendRules?:  {
      __typename: "HNSpendRuleConnection",
    } | null,
    cardDigitalWalletTokens?:  {
      __typename: "HNCardDigitalWalletTokenConnection",
    } | null,
    velocityRuleBalances?:  Array< {
      __typename: "HNVelocityRuleBalance",
    } | null > | null,
    velocitySpendRuleBalances:  Array<( {
        __typename: "HNVelocitySpendRuleAmountBalance",
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      } | {
        __typename: "HNVelocitySpendRuleCountBalance",
        currentCountBalance?: number | null,
        remainingCountBalance?: number | null,
        computedCurrentCountBalance?: number | null,
        computedRemainingCountBalance?: number | null,
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      }
    ) | null > | null,
    attachedVelocityRules?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    paymentCardHolderDetails?:  {
      __typename: "HNPaymentCardHolderDetails",
    } | null,
    customFields:  Array<( {
        __typename: "HNCustomStringField",
        key: string,
        value: string,
      }
    ) > | null,
    revisionSnapshots?:  {
      __typename: "HNPaymentCardSnapshotConnection",
    } | null,
    cardProfileSet?:  {
      __typename: "HNCardProfileSet",
      id: string,
      status?: HNCardProfileSetStatus | null,
      name?: string | null,
      intent?: HNCardProfileSetIntent | null,
      network?: HNCardProfileSetNetwork | null,
      preferredConfiguration?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      description?: string | null,
    } | null,
    pinDetails?:  {
      __typename: "HNPaymentCardPinDetails",
      isSet?: boolean | null,
    } | null,
    suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
  } | null,
};

export type HnViewDirectDepositDetailsQueryVariables = {
  id: string,
};

export type HnViewDirectDepositDetailsQuery = {
  hnViewDirectDepositDetails?:  {
    __typename: "HNDirectDepositDetail",
    id: string,
    restrictedDetails: ( {
        __typename: "HNDirectDepositDetailRestrictedDetails",
        number?: string | null,
        routingNumber?: string | null,
        type?: HNBankAccountType | null,
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type HnFindFinancialAccountTransfersQueryVariables = {
  id: string,
  firstScheduledTransfers?: number | null,
  scheduledTransfersAfterCursor?: string | null,
  firstIntegratorTransfers?: number | null,
  integratorTransfersAfterCursor?: string | null,
  firstExternalTransfers?: number | null,
  externalTransfersAfterCursor?: string | null,
};

export type HnFindFinancialAccountTransfersQuery = {
  hnFindFinancialAccountTransfers?:  {
    __typename: "HNFinancialAccount",
    paymentCardTransactionChargebacks?:  {
      __typename: "HNPaymentCardTransactionChargebackConnection",
    } | null,
    globalNotes: ( {
        __typename: "HNGlobalNoteConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    accountReviewHistory: ( {
        __typename: "HNAccountReviewConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    id: string,
    externalId?: string | null,
    ledgers?:  Array< {
      __typename: "HNLedger",
      id: string,
      name?: HNLedgerName | null,
      description?: string | null,
      normalBalance?: HNNormalBalance | null,
      asOf?: string | null,
    } > | null,
    owner: ( {
        __typename: "HNOrganization",
        id: string,
      } | {
        __typename: "HNPaymentCard",
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | {
        __typename: "HNUSPersonAccountHolder",
        id: string,
        email?: string | null,
        dateOfBirth?: string | null,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNUSBusinessAccountHolder",
        id: string,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    name?: string | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    application?:  {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationDenialReason?: HNApplicationDenialReason | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    features:  Array<( {
        __typename: "HNDirectDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNDebitPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNIncomeAccountFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNJustInTimeFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNOnDemandFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
        sourceFinancialAccountId?: string | null,
        pseudoBalanceEnabled?: boolean | null,
      } | {
        __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNFleetCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCommercialCreditPayInFullCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCardFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPointRewardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNonVerifiedFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNAchCapableFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNVendorProvidedBankFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPartialFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNRepaymentFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPreprintedCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNMerchantSettlementFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      }
    ) > | null,
    directDepositDetails?:  {
      __typename: "HNDirectDepositDetail",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    activeBillingCycleConfiguration?:  {
      __typename: "HNBillingCycleConfiguration",
      id: string,
      paymentDueDayOfMonth?: number | null,
      billingCycleStartDayOfMonth?: number | null,
      billingCycleEndDayOfMonth?: number | null,
      from?: string | null,
      through?: string | null,
    } | null,
    statementSnapshot: ( {
        __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCreditPayInFullCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    statements?:  {
      __typename: "HNFinancialAccountStatementConnection",
    } | null,
    financialAccountActivities?:  {
      __typename: "HNFinancialAccountActivityConnection",
    } | null,
    integratorInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    integratorInitiatedACHTransfer?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    integratorACHTransfers?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    externallyInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    externallyInitiatedACHTransfer?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    externalACHTransfers?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    originatedAchTransfers: ( {
        __typename: "HNOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    nonOriginatedAchTransfers: ( {
        __typename: "HNNonOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    incomingScheduledTransfers?:  {
      __typename: "HNScheduledTransferConnection",
    } | null,
    transactionEvents?:  {
      __typename: "HNTransactionEventConnection",
    } | null,
    interFinancialAccountTransfers?:  {
      __typename: "HNInterFinancialAccountTransferConnection",
    } | null,
    accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
    accountStatus?: string | null,
    accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
    financialAccountAttributesWithReason?:  Array< {
      __typename: "HNFinancialAccountAttributeWithReason",
      attribute: HNFinancialAccountAttribute,
      reason?: HNFinancialAccountAttributeReason | null,
    } > | null,
    paymentCards?:  {
      __typename: "HNPaymentCardConnection",
    } | null,
    velocityRuleBalances?:  Array< {
      __typename: "HNVelocityRuleBalance",
    } | null > | null,
    velocitySpendRuleBalances:  Array<( {
        __typename: "HNVelocitySpendRuleAmountBalance",
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      } | {
        __typename: "HNVelocitySpendRuleCountBalance",
        currentCountBalance?: number | null,
        remainingCountBalance?: number | null,
        computedCurrentCountBalance?: number | null,
        computedRemainingCountBalance?: number | null,
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      }
    ) | null > | null,
    partnerBankName?: HNPartnerBankName | null,
    delinquency: ( {
        __typename: "HNCreditPayInFullFinancialAccountDelinquency",
        delinquencyStartedOn?: string | null,
        totalDaysDelinquent?: number | null,
        numberOfCycles?: number | null,
      }
    ) | null,
    delinquencyState?:  {
      __typename: "HNCurrentFinancialAccountDelinquencyState",
      state?: HNFinancialAccountDelinquencyState | null,
      updatedAt?: string | null,
    } | null,
    billingCycleHistory?:  {
      __typename: "HNBillingCycleConnection",
    } | null,
    creditConfiguration?:  {
      __typename: "HNCreditFinancialAccountConfiguration",
    } | null,
    feeTransferEvents?:  {
      __typename: "HNFeeTransferEventConnection",
    } | null,
    paymentCardTransactionDisputes: ( {
        __typename: "HNPaymentCardTransactionDisputeConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    customFields:  Array<( {
        __typename: "HNCustomStringField",
        key: string,
        value: string,
      }
    ) > | null,
    revisionSnapshots?:  {
      __typename: "HNFinancialAccountSnapshotConnection",
    } | null,
    rewardPointsTransfers: ( {
        __typename: "HNRewardPointsTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    attachedSpendRules?:  {
      __typename: "HNSpendRuleConnection",
    } | null,
    attachedVelocityRules?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
  } | null,
};

export type HnFindFinancialAccountLedgerActivityQueryVariables = {
  id: string,
  firstActivities?: number | null,
  activitiesAfterCursor?: string | null,
};

export type HnFindFinancialAccountLedgerActivityQuery = {
  hnFindFinancialAccountLedgerActivity?:  {
    __typename: "HNFinancialAccount",
    paymentCardTransactionChargebacks?:  {
      __typename: "HNPaymentCardTransactionChargebackConnection",
    } | null,
    globalNotes: ( {
        __typename: "HNGlobalNoteConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    accountReviewHistory: ( {
        __typename: "HNAccountReviewConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    id: string,
    externalId?: string | null,
    ledgers?:  Array< {
      __typename: "HNLedger",
      id: string,
      name?: HNLedgerName | null,
      description?: string | null,
      normalBalance?: HNNormalBalance | null,
      asOf?: string | null,
    } > | null,
    owner: ( {
        __typename: "HNOrganization",
        id: string,
      } | {
        __typename: "HNPaymentCard",
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | {
        __typename: "HNUSPersonAccountHolder",
        id: string,
        email?: string | null,
        dateOfBirth?: string | null,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNUSBusinessAccountHolder",
        id: string,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    name?: string | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    application?:  {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationDenialReason?: HNApplicationDenialReason | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    features:  Array<( {
        __typename: "HNDirectDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNDebitPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNIncomeAccountFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNJustInTimeFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNOnDemandFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
        sourceFinancialAccountId?: string | null,
        pseudoBalanceEnabled?: boolean | null,
      } | {
        __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNFleetCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCommercialCreditPayInFullCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCardFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPointRewardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNonVerifiedFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNAchCapableFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNVendorProvidedBankFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPartialFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNRepaymentFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPreprintedCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNMerchantSettlementFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      }
    ) > | null,
    directDepositDetails?:  {
      __typename: "HNDirectDepositDetail",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    activeBillingCycleConfiguration?:  {
      __typename: "HNBillingCycleConfiguration",
      id: string,
      paymentDueDayOfMonth?: number | null,
      billingCycleStartDayOfMonth?: number | null,
      billingCycleEndDayOfMonth?: number | null,
      from?: string | null,
      through?: string | null,
    } | null,
    statementSnapshot: ( {
        __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCreditPayInFullCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    statements?:  {
      __typename: "HNFinancialAccountStatementConnection",
    } | null,
    financialAccountActivities?:  {
      __typename: "HNFinancialAccountActivityConnection",
    } | null,
    integratorInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    integratorInitiatedACHTransfer?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    integratorACHTransfers?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    externallyInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    externallyInitiatedACHTransfer?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    externalACHTransfers?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    originatedAchTransfers: ( {
        __typename: "HNOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    nonOriginatedAchTransfers: ( {
        __typename: "HNNonOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    incomingScheduledTransfers?:  {
      __typename: "HNScheduledTransferConnection",
    } | null,
    transactionEvents?:  {
      __typename: "HNTransactionEventConnection",
    } | null,
    interFinancialAccountTransfers?:  {
      __typename: "HNInterFinancialAccountTransferConnection",
    } | null,
    accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
    accountStatus?: string | null,
    accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
    financialAccountAttributesWithReason?:  Array< {
      __typename: "HNFinancialAccountAttributeWithReason",
      attribute: HNFinancialAccountAttribute,
      reason?: HNFinancialAccountAttributeReason | null,
    } > | null,
    paymentCards?:  {
      __typename: "HNPaymentCardConnection",
    } | null,
    velocityRuleBalances?:  Array< {
      __typename: "HNVelocityRuleBalance",
    } | null > | null,
    velocitySpendRuleBalances:  Array<( {
        __typename: "HNVelocitySpendRuleAmountBalance",
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      } | {
        __typename: "HNVelocitySpendRuleCountBalance",
        currentCountBalance?: number | null,
        remainingCountBalance?: number | null,
        computedCurrentCountBalance?: number | null,
        computedRemainingCountBalance?: number | null,
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      }
    ) | null > | null,
    partnerBankName?: HNPartnerBankName | null,
    delinquency: ( {
        __typename: "HNCreditPayInFullFinancialAccountDelinquency",
        delinquencyStartedOn?: string | null,
        totalDaysDelinquent?: number | null,
        numberOfCycles?: number | null,
      }
    ) | null,
    delinquencyState?:  {
      __typename: "HNCurrentFinancialAccountDelinquencyState",
      state?: HNFinancialAccountDelinquencyState | null,
      updatedAt?: string | null,
    } | null,
    billingCycleHistory?:  {
      __typename: "HNBillingCycleConnection",
    } | null,
    creditConfiguration?:  {
      __typename: "HNCreditFinancialAccountConfiguration",
    } | null,
    feeTransferEvents?:  {
      __typename: "HNFeeTransferEventConnection",
    } | null,
    paymentCardTransactionDisputes: ( {
        __typename: "HNPaymentCardTransactionDisputeConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    customFields:  Array<( {
        __typename: "HNCustomStringField",
        key: string,
        value: string,
      }
    ) > | null,
    revisionSnapshots?:  {
      __typename: "HNFinancialAccountSnapshotConnection",
    } | null,
    rewardPointsTransfers: ( {
        __typename: "HNRewardPointsTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    attachedSpendRules?:  {
      __typename: "HNSpendRuleConnection",
    } | null,
    attachedVelocityRules?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
  } | null,
};

export type HnFindFinancialAccountActivitiesQueryVariables = {
  id: string,
  firstActivities?: number | null,
  filterBy?: HNFinancialAccountActivitiesFilterInput | null,
  activitiesAfterCursor?: string | null,
};

export type HnFindFinancialAccountActivitiesQuery = {
  hnFindFinancialAccountActivities?:  {
    __typename: "HNFinancialAccount",
    paymentCardTransactionChargebacks?:  {
      __typename: "HNPaymentCardTransactionChargebackConnection",
    } | null,
    globalNotes: ( {
        __typename: "HNGlobalNoteConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    accountReviewHistory: ( {
        __typename: "HNAccountReviewConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    id: string,
    externalId?: string | null,
    ledgers?:  Array< {
      __typename: "HNLedger",
      id: string,
      name?: HNLedgerName | null,
      description?: string | null,
      normalBalance?: HNNormalBalance | null,
      asOf?: string | null,
    } > | null,
    owner: ( {
        __typename: "HNOrganization",
        id: string,
      } | {
        __typename: "HNPaymentCard",
        id: string,
        externalId?: string | null,
        bin?: string | null,
        last4?: string | null,
        expirationDate?: string | null,
        expirationMonth?: string | null,
        expirationYear?: string | null,
        network?: HNPaymentCardNetwork | null,
        status?: HNPaymentCardStatus | null,
        formFactor?: HNCardFormFactor | null,
        suspensionFlags?: Array< HNPaymentCardSuspensionFlag > | null,
      } | {
        __typename: "HNUSPersonAccountHolder",
        id: string,
        email?: string | null,
        dateOfBirth?: string | null,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNUSBusinessAccountHolder",
        id: string,
        externalId?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    name?: string | null,
    cardProduct?:  {
      __typename: "HNCardProduct",
      id: string,
      name?: string | null,
      usage?: HNCardUsage | null,
      vertical?: HNCardProductVertical | null,
      commercial?: boolean | null,
      sourceTemplateId?: string | null,
    } | null,
    application?:  {
      __typename: "HNAccountHolderCardProductApplication",
      id: string,
      applicationDenialReason?: HNApplicationDenialReason | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    features:  Array<( {
        __typename: "HNDirectDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPrePaidPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNDebitPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPayrollEmployerAdvanceFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNegativeBalanceReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductReserveFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNIncomeAccountFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNJustInTimeFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNOnDemandFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
        sourceFinancialAccountId?: string | null,
        pseudoBalanceEnabled?: boolean | null,
      } | {
        __typename: "HNSecuredCreditPaymentCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNFleetCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCommercialCreditPayInFullCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCreditCardAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNCardFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPointRewardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNNonVerifiedFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNAchCapableFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNVendorProvidedBankFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPartialFundingFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNRepaymentFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNPreprintedCardFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNProductSecuredDepositFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      } | {
        __typename: "HNMerchantSettlementFinancialAccountFeature",
        enabled?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        effectiveFrom?: string | null,
        effectiveThrough?: string | null,
      }
    ) > | null,
    directDepositDetails?:  {
      __typename: "HNDirectDepositDetail",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    activeBillingCycleConfiguration?:  {
      __typename: "HNBillingCycleConfiguration",
      id: string,
      paymentDueDayOfMonth?: number | null,
      billingCycleStartDayOfMonth?: number | null,
      billingCycleEndDayOfMonth?: number | null,
      from?: string | null,
      through?: string | null,
    } | null,
    statementSnapshot: ( {
        __typename: "HNSecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCreditPayInFullCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNConsumerRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialChargeCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCommercialRevolvingCardFinancialAccountStatementSnapshot",
        asOf?: string | null,
        updatedAt?: string | null,
      }
    ) | null,
    statements?:  {
      __typename: "HNFinancialAccountStatementConnection",
    } | null,
    financialAccountActivities?:  {
      __typename: "HNFinancialAccountActivityConnection",
    } | null,
    integratorInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    integratorInitiatedACHTransfer?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    integratorACHTransfers?:  {
      __typename: "HNIntegratorInitiatedACHTransferConnection",
    } | null,
    externallyInitiatedAchTransfers?:  {
      __typename: "HNACHTransactionConnection",
    } | null,
    externallyInitiatedACHTransfer?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    externalACHTransfers?:  {
      __typename: "HNExternallyInitiatedACHTransferConnection",
    } | null,
    originatedAchTransfers: ( {
        __typename: "HNOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    nonOriginatedAchTransfers: ( {
        __typename: "HNNonOriginatedAchTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    incomingScheduledTransfers?:  {
      __typename: "HNScheduledTransferConnection",
    } | null,
    transactionEvents?:  {
      __typename: "HNTransactionEventConnection",
    } | null,
    interFinancialAccountTransfers?:  {
      __typename: "HNInterFinancialAccountTransferConnection",
    } | null,
    accountClosureBlockers?: Array< HNAccountClosureBlocker | null > | null,
    accountStatus?: string | null,
    accountAttributes?: Array< HNFinancialAccountAttribute | null > | null,
    financialAccountAttributesWithReason?:  Array< {
      __typename: "HNFinancialAccountAttributeWithReason",
      attribute: HNFinancialAccountAttribute,
      reason?: HNFinancialAccountAttributeReason | null,
    } > | null,
    paymentCards?:  {
      __typename: "HNPaymentCardConnection",
    } | null,
    velocityRuleBalances?:  Array< {
      __typename: "HNVelocityRuleBalance",
    } | null > | null,
    velocitySpendRuleBalances:  Array<( {
        __typename: "HNVelocitySpendRuleAmountBalance",
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      } | {
        __typename: "HNVelocitySpendRuleCountBalance",
        currentCountBalance?: number | null,
        remainingCountBalance?: number | null,
        computedCurrentCountBalance?: number | null,
        computedRemainingCountBalance?: number | null,
        asOfDate?: string | null,
        attachedLevel?: HNAttachedLevel | null,
      }
    ) | null > | null,
    partnerBankName?: HNPartnerBankName | null,
    delinquency: ( {
        __typename: "HNCreditPayInFullFinancialAccountDelinquency",
        delinquencyStartedOn?: string | null,
        totalDaysDelinquent?: number | null,
        numberOfCycles?: number | null,
      }
    ) | null,
    delinquencyState?:  {
      __typename: "HNCurrentFinancialAccountDelinquencyState",
      state?: HNFinancialAccountDelinquencyState | null,
      updatedAt?: string | null,
    } | null,
    billingCycleHistory?:  {
      __typename: "HNBillingCycleConnection",
    } | null,
    creditConfiguration?:  {
      __typename: "HNCreditFinancialAccountConfiguration",
    } | null,
    feeTransferEvents?:  {
      __typename: "HNFeeTransferEventConnection",
    } | null,
    paymentCardTransactionDisputes: ( {
        __typename: "HNPaymentCardTransactionDisputeConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    customFields:  Array<( {
        __typename: "HNCustomStringField",
        key: string,
        value: string,
      }
    ) > | null,
    revisionSnapshots?:  {
      __typename: "HNFinancialAccountSnapshotConnection",
    } | null,
    rewardPointsTransfers: ( {
        __typename: "HNRewardPointsTransferConnection",
      } | {
        __typename: "HNUserError",
      } | {
        __typename: "HNAccessDeniedError",
        message: string,
      }
    ) | null,
    attachedSpendRules?:  {
      __typename: "HNSpendRuleConnection",
    } | null,
    attachedVelocityRules?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
  } | null,
};

export type GetCardsQueryVariables = {
  input: GetCardsInput,
};

export type GetCardsQuery = {
  getCards:  {
    __typename: "GetCardsPayloadResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "GetCardsPayload",
      last4: string,
      paymentCardId: string,
      formFactor: HNCardFormFactor,
      paidolId: string,
      name?: string | null,
      status: HNPaymentCardStatus,
      expirationDate: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      network?: HNPaymentCardNetwork | null,
      isAdminLocked?: boolean | null,
      isAuthorizedUserCard?: boolean | null,
    } > | null,
  },
};

export type GetCardsLiteQueryVariables = {
  input: GetCardsInput,
};

export type GetCardsLiteQuery = {
  getCardsLite:  {
    __typename: "GetCardsLitePayloadResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "GetCardsLitePayload",
      paymentCardId: string,
      last4: string,
      name?: string | null,
    } > | null,
  },
};

export type GetJobCodesQueryVariables = {
  input: GetJobCodesInput,
};

export type GetJobCodesQuery = {
  getJobCodes:  {
    __typename: "GetJobCodesPayloadResult",
    jobCodeImport?:  {
      __typename: "GetJobCodesJobCodeImportPayload",
      id: string,
      paidolId: string,
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    paidolUsersMap:  Array< {
      __typename: "GetJobCodesPaidolUserMapPayload",
      code: string,
    } >,
  },
};

export type GetFinicityConnectUrlQueryVariables = {
  input: GetFinicityConnectUrlInput,
};

export type GetFinicityConnectUrlQuery = {
  getFinicityConnectUrl?:  {
    __typename: "GetFinicityConnectUrlResult",
    link?: string | null,
  } | null,
};

export type GetFinicityCustomerAccountsQueryVariables = {
  input: GetFinicityCustomerAccountsInput,
};

export type GetFinicityCustomerAccountsQuery = {
  getFinicityCustomerAccounts?:  Array< {
    __typename: "FinicityBankAccountInfo",
    id?: string | null,
    accountNumberDisplay?: string | null,
    name?: string | null,
    type?: string | null,
    balance?: number | null,
    status?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "FinicityBankInstitution",
      name?: string | null,
      urlHomeApp?: string | null,
    } | null,
  } > | null,
};

export type GetProcoreCompaniesQueryVariables = {
  input: GetProcoreCompaniesInput,
};

export type GetProcoreCompaniesQuery = {
  getProcoreCompanies?:  Array< {
    __typename: "GetProcoreCompaniesPayload",
    id: number,
    name: string,
    is_active: boolean,
    logo_url?: string | null,
  } > | null,
};

export type GetProcoreProjectsQueryVariables = {
  input: GetProcoreProjectsInput,
};

export type GetProcoreProjectsQuery = {
  getProcoreProjects?:  Array< {
    __typename: "GetProcoreProjectsPayload",
    id: number,
    active: boolean,
    display_name: string,
    name: string,
    created_at: string,
    start_date?: string | null,
    completion_date?: string | null,
    project_number?: string | null,
    project_stage?:  {
      __typename: "ProcoreProjectStage",
      id: number,
      name: string,
    } | null,
    project_template?:  {
      __typename: "ProcoreProjectTemplate",
      id: number,
      name: string,
    } | null,
    total_value?: string | null,
  } > | null,
};

export type GetProcoreProjectUsersQueryVariables = {
  input: GetProcoreProjectUsersInput,
};

export type GetProcoreProjectUsersQuery = {
  getProcoreProjectUsers?:  Array< {
    __typename: "GetProcoreProjectUsersPayload",
    id: number,
    name: string,
    email_address?: string | null,
  } > | null,
};

export type GetProcoreWBSCodesQueryVariables = {
  input: GetProcoreWBSCodesInput,
};

export type GetProcoreWBSCodesQuery = {
  getProcoreWBSCodes?:  Array< {
    __typename: "GetProcoreWBSCodesPayload",
    id: number,
    flat_code?: string | null,
    flat_name?: string | null,
    description?: string | null,
    status?: string | null,
    segment_items?:  Array< {
      __typename: "ProcoreSegmentItem",
      id: number,
      code?: string | null,
      name?: string | null,
      status?: string | null,
    } > | null,
  } > | null,
};

export type GetCardsManagementFilterOptionsQueryVariables = {
  input: GetCardsManagementFilterOptionsInput,
};

export type GetCardsManagementFilterOptionsQuery = {
  getCardsManagementFilterOptions:  {
    __typename: "GetCardsManagementFilterOptionsResult",
    cardGroupId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardNames?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardholders?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    last4?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    status?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
  },
};

export type GetAgaveProjectsQueryVariables = {
  input: AgaveProjectsInput,
};

export type GetAgaveProjectsQuery = {
  getAgaveProjects?:  Array< {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } > | null,
};

export type GetAgaveGlCodesQueryVariables = {
  input: AgaveGlCodesInput,
};

export type GetAgaveGlCodesQuery = {
  getAgaveGlCodes?:  Array< {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } > | null,
};

export type GetAgaveCostCodesQueryVariables = {
  input: AgaveCostCodesInput,
};

export type GetAgaveCostCodesQuery = {
  getAgaveCostCodes?:  Array< {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } > | null,
};

export type GetAgaveEmployeesQueryVariables = {
  input: AgaveEmployeesInput,
};

export type GetAgaveEmployeesQuery = {
  getAgaveEmployees?:  Array< {
    __typename: "AgaveEmployee",
    id?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveEmployeeAddress",
      city?: string | null,
      country?: string | null,
      postal_code?: string | null,
      state?: string | null,
      street_1?: string | null,
      street_2?: string | null,
      type?: string | null,
    } | null,
    company?: string | null,
    email?: string | null,
    first_name?: string | null,
    full_name?: string | null,
    gender?: string | null,
    hire_date?: string | null,
    industry?: string | null,
    job_title?: string | null,
    last_name?: string | null,
    mobile_phone?: string | null,
    phone?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    status?: string | null,
    termination_date?: string | null,
    type?: string | null,
    source_data?:  {
      __typename: "AgaveEmployeeSourceData",
      path?: string | null,
      content_type?: string | null,
    } | null,
  } > | null,
};

export type GetAgaveCostTypesQueryVariables = {
  input: AgaveCostTypesInput,
};

export type GetAgaveCostTypesQuery = {
  getAgaveCostTypes?:  Array< {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } > | null,
};

export type GetAgaveGlCostTypesQueryVariables = {
  input: AgaveGlCostTypesInput,
};

export type GetAgaveGlCostTypesQuery = {
  getAgaveGlCostTypes?:  Array< {
    __typename: "AgaveGlCostType",
    id?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveGlCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
  } > | null,
};

export type GetAgaveVendorsQueryVariables = {
  input: GetAgaveVendorsInput,
};

export type GetAgaveVendorsQuery = {
  getAgaveVendors?:  Array< {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } > | null,
};

export type GetAgaveBankAccountsQueryVariables = {
  input: AgaveBankAccountsInput,
};

export type GetAgaveBankAccountsQuery = {
  getAgaveBankAccounts?:  Array< {
    __typename: "AgaveBankAccount",
    id?: string | null,
    source_id?: string | null,
    bank_name?: string | null,
    currency_code?: string | null,
    current_balance?: string | null,
    description?: string | null,
    ledger_account_id?: string | null,
    name?: string | null,
    number?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    status?: string | null,
    type?: string | null,
    source_data?:  {
      __typename: "AgaveBankAccountSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
  } > | null,
};

export type GetAgaveVendorByNameQueryVariables = {
  input: GetAgaveVendorInput,
};

export type GetAgaveVendorByNameQuery = {
  getAgaveVendorByName?:  Array< {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } > | null,
};

export type GetAgaveAccountQueryVariables = {
  input: AgaveAccountInput,
};

export type GetAgaveAccountQuery = {
  getAgaveAccount:  {
    __typename: "AgaveAccount",
    account_id?: string | null,
    connection?:  {
      __typename: "AgaveAccountConnection",
      type?: string | null,
    } | null,
    created_at?: string | null,
    linked_company?:  {
      __typename: "AgaveAccountLinkedCompany",
      id?: string | null,
      source_id?: string | null,
      name?: string | null,
    } | null,
    linked_user?:  {
      __typename: "AgaveAccountLinkedUser",
      id?: string | null,
      source_id?: string | null,
      name?: string | null,
      email?: string | null,
    } | null,
    reference_id?: string | null,
    source_system?:  {
      __typename: "AgaveAccountSourceSystem",
      name?: string | null,
      slug?: string | null,
    } | null,
    source_system_environment?:  {
      __typename: "AgaveAccountSourceSystemEnvironment",
      name?: string | null,
      slug?: string | null,
    } | null,
    status?: string | null,
    supports_cross_account_uuid?: boolean | null,
    supports_cross_company_requests?: boolean | null,
  },
};

export type GetAgavePassThroughQueryVariables = {
  input: AgavePassThroughInput,
};

export type GetAgavePassThroughQuery = {
  getAgavePassThrough?:  Array< {
    __typename: "AgavePassThroughResponse",
    status: number,
    content_type: string,
    body?: string | null,
    headers?:  {
      __typename: "AWSJSONWrapper",
      raw?: string | null,
    } | null,
  } > | null,
};

export type GetAgaveAPInvoiceByFilterSageIntacctQueryVariables = {
  input: GetAgaveAPInvoiceByFilterSageIntacctInput,
};

export type GetAgaveAPInvoiceByFilterSageIntacctQuery = {
  getAgaveAPInvoiceByFilterSageIntacct?:  Array< {
    __typename: "AgaveAPInvoicesPayload",
    id?: string | null,
    source_id?: string | null,
    amount?: string | null,
    amount_due?: string | null,
    ap_payment_ids?: Array< string | null > | null,
    attachments?:  Array< {
      __typename: "AgaveAPInvoicesResultAttachment",
      id?: string | null,
      source_id?: string | null,
      name?: string | null,
      url?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null > | null,
    batch?: string | null,
    batch_id?: string | null,
    contract?:  {
      __typename: "AgaveAPInvoicesResultContract",
      id?: string | null,
      type?: string | null,
    } | null,
    creator_id?: string | null,
    currency_code?: string | null,
    description?: string | null,
    discount_amount?: string | null,
    discount_date?: string | null,
    due_date?: string | null,
    issue_date?: string | null,
    line_items?:  Array< {
      __typename: "AgaveAPInvoicesResultLineItem",
      id?: string | null,
      source_id?: string | null,
      amount?: string | null,
      cost_code_id?: string | null,
      cost_type_id?: string | null,
      customer_id?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      item_id?: string | null,
      ledger_account_id?: string | null,
      project_id?: string | null,
      quantity?: string | null,
      retention_amount?: string | null,
      status?: string | null,
      sub_job_id?: string | null,
      tax_amount?: string | null,
      tax_code_id?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_of_measure?: string | null,
      vendor_id?: string | null,
      wbs_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null > | null,
    misc_amount?: string | null,
    net_amount?: string | null,
    number?: string | null,
    project_id?: string | null,
    retention_amount?: string | null,
    retention_percent?: string | null,
    status?: string | null,
    subtotal_amount?: string | null,
    tax_amount?: string | null,
    total_amount?: string | null,
    type?: string | null,
    vendor_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveAPInvoicesResultSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
  } > | null,
};

export type HnGetVelocityRuleByIdQueryVariables = {
  ruleId: string,
};

export type HnGetVelocityRuleByIdQuery = {
  hnGetVelocityRuleById?:  {
    __typename: "HNVelocityRule",
    id: string,
    name?: string | null,
    velocityRuleWindow?: HNVelocityRuleWindow | null,
    cumulativeRule: ( {
        __typename: "HNMerchantCategorySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
        allowedMcc?: Array< string > | null,
        blockedMcc?: Array< string > | null,
      } | {
        __typename: "HNCVVSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNStreetAddressSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNMerchantIdentifierSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNMerchantCountrySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNAmountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        maximumCount?: number | null,
      } | {
        __typename: "HNPointOfServiceCategorySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNPostalCodeVerificationSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNDepositAmountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNDepositProcessingNetworkSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNDepositCountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        maximumCount?: number | null,
      } | {
        __typename: "HNConditionalRuleSetSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allow?: boolean | null,
      } | {
        __typename: "HNCardTransactionProcessingTypeConditionSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNRestrictedAccountHolderSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNPanEntryModeSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNCardDataInputCapabilitySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      }
    ) | null,
    spendRules:  Array<( {
        __typename: "HNMerchantCategorySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
        allowedMcc?: Array< string > | null,
        blockedMcc?: Array< string > | null,
      } | {
        __typename: "HNCVVSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNStreetAddressSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNMerchantIdentifierSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNMerchantCountrySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNAmountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNCountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        maximumCount?: number | null,
      } | {
        __typename: "HNPointOfServiceCategorySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNPostalCodeVerificationSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNDepositAmountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | {
        __typename: "HNDepositProcessingNetworkSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNDepositCountLimitSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        maximumCount?: number | null,
      } | {
        __typename: "HNConditionalRuleSetSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allow?: boolean | null,
      } | {
        __typename: "HNCardTransactionProcessingTypeConditionSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNRestrictedAccountHolderSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNPanEntryModeSpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      } | {
        __typename: "HNCardDataInputCapabilitySpendRule",
        id: string,
        name?: string | null,
        version?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        allowed?: Array< string > | null,
        blocked?: Array< string > | null,
      }
    ) | null > | null,
    version?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    revisions?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    velocityConstraintLevelOverride?: HNVelocityConstraintLevel | null,
  } | null,
};

export type SearchSpxTransactionsQueryVariables = {
  input: SearchSpxTransactionsInput,
};

export type SearchSpxTransactionsQuery = {
  searchSpxTransactions?:  {
    __typename: "SearchSpxTransactionsPayload",
    items?:  Array< {
      __typename: "HighnoteTransactionEvent",
      id: string,
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      reconciliationId?: string | null,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      eventDate: string,
      processedAt?: string | null,
      origin: string,
      status: HighnoteTransactionStatus,
      partial?: boolean | null,
      settlementImpact?: boolean | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      eventData?: string | null,
      transactionOldState?: string | null,
      transactionNewState?: string | null,
      enableListing?: boolean | null,
      email?: string | null,
      userId?: string | null,
      last4?: string | null,
      groupApprovalLevels?: number | null,
      owningProjectGroupIds?: Array< string | null > | null,
      cardGroupId?: string | null,
      merchantCategory?: string | null,
      merchantCategoryCode?: string | null,
      merchantName?: string | null,
      jobCodeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      workflowStatus?: WorkflowStatus | null,
      returnedStatus?: ReturnedStatus | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveExpenseId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveGlCodeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      erpApprovalStatus?: boolean | null,
      erpBypassStatus?: boolean | null,
      // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
      // line billable at post time (Sage Intacct's billable cascade also requires the coded
      // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
      // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
      // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
      // ERP-neutral so a future ERP can reuse the same fields.
      erpBillableItemId?: string | null,
      erpBillableItemName?: string | null,
      // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
      // (manual pick or cost-type derivation); explicitly false posts the line
      // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
      // behavior: item present = billable.
      erpBillable?: boolean | null,
      // Generic ERP posting status tracking (for all ERPs)
      erpPostingStatus?: ERPPostingStatus | null,
      erpPostingError?: string | null,
      // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
      // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
      erpPostingWarning?: string | null,
      // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
      sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
      sage300APInvoiceError?: string | null,
      note?: string | null,
      approveWithoutNotes?: boolean | null,
      receiptPath?: string | null,
      receiptId?: string | null,
      // Source-of-truth flag maintained by the v2-transaction Lambda from the
      // TransactionToReceiptUpload join table. Use this for "does this transaction
      // have a receipt"; receiptPath/receiptId are legacy display pointers.
      hasReceipt?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      // Admin time savings tracking (SEE-407)
      codedAt?: string | null,
      codingMethod?: string | null,
      receiptUploadedAt?: string | null,
      receiptUploadMethod?: string | null,
      // SEE-1462: set once the transaction has been HANDLED by the daily flex
      // transaction export. Selection is "qualifying and erpExportedAt not set", plus
      // ONE permanent time bound: transactions dated before the company's enablement
      // window are baseline-stamped rather than delivered (see erpExportBatchId
      // below). There is deliberately no index on this field — the export queries
      // byPaidol and filters (an accepted read cost that grows with the company's
      // history).
      // 
      // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
      // stamps BEFORE building/uploading the file (a conditional update on
      // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
      // the file — this is what makes concurrent runs safe), and on a failed delivery
      // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
      // the rows return to the pool. Residual risk is a process kill between stamp and
      // rollback; the unwind is operational: for a FlexTransactionExport row that is
      // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
      // from the console/CLI, oldest first; deliberately no AppSync queryField), find
      // this paidol's transactions where
      // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
      // field is on the @searchable projection, no scan needed) and REMOVE
      // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
      // rollback fails, naming the stuck transaction ids.
      // 
      // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
      // a FlexTransactionExport.id for rows actually delivered in that run, or
      // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
      // handled-before-switch-on — on ANY run, not just the first: the cutoff is
      // permanent (anchored on the company's earliest export attempt; the audit row
      // for a run is created BEFORE the anchor is read, so a true first run anchors
      // on its own row), and a pre-enablement transaction is stamped whenever it
      // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
      // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
      // rollback nor the manual unwind above touches them (both match the bare batch
      // id, which "baseline-" rows never equal — that exclusion is intentional, not an
      // oversight; an operator should not hunt for baseline rows that "didn't get
      // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
      // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
      // newly enabled company's entire history would display as Exported for files
      // that never existed.
      // 
      // Field-level auth: read-only through AppSync for group members; admin roles
      // (custom-roles.json) bypass rules as everywhere. A client that can set
      // erpExportedAt can silently suppress a transaction from every future file
      // (selection skips stamped rows), or clear it and force a duplicate. The
      // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
      // `allow: private, provider: iam` read here either. A field-level rule is
      // unioned into the model's read resolvers, so it would reopen get/list/search
      // to every signed-in user's identity pool role.
      erpExportedAt?: string | null,
      erpExportBatchId?: string | null,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2CardHealthCheckQueryVariables = {
  input?: string | null,
};

export type V2CardHealthCheckQuery = {
  v2CardHealthCheck?: string | null,
};

export type V2TransactionHealthCheckQueryVariables = {
  input?: string | null,
};

export type V2TransactionHealthCheckQuery = {
  v2TransactionHealthCheck?: string | null,
};

export type V2SearchFlexGlCodesQueryVariables = {
  input: SearchFlexCodingInput,
};

export type V2SearchFlexGlCodesQuery = {
  v2SearchFlexGlCodes?:  {
    __typename: "SearchFlexGlCodePayload",
    items?:  Array< {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2GetProjectGroupQueryVariables = {
  input: GetProjectGroupInput,
};

export type V2GetProjectGroupQuery = {
  v2GetProjectGroup?:  {
    __typename: "GetProjectGroupPayload",
    projectGroup?:  {
      __typename: "ProjectGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    projects?:  Array< {
      __typename: "GetProjectGroupProjects",
      id: string,
      name: string,
    } > | null,
    groupAdmins?:  Array< {
      __typename: "PaidolUserToProjectGroup",
      id: string,
      paidolId: string,
      paidolUserId: string,
      projectGroupId: string,
      approvalLevels?: Array< number | null > | null,
      isReviewer?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type V2SearchFlexCodesQueryVariables = {
  input: SearchFlexCodingInput,
};

export type V2SearchFlexCodesQuery = {
  v2SearchFlexCodes?:  {
    __typename: "SearchFlexCodesPayload",
    items?:  Array< {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchFlexCostCodesQueryVariables = {
  input: SearchFlexCodingInput,
};

export type V2SearchFlexCostCodesQuery = {
  v2SearchFlexCostCodes?:  {
    __typename: "SearchFlexCostCodesPayload",
    items?:  Array< {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchFlexCostTypesQueryVariables = {
  input: SearchFlexCodingInput,
};

export type V2SearchFlexCostTypesQuery = {
  v2SearchFlexCostTypes?:  {
    __typename: "SearchFlexCostTypesPayload",
    items?:  Array< {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchFlexVendorsQueryVariables = {
  input: SearchFlexCodingInput,
};

export type V2SearchFlexVendorsQuery = {
  v2SearchFlexVendors?:  {
    __typename: "SearchFlexVendorsPayload",
    items?:  Array< {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetAgaveSyncByPaidolIdQueryVariables = {
  input: GetAgaveSyncByPaidolIdInput,
};

export type GetAgaveSyncByPaidolIdQuery = {
  getAgaveSyncByPaidolId?:  {
    __typename: "GetAgaveSyncByPaidolIdPayload",
    sync?:  {
      __typename: "PaidolAgaveSync",
      id: string,
      paidolId: string,
      authPaidolId: string,
      inProgress: boolean,
      error?: string | null,
      lastRunStart: string,
      lastRunEnd?: string | null,
      taskArn?: string | null,
      syncEntityFilter?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type MigrateERPEndpointSettingsQueryVariables = {
  input: string,
};

export type MigrateERPEndpointSettingsQuery = {
  migrateERPEndpointSettings?:  {
    __typename: "MigrateERPEndpointSettingsPayload",
    migrated?: boolean | null,
    paidol?:  {
      __typename: "Paidol",
      id: string,
      id_base58?: string | null,
      id_base58_short?: string | null,
      // TODO: owner_paidol_id gives Paidols the right to edit other Paidols
      // that are associated w/ their Suppliers... this will probably need
      // to be rethought once we start onboarding Suppliers into the system
      // as Paidol administrators
      owner_paidol_id?: string | null,
      slug?: string | null,
      legal_name?: string | null,
      account_balance?: string | null,
      name: string,
      dba?: string | null,
      ein?: string | null,
      mcc?: string | null,
      corp_type?: string | null,
      industry?: string | null,
      company_email?: string | null,
      customer_facing_email?: string | null,
      company_phone?: string | null,
      website?: string | null,
      business_owner_ssn?: string | null,
      dwolla_business_industry_classification?: string | null,
      admin_user_id?: string | null,
      low_balance_alert_threshold?: number | null,
      low_balance_auto_funding_amount?: number | null,
      low_balance_auto_funding_threshold?: number | null,
      speedscore?: number | null,
      priority_status?: string | null,
      deleted_at?: string | null,
      company_id?: string | null,
      logo?: string | null,
      priority_response?: string | null,
      // Indicates whether agave data is currently being synced to the Paidol
      agave_data_sync_in_progress?: boolean | null,
      submittedBankAccounts?: Array< string | null > | null,
      achEnabled?: boolean | null,
      virtualCardRequested?: boolean | null,
      virtualCardEnabled?: boolean | null,
      achRequested?: boolean | null,
      cron_status?: CronStatus | null,
      // The Cognito user ID of the user who signed-up for Speedchain
      owner_sub?: string | null,
      is_test_fixture?: boolean | null,
      is_migration?: boolean | null,
      // Enables Payment Cards when signed-in to Speedchain
      enablePCards?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Indicates if it's a Construction company, which will allow 3rd party connections such as Procore
      isConstructionType?: boolean | null,
      // Account token that is getting persisted after a user authenticates with the agave widget
      agaveAccountToken?: string | null,
      // The slug of the connected ERP source system (e.g., 'quickbooks-online', 'sage-300-cre')
      // Persisted when user authenticates with Agave to avoid async lookup
      agaveSourceSystemSlug?: string | null,
      // Is this paidol an Agave client or not
      isAgaveClient?: boolean | null,
      // Whether this paidol uses Speedchain's direct ERP integration (ERPv1) instead of Agave
      erpSpeedchain?: boolean | null,
      // References the ERPConnection record for this paidol's direct ERP integration
      erpConnectionId?: string | null,
      // SEE-1030: QBO realmId of the company this paidol was connected to via Agave,
      // captured at swap time (before the Agave token is cleared). The direct-ERP
      // cutover reconciliation compares it to the reconnected realmId to confirm a
      // same-company migration before remapping coding references.
      priorErpRealmId?: string | null,
      // SEE-1030: Human-readable name of the prior Agave-connected company (label only).
      priorErpName?: string | null,
      // SEE-1030: Timestamp set once the one-time cutover reconciliation has run for
      // this paidol, so subsequent direct syncs skip the bridge/clear step.
      erpCutoverReconciledAt?: string | null,
      // Track which ERP system a user wants to integrate their SC transactions with
      selectedERP?: ERP | null,
      logoUrl?: string | null,
      isProcoreClient?: boolean | null,
      creditLimit?: number | null,
      // SEE-1112: True when this Sage Intacct paidol does NOT license the Projects module.
      // Their projects/codes live as GL dimensions, so coding is sourced from them
      // (Project native via AR, Class -> cost code, Item -> cost type), coding-dropdown
      // filtering is bypassed (show all, no relationships exist), and posting routes the
      // cost code -> classid and cost type -> itemid. Absent/false = standard behavior.
      intacctProjectsNotLicensed?: boolean | null,
      // SEE-1773: Sage Intacct only. When on, a transaction coded to a project created
      // at the Sage top level posts on the top-level session, so Sage owns the record at
      // the top level and Projects > Generate Invoices sees it from the top level too.
      intacctTopLevelProjectPosting?: boolean | null,
      paymentTermDays?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListMerchantSpendRulesForPaidolQueryVariables = {
  input: ListMerchantSpendRulesInput,
};

export type ListMerchantSpendRulesForPaidolQuery = {
  listMerchantSpendRulesForPaidol?:  Array< {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } > | null,
};

export type V2ListCardGroupsByPaidolIdQueryVariables = {
  input: v2ListCardGroupsByPaidolIdInput,
};

export type V2ListCardGroupsByPaidolIdQuery = {
  v2ListCardGroupsByPaidolId?:  {
    __typename: "v2ListCardGroupsByPaidolIdPayload",
    items:  Array< {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2ListProjectGroupsByPaidolIdQueryVariables = {
  input: v2ListProjectGroupsByPaidolIdInput,
};

export type V2ListProjectGroupsByPaidolIdQuery = {
  v2ListProjectGroupsByPaidolId?:  {
    __typename: "v2ListProjectGroupsByPaidolIdPayload",
    items:  Array< {
      __typename: "ProjectGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveGLCodesQueryVariables = {
  input: SearchAgaveGLCodesInput,
};

export type V2SearchAgaveGLCodesQuery = {
  v2SearchAgaveGLCodes?:  {
    __typename: "SearchAgaveGLCodesPayload",
    items?:  Array< {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveProjectsQueryVariables = {
  input: SearchAgaveProjectsInput,
};

export type V2SearchAgaveProjectsQuery = {
  v2SearchAgaveProjects?:  {
    __typename: "SearchAgaveProjectsPayload",
    items?:  Array< {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveCostCodesQueryVariables = {
  input: SearchAgaveCostCodesInput,
};

export type V2SearchAgaveCostCodesQuery = {
  v2SearchAgaveCostCodes?:  {
    __typename: "SearchAgaveCostCodesPayload",
    items?:  Array< {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2GetAgaveGlCodesByCostingQueryVariables = {
  input: GetAgaveGlCodesByCostingInput,
};

export type V2GetAgaveGlCodesByCostingQuery = {
  v2GetAgaveGlCodesByCosting?:  {
    __typename: "GetAgaveGlCodesByCostingPayload",
    items?:  Array< {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } > | null,
    total?: number | null,
    itemSourceId?: string | null,
    itemName?: string | null,
  } | null,
};

export type V2SearchAgaveVendorsQueryVariables = {
  input: SearchAgaveVendorsInput,
};

export type V2SearchAgaveVendorsQuery = {
  v2SearchAgaveVendors?:  {
    __typename: "SearchAgaveVendorsPayload",
    items?:  Array< {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveCostTypesQueryVariables = {
  input: SearchAgaveCostTypesInput,
};

export type V2SearchAgaveCostTypesQuery = {
  v2SearchAgaveCostTypes?:  {
    __typename: "SearchAgaveCostTypesPayload",
    items?:  Array< {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveSubJobsQueryVariables = {
  input: SearchAgaveSubJobsInput,
};

export type V2SearchAgaveSubJobsQuery = {
  v2SearchAgaveSubJobs?:  {
    __typename: "SearchAgaveSubJobsPayload",
    items?:  Array< {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveLocationsQueryVariables = {
  input: SearchAgaveLocationsInput,
};

export type V2SearchAgaveLocationsQuery = {
  v2SearchAgaveLocations?:  {
    __typename: "SearchAgaveLocationsPayload",
    items?:  Array< {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveDepartmentsQueryVariables = {
  input: SearchAgaveDepartmentsInput,
};

export type V2SearchAgaveDepartmentsQuery = {
  v2SearchAgaveDepartments?:  {
    __typename: "SearchAgaveDepartmentsPayload",
    items?:  Array< {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveSubaccountsQueryVariables = {
  input: SearchAgaveSubaccountsInput,
};

export type V2SearchAgaveSubaccountsQuery = {
  v2SearchAgaveSubaccounts?:  {
    __typename: "SearchAgaveSubaccountsPayload",
    items?:  Array< {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2SearchAgaveEmployeesQueryVariables = {
  input: SearchAgaveEmployeesInput,
};

export type V2SearchAgaveEmployeesQuery = {
  v2SearchAgaveEmployees?:  {
    __typename: "SearchAgaveEmployeesPayload",
    items?:  Array< {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type V2ReimbursementsHealthCheckQueryVariables = {
  input?: string | null,
};

export type V2ReimbursementsHealthCheckQuery = {
  v2ReimbursementsHealthCheck?: string | null,
};

export type V2GetReimbursementTransactionQueryVariables = {
  input: GetReimbursementTransactionInput,
};

export type V2GetReimbursementTransactionQuery = {
  v2GetReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2GetReimbursementTransactionsByPaidolIdQueryVariables = {
  input: GetReimbursementTransactionsByPaidolIdInput,
};

export type V2GetReimbursementTransactionsByPaidolIdQuery = {
  v2GetReimbursementTransactionsByPaidolId?:  {
    __typename: "GetReimbursementTransactionsByPaidolIdPayload",
    items:  Array< {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } >,
    nextToken?: string | null,
  } | null,
};

export type V2GetReceiptUploadQueryVariables = {
  input: GetReceiptUploadInput,
};

export type V2GetReceiptUploadQuery = {
  v2GetReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2GetReceiptsByTransactionIdQueryVariables = {
  input: GetReceiptsByTransactionIdInput,
};

export type V2GetReceiptsByTransactionIdQuery = {
  v2GetReceiptsByTransactionId?:  {
    __typename: "GetReceiptsByTransactionIdPayload",
    items:  Array< {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } >,
    nextToken?: string | null,
  } | null,
};

export type V2ExportReimbursementsQueryVariables = {
  input: ExportReimbursementsInput,
};

export type V2ExportReimbursementsQuery = {
  v2ExportReimbursements?:  {
    __typename: "ExportReimbursementsPayload",
    csvContent?: string | null,
    filename?: string | null,
    success: boolean,
    message?: string | null,
    exportedIds?: Array< string > | null,
    skippedIds?: Array< string > | null,
  } | null,
};

export type GetBudgetSpendByCurrentCycleQueryVariables = {
  paymentCardId: string,
};

export type GetBudgetSpendByCurrentCycleQuery = {
  getBudgetSpendByCurrentCycle?:  {
    __typename: "BudgetSpendByCurrentCycle",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    amount?: number | null,
    transactionCount?: number | null,
    lastResetAt?: string | null,
    lastTransactionAt?: string | null,
    processedTransactionIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type V2GetTransactionFilterOptionsQueryVariables = {
  input: V2GetTransactionFilterOptionsInput,
};

export type V2GetTransactionFilterOptionsQuery = {
  v2GetTransactionFilterOptions?:  {
    __typename: "V2TransactionFilterOptionsPayload",
    paidolId: string,
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    erpBillableItemIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    statementPeriods?:  Array< {
      __typename: "StatementPeriodOption",
      id: string,
      label: string,
      startDate: string,
      endDate: string,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdatePaymentStatusDownloadByIdSubscriptionVariables = {
  id: string,
};

export type OnUpdatePaymentStatusDownloadByIdSubscription = {
  onUpdatePaymentStatusDownloadById?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTransactionsDownloadQueueByIdSubscriptionVariables = {
  id: string,
};

export type OnUpdateTransactionsDownloadQueueByIdSubscription = {
  onUpdateTransactionsDownloadQueueById?:  {
    __typename: "TransactionsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    range_option: ExportDateRangeEnum,
    start_date?: string | null,
    end_date?: string | null,
    columns: Array< string >,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    paidolUserId?: string | null,
    mark_as_exported?: boolean | null,
    exported_count?: number | null,
    skipped_count?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateTransactionsReceiptsDownloadQueueByIdSubscriptionVariables = {
  id: string,
};

export type OnUpdateTransactionsReceiptsDownloadQueueByIdSubscription = {
  onUpdateTransactionsReceiptsDownloadQueueById?:  {
    __typename: "TransactionsReceiptsDownloadQueue",
    id: string,
    user_id: string,
    paidol_id: string,
    paidolUserId?: string | null,
    s3_key?: string | null,
    range_option?: ExportDateRangeEnum | null,
    start_date?: string | null,
    end_date?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    // SEE-1377: why the export ended in ERROR (RANGE_TOO_LARGE, NO_RECEIPTS,
    // EXPORT_FAILED) so the frontend can show an honest message instead of a
    // generic "no receipts found".
    error_code?: string | null,
    createdAt: string,
    filteredTransactionIds?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateHighnoteTransactionEventByIdSubscriptionVariables = {
  id: string,
};

export type OnUpdateHighnoteTransactionEventByIdSubscription = {
  onUpdateHighnoteTransactionEventById?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAgaveProjectSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectFilterInput | null,
};

export type OnCreateAgaveProjectSubscription = {
  onCreateAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnUpdateAgaveProjectSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectFilterInput | null,
};

export type OnUpdateAgaveProjectSubscription = {
  onUpdateAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnDeleteAgaveProjectSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectFilterInput | null,
};

export type OnDeleteAgaveProjectSubscription = {
  onDeleteAgaveProject?:  {
    __typename: "AgaveProject",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      postal_code?: string | null,
      country?: string | null,
    } | null,
    amount?: number | null,
    completion_date?: string | null,
    name?: string | null,
    number?: string | null,
    start_date?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnCreateAgaveGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveGlCodeFilterInput | null,
};

export type OnCreateAgaveGlCodeSubscription = {
  onCreateAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnUpdateAgaveGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveGlCodeFilterInput | null,
};

export type OnUpdateAgaveGlCodeSubscription = {
  onUpdateAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnDeleteAgaveGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveGlCodeFilterInput | null,
};

export type OnDeleteAgaveGlCodeSubscription = {
  onDeleteAgaveGlCode?:  {
    __typename: "AgaveGlCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    classification?: string | null,
    currency_code?: string | null,
    current_balance?: number | null,
    description?: string | null,
    name?: string | null,
    number?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSourceData",
      CreationDate?: string | null,
      data?: string | null,
      DeliveryAddressLine?: Array< string | null > | null,
      DeliveryCity?: Array< string | null > | null,
      DeliveryCountry?: Array< string | null > | null,
      DeliveryPostcode?: Array< string | null > | null,
      DeliveryState?: Array< string | null > | null,
      FaxNumber?: string | null,
      LogoPath?: string | null,
      ProjectOwnerOrganizationId?: string | null,
      ProjectOwnerOrganizationName?: string | null,
      PhoneNumber?: string | null,
      PostalAddressLine?: Array< string | null > | null,
      PostalCity?: Array< string | null > | null,
      PostalCountry?: Array< string | null > | null,
      PostalPostcode?: Array< string | null > | null,
      PostalState?: Array< string | null > | null,
      ProjectAddressLine?: string | null,
      ProjectCity?: string | null,
      ProjectCode?: string | null,
      ProjectCountry?: string | null,
      ProjectDescription?: string | null,
      ProjectId?: string | null,
      ProjectName?: string | null,
      ProjectPostcode?: string | null,
      ProjectShortName?: string | null,
      ProjectState?: string | null,
      ProjectType?: string | null,
      ProjectValue?: string | null,
      ProjectResponsibilities?: Array< string | null > | null,
      StartDate?: string | null,
      StopDate?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnCreateAgaveCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeFilterInput | null,
};

export type OnCreateAgaveCostCodeSubscription = {
  onCreateAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type OnUpdateAgaveCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeFilterInput | null,
};

export type OnUpdateAgaveCostCodeSubscription = {
  onUpdateAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type OnDeleteAgaveCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeFilterInput | null,
};

export type OnDeleteAgaveCostCodeSubscription = {
  onDeleteAgaveCostCode?:  {
    __typename: "AgaveCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    asset_account_id?: string | null,
    source_id?: string | null,
    formatted_full_code?: string | null,
    code?: string | null,
    full_code?: string | null,
    cost_unit_of_measure?: string | null,
    description?: string | null,
    expense_account_id?: string | null,
    income_account_id?: string | null,
    name?: string | null,
    parent_id?: string | null,
    project_id?: string | null,
    price_unit_of_measure?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostCodesSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    status?: string | null,
    type?: string | null,
    unit_cost?: string | null,
    unit_price?: string | null,
    vendor_id?: string | null,
    sub_job_id?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
    projectIds?: Array< string | null > | null,
    cost_type_ids?: Array< string | null > | null,
    fullName?: string | null,
  } | null,
};

export type OnCreateAgaveSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobFilterInput | null,
};

export type OnCreateAgaveSubJobSubscription = {
  onCreateAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type OnUpdateAgaveSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobFilterInput | null,
};

export type OnUpdateAgaveSubJobSubscription = {
  onUpdateAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type OnDeleteAgaveSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobFilterInput | null,
};

export type OnDeleteAgaveSubJobSubscription = {
  onDeleteAgaveSubJob?:  {
    __typename: "AgaveSubJob",
    id: string,
    agaveSubJobId?: string | null,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    name?: string | null,
    number?: string | null,
    code?: string | null,
    status?: string | null,
    type?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveSubJobSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    fullName?: string | null,
    cost_code_ids?: Array< string | null > | null,
  } | null,
};

export type OnCreateAgaveProjectCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectCostCodeFilterInput | null,
};

export type OnCreateAgaveProjectCostCodeSubscription = {
  onCreateAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveProjectCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectCostCodeFilterInput | null,
};

export type OnUpdateAgaveProjectCostCodeSubscription = {
  onUpdateAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveProjectCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectCostCodeFilterInput | null,
};

export type OnDeleteAgaveProjectCostCodeSubscription = {
  onDeleteAgaveProjectCostCode?:  {
    __typename: "AgaveProjectCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    projectIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveProjectSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectSubJobFilterInput | null,
};

export type OnCreateAgaveProjectSubJobSubscription = {
  onCreateAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveProjectSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectSubJobFilterInput | null,
};

export type OnUpdateAgaveProjectSubJobSubscription = {
  onUpdateAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveProjectSubJobSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectSubJobFilterInput | null,
};

export type OnDeleteAgaveProjectSubJobSubscription = {
  onDeleteAgaveProjectSubJob?:  {
    __typename: "AgaveProjectSubJob",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    subJobId: string,
    projectIdSubJobId?: string | null,
    subJobName?: string | null,
    subJobNumber?: string | null,
    projectName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveSubJobCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobCostCodeFilterInput | null,
};

export type OnCreateAgaveSubJobCostCodeSubscription = {
  onCreateAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveSubJobCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobCostCodeFilterInput | null,
};

export type OnUpdateAgaveSubJobCostCodeSubscription = {
  onUpdateAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveSubJobCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubJobCostCodeFilterInput | null,
};

export type OnDeleteAgaveSubJobCostCodeSubscription = {
  onDeleteAgaveSubJobCostCode?:  {
    __typename: "AgaveSubJobCostCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    subJobId: string,
    costCodeId: string,
    projectId?: string | null,
    subJobIdCostCodeId?: string | null,
    costCodeName?: string | null,
    costCodeCode?: string | null,
    subJobName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveProjectLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectLocationFilterInput | null,
};

export type OnCreateAgaveProjectLocationSubscription = {
  onCreateAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveProjectLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectLocationFilterInput | null,
};

export type OnUpdateAgaveProjectLocationSubscription = {
  onUpdateAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveProjectLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectLocationFilterInput | null,
};

export type OnDeleteAgaveProjectLocationSubscription = {
  onDeleteAgaveProjectLocation?:  {
    __typename: "AgaveProjectLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    locationId: string,
    projectName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveProjectDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectDepartmentFilterInput | null,
};

export type OnCreateAgaveProjectDepartmentSubscription = {
  onCreateAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveProjectDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectDepartmentFilterInput | null,
};

export type OnUpdateAgaveProjectDepartmentSubscription = {
  onUpdateAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveProjectDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveProjectDepartmentFilterInput | null,
};

export type OnDeleteAgaveProjectDepartmentSubscription = {
  onDeleteAgaveProjectDepartment?:  {
    __typename: "AgaveProjectDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    departmentId: string,
    projectName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmployeeEntitySubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeEntityFilterInput | null,
};

export type OnCreateAgaveEmployeeEntitySubscription = {
  onCreateAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnUpdateAgaveEmployeeEntitySubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeEntityFilterInput | null,
};

export type OnUpdateAgaveEmployeeEntitySubscription = {
  onUpdateAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnDeleteAgaveEmployeeEntitySubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeEntityFilterInput | null,
};

export type OnDeleteAgaveEmployeeEntitySubscription = {
  onDeleteAgaveEmployeeEntity?:  {
    __typename: "AgaveEmployeeEntity",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    status?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnCreateAgaveEmployeeLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeLocationFilterInput | null,
};

export type OnCreateAgaveEmployeeLocationSubscription = {
  onCreateAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmployeeLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeLocationFilterInput | null,
};

export type OnUpdateAgaveEmployeeLocationSubscription = {
  onUpdateAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmployeeLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeLocationFilterInput | null,
};

export type OnDeleteAgaveEmployeeLocationSubscription = {
  onDeleteAgaveEmployeeLocation?:  {
    __typename: "AgaveEmployeeLocation",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    locationId: string,
    employeeName?: string | null,
    locationName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmployeeDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeDepartmentFilterInput | null,
};

export type OnCreateAgaveEmployeeDepartmentSubscription = {
  onCreateAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmployeeDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeDepartmentFilterInput | null,
};

export type OnUpdateAgaveEmployeeDepartmentSubscription = {
  onUpdateAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmployeeDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmployeeDepartmentFilterInput | null,
};

export type OnDeleteAgaveEmployeeDepartmentSubscription = {
  onDeleteAgaveEmployeeDepartment?:  {
    __typename: "AgaveEmployeeDepartment",
    id: string,
    paidolId: string,
    authPaidolId: string,
    employeeId: string,
    departmentId: string,
    employeeName?: string | null,
    departmentName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostTypeFilterInput | null,
};

export type OnCreateAgaveCostTypeSubscription = {
  onCreateAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type OnUpdateAgaveCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostTypeFilterInput | null,
};

export type OnUpdateAgaveCostTypeSubscription = {
  onUpdateAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type OnDeleteAgaveCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostTypeFilterInput | null,
};

export type OnDeleteAgaveCostTypeSubscription = {
  onDeleteAgaveCostType?:  {
    __typename: "AgaveCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    project_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    projectId?: string | null,
    paidolProject?: string | null,
  } | null,
};

export type OnCreateAgaveEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEquipmentFilterInput | null,
};

export type OnCreateAgaveEquipmentSubscription = {
  onCreateAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEquipmentFilterInput | null,
};

export type OnUpdateAgaveEquipmentSubscription = {
  onUpdateAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEquipmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEquipmentFilterInput | null,
};

export type OnDeleteAgaveEquipmentSubscription = {
  onDeleteAgaveEquipment?:  {
    __typename: "AgaveEquipment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCo?: string | null,
    category?: string | null,
    department?: string | null,
    status?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEquipmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeFilterInput | null,
};

export type OnCreateAgaveEmCostCodeSubscription = {
  onCreateAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeFilterInput | null,
};

export type OnUpdateAgaveEmCostCodeSubscription = {
  onUpdateAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeFilterInput | null,
};

export type OnDeleteAgaveEmCostCodeSubscription = {
  onDeleteAgaveEmCostCode?:  {
    __typename: "AgaveEmCostCode",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    emCostTypeCodes?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostCodeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmDepartmentFilterInput | null,
};

export type OnCreateAgaveEmDepartmentSubscription = {
  onCreateAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmDepartmentFilterInput | null,
};

export type OnUpdateAgaveEmDepartmentSubscription = {
  onUpdateAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmDepartmentFilterInput | null,
};

export type OnDeleteAgaveEmDepartmentSubscription = {
  onDeleteAgaveEmDepartment?:  {
    __typename: "AgaveEmDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emCo?: string | null,
    costCodeKeys?: Array< string | null > | null,
    costTypeKeys?: Array< string | null > | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmDepartmentSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostTypeFilterInput | null,
};

export type OnCreateAgaveEmCostTypeSubscription = {
  onCreateAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostTypeFilterInput | null,
};

export type OnUpdateAgaveEmCostTypeSubscription = {
  onUpdateAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostTypeFilterInput | null,
};

export type OnDeleteAgaveEmCostTypeSubscription = {
  onDeleteAgaveEmCostType?:  {
    __typename: "AgaveEmCostType",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    emGroup?: string | null,
    abbreviation?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveEmCostTypeSourceData",
      path?: string | null,
      content_type?: string | null,
      data?: string | null,
    } | null,
    lastSeenAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeFilterInput | null,
};

export type OnCreateAgaveCostCodeCostTypeSubscription = {
  onCreateAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeFilterInput | null,
};

export type OnUpdateAgaveCostCodeCostTypeSubscription = {
  onUpdateAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeFilterInput | null,
};

export type OnDeleteAgaveCostCodeCostTypeSubscription = {
  onDeleteAgaveCostCodeCostType?:  {
    __typename: "AgaveCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    costCodeId: string,
    costTypeId: string,
    projectId?: string | null,
    costCodeCode?: string | null,
    costCodeName?: string | null,
    costTypeCode?: string | null,
    costTypeName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveEmCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput | null,
};

export type OnCreateAgaveEmCostCodeCostTypeSubscription = {
  onCreateAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveEmCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput | null,
};

export type OnUpdateAgaveEmCostCodeCostTypeSubscription = {
  onUpdateAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveEmCostCodeCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveEmCostCodeCostTypeFilterInput | null,
};

export type OnDeleteAgaveEmCostCodeCostTypeSubscription = {
  onDeleteAgaveEmCostCodeCostType?:  {
    __typename: "AgaveEmCostCodeCostType",
    id: string,
    paidolId: string,
    authPaidolId: string,
    emCostCodeId: string,
    emCostTypeId: string,
    emGroup?: string | null,
    emCostCodeCode?: string | null,
    emCostCodeName?: string | null,
    emCostTypeCode?: string | null,
    emCostTypeName?: string | null,
    unitOfMeasure?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveCostCodeCostTypeGlSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput | null,
};

export type OnCreateAgaveCostCodeCostTypeGlSubscription = {
  onCreateAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAgaveCostCodeCostTypeGlSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput | null,
};

export type OnUpdateAgaveCostCodeCostTypeGlSubscription = {
  onUpdateAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAgaveCostCodeCostTypeGlSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveCostCodeCostTypeGlFilterInput | null,
};

export type OnDeleteAgaveCostCodeCostTypeGlSubscription = {
  onDeleteAgaveCostCodeCostTypeGl?:  {
    __typename: "AgaveCostCodeCostTypeGl",
    id: string,
    paidolId: string,
    authPaidolId: string,
    projectId: string,
    costCodeId: string,
    costTypeId: string,
    glCodeId: string,
    projectCostCodeCostTypeKey: string,
    glCodeSourceId?: string | null,
    glCodeNumber?: string | null,
    itemSourceId?: string | null,
    itemName?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAgaveLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveLocationFilterInput | null,
};

export type OnCreateAgaveLocationSubscription = {
  onCreateAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnUpdateAgaveLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveLocationFilterInput | null,
};

export type OnUpdateAgaveLocationSubscription = {
  onUpdateAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnDeleteAgaveLocationSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveLocationFilterInput | null,
};

export type OnDeleteAgaveLocationSubscription = {
  onDeleteAgaveLocation?:  {
    __typename: "AgaveLocation",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    name?: string | null,
    fullName?: string | null,
    parent_id?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnCreateAgaveDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveDepartmentFilterInput | null,
};

export type OnCreateAgaveDepartmentSubscription = {
  onCreateAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnUpdateAgaveDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveDepartmentFilterInput | null,
};

export type OnUpdateAgaveDepartmentSubscription = {
  onUpdateAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnDeleteAgaveDepartmentSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveDepartmentFilterInput | null,
};

export type OnDeleteAgaveDepartmentSubscription = {
  onDeleteAgaveDepartment?:  {
    __typename: "AgaveDepartment",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    fullName?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
    relatedIds?: Array< string | null > | null,
  } | null,
};

export type OnCreateAgaveSubaccountSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubaccountFilterInput | null,
};

export type OnCreateAgaveSubaccountSubscription = {
  onCreateAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnUpdateAgaveSubaccountSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubaccountFilterInput | null,
};

export type OnUpdateAgaveSubaccountSubscription = {
  onUpdateAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnDeleteAgaveSubaccountSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveSubaccountFilterInput | null,
};

export type OnDeleteAgaveSubaccountSubscription = {
  onDeleteAgaveSubaccount?:  {
    __typename: "AgaveSubaccount",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    code?: string | null,
    name?: string | null,
    status?: string | null,
    type?: string | null,
    source_id?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    source_data?: string | null,
  } | null,
};

export type OnCreateAgaveVendorSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveVendorFilterInput | null,
};

export type OnCreateAgaveVendorSubscription = {
  onCreateAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type OnUpdateAgaveVendorSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveVendorFilterInput | null,
};

export type OnUpdateAgaveVendorSubscription = {
  onUpdateAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type OnDeleteAgaveVendorSubscriptionVariables = {
  filter?: ModelSubscriptionAgaveVendorFilterInput | null,
};

export type OnDeleteAgaveVendorSubscription = {
  onDeleteAgaveVendor?:  {
    __typename: "AgaveVendor",
    id: string,
    paidolId?: string | null,
    authPaidolId?: string | null,
    source_id?: string | null,
    address?:  {
      __typename: "AgaveVendorAddress",
      street_1?: string | null,
      street_2?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      postal_code?: string | null,
    } | null,
    code?: string | null,
    email?: string | null,
    fax?: string | null,
    name?: string | null,
    phone?: string | null,
    status?: AgaveVendorStatus | null,
    tax_number?: string | null,
    terms?: string | null,
    type?: AgaveVendorType | null,
    website?: string | null,
    source_create_time?: string | null,
    source_update_time?: string | null,
    source_data?:  {
      __typename: "AgaveVendorSourceData",
      V1099YN: AgaveVendorV1099YN,
      V1099Type?: string | null,
      V1099Box?: string | null,
      EFT: AgaveVendorEFT,
      data?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    fullName?: string | null,
  } | null,
};

export type OnCreatePaidolAgaveSyncSubscriptionVariables = {
  filter?: ModelSubscriptionPaidolAgaveSyncFilterInput | null,
};

export type OnCreatePaidolAgaveSyncSubscription = {
  onCreatePaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePaidolAgaveSyncSubscriptionVariables = {
  filter?: ModelSubscriptionPaidolAgaveSyncFilterInput | null,
};

export type OnUpdatePaidolAgaveSyncSubscription = {
  onUpdatePaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePaidolAgaveSyncSubscriptionVariables = {
  filter?: ModelSubscriptionPaidolAgaveSyncFilterInput | null,
};

export type OnDeletePaidolAgaveSyncSubscription = {
  onDeletePaidolAgaveSync?:  {
    __typename: "PaidolAgaveSync",
    id: string,
    paidolId: string,
    authPaidolId: string,
    inProgress: boolean,
    error?: string | null,
    lastRunStart: string,
    lastRunEnd?: string | null,
    taskArn?: string | null,
    syncEntityFilter?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePaymentStatusDownloadSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentStatusDownloadFilterInput | null,
  user_id?: string | null,
};

export type OnCreatePaymentStatusDownloadSubscription = {
  onCreatePaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePaymentStatusDownloadSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentStatusDownloadFilterInput | null,
  user_id?: string | null,
};

export type OnUpdatePaymentStatusDownloadSubscription = {
  onUpdatePaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePaymentStatusDownloadSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentStatusDownloadFilterInput | null,
  user_id?: string | null,
};

export type OnDeletePaymentStatusDownloadSubscription = {
  onDeletePaymentStatusDownload?:  {
    __typename: "PaymentStatusDownload",
    id: string,
    user_id: string,
    paidol_id: string,
    start_date: string,
    end_date: string,
    s3_key?: string | null,
    cron_status?: PaymentStatusDownloadStatusEnum | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePaidolHighnoteIntegrationSubscriptionVariables = {
  filter?: ModelSubscriptionPaidolHighnoteIntegrationFilterInput | null,
};

export type OnUpdatePaidolHighnoteIntegrationSubscription = {
  onUpdatePaidolHighnoteIntegration?:  {
    __typename: "PaidolHighnoteIntegration",
    // id and paidolId are the same; corresponds to Paidol.id
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    id: string,
    paidolId: string,
    userId?: string | null,
    legalBusinessName?: string | null,
    businessAccountHolderId?: string | null,
    primaryAuthorizedPersonId?: string | null,
    financialAccountId?: string | null,
    externalFinancialBankAccountId?: string | null,
    hasInitialFunding?: boolean | null,
    accountHolderCardProductApplicationId?: string | null,
    isApplicationAccepted?: boolean | null,
    isDisconnected?: boolean | null,
    highnoteProductId?: string | null,
    highnoteProduct?:  {
      __typename: "HighnoteProduct",
      id: string,
      type: HighnoteProductType,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    finicityCustomerId?: string | null,
    dwollaCustomerId?: string | null,
    cardProfileId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHighnotePaymentCardSubscriptionVariables = {
  filter?: ModelSubscriptionHighnotePaymentCardFilterInput | null,
};

export type OnCreateHighnotePaymentCardSubscription = {
  onCreateHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHighnotePaymentCardSubscriptionVariables = {
  filter?: ModelSubscriptionHighnotePaymentCardFilterInput | null,
};

export type OnUpdateHighnotePaymentCardSubscription = {
  onUpdateHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteHighnotePaymentCardSubscriptionVariables = {
  filter?: ModelSubscriptionHighnotePaymentCardFilterInput | null,
};

export type OnDeleteHighnotePaymentCardSubscription = {
  onDeleteHighnotePaymentCard?:  {
    __typename: "HighnotePaymentCard",
    paymentCardId: string,
    paidolId: string,
    authPaidolId: string,
    paidolUsers?:  {
      __typename: "ModelPaidolUserToHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    name?: string | null,
    cardGroupId?: string | null,
    group?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    status?: HNPaymentCardStatus | null,
    bin?: string | null,
    last4?: string | null,
    network?: HNPaymentCardNetwork | null,
    formFactor?: HNCardFormFactor | null,
    expirationDate?: string | null,
    budget?:  {
      __typename: "HNVelocityRuleConnection",
    } | null,
    hasPin?: boolean | null,
    procoreEmployee?:  {
      __typename: "IssuePaymentCardProcoreEmployee",
      id: number,
      name: string,
      email_address?: string | null,
    } | null,
    cardholderId?: string | null,
    cardholder?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cardholderName?: string | null,
    isAdminLocked?: boolean | null,
    // Who last locked, unlocked or cancelled this card, captured at the moment of
    // the action (SEE-946, SEE-1495). Never resolved at read time.
    lastActionByRole?: string | null,
    lastActionByPaidolUserId?: string | null,
    lastActionByName?: string | null,
    lastActionByEmail?: string | null,
    lastActionAt?: string | null,
    merchantSpendRuleId?: string | null,
    isAuthorizedUserCard?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSpendRulesSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRulesFilterInput | null,
};

export type OnCreateSpendRulesSubscription = {
  onCreateSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSpendRulesSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRulesFilterInput | null,
};

export type OnUpdateSpendRulesSubscription = {
  onUpdateSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSpendRulesSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRulesFilterInput | null,
};

export type OnDeleteSpendRulesSubscription = {
  onDeleteSpendRules?:  {
    __typename: "SpendRules",
    spendRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    streetAddressAllowed?: Array< string | null > | null,
    streetAddressBlocked?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVelocityRulesSubscriptionVariables = {
  filter?: ModelSubscriptionVelocityRulesFilterInput | null,
};

export type OnCreateVelocityRulesSubscription = {
  onCreateVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVelocityRulesSubscriptionVariables = {
  filter?: ModelSubscriptionVelocityRulesFilterInput | null,
};

export type OnUpdateVelocityRulesSubscription = {
  onUpdateVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVelocityRulesSubscriptionVariables = {
  filter?: ModelSubscriptionVelocityRulesFilterInput | null,
};

export type OnDeleteVelocityRulesSubscription = {
  onDeleteVelocityRules?:  {
    __typename: "VelocityRules",
    velocityRuleId: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    maximumAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    cumulativeRuleId: string,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReceiptSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptSummaryFieldFilterInput | null,
};

export type OnCreateReceiptSummaryFieldSubscription = {
  onCreateReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReceiptSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptSummaryFieldFilterInput | null,
};

export type OnUpdateReceiptSummaryFieldSubscription = {
  onUpdateReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReceiptSummaryFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptSummaryFieldFilterInput | null,
};

export type OnDeleteReceiptSummaryFieldSubscription = {
  onDeleteReceiptSummaryField?:  {
    __typename: "ReceiptSummaryField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore?: number | null,
    label?: string | null,
    labelConfidenceScore?: number | null,
    value?: string | null,
    valueConfidenceScore?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReceiptLineItemSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFilterInput | null,
};

export type OnCreateReceiptLineItemSubscription = {
  onCreateReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReceiptLineItemSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFilterInput | null,
};

export type OnUpdateReceiptLineItemSubscription = {
  onUpdateReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReceiptLineItemSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFilterInput | null,
};

export type OnDeleteReceiptLineItemSubscription = {
  onDeleteReceiptLineItem?:  {
    __typename: "ReceiptLineItem",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptUploadId: string,
    lineItemFields?:  {
      __typename: "ModelReceiptLineItemFieldConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReceiptLineItemFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFieldFilterInput | null,
};

export type OnCreateReceiptLineItemFieldSubscription = {
  onCreateReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReceiptLineItemFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFieldFilterInput | null,
};

export type OnUpdateReceiptLineItemFieldSubscription = {
  onUpdateReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReceiptLineItemFieldSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptLineItemFieldFilterInput | null,
};

export type OnDeleteReceiptLineItemFieldSubscription = {
  onDeleteReceiptLineItemField?:  {
    __typename: "ReceiptLineItemField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    receiptLineItemId: string,
    type: NormalizedSummaryField,
    typeConfidenceScore: number,
    label: string,
    labelConfidenceScore: number,
    value: string,
    valueConfidenceScore: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptUploadFilterInput | null,
};

export type OnCreateReceiptUploadSubscription = {
  onCreateReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptUploadFilterInput | null,
};

export type OnUpdateReceiptUploadSubscription = {
  onUpdateReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionReceiptUploadFilterInput | null,
};

export type OnDeleteReceiptUploadSubscription = {
  onDeleteReceiptUpload?:  {
    __typename: "ReceiptUpload",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    document: string,
    status: ReceiptUploadStatus,
    summaryFields?:  {
      __typename: "ModelReceiptSummaryFieldConnection",
      nextToken?: string | null,
    } | null,
    lineItems?:  {
      __typename: "ModelReceiptLineItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTransactionToReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionToReceiptUploadFilterInput | null,
};

export type OnCreateTransactionToReceiptUploadSubscription = {
  onCreateTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTransactionToReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionToReceiptUploadFilterInput | null,
};

export type OnUpdateTransactionToReceiptUploadSubscription = {
  onUpdateTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTransactionToReceiptUploadSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionToReceiptUploadFilterInput | null,
};

export type OnDeleteTransactionToReceiptUploadSubscription = {
  onDeleteTransactionToReceiptUpload?:  {
    __typename: "TransactionToReceiptUpload",
    id: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    receiptUploadId: string,
    receiptUpload?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    transactionDate: string,
    reimbursementTransactionId?: string | null,
    reimbursementTransaction?:  {
      __typename: "ReimbursementTransaction",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      dwollaTransferId?: string | null,
      transactionDate: string,
      status: ReimbursementTransactionStatus,
      checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
      note?: string | null,
      contestNote?: string | null,
      deniedNote?: string | null,
      merchantName?: string | null,
      receiptLineItems: ReceiptLineItems,
      jobCodeId?: string | null,
      reimbursementDate?: string | null,
      decisionDate?: string | null,
      reviewedByPaidolUserId?: string | null,
      reviewedByName?: string | null,
      reviewedByRole?: string | null,
      reviewedAt?: string | null,
      paidolUserId: string,
      transactionType: ReimbursementTransactionType,
      expenseTypeId?: string | null,
      receiptId: string,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      agaveGlCodeId?: string | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveVendorId?: string | null,
      agaveSubJobId?: string | null,
      agaveLocationId?: string | null,
      agaveDepartmentId?: string | null,
      agaveSubaccountId?: string | null,
      agaveEmployeeId?: string | null,
      agaveEquipmentId?: string | null,
      agaveEmCostCodeId?: string | null,
      agaveEmCostTypeId?: string | null,
      codingType?: string | null,
      accountingDate?: string | null,
      flexGlCodeId?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexVendorId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    highnoteTransactionId?: string | null,
    highnoteTransaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReimbursementTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionReimbursementTransactionFilterInput | null,
};

export type OnCreateReimbursementTransactionSubscription = {
  onCreateReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReimbursementTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionReimbursementTransactionFilterInput | null,
};

export type OnUpdateReimbursementTransactionSubscription = {
  onUpdateReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReimbursementTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionReimbursementTransactionFilterInput | null,
};

export type OnDeleteReimbursementTransactionSubscription = {
  onDeleteReimbursementTransaction?:  {
    __typename: "ReimbursementTransaction",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    dwollaTransferId?: string | null,
    transactionDate: string,
    amount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    status: ReimbursementTransactionStatus,
    checkrunStatus?: ReimbursementTransactionCheckrunStatus | null,
    note?: string | null,
    contestNote?: string | null,
    deniedNote?: string | null,
    merchantName?: string | null,
    receiptLineItems: ReceiptLineItems,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    reimbursementDate?: string | null,
    decisionDate?: string | null,
    reviewedByPaidolUserId?: string | null,
    reviewedByName?: string | null,
    reviewedByRole?: string | null,
    reviewedAt?: string | null,
    paidolUserId: string,
    paidolUser?:  {
      __typename: "PaidolUser",
      id: string,
      paidol_id?: string | null,
      user_id?: string | null,
      email?: string | null,
      position?: string | null,
      phone?: string | null,
      roles?: Role | null,
      is_test_fixture?: boolean | null,
      authorizedUserId?: string | null,
      authorizedUserApplicationId?: string | null,
      allowedJobCodes?: Array< string > | null,
      employee_id?: number | null,
      // Default Agave (Sage Intacct) employee for this cardholder in this company.
      // Set when a transaction is posted with an employee; used to auto-fill employee on future transactions.
      defaultAgaveEmployeeId?: string | null,
      deletedAt?: string | null,
      landingPagePreference?: LandingPagePreference | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactionType: ReimbursementTransactionType,
    expenseTypeId?: string | null,
    expenseType?:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptId: string,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    procoreProjectId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    codingType?: string | null,
    accountingDate?: string | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProjectGroupSubscriptionVariables = {
  filter?: ModelSubscriptionProjectGroupFilterInput | null,
};

export type OnCreateProjectGroupSubscription = {
  onCreateProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProjectGroupSubscriptionVariables = {
  filter?: ModelSubscriptionProjectGroupFilterInput | null,
};

export type OnUpdateProjectGroupSubscription = {
  onUpdateProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProjectGroupSubscriptionVariables = {
  filter?: ModelSubscriptionProjectGroupFilterInput | null,
};

export type OnDeleteProjectGroupSubscription = {
  onDeleteProjectGroup?:  {
    __typename: "ProjectGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelProjectGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToProjectGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCardGroupSubscriptionVariables = {
  filter?: ModelSubscriptionCardGroupFilterInput | null,
};

export type OnCreateCardGroupSubscription = {
  onCreateCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCardGroupSubscriptionVariables = {
  filter?: ModelSubscriptionCardGroupFilterInput | null,
};

export type OnUpdateCardGroupSubscription = {
  onUpdateCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCardGroupSubscriptionVariables = {
  filter?: ModelSubscriptionCardGroupFilterInput | null,
};

export type OnDeleteCardGroupSubscription = {
  onDeleteCardGroup?:  {
    __typename: "CardGroup",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    groupProjects?: Array< string | null > | null,
    paymentCards?:  {
      __typename: "ModelHighnotePaymentCardConnection",
      nextToken?: string | null,
    } | null,
    monthlyBudget?:  {
      __typename: "Currency",
      // Integer value, original amount multiplied by 100. E.g. $1.23 -> 123
      // This guards against rounding errors in floating point math
      value: number,
      // The currency code; in real life always 'USD' for now.
      currency: string,
    } | null,
    isMonthlyBudgetUnlimited?: boolean | null,
    spendGroupId?: string | null,
    spendGroup?:  {
      __typename: "MerchantSpendRule",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      paymentCards?: Array< string | null > | null,
      merchantCountrySpendRuleId?: string | null,
      merchantCategorySpendRuleId?: string | null,
      amountLimitSpendRuleId?: string | null,
      monthlyLimitSpendRuleId?: string | null,
      monthlyLimitCumulativeRuleId?: string | null,
      merchantCategoryAllowed?: Array< string | null > | null,
      merchantCategoryBlocked?: Array< string | null > | null,
      merchantCountryAllowed?: Array< string | null > | null,
      merchantCountryBlocked?: Array< string | null > | null,
      monthlyLimitResetTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    monthlyBudgetSpend?:  {
      __typename: "ModelCardGroupBudgetSpendByMonthConnection",
      nextToken?: string | null,
    } | null,
    transactions?:  {
      __typename: "ModelHighnoteTransactionEventConnection",
      nextToken?: string | null,
    } | null,
    groupAdmins?:  {
      __typename: "ModelPaidolUserToCardGroupConnection",
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    glCodeVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    projectVisibilitySettings?:  {
      __typename: "CodingFilteringSettings",
      isAllAvailable: boolean,
      ids?: Array< string | null > | null,
    } | null,
    hasReviewers?: boolean | null,
    spentThisMonth?:  {
      __typename: "AmountSpentThisMonth",
      amount?: number | null,
      yearAndMonth?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMerchantSpendRuleSubscriptionVariables = {
  filter?: ModelSubscriptionMerchantSpendRuleFilterInput | null,
};

export type OnCreateMerchantSpendRuleSubscription = {
  onCreateMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMerchantSpendRuleSubscriptionVariables = {
  filter?: ModelSubscriptionMerchantSpendRuleFilterInput | null,
};

export type OnUpdateMerchantSpendRuleSubscription = {
  onUpdateMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMerchantSpendRuleSubscriptionVariables = {
  filter?: ModelSubscriptionMerchantSpendRuleFilterInput | null,
};

export type OnDeleteMerchantSpendRuleSubscription = {
  onDeleteMerchantSpendRule?:  {
    __typename: "MerchantSpendRule",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    paymentCards?: Array< string | null > | null,
    merchantCountrySpendRuleId?: string | null,
    merchantCategorySpendRuleId?: string | null,
    amountLimitSpendRuleId?: string | null,
    monthlyLimitSpendRuleId?: string | null,
    monthlyLimitCumulativeRuleId?: string | null,
    maximumAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    monthlyLimitAmount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    merchantCategoryAllowed?: Array< string | null > | null,
    merchantCategoryBlocked?: Array< string | null > | null,
    merchantCountryAllowed?: Array< string | null > | null,
    merchantCountryBlocked?: Array< string | null > | null,
    monthlyLimitResetTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSpendRuleConfigSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRuleConfigFilterInput | null,
};

export type OnCreateSpendRuleConfigSubscription = {
  onCreateSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSpendRuleConfigSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRuleConfigFilterInput | null,
};

export type OnUpdateSpendRuleConfigSubscription = {
  onUpdateSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSpendRuleConfigSubscriptionVariables = {
  filter?: ModelSubscriptionSpendRuleConfigFilterInput | null,
};

export type OnDeleteSpendRuleConfigSubscription = {
  onDeleteSpendRuleConfig?:  {
    __typename: "SpendRuleConfig",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    ruleId: string,
    ruleType: SpendRuleType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateJobCodeSubscriptionVariables = {
  filter?: ModelSubscriptionJobCodeFilterInput | null,
};

export type OnCreateJobCodeSubscription = {
  onCreateJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateJobCodeSubscriptionVariables = {
  filter?: ModelSubscriptionJobCodeFilterInput | null,
};

export type OnUpdateJobCodeSubscription = {
  onUpdateJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteJobCodeSubscriptionVariables = {
  filter?: ModelSubscriptionJobCodeFilterInput | null,
};

export type OnDeleteJobCodeSubscription = {
  onDeleteJobCode?:  {
    __typename: "JobCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    description: string,
    code: string,
    isActive: boolean,
    budget?: number | null,
    jobCodeImportId: string,
    jobCodeImport?:  {
      __typename: "JobCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      storageFileKey: string,
      fileName: string,
      status: JobCodeImportStatus,
      errors?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateV2FlexRelationshipsSubscriptionVariables = {
  filter?: ModelSubscriptionV2FlexRelationshipsFilterInput | null,
};

export type OnCreateV2FlexRelationshipsSubscription = {
  onCreateV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateV2FlexRelationshipsSubscriptionVariables = {
  filter?: ModelSubscriptionV2FlexRelationshipsFilterInput | null,
};

export type OnUpdateV2FlexRelationshipsSubscription = {
  onUpdateV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteV2FlexRelationshipsSubscriptionVariables = {
  filter?: ModelSubscriptionV2FlexRelationshipsFilterInput | null,
};

export type OnDeleteV2FlexRelationshipsSubscription = {
  onDeleteV2FlexRelationships?:  {
    __typename: "V2FlexRelationships",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexGlCodeId?: string | null,
    flexCodeId?: string | null,
    flexCostCodeId?: string | null,
    flexCostTypeId?: string | null,
    flexVendorId?: string | null,
    flexCodeImportId: string,
    // Denormalized entity names cached at import time so the dropdown handlers can sort,
    // search, and display directly off this index without a second query against the entity
    // tables. The canonical names still live in the FlexCode/FlexGlCode/etc. tables — these
    // fields are a read-time cache for the dropdown query path only.
    flexGlCodeName?: string | null,
    projectName?: string | null,
    projectCode?: string | null,
    flexCostCodeName?: string | null,
    flexCostTypeName?: string | null,
    flexVendorName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexGlCodeFilterInput | null,
};

export type OnCreateFlexGlCodeSubscription = {
  onCreateFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexGlCodeFilterInput | null,
};

export type OnUpdateFlexGlCodeSubscription = {
  onUpdateFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexGlCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexGlCodeFilterInput | null,
};

export type OnDeleteFlexGlCodeSubscription = {
  onDeleteFlexGlCode?:  {
    __typename: "FlexGlCode",
    id: string,
    paidolId: string,
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCodeFilterInput | null,
};

export type OnCreateFlexCodeSubscription = {
  onCreateFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCodeFilterInput | null,
};

export type OnUpdateFlexCodeSubscription = {
  onUpdateFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCodeFilterInput | null,
};

export type OnDeleteFlexCodeSubscription = {
  onDeleteFlexCode?:  {
    __typename: "FlexCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    projectName: string,
    projectCode?: string | null,
    isActive: boolean,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostCodeFilterInput | null,
};

export type OnCreateFlexCostCodeSubscription = {
  onCreateFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostCodeFilterInput | null,
};

export type OnUpdateFlexCostCodeSubscription = {
  onUpdateFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexCostCodeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostCodeFilterInput | null,
};

export type OnDeleteFlexCostCodeSubscription = {
  onDeleteFlexCostCode?:  {
    __typename: "FlexCostCode",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    code: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostTypeFilterInput | null,
};

export type OnCreateFlexCostTypeSubscription = {
  onCreateFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostTypeFilterInput | null,
};

export type OnUpdateFlexCostTypeSubscription = {
  onUpdateFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexCostTypeSubscriptionVariables = {
  filter?: ModelSubscriptionFlexCostTypeFilterInput | null,
};

export type OnDeleteFlexCostTypeSubscription = {
  onDeleteFlexCostType?:  {
    __typename: "FlexCostType",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexVendorSubscriptionVariables = {
  filter?: ModelSubscriptionFlexVendorFilterInput | null,
};

export type OnCreateFlexVendorSubscription = {
  onCreateFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexVendorSubscriptionVariables = {
  filter?: ModelSubscriptionFlexVendorFilterInput | null,
};

export type OnUpdateFlexVendorSubscription = {
  onUpdateFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexVendorSubscriptionVariables = {
  filter?: ModelSubscriptionFlexVendorFilterInput | null,
};

export type OnDeleteFlexVendorSubscription = {
  onDeleteFlexVendor?:  {
    __typename: "FlexVendor",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    flexCodeImportId: string,
    flexCodeImport?:  {
      __typename: "FlexCodeImport",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      createdAt: string,
      updatedAt: string,
      storageFileKey: string,
      fileName: string,
      status: FlexCodeImportStatus,
      errors?: string | null,
      searchSynced?: boolean | null,
      type: FlexCodeImportType,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexFieldSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldFilterInput | null,
};

export type OnCreateFlexFieldSubscription = {
  onCreateFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexFieldSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldFilterInput | null,
};

export type OnUpdateFlexFieldSubscription = {
  onUpdateFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexFieldSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldFilterInput | null,
};

export type OnDeleteFlexFieldSubscription = {
  onDeleteFlexField?:  {
    __typename: "FlexField",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    name: string,
    alias?: string | null,
    order?: number | null,
    source: FlexFieldSource,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlexFieldValueSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldValueFilterInput | null,
};

export type OnCreateFlexFieldValueSubscription = {
  onCreateFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlexFieldValueSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldValueFilterInput | null,
};

export type OnUpdateFlexFieldValueSubscription = {
  onUpdateFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlexFieldValueSubscriptionVariables = {
  filter?: ModelSubscriptionFlexFieldValueFilterInput | null,
};

export type OnDeleteFlexFieldValueSubscription = {
  onDeleteFlexFieldValue?:  {
    __typename: "FlexFieldValue",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    flexFieldId: string,
    externalId?: string | null,
    value: string,
    status: FlexFieldValueStatus,
    flexFieldUploadId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStatementSummarySubscriptionVariables = {
  filter?: ModelSubscriptionStatementSummaryFilterInput | null,
};

export type OnCreateStatementSummarySubscription = {
  onCreateStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateStatementSummarySubscriptionVariables = {
  filter?: ModelSubscriptionStatementSummaryFilterInput | null,
};

export type OnUpdateStatementSummarySubscription = {
  onUpdateStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteStatementSummarySubscriptionVariables = {
  filter?: ModelSubscriptionStatementSummaryFilterInput | null,
};

export type OnDeleteStatementSummarySubscription = {
  onDeleteStatementSummary?:  {
    __typename: "StatementSummary",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    startDate: string,
    endDate: string,
    statementBalance: number,
    paymentDueDate?: string | null,
    pdfLink: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAutoPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionAutoPaymentFilterInput | null,
};

export type OnCreateAutoPaymentSubscription = {
  onCreateAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAutoPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionAutoPaymentFilterInput | null,
};

export type OnUpdateAutoPaymentSubscription = {
  onUpdateAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAutoPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionAutoPaymentFilterInput | null,
};

export type OnDeleteAutoPaymentSubscription = {
  onDeleteAutoPayment?:  {
    __typename: "AutoPayment",
    id: string,
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    amountType: AutoPayAmountType,
    fixedAmountCents?: number | null,
    paymentDayOfMonth: number,
    externalBankAccountId: string,
    financialAccountId: string,
    active: boolean,
    createdBy: string,
    updatedBy?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTransactionFilterOptionsSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterOptionsFilterInput | null,
};

export type OnCreateTransactionFilterOptionsSubscription = {
  onCreateTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateTransactionFilterOptionsSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterOptionsFilterInput | null,
};

export type OnUpdateTransactionFilterOptionsSubscription = {
  onUpdateTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteTransactionFilterOptionsSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterOptionsFilterInput | null,
};

export type OnDeleteTransactionFilterOptionsSubscription = {
  onDeleteTransactionFilterOptions?:  {
    __typename: "TransactionFilterOptions",
    paidolId: string,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    last4?: Array< string > | null,
    userId?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantName?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    merchantCategory?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    cardGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    projectGroup?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    receiptStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    highnoteTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    flexVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveTransactionStatus?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveGlCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveProjectIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveVendorIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveLocationIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveDepartmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubaccountIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveSubJobIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEquipmentIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostCodeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    agaveEmCostTypeIds?:  Array< {
      __typename: "FilterOption",
      id: string,
      label: string,
      projectId?: string | null,
    } > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateHighnoteDisputeEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteDisputeEventFilterInput | null,
};

export type OnCreateHighnoteDisputeEventSubscription = {
  onCreateHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHighnoteDisputeEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteDisputeEventFilterInput | null,
};

export type OnUpdateHighnoteDisputeEventSubscription = {
  onUpdateHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteHighnoteDisputeEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteDisputeEventFilterInput | null,
};

export type OnDeleteHighnoteDisputeEventSubscription = {
  onDeleteHighnoteDisputeEvent?:  {
    __typename: "HighnoteDisputeEvent",
    id: string,
    disputeId: string,
    paidolId: string,
    paymentCardId: string,
    transactionEventId: string,
    amount?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    enableListing: boolean,
    status: string,
    creditStatus?: string | null,
    category?: string | null,
    liability?: string | null,
    eventType: string,
    eventDate: string,
    source: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHighnoteTransactionEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteTransactionEventFilterInput | null,
};

export type OnCreateHighnoteTransactionEventSubscription = {
  onCreateHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHighnoteTransactionEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteTransactionEventFilterInput | null,
};

export type OnUpdateHighnoteTransactionEventSubscription = {
  onUpdateHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteHighnoteTransactionEventSubscriptionVariables = {
  filter?: ModelSubscriptionHighnoteTransactionEventFilterInput | null,
};

export type OnDeleteHighnoteTransactionEventSubscription = {
  onDeleteHighnoteTransactionEvent?:  {
    __typename: "HighnoteTransactionEvent",
    id: string,
    transactionId: string,
    transaction?:  {
      __typename: "HighnoteTransaction",
      transactionId: string,
      paymentCardId: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      cardGroupId?: string | null,
      status: HighnoteTransactionStatus,
      transactionDate: string,
      merchantName?: string | null,
      merchantCategoryCode?: string | null,
      // Our custom category mapping, based on original MCCCode
      merchantCategory?: string | null,
      // An array of source TransactionEvents payloads from the Highnote API.
      // May be useful in future if we need to backfill this data with additional
      // fields. This data is in its original JSON-serialized format.
      transactionEvents?: Array< string | null > | null,
      note?: string | null,
      jobCodeId?: string | null,
      procoreCompanyId?: number | null,
      procoreProjectId?: number | null,
      procoreWBSCodeId?: number | null,
      procoreDirectCostId?: number | null,
      procoreDirectCostLineItemId?: number | null,
      agaveProjectId?: string | null,
      agaveCostCodeId?: string | null,
      agaveCostTypeId?: string | null,
      agaveExpenseId?: string | null,
      agaveVendorId?: string | null,
      agaveGlCodeId?: string | null,
      agaveDepartmentId?: string | null,
      agaveLocationId?: string | null,
      agaveSubaccountId?: string | null,
      // AWS S3 receipt upload path
      receiptPath?: string | null,
      receiptId?: string | null,
      // Track when a transaction is approved to be sent to an ERP (PROCURE|AGAVE)
      erpApprovalStatus?: boolean | null,
      // Track when a transaction is marked to bypass ERP posting (acts like posted)
      erpBypassStatus?: boolean | null,
      last4?: string | null,
      userId?: string | null,
      // The email from paidolUser assigned to the Highnote Payment Card
      email?: string | null,
      approvedAmountValue?: number | null,
      approvedAmountCurrencyCode?: string | null,
      flexCodeId?: string | null,
      flexCostCodeId?: string | null,
      flexCostTypeId?: string | null,
      flexGlCodeId?: string | null,
      flexVendorId?: string | null,
      selectedCodingOption?: CodingOptions | null,
      agaveGlCostTypeId?: string | null,
      flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
      approveWithoutNotes?: boolean | null,
      approveWithoutReceipts?: boolean | null,
      // Fuel capture fields for tracking fuel purchases
      fuelVehicleId?: string | null,
      fuelOdometerReading?: number | null,
      fuelGallons?: number | null,
      fuelCostPerGallon?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paymentCardId: string,
    paymentCard?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    paidolId: string,
    reconciliationId?: string | null,
    // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
    authPaidolId: string,
    eventDate: string,
    processedAt?: string | null,
    origin: string,
    status: HighnoteTransactionStatus,
    partial?: boolean | null,
    settlementImpact?: boolean | null,
    approvedAmount:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    },
    fees?:  Array< {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null > | null,
    approvedAmountValue?: number | null,
    approvedAmountCurrencyCode?: string | null,
    eventData?: string | null,
    transactionOldState?: string | null,
    transactionNewState?: string | null,
    enableListing?: boolean | null,
    email?: string | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      first_name: string,
      middle_name?: string | null,
      last_name: string,
      suffix?: string | null,
      picture?: string | null,
      is_speedster?: string | null,
      birthdate?: string | null,
      address?: string | null,
      phone_number?: string | null,
      phone_extension?: string | null,
      password_updated_at?: string | null,
      finicityCustomerId?: string | null,
      dwollaCustomerId?: string | null,
      is_support?: boolean | null,
      deletedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    last4?: string | null,
    card?:  {
      __typename: "HighnotePaymentCard",
      paymentCardId: string,
      paidolId: string,
      authPaidolId: string,
      name?: string | null,
      cardGroupId?: string | null,
      status?: HNPaymentCardStatus | null,
      bin?: string | null,
      last4?: string | null,
      network?: HNPaymentCardNetwork | null,
      formFactor?: HNCardFormFactor | null,
      expirationDate?: string | null,
      hasPin?: boolean | null,
      cardholderId?: string | null,
      cardholderName?: string | null,
      isAdminLocked?: boolean | null,
      // Who last locked, unlocked or cancelled this card, captured at the moment of
      // the action (SEE-946, SEE-1495). Never resolved at read time.
      lastActionByRole?: string | null,
      lastActionByPaidolUserId?: string | null,
      lastActionByName?: string | null,
      lastActionByEmail?: string | null,
      lastActionAt?: string | null,
      merchantSpendRuleId?: string | null,
      isAuthorizedUserCard?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupApprovalLevels?: number | null,
    owningProjectGroupIds?: Array< string | null > | null,
    cardGroupId?: string | null,
    cardGroup?:  {
      __typename: "CardGroup",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      groupProjects?: Array< string | null > | null,
      isMonthlyBudgetUnlimited?: boolean | null,
      spendGroupId?: string | null,
      deletedAt?: string | null,
      hasReviewers?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    merchantCategory?: string | null,
    merchantCategoryCode?: string | null,
    merchantName?: string | null,
    jobCodeId?: string | null,
    jobCode?:  {
      __typename: "JobCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      description: string,
      code: string,
      isActive: boolean,
      budget?: number | null,
      jobCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCodeTransactionStatus?: FlexCodeTransactionStatus | null,
    workflowStatus?: WorkflowStatus | null,
    returnedStatus?: ReturnedStatus | null,
    flexCodeId?: string | null,
    flexCode?:  {
      __typename: "FlexCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      projectName: string,
      projectCode?: string | null,
      isActive: boolean,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostCodeId?: string | null,
    flexCostCode?:  {
      __typename: "FlexCostCode",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      code: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexCostTypeId?: string | null,
    flexCostType?:  {
      __typename: "FlexCostType",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexGlCodeId?: string | null,
    flexGlCode?:  {
      __typename: "FlexGlCode",
      id: string,
      paidolId: string,
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    flexVendorId?: string | null,
    flexVendor?:  {
      __typename: "FlexVendor",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      name: string,
      flexCodeImportId: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    agaveDepartment?:  {
      __typename: "AgaveDepartment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveDepartmentId?: string | null,
    agaveLocation?:  {
      __typename: "AgaveLocation",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      parent_id?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveLocationId?: string | null,
    agaveSubaccount?:  {
      __typename: "AgaveSubaccount",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      code?: string | null,
      name?: string | null,
      status?: string | null,
      type?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveSubaccountId?: string | null,
    agaveEmployee?:  {
      __typename: "AgaveEmployeeEntity",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      name?: string | null,
      fullName?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
      source_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      source_data?: string | null,
    } | null,
    agaveEmployeeId?: string | null,
    agaveExpense?:  {
      __typename: "CreateAgaveExpenseAPInvoice",
      id: string,
      source_id?: string | null,
      amount?: string | null,
      amount_due?: string | null,
      ap_payment_ids?: Array< string | null > | null,
      batch?: string | null,
      batch_id?: string | null,
      creator_id?: string | null,
      currency_code?: string | null,
      description?: string | null,
      discount_amount?: string | null,
      discount_date?: string | null,
      due_date?: string | null,
      issue_date?: string | null,
      misc_amount?: string | null,
      net_amount?: string | null,
      number?: string | null,
      project_id?: string | null,
      retention_amount?: string | null,
      retention_percent?: string | null,
      status?: string | null,
      subtotal_amount?: string | null,
      tax_amount?: string | null,
      total_amount?: string | null,
      type?: string | null,
      vendor_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
    } | null,
    agaveExpenseId?: string | null,
    agaveProject?:  {
      __typename: "AgaveProject",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      amount?: number | null,
      completion_date?: string | null,
      name?: string | null,
      number?: string | null,
      start_date?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveProjectId?: string | null,
    agaveCostCode?:  {
      __typename: "AgaveCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      asset_account_id?: string | null,
      source_id?: string | null,
      formatted_full_code?: string | null,
      code?: string | null,
      full_code?: string | null,
      cost_unit_of_measure?: string | null,
      description?: string | null,
      expense_account_id?: string | null,
      income_account_id?: string | null,
      name?: string | null,
      parent_id?: string | null,
      project_id?: string | null,
      price_unit_of_measure?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      status?: string | null,
      type?: string | null,
      unit_cost?: string | null,
      unit_price?: string | null,
      vendor_id?: string | null,
      sub_job_id?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
      projectIds?: Array< string | null > | null,
      cost_type_ids?: Array< string | null > | null,
      fullName?: string | null,
    } | null,
    agaveCostCodeId?: string | null,
    agaveCostTypeId?: string | null,
    agaveCostType?:  {
      __typename: "AgaveCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      project_id?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      paidolProject?: string | null,
    } | null,
    agaveGlCode?:  {
      __typename: "AgaveGlCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      classification?: string | null,
      currency_code?: string | null,
      current_balance?: number | null,
      description?: string | null,
      name?: string | null,
      number?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
      relatedIds?: Array< string | null > | null,
    } | null,
    agaveGlCodeId?: string | null,
    agaveVendor?:  {
      __typename: "AgaveVendor",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      email?: string | null,
      fax?: string | null,
      name?: string | null,
      phone?: string | null,
      status?: AgaveVendorStatus | null,
      tax_number?: string | null,
      terms?: string | null,
      type?: AgaveVendorType | null,
      website?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      fullName?: string | null,
    } | null,
    agaveVendorId?: string | null,
    agaveSubJob?:  {
      __typename: "AgaveSubJob",
      id: string,
      agaveSubJobId?: string | null,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      name?: string | null,
      number?: string | null,
      code?: string | null,
      status?: string | null,
      type?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      projectId?: string | null,
      fullName?: string | null,
      cost_code_ids?: Array< string | null > | null,
    } | null,
    agaveSubJobId?: string | null,
    agaveEquipment?:  {
      __typename: "AgaveEquipment",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCo?: string | null,
      category?: string | null,
      department?: string | null,
      status?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEquipmentId?: string | null,
    agaveEmCostCode?:  {
      __typename: "AgaveEmCostCode",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      emCostTypeCodes?: Array< string | null > | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostCodeId?: string | null,
    agaveEmCostType?:  {
      __typename: "AgaveEmCostType",
      id: string,
      paidolId?: string | null,
      authPaidolId?: string | null,
      source_id?: string | null,
      code?: string | null,
      name?: string | null,
      fullName?: string | null,
      emGroup?: string | null,
      abbreviation?: string | null,
      source_create_time?: string | null,
      source_update_time?: string | null,
      lastSeenAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    agaveEmCostTypeId?: string | null,
    codingType?: string | null,
    accountingDate?: string | null,
    procoreDirectCostId?: number | null,
    procoreDirectCostLineItemId?: number | null,
    procoreProject?:  {
      __typename: "GetProcoreProjectsPayload",
      id: number,
      active: boolean,
      display_name: string,
      name: string,
      created_at: string,
      start_date?: string | null,
      completion_date?: string | null,
      project_number?: string | null,
      total_value?: string | null,
    } | null,
    procoreProjectId?: number | null,
    procoreWBSCode?:  {
      __typename: "GetProcoreWBSCodesPayload",
      id: number,
      flat_code?: string | null,
      flat_name?: string | null,
      description?: string | null,
      status?: string | null,
    } | null,
    procoreWBSCodeId?: number | null,
    erpApprovalStatus?: boolean | null,
    erpBypassStatus?: boolean | null,
    // SEE-1135: per-transaction billable posting. Selecting an ERP billable item marks the
    // line billable at post time (Sage Intacct's billable cascade also requires the coded
    // project's customer, resolved server-side). erpBillableItemId is the item id sent on the
    // line (for Sage, the ITEMID); erpBillableItemName is a denormalized display label since
    // ERPItem is a CDK-owned table, not an @model (no @hasOne to resolve a name). Named
    // ERP-neutral so a future ERP can reuse the same fields.
    erpBillableItemId?: string | null,
    erpBillableItemName?: string | null,
    // SEE-1390: per-transaction billable opt-out. Auto-set true when an item lands
    // (manual pick or cost-type derivation); explicitly false posts the line
    // non-billable while the item stays coded. Null (legacy rows) keeps SEE-1135
    // behavior: item present = billable.
    erpBillable?: boolean | null,
    // Generic ERP posting status tracking (for all ERPs)
    erpPostingStatus?: ERPPostingStatus | null,
    erpPostingError?: string | null,
    // SEE-1696: why a successful post degraded (Sage Intacct billable fallback:
    // posted non-billable with the item dropped). Set on COMPLETED, cleared otherwise.
    erpPostingWarning?: string | null,
    // Sage 300 AP Invoice async posting tracking (deprecated - use erpPostingStatus)
    sage300APInvoiceStatus?: Sage300APInvoiceStatus | null,
    sage300APInvoiceError?: string | null,
    note?: string | null,
    approveWithoutNotes?: boolean | null,
    receiptPath?: string | null,
    receiptId?: string | null,
    receipt?:  {
      __typename: "ReceiptUpload",
      id: string,
      paidolId: string,
      // Workaround for https://github.com/aws-amplify/amplify-cli/issues/10149
      authPaidolId: string,
      document: string,
      status: ReceiptUploadStatus,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Source-of-truth flag maintained by the v2-transaction Lambda from the
    // TransactionToReceiptUpload join table. Use this for "does this transaction
    // have a receipt"; receiptPath/receiptId are legacy display pointers.
    hasReceipt?: boolean | null,
    approveWithoutReceipts?: boolean | null,
    // Fuel capture fields for tracking fuel purchases
    fuelVehicleId?: string | null,
    fuelOdometerReading?: number | null,
    fuelGallons?: number | null,
    fuelCostPerGallon?: number | null,
    // Admin time savings tracking (SEE-407)
    codedAt?: string | null,
    codingMethod?: string | null,
    receiptUploadedAt?: string | null,
    receiptUploadMethod?: string | null,
    // SEE-1462: set once the transaction has been HANDLED by the daily flex
    // transaction export. Selection is "qualifying and erpExportedAt not set", plus
    // ONE permanent time bound: transactions dated before the company's enablement
    // window are baseline-stamped rather than delivered (see erpExportBatchId
    // below). There is deliberately no index on this field — the export queries
    // byPaidol and filters (an accepted read cost that grows with the company's
    // history).
    // 
    // EXACTLY-ONCE is enforced at the WRITE, not the read. Ordering: the lambda
    // stamps BEFORE building/uploading the file (a conditional update on
    // attribute_not_exists(erpExportedAt); losers of the condition are dropped from
    // the file — this is what makes concurrent runs safe), and on a failed delivery
    // it ROLLS THE STAMPS BACK (conditional on erpExportBatchId == the batch id) so
    // the rows return to the pool. Residual risk is a process kill between stamp and
    // rollback; the unwind is operational: for a FlexTransactionExport row that is
    // ERROR (or stuck PROCESSING — find those across companies via the byStatus GSI
    // from the console/CLI, oldest first; deliberately no AppSync queryField), find
    // this paidol's transactions where
    // erpExportBatchId equals that row's id (searchHighnoteTransactionEvents — the
    // field is on the @searchable projection, no scan needed) and REMOVE
    // erpExportedAt/erpExportBatchId. The export alerts engineering when its own
    // rollback fails, naming the stuck transaction ids.
    // 
    // erpExportBatchId is a String, not an ID/FK, because it carries two shapes:
    // a FlexTransactionExport.id for rows actually delivered in that run, or
    // "baseline-<batch id>" for rows the ENABLEMENT BASELINE marked as
    // handled-before-switch-on — on ANY run, not just the first: the cutoff is
    // permanent (anchored on the company's earliest export attempt; the audit row
    // for a run is created BEFORE the anchor is read, so a true first run anchors
    // on its own row), and a pre-enablement transaction is stamped whenever it
    // finally qualifies. Those rows were NEVER DELIVERED anywhere. Baseline stamps are
    // DELIBERATELY PERMANENT: delivery was never expected, so neither the automatic
    // rollback nor the manual unwind above touches them (both match the bare batch
    // id, which "baseline-" rows never equal — that exclusion is intentional, not an
    // oversight; an operator should not hunt for baseline rows that "didn't get
    // cleared"). Anything user-facing built on these fields (SEE-1294's Exported
    // status) MUST treat "baseline-" rows as not-exported-to-the-customer, or a
    // newly enabled company's entire history would display as Exported for files
    // that never existed.
    // 
    // Field-level auth: read-only through AppSync for group members; admin roles
    // (custom-roles.json) bypass rules as everywhere. A client that can set
    // erpExportedAt can silently suppress a transaction from every future file
    // (selection skips stamped rows), or clear it and force a duplicate. The
    // export lambda is unaffected: it writes direct to DynamoDB. SEE-1730: no
    // `allow: private, provider: iam` read here either. A field-level rule is
    // unioned into the model's read resolvers, so it would reopen get/list/search
    // to every signed-in user's identity pool role.
    erpExportedAt?: string | null,
    erpExportBatchId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSyncBalanceCurrentCycleSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCycleFilterInput | null,
};

export type OnCreateSyncBalanceCurrentCycleSubscription = {
  onCreateSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSyncBalanceCurrentCycleSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCycleFilterInput | null,
};

export type OnUpdateSyncBalanceCurrentCycleSubscription = {
  onUpdateSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSyncBalanceCurrentCycleSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCycleFilterInput | null,
};

export type OnDeleteSyncBalanceCurrentCycleSubscription = {
  onDeleteSyncBalanceCurrentCycle?:  {
    __typename: "SyncBalanceCurrentCycle",
    id: string,
    paidolId: string,
    authPaidolId: string,
    startDate: string,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSyncBalanceCurrentCyclePaymentCardsSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
};

export type OnCreateSyncBalanceCurrentCyclePaymentCardsSubscription = {
  onCreateSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSyncBalanceCurrentCyclePaymentCardsSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
};

export type OnUpdateSyncBalanceCurrentCyclePaymentCardsSubscription = {
  onUpdateSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSyncBalanceCurrentCyclePaymentCardsSubscriptionVariables = {
  filter?: ModelSubscriptionSyncBalanceCurrentCyclePaymentCardsFilterInput | null,
};

export type OnDeleteSyncBalanceCurrentCyclePaymentCardsSubscription = {
  onDeleteSyncBalanceCurrentCyclePaymentCards?:  {
    __typename: "SyncBalanceCurrentCyclePaymentCards",
    id: string,
    authPaidolId: string,
    paidolId: string,
    syncBalanceCurrentCycleId: string,
    paymentCardId: string,
    balance?:  {
      __typename: "HNAmount",
      value?: number | null,
      currencyCode?: string | null,
      decimalPlaces?: number | null,
    } | null,
    syncedAt: string,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateExpenseTypeToMCCSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseTypeToMCCFilterInput | null,
};

export type OnCreateExpenseTypeToMCCSubscription = {
  onCreateExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateExpenseTypeToMCCSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseTypeToMCCFilterInput | null,
};

export type OnUpdateExpenseTypeToMCCSubscription = {
  onUpdateExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteExpenseTypeToMCCSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseTypeToMCCFilterInput | null,
};

export type OnDeleteExpenseTypeToMCCSubscription = {
  onDeleteExpenseTypeToMCC?:  {
    __typename: "ExpenseTypeToMCC",
    id: string,
    mccID: string,
    expenseTypeID: string,
    mcc:  {
      __typename: "Mcc",
      id: string,
      code: number,
      highnoteDescription: HNMerchantCategory,
      highnoteCategoryDescription?: string | null,
      speedchainDescription?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    expenseType:  {
      __typename: "ExpenseType",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};
